export const CUSTOM_SITE_MAP = 
[
  {
    "name": "Homepage",
    "path": "/",
    "template": "homepage",
    "modules": {
      "hero": {
        "hero_src": "",
        "hero_alt": "",
        "hero_title": "HELPING BUSINESSES ACHIEVE THEIR ENVIRONMENTAL OBJECTIVES",
        "hero_description": "",
        "hero_ctas": []
      }
    }
  },
  {
    "name": "Software",
    "apiurl": "/restapi/customsoftwarecontent/software",
    "url": "/software/products",
    "template": "new-software-landing",
    "section": "software"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/patrick-nonhof",
    "url": "/about-us/individual-bio/patrick-nonhof",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/patrick-fisher",
    "url": "/about-us/individual-bio/patrick-fisher",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/brent-altemose",
    "url": "/about-us/individual-bio/brent-altemose",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/emily-kolb",
    "url": "/about-us/individual-bio/emily-kolb",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/matt-berlew",
    "url": "/about-us/individual-bio/matt-berlew",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/raghu-soule",
    "url": "/about-us/individual-bio/raghu-soule",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/mike-sherer-pe",
    "url": "/about-us/individual-bio/mike-sherer-pe",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/managing-consultant",
    "url": "/about-us/individual-bio/managing-consultant",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/jeff-adkins",
    "url": "/about-us/individual-bio/jeff-adkins",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/courtny-edge",
    "url": "/about-us/individual-bio/courtny-edge",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/tony-phan",
    "url": "/about-us/individual-bio/tony-phan",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/mike-olson",
    "url": "/about-us/individual-bio/mike-olson",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/phillip-stanford",
    "url": "/about-us/individual-bio/phillip-stanford",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/associate-consultant",
    "url": "/about-us/individual-bio/associate-consultant",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/hung-ming-sue-sung",
    "url": "/about-us/individual-bio/hung-ming-sue-sung",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/priscilla-khuu",
    "url": "/about-us/individual-bio/priscilla-khuu",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/chloe-s-reece",
    "url": "/about-us/individual-bio/chloe-s-reece",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/senior-consultant",
    "url": "/about-us/individual-bio/senior-consultant",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/aj-hansborough",
    "url": "/about-us/individual-bio/aj-hansborough",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/robert-sussman",
    "url": "/about-us/individual-bio/robert-sussman",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/michael-trupin",
    "url": "/about-us/individual-bio/michael-trupin",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/dale-overcash",
    "url": "/about-us/individual-bio/dale-overcash",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/bernie-lindquist",
    "url": "/about-us/individual-bio/bernie-lindquist",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/cheryl-wiramanaden",
    "url": "/about-us/individual-bio/cheryl-wiramanaden",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/kurt-last",
    "url": "/about-us/individual-bio/kurt-last",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/eugene-w-taylor",
    "url": "/about-us/individual-bio/eugene-w-taylor",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/ian-donaldson",
    "url": "/about-us/individual-bio/ian-donaldson",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/mike-zimmer",
    "url": "/about-us/individual-bio/mike-zimmer",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/felicity-melville",
    "url": "/about-us/individual-bio/felicity-melville",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/kim-connors",
    "url": "/about-us/individual-bio/kim-connors",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/justin-adams",
    "url": "/about-us/individual-bio/justin-adams",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/kathryn-connolly",
    "url": "/about-us/individual-bio/kathryn-connolly",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/jason-schmitz",
    "url": "/about-us/individual-bio/jason-schmitz",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/weiping-dai",
    "url": "/about-us/individual-bio/weiping-dai",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/robert-liles",
    "url": "/about-us/individual-bio/robert-liles",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/christina-ridge",
    "url": "/about-us/individual-bio/christina-ridge",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/gena-driscoll",
    "url": "/about-us/individual-bio/gena-driscoll",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/managing-consultant-climate-change-services",
    "url": "/about-us/individual-bio/managing-consultant-climate-change-services",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/john-iwanski",
    "url": "/about-us/individual-bio/john-iwanski",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/christine-heath",
    "url": "/about-us/individual-bio/christine-heath",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/Charles-C-Lee",
    "url": "/about-us/individual-bio/Charles-C-Lee",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/adam-erenstein",
    "url": "/about-us/individual-bio/adam-erenstein",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/mike-burr",
    "url": "/about-us/individual-bio/mike-burr",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/elaine-strauss",
    "url": "/about-us/individual-bio/elaine-strauss",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/jon-snoeberger",
    "url": "/about-us/individual-bio/jon-snoeberger",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/simon-colenutt",
    "url": "/about-us/individual-bio/simon-colenutt",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/chris-price",
    "url": "/about-us/individual-bio/chris-price",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/john-schnarre",
    "url": "/about-us/individual-bio/john-schnarre",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/terry-donnelly",
    "url": "/about-us/individual-bio/terry-donnelly",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/shreyas-erapalli",
    "url": "/about-us/individual-bio/shreyas-erapalli",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/andrey-nikiforov",
    "url": "/about-us/individual-bio/andrey-nikiforov",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/managing-consultant-pmp",
    "url": "/about-us/individual-bio/managing-consultant-pmp",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/ecosa-team",
    "url": "/about-us/individual-bio/ecosa-team",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/kristine-davies",
    "url": "/about-us/individual-bio/kristine-davies",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/erica-dahl",
    "url": "/about-us/individual-bio/erica-dahl",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/chuck-buttry",
    "url": "/about-us/individual-bio/chuck-buttry",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/susan-barnes",
    "url": "/about-us/individual-bio/susan-barnes",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/shishir-mohan",
    "url": "/about-us/individual-bio/shishir-mohan",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/caitlin-king",
    "url": "/about-us/individual-bio/caitlin-king",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/adam-jackson",
    "url": "/about-us/individual-bio/adam-jackson",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/nimish-katwala",
    "url": "/about-us/individual-bio/nimish-katwala",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/kasi-dubbs",
    "url": "/about-us/individual-bio/kasi-dubbs",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/dana-norvell-pe",
    "url": "/about-us/individual-bio/dana-norvell-pe",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/josh-haar",
    "url": "/about-us/individual-bio/josh-haar",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/tiffany-stefanescu",
    "url": "/about-us/individual-bio/tiffany-stefanescu",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/george-iwaszek",
    "url": "/about-us/individual-bio/george-iwaszek",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/laura-redmon",
    "url": "/about-us/individual-bio/laura-redmon",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/disha-gadre",
    "url": "/about-us/individual-bio/disha-gadre",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/latha-kambham",
    "url": "/about-us/individual-bio/latha-kambham",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/mike-liebert",
    "url": "/about-us/individual-bio/mike-liebert",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/edward-gardetto",
    "url": "/about-us/individual-bio/edward-gardetto",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/valerie-rosenkrantz",
    "url": "/about-us/individual-bio/valerie-rosenkrantz",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/lori-bocchino",
    "url": "/about-us/individual-bio/lori-bocchino",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/meghan-foley",
    "url": "/about-us/individual-bio/meghan-foley",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/arron-heinerikson",
    "url": "/about-us/individual-bio/arron-heinerikson",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/ellen-hewitt",
    "url": "/about-us/individual-bio/ellen-hewitt",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/sundar-sadashivam",
    "url": "/about-us/individual-bio/sundar-sadashivam",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/qiguo-jing",
    "url": "/about-us/individual-bio/qiguo-jing",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/lisa-schmidt",
    "url": "/about-us/individual-bio/lisa-schmidt",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/mike-meister",
    "url": "/about-us/individual-bio/mike-meister",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/paul-smith",
    "url": "/about-us/individual-bio/paul-smith",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/Rich-Trzupek",
    "url": "/about-us/individual-bio/Rich-Trzupek",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/kirk-lowery",
    "url": "/about-us/individual-bio/kirk-lowery",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/chris-scullion-besc-cm",
    "url": "/about-us/individual-bio/chris-scullion-besc-cm",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/yana-chervona",
    "url": "/about-us/individual-bio/yana-chervona",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/emily-lower",
    "url": "/about-us/individual-bio/emily-lower",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/tony-colombari",
    "url": "/about-us/individual-bio/tony-colombari",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/wes-younger",
    "url": "/about-us/individual-bio/wes-younger",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/deborah-walden-hersh",
    "url": "/about-us/individual-bio/deborah-walden-hersh",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/allan-ader",
    "url": "/about-us/individual-bio/allan-ader",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/martin-axon",
    "url": "/about-us/individual-bio/martin-axon",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/jeremiah-redman",
    "url": "/about-us/individual-bio/jeremiah-redman",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/taylor-wilson",
    "url": "/about-us/individual-bio/taylor-wilson",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/natalie-vanliew",
    "url": "/about-us/individual-bio/natalie-vanliew",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/david-eb-strohm",
    "url": "/about-us/individual-bio/david-eb-strohm",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/jay-hofmann",
    "url": "/about-us/individual-bio/jay-hofmann",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/bill-bruscino",
    "url": "/about-us/individual-bio/bill-bruscino",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/steve-tasch",
    "url": "/about-us/individual-bio/steve-tasch",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/vineet-masuraha",
    "url": "/about-us/individual-bio/vineet-masuraha",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/melissa-ryan",
    "url": "/about-us/individual-bio/melissa-ryan",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/christine-haman",
    "url": "/about-us/individual-bio/christine-haman",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/christa-russell",
    "url": "/about-us/individual-bio/christa-russell",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/janet-martin",
    "url": "/about-us/individual-bio/janet-martin",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/steve-walters",
    "url": "/about-us/individual-bio/steve-walters",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/principal-consultant-climate-change-services",
    "url": "/about-us/individual-bio/principal-consultant-climate-change-services",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/mike-gunsinger",
    "url": "/about-us/individual-bio/mike-gunsinger",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/anna-aumann",
    "url": "/about-us/individual-bio/anna-aumann",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/rich-jenks",
    "url": "/about-us/individual-bio/rich-jenks",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/brian-mensinger",
    "url": "/about-us/individual-bio/brian-mensinger",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/jim-lyons",
    "url": "/about-us/individual-bio/jim-lyons",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/safebridge-team",
    "url": "/about-us/individual-bio/safebridge-team",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/tiffany-wang",
    "url": "/about-us/individual-bio/tiffany-wang",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/paul-lepage",
    "url": "/about-us/individual-bio/paul-lepage",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/andrew-martin",
    "url": "/about-us/individual-bio/andrew-martin",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/trs-team",
    "url": "/about-us/individual-bio/trs-team",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/dan-risch",
    "url": "/about-us/individual-bio/dan-risch",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/deanna-duram",
    "url": "/about-us/individual-bio/deanna-duram",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/lindsay-giovannetti",
    "url": "/about-us/individual-bio/lindsay-giovannetti",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/mike-remsberg",
    "url": "/about-us/individual-bio/mike-remsberg",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/anna-henolson",
    "url": "/about-us/individual-bio/anna-henolson",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/dave-larsen",
    "url": "/about-us/individual-bio/dave-larsen",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/divya-agarwal",
    "url": "/about-us/individual-bio/divya-agarwal",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/tony-schroeder",
    "url": "/about-us/individual-bio/tony-schroeder",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/aaron-day",
    "url": "/about-us/individual-bio/aaron-day",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/christi-wilson",
    "url": "/about-us/individual-bio/christi-wilson",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/inaas-darrat",
    "url": "/about-us/individual-bio/inaas-darrat",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/katie-jeziorski",
    "url": "/about-us/individual-bio/katie-jeziorski",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/rahul-pendse",
    "url": "/about-us/individual-bio/rahul-pendse",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/bob-schreiber",
    "url": "/about-us/individual-bio/bob-schreiber",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/minnow-team",
    "url": "/about-us/individual-bio/minnow-team",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/jesse-gonzalez",
    "url": "/about-us/individual-bio/jesse-gonzalez",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/cynthia-russel",
    "url": "/about-us/individual-bio/cynthia-russel",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/russell-bailey",
    "url": "/about-us/individual-bio/russell-bailey",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/leonie-andersen",
    "url": "/about-us/individual-bio/leonie-andersen",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/albert-dyrness",
    "url": "/about-us/individual-bio/albert-dyrness",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/brad-james",
    "url": "/about-us/individual-bio/brad-james",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/brian-noel",
    "url": "/about-us/individual-bio/brian-noel",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/bruce-douglas",
    "url": "/about-us/individual-bio/bruce-douglas",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/eddie-al-rayes",
    "url": "/about-us/individual-bio/eddie-al-rayes",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/advent-team",
    "url": "/about-us/individual-bio/advent-team",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/pierre-stecko",
    "url": "/about-us/individual-bio/pierre-stecko",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/jennifer-markwardt",
    "url": "/about-us/individual-bio/jennifer-markwardt",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/alex-marcucci",
    "url": "/about-us/individual-bio/alex-marcucci",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/john-hecht",
    "url": "/about-us/individual-bio/john-hecht",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/robert-a-large",
    "url": "/about-us/individual-bio/robert-a-large",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/kim-ayotte",
    "url": "/about-us/individual-bio/kim-ayotte",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/david-dempsey",
    "url": "/about-us/individual-bio/david-dempsey",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/casey-lenhart",
    "url": "/about-us/individual-bio/casey-lenhart",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/janet-gould",
    "url": "/about-us/individual-bio/janet-gould",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/taylor-loftis",
    "url": "/about-us/individual-bio/taylor-loftis",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/wendy-merz",
    "url": "/about-us/individual-bio/wendy-merz",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/brian-burdorf",
    "url": "/about-us/individual-bio/brian-burdorf",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/jeremy-jewell",
    "url": "/about-us/individual-bio/jeremy-jewell",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/tom-muscenti",
    "url": "/about-us/individual-bio/tom-muscenti",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/tony-jabon",
    "url": "/about-us/individual-bio/tony-jabon",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/rich-pandullo",
    "url": "/about-us/individual-bio/rich-pandullo",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/john-colebrook",
    "url": "/about-us/individual-bio/john-colebrook",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/george-shewe",
    "url": "/about-us/individual-bio/george-shewe",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/cems-specialist",
    "url": "/about-us/individual-bio/cems-specialist",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/rob-ferry",
    "url": "/about-us/individual-bio/rob-ferry",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/regional-director",
    "url": "/about-us/individual-bio/regional-director",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/steve-zervas",
    "url": "/about-us/individual-bio/steve-zervas",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/kyle-dunn",
    "url": "/about-us/individual-bio/kyle-dunn",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/alan-chuang",
    "url": "/about-us/individual-bio/alan-chuang",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/georgette-reeves",
    "url": "/about-us/individual-bio/georgette-reeves",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/branden-barry",
    "url": "/about-us/individual-bio/branden-barry",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/principal-consultant-ehs-performance-and-risk-management",
    "url": "/about-us/individual-bio/principal-consultant-ehs-performance-and-risk-management",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/sharon-limage",
    "url": "/about-us/individual-bio/sharon-limage",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/shari-weech",
    "url": "/about-us/individual-bio/shari-weech",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/tracy-kimmel",
    "url": "/about-us/individual-bio/tracy-kimmel",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/manager-ehands-auditing",
    "url": "/about-us/individual-bio/manager-ehands-auditing",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/steve-reale",
    "url": "/about-us/individual-bio/steve-reale",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/kati-petersburg",
    "url": "/about-us/individual-bio/kati-petersburg",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/christine-chambers",
    "url": "/about-us/individual-bio/christine-chambers",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/dan-smith",
    "url": "/about-us/individual-bio/dan-smith",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/paul-greywall",
    "url": "/about-us/individual-bio/paul-greywall",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/craig-llewellyn",
    "url": "/about-us/individual-bio/craig-llewellyn",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/carla-adduci",
    "url": "/about-us/individual-bio/carla-adduci",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/suzy-sabanathan",
    "url": "/about-us/individual-bio/suzy-sabanathan",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/david-wall",
    "url": "/about-us/individual-bio/david-wall",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/tony-powell",
    "url": "/about-us/individual-bio/tony-powell",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/jim-eggenschwiler",
    "url": "/about-us/individual-bio/jim-eggenschwiler",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/rhonda-grigg",
    "url": "/about-us/individual-bio/rhonda-grigg",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/sharon-killian",
    "url": "/about-us/individual-bio/sharon-killian",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/michael-ballenger",
    "url": "/about-us/individual-bio/michael-ballenger",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/nicole-saniti",
    "url": "/about-us/individual-bio/nicole-saniti",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/shannon-lynn",
    "url": "/about-us/individual-bio/shannon-lynn",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/matt-page",
    "url": "/about-us/individual-bio/matt-page",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/gillian-adams",
    "url": "/about-us/individual-bio/gillian-adams",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/colt-sommers",
    "url": "/about-us/individual-bio/colt-sommers",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/maya-rao",
    "url": "/about-us/individual-bio/maya-rao",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/xu-liu",
    "url": "/about-us/individual-bio/xu-liu",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/lynne-santos",
    "url": "/about-us/individual-bio/lynne-santos",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/consultant",
    "url": "/about-us/individual-bio/consultant",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/individual-bio/kate-mcdaniel",
    "url": "/about-us/individual-bio/kate-mcdaniel",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Managing Director",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/patrick-nonhof",
    "url": "/contact-us/patrick-nonhof",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "PHA Facilitator",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/patrick-fisher",
    "url": "/contact-us/patrick-fisher",
    "template": "new-individual-bio",
    "section": "pha-facilitator"
  },
  {
    "name": "Principal Industrial Hygienist",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/brent-altemose",
    "url": "/contact-us/brent-altemose",
    "template": "new-individual-bio",
    "section": "principal-industrial-hygienist"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/emily-kolb",
    "url": "/contact-us/emily-kolb",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Director, Mergers & Acquisitions",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/matt-berlew",
    "url": "/contact-us/matt-berlew",
    "template": "new-individual-bio",
    "section": "director,-mergers-acquisitions"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/raghu-soule",
    "url": "/contact-us/raghu-soule",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/mike-sherer-pe",
    "url": "/contact-us/mike-sherer-pe",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/managing-consultant",
    "url": "/contact-us/managing-consultant",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/managing-consultant",
    "url": "/managing-consultant",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/jeff-adkins",
    "url": "/contact-us/jeff-adkins",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Senior Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/courtny-edge",
    "url": "/contact-us/courtny-edge",
    "template": "new-individual-bio",
    "section": "senior-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/tony-phan",
    "url": "/contact-us/tony-phan",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Principal Toxicologist",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/mike-olson",
    "url": "/contact-us/mike-olson",
    "template": "new-individual-bio",
    "section": "principal-toxicologist"
  },
  {
    "name": "Director of Science and Technology",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/phillip-stanford",
    "url": "/contact-us/phillip-stanford",
    "template": "new-individual-bio",
    "section": "director-of-science-and-technology"
  },
  {
    "name": "Associate Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/associate-consultant",
    "url": "/contact-us/associate-consultant",
    "template": "new-individual-bio",
    "section": "associate-consultant"
  },
  {
    "name": "Associate Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/associate-consultant",
    "url": "/associate-consultant",
    "template": "new-individual-bio",
    "section": "associate-consultant"
  },
  {
    "name": "Director, EHS Global Services",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/hung-ming-sue-sung",
    "url": "/contact-us/hung-ming-sue-sung",
    "template": "new-individual-bio",
    "section": "director,-ehs-global-services"
  },
  {
    "name": "Director, EHS Global Services",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/hung-ming-sue-sung",
    "url": "/Hung-Ming-sue-Sung",
    "template": "new-individual-bio",
    "section": "director,-ehs-global-services"
  },
  {
    "name": "Associate Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/priscilla-khuu",
    "url": "/contact-us/priscilla-khuu",
    "template": "new-individual-bio",
    "section": "associate-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/chloe-s-reece",
    "url": "/contact-us/chloe-s-reece",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Senior Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/senior-consultant",
    "url": "/contact-us/senior-consultant",
    "template": "new-individual-bio",
    "section": "senior-consultant"
  },
  {
    "name": "Senior Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/senior-consultant",
    "url": "/senior-consultant",
    "template": "new-individual-bio",
    "section": "senior-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/aj-hansborough",
    "url": "/contact-us/aj-hansborough",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Managing Director",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/robert-sussman",
    "url": "/contact-us/robert-sussman",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/michael-trupin",
    "url": "/contact-us/michael-trupin",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/dale-overcash",
    "url": "/contact-us/dale-overcash",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Senior Toxicologist",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/bernie-lindquist",
    "url": "/contact-us/bernie-lindquist",
    "template": "new-individual-bio",
    "section": "senior-toxicologist"
  },
  {
    "name": "Senior Environmental Chemist",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/cheryl-wiramanaden",
    "url": "/contact-us/cheryl-wiramanaden",
    "template": "new-individual-bio",
    "section": "senior-environmental-chemist"
  },
  {
    "name": "Senior Environmental Chemist",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/cheryl-wiramanaden",
    "url": "/contact-us/cheryl-wiramanaden-m.chem.-ph.d.-p.chem",
    "template": "new-individual-bio",
    "section": "senior-environmental-chemist"
  },
  {
    "name": "Regional Director - Minneapolis, Minnesota",
    "apiurl": "/restapi/customaboutuslvl2content/regional-director--minneapolis-minnesota",
    "url": "/regional-director--minneapolis-minnesota",
    "template": "new-individual-bio",
    "section": "regional-director--minneapolis,-minnesota"
  },
  {
    "name": "Executive VP - WorkingBuildings",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/kurt-last",
    "url": "/contact-us/kurt-last",
    "template": "new-individual-bio",
    "section": "executive-vp--workingbuildings"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/eugene-w-taylor",
    "url": "/contact-us/eugene-w-taylor",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/ian-donaldson",
    "url": "/contact-us/ian-donaldson",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/mike-zimmer",
    "url": "/contact-us/mike-zimmer",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/mike-zimmer",
    "url": "/contact-us/mike-zimmer-pe",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Managing Director",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/felicity-melville",
    "url": "/contact-us/felicity-melville",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Managing Principal",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/kim-connors",
    "url": "/contact-us/kim-connors",
    "template": "new-individual-bio",
    "section": "managing-principal"
  },
  {
    "name": "Managing Director",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/justin-adams",
    "url": "/contact-us/justin-adams",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Senior Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/kathryn-connolly",
    "url": "/contact-us/kathryn-connolly",
    "template": "new-individual-bio",
    "section": "senior-consultant"
  },
  {
    "name": "Director, EHS Digital Solutions",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/jason-schmitz",
    "url": "/contact-us/jason-schmitz",
    "template": "new-individual-bio",
    "section": "director,-ehs-digital-solutions"
  },
  {
    "name": "Director, BREEZE Software & China Operations",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/weiping-dai",
    "url": "/contact-us/weiping-dai",
    "template": "new-individual-bio",
    "section": "director,-breeze-software-china-operations"
  },
  {
    "name": "Regional Director",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/robert-liles",
    "url": "/contact-us/robert-liles",
    "template": "new-individual-bio",
    "section": "regional-director"
  },
  {
    "name": "Vice President",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/christina-ridge",
    "url": "/contact-us/christina-ridge",
    "template": "new-individual-bio",
    "section": "vice-president"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/gena-driscoll",
    "url": "/contact-us/gena-driscoll",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Managing Consultant, Climate Change Services",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/managing-consultant-climate-change-services",
    "url": "/contact-us/managing-consultant-climate-change-services",
    "template": "new-individual-bio",
    "section": "managing-consultant,-climate-change-services"
  },
  {
    "name": "Managing Consultant, Climate Change Services",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/managing-consultant-climate-change-services",
    "url": "/managing-consultant-climate-change-services",
    "template": "new-individual-bio",
    "section": "managing-consultant,-climate-change-services"
  },
  {
    "name": "Managing Director",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/john-iwanski",
    "url": "/contact-us/john-iwanski",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Managing Director",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/john-iwanski",
    "url": "/contact-us/managing-director---north-region",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Managing Director",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/john-iwanski",
    "url": "/managing-director---north-region",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/christine-heath",
    "url": "/contact-us/christine-heath",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/charles-c-lee",
    "url": "/contact-us/charles-c-lee",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/adam-erenstein",
    "url": "/contact-us/adam-erenstein",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/mike-burr",
    "url": "/contact-us/mike-burr",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Senior Consultant, Cleanrooms and Sterile Compounding",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/elaine-strauss",
    "url": "/contact-us/elaine-strauss",
    "template": "new-individual-bio",
    "section": "senior-consultant,-cleanrooms-and-sterile-compounding"
  },
  {
    "name": "Associate Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/jon-snoeberger",
    "url": "/contact-us/jon-snoeberger",
    "template": "new-individual-bio",
    "section": "associate-consultant"
  },
  {
    "name": "Managing Principal Ecologist",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/simon-colenutt",
    "url": "/contact-us/simon-colenutt",
    "template": "new-individual-bio",
    "section": "managing-principal-ecologist"
  },
  {
    "name": "Director, Human Resources",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/chris-price",
    "url": "/contact-us/chris-price",
    "template": "new-individual-bio",
    "section": "director,-human-resources"
  },
  {
    "name": "Senior Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/john-schnarre",
    "url": "/contact-us/john-schnarre",
    "template": "new-individual-bio",
    "section": "senior-consultant"
  },
  {
    "name": "Managing Director, AWN Consulting",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/terry-donnelly",
    "url": "/contact-us/terry-donnelly",
    "template": "new-individual-bio",
    "section": "managing-director,-awn-consulting"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/shreyas-erapalli",
    "url": "/contact-us/shreyas-erapalli",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "President, Principal",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/andrey-nikiforov",
    "url": "/contact-us/andrey-nikiforov",
    "template": "new-individual-bio",
    "section": "president,-principal"
  },
  {
    "name": "Managing Consultant, PMP",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/managing-consultant-pmp",
    "url": "/contact-us/managing-consultant-pmp",
    "template": "new-individual-bio",
    "section": "managing-consultant,-pmp"
  },
  {
    "name": "Managing Consultant, PMP",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/managing-consultant-pmp",
    "url": "/managing-consultant-pmp",
    "template": "new-individual-bio",
    "section": "managing-consultant,-pmp"
  },
  {
    "name": "ECOSA Team",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/ecosa-team",
    "url": "/contact-us/ecosa-team",
    "template": "new-individual-bio",
    "section": "ecosa-team"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/kristine-davies",
    "url": "/contact-us/kristine-davies",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Managing Toxicologist",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/erica-dahl",
    "url": "/contact-us/erica-dahl",
    "template": "new-individual-bio",
    "section": "managing-toxicologist"
  },
  {
    "name": "Regional Manager",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/chuck-buttry",
    "url": "/contact-us/chuck-buttry",
    "template": "new-individual-bio",
    "section": "regional-manager"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/susan-barnes",
    "url": "/contact-us/susan-barnes",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Managing Director",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/shishir-mohan",
    "url": "/contact-us/shishir-mohan",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Senior Supervisor",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/caitlin-king",
    "url": "/contact-us/caitlin-king",
    "template": "new-individual-bio",
    "section": "senior-supervisor"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/adam-jackson",
    "url": "/contact-us/adam-jackson",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Director, Integration & Corporate Strategy",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/nimish-katwala",
    "url": "/contact-us/nimish-katwala",
    "template": "new-individual-bio",
    "section": "director,-integration-corporate-strategy"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/kasi-dubbs",
    "url": "/contact-us/kasi-dubbs",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/dana-norvell-pe",
    "url": "/contact-us/dana-norvell-pe",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Senior Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/josh-haar",
    "url": "/contact-us/josh-haar",
    "template": "new-individual-bio",
    "section": "senior-consultant"
  },
  {
    "name": "Senior Product Specialist / Meteorologist",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/tiffany-stefanescu",
    "url": "/contact-us/tiffany-stefanescu",
    "template": "new-individual-bio",
    "section": "senior-product-specialist--meteorologist"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/george-iwaszek",
    "url": "/contact-us/george-iwaszek",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/george-iwaszek",
    "url": "/contact-us/manager-of-consulting-services",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Director, Marketing",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/laura-redmon",
    "url": "/contact-us/laura-redmon",
    "template": "new-individual-bio",
    "section": "director,-marketing"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/disha-gadre",
    "url": "/contact-us/disha-gadre",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/latha-kambham",
    "url": "/contact-us/latha-kambham",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/mike-liebert",
    "url": "/contact-us/mike-liebert",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/edward-gardetto",
    "url": "/contact-us/edward-gardetto",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "﻿ Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/valerie-rosenkrantz",
    "url": "/contact-us/valerie-rosenkrantz",
    "template": "new-individual-bio",
    "section": "﻿-managing-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/lori-bocchino",
    "url": "/contact-us/lori-bocchino",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/meghan-foley",
    "url": "/contact-us/meghan-foley",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Regional Director",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/arron-heinerikson",
    "url": "/contact-us/arron-heinerikson",
    "template": "new-individual-bio",
    "section": "regional-director"
  },
  {
    "name": "Regional Director",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/arron-heinerikson",
    "url": "/contact-us/aaron-heinerikson",
    "template": "new-individual-bio",
    "section": "regional-director"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/ellen-hewitt",
    "url": "/contact-us/ellen-hewitt",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/sundar-sadashivam",
    "url": "/contact-us/sundar-sadashivam",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Senior Environmental Software Specialist",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/qiguo-jing",
    "url": "/contact-us/qiguo-jing",
    "template": "new-individual-bio",
    "section": "senior-environmental-software-specialist"
  },
  {
    "name": "Principal Consultant - Tulsa, OK",
    "apiurl": "/restapi/customaboutuslvl2content/principal-consultant--tulsa-ok",
    "url": "/principal-consultant--tulsa-ok",
    "template": "new-individual-bio",
    "section": "principal-consultant--tulsa,-ok"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/lisa-schmidt",
    "url": "/contact-us/lisa-schmidt",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/mike-meister",
    "url": "/contact-us/mike-meister",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Director, Quality Management",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/paul-smith",
    "url": "/contact-us/paul-smith",
    "template": "new-individual-bio",
    "section": "director,-quality-management"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/Rich-Trzupek",
    "url": "/contact-us/Rich-Trzupek",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/Rich-Trzupek",
    "url": "/contact-us/trinity-consultants",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/Rich-Trzupek",
    "url": "/Rich-Trzupek",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Regional Director",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/kirk-lowery",
    "url": "/contact-us/kirk-lowery",
    "template": "new-individual-bio",
    "section": "regional-director"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/chris-scullion-besc-cm",
    "url": "/contact-us/chris-scullion-besc-cm",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Senior Toxicologist",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/yana-chervona",
    "url": "/contact-us/yana-chervona",
    "template": "new-individual-bio",
    "section": "senior-toxicologist"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/emily-lower",
    "url": "/contact-us/emily-lower",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/tony-colombari",
    "url": "/contact-us/tony-colombari",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/wes-younger",
    "url": "/contact-us/wes-younger",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/deborah-walden--hersh",
    "url": "/contact-us/deborah-walden--hersh",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/deborah-walden--hersh",
    "url": "/contact-us/deborah-walden-hersh",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Managing Director",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/allan-ader",
    "url": "/contact-us/allan-ader",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Senior Principal Occupational Hygienist, European Operations",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/martin-axon",
    "url": "/contact-us/martin-axon",
    "template": "new-individual-bio",
    "section": "senior-principal-occupational-hygienist,-european-operations"
  },
  {
    "name": "Senior Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/jeremiah-redman",
    "url": "/contact-us/jeremiah-redman",
    "template": "new-individual-bio",
    "section": "senior-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/taylor-wilson",
    "url": "/contact-us/taylor-wilson",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/natalie-vanliew",
    "url": "/contact-us/natalie-vanliew",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/david-eb-strohm",
    "url": "/contact-us/david-eb-strohm",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "President / CEO",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/jay-hofmann",
    "url": "/contact-us/jay-hofmann",
    "template": "new-individual-bio",
    "section": "president--ceo"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/bill-bruscino",
    "url": "/contact-us/bill-bruscino",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/steve-tasch",
    "url": "/contact-us/steve-tasch",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Managing Director",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/vineet-masuraha",
    "url": "/contact-us/vineet-masuraha",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/melissa-ryan",
    "url": "/contact-us/melissa-ryan",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/christine-haman",
    "url": "/contact-us/christine-haman",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Senior Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/christa-russell",
    "url": "/contact-us/christa-russell",
    "template": "new-individual-bio",
    "section": "senior-consultant"
  },
  {
    "name": "Vice President",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/janet-martin",
    "url": "/contact-us/janet-martin",
    "template": "new-individual-bio",
    "section": "vice-president"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/steve-walters",
    "url": "/contact-us/steve-walters",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Principal Consultant, Climate Change Services",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/principal-consultant-climate-change-services",
    "url": "/contact-us/principal-consultant-climate-change-services",
    "template": "new-individual-bio",
    "section": "principal-consultant,-climate-change-services"
  },
  {
    "name": "Principal Consultant, Climate Change Services",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/principal-consultant-climate-change-services",
    "url": "/principal-consultant-climate-change-services",
    "template": "new-individual-bio",
    "section": "principal-consultant,-climate-change-services"
  },
  {
    "name": "Senior Geoscientist",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/mike-gunsinger",
    "url": "/contact-us/mike-gunsinger",
    "template": "new-individual-bio",
    "section": "senior-geoscientist"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/anna-aumann",
    "url": "/contact-us/anna-aumann",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Regional Director",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/rich-jenks",
    "url": "/contact-us/rich-jenks",
    "template": "new-individual-bio",
    "section": "regional-director"
  },
  {
    "name": "Regional Director",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/rich-jenks",
    "url": "/contact-us/rich-jenks-",
    "template": "new-individual-bio",
    "section": "regional-director"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/brian-mensinger",
    "url": "/contact-us/brian-mensinger",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/jim-lyons",
    "url": "/contact-us/jim-lyons",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "SafeBridge Team",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/safebridge-team",
    "url": "/contact-us/safebridge-team",
    "template": "new-individual-bio",
    "section": "safebridge-team"
  },
  {
    "name": "Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/tiffany-wang",
    "url": "/contact-us/tiffany-wang",
    "template": "new-individual-bio",
    "section": "consultant"
  },
  {
    "name": "Senior Aquatic Scientist",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/paul-lepage",
    "url": "/contact-us/paul-lepage",
    "template": "new-individual-bio",
    "section": "senior-aquatic-scientist"
  },
  {
    "name": "Air Quality Manager",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/andrew-martin",
    "url": "/contact-us/andrew-martin",
    "template": "new-individual-bio",
    "section": "air-quality-manager"
  },
  {
    "name": "TRS Team",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/trs-team",
    "url": "/contact-us/trs-team",
    "template": "new-individual-bio",
    "section": "trs-team"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/dan-risch",
    "url": "/contact-us/dan-risch",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/deanna-duram",
    "url": "/contact-us/deanna-duram",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Senior Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/lindsay-giovannetti",
    "url": "/contact-us/lindsay-giovannetti",
    "template": "new-individual-bio",
    "section": "senior-consultant"
  },
  {
    "name": "Managing Director, Commercial and Operational Strategies",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/mike-remsberg",
    "url": "/contact-us/mike-remsberg",
    "template": "new-individual-bio",
    "section": "managing-director,-commercial-and-operational-strategies"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/anna-henolson",
    "url": "/contact-us/anna-henolson",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Chief Financial Officer",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/dave-larsen",
    "url": "/contact-us/dave-larsen",
    "template": "new-individual-bio",
    "section": "chief-financial-officer"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/divya-agarwal",
    "url": "/contact-us/divya-agarwal",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/tony-schroeder",
    "url": "/contact-us/tony-schroeder",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/aaron-day",
    "url": "/contact-us/aaron-day",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/christi-wilson",
    "url": "/contact-us/christi-wilson",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Director, Chemical Sector Services",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/inaas-darrat",
    "url": "/contact-us/inaas-darrat",
    "template": "new-individual-bio",
    "section": "director,-chemical-sector-services"
  },
  {
    "name": "Director, Chemical Sector Services",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/inaas-darrat",
    "url": "/director-chemical-sector-services",
    "template": "new-individual-bio",
    "section": "director,-chemical-sector-services"
  },
  {
    "name": "Director, Chemical Sector Services",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/inaas-darrat",
    "url": "/contact-us/director-chemical-sector-services",
    "template": "new-individual-bio",
    "section": "director,-chemical-sector-services"
  },
  {
    "name": "BD Manager",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/katie-jeziorski",
    "url": "/contact-us/katie-jeziorski",
    "template": "new-individual-bio",
    "section": "bd-manager"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/rahul-pendse",
    "url": "/contact-us/rahul-pendse",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/bob-schreiber",
    "url": "/contact-us/bob-schreiber",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Minnow Team",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/minnow-team",
    "url": "/contact-us/minnow-team",
    "template": "new-individual-bio",
    "section": "minnow-team"
  },
  {
    "name": "Senior Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/jesse-gonzalez",
    "url": "/contact-us/jesse-gonzalez",
    "template": "new-individual-bio",
    "section": "senior-consultant"
  },
  {
    "name": "Regional Manager",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/cynthia-russel",
    "url": "/contact-us/cynthia-russel",
    "template": "new-individual-bio",
    "section": "regional-manager"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/russell-bailey",
    "url": "/contact-us/russell-bailey",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/russell-bailey",
    "url": "/contact-us/russell-bailey-",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Managing Director",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/leonie-andersen",
    "url": "/contact-us/leonie-andersen",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Managing Director, Advent Engineering Life Sciences Solutions",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/albert-dyrness",
    "url": "/contact-us/albert-dyrness",
    "template": "new-individual-bio",
    "section": "managing-director,-advent-engineering-life-sciences-solutions"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/brad-james",
    "url": "/contact-us/brad-james",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Manager of Consulting Services",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/brian-noel",
    "url": "/contact-us/brian-noel",
    "template": "new-individual-bio",
    "section": "manager-of-consulting-services"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/bruce-douglas",
    "url": "/contact-us/bruce-douglas",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Regional Manager",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/eddie-al--rayes",
    "url": "/contact-us/eddie-al--rayes",
    "template": "new-individual-bio",
    "section": "regional-manager"
  },
  {
    "name": "Regional Manager",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/eddie-al--rayes",
    "url": "/contact-us/eddie-al-rayes",
    "template": "new-individual-bio",
    "section": "regional-manager"
  },
  {
    "name": "Regional Manager",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/eddie-al--rayes",
    "url": "/contact-us/eddie--al-rayes",
    "template": "new-individual-bio",
    "section": "regional-manager"
  },
  {
    "name": "Regional Manager",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/eddie-al--rayes",
    "url": "/about/leadership/eddie-al-rayes",
    "template": "new-individual-bio",
    "section": "regional-manager"
  },
  {
    "name": "Regional Manager",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/eddie-al--rayes",
    "url": "/contact-us/eddie-al---rayes",
    "template": "new-individual-bio",
    "section": "regional-manager"
  },
  {
    "name": "Regional Manager",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/eddie-al--rayes",
    "url": "/contact-us/eddie-alrayes",
    "template": "new-individual-bio",
    "section": "regional-manager"
  },
  {
    "name": "Regional Manager",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/eddie-al--rayes",
    "url": "/contact-us/eddie--al--rayes",
    "template": "new-individual-bio",
    "section": "regional-manager"
  },
  {
    "name": "Regional Manager",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/eddie-al--rayes",
    "url": "/contact-us/eddie-al_-rayes",
    "template": "new-individual-bio",
    "section": "regional-manager"
  },
  {
    "name": "Regional Manager",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/eddie-al--rayes",
    "url": "/contact-us/eddie-al-rayes-",
    "template": "new-individual-bio",
    "section": "regional-manager"
  },
  {
    "name": "Regional Manager",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/eddie-al--rayes",
    "url": "/about/leadership/eddie--al--rayes",
    "template": "new-individual-bio",
    "section": "regional-manager"
  },
  {
    "name": "Advent Team",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/advent-team",
    "url": "/contact-us/advent-team",
    "template": "new-individual-bio",
    "section": "advent-team"
  },
  {
    "name": "Managing Principal",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/pierre-stecko",
    "url": "/contact-us/pierre-stecko",
    "template": "new-individual-bio",
    "section": "managing-principal"
  },
  {
    "name": "Senior Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/jennifer-markwardt",
    "url": "/contact-us/jennifer-markwardt",
    "template": "new-individual-bio",
    "section": "senior-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/alex-marcucci",
    "url": "/contact-us/alex-marcucci",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/john-hecht",
    "url": "/contact-us/john-hecht",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/robert-a-large",
    "url": "/contact-us/robert-a-large",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/kim-ayotte",
    "url": "/contact-us/kim-ayotte",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/david-dempsey",
    "url": "/contact-us/david-dempsey",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Director, Monitoring Services",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/casey-lenhart",
    "url": "/contact-us/casey-lenhart",
    "template": "new-individual-bio",
    "section": "director,-monitoring-services"
  },
  {
    "name": "Principal Toxicologist",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/janet-gould",
    "url": "/contact-us/janet-gould",
    "template": "new-individual-bio",
    "section": "principal-toxicologist"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/taylor-loftis",
    "url": "/contact-us/taylor-loftis",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/wendy-merz",
    "url": "/contact-us/wendy-merz",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Director, Operations",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/brian-burdorf",
    "url": "/contact-us/brian-burdorf",
    "template": "new-individual-bio",
    "section": "director,-operations"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/jeremy-jewell",
    "url": "/contact-us/jeremy-jewell",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Regional Manager",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/tom-muscenti",
    "url": "/contact-us/tom-muscenti",
    "template": "new-individual-bio",
    "section": "regional-manager"
  },
  {
    "name": "Regional Manager",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/tony-jabon",
    "url": "/contact-us/tony-jabon",
    "template": "new-individual-bio",
    "section": "regional-manager"
  },
  {
    "name": "Regional Manager",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/tony-jabon",
    "url": "/contact-us/tony-jabon-pe",
    "template": "new-individual-bio",
    "section": "regional-manager"
  },
  {
    "name": "Director, Sustainability and Environmental Management",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/rich-pandullo",
    "url": "/contact-us/rich-pandullo",
    "template": "new-individual-bio",
    "section": "director,-sustainability-and-environmental-management"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/john-colebrook",
    "url": "/contact-us/john-colebrook",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/george-shewe",
    "url": "/contact-us/george-shewe",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "CEMS Specialist",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/cems-specialist",
    "url": "/contact-us/cems-specialist",
    "template": "new-individual-bio",
    "section": "cems-specialist"
  },
  {
    "name": "CEMS Specialist",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/cems-specialist",
    "url": "/cems-specialist",
    "template": "new-individual-bio",
    "section": "cems-specialist"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/rob-ferry",
    "url": "/contact-us/rob-ferry",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Regional Director",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/regional-director",
    "url": "/contact-us/regional-director",
    "template": "new-individual-bio",
    "section": "regional-director"
  },
  {
    "name": "Regional Director",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/regional-director",
    "url": "/regional-director",
    "template": "new-individual-bio",
    "section": "regional-director"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/steve-zervas",
    "url": "/contact-us/steve-zervas",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/kyle-dunn",
    "url": "/contact-us/kyle-dunn",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Director, Information Technology",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/alan-chuang",
    "url": "/contact-us/alan-chuang",
    "template": "new-individual-bio",
    "section": "director,-information-technology"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/georgette-reeves",
    "url": "/contact-us/georgette-reeves",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Senior Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/branden-barry",
    "url": "/contact-us/branden-barry",
    "template": "new-individual-bio",
    "section": "senior-consultant"
  },
  {
    "name": "Principal Consultant, EHS Performance & Risk Management",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/principal-consultant-ehs-performance-and-risk-management",
    "url": "/contact-us/principal-consultant-ehs-performance-and-risk-management",
    "template": "new-individual-bio",
    "section": "principal-consultant,-ehs-performance-risk-management"
  },
  {
    "name": "Principal Consultant, EHS Performance & Risk Management",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/principal-consultant-ehs-performance-and-risk-management",
    "url": "/principal-consultant-ehs-performance-and-risk-management",
    "template": "new-individual-bio",
    "section": "principal-consultant,-ehs-performance-risk-management"
  },
  {
    "name": "Regional Business Development Supervisor",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/sharon-limage",
    "url": "/contact-us/sharon-limage",
    "template": "new-individual-bio",
    "section": "regional-business-development-supervisor"
  },
  {
    "name": "Senior Scientist/Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/shari-weech",
    "url": "/contact-us/shari-weech",
    "template": "new-individual-bio",
    "section": "senior-scientistprincipal-consultant"
  },
  {
    "name": "Principal Toxicologist",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/tracy-kimmel",
    "url": "/contact-us/tracy-kimmel",
    "template": "new-individual-bio",
    "section": "principal-toxicologist"
  },
  {
    "name": "Manager, EH&S Auditing",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/manager-ehands-auditing",
    "url": "/contact-us/manager-ehands-auditing",
    "template": "new-individual-bio",
    "section": "manager,-ehs-auditing"
  },
  {
    "name": "Manager, EH&S Auditing",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/manager-ehands-auditing",
    "url": "/manager-ehands-auditing",
    "template": "new-individual-bio",
    "section": "manager,-ehs-auditing"
  },
  {
    "name": "Senior Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/steve-reale",
    "url": "/contact-us/steve-reale",
    "template": "new-individual-bio",
    "section": "senior-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/kati-petersburg",
    "url": "/contact-us/kati-petersburg",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Regional Manager",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/christine-chambers",
    "url": "/contact-us/christine-chambers",
    "template": "new-individual-bio",
    "section": "regional-manager"
  },
  {
    "name": "Senior Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/dan-smith",
    "url": "/contact-us/dan-smith",
    "template": "new-individual-bio",
    "section": "senior-consultant"
  },
  {
    "name": "Managing Director, Corp. Development",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/paul-greywall",
    "url": "/contact-us/paul-greywall",
    "template": "new-individual-bio",
    "section": "managing-director,-corp.-development"
  },
  {
    "name": "Principal and Scientific Director",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/craig-llewellyn",
    "url": "/contact-us/craig-llewellyn",
    "template": "new-individual-bio",
    "section": "principal-and-scientific-director"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/carla-adduci",
    "url": "/contact-us/carla-adduci",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Senior Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/suzy-sabanathan",
    "url": "/contact-us/suzy-sabanathan",
    "template": "new-individual-bio",
    "section": "senior-consultant"
  },
  {
    "name": "Regional Manager",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/david-wall",
    "url": "/contact-us/david-wall",
    "template": "new-individual-bio",
    "section": "regional-manager"
  },
  {
    "name": "Managing Director",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/tony-powell",
    "url": "/contact-us/tony-powell",
    "template": "new-individual-bio",
    "section": "managing-director"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/jim-eggenschwiler",
    "url": "/contact-us/jim-eggenschwiler",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/rhonda-grigg",
    "url": "/contact-us/rhonda-grigg",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/sharon-killian",
    "url": "/contact-us/sharon-killian",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/michael-ballenger",
    "url": "/contact-us/michael-ballenger",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/michael-ballenger",
    "url": "/contact-us/michael-ballenger-",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/nicole-saniti",
    "url": "/contact-us/nicole-saniti",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/shannon-lynn",
    "url": "/contact-us/shannon-lynn",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/shannon-lynn",
    "url": "/contact-us/principal-consultant--little-rock-ar",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/shannon-lynn",
    "url": "/contact-us/shannon-lynn-pe",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Principal Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/shannon-lynn",
    "url": "/principal-consultant--little-rock-ar",
    "template": "new-individual-bio",
    "section": "principal-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/matt-page",
    "url": "/contact-us/matt-page",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Business Manager",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/gillian-adams",
    "url": "/contact-us/gillian-adams",
    "template": "new-individual-bio",
    "section": "business-manager"
  },
  {
    "name": "Senior Project Manager",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/colt-sommers",
    "url": "/contact-us/colt-sommers",
    "template": "new-individual-bio",
    "section": "senior-project-manager"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/maya-rao",
    "url": "/contact-us/maya-rao",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Senior Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/xu-liu",
    "url": "/contact-us/xu-liu",
    "template": "new-individual-bio",
    "section": "senior-consultant"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/lynne-santos",
    "url": "/contact-us/lynne-santos",
    "template": "new-individual-bio",
    "section": "managing-consultant"
  },
  {
    "name": "Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/consultant",
    "url": "/contact-us/consultant",
    "template": "new-individual-bio",
    "section": "consultant"
  },
  {
    "name": "Consultant",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/consultant",
    "url": "/consultant",
    "template": "new-individual-bio",
    "section": "consultant"
  },
  {
    "name": "Principal Consultant, EHS Digital Solutions",
    "apiurl": "/restapi/customaboutuslvl2content/contact-us/kate-mcdaniel",
    "url": "/contact-us/kate-mcdaniel",
    "template": "new-individual-bio",
    "section": "principal-consultant,-ehs-digital-solutions"
  },
  {
    "name": "Subscribe",
    "apiurl": "/restapi/customcontent/subscribe",
    "url": "/subscribe",
    "template": "general_content",
    "section": "subscribe"
  },
  {
    "name": "Tanks",
    "apiurl": "/restapi/customcontent/software/tanks",
    "url": "/software/tanks",
    "template": "software-categories",
    "section": "tanks"
  },
  {
    "name": "Tanks",
    "apiurl": "/restapi/customcontent/software/tanks",
    "url": "/software/tank-emissions",
    "template": "software-categories",
    "section": "tanks"
  },
  {
    "name": "Explosion",
    "apiurl": "/restapi/customcontent/software/explosion",
    "url": "/software/explosion",
    "template": "software-categories",
    "section": "explosion"
  },
  {
    "name": "Explosion",
    "apiurl": "/restapi/customcontent/software/explosion",
    "url": "/software/products/explosion",
    "template": "software-categories",
    "section": "explosion"
  },
  {
    "name": "Data Analysis",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization",
    "url": "/software/air-dispersion---data-visualization",
    "template": "software-categories",
    "section": "data-analysis"
  },
  {
    "name": "Data Analysis",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization",
    "url": "/software/products/air-dispersion-data-visualization",
    "template": "software-categories",
    "section": "data-analysis"
  },
  {
    "name": "Data Analysis",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization",
    "url": "/software/air-dispersion---data",
    "template": "software-categories",
    "section": "data-analysis"
  },
  {
    "name": "Hazard",
    "apiurl": "/restapi/customcontent/software/hazard",
    "url": "/software/hazard",
    "template": "software-categories",
    "section": "hazard"
  },
  {
    "name": "Hazard",
    "apiurl": "/restapi/customcontent/software/hazard",
    "url": "/software/products/hazard",
    "template": "software-categories",
    "section": "hazard"
  },
  {
    "name": "Air Dispersion",
    "apiurl": "/restapi/customcontent/software/dispersion",
    "url": "/software/dispersion",
    "template": "software-categories",
    "section": "air-dispersion"
  },
  {
    "name": "Air Dispersion",
    "apiurl": "/restapi/customcontent/software/dispersion",
    "url": "/software/products/air-dispersion/",
    "template": "software-categories",
    "section": "air-dispersion"
  },
  {
    "name": "Health Risk",
    "apiurl": "/restapi/customcontent/software/health-risk",
    "url": "/software/health-risk",
    "template": "software-categories",
    "section": "health-risk"
  },
  {
    "name": "Health Risk",
    "apiurl": "/restapi/customcontent/software/health-risk",
    "url": "/software/products/health-risk",
    "template": "software-categories",
    "section": "health-risk"
  },
  {
    "name": "5.0",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/tankesp/5.0",
    "url": "/software/support/release-notes/tankesp/5.0",
    "template": "new-releasenotes-categroy",
    "section": "tankesp"
  },
  {
    "name": "2.4.1",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/3d-analyst/2.4.1",
    "url": "/software/support/release-notes/3d-analyst/2.4.1",
    "template": "new-releasenotes-categroy",
    "section": "3d-analyst"
  },
  {
    "name": "1.7",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/downwash-analyst/1.7",
    "url": "/software/support/release-notes/downwash-analyst/1.7",
    "template": "new-releasenotes-categroy",
    "section": "downwash-analyst"
  },
  {
    "name": "9.2",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermod/9.2",
    "url": "/software/support/release-notes/aermod/9.2",
    "template": "new-releasenotes-categroy",
    "section": "aermod"
  },
  {
    "name": "4.0",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/incident-analyst/4.0",
    "url": "/software/support/release-notes/incident-analyst/4.0",
    "template": "new-releasenotes-categroy",
    "section": "incident-analyst"
  },
  {
    "name": "7.4",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermod/7.4",
    "url": "/software/support/release-notes/aermod/7.4",
    "template": "new-releasenotes-categroy",
    "section": "aermod"
  },
  {
    "name": "3.0",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/incident-analyst/3.0",
    "url": "/software/support/release-notes/incident-analyst/3.0",
    "template": "new-releasenotes-categroy",
    "section": "incident-analyst"
  },
  {
    "name": "5.1",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/tankesp/5.1",
    "url": "/software/support/release-notes/tankesp/5.1",
    "template": "new-releasenotes-categroy",
    "section": "tankesp"
  },
  {
    "name": "7.5",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermet/7.5",
    "url": "/software/support/release-notes/aermet/7.5",
    "template": "new-releasenotes-categroy",
    "section": "aermet"
  },
  {
    "name": "2.3.2",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/3d-analyst/2.3.2",
    "url": "/software/support/release-notes/3d-analyst/2.3.2",
    "template": "new-releasenotes-categroy",
    "section": "3d-analyst"
  },
  {
    "name": "7.4",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermet/7.4",
    "url": "/software/support/release-notes/aermet/7.4",
    "template": "new-releasenotes-categroy",
    "section": "aermet"
  },
  {
    "name": "2.0",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/calpuff/2.0",
    "url": "/software/support/release-notes/calpuff/2.0",
    "template": "new-releasenotes-categroy",
    "section": "calpuff"
  },
  {
    "name": "1.4",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/incident-analyst/1.4",
    "url": "/software/support/release-notes/incident-analyst/1.4",
    "template": "new-releasenotes-categroy",
    "section": "incident-analyst"
  },
  {
    "name": "9.0",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermod/9.0",
    "url": "/software/support/release-notes/aermod/9.0",
    "template": "new-releasenotes-categroy",
    "section": "aermod"
  },
  {
    "name": "7.5",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermod/7.5",
    "url": "/software/support/release-notes/aermod/7.5",
    "template": "new-releasenotes-categroy",
    "section": "aermod"
  },
  {
    "name": "5.1.9",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/roads/5.1.9",
    "url": "/software/support/release-notes/roads/5.1.9",
    "template": "new-releasenotes-categroy",
    "section": "roads"
  },
  {
    "name": "1.8",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aerscreen/1.8",
    "url": "/software/support/release-notes/aerscreen/1.8",
    "template": "new-releasenotes-categroy",
    "section": "aerscreen"
  },
  {
    "name": "7.12",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermod/7.12",
    "url": "/software/support/release-notes/aermod/7.12",
    "template": "new-releasenotes-categroy",
    "section": "aermod"
  },
  {
    "name": "1.9",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aerscreen/1.9",
    "url": "/software/support/release-notes/aerscreen/1.9",
    "template": "new-releasenotes-categroy",
    "section": "aerscreen"
  },
  {
    "name": "7.12.1",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermod/7.12.1",
    "url": "/software/support/release-notes/aermod/7.12.1",
    "template": "new-releasenotes-categroy",
    "section": "aermod"
  },
  {
    "name": "8.0",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermod/8.0",
    "url": "/software/support/release-notes/aermod/8.0",
    "template": "new-releasenotes-categroy",
    "section": "aermod"
  },
  {
    "name": "5.0",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/vasdip/5.0",
    "url": "/software/support/release-notes/vasdip/5.0",
    "template": "new-releasenotes-categroy",
    "section": "vasdip"
  },
  {
    "name": "2.2",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/calpuff/2.2",
    "url": "/software/support/release-notes/calpuff/2.2",
    "template": "new-releasenotes-categroy",
    "section": "calpuff"
  },
  {
    "name": "7.8",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermod/7.8",
    "url": "/software/support/release-notes/aermod/7.8",
    "template": "new-releasenotes-categroy",
    "section": "aermod"
  },
  {
    "name": "8.5.1",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/exdam/8.5.1",
    "url": "/software/support/release-notes/exdam/8.5.1",
    "template": "new-releasenotes-categroy",
    "section": "exdam"
  },
  {
    "name": "1.7",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aerscreen/1.7",
    "url": "/software/support/release-notes/aerscreen/1.7",
    "template": "new-releasenotes-categroy",
    "section": "aerscreen"
  },
  {
    "name": "2.0",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/incident-analyst/2.0",
    "url": "/software/support/release-notes/incident-analyst/2.0",
    "template": "new-releasenotes-categroy",
    "section": "incident-analyst"
  },
  {
    "name": "7.7",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermet/7.7",
    "url": "/software/support/release-notes/aermet/7.7",
    "template": "new-releasenotes-categroy",
    "section": "aermet"
  },
  {
    "name": "2.3",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/3d-analyst/2.3",
    "url": "/software/support/release-notes/3d-analyst/2.3",
    "template": "new-releasenotes-categroy",
    "section": "3d-analyst"
  },
  {
    "name": "8.0",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermet/8.0",
    "url": "/software/support/release-notes/aermet/8.0",
    "template": "new-releasenotes-categroy",
    "section": "aermet"
  },
  {
    "name": "7.2",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermod/7.2",
    "url": "/software/support/release-notes/aermod/7.2",
    "template": "new-releasenotes-categroy",
    "section": "aermod"
  },
  {
    "name": "2.2",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/3d-analyst/2.2",
    "url": "/software/support/release-notes/3d-analyst/2.2",
    "template": "new-releasenotes-categroy",
    "section": "3d-analyst"
  },
  {
    "name": "2.4",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/3d-analyst/2.4",
    "url": "/software/support/release-notes/3d-analyst/2.4",
    "template": "new-releasenotes-categroy",
    "section": "3d-analyst"
  },
  {
    "name": "4.0",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/3d-analyst/4.0",
    "url": "/software/support/release-notes/3d-analyst/4.0",
    "template": "new-releasenotes-categroy",
    "section": "3d-analyst"
  },
  {
    "name": "7.9",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermet/7.9",
    "url": "/software/support/release-notes/aermet/7.9",
    "template": "new-releasenotes-categroy",
    "section": "aermet"
  },
  {
    "name": "1.2",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/incident-analyst/1.2",
    "url": "/software/support/release-notes/incident-analyst/1.2",
    "template": "new-releasenotes-categroy",
    "section": "incident-analyst"
  },
  {
    "name": "2.3",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/calpuff/2.3",
    "url": "/software/support/release-notes/calpuff/2.3",
    "template": "new-releasenotes-categroy",
    "section": "calpuff"
  },
  {
    "name": "5.0.1",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/tankesp/5.0.1",
    "url": "/software/support/release-notes/tankesp/5.0.1",
    "template": "new-releasenotes-categroy",
    "section": "tankesp"
  },
  {
    "name": "8.1",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermod/8.1",
    "url": "/software/support/release-notes/aermod/8.1",
    "template": "new-releasenotes-categroy",
    "section": "aermod"
  },
  {
    "name": "7.6",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermod/7.6",
    "url": "/software/support/release-notes/aermod/7.6",
    "template": "new-releasenotes-categroy",
    "section": "aermod"
  },
  {
    "name": "7.5.2",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermet/7.5.2",
    "url": "/software/support/release-notes/aermet/7.5.2",
    "template": "new-releasenotes-categroy",
    "section": "aermet"
  },
  {
    "name": "5.1.8",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/roads/5.1.8",
    "url": "/software/support/release-notes/roads/5.1.8",
    "template": "new-releasenotes-categroy",
    "section": "roads"
  },
  {
    "name": "9.0",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/exdam/9.0",
    "url": "/software/support/release-notes/exdam/9.0",
    "template": "new-releasenotes-categroy",
    "section": "exdam"
  },
  {
    "name": "7.2.3",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/metview/7.2.3",
    "url": "/software/support/release-notes/metview/7.2.3",
    "template": "new-releasenotes-categroy",
    "section": "metview"
  },
  {
    "name": "7.5.1",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermet/7.5.1",
    "url": "/software/support/release-notes/aermet/7.5.1",
    "template": "new-releasenotes-categroy",
    "section": "aermet"
  },
  {
    "name": "3.0",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/calpuff/3.0",
    "url": "/software/support/release-notes/calpuff/3.0",
    "template": "new-releasenotes-categroy",
    "section": "calpuff"
  },
  {
    "name": "2.0",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aerscreen/2.0",
    "url": "/software/support/release-notes/aerscreen/2.0",
    "template": "new-releasenotes-categroy",
    "section": "aerscreen"
  },
  {
    "name": "2.1",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/calpuff/2.1",
    "url": "/software/support/release-notes/calpuff/2.1",
    "template": "new-releasenotes-categroy",
    "section": "calpuff"
  },
  {
    "name": "3.0",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/3d-analyst/3.0",
    "url": "/software/support/release-notes/3d-analyst/3.0",
    "template": "new-releasenotes-categroy",
    "section": "3d-analyst"
  },
  {
    "name": "7.6",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermet/7.6",
    "url": "/software/support/release-notes/aermet/7.6",
    "template": "new-releasenotes-categroy",
    "section": "aermet"
  },
  {
    "name": "7.7",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermod/7.7",
    "url": "/software/support/release-notes/aermod/7.7",
    "template": "new-releasenotes-categroy",
    "section": "aermod"
  },
  {
    "name": "7.2.4",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/metview/7.2.4",
    "url": "/software/support/release-notes/metview/7.2.4",
    "template": "new-releasenotes-categroy",
    "section": "metview"
  },
  {
    "name": "2.4",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/calpuff/2.4",
    "url": "/software/support/release-notes/calpuff/2.4",
    "template": "new-releasenotes-categroy",
    "section": "calpuff"
  },
  {
    "name": "9.1",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermod/9.1",
    "url": "/software/support/release-notes/aermod/9.1",
    "template": "new-releasenotes-categroy",
    "section": "aermod"
  },
  {
    "name": "5.2",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/tankesp/5.2",
    "url": "/software/support/release-notes/tankesp/5.2",
    "template": "new-releasenotes-categroy",
    "section": "tankesp"
  },
  {
    "name": "7.9.2",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermod/7.9.2",
    "url": "/software/support/release-notes/aermod/7.9.2",
    "template": "new-releasenotes-categroy",
    "section": "aermod"
  },
  {
    "name": "7.3",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermod/7.3",
    "url": "/software/support/release-notes/aermod/7.3",
    "template": "new-releasenotes-categroy",
    "section": "aermod"
  },
  {
    "name": "1.3",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/incident-analyst/1.3",
    "url": "/software/support/release-notes/incident-analyst/1.3",
    "template": "new-releasenotes-categroy",
    "section": "incident-analyst"
  },
  {
    "name": "7.8",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermet/7.8",
    "url": "/software/support/release-notes/aermet/7.8",
    "template": "new-releasenotes-categroy",
    "section": "aermet"
  },
  {
    "name": "8.5",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/exdam/8.5",
    "url": "/software/support/release-notes/exdam/8.5",
    "template": "new-releasenotes-categroy",
    "section": "exdam"
  },
  {
    "name": "8.7",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/exdam/8.7",
    "url": "/software/support/release-notes/exdam/8.7",
    "template": "new-releasenotes-categroy",
    "section": "exdam"
  },
  {
    "name": "7.9",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermod/7.9",
    "url": "/software/support/release-notes/aermod/7.9",
    "template": "new-releasenotes-categroy",
    "section": "aermod"
  },
  {
    "name": "8.6",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/exdam/8.6",
    "url": "/software/support/release-notes/exdam/8.6",
    "template": "new-releasenotes-categroy",
    "section": "exdam"
  },
  {
    "name": "7.10",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermod/7.10",
    "url": "/software/support/release-notes/aermod/7.10",
    "template": "new-releasenotes-categroy",
    "section": "aermod"
  },
  {
    "name": "7.11",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermod/7.11",
    "url": "/software/support/release-notes/aermod/7.11",
    "template": "new-releasenotes-categroy",
    "section": "aermod"
  },
  {
    "name": "5.1.10",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/roads/5.1.10",
    "url": "/software/support/release-notes/roads/5.1.10",
    "template": "new-releasenotes-categroy",
    "section": "roads"
  },
  {
    "name": "7.10.1",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl3/software/support/release-notes/aermod/7.10.1",
    "url": "/software/support/release-notes/aermod/7.10.1",
    "template": "new-releasenotes-categroy",
    "section": "aermod"
  },
  {
    "name": "Burlington, Iowa",
    "apiurl": "/restapi/customcontent/contact-us/burlington-iowa",
    "url": "/contact-us/burlington-iowa",
    "template": "general_content",
    "section": "burlington,-iowa"
  },
  {
    "name": "Denver, Colorado",
    "apiurl": "/restapi/customcontent/contact-us/denver-colorado",
    "url": "/contact-us/denver-colorado",
    "template": "general_content",
    "section": "denver,-colorado"
  },
  {
    "name": "Boston, Massachusetts",
    "apiurl": "/restapi/customcontent/contact-us/boston-massachusetts",
    "url": "/contact-us/boston-massachusetts",
    "template": "general_content",
    "section": "boston,-massachusetts"
  },
  {
    "name": "Oakland, California",
    "apiurl": "/restapi/customcontent/contact-us/oakland-california",
    "url": "/contact-us/oakland-california",
    "template": "general_content",
    "section": "oakland,-california"
  },
  {
    "name": "Exton, Pennsylvania",
    "apiurl": "/restapi/customcontent/contact-us/exton-pennsylvania",
    "url": "/contact-us/exton-pennsylvania",
    "template": "general_content",
    "section": "exton,-pennsylvania"
  },
  {
    "name": "Princeton, New Jersey",
    "apiurl": "/restapi/customcontent/contact-us/princeton-new-jersey",
    "url": "/contact-us/princeton-new-jersey",
    "template": "general_content",
    "section": "princeton,-new-jersey"
  },
  {
    "name": "Birmingham, Alabama",
    "apiurl": "/restapi/customcontent/contact-us/birmingham-alabama",
    "url": "/contact-us/birmingham-alabama",
    "template": "general_content",
    "section": "birmingham,-alabama"
  },
  {
    "name": "Dublin, Ohio",
    "apiurl": "/restapi/customcontent/contact-us/dublin-ohio",
    "url": "/contact-us/dublin-ohio",
    "template": "general_content",
    "section": "dublin,-ohio"
  },
  {
    "name": "Raleigh, North Carolina",
    "apiurl": "/restapi/customcontent/contact-us/raleigh-north-carolina",
    "url": "/contact-us/raleigh-north-carolina",
    "template": "general_content",
    "section": "raleigh,-north-carolina"
  },
  {
    "name": "Covington, Kentucky",
    "apiurl": "/restapi/customcontent/contact-us/covington-kentucky",
    "url": "/contact-us/covington-kentucky",
    "template": "general_content",
    "section": "covington,-kentucky"
  },
  {
    "name": "West Des Moines, Iowa",
    "apiurl": "/restapi/customcontent/contact-us/west-des-moines-iowa",
    "url": "/contact-us/west-des-moines-iowa",
    "template": "general_content",
    "section": "west-des-moines,-iowa"
  },
  {
    "name": "Charlotte, NC",
    "apiurl": "/restapi/customcontent/contact-us/charlotte-nc",
    "url": "/contact-us/charlotte-nc",
    "template": "general_content",
    "section": "charlotte,-nc"
  },
  {
    "name": "Upstate, New York",
    "apiurl": "/restapi/customcontent/contact-us/upstate-new-york",
    "url": "/contact-us/upstate-new-york",
    "template": "general_content",
    "section": "upstate,-new-york"
  },
  {
    "name": "Ontario",
    "apiurl": "/restapi/customcontent/contact-us/ontario",
    "url": "/contact-us/ontario",
    "template": "general_content",
    "section": "ontario"
  },
  {
    "name": "Dallas",
    "apiurl": "/restapi/customcontent/contact-us/dallas",
    "url": "/contact-us/dallas",
    "template": "general_content",
    "section": "dallas"
  },
  {
    "name": "South Carolina",
    "apiurl": "/restapi/customcontent/contact-us/south-carolina",
    "url": "/contact-us/south-carolina",
    "template": "general_content",
    "section": "south-carolina"
  },
  {
    "name": "Ohio",
    "apiurl": "/restapi/customcontent/contact-us/ohio",
    "url": "/contact-us/ohio",
    "template": "general_content",
    "section": "ohio"
  },
  {
    "name": "New York",
    "apiurl": "/restapi/customcontent/contact-us/new-york",
    "url": "/contact-us/new-york",
    "template": "general_content",
    "section": "new-york"
  },
  {
    "name": "Dallas, TX",
    "apiurl": "/restapi/customcontent/contact-us/dallas-tx",
    "url": "/contact-us/dallas-tx",
    "template": "general_content",
    "section": "dallas,-tx"
  },
  {
    "name": "Chicago, Illinois",
    "apiurl": "/restapi/customcontent/contact-us/chicago-illinois",
    "url": "/contact-us/chicago-illinois",
    "template": "general_content",
    "section": "chicago,-illinois"
  },
  {
    "name": "Multiple Locations",
    "apiurl": "/restapi/customcontent/contact-us/multiple-locations",
    "url": "/contact-us/multiple-locations",
    "template": "general_content",
    "section": "multiple-locations"
  },
  {
    "name": "Sacramento, California",
    "apiurl": "/restapi/customcontent/contact-us/sacramento-california",
    "url": "/contact-us/sacramento-california",
    "template": "general_content",
    "section": "sacramento,-california"
  },
  {
    "name": "Atlanta, Georgia",
    "apiurl": "/restapi/customcontent/contact-us/atlanta-georgia",
    "url": "/contact-us/atlanta-georgia",
    "template": "general_content",
    "section": "atlanta,-georgia"
  },
  {
    "name": "Bakersfield, California",
    "apiurl": "/restapi/customcontent/contact-us/bakersfield-california",
    "url": "/contact-us/bakersfield-california",
    "template": "general_content",
    "section": "bakersfield,-california"
  },
  {
    "name": "United States",
    "apiurl": "/restapi/customcontent/contact-us/united-states",
    "url": "/contact-us/united-states",
    "template": "general_content",
    "section": "united-states"
  },
  {
    "name": "Canada",
    "apiurl": "/restapi/customcontent/contact-us/canada",
    "url": "/contact-us/canada",
    "template": "general_content",
    "section": "canada"
  },
  {
    "name": "Albany, New York",
    "apiurl": "/restapi/customcontent/contact-us/albany-new-york",
    "url": "/contact-us/albany-new-york",
    "template": "general_content",
    "section": "albany,-new-york"
  },
  {
    "name": "Albuquerque, New Mexico",
    "apiurl": "/restapi/customcontent/contact-us/albuquerque-new-mexico",
    "url": "/contact-us/albuquerque-new-mexico",
    "template": "general_content",
    "section": "albuquerque,-new-mexico"
  },
  {
    "name": "Multiple Locations - North Carolina",
    "apiurl": "/restapi/customcontent/contact-us/multiple-locations---north-carolina",
    "url": "/contact-us/multiple-locations---north-carolina",
    "template": "general_content",
    "section": "multiple-locations--north-carolina"
  },
  {
    "name": "Maryland",
    "apiurl": "/restapi/customcontent/contact-us/maryland",
    "url": "/contact-us/maryland",
    "template": "general_content",
    "section": "maryland"
  },
  {
    "name": "New Jersey",
    "apiurl": "/restapi/customcontent/contact-us/new-jersey",
    "url": "/contact-us/new-jersey",
    "template": "general_content",
    "section": "new-jersey"
  },
  {
    "name": "Irvine, California",
    "apiurl": "/restapi/customcontent/contact-us/irvine-california",
    "url": "/contact-us/irvine-california",
    "template": "general_content",
    "section": "irvine,-california"
  },
  {
    "name": "Missouri",
    "apiurl": "/restapi/customcontent/contact-us/missouri",
    "url": "/contact-us/missouri",
    "template": "general_content",
    "section": "missouri"
  },
  {
    "name": "Orlando, Florida",
    "apiurl": "/restapi/customcontent/contact-us/orlando-florida",
    "url": "/contact-us/orlando-florida",
    "template": "general_content",
    "section": "orlando,-florida"
  },
  {
    "name": "Georgetown, Ontario",
    "apiurl": "/restapi/customcontent/contact-us/georgetown-ontario",
    "url": "/contact-us/georgetown-ontario",
    "template": "general_content",
    "section": "georgetown,-ontario"
  },
  {
    "name": "Frederick, Maryland",
    "apiurl": "/restapi/customcontent/contact-us/frederick-maryland",
    "url": "/contact-us/frederick-maryland",
    "template": "general_content",
    "section": "frederick,-maryland"
  },
  {
    "name": "Air Quality Contact Meeting-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Contact-Meeting-Iowa",
    "url": "/news/Air-Quality-Contact-Meeting-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity is Pleased to Announce the Addition of Justin Fickas to the Staff of the Atlanta Office",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-is",
    "url": "/news/Trinity-is",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Preparing for EPA’s Mandatory Reporting of Greenhouse Gases Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Preparing-for-EPA-s-Mandatory-Reporting-of-Greenhouse-Gases-Rule",
    "url": "/news/Preparing-for-EPA-s-Mandatory-Reporting-of-Greenhouse-Gases-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reminder - AWMA Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reminder---AWMA-Meeting",
    "url": "/news/Reminder---AWMA-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Issues Final Decision to Deny OTR Expansion Petition-Connecticut",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Issues-Final-Decision-to-Deny-OTR-Expansion-Petition-Connecticut",
    "url": "/news/EPA-Issues-Final-Decision-to-Deny-OTR-Expansion-Petition-Connecticut",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Midwest Environmental Compliance Conference April 11-12, 2018-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/Midwest-Environmental-Compliance-Conference-April-11-12-2018-Nebraska",
    "url": "/news/Midwest-Environmental-Compliance-Conference-April-11-12-2018-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New State of Minnesota Silica Sand Information Website",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-State-of-Minnesota-Silica-Sand-Information-Website",
    "url": "/news/New-State-of-Minnesota-Silica-Sand-Information-Website",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Tony Schroeder Earns AMS Certified Consulting Meteorological Designation",
    "apiurl": "/restapi/customnewscontentlvl2/news/Tony-Schro",
    "url": "/news/Tony-Schro",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SUIT/CO Environmental Commission Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/SUIT-CO-Environmental-Commission-Update",
    "url": "/news/SUIT-CO-Environmental-Commission-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Northern Wasatch Front Ozone Nonattainment Area Potential Reclassification",
    "apiurl": "/restapi/customnewscontentlvl2/news/northern-wasatch-front-ozone-nonattainment-area-potential-reclassification",
    "url": "/news/northern-wasatch-front-ozone-nonattainment-area-potential-reclassification",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Northern Wasatch Front Ozone Nonattainment Area Potential Reclassification",
    "apiurl": "/restapi/customnewscontentlvl2/news/northern-wasatch-front-ozone-nonattainment-area-potential-reclassification",
    "url": "/news/states/utah/northern-wasatch-front-ozone-nonattainment-area-potential-reclassification",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "State Oil Production at Highest Level in 25 Years-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/State-Oil-Production-at-Highest-Level-in-25-Years-Wyoming",
    "url": "/news/State-Oil-Production-at-Highest-Level-in-25-Years-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EIB Schedules Public Hearing for SIP Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/EIB-Schedules-Public-Hearing-for-SIP-Updates",
    "url": "/news/EIB-Schedules-Public-Hearing-for-SIP-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Will You Be Targeted for the Regional Haze Second Planning Period?",
    "apiurl": "/restapi/customnewscontentlvl2/news/will-you-be-targeted-for-the-regional-haze-second-planning-period",
    "url": "/news/will-you-be-targeted-for-the-regional-haze-second-planning-period",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Will You Be Targeted for the Regional Haze Second Planning Period?",
    "apiurl": "/restapi/customnewscontentlvl2/news/will-you-be-targeted-for-the-regional-haze-second-planning-period",
    "url": "/News/Federal/Will-You-Be-Targeted-for-the-Regional-Haze-Second-Planning-Period-/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Will You Be Targeted for the Regional Haze Second Planning Period?",
    "apiurl": "/restapi/customnewscontentlvl2/news/will-you-be-targeted-for-the-regional-haze-second-planning-period",
    "url": "/news/Will-You-Be-Targeted-for-the-Regional-Haze-Second-Planning-Period-/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Water Quality Standard for Manganese and Implementation",
    "apiurl": "/restapi/customnewscontentlvl2/news/water-quality-standard-for-manganese-and-implementation",
    "url": "/news/water-quality-standard-for-manganese-and-implementation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Water Quality Standard for Manganese and Implementation",
    "apiurl": "/restapi/customnewscontentlvl2/news/water-quality-standard-for-manganese-and-implementation",
    "url": "/news/state/pennsylvania/water-quality-standard-for-manganese-and-implementation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Quality Contact Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Contact-Meeting",
    "url": "/news/Air-Quality-Contact-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEC Requests to Divide the Fairbanks PM2.5 Nonattainment Area",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEC-Requests-to-Divide-the-Fairbanks-PM2-5-Nonattainment-Area",
    "url": "/news/ADEC-Requests-to-Divide-the-Fairbanks-PM2-5-Nonattainment-Area",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "UDAQ Proposed Emission Rule Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/udaq-proposed-emission-rule-amendments",
    "url": "/news/udaq-proposed-emission-rule-amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LDEQ Proposes Water Quality Updates-Louisiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/LDEQ-Proposes-Water-Quality-Updates-Louisiana",
    "url": "/news/LDEQ-Proposes-Water-Quality-Updates-Louisiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "WDNR Issues Draft Guidance on Applying for One-Year Wisconsin Extension to MACT Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/WDNR-Issues-Draft-Guidance-on-Applying-for-One-Year-Wisconsin-Extension-to-MACT-Requirements",
    "url": "/news/WDNR-Issues-Draft-Guidance-on-Applying-for-One-Year-Wisconsin-Extension-to-MACT-Requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CAIR Quietly Reinstated",
    "apiurl": "/restapi/customnewscontentlvl2/news/CAIR-Quietly-Reinstated-",
    "url": "/news/CAIR-Quietly-Reinstated-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Wyoming Nonpoint Source Program Report Released-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Wyoming-Nonpoint-Source-Program-Report-Released-Wyoming",
    "url": "/news/Wyoming-Nonpoint-Source-Program-Report-Released-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Disallows PM10 as Surrogate for PM2.5",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Disallows-PM10-as-Surrogate-for-PM2-5",
    "url": "/news/EPA-Disallows-PM10-as-Surrogate-for-PM2-5",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DNR Seeks Public Input on Plan to Reduce Lead in Council Bluffs",
    "apiurl": "/restapi/customnewscontentlvl2/news/DNR-Seeks-Public-Input-on-Plan-to-Reduce-Lead-in-Council-Bluffs",
    "url": "/news/DNR-Seeks-Public-Input-on-Plan-to-Reduce-Lead-in-Council-Bluffs",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The Engine Rules: More Key Elements",
    "apiurl": "/restapi/customnewscontentlvl2/news/The-Engine-Rules-More-Key-Elements",
    "url": "/news/The-Engine-Rules-More-Key-Elements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Compliance Instrument Tracking System Service (CITSS) Now Open for Registration",
    "apiurl": "/restapi/customnewscontentlvl2/news/Compliance-Instrument-Tracking-System-Service-(CITSS)-Now-Open-for-Registration",
    "url": "/news/Compliance-Instrument-Tracking-System-Service-(CITSS)-Now-Open-for-Registration",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "WA State Supreme Court Rules Ecology May Not Apply Air Emission Standards to ‘Indirect Emitters’-Washington",
    "apiurl": "/restapi/customnewscontentlvl2/news/WA-State-Supreme-Court-Rules-Ecology-May-Not-Apply-Air-Emission-Standards-to-Indirect-Emitters--Washington",
    "url": "/news/WA-State-Supreme-Court-Rules-Ecology-May-Not-Apply-Air-Emission-Standards-to-Indirect-Emitters--Washington",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Quality Control Board Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Control-Board-Meeting",
    "url": "/news/Air-Quality-Control-Board-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NYSDEC Part 222 Update-New York",
    "apiurl": "/restapi/customnewscontentlvl2/news/NYSDEC-Part-222-Update-New-York",
    "url": "/news/NYSDEC-Part-222-Update-New-York",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Extension to Indian Country Minor NSR Permitting Deadline",
    "apiurl": "/restapi/customnewscontentlvl2/news/Extension-to-Indian-Country-Minor-NSR-Permitting-Deadline",
    "url": "/news/Extension-to-Indian-Country-Minor-NSR-Permitting-Deadline",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Cement NESHAP Finalized",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Cement-NESHAP-Finalized",
    "url": "/news/New-Cement-NESHAP-Finalized",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Permitting Tip: APEN / Permit Exempt Checklist",
    "apiurl": "/restapi/customnewscontentlvl2/news/Permitting-Tip-APEN-Permit-Exempt-Checklist",
    "url": "/news/Permitting-Tip-APEN-Permit-Exempt-Checklist",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Approves 65 Exceedances of the 24-Hour PM10 Standard in Maricopa County",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Approves-65-Exceedances-of-the-24-Hour-PM10-Standard-in-Maricopa-County",
    "url": "/news/EPA-Approves-65-Exceedances-of-the-24-Hour-PM10-Standard-in-Maricopa-County",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Addressing PM2.5 Permit Modeling",
    "apiurl": "/restapi/customnewscontentlvl2/news/Addressing-PM2-5-Permit-Modeling",
    "url": "/news/Addressing-PM2-5-Permit-Modeling",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Seamlessly Generate Graphical Displays of Your Met Data with BREEZE MetView 7.2.4",
    "apiurl": "/restapi/customnewscontentlvl2/news/Seamlessly-Generate-Graphical-Displays-of-Your-Met-Data-with-BREEZE-MetView-7-2-4",
    "url": "/news/Seamlessly-Generate-Graphical-Displays-of-Your-Met-Data-with-BREEZE-MetView-7-2-4",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Revises TSCA Inventory Update Reporting Requirements (Chemical Data Reporting)",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Revises-TSCA-Inventory-Update-Reporting-Requirements-(Chemical-Data-Reporting)",
    "url": "/news/EPA-Revises-TSCA-Inventory-Update-Reporting-Requirements-(Chemical-Data-Reporting)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Fairbanks PM2.5 Nonattainment Area Expected to Reach \"Serious\" Designation",
    "apiurl": "/restapi/customnewscontentlvl2/news/Fairbanks-PM2-5-Nonattainment-Area-Expected-to-Reach-Serious-Designation",
    "url": "/news/Fairbanks-PM2-5-Nonattainment-Area-Expected-to-Reach-Serious-Designation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PM2.5 SIPs are Proposed for Subpart 4",
    "apiurl": "/restapi/customnewscontentlvl2/news/PM2-5-SIPs-are-Proposed-for-Subpart-4",
    "url": "/news/PM2-5-SIPs-are-Proposed-for-Subpart-4",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDNR Provides Streamlined Public Notice-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDNR-Provides-Streamlined-Public-Notice-Iowa",
    "url": "/news/IDNR-Provides-Streamlined-Public-Notice-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "What you need to know about the ISO 14001 Certification and \"Life Cycle Perspective\"",
    "apiurl": "/restapi/customnewscontentlvl2/news/What-you-need-to-know-about-the-ISO-14001-Certification-and-Life-Cycle-Perspective-",
    "url": "/news/What-you-need-to-know-about-the-ISO-14001-Certification-and-Life-Cycle-Perspective-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Effective Preparation for EHS Compliance Audits: Stormwater and Industrial Wastewater Discharges",
    "apiurl": "/restapi/customnewscontentlvl2/news/Effective-Preparation-for-EHS-Compliance-Audits-Stormwater-and-Industrial-Wastewater-Discharges",
    "url": "/news/Effective-Preparation-for-EHS-Compliance-Audits-Stormwater-and-Industrial-Wastewater-Discharges",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Effective Preparation for EHS Compliance Audits: Stormwater and Industrial Wastewater Discharges",
    "apiurl": "/restapi/customnewscontentlvl2/news/Effective-Preparation-for-EHS-Compliance-Audits-Stormwater-and-Industrial-Wastewater-Discharges",
    "url": "/news/ehs-management/Effective-Preparation-for-EHS-Compliance-Audits-Stormwater-and-Industrial-Wastewater-Discharges",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDNR News",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDNR-News",
    "url": "/news/IDNR-News",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Assists City of Flagstaff, AZ with Greenhouse Gas Emissions Management",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Assists-City-of-Flagstaff-AZ-with-Greenhouse-Gas-Emissions-Management",
    "url": "/news/Trinity-Assists-City-of-Flagstaff-AZ-with-Greenhouse-Gas-Emissions-Management",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Region 4 Administrator",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Region-4-Administrator",
    "url": "/news/EPA-Region-4-Administrator",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to Public Notice Procedure in New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-to-Public-Notice-Procedure-in-New-Mexico",
    "url": "/news/Updates-to-Public-Notice-Procedure-in-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Hearing on Proposed Revisions to the 20.11.41 NMAC - new Permit to Construct Reulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Hearing-on-Proposed-Revisions-to-the-20-11-41-NMAC---new-Permit-to-Construct-Reulations",
    "url": "/news/Hearing-on-Proposed-Revisions-to-the-20-11-41-NMAC---new-Permit-to-Construct-Reulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Updates to Compressor Station General Permits",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Updates-to-Compressor-Station-General-Permits",
    "url": "/news/Proposed-Updates-to-Compressor-Station-General-Permits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Ontario Excess Soil Management Regulations, and Amendments to Brownfields Regulation 153/04",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-ontario-excess-soil-management-regulations-and-amendments-to-brownfields-regulation-153-04",
    "url": "/news/new-ontario-excess-soil-management-regulations-and-amendments-to-brownfields-regulation-153-04",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Ontario Excess Soil Management Regulations, and Amendments to Brownfields Regulation 153/04",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-ontario-excess-soil-management-regulations-and-amendments-to-brownfields-regulation-153-04",
    "url": "/states/ontario/new-ontario-excess-soil-management-regulations-and-amendments-to-brownfields-regulation-153-04",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Illinois Infrastructure SIP requirements for the 2008 Lead NAAQS and Approval/Promulgation of Air Quality Implementation Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Illinois-Infrastructure-SIP-requirements-for-the-2008-Lead-NAAQS-and-Approval-Promulgation-of-Air-Quality-Implementation-Plan",
    "url": "/news/Illinois-Infrastructure-SIP-requirements-for-the-2008-Lead-NAAQS-and-Approval-Promulgation-of-Air-Quality-Implementation-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Rulemaking Prohibiting Hydrofluorocarbons (HFC) for use in Specific End Uses",
    "apiurl": "/restapi/customnewscontentlvl2/news/proposed-rulemaking-prohibiting-hydrofluorocarbons-hfc-for-use-in-specific-end-uses",
    "url": "/news/proposed-rulemaking-prohibiting-hydrofluorocarbons-hfc-for-use-in-specific-end-uses",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Supplemental Proposal for Amendments to NSPS Subpart Y for Coal Preparation Plants",
    "apiurl": "/restapi/customnewscontentlvl2/news/Supplement",
    "url": "/news/Supplement",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA Recommendations for PM2.5 Area Designations in Indiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-Recommendations-for-PM2-5-Area-Designations-in-Indiana",
    "url": "/news/USEPA-Recommendations-for-PM2-5-Area-Designations-in-Indiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Small Project PSD Cautions (Post-GHG Tailoring Rule)",
    "apiurl": "/restapi/customnewscontentlvl2/news/Small-Project-PSD-Cautions-(Post-GHG-Tailoring-Rule)",
    "url": "/news/Small-Project-PSD-Cautions-(Post-GHG-Tailoring-Rule)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Hiring Industrial Hygienist – Apply Today!",
    "apiurl": "/restapi/customnewscontentlvl2/news/Hiring-Industrial-Hygienist-Apply-Today!",
    "url": "/news/Hiring-Industrial-Hygienist-Apply-Today!",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments Released for Linkage of Cap-and-Trade Program with Quebec",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendments-Released-for-Linkage-of-Cap-and-Trade-Program-with-Quebec",
    "url": "/news/Proposed-Amendments-Released-for-Linkage-of-Cap-and-Trade-Program-with-Quebec",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Clark County DAQ Releases New Visible Emissions Check Guide",
    "apiurl": "/restapi/customnewscontentlvl2/news/clark-county-daq-releases-new-visible-emissions-check-guide",
    "url": "/news/clark-county-daq-releases-new-visible-emissions-check-guide",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Preliminary Designations for 1-Hour SO2 NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/Preliminary-Designations-for-1-Hour-SO2-NAAQS",
    "url": "/news/Preliminary-Designations-for-1-Hour-SO2-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MRR Update: New Reporting Deadlines for 2012",
    "apiurl": "/restapi/customnewscontentlvl2/news/MRR-Update-New-Reporting-Deadlines-for-2012",
    "url": "/news/MRR-Update-New-Reporting-Deadlines-for-2012",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Opens Bakersfield, California Office with the Acquisition of Insight Environmental Consultants",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Opens-Bakersfield-California-Office-with-the-Acquisition-of-Insight-Environmental-Consultants",
    "url": "/news/Trinity-Consultants-Opens-Bakersfield-California-Office-with-the-Acquisition-of-Insight-Environmental-Consultants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD Proposed Rule 415 – Odors from Rendering Facilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/SCAQMD-Proposed-Rule-415-Odors-from-Rendering-Facilities",
    "url": "/news/SCAQMD-Proposed-Rule-415-Odors-from-Rendering-Facilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Finalizes Updates for Electric Generating Units (EGU)",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Finalizes-Updates-for-Electric-Generating-Units-(EGU)",
    "url": "/news/EPA-Finalizes-Updates-for-Electric-Generating-Units-(EGU)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Toxic Release Inventory (TRI) Reporting Deadline Reminder",
    "apiurl": "/restapi/customnewscontentlvl2/news/Toxic-Release-Inventory-(TRI)-Reporting-Deadline-Reminder",
    "url": "/news/Toxic-Release-Inventory-(TRI)-Reporting-Deadline-Reminder",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Regulation 7 Changes to Address Ozone Nonattainment Redesignation-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Regulation-7-Changes-to-Address-Ozone-Nonattainment-Redesignation-Colorado",
    "url": "/news/Proposed-Regulation-7-Changes-to-Address-Ozone-Nonattainment-Redesignation-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reminder:  Annual Reporting Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reminder-Annual-Reporting-Requirements",
    "url": "/news/Reminder-Annual-Reporting-Requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MassDEP Issues Final Regional Haze State Implementation Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/MassDEP-Issues-Final-Regional-Haze-State-Implementation-Plan",
    "url": "/news/MassDEP-Issues-Final-Regional-Haze-State-Implementation-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "U.S. Customs’ New Audit Policy -  Checkmate in Two Moves?",
    "apiurl": "/restapi/customnewscontentlvl2/news/U-S-Customs-New-Audit-Policy---Checkmate-in-Two-Moves-",
    "url": "/news/U-S-Customs-New-Audit-Policy---Checkmate-in-Two-Moves-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "U.S. Customs’ New Audit Policy -  Checkmate in Two Moves?",
    "apiurl": "/restapi/customnewscontentlvl2/news/U-S-Customs-New-Audit-Policy---Checkmate-in-Two-Moves-",
    "url": "/nnews/federal/U-S-Customs-New-Audit-Policy---Checkmate-in-Two-Moves-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Rule: Air Plan Approval; Regional Haze Progress Report",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Rule-Air-Plan-Approval-Regional-Haze-Progress-Report",
    "url": "/news/Proposed-Rule-Air-Plan-Approval-Regional-Haze-Progress-Report",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Kentucky Cabinet Submits Comments on Proposed Standards for New Power Plants",
    "apiurl": "/restapi/customnewscontentlvl2/news/Kentucky-Cabinet-Submits-Comments-on-Proposed-Standards-for-New-Power-Plants",
    "url": "/news/Kentucky-Cabinet-Submits-Comments-on-Proposed-Standards-for-New-Power-Plants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Missouri Air Permitting Rule Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Missouri-Air-Permitting-Rule-Updates",
    "url": "/news/Missouri-Air-Permitting-Rule-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Rulemaking for Registration of Small Sources in Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Rulemaking-for-Registration-of-Small-Sources-in-Illinois",
    "url": "/news/Proposed-Rulemaking-for-Registration-of-Small-Sources-in-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Kentucky Proposes Jefferson County as Nonattainment for the 1-hour SO2 NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/Kentucky-P",
    "url": "/news/Kentucky-P",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPD Proposes to Revise the SIP Rules for Permit Requirements-Georgia",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPD-Proposes-to-Revise-the-SIP-Rules-for-Permit-Requirements-Georgia",
    "url": "/news/EPD-Proposes-to-Revise-the-SIP-Rules-for-Permit-Requirements-Georgia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DDOE Proposes Changes to NSR Permitting Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/DDOE-Proposes-Changes-to-NSR-Permitting-Program",
    "url": "/news/DDOE-Proposes-Changes-to-NSR-Permitting-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2020 Reporting Reminders-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/2020-Reporting-Reminders-Kansas",
    "url": "/news/2020-Reporting-Reminders-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SMAQMD Proposed Revisions to Particulate Matter CEQA Thresholds of Significance",
    "apiurl": "/restapi/customnewscontentlvl2/news/SMAQMD-Proposed-Revisions-to-Particulate-Matter-CEQA-Thresholds-of-Significance",
    "url": "/news/SMAQMD-Proposed-Revisions-to-Particulate-Matter-CEQA-Thresholds-of-Significance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA Finalizes Changes to Air Quality Modeling Guidance-Montana",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-Finalizes-Changes-to-Air-Quality-Modeling-Guidance-Montana",
    "url": "/news/USEPA-Finalizes-Changes-to-Air-Quality-Modeling-Guidance-Montana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Rulemaking for Two Lead Nonattainment Areas in Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-Rulemaking-for-Two-Lead-Nonattainment-Areas-in-Illinois",
    "url": "/news/Final-Rulemaking-for-Two-Lead-Nonattainment-Areas-in-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oregon DEQ Adopted Title V Fee Increase -Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oregon-DEQ-Adopted-Title-V-Fee-Increase--Oregon",
    "url": "/news/Oregon-DEQ-Adopted-Title-V-Fee-Increase--Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "North Dakota High Efficiency Program for Control Devices",
    "apiurl": "/restapi/customnewscontentlvl2/news/north-dakota-high-efficiency-program-for-control-devices",
    "url": "/news/north-dakota-high-efficiency-program-for-control-devices",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Quick Look at the New Ozone Standard in Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Quick-Look-at-the-New-Ozone-Standard-in-Wyoming",
    "url": "/news/Quick-Look-at-the-New-Ozone-Standard-in-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ecology Provides Updates on Proposed Clean Air Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ecology-Provides-Updates-on-Proposed-Clean-Air-Rule",
    "url": "/news/Ecology-Provides-Updates-on-Proposed-Clean-Air-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LDEQ Withdraws Proposed Revisions to the Risk Evaluation/Corrective Action Program (RECAP)-Louisiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/LDEQ-Withdraws-Proposed-Revisions-to-the-Risk-Evaluation-Corrective-Action-Program-(RECAP)-Louisiana",
    "url": "/news/LDEQ-Withdraws-Proposed-Revisions-to-the-Risk-Evaluation-Corrective-Action-Program-(RECAP)-Louisiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Mark your Calendars for Annual Reporting!",
    "apiurl": "/restapi/customnewscontentlvl2/news/Mark-your-Calendars-for-Annual-Reporting!",
    "url": "/news/Mark-your-Calendars-for-Annual-Reporting!",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New and Updated Air Quality Construction Permit Forms",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-and-Updated-Air-Quality-Construction-Permit-Forms",
    "url": "/news/New-and-Updated-Air-Quality-Construction-Permit-Forms",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed RICE Rule Has Potentially Wide-Randing Impact",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-RICE-Rule-Has-Potentially-Wide-Randing-Impact",
    "url": "/news/Proposed-RICE-Rule-Has-Potentially-Wide-Randing-Impact",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEM Revises the General Administration Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEM-Revises-the-General-Administration-Regulations",
    "url": "/news/ADEM-Revises-the-General-Administration-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEP Launches Document Viewer for Air Quality Records-Nevada",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEP-Launches-Document-Viewer-for-Air-Quality-Records-Nevada",
    "url": "/news/NDEP-Launches-Document-Viewer-for-Air-Quality-Records-Nevada",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Pennsylvania Department of Environmental Protection Issues Revisions to General Permit No. 5",
    "apiurl": "/restapi/customnewscontentlvl2/news/Pennsylvania-Department-of-Environmental-Protection-Issues-Revisions-to-General-Permit-No-5",
    "url": "/news/Pennsylvania-Department-of-Environmental-Protection-Issues-Revisions-to-General-Permit-No-5",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "RICE MACT Applicability Broadens",
    "apiurl": "/restapi/customnewscontentlvl2/news/RICE-MACT-Applicability-Broadens",
    "url": "/news/RICE-MACT-Applicability-Broadens",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Courts Remand Fine Particulate National Ambient Air Quality Standards",
    "apiurl": "/restapi/customnewscontentlvl2/news/Courts-Rem",
    "url": "/news/Courts-Rem",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposed Rule - SSM: Proposed Response to Petition for Rulemaking, Findings of Inadequacy, and Call for Plan Revisions",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposed-Rule---SSM-Proposed-Response-to-Petition-for-Rulemaking-Findings-of-Inadequacy-and-Call-for-Plan-Revisions",
    "url": "/news/EPA-Proposed-Rule---SSM-Proposed-Response-to-Petition-for-Rulemaking-Findings-of-Inadequacy-and-Call-for-Plan-Revisions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Disapproves the TCEQ Flexible Permit Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Disapproves-the-TCEQ-Flexible-Permit-Program",
    "url": "/news/EPA-Disapproves-the-TCEQ-Flexible-Permit-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Jersey Passes Major Environmental Justice Legislation",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-jersey-passes-major-environmental-justice-legislation",
    "url": "/news/new-jersey-passes-major-environmental-justice-legislation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Jersey Passes Major Environmental Justice Legislation",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-jersey-passes-major-environmental-justice-legislation",
    "url": "/news/state/new-jersey/new-jersey-passes-major-environmental-justice-legislation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2020 Client Satisfaction Survey Summary",
    "apiurl": "/restapi/customnewscontentlvl2/news/2020-client-satisfaction-survey-summary",
    "url": "/news/2020-client-satisfaction-survey-summary",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA’s TANKS Program No Longer Accepted by Clark County DAQ",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-s-tanks-program-no-longer-accepted-by-clark-county-daq",
    "url": "/news/epa-s-tanks-program-no-longer-accepted-by-clark-county-daq",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Donation Benefits Victims of Racial Injustice and COVID-19",
    "apiurl": "/restapi/customnewscontentlvl2/news/donation-benefits-victims-of-racial-injustice-and-covid-19",
    "url": "/news/donation-benefits-victims-of-racial-injustice-and-covid-19",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Court Decision Impacts Large Sources Near State Boundaries",
    "apiurl": "/restapi/customnewscontentlvl2/news/Court-Decision-Impacts-Large-Sources-Near-State-Boundaries",
    "url": "/news/Court-Decision-Impacts-Large-Sources-Near-State-Boundaries",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reminder for Bulk Material Sites and Sources of Particulate Matter Regulation 6, Rule 1 Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/reminder-for-bulk-material-sites-and-sources-of-particulate-matter-regulation-6-rule-1-amendments",
    "url": "/news/reminder-for-bulk-material-sites-and-sources-of-particulate-matter-regulation-6-rule-1-amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reminder for Bulk Material Sites and Sources of Particulate Matter Regulation 6, Rule 1 Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/reminder-for-bulk-material-sites-and-sources-of-particulate-matter-regulation-6-rule-1-amendments",
    "url": "/states/reminder-for-bulk-material-sites-and-sources-of-particulate-matter-regulation-6-rule-1-amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Handling Odor Complaints in Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/handling-odor-complaints-in-texas",
    "url": "/news/handling-odor-complaints-in-texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Issues Final Rules for Boiler NESHAPs, CISWI, and Definition of Solid Waste",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Issues-Final-Rules-for-Boiler-NESHAPs-CISWI-and-Definition-of-Solid-Waste",
    "url": "/news/EPA-Issues-Final-Rules-for-Boiler-NESHAPs-CISWI-and-Definition-of-Solid-Waste",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA is Proposing to Approve ADEM's Request for Revisions to the SIPs",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-is-Proposing-to-Approve-ADEM's-Request-for-Revisions-to-the-SIPs",
    "url": "/news/EPA-is-Proposing-to-Approve-ADEM's-Request-for-Revisions-to-the-SIPs",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2015 LDAR Annual Reporting Deadline Fast Approaching for Colorado Sites",
    "apiurl": "/restapi/customnewscontentlvl2/news/2015-LDAR-Annual-Reporting-Deadline-Fast-Approaching-for-Colorado-Sites",
    "url": "/news/2015-LDAR-Annual-Reporting-Deadline-Fast-Approaching-for-Colorado-Sites",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Lower NAAQS Standard for Ozone Impacts New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Lower-NAAQS-Standard-for-Ozone-Impacts-New-Mexico",
    "url": "/news/EPA-Lower-NAAQS-Standard-for-Ozone-Impacts-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Performance & Trends: Air Activity Dashboard",
    "apiurl": "/restapi/customnewscontentlvl2/news/Performance-Trends-Air-Activity-Dashboard",
    "url": "/news/Performance-Trends-Air-Activity-Dashboard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Have you recently been issued an air permit? Are you unclear on what your permit conditions mean? WE CAN HELP!",
    "apiurl": "/restapi/customnewscontentlvl2/news/Have-you-recently-been-issued-an-air-permit-Are-you-unclear-on-what-your-permit-conditions-mean-WE-CAN-HELP!",
    "url": "/news/Have-you-recently-been-issued-an-air-permit-Are-you-unclear-on-what-your-permit-conditions-mean-WE-CAN-HELP!",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Combustion Source Exemption Removed",
    "apiurl": "/restapi/customnewscontentlvl2/news/Combustion-Source-Exemption-Removed-",
    "url": "/news/Combustion-Source-Exemption-Removed-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Virginia DEQ Issues Draft Amendments to PSD Regulations to Better Reflect Federal Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/Virginia-DEQ-Issues-Draft-Amendments-to-PSD-Regulations-to-Better-Reflect-Federal-Rules-",
    "url": "/news/Virginia-DEQ-Issues-Draft-Amendments-to-PSD-Regulations-to-Better-Reflect-Federal-Rules-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Rulemaking - Comment Request",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Rulemaking---Comment-Request",
    "url": "/news/Proposed-Rulemaking---Comment-Request",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA Finalizes Limited Approval and Disapproval of the Bay Area AQMD's Revisions to New Source Review Regulation",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-Finalizes-Limited-Approval-and-Disapproval-of-the-Bay-Area-AQMD's-Revisions-to-New-Source-Review-Regulation",
    "url": "/news/USEPA-Finalizes-Limited-Approval-and-Disapproval-of-the-Bay-Area-AQMD's-Revisions-to-New-Source-Review-Regulation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Georgia EPD Expedited Permitting  Program Finalized",
    "apiurl": "/restapi/customnewscontentlvl2/news/Georgia-EPD-Expedited-Permitting-Program-Finalized-",
    "url": "/news/Georgia-EPD-Expedited-Permitting-Program-Finalized-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Partners with its Clients to Support Direct Relief",
    "apiurl": "/restapi/customnewscontentlvl2/news/trinity-partners-with-its-clients-to-support-direct-relief",
    "url": "/news/trinity-partners-with-its-clients-to-support-direct-relief",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Partners with its Clients to Support Direct Relief",
    "apiurl": "/restapi/customnewscontentlvl2/news/trinity-partners-with-its-clients-to-support-direct-relief",
    "url": "/www.trinityconsultants.com/news/trinity-partners-with-its-clients-to-support-direct-relief",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Finding the EH&S Staff You Need",
    "apiurl": "/restapi/customnewscontentlvl2/news/Finding-the-EH-S-Staff-You-Need",
    "url": "/news/Finding-the-EH-S-Staff-You-Need",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Regulations Respecting Reduction in the Release of Methane and Certain Volatile Organic Compounds (Upstream Oil and Gas Sector)-Alberta",
    "apiurl": "/restapi/customnewscontentlvl2/news/Regulations-Respecting-Reduction-in-the-Release-of-Methane-and-Certain-Volatile-Organic-Compounds-(Upstream-Oil-and-Gas-Sector)-Alberta",
    "url": "/news/Regulations-Respecting-Reduction-in-the-Release-of-Methane-and-Certain-Volatile-Organic-Compounds-(Upstream-Oil-and-Gas-Sector)-Alberta",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Corporate Performance Excellence through CDP Reporting & Disclosure",
    "apiurl": "/restapi/customnewscontentlvl2/news/Corporate-Performance-Excellence-through-CDP-Reporting-Disclosure",
    "url": "/news/Corporate-Performance-Excellence-through-CDP-Reporting-Disclosure",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Washington Sources Must Reapply for Industrial Stormwater General Permit",
    "apiurl": "/restapi/customnewscontentlvl2/news/Washington-Sources-Must-Reapply-for-Industrial-Stormwater-General-Permit",
    "url": "/news/Washington-Sources-Must-Reapply-for-Industrial-Stormwater-General-Permit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Kansas Sets Minor Source Baseline Dates for PSD Increment Consumption-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Kansas-Sets-Minor-Source-Baseline-Dates-for-PSD-Increment-Consumption-Kansas",
    "url": "/news/Kansas-Sets-Minor-Source-Baseline-Dates-for-PSD-Increment-Consumption-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EHS Information Technology Spotlight",
    "apiurl": "/restapi/customnewscontentlvl2/news/EHS-Information-Technology-Spotlight",
    "url": "/news/EHS-Information-Technology-Spotlight",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MassDEP Enforcement Actions Leads to Substantial Fines Collection",
    "apiurl": "/restapi/customnewscontentlvl2/news/MassDEP-Enforcement-Actions-Leads-to-Substantial-Fines-Collection",
    "url": "/news/MassDEP-Enforcement-Actions-Leads-to-Substantial-Fines-Collection",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cementing the PC MACT",
    "apiurl": "/restapi/customnewscontentlvl2/news/Cementing-the-PC-MACT",
    "url": "/news/Cementing-the-PC-MACT",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Maryland SIP Approval - 1997 8-Hour Ozone Philadelphia Nonattainment Area",
    "apiurl": "/restapi/customnewscontentlvl2/news/Maryland-SIP-Approval---1997-8-Hour-Ozone-Philadelphia-Nonattainment-Area",
    "url": "/news/Maryland-SIP-Approval---1997-8-Hour-Ozone-Philadelphia-Nonattainment-Area",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Alaska DEC Proposed Regulations Updates and SIP for Fairbanks",
    "apiurl": "/restapi/customnewscontentlvl2/news/Alaska-DEC-Proposed-Regulations-Updates-and-SIP-for-Fairbanks",
    "url": "/news/Alaska-DEC-Proposed-Regulations-Updates-and-SIP-for-Fairbanks",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Arizona Passes Landmark Judgement for Underground Storage Tank Non-Compliance",
    "apiurl": "/restapi/customnewscontentlvl2/news/Arizona-Passes-Landmark-Judgement-for-Underground-Storage-Tank-Non-Compliance",
    "url": "/news/Arizona-Passes-Landmark-Judgement-for-Underground-Storage-Tank-Non-Compliance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Officially Allowing Use of Camera as an Alternative to Method 9",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ-Officially-Allowing-Use-of-Camera-as-an-Alternative-to-Method-9",
    "url": "/news/ADEQ-Officially-Allowing-Use-of-Camera-as-an-Alternative-to-Method-9",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Incorporating RCRA Federal Updates-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/TCEQ-Incorporating-RCRA-Federal-Updates-Texas",
    "url": "/news/TCEQ-Incorporating-RCRA-Federal-Updates-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Revisions to the Sulfur Content Requirements for Fuel Oil",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Revisions-to-the-Sulfur-Content-Requirements-for-Fuel-Oil",
    "url": "/news/Proposed-Revisions-to-the-Sulfur-Content-Requirements-for-Fuel-Oil",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "INDR Presentations Available",
    "apiurl": "/restapi/customnewscontentlvl2/news/INDR-Presentations-Available",
    "url": "/news/INDR-Presentations-Available",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Strategic Partnership with AnyWare E-Commerce Further Expands BREEZE Software and Services in Israel and Romania",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Strategic-Partnership-with-AnyWare-E-Commerce-Further-Expands-BREEZE-Software-and-Services-in-Israel-and-Romania",
    "url": "/news/New-Strategic-Partnership-with-AnyWare-E-Commerce-Further-Expands-BREEZE-Software-and-Services-in-Israel-and-Romania",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Potential Follow-up Investigations in Response to USA Today Special Report: \"'The Smokestack Effect\"",
    "apiurl": "/restapi/customnewscontentlvl2/news/Potential-",
    "url": "/news/Potential-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ISO 14001: 2015 Implementation Challenges - Addressing Life Cycle Perspective",
    "apiurl": "/restapi/customnewscontentlvl2/news/ISO-14001-2015-Implementation-Challenges---Addressing-Life-Cycle-Perspective",
    "url": "/news/ISO-14001-2015-Implementation-Challenges---Addressing-Life-Cycle-Perspective",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Powerful Results Visualization Starts with BREEZE 3D Analyst 2.3",
    "apiurl": "/restapi/customnewscontentlvl2/news/Powerful-Results-Visualization-Starts-with-BREEZE-3D-Analyst-2-3",
    "url": "/news/Powerful-Results-Visualization-Starts-with-BREEZE-3D-Analyst-2-3",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Illinois Air Quality Report for 2012",
    "apiurl": "/restapi/customnewscontentlvl2/news/Illinois-Air-Quality-Report-for-2012-",
    "url": "/news/Illinois-Air-Quality-Report-for-2012-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Additional Public Input Opportunity for Draft Rules to Provide Regulatory Certainty",
    "apiurl": "/restapi/customnewscontentlvl2/news/Additional-Public-Input-Opportunity-for-Draft-Rules-to-Provide-Regulatory-Certainty",
    "url": "/news/Additional-Public-Input-Opportunity-for-Draft-Rules-to-Provide-Regulatory-Certainty",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendment to 10 CSR 10-6.220 Hospital, Medical, Infectious Waste Incinerators",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendment-to-10-CSR-10-6-220-Hospital-Medical-Infectious-Waste-Incinerators",
    "url": "/news/Proposed-Amendment-to-10-CSR-10-6-220-Hospital-Medical-Infectious-Waste-Incinerators",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "North Dakota Reporting Reminders!",
    "apiurl": "/restapi/customnewscontentlvl2/news/North-Dakota-Reporting-Reminders!",
    "url": "/news/North-Dakota-Reporting-Reminders!",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Completes Transaction With Levine Leichtman Capital Partners",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Completes-Transaction-With-Levine-Leichtman-Capital-Partners",
    "url": "/news/Trinity-Consultants-Completes-Transaction-With-Levine-Leichtman-Capital-Partners",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Opens Offices in Cleveland and Milwaukee",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Opens-Offices-in-Cleveland-and-Milwaukee",
    "url": "/news/Trinity-Opens-Offices-in-Cleveland-and-Milwaukee",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Virtual Inspections in Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/virtual-inspections-",
    "url": "/news/virtual-inspections-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Approval of Illinois' Ozone NNSR SIP-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Approval-of-Illinois'-Ozone-NNSR-SIP-Illinois",
    "url": "/news/Approval-of-Illinois'-Ozone-NNSR-SIP-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oregon DEQ Extends Submission Deadline for Upcoming Toxic Air Contaminant Emissions Reporting",
    "apiurl": "/restapi/customnewscontentlvl2/news/oregon-deq-extends-submission-deadline-for-upcoming-toxic-air-contaminant-emissions-reporting",
    "url": "/news/oregon-deq-extends-submission-deadline-for-upcoming-toxic-air-contaminant-emissions-reporting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oregon DEQ Informally Notifies Facilities of Upcoming Cleaner Air Oregon Triennial Reporting Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/oregon-deq-informally-notifies-facilities-of-upcoming-cleaner-air-oregon-triennial-reporting-requirements-",
    "url": "/news/oregon-deq-informally-notifies-facilities-of-upcoming-cleaner-air-oregon-triennial-reporting-requirements-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DOEE Proposes to Renew and Revise Source Category Permits for Engines Subject to NSPS JJJJ and NSPS IIII-Washington, DC",
    "apiurl": "/restapi/customnewscontentlvl2/news/DOEE-Proposes-to-Renew-and-Revise-Source-Category-Permits-for-Engines-Subject-to-NSPS-JJJJ-and-NSPS-IIII-Washington-DC",
    "url": "/news/DOEE-Proposes-to-Renew-and-Revise-Source-Category-Permits-for-Engines-Subject-to-NSPS-JJJJ-and-NSPS-IIII-Washington-DC",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Benzene Fenceline Monitoring for Refineries in Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Benzene-Fenceline-Monitoring-for-Refineries-in-Colorado",
    "url": "/news/Benzene-Fenceline-Monitoring-for-Refineries-in-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE Releases AERMET 7.5.2 to Include Latest U.S. EPA AERMINUTE Executable 14337",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-Releases-AERMET-7-5-2-to-Include-Latest-U-S-EPA-AERMINUTE-Executable-14337-",
    "url": "/news/BREEZE-Releases-AERMET-7-5-2-to-Include-Latest-U-S-EPA-AERMINUTE-Executable-14337-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Emissions Inventories For All Arkansas Title V Facilities Due in 2015",
    "apiurl": "/restapi/customnewscontentlvl2/news/Emissions-Inventories-For-All-Arkansas-Title-V-Facilities-Due-in-2015",
    "url": "/news/Emissions-Inventories-For-All-Arkansas-Title-V-Facilities-Due-in-2015",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2019 Texas Environmental Regulatory Deadlines-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/2019-Texas-Environmental-Regulatory-Deadlines-Texas",
    "url": "/news/2019-Texas-Environmental-Regulatory-Deadlines-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Designing a PSD PM2.5 Monitoring Program: Challenges and Considerations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Designing-a-PSD-PM2-5-Monitoring-Program-Challenges-and-Considerations",
    "url": "/news/Designing-a-PSD-PM2-5-Monitoring-Program-Challenges-and-Considerations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Rulemaking to TCEQ NSR Public Notice (30 TAC Chapter 39 and 55)-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Rulemaking-to-TCEQ-NSR-Public-Notice-(30-TAC-Chapter-39-and-55)-Texas",
    "url": "/news/Proposed-Rulemaking-to-TCEQ-NSR-Public-Notice-(30-TAC-Chapter-39-and-55)-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to Maricopa County Adopted Rule 316 and Rule 320",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-to-Maricopa-County-Adopted-Rule-316-and-Rule-320",
    "url": "/news/Updates-to-Maricopa-County-Adopted-Rule-316-and-Rule-320",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Recent Changes to New Mexico Environmental Department Modeling Guidelines",
    "apiurl": "/restapi/customnewscontentlvl2/news/Recent-Changes-to-New-Mexico-Environmental-Department-Modeling-Guidelines",
    "url": "/news/Recent-Changes-to-New-Mexico-Environmental-Department-Modeling-Guidelines",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Expands New Jersey Team",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Expands-New-Jersey-Team",
    "url": "/news/Trinity-Consultants-Expands-New-Jersey-Team",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Permitting and Emissions Fees to Increase-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Permitting-and-Emissions-Fees-to-Increase-Colorado",
    "url": "/news/Permitting-and-Emissions-Fees-to-Increase-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Michigan Mercury Rule Changes",
    "apiurl": "/restapi/customnewscontentlvl2/news/Michigan-Mercury-Rule-Changes",
    "url": "/news/Michigan-Mercury-Rule-Changes",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update from September 19, 2017 GSHMM Meeting-Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-from-September-19-2017-GSHMM-Meeting-Missouri",
    "url": "/news/Update-from-September-19-2017-GSHMM-Meeting-Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed SIP Revision - Significant Emission Rate for Ammonia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-SIP-Revision---Significant-Emission-Rate-for-Ammonia",
    "url": "/news/Proposed-SIP-Revision---Significant-Emission-Rate-for-Ammonia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Drills New Claim in Tulsa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Drills-New-Claim-in-Tulsa",
    "url": "/news/Trinity-Consultants-Drills-New-Claim-in-Tulsa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Montana Registration Program for Aggregates, Ready-Mix, and Asphalt Industry-Montana",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Montana-Registration-Program-for-Aggregates-Ready-Mix-and-Asphalt-Industry-Montana",
    "url": "/news/New-Montana-Registration-Program-for-Aggregates-Ready-Mix-and-Asphalt-Industry-Montana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD CEQA Updates Workshop-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/BAAQMD-CEQA-Updates-Workshop-California",
    "url": "/news/BAAQMD-CEQA-Updates-Workshop-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Rule Change to Adopt PAL Provisions for GHGs",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Rule-Change-to-Adopt-PAL-Provisions-for-GHGs",
    "url": "/news/Proposed-Rule-Change-to-Adopt-PAL-Provisions-for-GHGs",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Recent Hot Button Air Permit Application Issues",
    "apiurl": "/restapi/customnewscontentlvl2/news/Recent-Hot-Button-Air-Permit-Application-Issues",
    "url": "/news/Recent-Hot-Button-Air-Permit-Application-Issues",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "What’s new in the 2019 Stormwater Multi-Sector General Permit",
    "apiurl": "/restapi/customnewscontentlvl2/news/what-s-new-in-the-2019-stormwater-multi-sector-general-permit",
    "url": "/news/what-s-new-in-the-2019-stormwater-multi-sector-general-permit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "What’s new in the 2019 Stormwater Multi-Sector General Permit",
    "apiurl": "/restapi/customnewscontentlvl2/news/what-s-new-in-the-2019-stormwater-multi-sector-general-permit",
    "url": "/states/arizona/what-s-new-in-the-2019-stormwater-multi-sector-general-permit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Obama EPA Stance on NSR Emissions is Tested",
    "apiurl": "/restapi/customnewscontentlvl2/news/Obama-EPA-Stance-on-NSR-Emissions-is-Tested-",
    "url": "/news/Obama-EPA-Stance-on-NSR-Emissions-is-Tested-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KC Chamber and Partners host 2015 Midwest Environmental Compliance Conference (MECC)-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/KC-Chamber-and-Partners-host-2015-Midwest-Environmental-Compliance-Conference-(MECC)-Nebraska",
    "url": "/news/KC-Chamber-and-Partners-host-2015-Midwest-Environmental-Compliance-Conference-(MECC)-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Minor Source VOP Stakeholder Froup Forming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Minor-Source-VOP-Stakeholder-Froup-Forming",
    "url": "/news/Minor-Source-VOP-Stakeholder-Froup-Forming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CAIR Quietly Reinstated",
    "apiurl": "/restapi/customnewscontentlvl2/news/CAIR-Quietly-Reinstated",
    "url": "/news/CAIR-Quietly-Reinstated",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendment to the California Air Resource Board (CARB) Mandatory Reporting of Greenhouse Gas Emission Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendment-to-the-California-Air-Resource-Board-(CARB)-Mandatory-Reporting-of-Greenhouse-Gas-Emission-Regulations",
    "url": "/news/Proposed-Amendment-to-the-California-Air-Resource-Board-(CARB)-Mandatory-Reporting-of-Greenhouse-Gas-Emission-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "California Crude Oil and Natural Gas Methane Rule-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/California-Crude-Oil-and-Natural-Gas-Methane-Rule-California",
    "url": "/news/California-Crude-Oil-and-Natural-Gas-Methane-Rule-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Washoe County AQMD's New Confidentiality Request Form",
    "apiurl": "/restapi/customnewscontentlvl2/news/washoe-county-aqmds-new-confidentiality-request-form",
    "url": "/news/washoe-county-aqmds-new-confidentiality-request-form",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Greenhouse Gases Endangerment",
    "apiurl": "/restapi/customnewscontentlvl2/news/Greenhouse-Gases-Endangerment",
    "url": "/news/Greenhouse-Gases-Endangerment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ODEQ Air Toxics Emission Inventory Request",
    "apiurl": "/restapi/customnewscontentlvl2/news/ODEQ-Air-Toxics-Emission-Inventory-Request",
    "url": "/news/ODEQ-Air-Toxics-Emission-Inventory-Request",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Ruling on Revision to Chicago’s 8-hr Ozone Maintenance Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-Ruling-on-Revision-to-Chicago-s-8-hr-Ozone-Maintenance-Plan",
    "url": "/news/Final-Ruling-on-Revision-to-Chicago-s-8-hr-Ozone-Maintenance-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Preparing for the Upcoming TRI Reporting Deadline",
    "apiurl": "/restapi/customnewscontentlvl2/news/Preparing-for-the-Upcoming-TRI-Reporting-Deadline",
    "url": "/news/Preparing-for-the-Upcoming-TRI-Reporting-Deadline",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reporting Reminders (April 2019 Update)-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reporting-Reminders-(April-2019-Update)-Iowa",
    "url": "/news/Reporting-Reminders-(April-2019-Update)-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "State Water Board Proposed Storm Water Industrial General Permit Amendments-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/State-Water-Board-Proposed-Storm-Water-Industrial-General-Permit-Amendments-California",
    "url": "/news/State-Water-Board-Proposed-Storm-Water-Industrial-General-Permit-Amendments-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Toxic Release Inventory (TRI) Basics and Landmines",
    "apiurl": "/restapi/customnewscontentlvl2/news/toxic-release-inventory-(tri)-basics-and-landmines",
    "url": "/news/toxic-release-inventory-(tri)-basics-and-landmines",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Toxic Release Inventory (TRI) Basics and Landmines",
    "apiurl": "/restapi/customnewscontentlvl2/news/toxic-release-inventory-(tri)-basics-and-landmines",
    "url": "/News/Federal/Toxic-Release-Inventory-TRI-Basics-and-Landmines/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MPCA Annual Permitting Efficiency Report Released-Minnesota",
    "apiurl": "/restapi/customnewscontentlvl2/news/MPCA-Annual-Permitting-Efficiency-Report-Released-Minnesota",
    "url": "/news/MPCA-Annual-Permitting-Efficiency-Report-Released-Minnesota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Redesignates Denver-Front Range Area as Moderate for 2008 Ozone Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Redesignates-Denver-Front-Range-Area-as-Moderate-for-2008-Ozone-Standard",
    "url": "/news/EPA-Redesignates-Denver-Front-Range-Area-as-Moderate-for-2008-Ozone-Standard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Are You Prepared for the RY2020 New PFAS TRI Reporting Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/are-you-prepared-for-the-ry2020-new-pfas-tri-reporting-requirements",
    "url": "/news/are-you-prepared-for-the-ry2020-new-pfas-tri-reporting-requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Are You Prepared for the RY2020 New PFAS TRI Reporting Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/are-you-prepared-for-the-ry2020-new-pfas-tri-reporting-requirements",
    "url": "/federal/are-you-prepared-for-the-ry2020-new-pfas-tri-reporting-requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Are You Prepared for the RY2020 New PFAS TRI Reporting Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/are-you-prepared-for-the-ry2020-new-pfas-tri-reporting-requirements",
    "url": "/news/federal/are-you-prepared-for-the-ry2020-new-pfas-tri-reporting-requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CDPHE Formal Application Rejection Process to Begin March 1, 2019-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/CDPHE-Formal-Application-Rejection-Process-to-Begin-March-1-2019-Colorado",
    "url": "/news/CDPHE-Formal-Application-Rejection-Process-to-Begin-March-1-2019-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Finalizes PSD / Title V Tailoring Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Finalizes-PSD-Title-V-Tailoring-Rule",
    "url": "/news/EPA-Finalizes-PSD-Title-V-Tailoring-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Determination of Single Stationary Source for the Oil and Gas Industries",
    "apiurl": "/restapi/customnewscontentlvl2/news/Determination-of-Single-Stationary-Source-for-the-Oil-and-Gas-Industries",
    "url": "/news/Determination-of-Single-Stationary-Source-for-the-Oil-and-Gas-Industries",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ohio EPA Issues Revised Air Dispersion Modeling Guidance",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ohio-EPA-Issues-Revised-Air-Dispersion-Modeling-Guidance",
    "url": "/news/Ohio-EPA-Issues-Revised-Air-Dispersion-Modeling-Guidance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cap-and-Trade February 2015 Joint-Auction Results Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/-Cap-and-Trade-February-2015-Joint-Auction-Results-Released",
    "url": "/news/-Cap-and-Trade-February-2015-Joint-Auction-Results-Released",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Annual Fees for Houston-Galveston-Brazoria Plants",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Annual-Fees-for-Houston-Galveston-Brazoria-Plants",
    "url": "/news/New-Annual-Fees-for-Houston-Galveston-Brazoria-Plants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Newly Created Connecticut Department of Energy and Environmental Protection (DEEP)",
    "apiurl": "/restapi/customnewscontentlvl2/news/Newly-Crea",
    "url": "/news/Newly-Crea",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated Name for the Online Permit System-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updated-Name-for-the-Online-Permit-System-Iowa",
    "url": "/news/Updated-Name-for-the-Online-Permit-System-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Alabama Annual Reporting Reminders",
    "apiurl": "/restapi/customnewscontentlvl2/news/Alabama-Annual-Reporting-Reminders",
    "url": "/news/Alabama-Annual-Reporting-Reminders",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Have You Updated Your Ambient Monitoring QAPP?",
    "apiurl": "/restapi/customnewscontentlvl2/news/Have-You-Updated-Your-Ambient-Monitoring-QAPP-",
    "url": "/news/Have-You-Updated-Your-Ambient-Monitoring-QAPP-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Acquires Jim Clary & Associates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Acquires-Jim-Clary-Associates",
    "url": "/news/Trinity-Consultants-Acquires-Jim-Clary-Associates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "AWMA Meetings Sep 2009",
    "apiurl": "/restapi/customnewscontentlvl2/news/AWMA-Meetings-Sep-2009",
    "url": "/news/AWMA-Meetings-Sep-2009",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Annual Audit Requirements for Facility Security Plans",
    "apiurl": "/restapi/customnewscontentlvl2/news/Annual-Audit-Requirements-for-Facility-Security-Plans",
    "url": "/news/Annual-Audit-Requirements-for-Facility-Security-Plans",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD Expands Funding and Scope for Heavy Duty Engine Replacement Projects",
    "apiurl": "/restapi/customnewscontentlvl2/news/baaqmd-expands-funding-and-scope-for-heavy-duty-engine-replacement-projects",
    "url": "/news/baaqmd-expands-funding-and-scope-for-heavy-duty-engine-replacement-projects",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Title V EZ Mod Permit Application Form",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Title-V-EZ-Mod-Permit-Application-Form",
    "url": "/news/New-Title-V-EZ-Mod-Permit-Application-Form",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MPCA Winter Air Modeling Seminar",
    "apiurl": "/restapi/customnewscontentlvl2/news/mpca-hosts-annual-winter-modeling-seminar",
    "url": "/news/mpca-hosts-annual-winter-modeling-seminar",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Tip of the Month - Reporting Spills in Kansas-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Tip-of-the-Month---Reporting-Spills-in-Kansas-Kansas",
    "url": "/news/Tip-of-the-Month---Reporting-Spills-in-Kansas-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Don’t Miss Your (RMP) Anniversary - For Your Risk Management Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/don-t-miss-your-(rmp)-anniversary---for-your-risk-management-plan",
    "url": "/news/don-t-miss-your-(rmp)-anniversary---for-your-risk-management-plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Don’t Miss Your (RMP) Anniversary - For Your Risk Management Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/don-t-miss-your-(rmp)-anniversary---for-your-risk-management-plan",
    "url": "/federal/don-t-miss-your-rmp-anniversary----for-your-risk-management-plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Comment Period Open for Proposed Revisions to Air Regulations-Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/Comment-Period-Open-for-Proposed-Revisions-to-Air-Regulations-Missouri",
    "url": "/news/Comment-Period-Open-for-Proposed-Revisions-to-Air-Regulations-Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA Redesignates Las Vegas Valley to Attainment for PM10",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-Redesignates-Las-Vegas-Valley-to-Attainment-for-PM10",
    "url": "/news/USEPA-Redesignates-Las-Vegas-Valley-to-Attainment-for-PM10",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Status of Outstanding SO2 NAAQS Designations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Status-of-Outstanding-SO2-NAAQS-Designations",
    "url": "/news/Status-of-Outstanding-SO2-NAAQS-Designations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "VA DEQ Proposes SIP Amendments to Comply with New Federal GHG Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/VA-DEQ-Proposes-SIP-Amendments-to-Comply-with-New-Federal-GHG-Regulations",
    "url": "/news/VA-DEQ-Proposes-SIP-Amendments-to-Comply-with-New-Federal-GHG-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Good News - Dec 2020",
    "apiurl": "/restapi/customnewscontentlvl2/news/good-news---dec-2020",
    "url": "/news/good-news---dec-2020",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Good News - Dec 2020",
    "apiurl": "/restapi/customnewscontentlvl2/news/good-news---dec-2020",
    "url": "/news/good-news-dec-2020",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Bad River Class I Redesignation – Nearing End of Public Comment Period",
    "apiurl": "/restapi/customnewscontentlvl2/news/Bad-River-Class-I-Redesignation-Nearing-End-of-Public-Comment-Period",
    "url": "/news/Bad-River-Class-I-Redesignation-Nearing-End-of-Public-Comment-Period",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Above Ground Storage Tank (AST) Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/Above-Ground-Storage-Tank-(AST)-Requirements",
    "url": "/news/Above-Ground-Storage-Tank-(AST)-Requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Missouri Rules in Development – Cross State Air Pollution Rule Allowance Allocations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Missouri-Rules-in-Development-Cross-State-Air-Pollution-Rule-Allowance-Allocations",
    "url": "/news/Missouri-Rules-in-Development-Cross-State-Air-Pollution-Rule-Allowance-Allocations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Regional Haze FIP for Taconite Facilities in Minnesota and Michigan-Minnesota",
    "apiurl": "/restapi/customnewscontentlvl2/news/Regional-Haze-FIP-for-Taconite-Facilities-in-Minnesota-and-Michigan-Minnesota",
    "url": "/news/Regional-Haze-FIP-for-Taconite-Facilities-in-Minnesota-and-Michigan-Minnesota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PADEP Announces Plan for Modeling 1-hr SO2 NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/PADEP-Announces-Plan-for-Modeling-1-hr-SO2-NAAQS",
    "url": "/news/PADEP-Announces-Plan-for-Modeling-1-hr-SO2-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Shanghai Potent Compound Boot Camp Brochure",
    "apiurl": "/restapi/customnewscontentlvl2/news/Shanghai-Potent-Compound-Boot-Camp-Brochure",
    "url": "/news/Shanghai-Potent-Compound-Boot-Camp-Brochure",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NJDEP Industrial Stakeholder Group (ISG) Summary for December 6, 2013 Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/NJDEP-Industrial-Stakeholder-Group-(ISG)-Summary-for-December-6-2013-Meeting",
    "url": "/news/NJDEP-Industrial-Stakeholder-Group-(ISG)-Summary-for-December-6-2013-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GHG Cap-and-Trade Updates-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/GHG-Cap-and-Trade-Updates-California",
    "url": "/news/GHG-Cap-and-Trade-Updates-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "REGFORM 2016 Missouri Air Seminar",
    "apiurl": "/restapi/customnewscontentlvl2/news/REGFORM-2016-Missouri-Air-Seminar",
    "url": "/news/REGFORM-2016-Missouri-Air-Seminar",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Finalized Amendments to COMAR 26.11.38 - Control of NOx from Coal-Fired Electric Generating Units",
    "apiurl": "/restapi/customnewscontentlvl2/news/Finalized-Amendments-to-COMAR-26-11-38---Control-of-NOx-from-Coal-Fired-Electric-Generating-Units",
    "url": "/news/Finalized-Amendments-to-COMAR-26-11-38---Control-of-NOx-from-Coal-Fired-Electric-Generating-Units",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "North Carolina Air Toxics Reform Legislation Signed into Law",
    "apiurl": "/restapi/customnewscontentlvl2/news/North-Carolina-Air-Toxics-Reform-Legislation-Signed-into-Law",
    "url": "/news/North-Carolina-Air-Toxics-Reform-Legislation-Signed-into-Law",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA Proposes Re-Designation of Milwaukee Area to Attainment for 24-Hour PM2.5 NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-Proposes-Re-Designation-of-Milwaukee-Area-to-Attainment-for-24-Hour-PM2-5-NAAQS",
    "url": "/news/USEPA-Proposes-Re-Designation-of-Milwaukee-Area-to-Attainment-for-24-Hour-PM2-5-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Midwest Environmental Compliance Conference April 11-12, 2018-Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/Midwest-Environmental-Compliance-Conference-April-11-12-2018-Missouri",
    "url": "/news/Midwest-Environmental-Compliance-Conference-April-11-12-2018-Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD Board of Directors Passes Resolution to Track and Limit Refinery Emissions",
    "apiurl": "/restapi/customnewscontentlvl2/news/BAAQMD-Board-of-Directors-Passes-Resolution-to-Track-and-Limit-Refinery-Emissions",
    "url": "/news/BAAQMD-Board-of-Directors-Passes-Resolution-to-Track-and-Limit-Refinery-Emissions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Silently Strikes SSM Exemption Language",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-silently-strikes-ssm-exemption-language",
    "url": "/news/epa-silently-strikes-ssm-exemption-language",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated Permit Template Available for Comment",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updated-Permit-Template-Available-for-Comment",
    "url": "/news/Updated-Permit-Template-Available-for-Comment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Environmental Regulatory Monitoring in 2015",
    "apiurl": "/restapi/customnewscontentlvl2/news/Environmental-Regulatory-Monitoring-in-2015-",
    "url": "/news/Environmental-Regulatory-Monitoring-in-2015-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2015 Nebraska Environmental Conference",
    "apiurl": "/restapi/customnewscontentlvl2/news/2015-Nebraska-Environmental-Conference",
    "url": "/news/2015-Nebraska-Environmental-Conference",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Finalizes Control Techniques Guidelines (CTG) for Existing Sources in the Oil and Natural Gas Industry",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Finalizes-Control-Techniques-Guidelines-(CTG)-for-Existing-Sources-in-the-Oil-and-Natural-Gas-Industry",
    "url": "/news/EPA-Finalizes-Control-Techniques-Guidelines-(CTG)-for-Existing-Sources-in-the-Oil-and-Natural-Gas-Industry",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Issues  with TANKS 4.09d and Tank Emission Calculations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Issues-with-TANKS-4-09d-and-Tank-Emission-Calculations",
    "url": "/news/Issues-with-TANKS-4-09d-and-Tank-Emission-Calculations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA to Propose New GHG Provisions in Utility, Refinery NSPS",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-to-Propose-New-GHG-Provisions-in-Utility-Refinery-NSPS",
    "url": "/news/EPA-to-Propose-New-GHG-Provisions-in-Utility-Refinery-NSPS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cap-and-Trade Amendments and Spending Guidance Workshops",
    "apiurl": "/restapi/customnewscontentlvl2/news/Cap-and-Trade-Amendments-and-Spending-Guidance-Workshops",
    "url": "/news/Cap-and-Trade-Amendments-and-Spending-Guidance-Workshops",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Adds Additional Permit Application Types to ePermits System",
    "apiurl": "/restapi/customnewscontentlvl2/news/tceq-adds-additional-permit-application-types-to-epermits-system",
    "url": "/news/tceq-adds-additional-permit-application-types-to-epermits-system",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Adds Additional Permit Application Types to ePermits System",
    "apiurl": "/restapi/customnewscontentlvl2/news/tceq-adds-additional-permit-application-types-to-epermits-system",
    "url": "/news/state/texas/tceq-adds-additional-permit-application-types-to-epermits-system",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed 2017 CEQA Guidelines Update-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-2017-CEQA-Guidelines-Update-California",
    "url": "/news/Proposed-2017-CEQA-Guidelines-Update-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendment to Definition used in Air Pollution Control Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendment-to-Definition-used-in-Air-Pollution-Control-Rules",
    "url": "/news/Proposed-Amendment-to-Definition-used-in-Air-Pollution-Control-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Texas Areas’ Potential Ozone Nonattainment Reclassification",
    "apiurl": "/restapi/customnewscontentlvl2/news/texas-areas-potential-ozone-nonattainment-reclassification",
    "url": "/news/texas-areas-potential-ozone-nonattainment-reclassification",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Management of Excess Soil",
    "apiurl": "/restapi/customnewscontentlvl2/news/Management-of-Excess-Soil",
    "url": "/news/Management-of-Excess-Soil",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Petitioned for Reconsideration of New NO2 Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Petitioned-for-Reconsideration-of-New-NO2-Standard",
    "url": "/news/EPA-Petitioned-for-Reconsideration-of-New-NO2-Standard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New FLAG Guidance for Class I Area Modeling",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-FLAG-Guidance-for-Class-I-Area-Modeling",
    "url": "/news/New-FLAG-Guidance-for-Class-I-Area-Modeling",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Governor Sisolak Launches the New State of Nevada Climate Initiative",
    "apiurl": "/restapi/customnewscontentlvl2/news/governor-sisolak-launches-the-new-state-of-nevada-climate-initiative",
    "url": "/news/governor-sisolak-launches-the-new-state-of-nevada-climate-initiative",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Governor Sisolak Launches the New State of Nevada Climate Initiative",
    "apiurl": "/restapi/customnewscontentlvl2/news/governor-sisolak-launches-the-new-state-of-nevada-climate-initiative",
    "url": "/news/state/nevada/governor-sisolak-launches-the-new-state-of-nevada-climate-initiative",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Authorizes GHG Permitting Deferral for Biogenic Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Authorizes-GHG-Permitting-Deferral-for-Biogenic-Sources",
    "url": "/news/EPA-Authorizes-GHG-Permitting-Deferral-for-Biogenic-Sources",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Federal and Nebraska Reporting Reminders",
    "apiurl": "/restapi/customnewscontentlvl2/news/Federal-and-Nebraska-Reporting-Reminders",
    "url": "/news/Federal-and-Nebraska-Reporting-Reminders",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LDEQ Finalizes Regulatory Permit for Turbines",
    "apiurl": "/restapi/customnewscontentlvl2/news/ldeq-finalizes-regulatory-permit-for-turbines",
    "url": "/news/ldeq-finalizes-regulatory-permit-for-turbines",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Next Steps Regarding Mandatory GHG Reporting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Next-Steps-Regarding-Mandatory-GHG-Reporting",
    "url": "/news/Next-Steps-Regarding-Mandatory-GHG-Reporting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Modeling Guidance Updated",
    "apiurl": "/restapi/customnewscontentlvl2/news/Modeling-Guidance-Updated",
    "url": "/news/Modeling-Guidance-Updated",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Air Pollution Emission Notice (APEN) for Gas/Liquid Separators",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Air-Pollution-Emission-Notice-(APEN)-for-Gas-Liquid-Separators",
    "url": "/news/New-Air-Pollution-Emission-Notice-(APEN)-for-Gas-Liquid-Separators",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MPCA to Update July 2012 Draft Mercury Rule Following Boiler MACT Final Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/MPCA-to-Update-July-2012-Draft-Mercury-Rule-Following-Boiler-MACT-Final-Rule",
    "url": "/news/MPCA-to-Update-July-2012-Draft-Mercury-Rule-Following-Boiler-MACT-Final-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Newest Version of AERMOD has been Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/-Newest-Ve",
    "url": "/news/-Newest-Ve",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KDHE Proposed Regulatory Changes - Right-to-Know Reporting",
    "apiurl": "/restapi/customnewscontentlvl2/news/kdhe-proposed-regulatory-changes-right-to-know-reporting",
    "url": "/news/kdhe-proposed-regulatory-changes-right-to-know-reporting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on Vacatur of SSM Exemption in NESHAP General Provisions",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-",
    "url": "/news/Update-on-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "HFC Refrigerant Rule in Effect in New York",
    "apiurl": "/restapi/customnewscontentlvl2/news/hfc-refrigerant-rule-in-effect-in-new-york",
    "url": "/news/hfc-refrigerant-rule-in-effect-in-new-york",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Kansas Emission Inventory Submittal System Training and Changes",
    "apiurl": "/restapi/customnewscontentlvl2/news/Kansas-Emission-Inventory-Submittal-System-Training-and-Changes",
    "url": "/news/Kansas-Emission-Inventory-Submittal-System-Training-and-Changes",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Regulation 7 Revisions Finalized-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Regulation-7-Revisions-Finalized-Colorado",
    "url": "/news/Regulation-7-Revisions-Finalized-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Nebraska in Attainment with 2015 Ozone Standard-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/Nebraska-in-Attainment-with-2015-Ozone-Standard-Nebraska",
    "url": "/news/Nebraska-in-Attainment-with-2015-Ozone-Standard-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Permitting and Modeling Revisions",
    "apiurl": "/restapi/customnewscontentlvl2/news/Permitting-and-Modeling-Revisions",
    "url": "/news/Permitting-and-Modeling-Revisions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MPCA Proposes New Permitting Fees",
    "apiurl": "/restapi/customnewscontentlvl2/news/MPCA-Proposes-New-Permitting-Fees",
    "url": "/news/MPCA-Proposes-New-Permitting-Fees",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEP Issues Guidance Document for Baghouse Testing Determination System",
    "apiurl": "/restapi/customnewscontentlvl2/news/ndep-issues-guidance-document-for-baghouse-testing-determination-system",
    "url": "/news/ndep-issues-guidance-document-for-baghouse-testing-determination-system",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GHG Inventory Data",
    "apiurl": "/restapi/customnewscontentlvl2/news/GHG-Inventory-Data",
    "url": "/news/GHG-Inventory-Data",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed SIP Approval for Limitations on Premises-Wide Actual Emissions Below Title V Source Threshold – Connecticut",
    "apiurl": "/restapi/customnewscontentlvl2/news/proposed-sip-approval-for-limitations-on-premises-wide-actual-emissions-below-title-v-source-threshold-connecticut",
    "url": "/news/proposed-sip-approval-for-limitations-on-premises-wide-actual-emissions-below-title-v-source-threshold-connecticut",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Pennsylvania Proposed Regulations Related to Coal Ash",
    "apiurl": "/restapi/customnewscontentlvl2/news/Pennsylvania-Proposed-Regulations-Related-to-Coal-Ash",
    "url": "/news/Pennsylvania-Proposed-Regulations-Related-to-Coal-Ash",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA’s Boiler MACT Reconsideration and Proposed Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-s-Boiler-MACT-Reconsideration-and-Proposed-Amendments",
    "url": "/news/EPA-s-Boiler-MACT-Reconsideration-and-Proposed-Amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Winery WDR Fee Stakeholder Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/winery-wdr-fee-stakeholder-meeting",
    "url": "/news/winery-wdr-fee-stakeholder-meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Winery WDR Fee Stakeholder Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/winery-wdr-fee-stakeholder-meeting",
    "url": "/www.trinityconsultants.com/news/winery-wdr-fee-stakeholder-meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Iowa's 5-year Network Assessment Available for Public Review and Comment",
    "apiurl": "/restapi/customnewscontentlvl2/news/Iowa's-5-year-Network-Assessment-Available-for-Public-Review-and-Comment",
    "url": "/news/Iowa's-5-year-Network-Assessment-Available-for-Public-Review-and-Comment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ohio EPA Revises BAT Guidance Document",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ohio-EPA-Revises-BAT-Guidance-Document",
    "url": "/news/Ohio-EPA-Revises-BAT-Guidance-Document",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Emissions During Startup, Shutdown & Malfunction",
    "apiurl": "/restapi/customnewscontentlvl2/news/Emissions-During-Startup-Shutdown-Malfunction",
    "url": "/news/Emissions-During-Startup-Shutdown-Malfunction",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Clark County DAQ Implements Revised Dust Control Operating Permit Application-Nevada",
    "apiurl": "/restapi/customnewscontentlvl2/news/Clark-County-DAQ-Implements-Revised-Dust-Control-Operating-Permit-Application-Nevada",
    "url": "/news/Clark-County-DAQ-Implements-Revised-Dust-Control-Operating-Permit-Application-Nevada",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ecology to Update Toxic Air Pollutant Rules-Washington",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ecology-to-Update-Toxic-Air-Pollutant-Rules-Washington",
    "url": "/news/Ecology-to-Update-Toxic-Air-Pollutant-Rules-Washington",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Utah, Wyoming and New Mexico achieved SO2 Regional Haze Milestone",
    "apiurl": "/restapi/customnewscontentlvl2/news/Utah-Wyoming-and-New-Mexico-achieved-SO2-Regional-Haze-Milestone",
    "url": "/news/Utah-Wyoming-and-New-Mexico-achieved-SO2-Regional-Haze-Milestone",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Partner Spotlight - Enablon",
    "apiurl": "/restapi/customnewscontentlvl2/news/partner-spotlight---enablon",
    "url": "/news/partner-spotlight---enablon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Partner Spotlight - Enablon",
    "apiurl": "/restapi/customnewscontentlvl2/news/partner-spotlight---enablon",
    "url": "/technology/partner-spotlight---enablon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Risk Assessments Now Needed for Nitrosamines in APIs and Drug Products",
    "apiurl": "/restapi/customnewscontentlvl2/news/Risk-Assessments-Now-Needed-for-Nitrosamines-in-APIs-and-Drug-Products",
    "url": "/news/Risk-Assessments-Now-Needed-for-Nitrosamines-in-APIs-and-Drug-Products",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Boiler MACT and Affiliated Rules Proposed",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Boiler-MACT-and-Affiliated-Rules-Proposed",
    "url": "/news/New-Boiler-MACT-and-Affiliated-Rules-Proposed",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Public Meetings on Ozone Notattainment Designations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Public-Meetings-on-Ozone-Notattainment-Designations",
    "url": "/news/Public-Meetings-on-Ozone-Notattainment-Designations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TSCA \"Lookback\" Reporting due February 7, 2018-Ohio",
    "apiurl": "/restapi/customnewscontentlvl2/news/TSCA-Lookback-Reporting-due-February-7-2018-Ohio",
    "url": "/news/TSCA-Lookback-Reporting-due-February-7-2018-Ohio",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Public Comment Period for Greenhouse Gas Inventory",
    "apiurl": "/restapi/customnewscontentlvl2/news/Public-Comment-Period-for-Greenhouse-Gas-Inventory",
    "url": "/news/Public-Comment-Period-for-Greenhouse-Gas-Inventory",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Maryland’s Draft Hazardous Substance (CHS) Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Maryland-s-Draft-Hazardous-Substance-(CHS)-Regulations",
    "url": "/news/Maryland-s-Draft-Hazardous-Substance-(CHS)-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NESHAP for Refineries",
    "apiurl": "/restapi/customnewscontentlvl2/news/NESHAP-for-Refineries",
    "url": "/news/NESHAP-for-Refineries",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BWON Annual TAB Reports",
    "apiurl": "/restapi/customnewscontentlvl2/news/BWON-Annual-TAB-Reports",
    "url": "/news/BWON-Annual-TAB-Reports",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD Amended Rule 1156 – Further Reductions of Particulate Emissions from Cement Manufacturing Facilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/SCAQMD-Amended-Rule-1156-Further-Reductions-of-Particulate-Emissions-from-Cement-Manufacturing-Facilities",
    "url": "/news/SCAQMD-Amended-Rule-1156-Further-Reductions-of-Particulate-Emissions-from-Cement-Manufacturing-Facilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Omnibus Air Rules Finalized",
    "apiurl": "/restapi/customnewscontentlvl2/news/Omnibus-Air-Rules-Finalized",
    "url": "/news/Omnibus-Air-Rules-Finalized",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Linn County Air Quality Stakeholders Highlights-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Linn-County-Air-Quality-Stakeholders-Highlights-Iowa",
    "url": "/news/Linn-County-Air-Quality-Stakeholders-Highlights-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Rulemaking to Implement New/Revised NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Rulemaking-to-Implement-New-Revised-NAAQS",
    "url": "/news/Proposed-Rulemaking-to-Implement-New-Revised-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ohio EPA Consolidates Ohio's Ambient Air Quality Standards into OAC 3745-25-02",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ohio-EPA-Consolidates-Ohio's-Ambient-Air-Quality-Standards-into-OAC-3745-25-02",
    "url": "/news/Ohio-EPA-Consolidates-Ohio's-Ambient-Air-Quality-Standards-into-OAC-3745-25-02",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Missouri Hazardous Waste Program Proposing Stakeholder Fee Increase-Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/Missouri-Hazardous-Waste-Program-Proposing-Stakeholder-Fee-Increase-Missouri",
    "url": "/news/Missouri-Hazardous-Waste-Program-Proposing-Stakeholder-Fee-Increase-Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DNR Requests Comments on Draft Greenhouse Gas Emissions Inventory",
    "apiurl": "/restapi/customnewscontentlvl2/news/DNR-Requests-Comments-on-Draft-Greenhouse-Gas-Emissions-Inventory",
    "url": "/news/DNR-Requests-Comments-on-Draft-Greenhouse-Gas-Emissions-Inventory",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cross-State Air Pollution Rule (CSAPR) Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/Cross-State-Air-Pollution-Rule-(CSAPR)-Update",
    "url": "/news/Cross-State-Air-Pollution-Rule-(CSAPR)-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PA DEP Publishes Draft RACT Regulations to Control VOC Emissions from Oil and Gas Industry",
    "apiurl": "/restapi/customnewscontentlvl2/news/pa-dep-publishes-draft-ract-regulations-to-control-voc-emissions-from-oil-and-gas-industry",
    "url": "/news/pa-dep-publishes-draft-ract-regulations-to-control-voc-emissions-from-oil-and-gas-industry",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Training Reminder-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/Training-Reminder-Nebraska",
    "url": "/news/Training-Reminder-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Important Changes in Processing of PSD Permits in Georgia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Important-",
    "url": "/news/Important-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ontario Greenhouse Gas Offset Proposal",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ontario-Greenhouse-Gas-Offset-Proposal",
    "url": "/news/Ontario-Greenhouse-Gas-Offset-Proposal",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Type B Registration Permit on Public Notice",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Type-B-Registration-Permit-on-Public-Notice",
    "url": "/news/New-Type-B-Registration-Permit-on-Public-Notice",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated Version of AERMOD Released in December-Tennessee",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updated-Version-of-AERMOD-Released-in-December-Tennessee",
    "url": "/news/Updated-Version-of-AERMOD-Released-in-December-Tennessee",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Notice of Rule Proposal: Fees for Permits and Certificates for Minor Facilities and Operating Permits, N.J.A.C. 7:27-8.6 and 22.31",
    "apiurl": "/restapi/customnewscontentlvl2/news/Notice-of-Rule-Proposal-Fees-for-Permits-and-Certificates-for-Minor-Facilities-and-Operating-Permits-N-J-A-C-7-27-8-6-and-22-31-",
    "url": "/news/Notice-of-Rule-Proposal-Fees-for-Permits-and-Certificates-for-Minor-Facilities-and-Operating-Permits-N-J-A-C-7-27-8-6-and-22-31-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Release of NMED TSP Repeal Guidance Document-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/Release-of-NMED-TSP-Repeal-Guidance-Document-New-Mexico",
    "url": "/news/Release-of-NMED-TSP-Repeal-Guidance-Document-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Dispersion Modeling Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/air-dispersion-modeling-updates",
    "url": "/news/air-dispersion-modeling-updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Class I Area Impact Analyses – Recent Guidance and Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Class-I-Area-Impact-Analyses-Recent-Guidance-and-Updates",
    "url": "/news/Class-I-Area-Impact-Analyses-Recent-Guidance-and-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDNR Provides Information on 1-Hour NO2 NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDNR-Provides-Information-on-1-Hour-NO2-NAAQS",
    "url": "/news/IDNR-Provides-Information-on-1-Hour-NO2-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Quick Regulatory Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Quick-Regulatory-Updates",
    "url": "/news/Quick-Regulatory-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2014 Emissions Inventories For All Title V Facilities Due April 15",
    "apiurl": "/restapi/customnewscontentlvl2/news/2014-Emissions-Inventories-For-All-Title-V-Facilities-Due-April-15",
    "url": "/news/2014-Emissions-Inventories-For-All-Title-V-Facilities-Due-April-15",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EHS Software Market Experiencing Transformational Shift",
    "apiurl": "/restapi/customnewscontentlvl2/news/EHS-Software-Market-Experiencing-Transformational-Shift",
    "url": "/news/EHS-Software-Market-Experiencing-Transformational-Shift",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Extends Comment Deadline for Proposed Cement Plant Rules-Montana",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Extends-Comment-Deadline-for-Proposed-Cement-Plant-Rules-Montana",
    "url": "/news/EPA-Extends-Comment-Deadline-for-Proposed-Cement-Plant-Rules-Montana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MassDEP 2019 TUR Plan Summary and Report Updated Deadline",
    "apiurl": "/restapi/customnewscontentlvl2/news/massdep-2019-tur-plan-summary-and-report-updated-deadline",
    "url": "/news/massdep-2019-tur-plan-summary-and-report-updated-deadline",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Benzene Fenceline Monitoring for Refineries in Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Benzene-Fenceline-Monitoring-for-Refineries-in-Wyoming",
    "url": "/news/Benzene-Fenceline-Monitoring-for-Refineries-in-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The Latest on the RACT II Rule in Pennsylvania",
    "apiurl": "/restapi/customnewscontentlvl2/news/The-Latest-on-the-RACT-II-Rule-in-Pennsylvania",
    "url": "/news/The-Latest-on-the-RACT-II-Rule-in-Pennsylvania",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New General Permits Available",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-General-Permits-Available",
    "url": "/news/New-General-Permits-Available",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Quality Client Contact and EASY-Air Update (CC) Meetings - November 21, 2019-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Client-Contact-and-EASY-Air-Update-(CC)-Meetings---November-21-2019-Iowa",
    "url": "/news/Air-Quality-Client-Contact-and-EASY-Air-Update-(CC)-Meetings---November-21-2019-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Friendly Reminder - Check Your Fuel-Oil Tickets for Sulfur Content-Vermont",
    "apiurl": "/restapi/customnewscontentlvl2/news/Friendly-Reminder---Check-Your-Fuel-Oil-Tickets-for-Sulfur-Content-Vermont",
    "url": "/news/Friendly-Reminder---Check-Your-Fuel-Oil-Tickets-for-Sulfur-Content-Vermont",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Virtual Public Workshop for BAAQMD Regulation 2: Permits Amendment Concepts",
    "apiurl": "/restapi/customnewscontentlvl2/news/virtual-public-workshop-for-baaqmd-regulation-2-permits-amendment-concepts",
    "url": "/news/virtual-public-workshop-for-baaqmd-regulation-2-permits-amendment-concepts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Virtual Public Workshop for BAAQMD Regulation 2: Permits Amendment Concepts",
    "apiurl": "/restapi/customnewscontentlvl2/news/virtual-public-workshop-for-baaqmd-regulation-2-permits-amendment-concepts",
    "url": "/www.trinityconsultants.com/news/virtual-public-workshop-for-baaqmd-regulation-2-permits-amendment-concepts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revisions to Non-Hazardous Secondary Materials Regulation",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revisions-to-Non-Hazardous-Secondary-Materials-Regulation",
    "url": "/news/Revisions-to-Non-Hazardous-Secondary-Materials-Regulation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Upcoming Reporting Requirements for Illinois Facilities-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Upcoming-Reporting-Requirements-for-Illinois-Facilities-Illinois",
    "url": "/news/Upcoming-Reporting-Requirements-for-Illinois-Facilities-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Upcoming Technical Review Checklists and Subchapter 18 Netting Analysis Tool",
    "apiurl": "/restapi/customnewscontentlvl2/news/Upcoming-Technical-Review-Checklists-and-Subchapter-18-Netting-Analysis-Tool",
    "url": "/news/Upcoming-Technical-Review-Checklists-and-Subchapter-18-Netting-Analysis-Tool",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Wildfire Smoke Information-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Wildfire-Smoke-Information-Wyoming",
    "url": "/news/Wildfire-Smoke-Information-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD Rule Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/SCAQMD-Rule-Updates-",
    "url": "/news/SCAQMD-Rule-Updates-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revisions to State Fuel Burning Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revisions-to-State-Fuel-Burning-Rule",
    "url": "/news/Revisions-to-State-Fuel-Burning-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CEDRI Available to Submit Title V Air Permit Applications and Reports",
    "apiurl": "/restapi/customnewscontentlvl2/news/cedri-available-to-submit-title-v-air-permit-applications-and-reports",
    "url": "/news/cedri-available-to-submit-title-v-air-permit-applications-and-reports",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CEDRI Available to Submit Title V Air Permit Applications and Reports",
    "apiurl": "/restapi/customnewscontentlvl2/news/cedri-available-to-submit-title-v-air-permit-applications-and-reports",
    "url": "/news/state/kentucky/cedri-available-to-submit-title-v-air-permit-applications-and-reports",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Issues Guidance For Timely Permitting of Stationary Engines",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ-Issues-Guidance-For-Timely-Permitting-of-Stationary-Engines",
    "url": "/news/ADEQ-Issues-Guidance-For-Timely-Permitting-of-Stationary-Engines",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NMED Open House & AEIR Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/NMED-Open-House-AEIR-Updates",
    "url": "/news/NMED-Open-House-AEIR-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LMAPCD's Fine Particulate Monitoring Data Invalidated",
    "apiurl": "/restapi/customnewscontentlvl2/news/LMAPCD's-F",
    "url": "/news/LMAPCD's-F",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes to Authority: TCEQ to Administer O&G Water Permitting",
    "apiurl": "/restapi/customnewscontentlvl2/news/changes-to-authority-tceq-to-administer-o-g-water-permitting",
    "url": "/news/changes-to-authority-tceq-to-administer-o-g-water-permitting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE Incident Analyst 1.2 Streamlines Accidental Chemical Release and Consequence Modeling",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-Incident-Analyst-1-2-Streamlines-Accidental-Chemical-Release-and-Consequence-Modeling",
    "url": "/news/BREEZE-Incident-Analyst-1-2-Streamlines-Accidental-Chemical-Release-and-Consequence-Modeling",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Federal GHG Reporting Reminder and Washington GHG Reporting Tool Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/Federal-GHG-Reporting-Reminder-and-Washington-GHG-Reporting-Tool-Update",
    "url": "/news/Federal-GHG-Reporting-Reminder-and-Washington-GHG-Reporting-Tool-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SLEIS is now available in Utah for Air Emissions Inventory Submittals-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/SLEIS-is-now-available-in-Utah-for-Air-Emissions-Inventory-Submittals-Utah",
    "url": "/news/SLEIS-is-now-available-in-Utah-for-Air-Emissions-Inventory-Submittals-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Best of 2020: Corporate Initiatives",
    "apiurl": "/restapi/customnewscontentlvl2/news/best-of-2020-corporate-initiatives",
    "url": "/news/best-of-2020-corporate-initiatives",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NJ DEP Air Quality Program Announces New General Permits",
    "apiurl": "/restapi/customnewscontentlvl2/news/NJ-DEP-Air-Quality-Program-Announces-New-General-Permits",
    "url": "/news/NJ-DEP-Air-Quality-Program-Announces-New-General-Permits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Dakota Oil and Gas Conservation Rules Adopted",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Dakota-Oil-and-Gas-Conservation-Rules-Adopted",
    "url": "/news/South-Dakota-Oil-and-Gas-Conservation-Rules-Adopted",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KDHE Schedules Public Hearings for Sunflower Electric Draft Air Quality Permit",
    "apiurl": "/restapi/customnewscontentlvl2/news/KDHE-Schedules-Public-Hearings-for-Sunflower-Electric-Draft-Air-Quality-Permit",
    "url": "/news/KDHE-Schedules-Public-Hearings-for-Sunflower-Electric-Draft-Air-Quality-Permit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Chemical Data Reporting Updates and Toxic Substance Control Act Reform",
    "apiurl": "/restapi/customnewscontentlvl2/news/Chemical-Data-Reporting-Updates-and-Toxic-Substance-Control-Act-Reform",
    "url": "/news/Chemical-Data-Reporting-Updates-and-Toxic-Substance-Control-Act-Reform",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reporting Deadlines and Information for 2019 Reporting Season-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reporting-Deadlines-and-Information-for-2019-Reporting-Season-Texas",
    "url": "/news/Reporting-Deadlines-and-Information-for-2019-Reporting-Season-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ News:  Dispersion Modeling Situation to Heat Up",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ-News-Dispersion-Modeling-Situation-to-Heat-Up",
    "url": "/news/ADEQ-News-Dispersion-Modeling-Situation-to-Heat-Up",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "RCRA E-Manifest Workshop-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/RCRA-E-Manifest-Workshop-Iowa",
    "url": "/news/RCRA-E-Manifest-Workshop-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Coast Air Quality Management District -- Control of Toxic Air Contaminants from Existing Sources (Rule 1402)",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Coast-Air-Quality-Management-District----Control-of-Toxic-Air-Contaminants-from-Existing-Sources-(Rule-1402)",
    "url": "/news/South-Coast-Air-Quality-Management-District----Control-of-Toxic-Air-Contaminants-from-Existing-Sources-(Rule-1402)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Canadian Fuel Regulations - Regulatory Reporting and Guidance",
    "apiurl": "/restapi/customnewscontentlvl2/news/canadian-fuel-regulations---regulatory-reporting-and-guidance-",
    "url": "/news/canadian-fuel-regulations---regulatory-reporting-and-guidance-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Virginia DEQ issues first Greenhouse Gas PSD Permit",
    "apiurl": "/restapi/customnewscontentlvl2/news/Virginia-DEQ-issues-first-Greenhouse-Gas-PSD-Permit",
    "url": "/news/Virginia-DEQ-issues-first-Greenhouse-Gas-PSD-Permit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Attainment Redesignation Approved by EPA for Lemont and Pekin Areas",
    "apiurl": "/restapi/customnewscontentlvl2/news/attainment-redesignation-approved-by-epa-for-lemont-and-pekin-areas",
    "url": "/news/attainment-redesignation-approved-by-epa-for-lemont-and-pekin-areas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Wyoming Air Quality Advisory Board Meeting Jul 15: SO2 Annual Report-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Wyoming-Air-Quality-Advisory-Board-Meeting-Jul-15-SO2-Annual-Report-Wyoming",
    "url": "/news/Wyoming-Air-Quality-Advisory-Board-Meeting-Jul-15-SO2-Annual-Report-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Bexar County RY2017 EI Revision Notice-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Bexar-County-RY2017-EI-Revision-Notice-Texas",
    "url": "/news/Bexar-County-RY2017-EI-Revision-Notice-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Senate Bill 1672 (SB1672) – State of Illinois PSD Permitting Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/Senate-Bill-1672-(SB1672)-State-of-Illinois-PSD-Permitting-Rules",
    "url": "/news/Senate-Bill-1672-(SB1672)-State-of-Illinois-PSD-Permitting-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Hofmann Named Ernst & Young Entrepreneur of the Year 2009 Finalist",
    "apiurl": "/restapi/customnewscontentlvl2/news/Hofmann-Named-Ernst-Young-Entrepreneur-of-the-Year-2009-Finalist",
    "url": "/news/Hofmann-Named-Ernst-Young-Entrepreneur-of-the-Year-2009-Finalist",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Electronic Reporting and Recordkeeping Requirements for New Source Performance Standards",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Electronic-Reporting-and-Recordkeeping-Requirements-for-New-Source-Performance-Standards",
    "url": "/news/Proposed-Electronic-Reporting-and-Recordkeeping-Requirements-for-New-Source-Performance-Standards",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NCDAQ Requiring Boiler MACT Applications",
    "apiurl": "/restapi/customnewscontentlvl2/news/NCDAQ-Requiring-Boiler-MACT-Applications",
    "url": "/news/NCDAQ-Requiring-Boiler-MACT-Applications",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MCAQD Relaxes New Minor NSR Modification Thresholds",
    "apiurl": "/restapi/customnewscontentlvl2/news/MCAQD-Relaxes-New-Minor-NSR-Modification-Thresholds",
    "url": "/news/MCAQD-Relaxes-New-Minor-NSR-Modification-Thresholds",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Additional CEDRI Updates for Certain NSPS & NESHAP Reporting Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/additional-cedri-updates-for-certain-nsps-neshap-reporting-requirements-",
    "url": "/news/additional-cedri-updates-for-certain-nsps-neshap-reporting-requirements-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Additional CEDRI Updates for Certain NSPS & NESHAP Reporting Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/additional-cedri-updates-for-certain-nsps-neshap-reporting-requirements-",
    "url": "/federal/additional-cedri-updates-for-certain-nsps-and-neshap-reporting-requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CSAPR Update May Reduce Ozone Season Emissions Budgets for EGUs",
    "apiurl": "/restapi/customnewscontentlvl2/news/csapr-update-may-reduce-ozone-season-emissions-budgets-for-egus",
    "url": "/news/csapr-update-may-reduce-ozone-season-emissions-budgets-for-egus",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Benefits of Comprehensive EHS Risk Management",
    "apiurl": "/restapi/customnewscontentlvl2/news/benefits-of-comprehensive-ehs-risk-management",
    "url": "/news/benefits-of-comprehensive-ehs-risk-management",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Benefits of Comprehensive EHS Risk Management",
    "apiurl": "/restapi/customnewscontentlvl2/news/benefits-of-comprehensive-ehs-risk-management",
    "url": "/news/ehs-management/benefits-of-comprehensive-ehs-risk-management",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MassDEP Proposes Amendments to 310 CMR 7.00 Air Pollution Control-Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/MassDEP-Proposes-Amendments-to-310-CMR-7-00-Air-Pollution-Control-Massachusetts",
    "url": "/news/MassDEP-Proposes-Amendments-to-310-CMR-7-00-Air-Pollution-Control-Massachusetts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Finalizes Approval of New York's SIP for PM2.5 NSR Requirements and Greenhouse Gases under PSD and Title V Programs",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Finalizes-Approval-of-New-York's-SIP-for-PM2-5-NSR-Requirements-and-Greenhouse-Gases-under-PSD-and-Title-V-Programs",
    "url": "/news/EPA-Finalizes-Approval-of-New-York's-SIP-for-PM2-5-NSR-Requirements-and-Greenhouse-Gases-under-PSD-and-Title-V-Programs",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2016 Monitoring Network Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/2016-Monitoring-Network-Plan",
    "url": "/news/2016-Monitoring-Network-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Modeling Tip: How to Add a New Chemical Mixture in BREEZE Incident Analyst",
    "apiurl": "/restapi/customnewscontentlvl2/news/Modeling-Tip-How-to-Add-a-New-Chemical-Mixture-in-BREEZE-Incident-Analyst",
    "url": "/news/Modeling-Tip-How-to-Add-a-New-Chemical-Mixture-in-BREEZE-Incident-Analyst",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "November 2012 AWMA Meeting hosted by the IDNR",
    "apiurl": "/restapi/customnewscontentlvl2/news/November-2012-AWMA-Meeting-hosted-by-the-IDNR",
    "url": "/news/November-2012-AWMA-Meeting-hosted-by-the-IDNR",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Stricter Emission Limits for Metal Melting and Heating Furnaces in Southern California",
    "apiurl": "/restapi/customnewscontentlvl2/news/stricter-emission-limits-for-metal-melting-and-heating-furnaces-in-southern-california",
    "url": "/news/stricter-emission-limits-for-metal-melting-and-heating-furnaces-in-southern-california",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Stricter Emission Limits for Metal Melting and Heating Furnaces in Southern California",
    "apiurl": "/restapi/customnewscontentlvl2/news/stricter-emission-limits-for-metal-melting-and-heating-furnaces-in-southern-california",
    "url": "/news/scaqmd-plans-to-set-stricter-emission-limits-for-metal-melting-and-heating-furnaces-in-southern-california",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oklahoma Air Quality Advisory Council Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oklahoma-Air-Quality-Advisory-Council-Meeting",
    "url": "/news/Oklahoma-Air-Quality-Advisory-Council-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA Finalizes Changes to Air Quality Modeling Guidance-Washington",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-Finalizes-Changes-to-Air-Quality-Modeling-Guidance-Washington",
    "url": "/news/USEPA-Finalizes-Changes-to-Air-Quality-Modeling-Guidance-Washington",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Virginia DEQ COVID-19 Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/virginia-deq-covid-19-updates-",
    "url": "/news/virginia-deq-covid-19-updates-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Virginia DEQ COVID-19 Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/virginia-deq-covid-19-updates-",
    "url": "/states/virginia/virginia-deq-covid-19-updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Energy Assessment Requirements under the Boiler MACT",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Energy-Assessment-Requirements-under-the-Boiler-MACT",
    "url": "/news/New-Energy-Assessment-Requirements-under-the-Boiler-MACT",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DEQ Plans Rule Updates to Accommodate Supreme Court Decision on GHGs",
    "apiurl": "/restapi/customnewscontentlvl2/news/DEQ-Plans-Rule-Updates-to-Accommodate-Supreme-Court-Decision-on-GHGs",
    "url": "/news/DEQ-Plans-Rule-Updates-to-Accommodate-Supreme-Court-Decision-on-GHGs",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NYSDEC Adopts Part 222 – Distributed Generation Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/NYSDEC-Adopts-Part-222-Distributed-Generation-Sources",
    "url": "/news/NYSDEC-Adopts-Part-222-Distributed-Generation-Sources",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Kansas Multi-Media Tip of the Month-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Kansas-Multi-Media-Tip-of-the-Month-Kansas",
    "url": "/news/Kansas-Multi-Media-Tip-of-the-Month-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDNR Website Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDNR-Website-Update",
    "url": "/news/IDNR-Website-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The Fees You Pay to the Kentucky Division for Air Quality Are Going to Change-Kentucky",
    "apiurl": "/restapi/customnewscontentlvl2/news/The-Fees-You-Pay-to-the-Kentucky-Division-for-Air-Quality-Are-Going-to-Change-Kentucky",
    "url": "/news/The-Fees-You-Pay-to-the-Kentucky-Division-for-Air-Quality-Are-Going-to-Change-Kentucky",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "REMINDER - Emission Inventory Questionnaire (EIQ) Rule Change Comment Deadline",
    "apiurl": "/restapi/customnewscontentlvl2/news/REMINDER---Emission-Inventory-Questionnaire-(EIQ)-Rule-Change-Comment-Deadline-",
    "url": "/news/REMINDER---Emission-Inventory-Questionnaire-(EIQ)-Rule-Change-Comment-Deadline-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "COVID-19 Impacts on Arizona Air Quality Agency Operations",
    "apiurl": "/restapi/customnewscontentlvl2/news/COVID-19-Impacts-on-Arizona-Air-Quality-Agency-Operations",
    "url": "/news/COVID-19-Impacts-on-Arizona-Air-Quality-Agency-Operations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "COVID-19 Impacts on Arizona Air Quality Agency Operations",
    "apiurl": "/restapi/customnewscontentlvl2/news/COVID-19-Impacts-on-Arizona-Air-Quality-Agency-Operations",
    "url": "/states/arizona/covid-19-impacts-on-arizona-air-quality-agency-operations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Forms are Required for Permit Applications",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Forms-are-Required-for-Permit-Applications-",
    "url": "/news/New-Forms-are-Required-for-Permit-Applications-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Outlook on Kansas Air Regulatory Agenda-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Outlook-on-Kansas-Air-Regulatory-Agenda-Kansas",
    "url": "/news/Outlook-on-Kansas-Air-Regulatory-Agenda-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes New Air Quality Rules for the Oil & Natural Gas Industry-West Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-New-Air-Quality-Rules-for-the-Oil-Natural-Gas-Industry-West-Virginia",
    "url": "/news/EPA-Proposes-New-Air-Quality-Rules-for-the-Oil-Natural-Gas-Industry-West-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Title V Emission Fees-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Title-V-Emission-Fees-Iowa",
    "url": "/news/Title-V-Emission-Fees-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Participation at 12th Annual Kentucky Environmental Permitting and Reporting Conference",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Pa",
    "url": "/news/Trinity-Pa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes to 30 TAC Chapter 117 NOx RACT Rules Finalized",
    "apiurl": "/restapi/customnewscontentlvl2/news/Changes-to-30-TAC-Chapter-117-NOx-RACT-Rules-Finalized",
    "url": "/news/Changes-to-30-TAC-Chapter-117-NOx-RACT-Rules-Finalized",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Tanks and Loading Increases RAP",
    "apiurl": "/restapi/customnewscontentlvl2/news/tanks-and-loading-increases-rap",
    "url": "/news/tanks-and-loading-increases-rap",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Solid Waste  Definition Proposed",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Solid-Waste-Definition-Proposed",
    "url": "/news/New-Solid-Waste-Definition-Proposed",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Potential Chemical Additions to Proposition 65",
    "apiurl": "/restapi/customnewscontentlvl2/news/Potential-Chemical-Additions-to-Proposition-65",
    "url": "/news/Potential-Chemical-Additions-to-Proposition-65",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Utility MACT",
    "apiurl": "/restapi/customnewscontentlvl2/news/Utility-MACT",
    "url": "/news/Utility-MACT",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2014 Ozone Data Available",
    "apiurl": "/restapi/customnewscontentlvl2/news/2014-Ozone-Data-Available",
    "url": "/news/2014-Ozone-Data-Available",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Pennsylvania Department of Environmental Protection Issues Revisions to General Permit No. 5-Pennsylvania",
    "apiurl": "/restapi/customnewscontentlvl2/news/Pennsylvania-Department-of-Environmental-Protection-Issues-Revisions-to-General-Permit-No-5-Pennsylvania",
    "url": "/news/Pennsylvania-Department-of-Environmental-Protection-Issues-Revisions-to-General-Permit-No-5-Pennsylvania",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA \"Final\" Actions on Oklahoma and Texas Regional Haze Plans",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Final-Actions-on-Oklahoma-and-Texas-Regional-Haze-Plans",
    "url": "/news/EPA-Final-Actions-on-Oklahoma-and-Texas-Regional-Haze-Plans",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "OSHA Announces Controversial Final Rule for Online Releasing of OSHA Injury/Illness Data",
    "apiurl": "/restapi/customnewscontentlvl2/news/OSHA-Announces-Controversial-Final-Rule-for-Online-Releasing-of-OSHA-Injury-Illness-Data",
    "url": "/news/OSHA-Announces-Controversial-Final-Rule-for-Online-Releasing-of-OSHA-Injury-Illness-Data",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ozone NAAQS Revision Proposed",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ozone-NAAQS-Revision-Proposed",
    "url": "/news/Ozone-NAAQS-Revision-Proposed",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Clark County DAQ Launches \"List Server\" Feature-Nevada",
    "apiurl": "/restapi/customnewscontentlvl2/news/Clark-County-DAQ-Launches-List-Server-Feature-Nevada",
    "url": "/news/Clark-County-DAQ-Launches-List-Server-Feature-Nevada",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "California Supreme Court Provides Disruptive CEQA Interpretation",
    "apiurl": "/restapi/customnewscontentlvl2/news/California-Supreme-Court-Provides-Disruptive-CEQA-Interpretation",
    "url": "/news/California-Supreme-Court-Provides-Disruptive-CEQA-Interpretation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Wyoming Confirms Emissions Do Not Contribute to Ozone Nonattainment in Other States-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Wyoming-Confirms-Emissions-Do-Not-Contribute-to-Ozone-Nonattainment-in-Other-States-Wyoming",
    "url": "/news/Wyoming-Confirms-Emissions-Do-Not-Contribute-to-Ozone-Nonattainment-in-Other-States-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Regulations Can Affect Your GHG Monitoring and Reporting",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Regulations-Can-Affect-Your-GHG-Monitoring-and-Reporting",
    "url": "/news/New-Regulations-Can-Affect-Your-GHG-Monitoring-and-Reporting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to the Toxics Reporting Inventory (TRI) Reporting Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-to-the-Toxics-Reporting-Inventory-(TRI)-Reporting-Requirements",
    "url": "/news/Updates-to-the-Toxics-Reporting-Inventory-(TRI)-Reporting-Requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "VOC Limits for Consumer Products",
    "apiurl": "/restapi/customnewscontentlvl2/news/VOC-Limits-for-Consumer-Products",
    "url": "/news/VOC-Limits-for-Consumer-Products",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Maine DEP Proposes Repeal of Existing Bleach Plant Chlorine and Chlorine Dioxide Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Maine-DEP-Proposes-Repeal-of-Existing-Bleach-Plant-Chlorine-and-Chlorine-Dioxide-Rule",
    "url": "/news/Maine-DEP-Proposes-Repeal-of-Existing-Bleach-Plant-Chlorine-and-Chlorine-Dioxide-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reporting Reminders-Minnesota",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reporting-Reminders-Minnesota",
    "url": "/news/Reporting-Reminders-Minnesota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to the Toxics Reporting Inventory (TRI) Reporting Requirements-Ohio",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-to-the-Toxics-Reporting-Inventory-(TRI)-Reporting-Requirements-Ohio",
    "url": "/news/Updates-to-the-Toxics-Reporting-Inventory-(TRI)-Reporting-Requirements-Ohio",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Are you ready? New VOC Control Technique Guidelines/RACT for VOCs emitted by surface coating processes.",
    "apiurl": "/restapi/customnewscontentlvl2/news/Are-you-ready-New-VOC-Control-Technique-Guidelines-RACT-for-VOCs-emitted-by-surface-coating-processes-",
    "url": "/news/Are-you-ready-New-VOC-Control-Technique-Guidelines-RACT-for-VOCs-emitted-by-surface-coating-processes-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "AMA Petition for ADEQ Rulemaking",
    "apiurl": "/restapi/customnewscontentlvl2/news/AMA-Petition-for-ADEQ-Rulemaking",
    "url": "/news/AMA-Petition-for-ADEQ-Rulemaking",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Delaware's Regulations Governing Hazardous Waste",
    "apiurl": "/restapi/customnewscontentlvl2/news/delawares-regulations-governing-hazardous-waste",
    "url": "/news/delawares-regulations-governing-hazardous-waste",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Delaware's Regulations Governing Hazardous Waste",
    "apiurl": "/restapi/customnewscontentlvl2/news/delawares-regulations-governing-hazardous-waste",
    "url": "/news/state/delaware/delawares-regulations-governing-hazardous-waste",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MPCA Intends to Adopt Proposed Exempt Source and Conditionally Insignificant Activities Rulemaking Updates without Public Hearing-Minnesota",
    "apiurl": "/restapi/customnewscontentlvl2/news/MPCA-Intends-to-Adopt-Proposed-Exempt-Source-and-Conditionally-Insignificant-Activities-Rulemaking-Updates-without-Public-Hearing-Minnesota",
    "url": "/news/MPCA-Intends-to-Adopt-Proposed-Exempt-Source-and-Conditionally-Insignificant-Activities-Rulemaking-Updates-without-Public-Hearing-Minnesota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Recent VOC RACT Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Recent-VOC-RACT-Updates-",
    "url": "/news/Recent-VOC-RACT-Updates-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEQ Proposed Changes to Title 129",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEQ-Proposed-Changes-to-Title-129",
    "url": "/news/NDEQ-Proposed-Changes-to-Title-129",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cap-and-Trade May 2017 Joint-Auction Results Released-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/Cap-and-Trade-May-2017-Joint-Auction-Results-Released-California",
    "url": "/news/Cap-and-Trade-May-2017-Joint-Auction-Results-Released-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DHEC Makes Recommendations to Amend or Repeal 25 Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/DHEC-Makes-Recommendations-to-Amend-or-Repeal-25-Regulations",
    "url": "/news/DHEC-Makes-Recommendations-to-Amend-or-Repeal-25-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Georgia Toxics Guidelines-Georgia",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Georgia-Toxics-Guidelines-Georgia",
    "url": "/news/New-Georgia-Toxics-Guidelines-Georgia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Recently Proposed OAC Changes",
    "apiurl": "/restapi/customnewscontentlvl2/news/recently-proposed-oac-changes",
    "url": "/news/recently-proposed-oac-changes",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Carolina's Recommendations on Ozone Nonattainment Boundaries for the 2008 8-hour Ozone Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Carolina's-Recommendations-on-Ozone-Nonattainment-Boundaries-for-the-2008-8-hour-Ozone-Standard",
    "url": "/news/South-Carolina's-Recommendations-on-Ozone-Nonattainment-Boundaries-for-the-2008-8-hour-Ozone-Standard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "REMINDER: Boiler MACT Initial Notification of Compliance Status",
    "apiurl": "/restapi/customnewscontentlvl2/news/REMINDER-Boiler-MACT-Initial-Notification-of-Compliance-Status",
    "url": "/news/REMINDER-Boiler-MACT-Initial-Notification-of-Compliance-Status",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Coast AQMD Proposed Rule 1153.1",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Coast-AQMD-Proposed-Rule-1153-1",
    "url": "/news/South-Coast-AQMD-Proposed-Rule-1153-1",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GHG Reporting for Oil & Natural Gas Nearly Finalized",
    "apiurl": "/restapi/customnewscontentlvl2/news/GHG-Reporting-for-Oil-Natural-Gas-Nearly-Finalized",
    "url": "/news/GHG-Reporting-for-Oil-Natural-Gas-Nearly-Finalized",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DDOE Finalizes Changes to Air Permitting Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/DDOE-Finalizes-Changes-to-Air-Permitting-Program",
    "url": "/news/DDOE-Finalizes-Changes-to-Air-Permitting-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Finalizes Mandatory Reporting of Greenhouse Gases Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Finalizes-Mandatory-Reporting-of-Greenhouse-Gases-Rule",
    "url": "/news/EPA-Finalizes-Mandatory-Reporting-of-Greenhouse-Gases-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Leak Detection Using FLIR Camera",
    "apiurl": "/restapi/customnewscontentlvl2/news/Leak-Detection-Using-FLIR-Camera",
    "url": "/news/Leak-Detection-Using-FLIR-Camera",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Gasoline MACT",
    "apiurl": "/restapi/customnewscontentlvl2/news/Gasoline-MACT",
    "url": "/news/Gasoline-MACT",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Air Quality Publications Available",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Air-Quality-Publications-Available",
    "url": "/news/New-Air-Quality-Publications-Available",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GA EPD Clarifies Position on Submitting Title V Renewal Applications",
    "apiurl": "/restapi/customnewscontentlvl2/news/GA-EPD-Cla",
    "url": "/news/GA-EPD-Cla",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Revisions to Illinois Air Quality Standards (35 IAC Part 243)",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Revisions-to-Illinois-Air-Quality-Standards-(35-IAC-Part-243)",
    "url": "/news/Proposed-Revisions-to-Illinois-Air-Quality-Standards-(35-IAC-Part-243)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Higher Permitting Fees-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Higher-Permitting-Fees-Colorado",
    "url": "/news/Higher-Permitting-Fees-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MassCAIR Facilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/MassCAIR-Facilities-",
    "url": "/news/MassCAIR-Facilities-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Algal Bloom Impacts in Wyoming Waters-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Algal-Bloom-Impacts-in-Wyoming-Waters-Wyoming",
    "url": "/news/Algal-Bloom-Impacts-in-Wyoming-Waters-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDNR EASY Air is Live-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDNR-EASY-Air-is-Live-Iowa",
    "url": "/news/IDNR-EASY-Air-is-Live-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments to Env-A 1200 Volatile Organic Compounds (VOCs) Reasonably Available Control Technology (RACT)-New Hampshire",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendments-to-Env-A-1200-Volatile-Organic-Compounds-(VOCs)-Reasonably-Available-Control-Technology-(RACT)-New-Hampshire",
    "url": "/news/Proposed-Amendments-to-Env-A-1200-Volatile-Organic-Compounds-(VOCs)-Reasonably-Available-Control-Technology-(RACT)-New-Hampshire",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Promulgates New Short-Term NO2 NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Promul",
    "url": "/news/EPA-Promul",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revised New Effluent Limits for Steam Electric Plants",
    "apiurl": "/restapi/customnewscontentlvl2/news/revised-new-effluent-limits-for-steam-electric-plants",
    "url": "/news/revised-new-effluent-limits-for-steam-electric-plants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revised New Effluent Limits for Steam Electric Plants",
    "apiurl": "/restapi/customnewscontentlvl2/news/revised-new-effluent-limits-for-steam-electric-plants",
    "url": "/news/federal/revised-new-effluent-limits-for-steam-electric-plants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Water and Waste Advisory Board October 18th Meeting-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Water-and-Waste-Advisory-Board-October-18th-Meeting-Wyoming",
    "url": "/news/Water-and-Waste-Advisory-Board-October-18th-Meeting-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Friendly Reminder - Check Your Fuel-Oil Tickets for Sulfur Content-Rhode Island",
    "apiurl": "/restapi/customnewscontentlvl2/news/Friendly-Reminder---Check-Your-Fuel-Oil-Tickets-for-Sulfur-Content-Rhode-Island",
    "url": "/news/Friendly-Reminder---Check-Your-Fuel-Oil-Tickets-for-Sulfur-Content-Rhode-Island",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Project Spotlight: KPUD Renewable Natural Gas Project",
    "apiurl": "/restapi/customnewscontentlvl2/news/project-spotlight-kpud-renewable-natural-gas-project",
    "url": "/news/project-spotlight-kpud-renewable-natural-gas-project",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ohio EPA Extends Comment Period on PSD/Title V GHG Tailoring Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ohio-EPA-Extends-Comment-Period-on-PSD-Title-V-GHG-Tailoring-Rule",
    "url": "/news/Ohio-EPA-Extends-Comment-Period-on-PSD-Title-V-GHG-Tailoring-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Midwest Environmental Compliance Conference April 11-12, 2018-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Midwest-Environmental-Compliance-Conference-April-11-12-2018-Kansas",
    "url": "/news/Midwest-Environmental-Compliance-Conference-April-11-12-2018-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "RICE MACT Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/RICE-MACT-Update",
    "url": "/news/RICE-MACT-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ohio EPA Announces STREAMS for Water Permitting and Reporting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ohio-EPA-Announces-STREAMS-for-Water-Permitting-and-Reporting",
    "url": "/news/Ohio-EPA-Announces-STREAMS-for-Water-Permitting-and-Reporting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes to State Operation Permit Terms",
    "apiurl": "/restapi/customnewscontentlvl2/news/Changes-to-State-Operation-Permit-Terms",
    "url": "/news/Changes-to-State-Operation-Permit-Terms",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "States Propose Attainment Designations for the New 1-Hour SO2 NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/States-Propose-Attainment-Designations-for-the-New-1-Hour-SO2-NAAQS-",
    "url": "/news/States-Propose-Attainment-Designations-for-the-New-1-Hour-SO2-NAAQS-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA Proposes Limited Approval and Disapproval of the Bay Area AQMD's Revisions to New Source Review Regulation",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-Proposes-Limited-Approval-and-Disapproval-of-the-Bay-Area-AQMD's-Revisions-to-New-Source-Review-Regulation",
    "url": "/news/USEPA-Proposes-Limited-Approval-and-Disapproval-of-the-Bay-Area-AQMD's-Revisions-to-New-Source-Review-Regulation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes to Disapprove SIP Revision for Clark County's Affirmative Defense Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-to-Disapprove-SIP-Revision-for-Clark-County's-Affirmative-Defense-Rule",
    "url": "/news/EPA-Proposes-to-Disapprove-SIP-Revision-for-Clark-County's-Affirmative-Defense-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oregon DEQ Releases Clean Air Oregon Prioritization Results-Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oregon-DEQ-Releases-Clean-Air-Oregon-Prioritization-Results-Oregon",
    "url": "/news/Oregon-DEQ-Releases-Clean-Air-Oregon-Prioritization-Results-Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE VExDAM and DEGADIS Software Selected for DoE's Idaho Cleanup Project",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-VExDAM-and-DEGADIS-Software-Selected-for-DoE's-Idaho-Cleanup-Project",
    "url": "/news/BREEZE-VExDAM-and-DEGADIS-Software-Selected-for-DoE's-Idaho-Cleanup-Project",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Superfund in Wyoming-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Superfund-in-Wyoming-Wyoming",
    "url": "/news/Superfund-in-Wyoming-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Georgia Environmental Online System is Coming Soon",
    "apiurl": "/restapi/customnewscontentlvl2/news/Georgia-En",
    "url": "/news/Georgia-En",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Environmental Justice Implications for Air Permitting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Environmental-Justice-Implications-for-Air-Permitting",
    "url": "/news/Environmental-Justice-Implications-for-Air-Permitting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Partners with Carbon Disclosure Project (CDP)",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Partners-with-Carbon-Disclosure-Project-(CDP)",
    "url": "/news/Trinity-Consultants-Partners-with-Carbon-Disclosure-Project-(CDP)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Issues Final Area Designations for the 2008 NAAQS-Tennessee",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Issues-Final-Area-Designations-for-the-2008-NAAQS-Tennessee",
    "url": "/news/EPA-Issues-Final-Area-Designations-for-the-2008-NAAQS-Tennessee",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "San Antonio (Bexar County) is Designated a Nonattainment Area for Ozone-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/San-Antonio-(Bexar-County)-is-Designated-a-Nonattainment-Area-for-Ozone-Texas",
    "url": "/news/San-Antonio-(Bexar-County)-is-Designated-a-Nonattainment-Area-for-Ozone-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA Alternative Test Method (ALT Method 082) – Opacity Camera",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-Alternative-Test-Method-(ALT-Method-082)-Opacity-Camera",
    "url": "/news/USEPA-Alternative-Test-Method-(ALT-Method-082)-Opacity-Camera",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The Changing Landscape for Waste Generators",
    "apiurl": "/restapi/customnewscontentlvl2/news/The-Changing-Landscape-for-Waste-Generators",
    "url": "/news/The-Changing-Landscape-for-Waste-Generators",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cap-and-Trade November 2013 Auction Results Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/Cap-and-Trade-November-2013-Auction-Results-Released",
    "url": "/news/Cap-and-Trade-November-2013-Auction-Results-Released",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Rule Approves Revisions to the Illinois State Implementation Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-Rule-Approves-Revisions-to-the-Illinois-State-Implementation-Plan",
    "url": "/news/Final-Rule-Approves-Revisions-to-the-Illinois-State-Implementation-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Denver/Front Range Ozone Update-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Denver-Front-Range-Ozone-Update-Colorado",
    "url": "/news/Denver-Front-Range-Ozone-Update-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Seeks Comment on Proposed National Enforcement Priorities for 2011-2013",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Seeks-Comment-on-Proposed-National-Enforcement-Priorities-for-2011-2013",
    "url": "/news/EPA-Seeks-Comment-on-Proposed-National-Enforcement-Priorities-for-2011-2013",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Polk County Air Pollution Amendments-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Polk-County-Air-Pollution-Amendments-Iowa",
    "url": "/news/Polk-County-Air-Pollution-Amendments-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Kansas Tip of the Month – Training Reminder-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Kansas-Tip-of-the-Month-Training-Reminder-Kansas",
    "url": "/news/Kansas-Tip-of-the-Month-Training-Reminder-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Mexico Environment Department Once Again Makes Updates to GCP-O&G Registration Forms-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Mexico-Environment-Department-Once-Again-Makes-Updates-to-GCP-O-G-Registration-Forms-New-Mexico",
    "url": "/news/New-Mexico-Environment-Department-Once-Again-Makes-Updates-to-GCP-O-G-Registration-Forms-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated O&M Plans-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updated-O-M-Plans-Colorado",
    "url": "/news/Updated-O-M-Plans-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NMED Adds Non-Discrimination Language to the Public Notice",
    "apiurl": "/restapi/customnewscontentlvl2/news/NMED-Adds-Non-Discrimination-Language-to-the-Public-Notice",
    "url": "/news/NMED-Adds-Non-Discrimination-Language-to-the-Public-Notice",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Notice of Intended Action - Chapter 9A: Environmental Services Division Rules - Compliance and Enforcement Procedures",
    "apiurl": "/restapi/customnewscontentlvl2/news/Notice-of-Intended-Action---Chapter-9A-Environmental-Services-Division-Rules---Compliance-and-Enforcement-Procedures",
    "url": "/news/Notice-of-Intended-Action---Chapter-9A-Environmental-Services-Division-Rules---Compliance-and-Enforcement-Procedures",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Stationary Diesel Fired Emergency Engine Environmental Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/Stationary-Diesel-Fired-Emergency-Engine-Environmental-Update",
    "url": "/news/Stationary-Diesel-Fired-Emergency-Engine-Environmental-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "HB 4181: Update to Applicable Requirements for New Source Review and Operating Permits-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/HB-4181-Update-to-Applicable-Requirements-for-New-Source-Review-and-Operating-Permits-Texas",
    "url": "/news/HB-4181-Update-to-Applicable-Requirements-for-New-Source-Review-and-Operating-Permits-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "National Pollutant Release Inventory (NPRI) & Toxic Reduction Act (TRA) Reminder-Ontario",
    "apiurl": "/restapi/customnewscontentlvl2/news/National-Pollutant-Release-Inventory-(NPRI)-Toxic-Reduction-Act-(TRA)-Reminder-Ontario",
    "url": "/news/National-Pollutant-Release-Inventory-(NPRI)-Toxic-Reduction-Act-(TRA)-Reminder-Ontario",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Informal Comments on Asbestos Fee Clarification Rulemaking Proposal",
    "apiurl": "/restapi/customnewscontentlvl2/news/Informal-Comments-on-Asbestos-Fee-Clarification-Rulemaking-Proposal",
    "url": "/news/Informal-Comments-on-Asbestos-Fee-Clarification-Rulemaking-Proposal",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Recently Acquires TGB Partnership",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Recently-Acquires-TGB-Partnership",
    "url": "/news/Trinity-Consultants-Recently-Acquires-TGB-Partnership",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Amendment Concepts for BAAQMD Regulation 2: Permits",
    "apiurl": "/restapi/customnewscontentlvl2/news/amendment-concepts-for-baaqmd-regulation-2-permits",
    "url": "/news/amendment-concepts-for-baaqmd-regulation-2-permits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Amendment Concepts for BAAQMD Regulation 2: Permits",
    "apiurl": "/restapi/customnewscontentlvl2/news/amendment-concepts-for-baaqmd-regulation-2-permits",
    "url": "/www.trinityconsultants.com/news/amendment-concepts-for-baaqmd-regulation-2-permits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADVENT Engineering Services Joins Trinity Consultants",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADVENT-Engineering-Services-Joins-Trinity-Consultants-",
    "url": "/news/ADVENT-Engineering-Services-Joins-Trinity-Consultants-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDNR Weighs in on New Sulfur Dioxide Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDNR-Weighs-in-on-New-Sulfur-Dioxide-Standard",
    "url": "/news/MDNR-Weighs-in-on-New-Sulfur-Dioxide-Standard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ozone Attainment Status of Lawrenceburg Township in Dearborn County, Indiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ozone-Attainment-Status-of-Lawrenceburg-Township-in-Dearborn-County-Indiana",
    "url": "/news/Ozone-Attainment-Status-of-Lawrenceburg-Township-in-Dearborn-County-Indiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Recent Amendments to K.A.R 28-19-11, K.A.R 28-19-300 and K.A.R 28-19-304 on November 18, 2016",
    "apiurl": "/restapi/customnewscontentlvl2/news/Recent-Amendments-to-K-A-R-28-19-11-K-A-R-28-19-300-and-K-A-R-28-19-304-on-November-18-2016",
    "url": "/news/Recent-Amendments-to-K-A-R-28-19-11-K-A-R-28-19-300-and-K-A-R-28-19-304-on-November-18-2016",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Substantive Changes to Water Quality Trading Proposed Rule-Louisiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/Substantive-Changes-to-Water-Quality-Trading-Proposed-Rule-Louisiana",
    "url": "/news/Substantive-Changes-to-Water-Quality-Trading-Proposed-Rule-Louisiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA’s Clean Power Plan - A Diet for US Fossil Fuel Usage",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-s-Clean-Power-Plan---A-Diet-for-US-Fossil-Fuel-Usage",
    "url": "/news/EPA-s-Clean-Power-Plan---A-Diet-for-US-Fossil-Fuel-Usage",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Town Hall Meeting Announced to Discuss Proposed Regulatory Amendments to CO2 Trading-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Town-Hall-Meeting-Announced-to-Discuss-Proposed-Regulatory-Amendments-to-CO2-Trading-Virginia",
    "url": "/news/Town-Hall-Meeting-Announced-to-Discuss-Proposed-Regulatory-Amendments-to-CO2-Trading-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Chemical Reporting and Compliance Basics: Many Changes to Manage",
    "apiurl": "/restapi/customnewscontentlvl2/news/chemical-reporting-and-compliance-basics-many-changes-to-manage",
    "url": "/news/chemical-reporting-and-compliance-basics-many-changes-to-manage",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Chemical Reporting and Compliance Basics: Many Changes to Manage",
    "apiurl": "/restapi/customnewscontentlvl2/news/chemical-reporting-and-compliance-basics-many-changes-to-manage",
    "url": "/news/federal/chemical-reporting-and-compliance-basics-many-changes-to-manage",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "When Odor and Noise are a Nuisance-New Jersey",
    "apiurl": "/restapi/customnewscontentlvl2/news/When-Odor-and-Noise-are-a-Nuisance-New-Jersey",
    "url": "/news/When-Odor-and-Noise-are-a-Nuisance-New-Jersey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Ethylene Oxide Ambient Monitoring-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Ethylene-Oxide-Ambient-Monitoring-Illinois",
    "url": "/news/Proposed-Ethylene-Oxide-Ambient-Monitoring-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Approves Massachusetts SIP Revision-Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Approves-Massachusetts-SIP-Revision-Massachusetts",
    "url": "/news/EPA-Approves-Massachusetts-SIP-Revision-Massachusetts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Environmental Product Declarations in the Building Construction Materials Sector",
    "apiurl": "/restapi/customnewscontentlvl2/news/Environmental-Product-Declarations-in-the-Building-Construction-Materials-Sector",
    "url": "/news/Environmental-Product-Declarations-in-the-Building-Construction-Materials-Sector",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PA EQB Authorizes Cap-and-Trade Petition For Evaluation-Pennsylvania",
    "apiurl": "/restapi/customnewscontentlvl2/news/PA-EQB-Authorizes-Cap-and-Trade-Petition-For-Evaluation-Pennsylvania",
    "url": "/news/PA-EQB-Authorizes-Cap-and-Trade-Petition-For-Evaluation-Pennsylvania",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2009 Emission Inventory Workshops",
    "apiurl": "/restapi/customnewscontentlvl2/news/2009-Emission-Inventory-Workshops",
    "url": "/news/2009-Emission-Inventory-Workshops",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA Issues Supplement to Proposed Indianapolis Area 1997 PM2.5 Annual NAAQS Attainment Redesignation",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-Issues-Supplement-to-Proposed-Indianapolis-Area-1997-PM2-5-Annual-NAAQS-Attainment-Redesignation",
    "url": "/news/USEPA-Issues-Supplement-to-Proposed-Indianapolis-Area-1997-PM2-5-Annual-NAAQS-Attainment-Redesignation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD Proposed Amended Rules 1146, 1146.1 and 1146.2 and Proposed Rule 1100-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/SCAQMD-Proposed-Amended-Rules-1146-1146-1-and-1146-2-and-Proposed-Rule-1100-California",
    "url": "/news/SCAQMD-Proposed-Amended-Rules-1146-1146-1-and-1146-2-and-Proposed-Rule-1100-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDAQMD Proposes Amendments to NSR & PSD Air Permitting Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/mdaqmd-proposes-amendments-to-nsr-psd-air-permitting-rules",
    "url": "/news/mdaqmd-proposes-amendments-to-nsr-psd-air-permitting-rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDAQMD Proposes Amendments to NSR & PSD Air Permitting Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/mdaqmd-proposes-amendments-to-nsr-psd-air-permitting-rules",
    "url": "/news/mdaqmd-proposes-amendments-to-nsr-psd-rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Nebraska Air Program Update Workshops",
    "apiurl": "/restapi/customnewscontentlvl2/news/Nebraska-Air-Program-Update-Workshops-",
    "url": "/news/Nebraska-Air-Program-Update-Workshops-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Wisconsin MPAP Guidance Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/Wisconsin-MPAP-Guidance-Released",
    "url": "/news/Wisconsin-MPAP-Guidance-Released",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Carbon Capture in Wyoming-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Carbon-Capture-in-Wyoming-Wyoming",
    "url": "/news/Carbon-Capture-in-Wyoming-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Multi-Sector General Permit Delayed, But Changes are Coming",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-multi-sector-general-permit-delayed-but-changes-are-coming",
    "url": "/news/epa-multi-sector-general-permit-delayed-but-changes-are-coming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Multi-Sector General Permit Delayed, But Changes are Coming",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-multi-sector-general-permit-delayed-but-changes-are-coming",
    "url": "/news/state/oklahoma/epa-multi-sector-general-permit-delayed-but-changes-are-coming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Air Permitting in Indian Country",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Air-Permitting-in-Indian-Country",
    "url": "/news/EPA-Air-Permitting-in-Indian-Country",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Training Reminder-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Training-Reminder-Kansas",
    "url": "/news/Training-Reminder-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Finalizes PM2.5 NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Finalizes-PM2-5-NAAQS",
    "url": "/news/EPA-Finalizes-PM2-5-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Tennessee Department of Environment & Conservation Air Pollution Control Board Hearing",
    "apiurl": "/restapi/customnewscontentlvl2/news/Tennessee-Department-of-Environment-Conservation-Air-Pollution-Control-Board-Hearing",
    "url": "/news/Tennessee-Department-of-Environment-Conservation-Air-Pollution-Control-Board-Hearing",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GPLPE Renewal Details and Due Dates",
    "apiurl": "/restapi/customnewscontentlvl2/news/GPLPE-Rene",
    "url": "/news/GPLPE-Rene",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Emissions Testing Report Deadline Extended by ADEQ",
    "apiurl": "/restapi/customnewscontentlvl2/news/Emissions-Testing-Report-Deadline-Extended-by-ADEQ",
    "url": "/news/Emissions-Testing-Report-Deadline-Extended-by-ADEQ",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ozone Nonattainment Update-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ozone-Nonattainment-Update-Colorado",
    "url": "/news/Ozone-Nonattainment-Update-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Nebraska Air General Construction Permitting -- Now An Online Process",
    "apiurl": "/restapi/customnewscontentlvl2/news/Nebraska-Air-General-Construction-Permitting----Now-An-Online-Process",
    "url": "/news/Nebraska-Air-General-Construction-Permitting----Now-An-Online-Process",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Federal Cap and Trade Legislation Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Federal-Ca",
    "url": "/news/Federal-Ca",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DEQ Launches Website for Cleaner Air Oregon Submissions-Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/DEQ-Launches-Website-for-Cleaner-Air-Oregon-Submissions-Oregon",
    "url": "/news/DEQ-Launches-Website-for-Cleaner-Air-Oregon-Submissions-Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes to Retain Existing NAAQS for Ozone",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-proposes-to-retain-existing-naaqs-for-ozone",
    "url": "/news/epa-proposes-to-retain-existing-naaqs-for-ozone",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes to Retain Existing NAAQS for Ozone",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-proposes-to-retain-existing-naaqs-for-ozone",
    "url": "/states/arizona/epa-proposes-to-retain-existing-naaqs-for-ozone",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ARB Consumer and Commercial Products Survey",
    "apiurl": "/restapi/customnewscontentlvl2/news/ARB-Consumer-and-Commercial-Products-Survey",
    "url": "/news/ARB-Consumer-and-Commercial-Products-Survey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KC Chamber and Partners host 2015 Midwest Environmental Compliance Conference (MECC)",
    "apiurl": "/restapi/customnewscontentlvl2/news/KC-Chamber-and-Partners-host-2015-Midwest-Environmental-Compliance-Conference-(MECC)",
    "url": "/news/KC-Chamber-and-Partners-host-2015-Midwest-Environmental-Compliance-Conference-(MECC)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Interim Operating Permit Section Supervisor",
    "apiurl": "/restapi/customnewscontentlvl2/news/Interim-Operating-Permit-Section-Supervisor-",
    "url": "/news/Interim-Operating-Permit-Section-Supervisor-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NYSDEC Implements New Rules for 6 NYCRR Part 243, 244 and 245",
    "apiurl": "/restapi/customnewscontentlvl2/news/NYSDEC-Implements-New-Rules-for-6-NYCRR-Part-243-244-and-245",
    "url": "/news/NYSDEC-Implements-New-Rules-for-6-NYCRR-Part-243-244-and-245",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Quality Advisory Board Meeting December 11-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Advisory-Board-Meeting-December-11-Wyoming",
    "url": "/news/Air-Quality-Advisory-Board-Meeting-December-11-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PM2.5 ERCs Continue to Not Be Available",
    "apiurl": "/restapi/customnewscontentlvl2/news/PM2-5-ERCs-Continue-to-Not-Be-Available",
    "url": "/news/PM2-5-ERCs-Continue-to-Not-Be-Available",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "November 2019 Triangle Newsletter",
    "apiurl": "/restapi/customnewscontentlvl2/news/November-2019-Triangle-Newsletter",
    "url": "/news/November-2019-Triangle-Newsletter",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Rule RCSA-22a-174-38 Municipal Waste Combustors",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-Rule-RCSA-22a-174-38-Municipal-Waste-Combustors",
    "url": "/news/Final-Rule-RCSA-22a-174-38-Municipal-Waste-Combustors",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Colorado’s Greenhouse Gas Inventory and More to Come-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Colorado-s-Greenhouse-Gas-Inventory-and-More-to-Come-Colorado",
    "url": "/news/Colorado-s-Greenhouse-Gas-Inventory-and-More-to-Come-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Colorado’s Greenhouse Gas Inventory and More to Come-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Colorado-s-Greenhouse-Gas-Inventory-and-More-to-Come-Colorado",
    "url": "/states/Colorado/Colorado-s-Greenhouse-Gas-Inventory-and-More-to-Come-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Default Thresholds Increased for AERA",
    "apiurl": "/restapi/customnewscontentlvl2/news/Default-Thresholds-Increased-for-AERA",
    "url": "/news/Default-Thresholds-Increased-for-AERA",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NMED proposed Incorporation by Reference of Federal NSPS, NESHAP, and MACT Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/NMED-proposed-Incorporation-by-Reference-of-Federal-NSPS-NESHAP-and-MACT-Rules",
    "url": "/news/NMED-proposed-Incorporation-by-Reference-of-Federal-NSPS-NESHAP-and-MACT-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDE Discusses Potential Changes to Distributed Generation Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDE-Discusses-Potential-Changes-to-Distributed-Generation-Regulations",
    "url": "/news/MDE-Discusses-Potential-Changes-to-Distributed-Generation-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDE Discusses Potential Changes to Distributed Generation Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDE-Discusses-Potential-Changes-to-Distributed-Generation-Regulations",
    "url": "/news/states/mde-discusses-potential-changes-to-distributed-generation-regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Next Step for ACE Expected Next Month",
    "apiurl": "/restapi/customnewscontentlvl2/news/next-step-for-ace-expected-next-month",
    "url": "/news/next-step-for-ace-expected-next-month",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Next Step for ACE Expected Next Month",
    "apiurl": "/restapi/customnewscontentlvl2/news/next-step-for-ace-expected-next-month",
    "url": "/news/state/oklahoma/next-step-for-ace-expected-next-month",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDNR Air Quality Client Contact Meeting Highlights",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDNR-Air-Quality-Client-Contact-Meeting-Highlights-",
    "url": "/news/IDNR-Air-Quality-Client-Contact-Meeting-Highlights-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Semi-Annual Fugitive Emission Equipment Leak Form",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Semi-Annual-Fugitive-Emission-Equipment-Leak-Form",
    "url": "/news/New-Semi-Annual-Fugitive-Emission-Equipment-Leak-Form",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Update Workshops",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Update-Workshops",
    "url": "/news/Air-Update-Workshops",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Modeling Remains Major Permitting Hurdle",
    "apiurl": "/restapi/customnewscontentlvl2/news/Modeling-Remains-Major-Permitting-Hurdle",
    "url": "/news/Modeling-Remains-Major-Permitting-Hurdle",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Senate Bill 181: Potential Changes for Oil and Gas Operations in Colorado-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Senate-Bill-181-Potential-Changes-for-Oil-and-Gas-Operations-in-Colorado-Colorado",
    "url": "/news/Senate-Bill-181-Potential-Changes-for-Oil-and-Gas-Operations-in-Colorado-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Crystalline Silica 24-hour ReV DSD",
    "apiurl": "/restapi/customnewscontentlvl2/news/crystalline-silica-24-hour-rev-dsd",
    "url": "/news/crystalline-silica-24-hour-rev-dsd",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Quality Client Contact Meeting - February 20, 2014",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Client-Contact-Meeting---February-20-2014",
    "url": "/news/Air-Quality-Client-Contact-Meeting---February-20-2014",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NYSDEC Proposes Updates to Requirements for Federally Enforceable Permit Conditions",
    "apiurl": "/restapi/customnewscontentlvl2/news/nysdec-proposes-updates-to-requirements-for-federally-enforceable-permit-conditions",
    "url": "/news/nysdec-proposes-updates-to-requirements-for-federally-enforceable-permit-conditions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New York to Lower Ozone Season NOx RACT Limits for SCCTs-New Jersey",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-York-to-Lower-Ozone-Season-NOx-RACT-Limits-for-SCCTs-New-Jersey",
    "url": "/news/New-York-to-Lower-Ozone-Season-NOx-RACT-Limits-for-SCCTs-New-Jersey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Washington Clean Fuel Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/Washington-Clean-Fuel-Standard",
    "url": "/news/Washington-Clean-Fuel-Standard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PSM Experts Present at 2021 AIChE Global Congress on Process Safety",
    "apiurl": "/restapi/customnewscontentlvl2/news/psm-experts-present-at-2021-aiche-global-congress-on-process-safety",
    "url": "/news/psm-experts-present-at-2021-aiche-global-congress-on-process-safety",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Minnesota's Electronic Emissions Inventory System",
    "apiurl": "/restapi/customnewscontentlvl2/news/Minnesota's-Electronic-Emissions-Inventory-System",
    "url": "/news/Minnesota's-Electronic-Emissions-Inventory-System",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Missouri DNR Seeks Public Input to Eliminate Unnecessary Red Tape-Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/Missouri-DNR-Seeks-Public-Input-to-Eliminate-Unnecessary-Red-Tape-Missouri",
    "url": "/news/Missouri-DNR-Seeks-Public-Input-to-Eliminate-Unnecessary-Red-Tape-Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Permit Alteration is Not Appropriate for Converting Flexible Permit to SIP-Approved Permit",
    "apiurl": "/restapi/customnewscontentlvl2/news/Permit-Alteration-is-Not-Appropriate-for-Converting-Flexible-Permit-to-SIP-Approved-Permit",
    "url": "/news/Permit-Alteration-is-Not-Appropriate-for-Converting-Flexible-Permit-to-SIP-Approved-Permit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Growing in Southern California",
    "apiurl": "/restapi/customnewscontentlvl2/news/Growing-in-Southern-California",
    "url": "/news/Growing-in-Southern-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SC Regulation Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/SC-Regulation-Updates",
    "url": "/news/SC-Regulation-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DOEE Proposes New Regulations for Screen Printing Operations",
    "apiurl": "/restapi/customnewscontentlvl2/news/doee-proposes-new-regulations-for-screen-printing-operations",
    "url": "/news/doee-proposes-new-regulations-for-screen-printing-operations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on Illinois Hazardous Waste Management Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-Illinois-Hazardous-Waste-Management-Program",
    "url": "/news/Update-on-Illinois-Hazardous-Waste-Management-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA Promulgates the Clean Power Plan for Existing Power Plants",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-Promulgates-the-Clean-Power-Plan-for-Existing-Power-Plants",
    "url": "/news/USEPA-Promulgates-the-Clean-Power-Plan-for-Existing-Power-Plants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PA DEP Proposes New PM2.5 Area Designations",
    "apiurl": "/restapi/customnewscontentlvl2/news/PA-DEP-Proposes-New-PM2-5-Area-Designations",
    "url": "/news/PA-DEP-Proposes-New-PM2-5-Area-Designations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Status of PM2.5 NAAQS Designations in Kentucky",
    "apiurl": "/restapi/customnewscontentlvl2/news/Status-of-",
    "url": "/news/Status-of-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NJDEP Provides COVID-19 Air Quality Regulatory Compliance Guidance",
    "apiurl": "/restapi/customnewscontentlvl2/news/njdep-provides-covid-19-air-quality-regulatory-compliance-guidance",
    "url": "/news/njdep-provides-covid-19-air-quality-regulatory-compliance-guidance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New ADEQ Air Permit Application Forms Available",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-ADEQ-Air-Permit-Application-Forms-Available",
    "url": "/news/New-ADEQ-Air-Permit-Application-Forms-Available",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Authorization of Illinois' Hazardous Waste Management Program Revision",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-Authorization-of-Illinois'-Hazardous-Waste-Management-Program-Revision",
    "url": "/news/Final-Authorization-of-Illinois'-Hazardous-Waste-Management-Program-Revision",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity's Jamie White Selected to Auditing Leadership Position",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity's-Jamie-White-Selected-to-Auditing-Leadership-Position",
    "url": "/news/Trinity's-Jamie-White-Selected-to-Auditing-Leadership-Position",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Albuquerque Air Board Hearing on SWOP's Request to Rescind Honstein Oil's ATC #3131",
    "apiurl": "/restapi/customnewscontentlvl2/news/Albuquerque-Air-Board-Hearing-on-SWOP's-Request-to-Rescind-Honstein-Oil's-ATC-3131",
    "url": "/news/Albuquerque-Air-Board-Hearing-on-SWOP's-Request-to-Rescind-Honstein-Oil's-ATC-3131",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Additional Updates to Michigan Air Permitting Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/Additional-Updates-to-Michigan-Air-Permitting-Rules",
    "url": "/news/Additional-Updates-to-Michigan-Air-Permitting-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "When is Air Dispersion Modeling Required?-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/When-is-Air-Dispersion-Modeling-Required--Nebraska",
    "url": "/news/When-is-Air-Dispersion-Modeling-Required--Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Illinois Passes Legislation to Streamline Environmental Permitting Process",
    "apiurl": "/restapi/customnewscontentlvl2/news/Illinois-Passes-Legislation-to-Streamline-Environmental-Permitting-Process",
    "url": "/news/Illinois-Passes-Legislation-to-Streamline-Environmental-Permitting-Process",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPW Committee Approves Greenhouse Gas Tracking Bill",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPW-Commit",
    "url": "/news/EPW-Commit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments to Env-A 1000 Prevention, Abatement, and Control of Open Source Air Pollution-New Hampshire",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendments-to-Env-A-1000-Prevention-Abatement-and-Control-of-Open-Source-Air-Pollution-New-Hampshire",
    "url": "/news/Proposed-Amendments-to-Env-A-1000-Prevention-Abatement-and-Control-of-Open-Source-Air-Pollution-New-Hampshire",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Latest on the 2015 Ozone NAAQS including SIP Revisions-Louisiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/Latest-on-the-2015-Ozone-NAAQS-including-SIP-Revisions-Louisiana",
    "url": "/news/Latest-on-the-2015-Ozone-NAAQS-including-SIP-Revisions-Louisiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Amendments to Air Permit Application Forms-New Hampshire",
    "apiurl": "/restapi/customnewscontentlvl2/news/Amendments-to-Air-Permit-Application-Forms-New-Hampshire",
    "url": "/news/Amendments-to-Air-Permit-Application-Forms-New-Hampshire",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEP New Biennial Hazardous Waste Reporting System-Nevada",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEP-New-Biennial-Hazardous-Waste-Reporting-System-Nevada",
    "url": "/news/NDEP-New-Biennial-Hazardous-Waste-Reporting-System-Nevada",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Air Emissions Calculation Tool for NOI Applications-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Air-Emissions-Calculation-Tool-for-NOI-Applications-New-Mexico",
    "url": "/news/New-Air-Emissions-Calculation-Tool-for-NOI-Applications-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Modeling Strategy",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Modeling-Strategy",
    "url": "/news/Proposed-Modeling-Strategy",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "APEN Fees-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/APEN-Fees-Colorado",
    "url": "/news/APEN-Fees-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NYSDEC Proposes Power Sector Regulations to Analyze Possible Environmental Impacts and Limit CO2 Emissions from Power Plants",
    "apiurl": "/restapi/customnewscontentlvl2/news/NYSDEC-Proposes-Power-Sector-Regulations-to-Analyze-Possible-Environmental-Impacts-and-Limit-CO2-Emissions-from-Power-Plants",
    "url": "/news/NYSDEC-Proposes-Power-Sector-Regulations-to-Analyze-Possible-Environmental-Impacts-and-Limit-CO2-Emissions-from-Power-Plants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Free Tank Operator Training",
    "apiurl": "/restapi/customnewscontentlvl2/news/Free-Tank-Operator-Training-",
    "url": "/news/Free-Tank-Operator-Training-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SJVAPCD Proposes Amendments to Rule 2201",
    "apiurl": "/restapi/customnewscontentlvl2/news/SJVAPCD-Proposes-Amendments-to-Rule-2201",
    "url": "/news/SJVAPCD-Proposes-Amendments-to-Rule-2201",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Boiler MACT Hammer Applications - Part 2 Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/Boiler-MACT-Hammer-Applications---Part-2-Update",
    "url": "/news/Boiler-MACT-Hammer-Applications---Part-2-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update to Annual Compliance Certification Submission Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-to-Annual-Compliance-Certification-Submission-Requirements",
    "url": "/news/Update-to-Annual-Compliance-Certification-Submission-Requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Enhanced LDAR in the Chemical Industry",
    "apiurl": "/restapi/customnewscontentlvl2/news/Enhanced-LDAR-in-the-Chemical-Industry",
    "url": "/news/Enhanced-LDAR-in-the-Chemical-Industry",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PCAQCD – New Dust Control Regulations for West Pinal County",
    "apiurl": "/restapi/customnewscontentlvl2/news/PCAQCD-New-Dust-Control-Regulations-for-West-Pinal-County",
    "url": "/news/PCAQCD-New-Dust-Control-Regulations-for-West-Pinal-County",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SIP Approval for Fuel Sulfur Limitations in New Hampshire",
    "apiurl": "/restapi/customnewscontentlvl2/news/sip-approval-for-fuel-sulfur-limitations-in-new-hampshire",
    "url": "/news/sip-approval-for-fuel-sulfur-limitations-in-new-hampshire",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LDAR Deficiencies Lead to Enhanced Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/LDAR-Deficiencies-Lead-to-Enhanced-Requirements",
    "url": "/news/LDAR-Deficiencies-Lead-to-Enhanced-Requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The SAFE Vehicles Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/the-safe-vehicles-rule",
    "url": "/news/the-safe-vehicles-rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "OOOOa Updates for LDAR",
    "apiurl": "/restapi/customnewscontentlvl2/news/OOOOa-Updates-for-LDAR",
    "url": "/news/OOOOa-Updates-for-LDAR",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Greenhouse Gas Permitting Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/Greenhouse-Gas-Permitting-Update",
    "url": "/news/Greenhouse-Gas-Permitting-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "UPDATE:  Potential Changes to PADEP Fee Structures-Pennsylvania",
    "apiurl": "/restapi/customnewscontentlvl2/news/UPDATE-Potential-Changes-to-PADEP-Fee-Structures-Pennsylvania",
    "url": "/news/UPDATE-Potential-Changes-to-PADEP-Fee-Structures-Pennsylvania",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Issues the Final 2021 MSGP",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-issues-the-final-2021-mspg",
    "url": "/news/epa-issues-the-final-2021-mspg",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Finalizes Federal Implementation Plan (FIP) for Taconite Industries in Minnesota for Regional Haze",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Finalizes-Federal-Implementation-Plan-(FIP)-for-Taconite-Industries-in-Minnesota-for-Regional-Haze",
    "url": "/news/EPA-Finalizes-Federal-Implementation-Plan-(FIP)-for-Taconite-Industries-in-Minnesota-for-Regional-Haze",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New General Condition for Excess Emission Reporting-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-General-Condition-for-Excess-Emission-Reporting-New-Mexico",
    "url": "/news/New-General-Condition-for-Excess-Emission-Reporting-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ODEQ CAO Website Resources-Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/ODEQ-CAO-Website-Resources-Oregon",
    "url": "/news/ODEQ-CAO-Website-Resources-Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Revisions to Washington Toxic Air Pollutant Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-Revisions-to-Washington-Toxic-Air-Pollutant-Rules",
    "url": "/news/Final-Revisions-to-Washington-Toxic-Air-Pollutant-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE TankESP 5.1 Software Includes Recently Updated AP-42 Tank Emission Factors",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-TankESP-5-1-Software-Includes-Recently-Updated-AP-42-Tank-Emission-Factors",
    "url": "/news/BREEZE-TankESP-5-1-Software-Includes-Recently-Updated-AP-42-Tank-Emission-Factors",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Delaware’s 2008 8-hour Ozone RACT SIP Revision",
    "apiurl": "/restapi/customnewscontentlvl2/news/Delaware-s-2008-8-hour-Ozone-RACT-SIP-Revision-",
    "url": "/news/Delaware-s-2008-8-hour-Ozone-RACT-SIP-Revision-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cap-and-Trade May 2015 Joint-Auction Results Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/Cap-and-Trade-May-2015-Joint-Auction-Results-Released",
    "url": "/news/Cap-and-Trade-May-2015-Joint-Auction-Results-Released",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "San Diego County Air Pollution Control District TAC and Exempt Compound Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/San-Diego-County-Air-Pollution-Control-District-TAC-and-Exempt-Compound-Updates",
    "url": "/news/San-Diego-County-Air-Pollution-Control-District-TAC-and-Exempt-Compound-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Migration Corridor Protection to be addressed as part of Wyoming Permitting",
    "apiurl": "/restapi/customnewscontentlvl2/news/migration-corridor-protection-to-be-addressed-as-part-of-wyoming-permitting",
    "url": "/news/migration-corridor-protection-to-be-addressed-as-part-of-wyoming-permitting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Migration Corridor Protection to be addressed as part of Wyoming Permitting",
    "apiurl": "/restapi/customnewscontentlvl2/news/migration-corridor-protection-to-be-addressed-as-part-of-wyoming-permitting",
    "url": "/states/migration-corridor-protection-to-be-addressed-as-part-of-wyoming-permitting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated Industrial General Stormwater Permit Effective January 1, 2020-Washington",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updated-Industrial-General-Stormwater-Permit-Effective-January-1-2020-Washington",
    "url": "/news/Updated-Industrial-General-Stormwater-Permit-Effective-January-1-2020-Washington",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Illinois NPDES e-Reporting Tool-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Illinois-NPDES-e-Reporting-Tool-Illinois",
    "url": "/news/Illinois-NPDES-e-Reporting-Tool-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on Illinois General Permits",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-Illinois-General-Permits",
    "url": "/news/Update-on-Illinois-General-Permits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD Proposed Amended Rule 1135-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/SCAQMD-Proposed-Amended-Rule-1135-California",
    "url": "/news/SCAQMD-Proposed-Amended-Rule-1135-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "San Joaquin Valley Reclassified as Serious Nonattainment for PM2.5",
    "apiurl": "/restapi/customnewscontentlvl2/news/San-Joaquin-Valley-Reclassified-as-Serious-Nonattainment-for-PM2-5",
    "url": "/news/San-Joaquin-Valley-Reclassified-as-Serious-Nonattainment-for-PM2-5",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DOEE Proposes New Air Quality Regulations for Permitting Demand Response Engines-Washington, DC",
    "apiurl": "/restapi/customnewscontentlvl2/news/DOEE-Proposes-New-Air-Quality-Regulations-for-Permitting-Demand-Response-Engines-Washington-DC",
    "url": "/news/DOEE-Proposes-New-Air-Quality-Regulations-for-Permitting-Demand-Response-Engines-Washington-DC",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Section 112(r) RMP Renewal Deadline Approaching",
    "apiurl": "/restapi/customnewscontentlvl2/news/Section-112(r)-RMP-Renewal-Deadline-Approaching",
    "url": "/news/Section-112(r)-RMP-Renewal-Deadline-Approaching",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Coast Air Quality Management District – Proposed Amended Rules 1469 and 1426",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Coast-Air-Quality-Management-District-Proposed-Amended-Rules-1469-and-1426",
    "url": "/news/South-Coast-Air-Quality-Management-District-Proposed-Amended-Rules-1469-and-1426",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cap-and-Trade August 2016 Joint-Auction Results Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/Cap-and-Trade-August-2016-Joint-Auction-Results-Released",
    "url": "/news/Cap-and-Trade-August-2016-Joint-Auction-Results-Released",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Onsite Meteorological Data - Everything You Need To Know",
    "apiurl": "/restapi/customnewscontentlvl2/news/Onsite-Meteorological-Data---Everything-You-Need-To-Know",
    "url": "/news/Onsite-Meteorological-Data---Everything-You-Need-To-Know",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to the Toxics Reporting Inventory (TRI) Reporting Requirements-Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-to-the-Toxics-Reporting-Inventory-(TRI)-Reporting-Requirements-Oregon",
    "url": "/news/Updates-to-the-Toxics-Reporting-Inventory-(TRI)-Reporting-Requirements-Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2015 Utah Legislative Session - Air Quality Bill",
    "apiurl": "/restapi/customnewscontentlvl2/news/2015-Utah-Legislative-Session---Air-Quality-Bill",
    "url": "/news/2015-Utah-Legislative-Session---Air-Quality-Bill",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Coast Air Quality Management District – Proposed Amended Rule 1118.1-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Coast-Air-Quality-Management-District-Proposed-Amended-Rule-1118-1-California",
    "url": "/news/South-Coast-Air-Quality-Management-District-Proposed-Amended-Rule-1118-1-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes Forthcoming to NSPS OOOO",
    "apiurl": "/restapi/customnewscontentlvl2/news/Changes-Forthcoming-to-NSPS-OOOO",
    "url": "/news/Changes-Forthcoming-to-NSPS-OOOO",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Federal Greenhouse Gas Pricing Act Requirements-Ontario",
    "apiurl": "/restapi/customnewscontentlvl2/news/Federal-Greenhouse-Gas-Pricing-Act-Requirements-Ontario",
    "url": "/news/Federal-Greenhouse-Gas-Pricing-Act-Requirements-Ontario",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Approves Louisiana's Request to Relax Federal Reid Vapor Pressure (RVP) Gasoline Volatility Standard-Louisiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Approves-Louisiana's-Request-to-Relax-Federal-Reid-Vapor-Pressure-(RVP)-Gasoline-Volatility-Standard-Louisiana",
    "url": "/news/EPA-Approves-Louisiana's-Request-to-Relax-Federal-Reid-Vapor-Pressure-(RVP)-Gasoline-Volatility-Standard-Louisiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Supreme Court Kicks Back Power Plant NESHAP",
    "apiurl": "/restapi/customnewscontentlvl2/news/Supreme-Court-Kicks-Back-Power-Plant-NESHAP",
    "url": "/news/Supreme-Court-Kicks-Back-Power-Plant-NESHAP",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Notice of Final Adoption of Air Quality Rules: Chapter 2 and Chapter 6 (R-25)",
    "apiurl": "/restapi/customnewscontentlvl2/news/Notice-of-Final-Adoption-of-Air-Quality-Rules-Chapter-2-and-Chapter-6-(R-25)",
    "url": "/news/Notice-of-Final-Adoption-of-Air-Quality-Rules-Chapter-2-and-Chapter-6-(R-25)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GHG Tailoring Rule - Title V Applications Deadline Reminder",
    "apiurl": "/restapi/customnewscontentlvl2/news/GHG-Tailoring-Rule---Title-V-Applications-Deadline-Reminder",
    "url": "/news/GHG-Tailoring-Rule---Title-V-Applications-Deadline-Reminder",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New York State DEC Requires Electronic Submittal of Annual Emission Statements",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-york-state-dec-requires-electronic-submittal-of-annual-emission-statements",
    "url": "/news/new-york-state-dec-requires-electronic-submittal-of-annual-emission-statements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Coast Air Quality Management District – Proposed Amendments to Rules 1148.1 and 1148.2",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Coast-Air-Quality-Management-District-Proposed-Amendments-to-Rules-1148-1-and-1148-2",
    "url": "/news/South-Coast-Air-Quality-Management-District-Proposed-Amendments-to-Rules-1148-1-and-1148-2",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NYDEC Regulatory Agenda - 3 Year Review of Rules in State Register",
    "apiurl": "/restapi/customnewscontentlvl2/news/NYDEC-Regulatory-Agenda---3-Year-Review-of-Rules-in-State-Register",
    "url": "/news/NYDEC-Regulatory-Agenda---3-Year-Review-of-Rules-in-State-Register",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Administrative Rules for the Hydraulic Fracturing Regulatory Act and Seismicity",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Administrative-Rules-for-the-Hydraulic-Fracturing-Regulatory-Act-and-Seismicity-",
    "url": "/news/Proposed-Administrative-Rules-for-the-Hydraulic-Fracturing-Regulatory-Act-and-Seismicity-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Determines Attainment of 2008 Ozone Standard for Upper Green River Basin Area",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Determines-Attainment-of-2008-Ozone-Standard-for-Upper-Green-River-Basin-Area",
    "url": "/news/EPA-Determines-Attainment-of-2008-Ozone-Standard-for-Upper-Green-River-Basin-Area",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KDHE Updates UST Compliance Forms",
    "apiurl": "/restapi/customnewscontentlvl2/news/kdhe-updates-ust-compliance-forms",
    "url": "/news/kdhe-updates-ust-compliance-forms",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KDHE Updates UST Compliance Forms",
    "apiurl": "/restapi/customnewscontentlvl2/news/kdhe-updates-ust-compliance-forms",
    "url": "/news/state/kansas/kdhe-updates-ust-compliance-forms",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Michigan Department of Environmental Quality Revising Proposed Air Toxics Rule Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Michigan-Department-of-Environmental-Quality-Revising-Proposed-Air-Toxics-Rule-Updates",
    "url": "/news/Michigan-Department-of-Environmental-Quality-Revising-Proposed-Air-Toxics-Rule-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ozone Standards in Illinois SIP Updated-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ozone-Standards-in-Illinois-SIP-Updated-Illinois",
    "url": "/news/Ozone-Standards-in-Illinois-SIP-Updated-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New NO2 Standard Adds New Challenges to Permitting of Engines and Other NOx Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-NO2-Standard-Adds-New-Challenges-to-Permitting-of-Engines-and-Other-NOx-Sources",
    "url": "/news/New-NO2-Standard-Adds-New-Challenges-to-Permitting-of-Engines-and-Other-NOx-Sources",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Preparing for NSPS Subpart OOOO Reporting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Preparing-for-NSPS-Subpart-OOOO-Reporting",
    "url": "/news/Preparing-for-NSPS-Subpart-OOOO-Reporting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Issues Final Decision to Deny OTR Expansion Petition-New Hampshire",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Issues-Final-Decision-to-Deny-OTR-Expansion-Petition-New-Hampshire",
    "url": "/news/EPA-Issues-Final-Decision-to-Deny-OTR-Expansion-Petition-New-Hampshire",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Minnesota Pollution Control Adopts Federal Air Permit Thresholds for Greenhouse Gas Emission Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/Minnesota-Pollution-Control-Adopts-Federal-Air-Permit-Thresholds-for-Greenhouse-Gas-Emission-Rules",
    "url": "/news/Minnesota-Pollution-Control-Adopts-Federal-Air-Permit-Thresholds-for-Greenhouse-Gas-Emission-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Working with ADEQ:  Reviewing Draft Permits",
    "apiurl": "/restapi/customnewscontentlvl2/news/Working-with-ADEQ-Reviewing-Draft-Permits",
    "url": "/news/Working-with-ADEQ-Reviewing-Draft-Permits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Air Application Form",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Air-Application-Form",
    "url": "/news/New-Air-Application-Form",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "January 2019 AWMA Midwest Section Meeting – EPA Region 7 Key Takeaways-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/January-2019-AWMA-Midwest-Section-Meeting-EPA-Region-7-Key-Takeaways-Kansas",
    "url": "/news/January-2019-AWMA-Midwest-Section-Meeting-EPA-Region-7-Key-Takeaways-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Finalizes new Toxic Release Inventory submission requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Finalizes-new-Toxic-Release-Inventory-submission-requirements",
    "url": "/news/EPA-Finalizes-new-Toxic-Release-Inventory-submission-requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The New ISO 45001:2018 OH&S Management System Standard: Overview and Key Changes",
    "apiurl": "/restapi/customnewscontentlvl2/news/The-New-ISO-45001-2018-OH-S-Management-System-Standard-Overview-and-Key-Changes",
    "url": "/news/The-New-ISO-45001-2018-OH-S-Management-System-Standard-Overview-and-Key-Changes",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CAIR Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/CAIR-Update",
    "url": "/news/CAIR-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revised Air Pollution Fee Structure",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revised-Air-Pollution-Fee-Structure",
    "url": "/news/Revised-Air-Pollution-Fee-Structure",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "San Diego Moderate Ozone Attainment Status",
    "apiurl": "/restapi/customnewscontentlvl2/news/San-Diego-Moderate-Ozone-Attainment-Status",
    "url": "/news/San-Diego-Moderate-Ozone-Attainment-Status",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Mark your Calendars for Annual Emission Reporting!",
    "apiurl": "/restapi/customnewscontentlvl2/news/Mark-your-Calendars-for-Annual-Emission-Reporting!",
    "url": "/news/Mark-your-Calendars-for-Annual-Emission-Reporting!",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity’s Suejung Shin Helps Ensure Clean Drinking Water in Fiji",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-s-Suejung-Shin-Helps-Ensure-Clean-Drinking-Water-in-Fiji",
    "url": "/news/Trinity-s-Suejung-Shin-Helps-Ensure-Clean-Drinking-Water-in-Fiji",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Boiler MACT Affected Sources Five-Year Tune-Up-South Carolina",
    "apiurl": "/restapi/customnewscontentlvl2/news/Boiler-MACT-Affected-Sources-Five-Year-Tune-Up-South-Carolina",
    "url": "/news/Boiler-MACT-Affected-Sources-Five-Year-Tune-Up-South-Carolina",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Pennsylvania Department of Environmental Protection Urges EPA to Revise Interstate Transport Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Pennsylvania-Department-of-Environmental-Protection-Urges-EPA-to-Revise-Interstate-Transport-Rule",
    "url": "/news/Pennsylvania-Department-of-Environmental-Protection-Urges-EPA-to-Revise-Interstate-Transport-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Overview of Indiana Reporting Deadlines – Meet or Miss the Deadlines?",
    "apiurl": "/restapi/customnewscontentlvl2/news/Overview-of-Indiana-Reporting-Deadlines-Meet-or-Miss-the-Deadlines-",
    "url": "/news/Overview-of-Indiana-Reporting-Deadlines-Meet-or-Miss-the-Deadlines-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Chemistry Today - Important Elements in Evaluating Contract Manufacturing Organizations - Allan W. Ader, J. Justin Mason, and John P. Farris",
    "apiurl": "/restapi/customnewscontentlvl2/news/Chemistry-Today---Important-Elements-in-Evaluating-Contract-Manufacturing-Organizations---Allan-W-Ader-J-Justin-Mason-and-John-P-Farris",
    "url": "/news/Chemistry-Today---Important-Elements-in-Evaluating-Contract-Manufacturing-Organizations---Allan-W-Ader-J-Justin-Mason-and-John-P-Farris",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Maricopa & Pinal County Revised 5% Plan Deemed Complete",
    "apiurl": "/restapi/customnewscontentlvl2/news/Maricopa-Pinal-County-Revised-5-Plan-Deemed-Complete",
    "url": "/news/Maricopa-Pinal-County-Revised-5-Plan-Deemed-Complete",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA Finalizes Changes to Air Quality Modeling Guidance-Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-Finalizes-Changes-to-Air-Quality-Modeling-Guidance-Oregon",
    "url": "/news/USEPA-Finalizes-Changes-to-Air-Quality-Modeling-Guidance-Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Partner Spotlight - Gensuite",
    "apiurl": "/restapi/customnewscontentlvl2/news/partner-spotlight---gensuite",
    "url": "/news/partner-spotlight---gensuite",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Partner Spotlight - Gensuite",
    "apiurl": "/restapi/customnewscontentlvl2/news/partner-spotlight---gensuite",
    "url": "/news/partner-spotlight-gensuite",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Partner Spotlight - Gensuite",
    "apiurl": "/restapi/customnewscontentlvl2/news/partner-spotlight---gensuite",
    "url": "/news/technology/partner-spotlight---gensuite",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Public Comment for 2015 Ozone Infrastructure SIP-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Public-Comment-for-2015-Ozone-Infrastructure-SIP-Iowa",
    "url": "/news/Public-Comment-for-2015-Ozone-Infrastructure-SIP-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Streamlining Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Streamlining-Rules",
    "url": "/news/Proposed-Streamlining-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "WDNR Streamlines Air Rules for Litho Printers and Launches Online Industry Portal-Wisconsin",
    "apiurl": "/restapi/customnewscontentlvl2/news/WDNR-Streamlines-Air-Rules-for-Litho-Printers-and-Launches-Online-Industry-Portal-Wisconsin",
    "url": "/news/WDNR-Streamlines-Air-Rules-for-Litho-Printers-and-Launches-Online-Industry-Portal-Wisconsin",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Regulatory Updates in Maryland",
    "apiurl": "/restapi/customnewscontentlvl2/news/Regulatory-Updates-in-Maryland",
    "url": "/news/Regulatory-Updates-in-Maryland",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Sept. 2009 Regulatory Summaries",
    "apiurl": "/restapi/customnewscontentlvl2/news/Sept-2009-Regulatory-Summaries",
    "url": "/news/Sept-2009-Regulatory-Summaries",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LDEQ Finalizes a Revision to the Water Quality Regulations-Louisiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/LDEQ-Finalizes-a-Revision-to-the-Water-Quality-Regulations-Louisiana",
    "url": "/news/LDEQ-Finalizes-a-Revision-to-the-Water-Quality-Regulations-Louisiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reporting Reminders",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reporting-Reminders-",
    "url": "/news/Reporting-Reminders-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDNR to Offer MoEIS Workshops",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDNR-to-Offer-MoEIS-Workshops",
    "url": "/news/MDNR-to-Offer-MoEIS-Workshops",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DEQ Requesting Comments on Draft Recommended Procedures for Cleaner Air Oregon-Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/DEQ-Requesting-Comments-on-Draft-Recommended-Procedures-for-Cleaner-Air-Oregon-Oregon",
    "url": "/news/DEQ-Requesting-Comments-on-Draft-Recommended-Procedures-for-Cleaner-Air-Oregon-Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SJVAPCD Preliminary Annual Offset Equivalency Demonstration Results",
    "apiurl": "/restapi/customnewscontentlvl2/news/sjvapcd-preliminary-annual-offset-equivalency-demonstration-results",
    "url": "/news/sjvapcd-preliminary-annual-offset-equivalency-demonstration-results",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SJVAPCD Preliminary Annual Offset Equivalency Demonstration Results",
    "apiurl": "/restapi/customnewscontentlvl2/news/sjvapcd-preliminary-annual-offset-equivalency-demonstration-results",
    "url": "/news/states/california/sjvapcd-preliminary-annual-offset-equivalency-demonstration-results",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reminder of the Month - Boiler MACT Compliance Certification Due January 31st-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reminder-of-the-Month---Boiler-MACT-Compliance-Certification-Due-January-31st-Nebraska",
    "url": "/news/Reminder-of-the-Month---Boiler-MACT-Compliance-Certification-Due-January-31st-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDNR Draft 2018 Impaired Waters List-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDNR-Draft-2018-Impaired-Waters-List-Iowa",
    "url": "/news/IDNR-Draft-2018-Impaired-Waters-List-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Site Plan Guideline in Ontario-Ontario",
    "apiurl": "/restapi/customnewscontentlvl2/news/Site-Plan-Guideline-in-Ontario-Ontario",
    "url": "/news/Site-Plan-Guideline-in-Ontario-Ontario",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEP Adoption of NO2, SO2, & PM2.5 NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEP-Adoption-of-NO2-SO2-PM2-5-NAAQS-",
    "url": "/news/NDEP-Adoption-of-NO2-SO2-PM2-5-NAAQS-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "National Performance Track May Have Fallen Off Track",
    "apiurl": "/restapi/customnewscontentlvl2/news/National-Performance-Track-May-Have-Fallen-Off-Track",
    "url": "/news/National-Performance-Track-May-Have-Fallen-Off-Track",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Reconsiders Ozone Standards-South Carolina",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Reconsiders-Ozone-Standards-South-Carolina",
    "url": "/news/EPA-Reconsiders-Ozone-Standards-South-Carolina",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "More than $3400 Raised for Children’s Hospital of Philadelphia by Team Trinity",
    "apiurl": "/restapi/customnewscontentlvl2/news/more-than-3400-raised-for-children-s-hospital-of-philadelphia-by-team-trinity",
    "url": "/news/more-than-3400-raised-for-children-s-hospital-of-philadelphia-by-team-trinity",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "More than $3400 Raised for Children’s Hospital of Philadelphia by Team Trinity",
    "apiurl": "/restapi/customnewscontentlvl2/news/more-than-3400-raised-for-children-s-hospital-of-philadelphia-by-team-trinity",
    "url": "/company/more-than-3400-raised-for-children-s-hospital-of-philadelphia-by-team-trinity",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "California Passes Climate and Air Pollutions Bills-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/California-Passes-Climate-and-Air-Pollutions-Bills-California",
    "url": "/news/California-Passes-Climate-and-Air-Pollutions-Bills-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Wyoming's IMPACT System to Go Public-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Wyoming's-IMPACT-System-to-Go-Public-Wyoming",
    "url": "/news/Wyoming's-IMPACT-System-to-Go-Public-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "REMINDER: Amnesty Period for Engine Permitting Established",
    "apiurl": "/restapi/customnewscontentlvl2/news/REMINDER-Amnesty-Period-for-Engine-Permitting-Established",
    "url": "/news/REMINDER-Amnesty-Period-for-Engine-Permitting-Established",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2014 AWMA Meeting Scheduled",
    "apiurl": "/restapi/customnewscontentlvl2/news/2014-AWMA-Meeting-Scheduled",
    "url": "/news/2014-AWMA-Meeting-Scheduled",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Authorizes GHG Permitting Deferral for Biogenic Sources -Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Authorizes-GHG-Permitting-Deferral-for-Biogenic-Sources--Oregon",
    "url": "/news/EPA-Authorizes-GHG-Permitting-Deferral-for-Biogenic-Sources--Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments to 6 NYCRR Part 249, Best Available Retrofit Technology (BART)",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendments-to-6-NYCRR-Part-249-Best-Available-Retrofit-Technology-(BART)",
    "url": "/news/Proposed-Amendments-to-6-NYCRR-Part-249-Best-Available-Retrofit-Technology-(BART)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity’s Rocky Mountain Team is Fast Out of the Gate",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-s-Rocky-Mountain-Team-is-Fast-Out-of-the-Gate",
    "url": "/news/Trinity-s-Rocky-Mountain-Team-is-Fast-Out-of-the-Gate",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Minnesota Reporting Reminders",
    "apiurl": "/restapi/customnewscontentlvl2/news/Minnesota-Reporting-Reminders",
    "url": "/news/Minnesota-Reporting-Reminders",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Don’t be Left in the Dust: Managing Dust Fire and Explosion Hazards at Industrial Facilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/don-t-be-left-in-the-dust-managing-dust-fire-and-explosion-hazards-at-industrial-facilities",
    "url": "/news/don-t-be-left-in-the-dust-managing-dust-fire-and-explosion-hazards-at-industrial-facilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Don’t be Left in the Dust: Managing Dust Fire and Explosion Hazards at Industrial Facilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/don-t-be-left-in-the-dust-managing-dust-fire-and-explosion-hazards-at-industrial-facilities",
    "url": "/News/Federal/Don-t-be-Left-in-the-Dust-Managing-Dust-Fire-and-Explosion-Hazards-at-Industrial-Facilities/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Missouri Air Permitting Rule Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Missouri-Air-Permitting-Rule-Updates-",
    "url": "/news/Missouri-Air-Permitting-Rule-Updates-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Oil and Gas Audit Program-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Oil-and-Gas-Audit-Program-Wyoming",
    "url": "/news/EPA-Oil-and-Gas-Audit-Program-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Highlight of Maryland Office Natural Gas Projects",
    "apiurl": "/restapi/customnewscontentlvl2/news/Highlight-of-Maryland-Office-Natural-Gas-Projects-",
    "url": "/news/Highlight-of-Maryland-Office-Natural-Gas-Projects-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Canada’s Air Requirements for “Onshore Upstream Oil and Gas” Sources is Effective January 2020-Ontario",
    "apiurl": "/restapi/customnewscontentlvl2/news/Canada-s-Air-Requirements-for-Onshore-Upstream-Oil-and-Gas-Sources-is-Effective-January-2020-Ontario",
    "url": "/news/Canada-s-Air-Requirements-for-Onshore-Upstream-Oil-and-Gas-Sources-is-Effective-January-2020-Ontario",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DEQ Finalizes Rule Establishing Cap and Trade Program-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/DEQ-Finalizes-Rule-Establishing-Cap-and-Trade-Program-Virginia",
    "url": "/news/DEQ-Finalizes-Rule-Establishing-Cap-and-Trade-Program-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EH&S Management and Sustainability Expert Dr. John Fillo Joins Trinity Consultants",
    "apiurl": "/restapi/customnewscontentlvl2/news/EH-S-Management-and-Sustainability-Expert-Dr-John-Fillo-Joins-Trinity-Consultants",
    "url": "/news/EH-S-Management-and-Sustainability-Expert-Dr-John-Fillo-Joins-Trinity-Consultants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Utility MACT Proposal Public Hearings Scheduled",
    "apiurl": "/restapi/customnewscontentlvl2/news/Utility-MA",
    "url": "/news/Utility-MA",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes to Approve Part of Illinois Infrastructure SIP for 2012 PM2.5 NAAQS-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-to-Approve-Part-of-Illinois-Infrastructure-SIP-for-2012-PM2-5-NAAQS-Illinois",
    "url": "/news/EPA-Proposes-to-Approve-Part-of-Illinois-Infrastructure-SIP-for-2012-PM2-5-NAAQS-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Amendments to CO2 Trading Program and Repeal of CO2 Offset Projects under RGGI-New Hampshire",
    "apiurl": "/restapi/customnewscontentlvl2/news/Amendments-to-CO2-Trading-Program-and-Repeal-of-CO2-Offset-Projects-under-RGGI-New-Hampshire",
    "url": "/news/Amendments-to-CO2-Trading-Program-and-Repeal-of-CO2-Offset-Projects-under-RGGI-New-Hampshire",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEM's Implementaion of the Greenhouse Gas (GHG) Tailoring Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEM's-Implementaion-of-the-Greenhouse-Gas-(GHG)-Tailoring-Rule",
    "url": "/news/ADEM's-Implementaion-of-the-Greenhouse-Gas-(GHG)-Tailoring-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "What You Need to Know About NYSDEC’s Recently Adopted Suite of Air Rule Revisions",
    "apiurl": "/restapi/customnewscontentlvl2/news/what-you-need-to-know-about-nysdecs-recently-adopted-suite-of-air-rule-revisions",
    "url": "/news/what-you-need-to-know-about-nysdecs-recently-adopted-suite-of-air-rule-revisions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NJDEP’s New Health RSW for Air Permit Applications",
    "apiurl": "/restapi/customnewscontentlvl2/news/njdep-s-new-health-rsw-for-air-permit-applications",
    "url": "/news/njdep-s-new-health-rsw-for-air-permit-applications",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PM2.5 Nonattainment Areas Designations in Washington, Oregon, Idaho and Alaska",
    "apiurl": "/restapi/customnewscontentlvl2/news/PM2-5-Nonattainment-Areas-Designations-in-Washington-Oregon-Idaho-and-Alaska",
    "url": "/news/PM2-5-Nonattainment-Areas-Designations-in-Washington-Oregon-Idaho-and-Alaska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ozone Update and Reminder",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ozone-Update-and-Reminder",
    "url": "/news/Ozone-Update-and-Reminder",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LDEQ Finalizes AQ382: Incorporating Test Results-Louisiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/LDEQ-Finalizes-AQ382-Incorporating-Test-Results-Louisiana",
    "url": "/news/LDEQ-Finalizes-AQ382-Incorporating-Test-Results-Louisiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Adoption of New Regulations as a Replacement of Current GPLPE-Connecticut",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Adoption-of-New-Regulations-as-a-Replacement-of-Current-GPLPE-Connecticut",
    "url": "/news/Proposed-Adoption-of-New-Regulations-as-a-Replacement-of-Current-GPLPE-Connecticut",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Don’t Forget Your RICE MACT Monitoring Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Don-t-Forget-Your-RICE-MACT-Monitoring-Plan",
    "url": "/news/Don-t-Forget-Your-RICE-MACT-Monitoring-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Thompson Environmental Consulting Joins Trinity Consultants",
    "apiurl": "/restapi/customnewscontentlvl2/news/Thompson-Environmental-Consulting-Joins-Trinity-Consultants",
    "url": "/news/Thompson-Environmental-Consulting-Joins-Trinity-Consultants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TRINITY CONSULTANTS EXPANDS NEW JERSEY TEAM",
    "apiurl": "/restapi/customnewscontentlvl2/news/TRINITY-CONSULTANTS-EXPANDS-NEW-JERSEY-TEAM-",
    "url": "/news/TRINITY-CONSULTANTS-EXPANDS-NEW-JERSEY-TEAM-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Hires Top Arkansas Environmental Expert",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Hires-Top-Arkansas-Environmental-Expert",
    "url": "/news/Trinity-Consultants-Hires-Top-Arkansas-Environmental-Expert",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Designing a GHG Management Strategy for Operational Advantages",
    "apiurl": "/restapi/customnewscontentlvl2/news/7a334f59-e5eb-4fde-808b-eebc10071838",
    "url": "/news/7a334f59-e5eb-4fde-808b-eebc10071838",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Part 70 Low-Emitting Facility General Permit",
    "apiurl": "/restapi/customnewscontentlvl2/news/Part-70-Low-Emitting-Facility-General-Permit",
    "url": "/news/Part-70-Low-Emitting-Facility-General-Permit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA's Preliminary Annual PM2.5 Designation",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA's-Preliminary-Annual-PM2-5-Designation",
    "url": "/news/USEPA's-Preliminary-Annual-PM2-5-Designation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revisions to the Refrigerant Management Programs Extension to Substitutes",
    "apiurl": "/restapi/customnewscontentlvl2/news/revisions-to-the-refrigerant-management-programs-extension-to-substitutes",
    "url": "/news/revisions-to-the-refrigerant-management-programs-extension-to-substitutes",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revisions to the Refrigerant Management Programs Extension to Substitutes",
    "apiurl": "/restapi/customnewscontentlvl2/news/revisions-to-the-refrigerant-management-programs-extension-to-substitutes",
    "url": "/news/federal/revisions-to-the-refrigerant-management-program-s-extension-to-substitutes",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revisions to the Refrigerant Management Programs Extension to Substitutes",
    "apiurl": "/restapi/customnewscontentlvl2/news/revisions-to-the-refrigerant-management-programs-extension-to-substitutes",
    "url": "/federal/revisions-to-the-refrigerant-management-program-s-extension-to-substitutes",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD Public Hearing is Proposing Amendments to Rule 1309",
    "apiurl": "/restapi/customnewscontentlvl2/news/SCAQMD-Public-Hearing-is-Proposing-Amendments-to-Rule-1309-",
    "url": "/news/SCAQMD-Public-Hearing-is-Proposing-Amendments-to-Rule-1309-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Senate Bill 427 Passed - Permitting Issuance Changes",
    "apiurl": "/restapi/customnewscontentlvl2/news/Senate-Bil",
    "url": "/news/Senate-Bil",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SafeBridge Consultants, Inc. Laboratory Accredited by American Industrial Hygiene Association for Pharmaceutical Sample Analysis",
    "apiurl": "/restapi/customnewscontentlvl2/news/SafeBridge-Consultants-Inc-Laboratory-Accredited-by-American-Industrial-Hygiene-Association-for-Pharmaceutical-Sample-Analysis",
    "url": "/news/SafeBridge-Consultants-Inc-Laboratory-Accredited-by-American-Industrial-Hygiene-Association-for-Pharmaceutical-Sample-Analysis",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Triennial Review of Surface Water Quality Standards-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Triennial-Review-of-Surface-Water-Quality-Standards-Wyoming",
    "url": "/news/Triennial-Review-of-Surface-Water-Quality-Standards-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Georgia EPD Debuts Draft PSD Permit Application Guidance Document",
    "apiurl": "/restapi/customnewscontentlvl2/news/Georgia-EPD-Debuts-Draft-PSD-Permit-Application-Guidance-Document",
    "url": "/news/Georgia-EPD-Debuts-Draft-PSD-Permit-Application-Guidance-Document",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDEM Conducts First Article 2 Workgroup Meeting to Update Air Permitting Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDEM-Conducts-First-Article-2-Workgroup-Meeting-to-Update-Air-Permitting-Rules",
    "url": "/news/IDEM-Conducts-First-Article-2-Workgroup-Meeting-to-Update-Air-Permitting-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Coast Air Quality Management District - Proposed Rules 1109.1 and Proposed Amended Rule 1134-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Coast-Air-Quality-Management-District---Proposed-Rules-1109-1-and-Proposed-Amended-Rule-1134-California",
    "url": "/news/South-Coast-Air-Quality-Management-District---Proposed-Rules-1109-1-and-Proposed-Amended-Rule-1134-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Draft Silica Sand Rule Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Draft-Silica-Sand-Rule-Updates",
    "url": "/news/Draft-Silica-Sand-Rule-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Draft 2021 Ambient Air Quality Monitoring Network Plan Published by NDEE",
    "apiurl": "/restapi/customnewscontentlvl2/news/2021-draft-ambient-air-quality-monitoring-network-plan-published-by-ndee",
    "url": "/news/2021-draft-ambient-air-quality-monitoring-network-plan-published-by-ndee",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Draft 2021 Ambient Air Quality Monitoring Network Plan Published by NDEE",
    "apiurl": "/restapi/customnewscontentlvl2/news/2021-draft-ambient-air-quality-monitoring-network-plan-published-by-ndee",
    "url": "/www.trinityconsultants.com/news/2021-draft-ambient-air-quality-monitoring-network-plan-published-by-ndee",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New York Proposes Several Rule Changes",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-york-proposes-several-rule-changes",
    "url": "/news/new-york-proposes-several-rule-changes",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated Wisconsin PM2.5 Background Concentration for Modeling",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updated-Wisconsin-PM2-5-Background-Concentration-for-Modeling",
    "url": "/news/Updated-Wisconsin-PM2-5-Background-Concentration-for-Modeling",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Coast Air Quality Management District - Proposed Rule 1148.3",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Coast-Air-Quality-Management-District---Proposed-Rule-1148-3",
    "url": "/news/South-Coast-Air-Quality-Management-District---Proposed-Rule-1148-3",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "North Dakota Reporting Reminders",
    "apiurl": "/restapi/customnewscontentlvl2/news/North-Dakota-Reporting-Reminders",
    "url": "/news/North-Dakota-Reporting-Reminders",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Regional Haze FIP for Taconite Facilities in Minnesota and Michigan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Regional-Haze-FIP-for-Taconite-Facilities-in-Minnesota-and-Michigan",
    "url": "/news/Regional-Haze-FIP-for-Taconite-Facilities-in-Minnesota-and-Michigan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Changes to Washington Air Permitting Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Changes-to-Washington-Air-Permitting-Rules",
    "url": "/news/Proposed-Changes-to-Washington-Air-Permitting-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New York State Court Rules That Towns Can Ban Fracking",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-York-State-Court-Rules-That-Towns-Can-Ban-Fracking",
    "url": "/news/New-York-State-Court-Rules-That-Towns-Can-Ban-Fracking",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oklahoma Air Quality Rule Changes Effective July 1",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oklahoma-Air-Quality-Rule-Changes-Effective-July-1",
    "url": "/news/Oklahoma-Air-Quality-Rule-Changes-Effective-July-1",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Calculating Tank Emissions in Arizona",
    "apiurl": "/restapi/customnewscontentlvl2/news/Calculating-Tank-Emissions-in-Arizona",
    "url": "/news/Calculating-Tank-Emissions-in-Arizona",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Software Updates x3: U.S. EPA 18081 Executables Now Available in BREEZE AERMOD, AERSCREEN and AERMET",
    "apiurl": "/restapi/customnewscontentlvl2/news/Software-Updates-x3-U-S-EPA-18081-Executables-Now-Available-in-BREEZE-AERMOD-AERSCREEN-and-AERMET",
    "url": "/news/Software-Updates-x3-U-S-EPA-18081-Executables-Now-Available-in-BREEZE-AERMOD-AERSCREEN-and-AERMET",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Modeling Tip: How to import model objects from AERMOD-related files into BREEZE AERMOD",
    "apiurl": "/restapi/customnewscontentlvl2/news/Modeling-Tip-How-to-import-model-objects-from-AERMOD-related-files-into-BREEZE-AERMOD",
    "url": "/news/Modeling-Tip-How-to-import-model-objects-from-AERMOD-related-files-into-BREEZE-AERMOD",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Addendum Form to Accompany APEN Submittal",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Addend",
    "url": "/news/New-Addend",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Consumer Product Survey Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/Consumer-Product-Survey-Update",
    "url": "/news/Consumer-Product-Survey-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Using Clean Air Act Section 111(d) to Regulate Greenhouse Gases from Existing Electric Utilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/Using-Clean-Air-Act-Section-111(d)-to-Regulate-Greenhouse-Gases-from-Existing-Electric-Utilities",
    "url": "/news/Using-Clean-Air-Act-Section-111(d)-to-Regulate-Greenhouse-Gases-from-Existing-Electric-Utilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Title V Emission Inventory",
    "apiurl": "/restapi/customnewscontentlvl2/news/Title-V-Emission-Inventory",
    "url": "/news/Title-V-Emission-Inventory",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Executive Order Signed to Address Environmental Justice in Virginia-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Executive-Order-Signed-to-Address-Environmental-Justice-in-Virginia-Virginia",
    "url": "/news/Executive-Order-Signed-to-Address-Environmental-Justice-in-Virginia-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Section 112(r) Risk Management Plan Renewal Deadline Approaching",
    "apiurl": "/restapi/customnewscontentlvl2/news/Section-112(r)-Risk-Management-Plan-Renewal-Deadline-Approaching",
    "url": "/news/Section-112(r)-Risk-Management-Plan-Renewal-Deadline-Approaching",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Informal Comments on Ease of Application Rulemaking",
    "apiurl": "/restapi/customnewscontentlvl2/news/Informal-Comments-on-Ease-of-Application-Rulemaking",
    "url": "/news/Informal-Comments-on-Ease-of-Application-Rulemaking",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes PM NAAQS Revisions",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-PM-NAAQS-Revisions",
    "url": "/news/EPA-Proposes-PM-NAAQS-Revisions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD – Proposed Amended Rule 1410-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/SCAQMD-Proposed-Amended-Rule-1410-California",
    "url": "/news/SCAQMD-Proposed-Amended-Rule-1410-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Best Practices in PSM Incident Management",
    "apiurl": "/restapi/customnewscontentlvl2/news/best-practices-in-psm-incident-management",
    "url": "/news/best-practices-in-psm-incident-management",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Best Practices in PSM Incident Management",
    "apiurl": "/restapi/customnewscontentlvl2/news/best-practices-in-psm-incident-management",
    "url": "/News/Federal/Best-Practices-in-PSM-Incident-Management/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Latest News on Emissions Events from Oil and Gas Sites in the Permian Basin",
    "apiurl": "/restapi/customnewscontentlvl2/news/latest-news-on-emissions-events-from-oil-and-gas-sites-in-the-permian-basin",
    "url": "/news/latest-news-on-emissions-events-from-oil-and-gas-sites-in-the-permian-basin",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Latest News on Emissions Events from Oil and Gas Sites in the Permian Basin",
    "apiurl": "/restapi/customnewscontentlvl2/news/latest-news-on-emissions-events-from-oil-and-gas-sites-in-the-permian-basin",
    "url": "/www.trinityconsultants.com/latest-news-on-emissions-events-from-oil-and-gas-sites-in-the-permian-basin",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EHS Auditing Best Practices Part 4: Writing Effective Audit Findings",
    "apiurl": "/restapi/customnewscontentlvl2/news/ehs-auditing-best-practices-part-4-writing-effective-audit-findings",
    "url": "/news/ehs-auditing-best-practices-part-4-writing-effective-audit-findings",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Recent Reporting Updates for ROP C Permit Holders-Wisconsin",
    "apiurl": "/restapi/customnewscontentlvl2/news/Recent-Reporting-Updates-for-ROP-C-Permit-Holders-Wisconsin",
    "url": "/news/Recent-Reporting-Updates-for-ROP-C-Permit-Holders-Wisconsin",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SANGEA Updates for U.S. EPA 40 CFR 98 Subpart W GHG Emissions Reporting Year 2015",
    "apiurl": "/restapi/customnewscontentlvl2/news/SANGEA-Updates-for-U-S-EPA-40-CFR-98-Subpart-W-GHG-Emissions-Reporting-Year-2015",
    "url": "/news/SANGEA-Updates-for-U-S-EPA-40-CFR-98-Subpart-W-GHG-Emissions-Reporting-Year-2015",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Modeling for NAAQS Part 1: How to select the appropriate output for NO2",
    "apiurl": "/restapi/customnewscontentlvl2/news/Modeling-for-NAAQS-Part-1-How-to-select-the-appropriate-output-for-NO2",
    "url": "/news/Modeling-for-NAAQS-Part-1-How-to-select-the-appropriate-output-for-NO2",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Potential Follow-up Investigations in Response to USA TODAY Special Report: \"The Smokestack Effect\" -Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/Potential-Follow-up-Investigations-in-Response-to-USA-TODAY-Special-Report-The-Smokestack-Effect--Oregon",
    "url": "/news/Potential-Follow-up-Investigations-in-Response-to-USA-TODAY-Special-Report-The-Smokestack-Effect--Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Greenhouse Gas Reporting Rule: 2015 Revisions and Confidentiality Determinations for Petroleum and Natural Gas Systems",
    "apiurl": "/restapi/customnewscontentlvl2/news/Greenhouse-Gas-Reporting-Rule-2015-Revisions-and-Confidentiality-Determinations-for-Petroleum-and-Natural-Gas-Systems",
    "url": "/news/Greenhouse-Gas-Reporting-Rule-2015-Revisions-and-Confidentiality-Determinations-for-Petroleum-and-Natural-Gas-Systems",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD Proposed Rule 4001:  Maintenance of AQMP Emission Reduction Targets at Commercial Marine Ports",
    "apiurl": "/restapi/customnewscontentlvl2/news/SCAQMD-Proposed-Rule-4001-Maintenance-of-AQMP-Emission-Reduction-Targets-at-Commercial-Marine-Ports",
    "url": "/news/SCAQMD-Proposed-Rule-4001-Maintenance-of-AQMP-Emission-Reduction-Targets-at-Commercial-Marine-Ports",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New York State’s GHG Focus - Impact to NY Industry",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-york-states-ghg-focus-impact-to-ny-industry",
    "url": "/news/new-york-states-ghg-focus-impact-to-ny-industry",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New York State’s GHG Focus - Impact to NY Industry",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-york-states-ghg-focus-impact-to-ny-industry",
    "url": "/news/new-york-state-s-ghg-focus---impact-to-ny-industry",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Legislative Session Air Quality Bills",
    "apiurl": "/restapi/customnewscontentlvl2/news/Legislative-Session-Air-Quality-Bills",
    "url": "/news/Legislative-Session-Air-Quality-Bills",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Quality Client Contact Meeting-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Client-Contact-Meeting-Iowa",
    "url": "/news/Air-Quality-Client-Contact-Meeting-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Revisions to Kentucky Standards of Performance for Indirect Heat Exchangers (401 KAR 59:015)",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Revisions-to-Kentucky-Standards-of-Performance-for-Indirect-Heat-Exchangers-(401-KAR-59-015)-",
    "url": "/news/Proposed-Revisions-to-Kentucky-Standards-of-Performance-for-Indirect-Heat-Exchangers-(401-KAR-59-015)-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Triennial Emission Inventories",
    "apiurl": "/restapi/customnewscontentlvl2/news/triennial-emission-inventories",
    "url": "/news/triennial-emission-inventories",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "AB 32 Verification Services",
    "apiurl": "/restapi/customnewscontentlvl2/news/AB-32-Verification-Services",
    "url": "/news/AB-32-Verification-Services",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oregon Proposes Numerous Updates to Air Quality Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oregon-Proposes-Numerous-Updates-to-Air-Quality-Regulations",
    "url": "/news/Oregon-Proposes-Numerous-Updates-to-Air-Quality-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Dakota Reporting Reminders",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Dakota-Reporting-Reminders",
    "url": "/news/South-Dakota-Reporting-Reminders",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New York State DEC Proposes Updates to Part 212 Guidelines DAR-1",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-york-state-dec-proposes-updates-to-part-212-guidelines-dar-1",
    "url": "/news/new-york-state-dec-proposes-updates-to-part-212-guidelines-dar-1",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The New Ground-Level Ozone NAAQS and its Implications for Air Quality Permitting",
    "apiurl": "/restapi/customnewscontentlvl2/news/The-New-Ground-Level-Ozone-NAAQS-and-its-Implications-for-Air-Quality-Permitting",
    "url": "/news/The-New-Ground-Level-Ozone-NAAQS-and-its-Implications-for-Air-Quality-Permitting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Texas RY2018 Tier II Reporting Updates-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Texas-RY2018-Tier-II-Reporting-Updates-Texas",
    "url": "/news/Texas-RY2018-Tier-II-Reporting-Updates-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD Adopts New AB 617 Title V Facility Owner Fee and Suspends Other Proposed Fee Increases",
    "apiurl": "/restapi/customnewscontentlvl2/news/baaqmd-adopts-new-ab-617-title-v-facility-owner-fee-and-suspends-other-proposed-fee-increases",
    "url": "/news/baaqmd-adopts-new-ab-617-title-v-facility-owner-fee-and-suspends-other-proposed-fee-increases",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD Adopts New AB 617 Title V Facility Owner Fee and Suspends Other Proposed Fee Increases",
    "apiurl": "/restapi/customnewscontentlvl2/news/baaqmd-adopts-new-ab-617-title-v-facility-owner-fee-and-suspends-other-proposed-fee-increases",
    "url": "/states/baaqmd-adopts-new-ab-617-title-v-facility-owner-fee-and-suspends-other-proposed-fee-increases",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Veteran Consultant Selected to Lead Oklahoma City Office",
    "apiurl": "/restapi/customnewscontentlvl2/news/Veteran-Consultant-Selected-to-Lead-Oklahoma-City-Office",
    "url": "/news/Veteran-Consultant-Selected-to-Lead-Oklahoma-City-Office",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD Halts Proposed Rule 12-16 Affecting Petroleum Refiners-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/BAAQMD-Halts-Proposed-Rule-12-16-Affecting-Petroleum-Refiners-California",
    "url": "/news/BAAQMD-Halts-Proposed-Rule-12-16-Affecting-Petroleum-Refiners-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Drilling for Natural Gas – Proposed New NY Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Drilling-for-Natural-Gas-Proposed-New-NY-Regulations",
    "url": "/news/Drilling-for-Natural-Gas-Proposed-New-NY-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE ExDAM Identified as an Example for Advanced Situational Awareness",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-ExDAM-Identified-as-an-Example-for-Advanced-Situational-Awareness",
    "url": "/news/BREEZE-ExDAM-Identified-as-an-Example-for-Advanced-Situational-Awareness",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Acquires QSEM Solutions",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Acquires-QSEM-Solutions",
    "url": "/news/Trinity-Consultants-Acquires-QSEM-Solutions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SABRE Health & Safety, LLC Merges with SafeBridge® Consultants, Inc.",
    "apiurl": "/restapi/customnewscontentlvl2/news/SABRE-Health-Safety-LLC-Merges-with-SafeBridge-Consultants-Inc-",
    "url": "/news/SABRE-Health-Safety-LLC-Merges-with-SafeBridge-Consultants-Inc-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on 2018 ERMS Season-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-2018-ERMS-Season-Illinois",
    "url": "/news/Update-on-2018-ERMS-Season-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DOEE Finalizes Revisions to Fuel Sulfur Requirements in DC",
    "apiurl": "/restapi/customnewscontentlvl2/news/DOEE-Finalizes-Revisions-to-Fuel-Sulfur-Requirements-in-DC",
    "url": "/news/DOEE-Finalizes-Revisions-to-Fuel-Sulfur-Requirements-in-DC",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Finalized Regulation 84 Now Includes Oil and Gas Operations",
    "apiurl": "/restapi/customnewscontentlvl2/news/finalized-regulation-84-now-includes-oil-and-gas-operations",
    "url": "/news/finalized-regulation-84-now-includes-oil-and-gas-operations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Finalized Regulation 84 Now Includes Oil and Gas Operations",
    "apiurl": "/restapi/customnewscontentlvl2/news/finalized-regulation-84-now-includes-oil-and-gas-operations",
    "url": "/news/state/colorado/finalized-regulation-84-now-includes-oil-and-gas-operations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes Changes to 6 NESHAPS",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-Changes-to-6-NESHAPS",
    "url": "/news/EPA-Proposes-Changes-to-6-NESHAPS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EHS Auditing Best Practices Part 1: Audit Team Selection",
    "apiurl": "/restapi/customnewscontentlvl2/news/ehs-auditing-best-practices-part-1-audit-team-selection",
    "url": "/news/ehs-auditing-best-practices-part-1-audit-team-selection",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Modeling for Part 212 - Is Air Dispersion Modeling for Toxic Air Contaminants Required at my Facility?-New York",
    "apiurl": "/restapi/customnewscontentlvl2/news/Modeling-for-Part-212---Is-Air-Dispersion-Modeling-for-Toxic-Air-Contaminants-Required-at-my-Facility--New-York",
    "url": "/news/Modeling-for-Part-212---Is-Air-Dispersion-Modeling-for-Toxic-Air-Contaminants-Required-at-my-Facility--New-York",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Bay Area AQMD Revises Proposed Air Toxic Emissions Risk Reduction Rule-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/Bay-Area-AQMD-Revises-Proposed-Air-Toxic-Emissions-Risk-Reduction-Rule-California",
    "url": "/news/Bay-Area-AQMD-Revises-Proposed-Air-Toxic-Emissions-Risk-Reduction-Rule-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "General Air Permit for NESHAP Area Sources-Oklahoma",
    "apiurl": "/restapi/customnewscontentlvl2/news/General-Air-Permit-for-NESHAP-Area-Sources-Oklahoma",
    "url": "/news/General-Air-Permit-for-NESHAP-Area-Sources-Oklahoma",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated GHG Emissions Guidance-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updated-GHG-Emissions-Guidance-Iowa",
    "url": "/news/Updated-GHG-Emissions-Guidance-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Draft 2012 PM2.5 SIP",
    "apiurl": "/restapi/customnewscontentlvl2/news/Draft-2012-PM2-5-SIP",
    "url": "/news/Draft-2012-PM2-5-SIP",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Regional Haze: Utah Finishes 1st Planning Period SIP and Prepares for 2nd Planning Period-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/Regional-Haze-Utah-Finishes-1st-Planning-Period-SIP-and-Prepares-for-2nd-Planning-Period-Utah",
    "url": "/news/Regional-Haze-Utah-Finishes-1st-Planning-Period-SIP-and-Prepares-for-2nd-Planning-Period-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BOEM Announces the Revised Offshore Air Quality Regulations for Gulf of Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/boem-announces-the-revised-offshore-air-quality-regulations-for-gulf-of-mexico",
    "url": "/news/boem-announces-the-revised-offshore-air-quality-regulations-for-gulf-of-mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BOEM Announces the Revised Offshore Air Quality Regulations for Gulf of Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/boem-announces-the-revised-offshore-air-quality-regulations-for-gulf-of-mexico",
    "url": "/federal/boem-announces-the-revised-offshore-air-quality-regulations-for-gulf-of-mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Recommends All of Illinois Designated as Unclassifiable for 2012 Particulate Matter 2.5 National Ambient Air Quality Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Recommends-All-of-Illinois-Designated-as-Unclassifiable-for-2012-Particulate-Matter-2-5-National-Ambient-Air-Quality-Standard",
    "url": "/news/EPA-Recommends-All-of-Illinois-Designated-as-Unclassifiable-for-2012-Particulate-Matter-2-5-National-Ambient-Air-Quality-Standard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Upcoming Key Reporting Dates for 2010",
    "apiurl": "/restapi/customnewscontentlvl2/news/Upcoming-Key-Reporting-Dates-for-2010",
    "url": "/news/Upcoming-Key-Reporting-Dates-for-2010",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Certification of Connecticut's Nonattainment New Source Review Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/Certification-of-Connecticut's-Nonattainment-New-Source-Review-Program",
    "url": "/news/Certification-of-Connecticut's-Nonattainment-New-Source-Review-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Will New Controls Be Required for Your Facility in a Serious Ozone Nonattainment Area?-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Will-New-Controls-Be-Required-for-Your-Facility-in-a-Serious-Ozone-Nonattainment-Area--Colorado",
    "url": "/news/Will-New-Controls-Be-Required-for-Your-Facility-in-a-Serious-Ozone-Nonattainment-Area--Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SO2 NAAQS Outreach Process and Stakeholder Discussions",
    "apiurl": "/restapi/customnewscontentlvl2/news/SO2-NAAQS-Outreach-Process-and-Stakeholder-Discussions",
    "url": "/news/SO2-NAAQS-Outreach-Process-and-Stakeholder-Discussions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes to Michigan Construction Permitting Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/Changes-to-Michigan-Construction-Permitting-Rules",
    "url": "/news/Changes-to-Michigan-Construction-Permitting-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Guidance for Permit Exempt Facilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/Guidance-for-Permit-Exempt-Facilities",
    "url": "/news/Guidance-for-Permit-Exempt-Facilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Upcoming Reporting Requirements for Illinois Facilities - January 2019-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Upcoming-Reporting-Requirements-for-Illinois-Facilities---January-2019-Illinois",
    "url": "/news/Upcoming-Reporting-Requirements-for-Illinois-Facilities---January-2019-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Policy for Source Trials-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Policy-for-Source-Trials-Nebraska",
    "url": "/news/New-Policy-for-Source-Trials-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Other Regulatory Changes: Updated Code of Practice for the Management of PM2.5 Emissions in the Potash Sector in Canada-Ontario",
    "apiurl": "/restapi/customnewscontentlvl2/news/Other-Regulatory-Changes-Updated-Code-of-Practice-for-the-Management-of-PM2-5-Emissions-in-the-Potash-Sector-in-Canada-Ontario",
    "url": "/news/Other-Regulatory-Changes-Updated-Code-of-Practice-for-the-Management-of-PM2-5-Emissions-in-the-Potash-Sector-in-Canada-Ontario",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDEQ Mailed Title V Invoices-Mississippi",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDEQ-Mailed-Title-V-Invoices-Mississippi",
    "url": "/news/MDEQ-Mailed-Title-V-Invoices-Mississippi",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Clark County Department of Air Quality Proposed Area Designation Recommendations for the 2015 Ozone NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/Clark-County-Department-of-Air-Quality-Proposed-Area-Designation-Recommendations-for-the-2015-Ozone-NAAQS",
    "url": "/news/Clark-County-Department-of-Air-Quality-Proposed-Area-Designation-Recommendations-for-the-2015-Ozone-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MPCA Publishes State Wide GHG Emissions 1970-2006",
    "apiurl": "/restapi/customnewscontentlvl2/news/MPCA-Publishes-State-Wide-GHG-Emissions-1970-2006",
    "url": "/news/MPCA-Publishes-State-Wide-GHG-Emissions-1970-2006",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Title V Application Forms Must Be Used After August 15",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Title-V-Application-Forms-Must-Be-Used-After-August-15",
    "url": "/news/New-Title-V-Application-Forms-Must-Be-Used-After-August-15",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Implications of COVID-19 on Method 9 Evaluation Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/implications-of-covid-19-on-method-9-evaluation-requirements",
    "url": "/news/implications-of-covid-19-on-method-9-evaluation-requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oil and Gas Guidance Documents Revised",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oil-and-Gas-Guidance-Documents-Revised",
    "url": "/news/Oil-and-Gas-Guidance-Documents-Revised",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Implications for Kentucky of EPA's Withdrawal of Ozone NAAQS Reconsideration",
    "apiurl": "/restapi/customnewscontentlvl2/news/Implicatio",
    "url": "/news/Implicatio",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PADEP Air Quality Permit Fees Effective January 16th",
    "apiurl": "/restapi/customnewscontentlvl2/news/padep-air-quality-permit-fees-effective-january-16th",
    "url": "/news/padep-air-quality-permit-fees-effective-january-16th",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Coast Air Quality Management District – Proposed Amendments to RECLAIM",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Coast-Air-Quality-Management-District-Proposed-Amendments-to-RECLAIM",
    "url": "/news/South-Coast-Air-Quality-Management-District-Proposed-Amendments-to-RECLAIM",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated Modeling Protocol Template Available for Review",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updated-Modeling-Protocol-Template-Available-for-Review",
    "url": "/news/Updated-Modeling-Protocol-Template-Available-for-Review",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed RICE Rules Expansion",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-RICE-Rules-Expansion",
    "url": "/news/Proposed-RICE-Rules-Expansion",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Repeal of the NMAAQS Standard for TSP-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/Repeal-of-the-NMAAQS-Standard-for-TSP-New-Mexico",
    "url": "/news/Repeal-of-the-NMAAQS-Standard-for-TSP-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Adopts Changes to the Industrial Solid Waste and Municipal Hazardous Waste Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/TCEQ-Adopts-Changes-to-the-Industrial-Solid-Waste-and-Municipal-Hazardous-Waste-Rules",
    "url": "/news/TCEQ-Adopts-Changes-to-the-Industrial-Solid-Waste-and-Municipal-Hazardous-Waste-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Greenhouse Gas Mandatory Reporting Rule Subpart W Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Greenhouse-Gas-Mandatory-Reporting-Rule-Subpart-W-Updates",
    "url": "/news/Greenhouse-Gas-Mandatory-Reporting-Rule-Subpart-W-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Meeting to Discuss Lake Pahoja Water Quality Improvement Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Meeting-to-Discuss-Lake-Pahoja-Water-Quality-Improvement-Plan",
    "url": "/news/Meeting-to-Discuss-Lake-Pahoja-Water-Quality-Improvement-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD Proposed Rule 1114 - Petroleum Refinery Coking Operations",
    "apiurl": "/restapi/customnewscontentlvl2/news/SCAQMD-Proposed-Rule-1114---Petroleum-Refinery-Coking-Operations",
    "url": "/news/SCAQMD-Proposed-Rule-1114---Petroleum-Refinery-Coking-Operations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Rule: Emissions Monitoring Provisions in State Implementation Plans Required Under the NOx SIP Call",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-Rule-Emissions-Monitoring-Provisions-in-State-Implementation-Plans-Required-Under-the-NOx-SIP-Call",
    "url": "/news/Final-Rule-Emissions-Monitoring-Provisions-in-State-Implementation-Plans-Required-Under-the-NOx-SIP-Call",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to Ontario's Air Dispersion Models - 2018-Ontario",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-to-Ontario's-Air-Dispersion-Models---2018-Ontario",
    "url": "/news/Updates-to-Ontario's-Air-Dispersion-Models---2018-Ontario",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "January 2020 SafeBridge Newsletter",
    "apiurl": "/restapi/customnewscontentlvl2/news/January-2020-Newsletter",
    "url": "/news/January-2020-Newsletter",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Revisions to MBARD Rule 426 Architectural Coatings",
    "apiurl": "/restapi/customnewscontentlvl2/news/proposed-revisions-to-mbard-rule-426-architectural-coatings",
    "url": "/news/proposed-revisions-to-mbard-rule-426-architectural-coatings",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Revisions to MBARD Rule 426 Architectural Coatings",
    "apiurl": "/restapi/customnewscontentlvl2/news/proposed-revisions-to-mbard-rule-426-architectural-coatings",
    "url": "/news/state/california/proposed-revisions-to-mbard-rule-426-architectural-coatings",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Calculating Tank Emissions with TankESP",
    "apiurl": "/restapi/customnewscontentlvl2/news/calculating-tank-emissions-with-tankesp",
    "url": "/news/calculating-tank-emissions-with-tankesp",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Calculating Tank Emissions with TankESP",
    "apiurl": "/restapi/customnewscontentlvl2/news/calculating-tank-emissions-with-tankesp",
    "url": "/News/Technology/Calculating-Tank-Emissions-with-TankESP/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Navigating Net-Zero Commitments",
    "apiurl": "/restapi/customnewscontentlvl2/news/navigating-net-zero-commitments",
    "url": "/news/navigating-net-zero-commitments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Quality Contact Meeting Postponed",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Contact-Meeting-Postponed",
    "url": "/news/Air-Quality-Contact-Meeting-Postponed",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Modeling Guidance Meeting and Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Modeling-Guidance-Meeting-and-Updates",
    "url": "/news/Modeling-Guidance-Meeting-and-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Follow Up on Updates to Administrative Code of North Dakota Article 33-15",
    "apiurl": "/restapi/customnewscontentlvl2/news/Follow-Up-on-Updates-to-Administrative-Code-of-North-Dakota-Article-33-15",
    "url": "/news/Follow-Up-on-Updates-to-Administrative-Code-of-North-Dakota-Article-33-15",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ozone NAAQS Revisions Proposed  -Washington",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ozone-NAAQS-Revisions-Proposed--Washington",
    "url": "/news/Ozone-NAAQS-Revisions-Proposed--Washington",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Acquires QSEM Solutions",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Acquires-QSEM-Solutions",
    "url": "/news/Trinity-Acquires-QSEM-Solutions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The New York State Department of Environmental Conservation increases Title V fees!",
    "apiurl": "/restapi/customnewscontentlvl2/news/The-New-York-State-Department-of-Environmental-Conservation-increases-Title-V-fees!",
    "url": "/news/The-New-York-State-Department-of-Environmental-Conservation-increases-Title-V-fees!",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Employee Spotlight: Gena Driscoll",
    "apiurl": "/restapi/customnewscontentlvl2/news/employee-spotlight-gena-driscoll",
    "url": "/news/employee-spotlight-gena-driscoll",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The Texas Environmental, Health and Safety Audit Privilege Act",
    "apiurl": "/restapi/customnewscontentlvl2/news/The-Texas-Environmental-Health-and-Safety-Audit-Privilege-Act",
    "url": "/news/The-Texas-Environmental-Health-and-Safety-Audit-Privilege-Act",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE Releases CALPUFF 2.2 to Include Latest U.S. EPA Executable 5.8.4",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-Releases-CALPUFF-2-2-to-Include-Latest-U-S-EPA-Executable-5-8-4",
    "url": "/news/BREEZE-Releases-CALPUFF-2-2-to-Include-Latest-U-S-EPA-Executable-5-8-4",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Revises PSD Air Dispersion Modeling Guidance",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Revise",
    "url": "/news/EPA-Revise",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "February 23 IDNR Client Contact Meeting Notes",
    "apiurl": "/restapi/customnewscontentlvl2/news/February-23-IDNR-Client-Contact-Meeting-Notes",
    "url": "/news/February-23-IDNR-Client-Contact-Meeting-Notes",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Redesignation of Northern Kentucky Counties as Attainment for 8-Hour Ozone Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Redesignation-of-Northern-Kentucky-Counties-as-Attainment-for-8-Hour-Ozone-Standard",
    "url": "/news/Proposed-Redesignation-of-Northern-Kentucky-Counties-as-Attainment-for-8-Hour-Ozone-Standard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Acquires Sespe Consulting",
    "apiurl": "/restapi/customnewscontentlvl2/news/trinity-acquires-sespe-consulting",
    "url": "/news/trinity-acquires-sespe-consulting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DNREC Proposes Changes to Hazardous Waste Regulations-Delaware",
    "apiurl": "/restapi/customnewscontentlvl2/news/DNREC-Proposes-Changes-to-Hazardous-Waste-Regulations-Delaware",
    "url": "/news/DNREC-Proposes-Changes-to-Hazardous-Waste-Regulations-Delaware",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "RGGI Re-established in New Jersey-New Jersey",
    "apiurl": "/restapi/customnewscontentlvl2/news/RGGI-Re-established-in-New-Jersey-New-Jersey",
    "url": "/news/RGGI-Re-established-in-New-Jersey-New-Jersey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Approval of Iowa SIP Revisions Relating to Polk County Regulation Revisions",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Approval-of-Iowa-SIP-Revisions-Relating-to-Polk-County-Regulation-Revisions",
    "url": "/news/EPA-Approval-of-Iowa-SIP-Revisions-Relating-to-Polk-County-Regulation-Revisions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed regulation Part 20 – Regulation and Licensing of TENORM",
    "apiurl": "/restapi/customnewscontentlvl2/news/proposed-regulation-part-20-regulation-and-licensing-of-tenorm-",
    "url": "/news/proposed-regulation-part-20-regulation-and-licensing-of-tenorm-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed regulation Part 20 – Regulation and Licensing of TENORM",
    "apiurl": "/restapi/customnewscontentlvl2/news/proposed-regulation-part-20-regulation-and-licensing-of-tenorm-",
    "url": "/states/proposed-regulation-part-20-regulation-and-licensing-of-tenorm-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes Coming to Illinois Ozone Attainment Designations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Changes-Coming-to-Illinois-Ozone-Attainment-Designations",
    "url": "/news/Changes-Coming-to-Illinois-Ozone-Attainment-Designations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DOEE Finalizes New Source Category Permits",
    "apiurl": "/restapi/customnewscontentlvl2/news/DOEE-Finalizes-New-Source-Category-Permits",
    "url": "/news/DOEE-Finalizes-New-Source-Category-Permits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDEM Issues Draft Compliance Monitoring Rule Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDEM-Issues-Draft-Compliance-Monitoring-Rule-Updates",
    "url": "/news/IDEM-Issues-Draft-Compliance-Monitoring-Rule-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Public Workshop on Updates to SJVAPCD Rule 9510 Indirect Source Review",
    "apiurl": "/restapi/customnewscontentlvl2/news/Public-Workshop-on-Updates-to-SJVAPCD-Rule-9510-Indirect-Source-Review",
    "url": "/news/Public-Workshop-on-Updates-to-SJVAPCD-Rule-9510-Indirect-Source-Review",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Sustainability Reporting: Transitioning from G4 Guidelines to GRI Standards-Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/Sustainability-Reporting-Transitioning-from-G4-Guidelines-to-GRI-Standards-Missouri",
    "url": "/news/Sustainability-Reporting-Transitioning-from-G4-Guidelines-to-GRI-Standards-Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Draft Proposed State Mitigation Plan under the Volkswagen Consent Decree",
    "apiurl": "/restapi/customnewscontentlvl2/news/Draft-Proposed-State-Mitigation-Plan-under-the-Volkswagen-Consent-Decree",
    "url": "/news/Draft-Proposed-State-Mitigation-Plan-under-the-Volkswagen-Consent-Decree",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Climate Change Work Group Reveals Phase II Report",
    "apiurl": "/restapi/customnewscontentlvl2/news/Climate-Change-Work-Group-Reveals-Phase-II-Report",
    "url": "/news/Climate-Change-Work-Group-Reveals-Phase-II-Report",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ventura County APCD Proposed Revisions to Rule 74.15.1- Boilers, Steam Generators, and Process Heaters",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ventura-County-APCD-Proposed-Revisions-to-Rule-74-15-1--Boilers-Steam-Generators-and-Process-Heaters",
    "url": "/news/Ventura-County-APCD-Proposed-Revisions-to-Rule-74-15-1--Boilers-Steam-Generators-and-Process-Heaters",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendment to 10 CSR 10-5.220 Control of Petroleum Liquid Storage, Loading and Transfer",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendment-to-10-CSR-10-5-220-Control-of-Petroleum-Liquid-Storage-Loading-and-Transfer",
    "url": "/news/Proposed-Amendment-to-10-CSR-10-5-220-Control-of-Petroleum-Liquid-Storage-Loading-and-Transfer",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Industrial Solvent Cleaning for Chicago and Metro-East Areas....Take Two!",
    "apiurl": "/restapi/customnewscontentlvl2/news/Industrial-Solvent-Cleaning-for-Chicago-and-Metro-East-Areas-Take-Two!",
    "url": "/news/Industrial-Solvent-Cleaning-for-Chicago-and-Metro-East-Areas-Take-Two!",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Supreme Court Ruling Allows CSAPR to Proceed-North Dakota",
    "apiurl": "/restapi/customnewscontentlvl2/news/Supreme-Court-Ruling-Allows-CSAPR-to-Proceed-North-Dakota",
    "url": "/news/Supreme-Court-Ruling-Allows-CSAPR-to-Proceed-North-Dakota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Partial Disapproval of the TCEQ Interstate Transport SIP for the 2008 Ozone NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Partial-Disapproval-of-the-TCEQ-Interstate-Transport-SIP-for-the-2008-Ozone-NAAQS",
    "url": "/news/EPA-Partial-Disapproval-of-the-TCEQ-Interstate-Transport-SIP-for-the-2008-Ozone-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MEDEP Updates Title V/Part 70 Forms-Maine",
    "apiurl": "/restapi/customnewscontentlvl2/news/MEDEP-Updates-Title-V-Part-70-Forms-Maine",
    "url": "/news/MEDEP-Updates-Title-V-Part-70-Forms-Maine",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Quality Client Contact Meeting Highlights-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Client-Contact-Meeting-Highlights-Iowa",
    "url": "/news/Air-Quality-Client-Contact-Meeting-Highlights-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Import 2D and 3D Geometric Data with BREEZE AERMOD 7.11",
    "apiurl": "/restapi/customnewscontentlvl2/news/Import-2D-and-3D-Geometric-Data-with-BREEZE-AERMOD-7-11",
    "url": "/news/Import-2D-and-3D-Geometric-Data-with-BREEZE-AERMOD-7-11",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Georgia's Biennial Hazardous Waste Report and Reduction Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Georgia's-",
    "url": "/news/Georgia's-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Personnel Changes at the GA EPD",
    "apiurl": "/restapi/customnewscontentlvl2/news/Personnel-",
    "url": "/news/Personnel-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA’s Objections to TCEQ’s Federal Operating Permits",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-s-Objections-to-TCEQ-s-Federal-Operating-Permits",
    "url": "/news/EPA-s-Objections-to-TCEQ-s-Federal-Operating-Permits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cap-and-Trade August 2015 Joint-Auction Results Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/Cap-and-Trade-August-2015-Joint-Auction-Results-Released",
    "url": "/news/Cap-and-Trade-August-2015-Joint-Auction-Results-Released",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Significant Proposed Source Aggregation Rule for Oil and Gas Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/Significant-Proposed-Source-Aggregation-Rule-for-Oil-and-Gas-Sources",
    "url": "/news/Significant-Proposed-Source-Aggregation-Rule-for-Oil-and-Gas-Sources",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Smith Aldridge Joins Forces with Trinity Atlanta",
    "apiurl": "/restapi/customnewscontentlvl2/news/Smith-Aldridge-Joins-Forces-with-Trinity-Atlanta",
    "url": "/news/Smith-Aldridge-Joins-Forces-with-Trinity-Atlanta",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PC MACT Proposal May Signal Widespread Change",
    "apiurl": "/restapi/customnewscontentlvl2/news/PC-MACT-Proposal-May-Signal-Widespread-Change",
    "url": "/news/PC-MACT-Proposal-May-Signal-Widespread-Change",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Objection to KY Air Permit Signals PM2.5 Policy Change",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Objection-to-KY-Air-Permit-Signals-PM2-5-Policy-Change",
    "url": "/news/EPA-Objection-to-KY-Air-Permit-Signals-PM2-5-Policy-Change",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Follow Up on Updates to Administrative Rules of South Dakota Article 74:36",
    "apiurl": "/restapi/customnewscontentlvl2/news/Follow-Up-on-Updates-to-Administrative-Rules-of-South-Dakota-Article-74-36",
    "url": "/news/Follow-Up-on-Updates-to-Administrative-Rules-of-South-Dakota-Article-74-36",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CAPCA Celebrates Their 45th Anniversary in Asheville-South Carolina",
    "apiurl": "/restapi/customnewscontentlvl2/news/CAPCA-Celebrates-Their-45th-Anniversary-in-Asheville-South-Carolina",
    "url": "/news/CAPCA-Celebrates-Their-45th-Anniversary-in-Asheville-South-Carolina",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revisions to Air Quality Model Guidelines and Air Quality Model Meteorological Data-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revisions-to-Air-Quality-Model-Guidelines-and-Air-Quality-Model-Meteorological-Data-Iowa",
    "url": "/news/Revisions-to-Air-Quality-Model-Guidelines-and-Air-Quality-Model-Meteorological-Data-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Due Diligence in Acquiring Oil & Gas Properties",
    "apiurl": "/restapi/customnewscontentlvl2/news/Due-Diligence-in-Acquiring-Oil-Gas-Properties",
    "url": "/news/Due-Diligence-in-Acquiring-Oil-Gas-Properties",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Volkswagen Settlement Update-Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/Volkswagen-Settlement-Update-Missouri",
    "url": "/news/Volkswagen-Settlement-Update-Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Minnesota Governor Signs Environmental Permitting Bill",
    "apiurl": "/restapi/customnewscontentlvl2/news/Minnesota-Governor-Signs-Environmental-Permitting-Bill-",
    "url": "/news/Minnesota-Governor-Signs-Environmental-Permitting-Bill-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Effects on Ethanol: Change in Chemical Process Plant Definition",
    "apiurl": "/restapi/customnewscontentlvl2/news/Effects-on-Ethanol-Change-in-Chemical-Process-Plant-Definition",
    "url": "/news/Effects-on-Ethanol-Change-in-Chemical-Process-Plant-Definition",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2016 Toxic Catastrophe Prevention Act Fee Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/2016-Toxic-Catastrophe-Prevention-Act-Fee-Updates",
    "url": "/news/2016-Toxic-Catastrophe-Prevention-Act-Fee-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes Proposed for the Indiana SIP Regarding Startup, Shutdown and Malfunction Emissions",
    "apiurl": "/restapi/customnewscontentlvl2/news/Changes-Proposed-for-the-Indiana-SIP-Regarding-Startup-Shutdown-and-Malfunction-Emissions",
    "url": "/news/Changes-Proposed-for-the-Indiana-SIP-Regarding-Startup-Shutdown-and-Malfunction-Emissions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Promulgation of Illinois Air Quality Implementation Rules (NAAQS Update)",
    "apiurl": "/restapi/customnewscontentlvl2/news/Promulgation-of-Illinois-Air-Quality-Implementation-Rules-(NAAQS-Update)",
    "url": "/news/Promulgation-of-Illinois-Air-Quality-Implementation-Rules-(NAAQS-Update)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Public Input Opportunity: DNR Draft Proposal to Adopt NESHAP and NSPS",
    "apiurl": "/restapi/customnewscontentlvl2/news/Public-Input-Opportunity-DNR-Draft-Proposal-to-Adopt-NESHAP-and-NSPS",
    "url": "/news/Public-Input-Opportunity-DNR-Draft-Proposal-to-Adopt-NESHAP-and-NSPS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated NC Air Toxics Program - DAQ's New Approach",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updated-NC-Air-Toxics-Program---DAQ's-New-Approach",
    "url": "/news/Updated-NC-Air-Toxics-Program---DAQ's-New-Approach",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ozone Redesignation Substitute Rulemaking for HGB and DFW Areas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ozone-Redesignation-Substitute-Rulemaking-for-HGB-and-DFW-Areas",
    "url": "/news/Ozone-Redesignation-Substitute-Rulemaking-for-HGB-and-DFW-Areas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revisions to North  Dakota Administrative Code Article 33-15",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revisions-to-North-Dakota-Administrative-Code-Article-33-15",
    "url": "/news/Revisions-to-North-Dakota-Administrative-Code-Article-33-15",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Partner Spotlight - Intelex",
    "apiurl": "/restapi/customnewscontentlvl2/news/partner-spotlight---intelex",
    "url": "/news/partner-spotlight---intelex",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Partner Spotlight - Intelex",
    "apiurl": "/restapi/customnewscontentlvl2/news/partner-spotlight---intelex",
    "url": "/news/technology/partner-spotlight---intelex",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Addresses Climate Change",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Addresses-Climate-Change",
    "url": "/news/EPA-Addresses-Climate-Change",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Fee Increases on the Horizon",
    "apiurl": "/restapi/customnewscontentlvl2/news/Fee-Increases-on-the-Horizon-Illinois",
    "url": "/news/Fee-Increases-on-the-Horizon-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments to Rule 1110.2",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendments-to-Rule-1110-2",
    "url": "/news/Proposed-Amendments-to-Rule-1110-2",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Announces New Company President",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Announces-New-Company-President",
    "url": "/news/Trinity-Consultants-Announces-New-Company-President",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Greenhouse Gases Permitting Rules Brewing",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ-Greenhouse-Gases-Permitting-Rules-Brewing",
    "url": "/news/ADEQ-Greenhouse-Gases-Permitting-Rules-Brewing",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Nevada Agency Responses to EPA COVID-19 Temporary Policy",
    "apiurl": "/restapi/customnewscontentlvl2/news/nevada-agency-responses-to-epa-covid-19-temporary-policy",
    "url": "/news/nevada-agency-responses-to-epa-covid-19-temporary-policy",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TRI Back Reporting",
    "apiurl": "/restapi/customnewscontentlvl2/news/tri-back-reporting",
    "url": "/news/tri-back-reporting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TRI Back Reporting",
    "apiurl": "/restapi/customnewscontentlvl2/news/tri-back-reporting",
    "url": "/news/federal/tri-back-reporting/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PS Memo 14-04 - Guidance on Regulation 7 Oil and Gas LDAR, Open Ended Valves and Line Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/PS-Memo-14-04---Guidance-on-Regulation-7-Oil-and-Gas-LDAR-Open-Ended-Valves-and-Line-Requirements",
    "url": "/news/PS-Memo-14-04---Guidance-on-Regulation-7-Oil-and-Gas-LDAR-Open-Ended-Valves-and-Line-Requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Templates for Hot Mix Asphalt Plants and Aggregate Processing Plants",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Templates-for-Hot-Mix-Asphalt-Plants-and-Aggregate-Processing-Plants",
    "url": "/news/New-Templates-for-Hot-Mix-Asphalt-Plants-and-Aggregate-Processing-Plants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Issues Final Decision to Deny OTR Expansion Petition-Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Issues-Final-Decision-to-Deny-OTR-Expansion-Petition-Massachusetts",
    "url": "/news/EPA-Issues-Final-Decision-to-Deny-OTR-Expansion-Petition-Massachusetts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New AEERS System Required for Calendar Year 2016 Emission Inventory",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-AEERS-System-Required-for-Calendar-Year-2016-Emission-Inventory",
    "url": "/news/New-AEERS-System-Required-for-Calendar-Year-2016-Emission-Inventory",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Second Notice of Public Notice Updates-Indiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/Second-Notice-of-Public-Notice-Updates-Indiana",
    "url": "/news/Second-Notice-of-Public-Notice-Updates-Indiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Partner Spotlight - Cority",
    "apiurl": "/restapi/customnewscontentlvl2/news/partner-spotlight---cority",
    "url": "/news/partner-spotlight---cority",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Partner Spotlight - Cority",
    "apiurl": "/restapi/customnewscontentlvl2/news/partner-spotlight---cority",
    "url": "/news/partner-spotlight-cority",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KDAQ Revises PSD Regulations to Address PM2.5",
    "apiurl": "/restapi/customnewscontentlvl2/news/KDAQ-Revis",
    "url": "/news/KDAQ-Revis",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "20.2.37 NMAC Effective Repeal Date is September 12, 2016",
    "apiurl": "/restapi/customnewscontentlvl2/news/20-2-37-NMAC-Effective-Repeal-Date-is-September-12-2016",
    "url": "/news/20-2-37-NMAC-Effective-Repeal-Date-is-September-12-2016",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Extending Deadlines for BAMM Requests",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Extending-Deadlines-for-BAMM-Requests",
    "url": "/news/EPA-Extending-Deadlines-for-BAMM-Requests",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes to GHG MRR Subpart W",
    "apiurl": "/restapi/customnewscontentlvl2/news/Changes-to-GHG-MRR-Subpart-W",
    "url": "/news/Changes-to-GHG-MRR-Subpart-W",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Public Hearing for the Annual Evaluation of TDEC's Ambient Air Monitoring Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Public-Hearing-for-the-Annual-Evaluation-of-TDEC's-Ambient-Air-Monitoring-Plan",
    "url": "/news/Public-Hearing-for-the-Annual-Evaluation-of-TDEC's-Ambient-Air-Monitoring-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reporting Toxics Emissions: TRI Overview and Important Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reporting-Toxics-Emissions-TRI-Overview-and-Important-Updates",
    "url": "/news/Reporting-Toxics-Emissions-TRI-Overview-and-Important-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Colorado’s Proposed GHG Pollution Reduction Roadmap",
    "apiurl": "/restapi/customnewscontentlvl2/news/colorado-s-proposed-ghg-pollution-reduction-roadmap",
    "url": "/news/colorado-s-proposed-ghg-pollution-reduction-roadmap",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Colorado’s Proposed GHG Pollution Reduction Roadmap",
    "apiurl": "/restapi/customnewscontentlvl2/news/colorado-s-proposed-ghg-pollution-reduction-roadmap",
    "url": "/states/colorado/colorado-s-proposed-ghg-pollution-reduction-roadmap",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "What the 2015 MSGP Expiration Means and How to Stay in Compliance",
    "apiurl": "/restapi/customnewscontentlvl2/news/what-the-2015-msgp-expiration-means-and-how-to-stay-in-compliance",
    "url": "/news/what-the-2015-msgp-expiration-means-and-how-to-stay-in-compliance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "What the 2015 MSGP Expiration Means and How to Stay in Compliance",
    "apiurl": "/restapi/customnewscontentlvl2/news/what-the-2015-msgp-expiration-means-and-how-to-stay-in-compliance",
    "url": "/federal/what-the-2015-msgp-expiration-means-and-how-to-stay-in-compliance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Environmental Considerations for Acquisitions, Divestitures, and Mergers",
    "apiurl": "/restapi/customnewscontentlvl2/news/Environmental-Considerations-for-Acquisitions-Divestitures-and-Mergers",
    "url": "/news/Environmental-Considerations-for-Acquisitions-Divestitures-and-Mergers",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes Amendments to Boiler MACT Including Changes to Emission Limits",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-proposes-amendments-to-boiler-mact-including-changes-to-emission-limits",
    "url": "/news/epa-proposes-amendments-to-boiler-mact-including-changes-to-emission-limits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes Amendments to Boiler MACT Including Changes to Emission Limits",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-proposes-amendments-to-boiler-mact-including-changes-to-emission-limits",
    "url": "/federal/epa-proposes-amendments-to-boiler-mact-including-changes-to-emission-limits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEQ Updates to Permit Conditions in Air Quality Permits-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEQ-Updates-to-Permit-Conditions-in-Air-Quality-Permits-Nebraska",
    "url": "/news/NDEQ-Updates-to-Permit-Conditions-in-Air-Quality-Permits-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reporting Reminders-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reporting-Reminders-Nebraska",
    "url": "/news/Reporting-Reminders-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Re-Proposes Boiler NESHAP",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Re-Proposes-Boiler-NESHAP",
    "url": "/news/EPA-Re-Proposes-Boiler-NESHAP",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Agrees to Issue Final Rule for Coal Ash by Dec. 19",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Agrees-to-Issue-Final-Rule-for-Coal-Ash-by-Dec-19",
    "url": "/news/EPA-Agrees-to-Issue-Final-Rule-for-Coal-Ash-by-Dec-19",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Acquires U.K. Ecology Firm ECOSA",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Acquires-U-K-Ecology-Firm-ECOSA",
    "url": "/news/Trinity-Consultants-Acquires-U-K-Ecology-Firm-ECOSA",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Virginia to Increase Fees-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Virginia-to-Increase-Fees-Virginia",
    "url": "/news/Virginia-to-Increase-Fees-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Two New NSR Actions",
    "apiurl": "/restapi/customnewscontentlvl2/news/Two-New-NSR-Actions",
    "url": "/news/Two-New-NSR-Actions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EKAPCD Proposed Amendments to Rules 301, 302, 303, and 402, and Proposed New Rule 402.2",
    "apiurl": "/restapi/customnewscontentlvl2/news/EKAPCD-Proposed-Amendments-to-Rules-301-302-303-and-402-and-Proposed-New-Rule-402-2",
    "url": "/news/EKAPCD-Proposed-Amendments-to-Rules-301-302-303-and-402-and-Proposed-New-Rule-402-2",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Meetings Scheduled to Discuss SCAQMD/CARB Emission Reduction Plans",
    "apiurl": "/restapi/customnewscontentlvl2/news/meetings-scheduled-to-discuss-scaqmd-carb-emission-reduction-plans",
    "url": "/news/meetings-scheduled-to-discuss-scaqmd-carb-emission-reduction-plans",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Meetings Scheduled to Discuss SCAQMD/CARB Emission Reduction Plans",
    "apiurl": "/restapi/customnewscontentlvl2/news/meetings-scheduled-to-discuss-scaqmd-carb-emission-reduction-plans",
    "url": "/news/state/california/meetings-scheduled-to-discuss-scaqmd-carb-emission-reduction-plans",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "UDAQ Amend R307-335: Degreasing and Solvent Cleaning Operations and Propose New Rule R307-304: Industrial Solvent Use",
    "apiurl": "/restapi/customnewscontentlvl2/news/UDAQ-Amend-R307-335-Degreasing-and-Solvent-Cleaning-Operations-and-Propose-New-Rule-R307-304-Industrial-Solvent-Use",
    "url": "/news/UDAQ-Amend-R307-335-Degreasing-and-Solvent-Cleaning-Operations-and-Propose-New-Rule-R307-304-Industrial-Solvent-Use",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Takes Final Action to Approve SJVAPCD Revisions to Rule 4702, Internal Combustion Engines",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Takes-Final-Action-to-Approve-SJVAPCD-Revisions-to-Rule-4702-Internal-Combustion-Engines",
    "url": "/news/EPA-Takes-Final-Action-to-Approve-SJVAPCD-Revisions-to-Rule-4702-Internal-Combustion-Engines",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Permitting Options for Minor Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Permitting-Options-for-Minor-Sources-",
    "url": "/news/New-Permitting-Options-for-Minor-Sources-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDDEQ Outlines Compliance Requirements for Condensate Truck Loadout Emissions-North Dakota",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDDEQ-Outlines-Compliance-Requirements-for-Condensate-Truck-Loadout-Emissions-North-Dakota",
    "url": "/news/NDDEQ-Outlines-Compliance-Requirements-for-Condensate-Truck-Loadout-Emissions-North-Dakota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ozone NAAQS Revisions Proposed     -Montana",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ozone-NAAQS-Revisions-Proposed--Montana",
    "url": "/news/Ozone-NAAQS-Revisions-Proposed--Montana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Comment Period for the Emission Reduction Credit Program Ending-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Comment-Period-for-the-Emission-Reduction-Credit-Program-Ending-Colorado",
    "url": "/news/Comment-Period-for-the-Emission-Reduction-Credit-Program-Ending-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "UDAQ’s 2019 Proposed Rule Summary for Stationary Sources-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/UDAQ-s-2019-Proposed-Rule-Summary-for-Stationary-Sources-Utah",
    "url": "/news/UDAQ-s-2019-Proposed-Rule-Summary-for-Stationary-Sources-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "California Adopts New Federal Hazard Categories for Hazardous Material Business Plans-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/California-Adopts-New-Federal-Hazard-Categories-for-Hazardous-Material-Business-Plans-California",
    "url": "/news/California-Adopts-New-Federal-Hazard-Categories-for-Hazardous-Material-Business-Plans-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Illinois Adopts NAAQS Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/Illinois-Adopts-NAAQS-Amendments",
    "url": "/news/Illinois-Adopts-NAAQS-Amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PM2.5 Nonattainment Areas Designations in Washington, Oregon, Idaho and Alaska-Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/PM2-5-Nonattainment-Areas-Designations-in-Washington-Oregon-Idaho-and-Alaska-Oregon",
    "url": "/news/PM2-5-Nonattainment-Areas-Designations-in-Washington-Oregon-Idaho-and-Alaska-Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed GHG Emission Requirements for Washington Petroleum Refineries",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-GHG-Emission-Requirements-for-Washington-Petroleum-Refineries",
    "url": "/news/Proposed-GHG-Emission-Requirements-for-Washington-Petroleum-Refineries",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Kentucky Sources Required to use DAQ Web-Survey for 2008 Emissions Inventory",
    "apiurl": "/restapi/customnewscontentlvl2/news/Kentucky-S",
    "url": "/news/Kentucky-S",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Stakeholder Review Drafts Released-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/Stakeholder-Review-Drafts-Released-New-Mexico",
    "url": "/news/Stakeholder-Review-Drafts-Released-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Colorado Rulemaking for Class B Firefighting Foam with PFAS",
    "apiurl": "/restapi/customnewscontentlvl2/news/colorado-rulemaking-for-class-b-firefighting-foam-with-pfas",
    "url": "/news/colorado-rulemaking-for-class-b-firefighting-foam-with-pfas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Upcoming Reporting Requirements for Illinois Facilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/Upcoming-Reporting-Requirements-for-Illinois-Facilities",
    "url": "/news/Upcoming-Reporting-Requirements-for-Illinois-Facilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NJDEP Quarterly Industrial Stakeholders/Air Permitting Group Meeting Updates-New Jersey",
    "apiurl": "/restapi/customnewscontentlvl2/news/NJDEP-Quarterly-Industrial-Stakeholders-Air-Permitting-Group-Meeting-Updates-New-Jersey",
    "url": "/news/NJDEP-Quarterly-Industrial-Stakeholders-Air-Permitting-Group-Meeting-Updates-New-Jersey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oregon Air Toxics Benchmarks Proposed Rulemaking-Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oregon-Air-Toxics-Benchmarks-Proposed-Rulemaking-Oregon",
    "url": "/news/Oregon-Air-Toxics-Benchmarks-Proposed-Rulemaking-Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Most GHG Reporting Facilities Affected by EPA Rule Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/Most-GHG-R",
    "url": "/news/Most-GHG-R",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Tier II Web-Based Reporting System-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/TCEQ-Tier-II-Web-Based-Reporting-System-Texas",
    "url": "/news/TCEQ-Tier-II-Web-Based-Reporting-System-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Leader in New Mexico Brings Mining Expertise",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Leader-in-New-Mexico-Brings-Mining-Expertise",
    "url": "/news/New-Leader-in-New-Mexico-Brings-Mining-Expertise",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NC Amended Ozone Boundary Recommendation Package",
    "apiurl": "/restapi/customnewscontentlvl2/news/NC-Amended-Ozone-Boundary-Recommendation-Package",
    "url": "/news/NC-Amended-Ozone-Boundary-Recommendation-Package",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Effluent Limits Set for Steam Electric Plants",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Effluent-Limits-Set-for-Steam-Electric-Plants",
    "url": "/news/New-Effluent-Limits-Set-for-Steam-Electric-Plants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Common Findings in OSHA PSM Audits",
    "apiurl": "/restapi/customnewscontentlvl2/news/Common-Findings-in-OSHA-PSM-Audits",
    "url": "/news/Common-Findings-in-OSHA-PSM-Audits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to TCEQ Fugitive Guidance Document-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-to-TCEQ-Fugitive-Guidance-Document-Texas",
    "url": "/news/Updates-to-TCEQ-Fugitive-Guidance-Document-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "San Joaquin Valley Area Attains the 2008 1-Hour Ozone NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/San-Joaquin-Valley-Area-Attains-the-2008-1-Hour-Ozone-NAAQS",
    "url": "/news/San-Joaquin-Valley-Area-Attains-the-2008-1-Hour-Ozone-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Merges with Church & Trought, Inc., Expanding Into Canada",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Merges-with-Church-Trought-Inc-Expanding-Into-Canada",
    "url": "/news/Trinity-Consultants-Merges-with-Church-Trought-Inc-Expanding-Into-Canada",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDNR Considers Changes to Construction and Operating Permit Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDNR-Considers-Changes-to-Construction-and-Operating-Permit-Rules",
    "url": "/news/MDNR-Considers-Changes-to-Construction-and-Operating-Permit-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Rule - Particulate Matter from Fuel Burning Equipment Used for Indirect Heating Placed on Hold for Now",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Rule---Particulate-Matter-from-Fuel-Burning-Equipment-Used-for-Indirect-Heating-Placed-on-Hold-for-Now",
    "url": "/news/Proposed-Rule---Particulate-Matter-from-Fuel-Burning-Equipment-Used-for-Indirect-Heating-Placed-on-Hold-for-Now",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Public Hearing for Amendments to SJVAPCD Rule 9510 - Indirect Source Review",
    "apiurl": "/restapi/customnewscontentlvl2/news/Public-Hearing-for-Amendments-to-SJVAPCD-Rule-9510---Indirect-Source-Review",
    "url": "/news/Public-Hearing-for-Amendments-to-SJVAPCD-Rule-9510---Indirect-Source-Review",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "RMP eSubmit Available",
    "apiurl": "/restapi/customnewscontentlvl2/news/RMP-eSubmit-Available",
    "url": "/news/RMP-eSubmit-Available",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DDOE Finalizes Changes to Visible Emissions Standards",
    "apiurl": "/restapi/customnewscontentlvl2/news/DDOE-Finalizes-Changes-to-Visible-Emissions-Standards",
    "url": "/news/DDOE-Finalizes-Changes-to-Visible-Emissions-Standards",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Opens New Office In Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Opens-New-Office-In-Iowa",
    "url": "/news/Trinity-Consultants-Opens-New-Office-In-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Section 114 for Boiler MACT",
    "apiurl": "/restapi/customnewscontentlvl2/news/Section-114-for-Boiler-MACT",
    "url": "/news/Section-114-for-Boiler-MACT",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Hourly Nitrogen Dioxide Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Hourly-Nitrogen-Dioxide-Standard",
    "url": "/news/New-Hourly-Nitrogen-Dioxide-Standard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Quality Rule Changes in Progress",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Rule-Changes-in-Progress",
    "url": "/news/Air-Quality-Rule-Changes-in-Progress",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MPCA Will No Longer Accept TANKS 4.09d Data-Minnesota",
    "apiurl": "/restapi/customnewscontentlvl2/news/MPCA-Will-No-Longer-Accept-TANKS-4-09d-Data-Minnesota",
    "url": "/news/MPCA-Will-No-Longer-Accept-TANKS-4-09d-Data-Minnesota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oil & Gas Permitting Guidance Update-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oil-Gas-Permitting-Guidance-Update-Wyoming",
    "url": "/news/Oil-Gas-Permitting-Guidance-Update-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Permitting Deferral for Biogenic Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Permitting-Deferral-for-Biogenic-Sources",
    "url": "/news/EPA-Permitting-Deferral-for-Biogenic-Sources",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Bay Area AQMD Proposes Revisions to Rule 2-5: New Source Review of Toxic Air Contaminants",
    "apiurl": "/restapi/customnewscontentlvl2/news/Bay-Area-AQMD-Proposes-Revisions-to-Rule-2-5-New-Source-Review-of-Toxic-Air-Contaminants",
    "url": "/news/Bay-Area-AQMD-Proposes-Revisions-to-Rule-2-5-New-Source-Review-of-Toxic-Air-Contaminants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Refinery MACT Residual Risk",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Refinery-MACT-Residual-Risk",
    "url": "/news/EPA-Refinery-MACT-Residual-Risk",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Title V Workshop (April 22nd and 23rd)",
    "apiurl": "/restapi/customnewscontentlvl2/news/Title-V-Workshop-(April-22nd-and-23rd)",
    "url": "/news/Title-V-Workshop-(April-22nd-and-23rd)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Lifts Stay on Turbine NESHAP: Risks for Post-2003 Turbines at Major HAP Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-lifts-stay-on-turbine-neshap-risks-for-post-2003-turbines-at-major-hap-sources",
    "url": "/news/epa-lifts-stay-on-turbine-neshap-risks-for-post-2003-turbines-at-major-hap-sources",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Lifts Stay on Turbine NESHAP: Risks for Post-2003 Turbines at Major HAP Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-lifts-stay-on-turbine-neshap-risks-for-post-2003-turbines-at-major-hap-sources",
    "url": "/News/Federal/EPA-Lifts-Stay-on-Turbine-NESHAP--Risks-for-Post-2003-Turbines-at-Major-HAP-Sources/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SLEIS for CY2015 Emissions Inventory and Training",
    "apiurl": "/restapi/customnewscontentlvl2/news/SLEIS-for-CY2015-Emissions-Inventory-and-Training",
    "url": "/news/SLEIS-for-CY2015-Emissions-Inventory-and-Training",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Winter time emissions inventories Deadline Approaching-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Winter-time-emissions-inventories-Deadline-Approaching-Wyoming",
    "url": "/news/Winter-time-emissions-inventories-Deadline-Approaching-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Issues Clarifications On Greenhouse Gas Permitting",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ-Issues-Clarifications-On-Greenhouse-Gas-Permitting",
    "url": "/news/ADEQ-Issues-Clarifications-On-Greenhouse-Gas-Permitting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Permit Deviation / Excess Emissions Reporting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Permit-Deviation-Excess-Emissions-Reporting",
    "url": "/news/Permit-Deviation-Excess-Emissions-Reporting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposal to Increase Fees for Permits, Approvals, and Registration",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposal-to-Increase-Fees-for-Permits-Approvals-and-Registration",
    "url": "/news/Proposal-to-Increase-Fees-for-Permits-Approvals-and-Registration",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDEQ Recommends Nonattainment Designations for 2015 Ozone Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDEQ-Recommends-Nonattainment-Designations-for-2015-Ozone-Standard",
    "url": "/news/MDEQ-Recommends-Nonattainment-Designations-for-2015-Ozone-Standard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Triennial Minor Source Emission Inventories Due April 30-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Triennial-Minor-Source-Emission-Inventories-Due-April-30-Wyoming",
    "url": "/news/Triennial-Minor-Source-Emission-Inventories-Due-April-30-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Montana DEQ COVID-19 Response",
    "apiurl": "/restapi/customnewscontentlvl2/news/montana-deq-covid-19-response",
    "url": "/news/montana-deq-covid-19-response",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NOx Budget Trading Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/NOx-Budget-Trading-Program",
    "url": "/news/NOx-Budget-Trading-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Arizona Withdraws from the Western Climate Initiative",
    "apiurl": "/restapi/customnewscontentlvl2/news/Arizona-Withdraws-from-the-Western-Climate-Initiative",
    "url": "/news/Arizona-Withdraws-from-the-Western-Climate-Initiative",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EHS Professionals Leading the Way on COVID-19",
    "apiurl": "/restapi/customnewscontentlvl2/news/ehs-professionals-leading-the-way-on-covid-19-",
    "url": "/news/ehs-professionals-leading-the-way-on-covid-19-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EHS Professionals Leading the Way on COVID-19",
    "apiurl": "/restapi/customnewscontentlvl2/news/ehs-professionals-leading-the-way-on-covid-19-",
    "url": "/Technology/EHS-Professionals-Leading-the-Way-on-COVID-19/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EHS Professionals Leading the Way on COVID-19",
    "apiurl": "/restapi/customnewscontentlvl2/news/ehs-professionals-leading-the-way-on-covid-19-",
    "url": "/news/federal/Technology/EHS-Professionals-Leading-the-Way-on-COVID-19/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IMPACT System Operating for 2019 Annual Emission Inventory Submittals",
    "apiurl": "/restapi/customnewscontentlvl2/news/IMPACT-System-Operating-for-2019-Annual-Emission-Inventory-Submittals",
    "url": "/news/IMPACT-System-Operating-for-2019-Annual-Emission-Inventory-Submittals",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IMPACT System Operating for 2019 Annual Emission Inventory Submittals",
    "apiurl": "/restapi/customnewscontentlvl2/news/IMPACT-System-Operating-for-2019-Annual-Emission-Inventory-Submittals",
    "url": "/states/arizona/impact-system-operating-for-2019-annual-emission-inventory-submittals",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Environmental Protection Commission Meeting-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Environmental-Protection-Commission-Meeting-Iowa",
    "url": "/news/Environmental-Protection-Commission-Meeting-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Coast Air Quality Management District - Proposed Amendments to Regulation XX",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Coast-Air-Quality-Management-District---Proposed-Amendments-to-Regulation-XX",
    "url": "/news/South-Coast-Air-Quality-Management-District---Proposed-Amendments-to-Regulation-XX",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MACT Hammer Implementation in Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/MACT-Hammer-Implementation-in-Oregon",
    "url": "/news/MACT-Hammer-Implementation-in-Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Permitting Stragegy for Complex and Phased Projects",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Permitting-Stragegy-for-Complex-and-Phased-Projects",
    "url": "/news/Air-Permitting-Stragegy-for-Complex-and-Phased-Projects",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Does Your SPCC Plan Make the Grade? Lessons Learned from EPA Inspections-South Carolina",
    "apiurl": "/restapi/customnewscontentlvl2/news/Does-Your-SPCC-Plan-Make-the-Grade-Lessons-Learned-from-EPA-Inspections-South-Carolina",
    "url": "/news/Does-Your-SPCC-Plan-Make-the-Grade-Lessons-Learned-from-EPA-Inspections-South-Carolina",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KC Chamber and Partners host 2015 Midwest Environmental Compliance Conference (MECC)-Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/KC-Chamber-and-Partners-host-2015-Midwest-Environmental-Compliance-Conference-(MECC)-Missouri",
    "url": "/news/KC-Chamber-and-Partners-host-2015-Midwest-Environmental-Compliance-Conference-(MECC)-Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Look, Expanded Expertise, Continued Commitment to Clients",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-look-expanded-expertise-continued-commitment-to-clients",
    "url": "/news/new-look-expanded-expertise-continued-commitment-to-clients",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Look, Expanded Expertise, Continued Commitment to Clients",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-look-expanded-expertise-continued-commitment-to-clients",
    "url": "/news/company/new-look-expanded-expertise-continued-commitment-to-clients",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Attainment/Unclassifiable Designations for the 2015 Ozone National Ambient Air Quality Standards (NAAQS) Are Now Final!-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/Attainment-Unclassifiable-Designations-for-the-2015-Ozone-National-Ambient-Air-Quality-Standards-(NAAQS)-Are-Now-Final!-Utah",
    "url": "/news/Attainment-Unclassifiable-Designations-for-the-2015-Ozone-National-Ambient-Air-Quality-Standards-(NAAQS)-Are-Now-Final!-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Rural NO2 Background Concentrations Developed",
    "apiurl": "/restapi/customnewscontentlvl2/news/Rural-NO2-Background-Concentrations-Developed",
    "url": "/news/Rural-NO2-Background-Concentrations-Developed",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oklahoma General Air Permit for NESHAP Area Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oklahoma-General-Air-Permit-for-NESHAP-Area-Sources",
    "url": "/news/Oklahoma-General-Air-Permit-for-NESHAP-Area-Sources",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2013 Emission Inventory Reminder",
    "apiurl": "/restapi/customnewscontentlvl2/news/2013-Emission-Inventory-Reminder-",
    "url": "/news/2013-Emission-Inventory-Reminder-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Odour Study Descriptions-Ontario",
    "apiurl": "/restapi/customnewscontentlvl2/news/Odour-Study-Descriptions-Ontario",
    "url": "/news/Odour-Study-Descriptions-Ontario",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Option for Tank Rule NSPS Subpart Kb",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-option-for-tank-rule-nsps-subpart-kb",
    "url": "/news/new-option-for-tank-rule-nsps-subpart-kb",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Annual Compliance Certifications",
    "apiurl": "/restapi/customnewscontentlvl2/news/Annual-Compliance-Certifications",
    "url": "/news/Annual-Compliance-Certifications",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Recent PFAS Related Activity in Canada",
    "apiurl": "/restapi/customnewscontentlvl2/news/recent-pfas-related-activity-in-canada",
    "url": "/news/recent-pfas-related-activity-in-canada",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Georgia Permit Fees",
    "apiurl": "/restapi/customnewscontentlvl2/news/Georgia-Permit-Fees",
    "url": "/news/Georgia-Permit-Fees",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KC Metro Ozone Designation",
    "apiurl": "/restapi/customnewscontentlvl2/news/KC-Metro-Ozone-Designation",
    "url": "/news/KC-Metro-Ozone-Designation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Dispersion Modeling e-Service Now Available",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Dispersion-Modeling-e-Service-Now-Available",
    "url": "/news/Air-Dispersion-Modeling-e-Service-Now-Available",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Sets Up Outreach Process and Stakeholder Discussions for SO2 NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Sets-Up-Outreach-Process-and-Stakeholder-Discussions-for-SO2-NAAQS",
    "url": "/news/EPA-Sets-Up-Outreach-Process-and-Stakeholder-Discussions-for-SO2-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Carbon XPRIZE Competition Finalists Coming to the Wyoming Integrated Test Center-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Carbon-XPRIZE-Competition-Finalists-Coming-to-the-Wyoming-Integrated-Test-Center-Wyoming",
    "url": "/news/Carbon-XPRIZE-Competition-Finalists-Coming-to-the-Wyoming-Integrated-Test-Center-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Updates on Tier II Chemical Reporting Process for Reporting Year 2019-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/TCEQ-Updates-on-Tier-II-Chemical-Reporting-Process-for-Reporting-Year-2019-Texas",
    "url": "/news/TCEQ-Updates-on-Tier-II-Chemical-Reporting-Process-for-Reporting-Year-2019-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Greenhouse Gas (GHG) Emissions Reporting - October 1-Ontario",
    "apiurl": "/restapi/customnewscontentlvl2/news/Greenhouse-Gas-(GHG)-Emissions-Reporting---October-1-Ontario",
    "url": "/news/Greenhouse-Gas-(GHG)-Emissions-Reporting---October-1-Ontario",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE Releases AERSCREEN 1.6 to Support Latest U.S. EPA Executable 14147",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-Releases-AERSCREEN-1-6-to-Support-Latest-U-S-EPA-Executable-14147",
    "url": "/news/BREEZE-Releases-AERSCREEN-1-6-to-Support-Latest-U-S-EPA-Executable-14147",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NYSDEC Finalizes Revisions to DAR-1, the Guidelines for the Evaluation and Control of Ambient Air Contaminants under Part 212",
    "apiurl": "/restapi/customnewscontentlvl2/news/NYSDEC-Finalizes-Revisions-to-DAR-1-the-Guidelines-for-the-Evaluation-and-Control-of-Ambient-Air-Contaminants-under-Part-212",
    "url": "/news/NYSDEC-Finalizes-Revisions-to-DAR-1-the-Guidelines-for-the-Evaluation-and-Control-of-Ambient-Air-Contaminants-under-Part-212",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Rhode Island Department of Environmental Management Proposes Outdoor Wood Boiler Regulation",
    "apiurl": "/restapi/customnewscontentlvl2/news/Rhode-Island-Department-of-Environmental-Management-Proposes-Outdoor-Wood-Boiler-Regulation",
    "url": "/news/Rhode-Island-Department-of-Environmental-Management-Proposes-Outdoor-Wood-Boiler-Regulation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE Risk Analyst Overview Presentation",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-Risk-Analyst-Overview-Presentation-",
    "url": "/news/BREEZE-Risk-Analyst-Overview-Presentation-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Draft Cleaner Air Oregon Rules Published-Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/Draft-Cleaner-Air-Oregon-Rules-Published-Oregon",
    "url": "/news/Draft-Cleaner-Air-Oregon-Rules-Published-Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ambient Air Monitoring at Marcellus Shale Drilling Locations in Pennsylvania",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ambient-Air-Monitoring-at-Marcellus-Shale-Drilling-Locations-in-Pennsylvania",
    "url": "/news/Ambient-Air-Monitoring-at-Marcellus-Shale-Drilling-Locations-in-Pennsylvania",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Title V Facilities' Emissions Reports due March 31, 2016",
    "apiurl": "/restapi/customnewscontentlvl2/news/Title-V-Facilities'-Emissions-Reports-due-March-31-2016",
    "url": "/news/Title-V-Facilities'-Emissions-Reports-due-March-31-2016",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "WVDEP Announces New Date for 2010 Emission Inventory Submission",
    "apiurl": "/restapi/customnewscontentlvl2/news/WVDEP-Announces-New-Date-for-2010-Emission-Inventory-Submission",
    "url": "/news/WVDEP-Announces-New-Date-for-2010-Emission-Inventory-Submission",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Attempts to Sets Precedent for Opacity Monitoring Technology",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Attempts-to-Sets-Precedent-for-Opacity-Monitoring-Technology",
    "url": "/news/EPA-Attempts-to-Sets-Precedent-for-Opacity-Monitoring-Technology",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Georgia EPD's Recommendation for Non-attainment Area Designations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Georgia-EPD's-Recommendation-for-Non-attainment-Area-Designations",
    "url": "/news/Georgia-EPD's-Recommendation-for-Non-attainment-Area-Designations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TankESPTip - How to locate the backend file and load it into BREEZE TankESP Version 5.0",
    "apiurl": "/restapi/customnewscontentlvl2/news/TankESPTip---How-to-locate-the-backend-file-and-load-it-into-BREEZE-TankESP-Version-5-0",
    "url": "/news/TankESPTip---How-to-locate-the-backend-file-and-load-it-into-BREEZE-TankESP-Version-5-0",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PHA Inconsistency Series - Part I: The Impact of PHA Inconsistencies",
    "apiurl": "/restapi/customnewscontentlvl2/news/the-impact-of-pha-inconsistencies",
    "url": "/news/the-impact-of-pha-inconsistencies",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PHA Inconsistency Series - Part I: The Impact of PHA Inconsistencies",
    "apiurl": "/restapi/customnewscontentlvl2/news/the-impact-of-pha-inconsistencies",
    "url": "/federal/the-impact-of-pha-inconsistencies",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PHA Inconsistency Series - Part I: The Impact of PHA Inconsistencies",
    "apiurl": "/restapi/customnewscontentlvl2/news/the-impact-of-pha-inconsistencies",
    "url": "/news/federal/the-impact-of-pha-inconsistencies",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Using FOIA for Environmental Advantage",
    "apiurl": "/restapi/customnewscontentlvl2/news/Using-FOIA-for-Environmental-Advantage",
    "url": "/news/Using-FOIA-for-Environmental-Advantage",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NCDAQ's Area Source Boiler Assistance Campaign and Initial Notification Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/NCDAQ's-Area-Source-Boiler-Assistance-Campaign-and-Initial-Notification-Requirements",
    "url": "/news/NCDAQ's-Area-Source-Boiler-Assistance-Campaign-and-Initial-Notification-Requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Odor Rule in Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Odor-Rule-in-Missouri",
    "url": "/news/Proposed-Odor-Rule-in-Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2014 Cap-and-Trade Updates: Linkage with Quebec, 2014 Auction Reserve Prices, and 2014 GHG Allowance Allocation Distributions Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/2014-Cap-and-Trade-Updates-Linkage-with-Quebec-2014-Auction-Reserve-Prices-and-2014-GHG-Allowance-Allocation-Distributions-Updates-",
    "url": "/news/2014-Cap-and-Trade-Updates-Linkage-with-Quebec-2014-Auction-Reserve-Prices-and-2014-GHG-Allowance-Allocation-Distributions-Updates-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Deferral of Biogenic CO2 Emissions May Not Lead to Relief from Title V Permitting in Minnesota",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Deferral-of-Biogenic-CO2-Emissions-May-Not-Lead-to-Relief-from-Title-V-Permitting-in-Minnesota",
    "url": "/news/EPA-Deferral-of-Biogenic-CO2-Emissions-May-Not-Lead-to-Relief-from-Title-V-Permitting-in-Minnesota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Redesignation Request for MD PM2.5 Nonattainment Areas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Redesignation-Request-for-MD-PM2-5-Nonattainment-Areas",
    "url": "/news/Proposed-Redesignation-Request-for-MD-PM2-5-Nonattainment-Areas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Delaware State Implementation Plan Incorporates EPA’s 2008 Lead National Ambient Air Quality Standards",
    "apiurl": "/restapi/customnewscontentlvl2/news/Delaware-S",
    "url": "/news/Delaware-S",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Receives Accreditation to Perform AB 32 GHG Verification",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Receives-Accreditation-to-Perform-AB-32-GHG-Verification",
    "url": "/news/Trinity-Receives-Accreditation-to-Perform-AB-32-GHG-Verification",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Process Safety and Risk Management Program Updates for California-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/Process-Safety-and-Risk-Management-Program-Updates-for-California-California",
    "url": "/news/Process-Safety-and-Risk-Management-Program-Updates-for-California-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "State-Focused Environmental Reporting Resources for RY2020",
    "apiurl": "/restapi/customnewscontentlvl2/news/state-focused-environmental-reporting-resources-for-ry2020",
    "url": "/news/state-focused-environmental-reporting-resources-for-ry2020",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "State-Focused Environmental Reporting Resources for RY2020",
    "apiurl": "/restapi/customnewscontentlvl2/news/state-focused-environmental-reporting-resources-for-ry2020",
    "url": "/news/state-focused-environmental-reporting-webinars-for-ry2020",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Construction Permit Option and Informational Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Construction-Permit-Option-and-Informational-Meeting",
    "url": "/news/New-Construction-Permit-Option-and-Informational-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Rule by NYSDEC Updates List of Delegated NSPS and NESHAPS",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-Rule-by-NYSDEC-Updates-List-of-Delegated-NSPS-and-NESHAPS",
    "url": "/news/Final-Rule-by-NYSDEC-Updates-List-of-Delegated-NSPS-and-NESHAPS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Overview of Current/Upcoming Rulemaking Efforts in Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Overview-of-Current-Upcoming-Rulemaking-Efforts-in-Iowa",
    "url": "/news/Overview-of-Current-Upcoming-Rulemaking-Efforts-in-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Public Comment for 2016 Greenhouse Gas Inventory Report-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Public-Comment-for-2016-Greenhouse-Gas-Inventory-Report-Iowa",
    "url": "/news/Public-Comment-for-2016-Greenhouse-Gas-Inventory-Report-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Delaware Department of Natural Resources and Environmental Control (DNREC) Proposes Amendments to Regulations of the Application of Spray Coatings",
    "apiurl": "/restapi/customnewscontentlvl2/news/Delaware-Department-of-Natural-Resources-and-Environmental-Control-(DNREC)-Proposes-Amendments-to-Regulations-of-the-Application-of-Spray-Coatings",
    "url": "/news/Delaware-Department-of-Natural-Resources-and-Environmental-Control-(DNREC)-Proposes-Amendments-to-Regulations-of-the-Application-of-Spray-Coatings",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Revisions to Maricopa County Air Pollution Control Regulations Rule 204",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Revisions-to-Maricopa-County-Air-Pollution-Control-Regulations-Rule-204",
    "url": "/news/Proposed-Revisions-to-Maricopa-County-Air-Pollution-Control-Regulations-Rule-204",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ozone Depleting Substances - Are You Confident That Your Facility Is In Compliance With Air Conditioning and Refrigeration Regulations Under Title VI of the Clean Air Act?",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ozone-Depl",
    "url": "/news/Ozone-Depl",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposing New Rules for Three Source Categories",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposing-New-Rules-for-Three-Source-Categories",
    "url": "/news/EPA-Proposing-New-Rules-for-Three-Source-Categories",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "UDAQ Proposes Maintenance Plans for PM2.5 Nonattainment Areas-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/UDAQ-Proposes-Maintenance-Plans-for-PM2-5-Nonattainment-Areas-Utah",
    "url": "/news/UDAQ-Proposes-Maintenance-Plans-for-PM2-5-Nonattainment-Areas-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ohio EPA Requesting Stakeholder Input",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ohio-EPA-Requesting-Stakeholder-Input",
    "url": "/news/Ohio-EPA-Requesting-Stakeholder-Input",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "A Cost-Effective Approach to Explosion Consequence Modeling",
    "apiurl": "/restapi/customnewscontentlvl2/news/A-Cost-Effective-Approach-to-Explosion-Consequence-Modeling-",
    "url": "/news/A-Cost-Effective-Approach-to-Explosion-Consequence-Modeling-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on Ozone NAAQS in Illinois-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-Ozone-NAAQS-in-Illinois-Illinois",
    "url": "/news/Update-on-Ozone-NAAQS-in-Illinois-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendment to Illinois Pollution Control Board Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendment-to-Illinois-Pollution-Control-Board-Rules",
    "url": "/news/Proposed-Amendment-to-Illinois-Pollution-Control-Board-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The Air Program Advisory Forum’s First 2015 Air Fee Stakeholder Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/The-Air-Program-Advisory-Forum-s-First-2015-Air-Fee-Stakeholder-Meeting",
    "url": "/news/The-Air-Program-Advisory-Forum-s-First-2015-Air-Fee-Stakeholder-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "California’s Low Carbon Fuel Standard Has Far-Reaching Impacts",
    "apiurl": "/restapi/customnewscontentlvl2/news/california-s-low-carbon-fuel-standard-has-far-reaching-impacts",
    "url": "/news/california-s-low-carbon-fuel-standard-has-far-reaching-impacts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Old EPD Title V Database Has Said \"Au Revoir\"",
    "apiurl": "/restapi/customnewscontentlvl2/news/Old-EPD-Ti",
    "url": "/news/Old-EPD-Ti",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Issues Guidance on Impacts of Vacatur of Startup, Shutdown, and Malfunction (SSM) Exemption",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Issues-Guidance-on-Impacts-of-Vacatur-of-Startup-Shutdown-and-Malfunction-(SSM)-Exemption",
    "url": "/news/EPA-Issues-Guidance-on-Impacts-of-Vacatur-of-Startup-Shutdown-and-Malfunction-(SSM)-Exemption",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revised Air Permitting Guidance Finalized for Oil and Gas Production-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revised-Air-Permitting-Guidance-Finalized-for-Oil-and-Gas-Production-Wyoming",
    "url": "/news/Revised-Air-Permitting-Guidance-Finalized-for-Oil-and-Gas-Production-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Nebraska Tip of the Month – Requesting Trade Secrets-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/Nebraska-Tip-of-the-Month-Requesting-Trade-Secrets-Nebraska",
    "url": "/news/Nebraska-Tip-of-the-Month-Requesting-Trade-Secrets-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes GHG Rule Revisions",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-GHG-Rule-Revisions",
    "url": "/news/EPA-Proposes-GHG-Rule-Revisions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDNR Fee Advisory Group Meeting-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDNR-Fee-Advisory-Group-Meeting-Iowa",
    "url": "/news/IDNR-Fee-Advisory-Group-Meeting-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SJVAPCD Proposes Increases to District Fees",
    "apiurl": "/restapi/customnewscontentlvl2/news/SJVAPCD-Proposes-Increases-to-District-Fees-",
    "url": "/news/SJVAPCD-Proposes-Increases-to-District-Fees-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "AWMA Meetings-Oklahoma",
    "apiurl": "/restapi/customnewscontentlvl2/news/AWMA-Meetings-Oklahoma",
    "url": "/news/AWMA-Meetings-Oklahoma",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes New SO2 Data Requirements Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-New-SO2-Data-Requirements-Rule",
    "url": "/news/EPA-Proposes-New-SO2-Data-Requirements-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Issues PCWP ICR to U.S. Wood Products Manufacturers-Washington",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Issues-PCWP-ICR-to-U-S-Wood-Products-Manufacturers-Washington",
    "url": "/news/EPA-Issues-PCWP-ICR-to-U-S-Wood-Products-Manufacturers-Washington",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Opportunity to Submit Air Quality Client Contact Meeting Agenda Items-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Opportunity-to-Submit-Air-Quality-Client-Contact-Meeting-Agenda-Items-Iowa",
    "url": "/news/Opportunity-to-Submit-Air-Quality-Client-Contact-Meeting-Agenda-Items-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MCAQD Impact System Launching in 2020",
    "apiurl": "/restapi/customnewscontentlvl2/news/MCAQD-Impact-System-Launching-in-2020-",
    "url": "/news/MCAQD-Impact-System-Launching-in-2020-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MCAQD Impact System Launching in 2020",
    "apiurl": "/restapi/customnewscontentlvl2/news/MCAQD-Impact-System-Launching-in-2020-",
    "url": "/states/arizona/mcaqd-impact-system-launching-in-2020",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes Proposed to Statewide Air Emission Inventory Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/changes-proposed-to-statewide-air-emission-inventory-requirements",
    "url": "/news/changes-proposed-to-statewide-air-emission-inventory-requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes Proposed to Statewide Air Emission Inventory Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/changes-proposed-to-statewide-air-emission-inventory-requirements",
    "url": "/news/ab-2588-eicg-ab-617-ctr-proposed-15-day-changes",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments to ARB's Cap-and-Trade Regulation Beyond 2020",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendments-to-ARB's-Cap-and-Trade-Regulation-Beyond-2020",
    "url": "/news/Proposed-Amendments-to-ARB's-Cap-and-Trade-Regulation-Beyond-2020",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Several New WDNR Proposed Program Guidance Documents Open for Public Comment",
    "apiurl": "/restapi/customnewscontentlvl2/news/Several-New-WDNR-Proposed-Program-Guidance-Documents-Open-for-Public-Comment",
    "url": "/news/Several-New-WDNR-Proposed-Program-Guidance-Documents-Open-for-Public-Comment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "State Ozone Designation Recommendation for Texas-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/State-Ozone-Designation-Recommendation-for-Texas-Texas",
    "url": "/news/State-Ozone-Designation-Recommendation-for-Texas-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes First-Ever GHG Emissions Standards for Newly Manufactured Aircraft",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-proposes-first-ever-ghg-emissions-standards-for-newly-manufactured-aircraft",
    "url": "/news/epa-proposes-first-ever-ghg-emissions-standards-for-newly-manufactured-aircraft",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes First-Ever GHG Emissions Standards for Newly Manufactured Aircraft",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-proposes-first-ever-ghg-emissions-standards-for-newly-manufactured-aircraft",
    "url": "/news/federal/epa-proposes-first-ever-ghg-emissions-standards-for-newly-manufactured-aircraft",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Linn County Air Quality Ordinance Update-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Linn-County-Air-Quality-Ordinance-Update-Iowa",
    "url": "/news/Linn-County-Air-Quality-Ordinance-Update-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Designations in Virginia for the 2015 Ozone NAAQS-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Designations-in-Virginia-for-the-2015-Ozone-NAAQS-Virginia",
    "url": "/news/New-Designations-in-Virginia-for-the-2015-Ozone-NAAQS-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "UDAQ’s Proposal to Revise Title V Fees",
    "apiurl": "/restapi/customnewscontentlvl2/news/UDAQ-s-Proposal-to-Revise-Title-V-Fees",
    "url": "/news/UDAQ-s-Proposal-to-Revise-Title-V-Fees",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Rescission of Voluntary Operating Permit Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/Rescission-of-Voluntary-Operating-Permit-Program-",
    "url": "/news/Rescission-of-Voluntary-Operating-Permit-Program-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NMED Releases Draft Plan and Proposes Rule on PM10 in Southern New Mexico-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/NMED-Releases-Draft-Plan-and-Proposes-Rule-on-PM10-in-Southern-New-Mexico-New-Mexico",
    "url": "/news/NMED-Releases-Draft-Plan-and-Proposes-Rule-on-PM10-in-Southern-New-Mexico-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Public Comment Period for Proposed Measures prepared by the Ozone Transport Commission – Stationary and Area Source Committee-Vermont",
    "apiurl": "/restapi/customnewscontentlvl2/news/Public-Comment-Period-for-Proposed-Measures-prepared-by-the-Ozone-Transport-Commission-Stationary-and-Area-Source-Committee-Vermont",
    "url": "/news/Public-Comment-Period-for-Proposed-Measures-prepared-by-the-Ozone-Transport-Commission-Stationary-and-Area-Source-Committee-Vermont",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Jersey County Second Maintenance Plan for the 1997 Ozone National Ambient Air Quality Standard-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Jersey-County-Second-Maintenance-Plan-for-the-1997-Ozone-National-Ambient-Air-Quality-Standard-Illinois",
    "url": "/news/Jersey-County-Second-Maintenance-Plan-for-the-1997-Ozone-National-Ambient-Air-Quality-Standard-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reporting Reminders-Wisconsin",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reporting-Reminders-Wisconsin",
    "url": "/news/Reporting-Reminders-Wisconsin",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Friendly Reminder - Check Your Fuel-Oil Tickets for Sulfur Content-New Hampshire",
    "apiurl": "/restapi/customnewscontentlvl2/news/Friendly-Reminder---Check-Your-Fuel-Oil-Tickets-for-Sulfur-Content-New-Hampshire",
    "url": "/news/Friendly-Reminder---Check-Your-Fuel-Oil-Tickets-for-Sulfur-Content-New-Hampshire",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDE Proposes Changes to Distributed Generation Regulations-Maryland",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDE-Proposes-Changes-to-Distributed-Generation-Regulations-Maryland",
    "url": "/news/MDE-Proposes-Changes-to-Distributed-Generation-Regulations-Maryland",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oklahoma Air Permit for NESHAP Area Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oklahoma-Air-Permit-for-NESHAP-Area-Sources",
    "url": "/news/Oklahoma-Air-Permit-for-NESHAP-Area-Sources",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Updating Toxics Release Inventory Reporting to Advance Environmental Justice",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-updating-toxics-release-inventory-reporting-to-advance-environmental-justice",
    "url": "/news/epa-updating-toxics-release-inventory-reporting-to-advance-environmental-justice",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDNR Rule Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDNR-Rule-Updates",
    "url": "/news/MDNR-Rule-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Area Source Permit Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/Area-Source-Permit-Requirements",
    "url": "/news/Area-Source-Permit-Requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA's Draft Guidance for Significant Impact Levels for Ozone and Fine Particles in the PSD Permitting Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA's-Draft-Guidance-for-Significant-Impact-Levels-for-Ozone-and-Fine-Particles-in-the-PSD-Permitting-Program",
    "url": "/news/USEPA's-Draft-Guidance-for-Significant-Impact-Levels-for-Ozone-and-Fine-Particles-in-the-PSD-Permitting-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Evaluating Your E&P Assets: Self Auditing, Disclosure, and Saving Money",
    "apiurl": "/restapi/customnewscontentlvl2/news/Evaluating-Your-E-P-Assets-Self-Auditing-Disclosure-and-Saving-Money",
    "url": "/news/Evaluating-Your-E-P-Assets-Self-Auditing-Disclosure-and-Saving-Money",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Submitting Proposed Amendments to District Rule 4601",
    "apiurl": "/restapi/customnewscontentlvl2/news/submitting-proposed-amendments-to-district-rule-4601-",
    "url": "/news/submitting-proposed-amendments-to-district-rule-4601-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TSCA Title VI Formaldehyde Rule Compliance Moved Up to June 1, 2018-Washington",
    "apiurl": "/restapi/customnewscontentlvl2/news/TSCA-Title-VI-Formaldehyde-Rule-Compliance-Moved-Up-to-June-1-2018-Washington",
    "url": "/news/TSCA-Title-VI-Formaldehyde-Rule-Compliance-Moved-Up-to-June-1-2018-Washington",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "AWMA Meeting - Linn County Solid Waste Agency Tour",
    "apiurl": "/restapi/customnewscontentlvl2/news/AWMA-Meeting---Linn-County-Solid-Waste-Agency-Tour",
    "url": "/news/AWMA-Meeting---Linn-County-Solid-Waste-Agency-Tour",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to Nevada Air Quality Permitting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-to-Nevada-Air-Quality-Permitting",
    "url": "/news/Updates-to-Nevada-Air-Quality-Permitting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "VA DEQ Proposes New General Permit for Generators",
    "apiurl": "/restapi/customnewscontentlvl2/news/VA-DEQ-Proposes-New-General-Permit-for-Generators",
    "url": "/news/VA-DEQ-Proposes-New-General-Permit-for-Generators",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE Releases AERSCREEN 1.7 to Support Latest U.S. EPA Executable 15181",
    "apiurl": "/restapi/customnewscontentlvl2/news/-BREEZE-Releases-AERSCREEN-1-7-to-Support-Latest-U-S-EPA-Executable-15181-",
    "url": "/news/-BREEZE-Releases-AERSCREEN-1-7-to-Support-Latest-U-S-EPA-Executable-15181-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revised Regulations Affect Air Quality Permitting and Emissions of Ozone Precursors",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revised-Regulations-Affect-Air-Quality-Permitting-and-Emissions-of-Ozone-Precursors",
    "url": "/news/Revised-Regulations-Affect-Air-Quality-Permitting-and-Emissions-of-Ozone-Precursors",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Stormwater Permit Renewals",
    "apiurl": "/restapi/customnewscontentlvl2/news/TCEQ-Stormwater-Permit-Renewals",
    "url": "/news/TCEQ-Stormwater-Permit-Renewals",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "APEN Update Clarification",
    "apiurl": "/restapi/customnewscontentlvl2/news/APEN-Update-Clarification",
    "url": "/news/APEN-Update-Clarification",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Illinois EPA to Begin Testing all Illinois Community Water Supplies for PFAS Substances",
    "apiurl": "/restapi/customnewscontentlvl2/news/illinois-epa-to-begin-testing-all-illinois-community-water-supplies-for-pfas-substances",
    "url": "/news/illinois-epa-to-begin-testing-all-illinois-community-water-supplies-for-pfas-substances",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Illinois EPA to Begin Testing all Illinois Community Water Supplies for PFAS Substances",
    "apiurl": "/restapi/customnewscontentlvl2/news/illinois-epa-to-begin-testing-all-illinois-community-water-supplies-for-pfas-substances",
    "url": "/states/illinois/illinois-epa-to-begin-testing-all-illinois-community-water-supplies-for-pfas-substances",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "San Diego APCD Proposes Amendments to Architectural Coatings Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/san-diego-apcd-proposes-amendments-to-architectural-coatings-rule",
    "url": "/news/san-diego-apcd-proposes-amendments-to-architectural-coatings-rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "San Diego APCD Proposes Amendments to Architectural Coatings Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/san-diego-apcd-proposes-amendments-to-architectural-coatings-rule",
    "url": "/news/states/california/san-diego-apcd-proposes-amendments-to-architectural-coatings-rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "UDAQ Adopts Revised PM2.5 SIPs for Submittal to USEPA",
    "apiurl": "/restapi/customnewscontentlvl2/news/UDAQ-Adopts-Revised-PM2-5-SIPs-for-Submittal-to-USEPA",
    "url": "/news/UDAQ-Adopts-Revised-PM2-5-SIPs-for-Submittal-to-USEPA",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes to approve New York's Air Quality Implementation Plans related to CSAPR NOx Annual and SO2 Group 1 Trading Programs-New York",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-to-approve-New-Yorks-Air-Quality-Implementation-Plans-related-to-CSAPR-NOx-Annual-and-SO2-Group-1-Trading-Programs-New-York",
    "url": "/news/EPA-Proposes-to-approve-New-Yorks-Air-Quality-Implementation-Plans-related-to-CSAPR-NOx-Annual-and-SO2-Group-1-Trading-Programs-New-York",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes to approve New York's Air Quality Implementation Plans related to CSAPR NOx Annual and SO2 Group 1 Trading Programs-New York",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-to-approve-New-Yorks-Air-Quality-Implementation-Plans-related-to-CSAPR-NOx-Annual-and-SO2-Group-1-Trading-Programs-New-York",
    "url": "/news/EPA-Proposes-to-approve-New-York's-Air-Quality-Implementation-Plans-related-to-CSAPR-NOx-Annual-and-SO2-Group-1-Trading-Programs-New-York",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes Hourly NO2 Limit",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-Hourly-NO2-Limit",
    "url": "/news/EPA-Proposes-Hourly-NO2-Limit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Common Findings in Health and Safety Compliance Audits",
    "apiurl": "/restapi/customnewscontentlvl2/news/common-findings-in-health-and-safety-compliance-audits-",
    "url": "/news/common-findings-in-health-and-safety-compliance-audits-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Common Findings in Health and Safety Compliance Audits",
    "apiurl": "/restapi/customnewscontentlvl2/news/common-findings-in-health-and-safety-compliance-audits-",
    "url": "/news/federal/common-findings-in-health-and-safety-compliance-audits-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Common Findings in Health and Safety Compliance Audits",
    "apiurl": "/restapi/customnewscontentlvl2/news/common-findings-in-health-and-safety-compliance-audits-",
    "url": "/new/ehs-management/common-findings-in-health-and-safety-compliance-audits-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Demand Response Participation Utilizing On-Site Standby Generators",
    "apiurl": "/restapi/customnewscontentlvl2/news/Demand-Response-Participation-Utilizing-On-Site-Standby-Generators",
    "url": "/news/Demand-Response-Participation-Utilizing-On-Site-Standby-Generators",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Publishes Proposed Texas SIP Revision in the Federal Register to Allow Construction Prior to Permit Amendment Issuance",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-publishes-proposed-texas-sip-revision-in-the-federal-register-to-allow-construction-prior-to-permit-amendment-issuance",
    "url": "/news/epa-publishes-proposed-texas-sip-revision-in-the-federal-register-to-allow-construction-prior-to-permit-amendment-issuance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Winter Ozone Season Ends",
    "apiurl": "/restapi/customnewscontentlvl2/news/Winter-Ozone-Season-Ends",
    "url": "/news/Winter-Ozone-Season-Ends",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Revision to the Stationary Source Definition",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Revision-to-the-Stationary-Source-Definition",
    "url": "/news/Proposed-Revision-to-the-Stationary-Source-Definition",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New York State DEC Part 222 Stayed!",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-York-State-DEC-Part-222-Stayed",
    "url": "/news/New-York-State-DEC-Part-222-Stayed",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New York State DEC Part 222 Stayed!",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-York-State-DEC-Part-222-Stayed",
    "url": "/news/New-York-State-DEC-Part-222-Stayed!",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Introducing BREEZE VASDIP to Compute Explosive Safety and Physical Security Parameters",
    "apiurl": "/restapi/customnewscontentlvl2/news/Introducing-BREEZE-VASDIP-to-Compute-Explosive-Safety-and-Physical-Security-Parameters",
    "url": "/news/Introducing-BREEZE-VASDIP-to-Compute-Explosive-Safety-and-Physical-Security-Parameters",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ODS Rule Updates – Are You Prepared?-Tennessee",
    "apiurl": "/restapi/customnewscontentlvl2/news/ODS-Rule-Updates-Are-You-Prepared--Tennessee",
    "url": "/news/ODS-Rule-Updates-Are-You-Prepared--Tennessee",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE AERMOD 7.8 Expands the Power and Flexibility of the AERMOD Model",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-AERMOD-7-8-Expands-the-Power-and-Flexibility-of-the-AERMOD-Model",
    "url": "/news/BREEZE-AERMOD-7-8-Expands-the-Power-and-Flexibility-of-the-AERMOD-Model",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Estimated Costs Associated with Proposed Uniform Standards",
    "apiurl": "/restapi/customnewscontentlvl2/news/Estimated-Costs-Associated-with-Proposed-Uniform-Standards",
    "url": "/news/Estimated-Costs-Associated-with-Proposed-Uniform-Standards",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oregon Environmental Quality Commission Adopts Amendments to Greenhouse Gas Reporting and Clean Fuels Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/oregon-environmental-quality-commission-adopts-amendments-to-greenhouse-gas-reporting-and-clean-fuels-program-",
    "url": "/news/oregon-environmental-quality-commission-adopts-amendments-to-greenhouse-gas-reporting-and-clean-fuels-program-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Recent PSD/Title V Tailoring Rule Developments",
    "apiurl": "/restapi/customnewscontentlvl2/news/Recent-PSD-Title-V-Tailoring-Rule-Developments",
    "url": "/news/Recent-PSD-Title-V-Tailoring-Rule-Developments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New General Permit for Solid Material Storage Equipment (Silos) to be Issued Soon",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-General-Permit-for-Solid-Material-Storage-Equipment-(Silos)-to-be-Issued-Soon",
    "url": "/news/New-General-Permit-for-Solid-Material-Storage-Equipment-(Silos)-to-be-Issued-Soon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Indiana Environmental Rules Board Adopts Above Ground Storage Tank (AST) Reporting Emergency Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Indiana-Environmental-Rules-Board-Adopts-Above-Ground-Storage-Tank-(AST)-Reporting-Emergency-Rule",
    "url": "/news/Indiana-Environmental-Rules-Board-Adopts-Above-Ground-Storage-Tank-(AST)-Reporting-Emergency-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final RMP Reconsideration Rule Now in Effect",
    "apiurl": "/restapi/customnewscontentlvl2/news/final-rmp-reconsideration-rule-now-in-effect",
    "url": "/news/final-rmp-reconsideration-rule-now-in-effect",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final RMP Reconsideration Rule Now in Effect",
    "apiurl": "/restapi/customnewscontentlvl2/news/final-rmp-reconsideration-rule-now-in-effect",
    "url": "/news/federal/final-rmp-reconsideration-rule-now-in-effect",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final RMP Reconsideration Rule Now in Effect",
    "apiurl": "/restapi/customnewscontentlvl2/news/final-rmp-reconsideration-rule-now-in-effect",
    "url": "/federal/final-rmp-reconsideration-rule-now-in-effect",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ARB Off-Road Regulation Deadlines",
    "apiurl": "/restapi/customnewscontentlvl2/news/ARB-Off-Road-Regulation-Deadlines-",
    "url": "/news/ARB-Off-Road-Regulation-Deadlines-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Construction Permit Format Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Construction-Permit-Format-Released",
    "url": "/news/New-Construction-Permit-Format-Released",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NJDEP Proposed Revisions to the TCPA-New Jersey",
    "apiurl": "/restapi/customnewscontentlvl2/news/NJDEP-Proposed-Revisions-to-the-TCPA-New-Jersey",
    "url": "/news/NJDEP-Proposed-Revisions-to-the-TCPA-New-Jersey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "RACT III is on the Horizon in Pennsylvania",
    "apiurl": "/restapi/customnewscontentlvl2/news/ract-iii-is-on-the-horizon-in-pennsylvania",
    "url": "/news/ract-iii-is-on-the-horizon-in-pennsylvania",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Additional RACT Requirements for Major Sources of NOx and VOCs",
    "apiurl": "/restapi/customnewscontentlvl2/news/Additional-RACT-Requirements-for-Major-Sources-of-NOx-and-VOCs",
    "url": "/news/Additional-RACT-Requirements-for-Major-Sources-of-NOx-and-VOCs",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Amendments to SPCC Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-Amendments-to-SPCC-Rule",
    "url": "/news/Final-Amendments-to-SPCC-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA TRI Inquiries-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-TRI-Inquiries-Nebraska",
    "url": "/news/EPA-TRI-Inquiries-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Emergency Response and Contingency Plans - Individual or Integrated",
    "apiurl": "/restapi/customnewscontentlvl2/news/emergency-response-and-contingency-plans---individual-or-integrated",
    "url": "/news/emergency-response-and-contingency-plans---individual-or-integrated",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Emergency Response and Contingency Plans - Individual or Integrated",
    "apiurl": "/restapi/customnewscontentlvl2/news/emergency-response-and-contingency-plans---individual-or-integrated",
    "url": "/news/state/kentucky/emergency-response-and-contingency-plans---individual-or-integrated",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Application Process to Propose Alternate \"Approved Instrument Monitoring Method\" (AIMM)",
    "apiurl": "/restapi/customnewscontentlvl2/news/Application-Process-to-Propose-Alternate-Approved-Instrument-Monitoring-Method-(AIMM)",
    "url": "/news/Application-Process-to-Propose-Alternate-Approved-Instrument-Monitoring-Method-(AIMM)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated Version of AERMOD Released in December-North Carolina",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updated-Version-of-AERMOD-Released-in-December-North-Carolina",
    "url": "/news/Updated-Version-of-AERMOD-Released-in-December-North-Carolina",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Public Hearing for Revisions to MCAQD Rules 350, 351, 352 and 353",
    "apiurl": "/restapi/customnewscontentlvl2/news/public-hearing-for-revisions-to-mcaqd-rules-350-351-352-and-353",
    "url": "/news/public-hearing-for-revisions-to-mcaqd-rules-350-351-352-and-353",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Public Hearing for Revisions to MCAQD Rules 350, 351, 352 and 353",
    "apiurl": "/restapi/customnewscontentlvl2/news/public-hearing-for-revisions-to-mcaqd-rules-350-351-352-and-353",
    "url": "/news/states/arizona/public-hearing-for-revisions-to-mcaqd-rules-350-351-352-and-353",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Class I Annual Emissions Inventory - HAP Exemption Lowered-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Class-I-Annual-Emissions-Inventory---HAP-Exemption-Lowered-Kansas",
    "url": "/news/Class-I-Annual-Emissions-Inventory---HAP-Exemption-Lowered-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Coast Air Quality Management District – Proposed Rule 1430",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Coast-Air-Quality-Management-District-Proposed-Rule-1430",
    "url": "/news/South-Coast-Air-Quality-Management-District-Proposed-Rule-1430",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Governor Endorses 25x25",
    "apiurl": "/restapi/customnewscontentlvl2/news/Governor-Endorses-25x25",
    "url": "/news/Governor-Endorses-25x25",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Compliance Still Required with California Method 9 Evaluations",
    "apiurl": "/restapi/customnewscontentlvl2/news/compliance-still-required-with-california-method-9-evaluations",
    "url": "/news/compliance-still-required-with-california-method-9-evaluations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Missouri Specific Reporting Deadlines",
    "apiurl": "/restapi/customnewscontentlvl2/news/Missouri-Specific-Reporting-Deadlines",
    "url": "/news/Missouri-Specific-Reporting-Deadlines",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE Releases AERMOD Version 7.10.1",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-Releases-AERMOD-Version-7-10-1-",
    "url": "/news/BREEZE-Releases-AERMOD-Version-7-10-1-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Extension on Comment Period for EPA's Partial Approval and Disapproval of Arizona State Implementation Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Extension-",
    "url": "/news/Extension-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "RICE MACT Applicability Broadens",
    "apiurl": "/restapi/customnewscontentlvl2/news/5e7ee449-2fc4-4cea-bcef-96b1e3636cff",
    "url": "/news/5e7ee449-2fc4-4cea-bcef-96b1e3636cff",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New App for Finding Wells Available to the Public-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-App-for-Finding-Wells-Available-to-the-Public-Wyoming",
    "url": "/news/New-App-for-Finding-Wells-Available-to-the-Public-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEC Adopts 1-hour NO2 NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEC-Adopts-1-hour-NO2-NAAQS",
    "url": "/news/ADEC-Adopts-1-hour-NO2-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Issues Final Rule to Approve Part of Illinois Infrastructure SIP for 2012 PM2.5 NAAQS-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Issues-Final-Rule-to-Approve-Part-of-Illinois-Infrastructure-SIP-for-2012-PM2-5-NAAQS-Illinois",
    "url": "/news/EPA-Issues-Final-Rule-to-Approve-Part-of-Illinois-Infrastructure-SIP-for-2012-PM2-5-NAAQS-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Breaking Ground in Cleveland and Milwaukee",
    "apiurl": "/restapi/customnewscontentlvl2/news/Breaking-Ground-in-Cleveland-and-Milwaukee",
    "url": "/news/Breaking-Ground-in-Cleveland-and-Milwaukee",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Greenhouse Gas Reporting for Oil & Gas Operations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Greenhouse-Gas-Reporting-for-Oil-Gas-Operations",
    "url": "/news/Greenhouse-Gas-Reporting-for-Oil-Gas-Operations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Houston, Galveston, Bazoria (HGB) Area Ozone Redesignation",
    "apiurl": "/restapi/customnewscontentlvl2/news/Houston-Galveston-Bazoria-(HGB)-Area-Ozone-Redesignation",
    "url": "/news/Houston-Galveston-Bazoria-(HGB)-Area-Ozone-Redesignation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Repeal of De Minimis Permit By Rules (PBRs)",
    "apiurl": "/restapi/customnewscontentlvl2/news/Repeal-of-De-Minimis-Permit-By-Rules-(PBRs)",
    "url": "/news/Repeal-of-De-Minimis-Permit-By-Rules-(PBRs)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The SSM Saga Continues",
    "apiurl": "/restapi/customnewscontentlvl2/news/the-ssm-saga-continues",
    "url": "/news/the-ssm-saga-continues",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update: Ozone and PM2.5 Significant Impact Levels-Louisiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-Ozone-and-PM2-5-Significant-Impact-Levels-Louisiana",
    "url": "/news/Update-Ozone-and-PM2-5-Significant-Impact-Levels-Louisiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New AQD Semiannual Fugitive Emissions Equipment Leak Form",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-AQD-Semiannual-Fugitive-Emissions-Equipment-Leak-Form",
    "url": "/news/New-AQD-Semiannual-Fugitive-Emissions-Equipment-Leak-Form",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Compliance Dates Approaching for Existing Engines",
    "apiurl": "/restapi/customnewscontentlvl2/news/Compliance-Dates-Approaching-for-Existing-Engines",
    "url": "/news/Compliance-Dates-Approaching-for-Existing-Engines",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Williston Basin Petroleum Conference (WBPC) sees an all-time high",
    "apiurl": "/restapi/customnewscontentlvl2/news/Williston-Basin-Petroleum-Conference-(WBPC)-sees-an-all-time-high",
    "url": "/news/Williston-Basin-Petroleum-Conference-(WBPC)-sees-an-all-time-high",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity’s Atlanta Office Permits Cinnamon Toast Crunch Expansion",
    "apiurl": "/restapi/customnewscontentlvl2/news/trinitys-atlanta-office-permits-cinnamon-toast-crunch-expansion",
    "url": "/news/trinitys-atlanta-office-permits-cinnamon-toast-crunch-expansion",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity’s Atlanta Office Permits Cinnamon Toast Crunch Expansion",
    "apiurl": "/restapi/customnewscontentlvl2/news/trinitys-atlanta-office-permits-cinnamon-toast-crunch-expansion",
    "url": "/news/trinity-s-atlanta-office-permits-cinnamon-toast-crunch-expansion",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SIP Review Delayed to December Air Quality Board Meeting-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/SIP-Review-Delayed-to-December-Air-Quality-Board-Meeting-Utah",
    "url": "/news/SIP-Review-Delayed-to-December-Air-Quality-Board-Meeting-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to Maricopa County Air Quality Department Rule 336 (Surface Coating Operations)",
    "apiurl": "/restapi/customnewscontentlvl2/news/updates-to-maricopa-county-air-quality-department-rule-336-surface-coating-operations",
    "url": "/news/updates-to-maricopa-county-air-quality-department-rule-336-surface-coating-operations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Rule Defines Approach for Grouping Projects Under New Source Review Permitting Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-Rule",
    "url": "/news/Final-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Recent Revisions to MDEQ's Guidance on Permit to Install Dispersion Modeling Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/Recent-Revisions-to-MDEQ's-Guidance-on-Permit-to-Install-Dispersion-Modeling-Requirements",
    "url": "/news/Recent-Revisions-to-MDEQ's-Guidance-on-Permit-to-Install-Dispersion-Modeling-Requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NYSDEC Requests EPA Impose Emission Limits on Sources Affecting Air Quality in New York, Including Sources in Pennsylvania-Pennsylvania",
    "apiurl": "/restapi/customnewscontentlvl2/news/NYSDEC-Requests-EPA-Impose-Emission-Limits-on-Sources-Affecting-Air-Quality-in-New-York-Including-Sources-in-Pennsylvania-Pennsylvania",
    "url": "/news/NYSDEC-Requests-EPA-Impose-Emission-Limits-on-Sources-Affecting-Air-Quality-in-New-York-Including-Sources-in-Pennsylvania-Pennsylvania",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDEM Proposes VOC RACT Updates for Lake and Porter Counties",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDEM-Proposes-VOC-RACT-Updates-for-Lake-and-Porter-Counties",
    "url": "/news/IDEM-Proposes-VOC-RACT-Updates-for-Lake-and-Porter-Counties",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Should Your Company Be Conducting Life Cycle Analyses?",
    "apiurl": "/restapi/customnewscontentlvl2/news/Should-Your-Company-Be-Conducting-Life-Cycle-Analyses-",
    "url": "/news/Should-Your-Company-Be-Conducting-Life-Cycle-Analyses-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD Accepting Applications for High Mileage Fleet Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/baaqmd-accepting-applications-for-high-mileage-fleet-program",
    "url": "/news/baaqmd-accepting-applications-for-high-mileage-fleet-program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SA Nonattainment Desigantion Udpate-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/SA-Nonattainment-Desigantion-Udpate-Texas",
    "url": "/news/SA-Nonattainment-Desigantion-Udpate-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "AWMA Meetings 2009",
    "apiurl": "/restapi/customnewscontentlvl2/news/-AWMA-Meetings-2009",
    "url": "/news/-AWMA-Meetings-2009",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Quality Board Reviews Adoption of Ammonia as Precursor to PM2.5-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Board-Reviews-Adoption-of-Ammonia-as-Precursor-to-PM2-5-Utah",
    "url": "/news/Air-Quality-Board-Reviews-Adoption-of-Ammonia-as-Precursor-to-PM2-5-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD Proposed Amendments to BACT Guidelines",
    "apiurl": "/restapi/customnewscontentlvl2/news/SCAQMD-Proposed-Amendments-to-BACT-Guidelines",
    "url": "/news/SCAQMD-Proposed-Amendments-to-BACT-Guidelines",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Environmental Federation of Oklahoma (EFO)",
    "apiurl": "/restapi/customnewscontentlvl2/news/Environmental-Federation-of-Oklahoma-(EFO)-",
    "url": "/news/Environmental-Federation-of-Oklahoma-(EFO)-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Acquires  Process Safety Management Firm Provenance Consulting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Acquires-Process-Safety-Management-Firm-Provenance-Consulting",
    "url": "/news/Trinity-Acquires-Process-Safety-Management-Firm-Provenance-Consulting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Shifts PM2.5 PSD Permitting Policies",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Shifts-PM2-5-PSD-Permitting-Policies",
    "url": "/news/EPA-Shifts-PM2-5-PSD-Permitting-Policies",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Boiler MACT",
    "apiurl": "/restapi/customnewscontentlvl2/news/Boiler-MACT",
    "url": "/news/Boiler-MACT",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to the Arizona State Implementation Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-to-the-Arizona-State-Implementation-Plan",
    "url": "/news/Updates-to-the-Arizona-State-Implementation-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Missouri Chamber of Commerce and Industry hosts 2015 Missouri Environmental & Energy Conference",
    "apiurl": "/restapi/customnewscontentlvl2/news/Missouri-Chamber-of-Commerce-and-Industry-hosts-2015-Missouri-Environmental-Energy-Conference",
    "url": "/news/Missouri-Chamber-of-Commerce-and-Industry-hosts-2015-Missouri-Environmental-Energy-Conference",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oregon Agencies Increase Scrutiny of Many Industries’ Current Air Emissions of Metals",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oregon-Agencies-Increase-Scrutiny-of-Many-Industries-Current-Air-Emissions-of-Metals",
    "url": "/news/Oregon-Agencies-Increase-Scrutiny-of-Many-Industries-Current-Air-Emissions-of-Metals",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed HFC Phasedown under the AIM Act",
    "apiurl": "/restapi/customnewscontentlvl2/news/proposed-hfc-phasedown-under-the-aim-act",
    "url": "/news/proposed-hfc-phasedown-under-the-aim-act",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Air Quality Regulations Incorporate GHG Tailoring Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Air-Quality-Regulations-Incorporate-GHG-Tailoring-Rule",
    "url": "/news/Proposed-Air-Quality-Regulations-Incorporate-GHG-Tailoring-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NJDEP No Longer Allowing Paper Permits (Air Preconstruction Permits Issued Prior to 1998)-New Jersey",
    "apiurl": "/restapi/customnewscontentlvl2/news/NJDEP-No-Longer-Allowing-Paper-Permits-(Air-Preconstruction-Permits-Issued-Prior-to-1998)-New-Jersey",
    "url": "/news/NJDEP-No-Longer-Allowing-Paper-Permits-(Air-Preconstruction-Permits-Issued-Prior-to-1998)-New-Jersey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New TCEQ NSR Application and PBR Assessment Workbooks",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-tceq-nsr-application-and-pbr-assessment-workbooks",
    "url": "/news/new-tceq-nsr-application-and-pbr-assessment-workbooks",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD nominates Richmond-San Pablo for Year 3 CARB Community Air Protection Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/baaqmd-nominates-richmond-san-pablo-for-year-3-carb-community-air-protection-program",
    "url": "/news/baaqmd-nominates-richmond-san-pablo-for-year-3-carb-community-air-protection-program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD nominates Richmond-San Pablo for Year 3 CARB Community Air Protection Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/baaqmd-nominates-richmond-san-pablo-for-year-3-carb-community-air-protection-program",
    "url": "/states/california/baaqmd-nominates-richmond-san-pablo-for-year-3-carb-community-air-protection-program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Hydrofluorocarbon Regulation Outlook",
    "apiurl": "/restapi/customnewscontentlvl2/news/hydrofluorocarbon-regulation-outlook",
    "url": "/news/hydrofluorocarbon-regulation-outlook",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Hydrofluorocarbon Regulation Outlook",
    "apiurl": "/restapi/customnewscontentlvl2/news/hydrofluorocarbon-regulation-outlook",
    "url": "/www.trinityconsultants.com/news/hydrofluorocarbon-regulation-outlook",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments to Permit Fees",
    "apiurl": "/restapi/customnewscontentlvl2/news/proposed-amendments-to-permit-fees",
    "url": "/news/proposed-amendments-to-permit-fees",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LDEQ Issues Multiple Potpourris for Various Air Regulations-Louisiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/LDEQ-Issues-Multiple-Potpourris-for-Various-Air-Regulations-Louisiana",
    "url": "/news/LDEQ-Issues-Multiple-Potpourris-for-Various-Air-Regulations-Louisiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Texas SIP Call on SSM Provisions",
    "apiurl": "/restapi/customnewscontentlvl2/news/Texas-SIP-Call-on-SSM-Provisions-",
    "url": "/news/Texas-SIP-Call-on-SSM-Provisions-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Colorado Reg Changes Due to Ozone Nonattainment Area Reclassification",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Colorado-Reg-Changes-Due-to-Ozone-Nonattainment-Area-Reclassification",
    "url": "/news/Proposed-Colorado-Reg-Changes-Due-to-Ozone-Nonattainment-Area-Reclassification",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2010 Emissions Inventory Workshop",
    "apiurl": "/restapi/customnewscontentlvl2/news/2010-Emissions-Inventory-Workshop",
    "url": "/news/2010-Emissions-Inventory-Workshop",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Additional Public Hearings for Compliance and Enforcement Procedures",
    "apiurl": "/restapi/customnewscontentlvl2/news/Additional-Public-Hearings-for-Compliance-and-Enforcement-Procedures",
    "url": "/news/Additional-Public-Hearings-for-Compliance-and-Enforcement-Procedures",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Annual Emission Inventory Due Soon!",
    "apiurl": "/restapi/customnewscontentlvl2/news/Annual-Emission-Inventory-Due-Soon!",
    "url": "/news/Annual-Emission-Inventory-Due-Soon!",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Finalizes Boiler NESHAP (Again)",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Finalizes-Boiler-NESHAP-(Again)",
    "url": "/news/EPA-Finalizes-Boiler-NESHAP-(Again)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PM10 SIP goes to Public Comment",
    "apiurl": "/restapi/customnewscontentlvl2/news/PM10-SIP-goes-to-Public-Comment",
    "url": "/news/PM10-SIP-goes-to-Public-Comment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CAO Hazard Index Proposed Rule Available for Public Comment-Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/CAO-Hazard-Index-Proposed-Rule-Available-for-Public-Comment-Oregon",
    "url": "/news/CAO-Hazard-Index-Proposed-Rule-Available-for-Public-Comment-Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Federal and Missouri Reporting Reminders",
    "apiurl": "/restapi/customnewscontentlvl2/news/Federal-and-Missouri-Reporting-Reminders",
    "url": "/news/Federal-and-Missouri-Reporting-Reminders",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TDEC Air Pollution Control Board Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/TDEC-Air-Pollution-Control-Board-Meeting-",
    "url": "/news/TDEC-Air-Pollution-Control-Board-Meeting-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MSS Permitting for the Oil and Gas Industry in Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/MSS-Permitting-for-the-Oil-and-Gas-Industry-in-Texas",
    "url": "/news/MSS-Permitting-for-the-Oil-and-Gas-Industry-in-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Much Anticipated BAT Policy Released by Ohio EPA on December 10th",
    "apiurl": "/restapi/customnewscontentlvl2/news/Much-Anticipated-BAT-Policy-Released-by-Ohio-EPA-on-December-10th",
    "url": "/news/Much-Anticipated-BAT-Policy-Released-by-Ohio-EPA-on-December-10th",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Hot Off the Presses",
    "apiurl": "/restapi/customnewscontentlvl2/news/Hot-Off-the-Presses",
    "url": "/news/Hot-Off-the-Presses",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NYSDEC Finalizes Carbon Dioxide Emissions Standards for Major Electric Generating Facilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/NYSDEC-Finalizes-Carbon-Dioxide-Emissions-Standards-for-Major-Electric-Generating-Facilities",
    "url": "/news/NYSDEC-Finalizes-Carbon-Dioxide-Emissions-Standards-for-Major-Electric-Generating-Facilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Midwest Environmental Compliance Conference May 17-18-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/Midwest-Environmental-Compliance-Conference-May-17-18-Nebraska",
    "url": "/news/Midwest-Environmental-Compliance-Conference-May-17-18-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Kansas Tip of the Month - Air Construction Approval Thresholds in Johnson and Wyandotte Counties-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Kansas-Tip-of-the-Month---Air-Construction-Approval-Thresholds-in-Johnson-and-Wyandotte-Counties-Kansas",
    "url": "/news/Kansas-Tip-of-the-Month---Air-Construction-Approval-Thresholds-in-Johnson-and-Wyandotte-Counties-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Newly Proposed Regulations Ensure Either State or EPA Has Authority to Issue PSD Permits for GHGs",
    "apiurl": "/restapi/customnewscontentlvl2/news/Newly-Proposed-Regulations-Ensure-Either-State-or-EPA-Has-Authority-to-Issue-PSD-Permits-for-GHGs",
    "url": "/news/Newly-Proposed-Regulations-Ensure-Either-State-or-EPA-Has-Authority-to-Issue-PSD-Permits-for-GHGs",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Acquires Australian Consultancy Air Noise Environment",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Acquires-Australian-Consultancy-Air-Noise-Environment",
    "url": "/news/Trinity-Consultants-Acquires-Australian-Consultancy-Air-Noise-Environment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Utah DEQ Updating Its ISIP to Include Use of AERMOD-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/Utah-DEQ-Updating-Its-ISIP-to-Include-Use-of-AERMOD-Utah",
    "url": "/news/Utah-DEQ-Updating-Its-ISIP-to-Include-Use-of-AERMOD-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NOx RACT rules amended for approval into WI SIP",
    "apiurl": "/restapi/customnewscontentlvl2/news/NOx-RACT-rules-amended-for-approval-into-WI-SIP",
    "url": "/news/NOx-RACT-rules-amended-for-approval-into-WI-SIP",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Rule Amendment to Increase Title V Fees on Public Notice-South Dakota",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Rule-Amendment-to-Increase-Title-V-Fees-on-Public-Notice-South-Dakota",
    "url": "/news/Proposed-Rule-Amendment-to-Increase-Title-V-Fees-on-Public-Notice-South-Dakota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ's Proposed Designations for Ozone Nonattainment Areas",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ's-Proposed-Designations-for-Ozone-Nonattainment-Areas",
    "url": "/news/ADEQ's-Proposed-Designations-for-Ozone-Nonattainment-Areas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "North Dakota Pollutant Discharge Elimination System Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/North-Dakota-Pollutant-Discharge-Elimination-System-Updates",
    "url": "/news/North-Dakota-Pollutant-Discharge-Elimination-System-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PADEP Proposes Changes to the Air Quality Permit Exemptions Related to Oil & Gas Exploration and Compressed Natural Gas Fueling",
    "apiurl": "/restapi/customnewscontentlvl2/news/PADEP-Proposes-Changes-to-the-Air-Quality-Permit-Exemptions-Related-to-Oil-Gas-Exploration-and-Compressed-Natural-Gas-Fueling",
    "url": "/news/PADEP-Proposes-Changes-to-the-Air-Quality-Permit-Exemptions-Related-to-Oil-Gas-Exploration-and-Compressed-Natural-Gas-Fueling",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Illinois Environmental Regulatory Group Air Seminar-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Illinois-Environmental-Regulatory-Group-Air-Seminar-Illinois",
    "url": "/news/Illinois-Environmental-Regulatory-Group-Air-Seminar-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "AQD Penalty Guidance Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/AQD-Penalty-Guidance-Updates",
    "url": "/news/AQD-Penalty-Guidance-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Substantive Changes to the U.S. EPA’s SPCC Guidance for Regional Inspectors",
    "apiurl": "/restapi/customnewscontentlvl2/news/Substantive-Changes-to-the-U-S-EPA-s-SPCC-Guidance-for-Regional-Inspectors",
    "url": "/news/Substantive-Changes-to-the-U-S-EPA-s-SPCC-Guidance-for-Regional-Inspectors",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reclassification of Connecticut for the 2008 Ozone National Ambient Air Quality Standards-Connecticut",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reclassification-of-Connecticut-for-the-2008-Ozone-National-Ambient-Air-Quality-Standards-Connecticut",
    "url": "/news/Reclassification-of-Connecticut-for-the-2008-Ozone-National-Ambient-Air-Quality-Standards-Connecticut",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Storm Water General Permits",
    "apiurl": "/restapi/customnewscontentlvl2/news/-Storm-Wat",
    "url": "/news/-Storm-Wat",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KDHE Guidance Document Updates and New District Office Map-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/KDHE-Guidance-Document-Updates-and-New-District-Office-Map-Kansas",
    "url": "/news/KDHE-Guidance-Document-Updates-and-New-District-Office-Map-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Draft Fact Sheet ''Is Modification to My Air Construction Permit Needed?''",
    "apiurl": "/restapi/customnewscontentlvl2/news/Draft-Fact-Sheet-''Is-Modification-to-My-Air-Construction-Permit-Needed-''",
    "url": "/news/Draft-Fact-Sheet-''Is-Modification-to-My-Air-Construction-Permit-Needed-''",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The Value Proposition for Sustainability Report Verification",
    "apiurl": "/restapi/customnewscontentlvl2/news/The-Value-Proposition-for-Sustainability-Report-Verification",
    "url": "/news/The-Value-Proposition-for-Sustainability-Report-Verification",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Newly Proposed Regulations Affect Arkansas PSD Permitting of GHGs",
    "apiurl": "/restapi/customnewscontentlvl2/news/Newly-Proposed-Regulations-Affect-Arkansas-PSD-Permitting-of-GHGs",
    "url": "/news/Newly-Proposed-Regulations-Affect-Arkansas-PSD-Permitting-of-GHGs",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Aggregate Processing Workshop-Nevada",
    "apiurl": "/restapi/customnewscontentlvl2/news/Aggregate-Processing-Workshop-Nevada",
    "url": "/news/Aggregate-Processing-Workshop-Nevada",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Other GHG Subparts",
    "apiurl": "/restapi/customnewscontentlvl2/news/Other-GHG-Subparts",
    "url": "/news/Other-GHG-Subparts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Approves Florida’s GHG PSD Permitting SIP",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Approves-Florida-s-GHG-PSD-Permitting-SIP",
    "url": "/news/EPA-Approves-Florida-s-GHG-PSD-Permitting-SIP",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revisions to Illinois Construction Permitting Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revisions-to-Illinois-Construction-Permitting-Rule",
    "url": "/news/Revisions-to-Illinois-Construction-Permitting-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Georgia Annual Reporting Reminders",
    "apiurl": "/restapi/customnewscontentlvl2/news/Georgia-An",
    "url": "/news/Georgia-An",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KDHE Publishes Draft 2020 303(d) List of Impaired Waters",
    "apiurl": "/restapi/customnewscontentlvl2/news/kdhe-publishes-draft-2020-303(d)-list-of-impaired-waters",
    "url": "/news/kdhe-publishes-draft-2020-303(d)-list-of-impaired-waters",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KDHE Publishes Draft 2020 303(d) List of Impaired Waters",
    "apiurl": "/restapi/customnewscontentlvl2/news/kdhe-publishes-draft-2020-303(d)-list-of-impaired-waters",
    "url": "/states/kansas/kdhe-publishes-draft-2020-303d-list-of-impaired-waters",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MCAQD NSR Revisions & NOx and VOC Rule Package Timeline Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/MCAQD-NSR-Revisions-NOx-and-VOC-Rule-Package-Timeline-Updates",
    "url": "/news/MCAQD-NSR-Revisions-NOx-and-VOC-Rule-Package-Timeline-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEQ Postpones Meetings on EPA's Clean Power Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEQ-Postpones-Meetings-on-EPA's-Clean-Power-Plan",
    "url": "/news/NDEQ-Postpones-Meetings-on-EPA's-Clean-Power-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TN Minor Sources - Confirming Potential Emissions and Source Classification",
    "apiurl": "/restapi/customnewscontentlvl2/news/TN-Minor-Sources---Confirming-Potential-Emissions-and-Source-Classification",
    "url": "/news/TN-Minor-Sources---Confirming-Potential-Emissions-and-Source-Classification",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reminder – SO2 SIP Requirements Effective January 1, 2017",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reminder-SO2-SIP-Requirements-Effective-January-1-2017",
    "url": "/news/Reminder-SO2-SIP-Requirements-Effective-January-1-2017",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Kentucky Considers Increasing Title V Emissions Fees",
    "apiurl": "/restapi/customnewscontentlvl2/news/Kentucky-C",
    "url": "/news/Kentucky-C",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Rule - Control of Emissions from Large Combustion Sources-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Rule---Control-of-Emissions-from-Large-Combustion-Sources-Illinois",
    "url": "/news/Proposed-Rule---Control-of-Emissions-from-Large-Combustion-Sources-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Is Your Upstream E&P Facility in Compliance with SPCC Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/is-your-upstream-e-p-facility-in-compliance-with-spcc-requirements",
    "url": "/news/is-your-upstream-e-p-facility-in-compliance-with-spcc-requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Is Your Upstream E&P Facility in Compliance with SPCC Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/is-your-upstream-e-p-facility-in-compliance-with-spcc-requirements",
    "url": "/federal/is-your-upstream-e-p-facility-in-compliance-with-spcc-requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Nebraska Reporting Reminders-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/Nebraska-Reporting-Reminders-Nebraska",
    "url": "/news/Nebraska-Reporting-Reminders-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Lead Rulemaking in Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Lead-Rulemaking-in-Illinois",
    "url": "/news/Proposed-Lead-Rulemaking-in-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "US EPA Proposes to Approve Illinois’ Sunsetting of ERMS Program-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/US-EPA-Proposes-to-Approve-Illinois-Sunsetting-of-ERMS-Program-Illinois",
    "url": "/news/US-EPA-Proposes-to-Approve-Illinois-Sunsetting-of-ERMS-Program-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Emission Reduction Credits-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Emission-Reduction-Credits-Colorado",
    "url": "/news/Emission-Reduction-Credits-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Kentucky Office Announcement – Visible Emissions Certified-Kentucky",
    "apiurl": "/restapi/customnewscontentlvl2/news/Kentucky-Office-Announcement-Visible-Emissions-Certified-Kentucky",
    "url": "/news/Kentucky-Office-Announcement-Visible-Emissions-Certified-Kentucky",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MassDEP Provides an Update on Deadlines for Source Registration and GHG Reporting-Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/MassDEP-Provides-an-Update-on-Deadlines-for-Source-Registration-and-GHG-Reporting-Massachusetts",
    "url": "/news/MassDEP-Provides-an-Update-on-Deadlines-for-Source-Registration-and-GHG-Reporting-Massachusetts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "UDAQ's Control Plan Includes Amending Area Source Rules-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/UDAQ's-Control-Plan-Includes-Amending-Area-Source-Rules-Utah",
    "url": "/news/UDAQ's-Control-Plan-Includes-Amending-Area-Source-Rules-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MSI's Scott Adamson Earns CCM Designation",
    "apiurl": "/restapi/customnewscontentlvl2/news/MSI's-Scott-Adamson-Earns-CCM-Designation",
    "url": "/news/MSI's-Scott-Adamson-Earns-CCM-Designation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MSI's Scott Adamson Earns CCM Designation",
    "apiurl": "/restapi/customnewscontentlvl2/news/MSI's-Scott-Adamson-Earns-CCM-Designation",
    "url": "/news/MSI-s-Scott-Adamson-Earns-CCM-Designation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Effective Preparation for EHS Compliance Audits",
    "apiurl": "/restapi/customnewscontentlvl2/news/Effective-Preparation-for-EHS-Compliance-Audits",
    "url": "/news/Effective-Preparation-for-EHS-Compliance-Audits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Effective Preparation for EHS Compliance Audits",
    "apiurl": "/restapi/customnewscontentlvl2/news/Effective-Preparation-for-EHS-Compliance-Audits",
    "url": "/news/ehs-management/Effective-Preparation-for-EHS-Compliance-Audits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Water Quality Technical Experts Meet Aug. 21, Discuss Optional Copper Model for Standards",
    "apiurl": "/restapi/customnewscontentlvl2/news/Water-Quality-Technical-Experts-Meet-Aug-21-Discuss-Optional-Copper-Model-for-Standards",
    "url": "/news/Water-Quality-Technical-Experts-Meet-Aug-21-Discuss-Optional-Copper-Model-for-Standards",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEQ Proposed Changes to Various Chapters of Title 129-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEQ-Proposed-Changes-to-Various-Chapters-of-Title-129-Nebraska",
    "url": "/news/NDEQ-Proposed-Changes-to-Various-Chapters-of-Title-129-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Rulemaking to Provide Regulatory Certainty",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Rulemaking-to-Provide-Regulatory-Certainty",
    "url": "/news/Proposed-Rulemaking-to-Provide-Regulatory-Certainty",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Issues Final Area Designations for the 2008 NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Issues-Final-Area-Designations-for-the-2008-NAAQS",
    "url": "/news/EPA-Issues-Final-Area-Designations-for-the-2008-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE Releases CALPUFF 2.1 Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-Releases-CALPUFF-2-1-Update",
    "url": "/news/BREEZE-Releases-CALPUFF-2-1-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Environmental Site Assessments",
    "apiurl": "/restapi/customnewscontentlvl2/news/Environmental-Site-Assessments",
    "url": "/news/Environmental-Site-Assessments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Executive Order Requires EPA to Establish Website for Guidance Documents Currently in Effect",
    "apiurl": "/restapi/customnewscontentlvl2/news/executive-order-requires-epa-to-establish-website-for-guidance-documents-currently-in-effect",
    "url": "/news/executive-order-requires-epa-to-establish-website-for-guidance-documents-currently-in-effect",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Executive Order Requires EPA to Establish Website for Guidance Documents Currently in Effect",
    "apiurl": "/restapi/customnewscontentlvl2/news/executive-order-requires-epa-to-establish-website-for-guidance-documents-currently-in-effect",
    "url": "/federal/executive-order-requires-epa-to-establish-website-for-guidance-documents-currently-in-effect",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Energy Assessment Requirements for Boilers at Area Sources of HAP",
    "apiurl": "/restapi/customnewscontentlvl2/news/Energy-Ass",
    "url": "/news/Energy-Ass",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated Version of AERMOD Released in December",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updated-Version-of-AERMOD-Released-in-December",
    "url": "/news/Updated-Version-of-AERMOD-Released-in-December",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Unveils New Permitting Procedures-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/TCEQ-Unveils-New-Permitting-Procedures-Texas",
    "url": "/news/TCEQ-Unveils-New-Permitting-Procedures-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Requirements Proposed in EPAs Draft 2020 MSGP",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-requirements-proposed-in-epas-draft-2020-msgp",
    "url": "/news/new-requirements-proposed-in-epas-draft-2020-msgp",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Requirements Proposed in EPAs Draft 2020 MSGP",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-requirements-proposed-in-epas-draft-2020-msgp",
    "url": "/federal/new-requirements-proposed-in-epa-s-draft-2020-msgp",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Wyoming’s 5-Year Ambient Air Monitoring Network Assessment Available for Comment",
    "apiurl": "/restapi/customnewscontentlvl2/news/wyoming-s-5-year-ambient-air-monitoring-network-assessment-available-for-comment",
    "url": "/news/wyoming-s-5-year-ambient-air-monitoring-network-assessment-available-for-comment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Understanding  GHG Verification  Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/Understanding-GHG-Verification-Requirements",
    "url": "/news/Understanding-GHG-Verification-Requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "U.S. EPA Proposes Strengthening Ozone National Ambient Air Quality Standard (NAAQS)",
    "apiurl": "/restapi/customnewscontentlvl2/news/U-S-EPA-P",
    "url": "/news/U-S-EPA-P",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Plan Approval: Revisions to VOC Definitions and Ambient Air Quality Standards-Georgia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Plan-Approval-Revisions-to-VOC-Definitions-and-Ambient-Air-Quality-Standards-Georgia",
    "url": "/news/Air-Plan-Approval-Revisions-to-VOC-Definitions-and-Ambient-Air-Quality-Standards-Georgia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Registration for Oregon Clean Fuels Program Due June 30th – Possible Impacts to Suppliers in Surrounding States",
    "apiurl": "/restapi/customnewscontentlvl2/news/Registration-for-Oregon-Clean-Fuels-Program-Due-June-30th-Possible-Impacts-to-Suppliers-in-Surrounding-States",
    "url": "/news/Registration-for-Oregon-Clean-Fuels-Program-Due-June-30th-Possible-Impacts-to-Suppliers-in-Surrounding-States",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "WDNR Debuts New Way to Track Air Permit Progress-Wisconsin",
    "apiurl": "/restapi/customnewscontentlvl2/news/WDNR-Debuts-New-Way-to-Track-Air-Permit-Progress-Wisconsin",
    "url": "/news/WDNR-Debuts-New-Way-to-Track-Air-Permit-Progress-Wisconsin",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Canadian Council of Ministers of the Environment Endorses New Air Quality Standards for NO2-British Columbia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Canadian-Council-of-Ministers-of-the-Environment-Endorses-New-Air-Quality-Standards-for-NO2-British-Columbia",
    "url": "/news/Canadian-Council-of-Ministers-of-the-Environment-Endorses-New-Air-Quality-Standards-for-NO2-British-Columbia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Type B Registration Operation Permit Available",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Type-B-Registration-Operation-Permit-Available",
    "url": "/news/New-Type-B-Registration-Operation-Permit-Available",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Updates to Missouri Air Regulations-Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Updates-to-Missouri-Air-Regulations-Missouri",
    "url": "/news/Proposed-Updates-to-Missouri-Air-Regulations-Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Upcoming Complimentary Webinar! MassDEP SR and GHG Reports: Tips and Tricks and What You Need to Know-Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/Upcoming-Complimentary-Webinar!-MassDEP-SR-and-GHG-Reports-Tips-and-Tricks-and-What-You-Need-to-Know-Massachusetts",
    "url": "/news/Upcoming-Complimentary-Webinar!-MassDEP-SR-and-GHG-Reports-Tips-and-Tricks-and-What-You-Need-to-Know-Massachusetts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes More Industry Groups for GHG Reporting",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-More-Industry-Groups-for-GHG-Reporting",
    "url": "/news/EPA-Proposes-More-Industry-Groups-for-GHG-Reporting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEE Proposed Issuance, with Change, to the NPDES General Permit NER920000",
    "apiurl": "/restapi/customnewscontentlvl2/news/ndee-proposed-issuance-with-change-to-the-npdes-general-permit-ner920000",
    "url": "/news/ndee-proposed-issuance-with-change-to-the-npdes-general-permit-ner920000",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEE Proposed Issuance, with Change, to the NPDES General Permit NER920000",
    "apiurl": "/restapi/customnewscontentlvl2/news/ndee-proposed-issuance-with-change-to-the-npdes-general-permit-ner920000",
    "url": "/news/draft-2021-ambient-air-quality-monitoring-network-plan-published-by-ndee",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDEM Proposes Guidelines for Approval and Use of Representative Stack Test Data",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDEM-Proposes-Guidelines-for-Approval-and-Use-of-Representative-Stack-Test-Data",
    "url": "/news/IDEM-Proposes-Guidelines-for-Approval-and-Use-of-Representative-Stack-Test-Data",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "North Dakota Proposes Revisions to State Implementation Plan for Air Pollution Control",
    "apiurl": "/restapi/customnewscontentlvl2/news/North-Dakota-Proposes-Revisions-to-State-Implementation-Plan-for-Air-Pollution-Control",
    "url": "/news/North-Dakota-Proposes-Revisions-to-State-Implementation-Plan-for-Air-Pollution-Control",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "November 2014 California Cap-and-Trade and Québec Cap-and-Trade Joint Auction Details Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/November-2014-California-Cap-and-Trade-and-Québec-Cap-and-Trade-Joint-Auction-Details-Released",
    "url": "/news/November-2014-California-Cap-and-Trade-and-Québec-Cap-and-Trade-Joint-Auction-Details-Released",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDAQMD Proposed Adoption of the 2015 8-Hour RACT SIP Analysis",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDAQMD-Proposed-Adoption-of-the-2015-8-Hour-RACT-SIP-Analysis",
    "url": "/news/MDAQMD-Proposed-Adoption-of-the-2015-8-Hour-RACT-SIP-Analysis",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SJVAPCD Rule 4354, Glass Melting Furnaces, Public Scoping Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/sjvapcd-rule-4354-glass-melting-furnaces-public-scoping-meeting",
    "url": "/news/sjvapcd-rule-4354-glass-melting-furnaces-public-scoping-meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Draft Emergency Engine to Demand Response Engine FAQs-Connecticut",
    "apiurl": "/restapi/customnewscontentlvl2/news/Draft-Emergency-Engine-to-Demand-Response-Engine-FAQs-Connecticut",
    "url": "/news/Draft-Emergency-Engine-to-Demand-Response-Engine-FAQs-Connecticut",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DEQ Finalizes CO2 Budget Trading Program as Virginia Joins RGGI",
    "apiurl": "/restapi/customnewscontentlvl2/news/deq-finalizes-co2-budget-trading-program-as-virginia-joins-rggi",
    "url": "/news/deq-finalizes-co2-budget-trading-program-as-virginia-joins-rggi",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Environmental & Carbon Reporting & Disclosure: A Complex and Evolving Paradigm",
    "apiurl": "/restapi/customnewscontentlvl2/news/Environmental-Carbon-Reporting-Disclosure-A-Complex-and-Evolving-Paradigm",
    "url": "/news/Environmental-Carbon-Reporting-Disclosure-A-Complex-and-Evolving-Paradigm",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "OMB Guidance for the EPA Regarding COVID-19",
    "apiurl": "/restapi/customnewscontentlvl2/news/omb-guidance-for-the-epa-regarding-covid-19",
    "url": "/news/omb-guidance-for-the-epa-regarding-covid-19",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "OMB Guidance for the EPA Regarding COVID-19",
    "apiurl": "/restapi/customnewscontentlvl2/news/omb-guidance-for-the-epa-regarding-covid-19",
    "url": "/federal/omb-guidance-for-the-epa-regarding-covid-19",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Helps Portland Cement Company Develop EMS",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Helps-Portland-Cement-Company-Develop-EMS",
    "url": "/news/Trinity-Helps-Portland-Cement-Company-Develop-EMS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Top Considerations and Challenges for ISO 14001:2015 Alignment",
    "apiurl": "/restapi/customnewscontentlvl2/news/Top-Considerations-and-Challenges-for-ISO-14001-2015-Alignment",
    "url": "/news/Top-Considerations-and-Challenges-for-ISO-14001-2015-Alignment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDEQ Accepting enHance Applications-Mississippi",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDEQ-Accepting-enHance-Applications-Mississippi",
    "url": "/news/MDEQ-Accepting-enHance-Applications-Mississippi",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Publishes On-Site Inspection Procedures",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-publishes-on-site-inspection-procedures",
    "url": "/news/epa-publishes-on-site-inspection-procedures",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Publishes On-Site Inspection Procedures",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-publishes-on-site-inspection-procedures",
    "url": "/federal/epa-publishes-on-site-inspection-procedures",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MACT Startup, Shutdown, and Malfunction Exemption Removed-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/MACT-Startup-Shutdown-and-Malfunction-Exemption-Removed-Texas",
    "url": "/news/MACT-Startup-Shutdown-and-Malfunction-Exemption-Removed-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Trinity Offices Serve Clients in the Northwest, Northeast and Deep South",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Trinity-Offices-Serve-Clients-in-the-Northwest-Northeast-and-Deep-South",
    "url": "/news/New-Trinity-Offices-Serve-Clients-in-the-Northwest-Northeast-and-Deep-South",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Staff Spotlight: Atmospheric Scientist Tackles Complex Air Quality Issues",
    "apiurl": "/restapi/customnewscontentlvl2/news/Staff-Spotlight-Atmospheric-Scientist-Tackles-Complex-Air-Quality-Issues",
    "url": "/news/Staff-Spotlight-Atmospheric-Scientist-Tackles-Complex-Air-Quality-Issues",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "San Diego APCD Restricts Stationary Engine Emissions",
    "apiurl": "/restapi/customnewscontentlvl2/news/san-diego-apcd-restricts-stationary-engine-emissions",
    "url": "/news/san-diego-apcd-restricts-stationary-engine-emissions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Sustainability Reporting Guidance for Oil & Gas Industry – 4th Edition released by IPIECA, API, and IOGP",
    "apiurl": "/restapi/customnewscontentlvl2/news/sustainability-reporting-guidance-for-oil-gas-industry-4th-edition-released-by-ipieca-api-and-iogp",
    "url": "/news/sustainability-reporting-guidance-for-oil-gas-industry-4th-edition-released-by-ipieca-api-and-iogp",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Sustainability Reporting Guidance for Oil & Gas Industry – 4th Edition released by IPIECA, API, and IOGP",
    "apiurl": "/restapi/customnewscontentlvl2/news/sustainability-reporting-guidance-for-oil-gas-industry-4th-edition-released-by-ipieca-api-and-iogp",
    "url": "/federal/sustainability-reporting-guidance-for-oil---gas-industry",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Precedent for Produced Water Management?-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Precedent-for-Produced-Water-Management--Wyoming",
    "url": "/news/Precedent-for-Produced-Water-Management--Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ozone Action Days Happening Early in the Upper Green-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ozone-Action-Days-Happening-Early-in-the-Upper-Green-Wyoming",
    "url": "/news/Ozone-Action-Days-Happening-Early-in-the-Upper-Green-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Adds More Muscle in Houston with Argent Consulting Services (ACS)",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Adds-More-Muscle-in-Houston-with-Argent-Consulting-Services-(ACS)",
    "url": "/news/Trinity-Adds-More-Muscle-in-Houston-with-Argent-Consulting-Services-(ACS)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The SO2 Data Requirements Rule: What Next?",
    "apiurl": "/restapi/customnewscontentlvl2/news/the-so2-data-requirements-rule-what-next",
    "url": "/news/the-so2-data-requirements-rule-what-next",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The SO2 Data Requirements Rule: What Next?",
    "apiurl": "/restapi/customnewscontentlvl2/news/the-so2-data-requirements-rule-what-next",
    "url": "/News/Federal/The-SO2-Data-Requirements-Rule--What-Next-/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Confronting Allegations of Air Quality Non-Compliance",
    "apiurl": "/restapi/customnewscontentlvl2/news/Confronting-Allegations-of-Air-Quality-Non-Compliance",
    "url": "/news/Confronting-Allegations-of-Air-Quality-Non-Compliance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "General Permits and Permits by Rule in Indian Country",
    "apiurl": "/restapi/customnewscontentlvl2/news/General-Permits-and-Permits-by-Rule-in-Indian-Country",
    "url": "/news/General-Permits-and-Permits-by-Rule-in-Indian-Country",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NAAQS SIP Revisions Withdrawn-Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/NAAQS-SIP-Revisions-Withdrawn-Missouri",
    "url": "/news/NAAQS-SIP-Revisions-Withdrawn-Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Announces New Corporate Leadership Role and New Kentucky Office Manager",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Announces-New-Corporate-Leadership-Role-and-New-Kentucky-Office-Manager",
    "url": "/news/Trinity-Consultants-Announces-New-Corporate-Leadership-Role-and-New-Kentucky-Office-Manager",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Strategy for Selecting EHS Software",
    "apiurl": "/restapi/customnewscontentlvl2/news/Strategy-for-Selecting-EHS-Software",
    "url": "/news/Strategy-for-Selecting-EHS-Software",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Announces Strengthening of Ozone Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Announces-Strengthening-of-Ozone-Standard",
    "url": "/news/EPA-Announces-Strengthening-of-Ozone-Standard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KDHE Emission Inventory Newsletter",
    "apiurl": "/restapi/customnewscontentlvl2/news/KDHE-Emission-Inventory-Newsletter",
    "url": "/news/KDHE-Emission-Inventory-Newsletter",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NJDEP Proposes Rule Amendments for Permit and Reporting Requirements for Fumigants and other Hazardous Air Pollutants",
    "apiurl": "/restapi/customnewscontentlvl2/news/njdep-proposes-rule-for-permit-and-reporting-fumigants-and-other-haps",
    "url": "/news/njdep-proposes-rule-for-permit-and-reporting-fumigants-and-other-haps",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "One-on-One Tutoring on the Issues Important to You",
    "apiurl": "/restapi/customnewscontentlvl2/news/One-on-One-Tutoring-on-the-Issues-Important-to-You",
    "url": "/news/One-on-One-Tutoring-on-the-Issues-Important-to-You",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Status of Boiler MACT and Proposed Amendments to Case-by-Case MACT Rules-South Carolina",
    "apiurl": "/restapi/customnewscontentlvl2/news/Status-of-Boiler-MACT-and-Proposed-Amendments-to-Case-by-Case-MACT-Rules-South-Carolina",
    "url": "/news/Status-of-Boiler-MACT-and-Proposed-Amendments-to-Case-by-Case-MACT-Rules-South-Carolina",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Preparing for ISO 14001:2015",
    "apiurl": "/restapi/customnewscontentlvl2/news/Preparing-for-ISO-14001-2015",
    "url": "/news/Preparing-for-ISO-14001-2015",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DEQ Publishes Proposed Rule Establishing a State CO2 Budget Trading Program-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/DEQ-Publishes-Proposed-Rule-Establishing-a-State-CO2-Budget-Trading-Program-Virginia",
    "url": "/news/DEQ-Publishes-Proposed-Rule-Establishing-a-State-CO2-Budget-Trading-Program-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revisions to OLD MACT [40 CFR 63, subpart EEEE]",
    "apiurl": "/restapi/customnewscontentlvl2/news/revisions-to-old-mact-40-cfr-63-subpart-eeee-",
    "url": "/news/revisions-to-old-mact-40-cfr-63-subpart-eeee-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revisions to OLD MACT [40 CFR 63, subpart EEEE]",
    "apiurl": "/restapi/customnewscontentlvl2/news/revisions-to-old-mact-40-cfr-63-subpart-eeee-",
    "url": "/federal/revisions-to-old-mact",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Expands in British Columbia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Expands-in-British-Columbia",
    "url": "/news/Trinity-Consultants-Expands-in-British-Columbia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GHG Monitoring for Oil & Gas",
    "apiurl": "/restapi/customnewscontentlvl2/news/GHG-Monitoring-for-Oil-Gas",
    "url": "/news/GHG-Monitoring-for-Oil-Gas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Bay Area AQMD Proposes Revisions to New Source Review Regulation",
    "apiurl": "/restapi/customnewscontentlvl2/news/Bay-Area-AQMD-Proposes-Revisions-to-New-Source-Review-Regulation",
    "url": "/news/Bay-Area-AQMD-Proposes-Revisions-to-New-Source-Review-Regulation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Toxics in the News- \"The Smokestack Effect\"",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Toxics",
    "url": "/news/Air-Toxics",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed State Implementation Plan Revision",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-State-Implementation-Plan-Revision",
    "url": "/news/Proposed-State-Implementation-Plan-Revision",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD Evaluating “Building Electrification” for Emission Reductions",
    "apiurl": "/restapi/customnewscontentlvl2/news/scaqmd-evaluating-building-electrification-for-emission-reductions",
    "url": "/news/scaqmd-evaluating-building-electrification-for-emission-reductions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Changes to Title V Air Permits Guidance Manual from 2014 US Supreme Court Ruling-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Changes-to-Title-V-Air-Permits-Guidance-Manual-from-2014-US-Supreme-Court-Ruling-Virginia",
    "url": "/news/Proposed-Changes-to-Title-V-Air-Permits-Guidance-Manual-from-2014-US-Supreme-Court-Ruling-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Registration for Small Sources is Here!  Does Your Source Qualify?",
    "apiurl": "/restapi/customnewscontentlvl2/news/Registration-for-Small-Sources-is-Here!-Does-Your-Source-Qualify-",
    "url": "/news/Registration-for-Small-Sources-is-Here!-Does-Your-Source-Qualify-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "E-Mail Submittal Option for Routine Air Quality Reports",
    "apiurl": "/restapi/customnewscontentlvl2/news/E-Mail-Submittal-Option-for-Routine-Air-Quality-Reports",
    "url": "/news/E-Mail-Submittal-Option-for-Routine-Air-Quality-Reports",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Cooling Water Intake Structures Rule Seeks to Minimize Adverse Impact",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Cooling-Water-Intake-Structures-Rule-Seeks-to-Minimize-Adverse-Impact",
    "url": "/news/New-Cooling-Water-Intake-Structures-Rule-Seeks-to-Minimize-Adverse-Impact",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Letter from AWMA Modeling Committee to EPA Addresses Air Quality Modeling Challenges for PM2.5 and NO2 NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/Letter-fro",
    "url": "/news/Letter-fro",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CFATS Compliance – Lessons Learned from an Authorization Visit",
    "apiurl": "/restapi/customnewscontentlvl2/news/cfats-compliance-lessons-learned-from-an-authorization-visit",
    "url": "/news/cfats-compliance-lessons-learned-from-an-authorization-visit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CFATS Compliance – Lessons Learned from an Authorization Visit",
    "apiurl": "/restapi/customnewscontentlvl2/news/cfats-compliance-lessons-learned-from-an-authorization-visit",
    "url": "/federal/lessons-learned-from-an-authorization-visit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "RICE MACT, Chopped",
    "apiurl": "/restapi/customnewscontentlvl2/news/RICE-MACT-Chopped",
    "url": "/news/RICE-MACT-Chopped",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes More Industry Groups for GHG Reporting-Oklahoma",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-More-Industry-Groups-for-GHG-Reporting-Oklahoma",
    "url": "/news/EPA-Proposes-More-Industry-Groups-for-GHG-Reporting-Oklahoma",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Coast Air Quality Management District – Proposed Rule 1430-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Coast-Air-Quality-Management-District-Proposed-Rule-1430-California",
    "url": "/news/South-Coast-Air-Quality-Management-District-Proposed-Rule-1430-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Don't forget the upcoming Compliance Certifications for your facility!",
    "apiurl": "/restapi/customnewscontentlvl2/news/Don't-forget-the-upcoming-Compliance-Certifications-for-your-facility!",
    "url": "/news/Don't-forget-the-upcoming-Compliance-Certifications-for-your-facility!",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Mojave Desert Air Quality Management District – Changes to Proposed Rule Amendments to PSD Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/Mojave-Desert-Air-Quality-Management-District-Changes-to-Proposed-Rule-Amendments-to-PSD-Program",
    "url": "/news/Mojave-Desert-Air-Quality-Management-District-Changes-to-Proposed-Rule-Amendments-to-PSD-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to the Toxics Reporting Inventory (TRI) Reporting Requirements-Montana",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-to-the-Toxics-Reporting-Inventory-(TRI)-Reporting-Requirements-Montana",
    "url": "/news/Updates-to-the-Toxics-Reporting-Inventory-(TRI)-Reporting-Requirements-Montana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes Amendments to 30 Subparts Under the Mandatory GHG Reporting Rule (40 CFR Part 98)",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-Amendments-to-30-Subparts-Under-the-Mandatory-GHG-Reporting-Rule-(40-CFR-Part-98)",
    "url": "/news/EPA-Proposes-Amendments-to-30-Subparts-Under-the-Mandatory-GHG-Reporting-Rule-(40-CFR-Part-98)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Understanding and Preparing for an Inspection",
    "apiurl": "/restapi/customnewscontentlvl2/news/Understanding-and-Preparing-for-an-Inspection-",
    "url": "/news/Understanding-and-Preparing-for-an-Inspection-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Enforcement Discretion for Oil and Gas Sites in the Permian Basin: The Audit Act and Permian Basin Find It and Fix It Initiative",
    "apiurl": "/restapi/customnewscontentlvl2/news/enforcement-discretion-for-oil-and-gas-sites-in-the-permian-basin-the-audit-act-and-permian-basin-find-it-and-fix-it-initiative",
    "url": "/news/enforcement-discretion-for-oil-and-gas-sites-in-the-permian-basin-the-audit-act-and-permian-basin-find-it-and-fix-it-initiative",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Enforcement Discretion for Oil and Gas Sites in the Permian Basin: The Audit Act and Permian Basin Find It and Fix It Initiative",
    "apiurl": "/restapi/customnewscontentlvl2/news/enforcement-discretion-for-oil-and-gas-sites-in-the-permian-basin-the-audit-act-and-permian-basin-find-it-and-fix-it-initiative",
    "url": "/www.trinityconsultants.com/enforcement-discretion-for-oil-and-gas-sites-in-the-permian-basin-the-audit-act-and-permian-basin-find-it-and-fix-it-initiative",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA NPDES Compliance Initiative - Are You Submitting Your DMRs?-Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-NPDES-Compliance-Initiative---Are-You-Submitting-Your-DMRs--Missouri",
    "url": "/news/USEPA-NPDES-Compliance-Initiative---Are-You-Submitting-Your-DMRs--Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PADEP Finalizes Standards for Control of VOC Emissions from Industrial Cleaning Solvents-Pennsylvania",
    "apiurl": "/restapi/customnewscontentlvl2/news/PADEP-Finalizes-Standards-for-Control-of-VOC-Emissions-from-Industrial-Cleaning-Solvents-Pennsylvania",
    "url": "/news/PADEP-Finalizes-Standards-for-Control-of-VOC-Emissions-from-Industrial-Cleaning-Solvents-Pennsylvania",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Unfinished Business: What Happens to EPA with a Change in US Presidents?",
    "apiurl": "/restapi/customnewscontentlvl2/news/unfinished-business-what-happens-to-epa-with-a-change-in-us-presidents",
    "url": "/news/unfinished-business-what-happens-to-epa-with-a-change-in-us-presidents",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Delegates Authority to Washoe County Health District for PSD Regulation Implementation",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-delegates-authority-to-washoe-county-health-district-for-psd-regulation-implementation",
    "url": "/news/epa-delegates-authority-to-washoe-county-health-district-for-psd-regulation-implementation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cumulative Impact Bill in Maryland Senate",
    "apiurl": "/restapi/customnewscontentlvl2/news/Cumulative-Impact-Bill-in-Maryland-Senate",
    "url": "/news/Cumulative-Impact-Bill-in-Maryland-Senate",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Appoints New Eastern Regional Director",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Appoints-New-Eastern-Regional-Director",
    "url": "/news/Trinity-Appoints-New-Eastern-Regional-Director",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Features/Attributes Added to WY Air Quality Division's Online IMPACT System-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Features-Attributes-Added-to-WY-Air-Quality-Division's-Online-IMPACT-System-Wyoming",
    "url": "/news/Features-Attributes-Added-to-WY-Air-Quality-Division's-Online-IMPACT-System-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Are you an E&P operator, using open flares? The Guidance is Changing!-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Are-you-an-E-P-operator-using-open-flares-The-Guidance-is-Changing!-Colorado",
    "url": "/news/Are-you-an-E-P-operator-using-open-flares-The-Guidance-is-Changing!-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DHEC Modeling Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/DHEC-Modeling-Updates",
    "url": "/news/DHEC-Modeling-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Green House Gases Regulatory Activity",
    "apiurl": "/restapi/customnewscontentlvl2/news/Green-House-Gases-Regulatory-Activity",
    "url": "/news/Green-House-Gases-Regulatory-Activity",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Life's a Beach at Trinity's New Corpus Christi Office",
    "apiurl": "/restapi/customnewscontentlvl2/news/Life's-a-Beach-at-Trinity's-New-Corpus-Christi-Office",
    "url": "/news/Life's-a-Beach-at-Trinity's-New-Corpus-Christi-Office",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "U.S. EPA's Recommendations for PM2.5 Nonattainment Areas",
    "apiurl": "/restapi/customnewscontentlvl2/news/U-S-EPA's",
    "url": "/news/U-S-EPA's",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Notice of Proposed Rulemaking for Maricopa County Air Quality Department Rule 324 (Stationary RICE)",
    "apiurl": "/restapi/customnewscontentlvl2/news/notice-of-proposed-rulemaking-for-maricopa-county-air-quality-department-rule-324-stationary-rice",
    "url": "/news/notice-of-proposed-rulemaking-for-maricopa-county-air-quality-department-rule-324-stationary-rice",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA's Partial Approval and Disapproval of Arizona State Implementation Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA's-Partial-Approval-and-Disapproval-of-Arizona-State-Implementation-Plan-",
    "url": "/news/USEPA's-Partial-Approval-and-Disapproval-of-Arizona-State-Implementation-Plan-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Complying with EPA’s Risk Management Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/Complying-with-EPA-s-Risk-Management-Program",
    "url": "/news/Complying-with-EPA-s-Risk-Management-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oregon DEQ Proposed Rule for GHG Control from Landfills",
    "apiurl": "/restapi/customnewscontentlvl2/news/oregon-deq-proposed-rule-for-ghg-control-from-landfills",
    "url": "/news/oregon-deq-proposed-rule-for-ghg-control-from-landfills",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "COVID-19 Adjustments at Arkansas DEQ",
    "apiurl": "/restapi/customnewscontentlvl2/news/covid-19-adjustments-at-arkansas-deq",
    "url": "/news/covid-19-adjustments-at-arkansas-deq",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "COVID-19 Adjustments at Arkansas DEQ",
    "apiurl": "/restapi/customnewscontentlvl2/news/covid-19-adjustments-at-arkansas-deq",
    "url": "/state/covid-19-adjustments-at-arkansas-deq",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Withdraws \"Source Determinations for Oil and Gas Industries\"",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Withdraws-Source-Determinations-for-Oil-and-Gas-Industries-",
    "url": "/news/EPA-Withdraws-Source-Determinations-for-Oil-and-Gas-Industries-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Additional Designations for the 2015 Ozone National Ambient Air Quality Standard (NAAQS)",
    "apiurl": "/restapi/customnewscontentlvl2/news/Additional-Designations-for-the-2015-Ozone-National-Ambient-Air-Quality-Standard-(NAAQS)",
    "url": "/news/Additional-Designations-for-the-2015-Ozone-National-Ambient-Air-Quality-Standard-(NAAQS)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "More Stringent Emissions Regulations Proposed Under SCAQMD Rule 1110.2 Changes",
    "apiurl": "/restapi/customnewscontentlvl2/news/More-Stringent-Emissions-Regulations-Proposed-Under-SCAQMD-Rule-1110-2-Changes",
    "url": "/news/More-Stringent-Emissions-Regulations-Proposed-Under-SCAQMD-Rule-1110-2-Changes",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Milwaukee-Racine Area Redesignated to Attainment for 24-hour PM2.5",
    "apiurl": "/restapi/customnewscontentlvl2/news/Milwaukee-Racine-Area-Redesignated-to-Attainment-for-24-hour-PM2-5-",
    "url": "/news/Milwaukee-Racine-Area-Redesignated-to-Attainment-for-24-hour-PM2-5-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Annual Operating Fee Change for Title V Facilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/annual-operating-fee-change-for-title-v-facilities",
    "url": "/news/annual-operating-fee-change-for-title-v-facilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SJVAPCD Launches Permit Administration System",
    "apiurl": "/restapi/customnewscontentlvl2/news/SJVAPCD-Launches-Permit-Administration-System-",
    "url": "/news/SJVAPCD-Launches-Permit-Administration-System-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes a Clean Data Determination for the Salt Lake PM2.5 Serious Non-Attainment Area-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-a-Clean-Data-Determination-for-the-Salt-Lake-PM2-5-Serious-Non-Attainment-Area-Utah",
    "url": "/news/EPA-Proposes-a-Clean-Data-Determination-for-the-Salt-Lake-PM2-5-Serious-Non-Attainment-Area-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Prepare for Changes and Upcoming Due Dates Associated with Wyoming’s Recently Issued Final Construction General Permits for Stormwater",
    "apiurl": "/restapi/customnewscontentlvl2/news/prepare-for-changes-and-upcoming-due-dates-associated-with-wyoming-s-recently-issued-final-construction-general-permits-for-stormwater",
    "url": "/news/prepare-for-changes-and-upcoming-due-dates-associated-with-wyoming-s-recently-issued-final-construction-general-permits-for-stormwater",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Prepare for Changes and Upcoming Due Dates Associated with Wyoming’s Recently Issued Final Construction General Permits for Stormwater",
    "apiurl": "/restapi/customnewscontentlvl2/news/prepare-for-changes-and-upcoming-due-dates-associated-with-wyoming-s-recently-issued-final-construction-general-permits-for-stormwater",
    "url": "/states/wyoming/prepare-for-changes-and-upcoming-due-dates-associated-with-wyoming-s-recently-issued-final-construction-general-permits-for-stormwater",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Missouri Air Conservation Commission Meeting Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Missouri-Air-Conservation-Commission-Meeting-Updates",
    "url": "/news/Missouri-Air-Conservation-Commission-Meeting-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Sierra Club is Modeling Power Plants",
    "apiurl": "/restapi/customnewscontentlvl2/news/Sierra-Club-is-Modeling-Power-Plants",
    "url": "/news/Sierra-Club-is-Modeling-Power-Plants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Standard Conditions Finalized for Air Quality Permits-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Standard-Conditions-Finalized-for-Air-Quality-Permits-Nebraska",
    "url": "/news/New-Standard-Conditions-Finalized-for-Air-Quality-Permits-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Air Construction Permit Application Forms Now Available",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Air-Construction-Permit-Application-Forms-Now-Available",
    "url": "/news/New-Air-Construction-Permit-Application-Forms-Now-Available",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Expands in the Middle East with New Qatar Office",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Expands-in-the-Middle-East-with-New-Qatar-Office",
    "url": "/news/Trinity-Expands-in-the-Middle-East-with-New-Qatar-Office",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Rule - National Ambient Air Quality Standards for Ozone",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-Rule---National-Ambient-Air-Quality-Standards-for-Ozone",
    "url": "/news/Final-Rule---National-Ambient-Air-Quality-Standards-for-Ozone",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Program Advisory Forum December Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Program-Advisory-Forum-December-Meeting-",
    "url": "/news/Air-Program-Advisory-Forum-December-Meeting-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oklahoma Air Quality Rule Changes In Progress",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oklahoma-Air-Quality-Rule-Changes-In-Progress-",
    "url": "/news/Oklahoma-Air-Quality-Rule-Changes-In-Progress-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Texas 2017 EI Reporting Updates-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Texas-2017-EI-Reporting-Updates-Texas",
    "url": "/news/Texas-2017-EI-Reporting-Updates-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Understanding North American Regulatory Requirements for Vehicles, Equipment, and Engines",
    "apiurl": "/restapi/customnewscontentlvl2/news/Understanding-North-American-Regulatory-Requirements-for-Vehicles-Equipment-and-Engines",
    "url": "/news/Understanding-North-American-Regulatory-Requirements-for-Vehicles-Equipment-and-Engines",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Reclassifies Denver Ozone Nonattainment Area to Serious-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Reclassifies-Denver-Ozone-Nonattainment-Area-to-Serious-Colorado",
    "url": "/news/EPA-Reclassifies-Denver-Ozone-Nonattainment-Area-to-Serious-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DOEE Finalizes Revised Source Category Permits for Engines Subject to NSPS JJJJ and NSPS IIII -Washington, DC",
    "apiurl": "/restapi/customnewscontentlvl2/news/DOEE-Finalizes-Revised-Source-Category-Permits-for-Engines-Subject-to-NSPS-JJJJ-and-NSPS-IIII--Washington-DC",
    "url": "/news/DOEE-Finalizes-Revised-Source-Category-Permits-for-Engines-Subject-to-NSPS-JJJJ-and-NSPS-IIII--Washington-DC",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Important Message from Trinity Consultants",
    "apiurl": "/restapi/customnewscontentlvl2/news/Important-Message-from-Trinity-Consultants",
    "url": "/news/Important-Message-from-Trinity-Consultants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Wisconsin Reporting Reminders-Wisconsin",
    "apiurl": "/restapi/customnewscontentlvl2/news/Wisconsin-Reporting-Reminders-Wisconsin",
    "url": "/news/Wisconsin-Reporting-Reminders-Wisconsin",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Redesignation Demonstration and Maintenance Plan for the Lemont and Pekin Sulfur Dioxide Nonattainment Areas-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Redesignation-Demonstration-and-Maintenance-Plan-for-the-Lemont-and-Pekin-Sulfur-Dioxide-Nonattainment-Areas-Illinois",
    "url": "/news/Redesignation-Demonstration-and-Maintenance-Plan-for-the-Lemont-and-Pekin-Sulfur-Dioxide-Nonattainment-Areas-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Toxic Release Inventory Deadline Approaching",
    "apiurl": "/restapi/customnewscontentlvl2/news/Toxic-Release-Inventory-Deadline-Approaching",
    "url": "/news/Toxic-Release-Inventory-Deadline-Approaching",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE ExDAM Featured at Process Safety Symposium",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-ExDAM-Featured-at-Process-Safety-Symposium",
    "url": "/news/BREEZE-ExDAM-Featured-at-Process-Safety-Symposium",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MRR Dates and Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/MRR-Dates-and-Updates",
    "url": "/news/MRR-Dates-and-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Opportunity to Comment on Proposed Changes to Air Construction Permit Forms",
    "apiurl": "/restapi/customnewscontentlvl2/news/Opportunity-to-Comment-on-Proposed-Changes-to-Air-Construction-Permit-Forms",
    "url": "/news/Opportunity-to-Comment-on-Proposed-Changes-to-Air-Construction-Permit-Forms",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DNR Environmental Emergency 24-hour Phone Number Changes",
    "apiurl": "/restapi/customnewscontentlvl2/news/DNR-Environmental-Emergency-24-hour-Phone-Number-Changes",
    "url": "/news/DNR-Environmental-Emergency-24-hour-Phone-Number-Changes",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Landfills, XXX Rated!",
    "apiurl": "/restapi/customnewscontentlvl2/news/Landfills-XXX-Rated!",
    "url": "/news/Landfills-XXX-Rated!",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trends in Environmental Compliance Auditing",
    "apiurl": "/restapi/customnewscontentlvl2/news/trends-in-environmental-compliance-auditing",
    "url": "/news/trends-in-environmental-compliance-auditing",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Hour Guidance Summary-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Hour-Guidance-Summary-Texas",
    "url": "/news/New-Hour-Guidance-Summary-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "COVID-19 Implications for EPA’s Enforcement and Compliance Assurance Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/covid-19-implications-for-epa-s-enforcement-and-compliance-assurance-program",
    "url": "/news/covid-19-implications-for-epa-s-enforcement-and-compliance-assurance-program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "COVID-19 Implications for EPA’s Enforcement and Compliance Assurance Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/covid-19-implications-for-epa-s-enforcement-and-compliance-assurance-program",
    "url": "/federal/covid-19-implications-for-epas-enforcement-and-compliance-assurance-program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "WY-DEQ and EPA Sign Self-Audit Agreement-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/WY-DEQ-and-EPA-Sign-Self-Audit-Agreement-Wyoming",
    "url": "/news/WY-DEQ-and-EPA-Sign-Self-Audit-Agreement-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cap-and-Trade August 2017 Joint-Auction Results Released-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/Cap-and-Trade-August-2017-Joint-Auction-Results-Released-California",
    "url": "/news/Cap-and-Trade-August-2017-Joint-Auction-Results-Released-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Wyoming Air Quality Advisory Board Meeting April 27-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Wyoming-Air-Quality-Advisory-Board-Meeting-April-27-Wyoming",
    "url": "/news/Wyoming-Air-Quality-Advisory-Board-Meeting-April-27-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Lesser Known Risk in Asset Acquisition - Understanding Liabilities Beyond a Phase I Assessment Luncheon Seminar",
    "apiurl": "/restapi/customnewscontentlvl2/news/Lesser-Known-Risk-in-Asset-Acquisition---Understanding-Liabilities-Beyond-a-Phase-I-Assessment-Luncheon-Seminar",
    "url": "/news/Lesser-Known-Risk-in-Asset-Acquisition---Understanding-Liabilities-Beyond-a-Phase-I-Assessment-Luncheon-Seminar",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "OPR to Implement Statewide VMT Requirements under CEQA",
    "apiurl": "/restapi/customnewscontentlvl2/news/opr-to-implement-statewide-vmt-requirements-under-ceqa",
    "url": "/news/opr-to-implement-statewide-vmt-requirements-under-ceqa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants to Provide Training on EPA's GHG \"Tailoring Rule\" for Air Quality Permitting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-to-Provide-Training-on-EPA's-GHG-Tailoring-Rule-for-Air-Quality-Permitting",
    "url": "/news/Trinity-Consultants-to-Provide-Training-on-EPA's-GHG-Tailoring-Rule-for-Air-Quality-Permitting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2012 PM2.5 NAAQS Attainment Designation",
    "apiurl": "/restapi/customnewscontentlvl2/news/2012-PM2-5-NAAQS-Attainment-Designation",
    "url": "/news/2012-PM2-5-NAAQS-Attainment-Designation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reporting Reminders (March Update)-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reporting-Reminders-(March-Update)-Iowa",
    "url": "/news/Reporting-Reminders-(March-Update)-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD:  Proposed Amendments to Rules 219 and 222",
    "apiurl": "/restapi/customnewscontentlvl2/news/SCAQMD-Proposed-Amendments-to-Rules-219-and-222",
    "url": "/news/SCAQMD-Proposed-Amendments-to-Rules-219-and-222",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on 2008 Ozone NAAQS Implementation in Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-2008-Ozone-NAAQS-Implementation-in-Illinois",
    "url": "/news/Update-on-2008-Ozone-NAAQS-Implementation-in-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Georgia VOC Nonattainment Area Rules Change",
    "apiurl": "/restapi/customnewscontentlvl2/news/Georgia-VO",
    "url": "/news/Georgia-VO",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2012 Reporting Reminders-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/2012-Reporting-Reminders-Nebraska",
    "url": "/news/2012-Reporting-Reminders-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated Washington Draft Greenhouse Gas Reporting Rule Posted",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updated-Washington-Draft-Greenhouse-Gas-Reporting-Rule-Posted",
    "url": "/news/Updated-Washington-Draft-Greenhouse-Gas-Reporting-Rule-Posted",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PHMSA FAQs Shed Light on Regulations for Midstream Processing Facilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/phmsa-faqs-shed-light-on-regulations-for-midstream-processing-facilities",
    "url": "/news/phmsa-faqs-shed-light-on-regulations-for-midstream-processing-facilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Need a Universal Waste Cheat Sheet-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Need-a-Universal-Waste-Cheat-Sheet-Kansas",
    "url": "/news/Need-a-Universal-Waste-Cheat-Sheet-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Change to Reporting Requirements in Response to Hurricane Harvey-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/TCEQ-Change-to-Reporting-Requirements-in-Response-to-Hurricane-Harvey-Texas",
    "url": "/news/TCEQ-Change-to-Reporting-Requirements-in-Response-to-Hurricane-Harvey-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD Expediting Permit Applications Critical to COVID-19 Response",
    "apiurl": "/restapi/customnewscontentlvl2/news/baaqmd-expediting-permit-applications-critical-to-covid-19-response",
    "url": "/news/baaqmd-expediting-permit-applications-critical-to-covid-19-response",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Kentucky DCA Creates New Air Quality Compliance Guide for Small Businesses",
    "apiurl": "/restapi/customnewscontentlvl2/news/Kentucky-DCA-Creates-New-Air-Quality-Compliance-Guide-for-Small-Businesses",
    "url": "/news/Kentucky-DCA-Creates-New-Air-Quality-Compliance-Guide-for-Small-Businesses",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Division for Air Quality Finalizes Repeal of 401 KAR 52:080 Regulatory Limits on Potential to Emit",
    "apiurl": "/restapi/customnewscontentlvl2/news/Division-f",
    "url": "/news/Division-f",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EHS Auditing Best Practices Part 3: Ensuring Confidentiality",
    "apiurl": "/restapi/customnewscontentlvl2/news/ehs-auditing-best-practices-part-3-ensuring-confidentiality",
    "url": "/news/ehs-auditing-best-practices-part-3-ensuring-confidentiality",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ohio EPA Blasts U.S. EPA's Proposal to Reclassify Columbus & Cincinnati Areas to Moderate Nonattainment Status with 8-hr Ozone Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ohio-EPA-Blasts-U-S-EPA's-Proposal-to-Reclassify-Columbus-Cincinnati-Areas-to-Moderate-Nonattainment-Status-with-8-hr-Ozone-Standard",
    "url": "/news/Ohio-EPA-Blasts-U-S-EPA's-Proposal-to-Reclassify-Columbus-Cincinnati-Areas-to-Moderate-Nonattainment-Status-with-8-hr-Ozone-Standard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Source Review State Implementation Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Source-Review-State-Implementation-Plan",
    "url": "/news/New-Source-Review-State-Implementation-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Climate Change Related Reporting & Disclosures",
    "apiurl": "/restapi/customnewscontentlvl2/news/climate-change-related-reporting-disclosures",
    "url": "/news/climate-change-related-reporting-disclosures",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Climate Change Related Reporting & Disclosures",
    "apiurl": "/restapi/customnewscontentlvl2/news/climate-change-related-reporting-disclosures",
    "url": "/www.trinityconsultants.com/news/climate-change-related-reporting-disclosures",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Maryland Regulations in Development",
    "apiurl": "/restapi/customnewscontentlvl2/news/Maryland-Regulations-in-Development",
    "url": "/news/Maryland-Regulations-in-Development",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NEW General Industrial Storm Water Permit NOI Now Available-Ohio",
    "apiurl": "/restapi/customnewscontentlvl2/news/NEW-General-Industrial-Storm-Water-Permit-NOI-Now-Available-Ohio",
    "url": "/news/NEW-General-Industrial-Storm-Water-Permit-NOI-Now-Available-Ohio",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Pennsylvania Fails to Submit SIP for 1997 PM 2.5 NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/Pennsylvania-Fails-to-Submit-SIP-for-1997-PM-2-5-NAAQS",
    "url": "/news/Pennsylvania-Fails-to-Submit-SIP-for-1997-PM-2-5-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Reconsiders Ozone Standards",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Reconsiders-Ozone-Standards",
    "url": "/news/EPA-Reconsiders-Ozone-Standards",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NPRI Reports Due June 1, 2017-British Columbia",
    "apiurl": "/restapi/customnewscontentlvl2/news/NPRI-Reports-Due-June-1-2017-British-Columbia",
    "url": "/news/NPRI-Reports-Due-June-1-2017-British-Columbia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cap and Trade Investments Update – Transformative Climate Communities Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/Cap-and-Trade-Investments-Update-Transformative-Climate-Communities-Program",
    "url": "/news/Cap-and-Trade-Investments-Update-Transformative-Climate-Communities-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NMED Air Quality Bureau has Moved!",
    "apiurl": "/restapi/customnewscontentlvl2/news/NMED-Air-Quality-Bureau-has-Moved!",
    "url": "/news/NMED-Air-Quality-Bureau-has-Moved!",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Pipeline Infrastructure Task Force Report",
    "apiurl": "/restapi/customnewscontentlvl2/news/Pipeline-Infrastructure-Task-Force-Report",
    "url": "/news/Pipeline-Infrastructure-Task-Force-Report",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Tip of the Month - Spill Plan Compliance-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Tip-of-the-Month---Spill-Plan-Compliance-Kansas",
    "url": "/news/Tip-of-the-Month---Spill-Plan-Compliance-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Compute Injuries Due to Fragmentation with the  ExDAM HExFRAG Module",
    "apiurl": "/restapi/customnewscontentlvl2/news/Compute-Injuries-Due-to-Fragmentation-with-the-ExDAM-HExFRAG-Module",
    "url": "/news/Compute-Injuries-Due-to-Fragmentation-with-the-ExDAM-HExFRAG-Module",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Status Report on Illinois Permits by Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Status-Report-on-Illinois-Permits-by-Rule",
    "url": "/news/Status-Report-on-Illinois-Permits-by-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NMED Newly Released Oil and Gas Sector Ozone Precursor Rule Expected to Impose Stringent Standards to Significantly Reduce Emissions",
    "apiurl": "/restapi/customnewscontentlvl2/news/nmed-newly-released-oil-and-gas-sector-ozone-precursor-rule-expected-to-impose-stringent-standards-to-significantly-reduce-emissions",
    "url": "/news/nmed-newly-released-oil-and-gas-sector-ozone-precursor-rule-expected-to-impose-stringent-standards-to-significantly-reduce-emissions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Industrial Solvent Cleaning Rule Amendment",
    "apiurl": "/restapi/customnewscontentlvl2/news/Industrial-Solvent-Cleaning-Rule-Amendment",
    "url": "/news/Industrial-Solvent-Cleaning-Rule-Amendment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Upstream and Midstream Operators Required to Attain a 98% Gas Capture by 2026 Under Proposed OCD Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/upstream-and-midstream-operators-required-to-attain-a-98-gas-capture-by-2026-under-proposed-ocd-rule",
    "url": "/news/upstream-and-midstream-operators-required-to-attain-a-98-gas-capture-by-2026-under-proposed-ocd-rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Upstream and Midstream Operators Required to Attain a 98% Gas Capture by 2026 Under Proposed OCD Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/upstream-and-midstream-operators-required-to-attain-a-98-gas-capture-by-2026-under-proposed-ocd-rule",
    "url": "/states/new-mexico/upstream-and-midstream-operators-required-to-attain-a-98--gas-capture-by-2026-under-proposed-ocd-rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEQ's 2017 Environmental Update Workshop-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEQ's-2017-Environmental-Update-Workshop-Nebraska",
    "url": "/news/NDEQ's-2017-Environmental-Update-Workshop-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes to Manifest Requirements for Nonhazardous Special Waste-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Changes-to-Manifest-Requirements-for-Nonhazardous-Special-Waste-Illinois",
    "url": "/news/Changes-to-Manifest-Requirements-for-Nonhazardous-Special-Waste-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDE Finalizes Rule to Allow Interprecursor Trading for NOx and VOC-Maryland",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDE-Finalizes-Rule-to-Allow-Interprecursor-Trading-for-NOx-and-VOC-Maryland",
    "url": "/news/MDE-Finalizes-Rule-to-Allow-Interprecursor-Trading-for-NOx-and-VOC-Maryland",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD’s Self-Reporting Pilot Program for Emergency Engine Operators",
    "apiurl": "/restapi/customnewscontentlvl2/news/baaqmd-s-self-reporting-pilot-program-for-emergency-engine-operators",
    "url": "/news/baaqmd-s-self-reporting-pilot-program-for-emergency-engine-operators",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD’s Self-Reporting Pilot Program for Emergency Engine Operators",
    "apiurl": "/restapi/customnewscontentlvl2/news/baaqmd-s-self-reporting-pilot-program-for-emergency-engine-operators",
    "url": "/www.trinityconsultants.com/news/baaqmd-s-self-reporting-pilot-program-for-emergency-engine-operators",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Notice of July Fee Advisory Group Meetings & Opportunity to Provide Public Input on Draft Fee Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/Notice-of-July-Fee-Advisory-Group-Meetings-Opportunity-to-Provide-Public-Input-on-Draft-Fee-Rules",
    "url": "/news/Notice-of-July-Fee-Advisory-Group-Meetings-Opportunity-to-Provide-Public-Input-on-Draft-Fee-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SJVAPCD Changes to Rule 4905-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/SJVAPCD-Changes-to-Rule-4905-California",
    "url": "/news/SJVAPCD-Changes-to-Rule-4905-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Governor Baker Climate Bill Includes Environmental Justice Component",
    "apiurl": "/restapi/customnewscontentlvl2/news/governor-baker-climate-bill-includes-environmental-justice-component",
    "url": "/news/governor-baker-climate-bill-includes-environmental-justice-component",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Governor Baker Climate Bill Includes Environmental Justice Component",
    "apiurl": "/restapi/customnewscontentlvl2/news/governor-baker-climate-bill-includes-environmental-justice-component",
    "url": "/www.trinityconsultants.com/news/governor-baker-climate-bill-includes-environmental-justice-component",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TRI Reporting Requirements Change",
    "apiurl": "/restapi/customnewscontentlvl2/news/TRI-Reporting-Requirements-Change",
    "url": "/news/TRI-Reporting-Requirements-Change",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BLM Wyoming Releases Greenhouse Gas Toolkit, Requires Submission with All APDs-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/BLM-Wyoming-Releases-Greenhouse-Gas-Toolkit-Requires-Submission-with-All-APDs-Wyoming",
    "url": "/news/BLM-Wyoming-Releases-Greenhouse-Gas-Toolkit-Requires-Submission-with-All-APDs-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GCP-Oil & Gas Permit for Oil and Gas Facilities-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/GCP-Oil-Gas-Permit-for-Oil-and-Gas-Facilities-New-Mexico",
    "url": "/news/GCP-Oil-Gas-Permit-for-Oil-and-Gas-Facilities-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Permitting Methodology for HAPs",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Permitting-Methodology-for-HAPs",
    "url": "/news/New-Permitting-Methodology-for-HAPs",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SJVAPCD Proposes Amendments to Rule 4905 regarding Natural Gas-Fired, Fan-Type Central Furnaces",
    "apiurl": "/restapi/customnewscontentlvl2/news/sjvapcd-proposes-amendments-to-rule-4905-regarding-natural-gas-fired-fan-type-central-furnaces",
    "url": "/news/sjvapcd-proposes-amendments-to-rule-4905-regarding-natural-gas-fired-fan-type-central-furnaces",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SJVAPCD Proposes Amendments to Rule 4905 regarding Natural Gas-Fired, Fan-Type Central Furnaces",
    "apiurl": "/restapi/customnewscontentlvl2/news/sjvapcd-proposes-amendments-to-rule-4905-regarding-natural-gas-fired-fan-type-central-furnaces",
    "url": "/news/states/california/sjvapcd-proposes-amendments-to-rule-4905-regarding-natural-gas-fired-fan-type-central-furnaces",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Updates Guideline on Air Quality Models",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Updates-Guideline-on-Air-Quality-Models",
    "url": "/news/EPA-Updates-Guideline-on-Air-Quality-Models",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DHEC Adopts Federal PM2.5 NSR Implementation Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/DHEC-Adopts-Federal-PM2-5-NSR-Implementation-Rule",
    "url": "/news/DHEC-Adopts-Federal-PM2-5-NSR-Implementation-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Washington Draft Greenhouse Gas Reporting Rule Issued",
    "apiurl": "/restapi/customnewscontentlvl2/news/Washington-Draft-Greenhouse-Gas-Reporting-Rule-Issued",
    "url": "/news/Washington-Draft-Greenhouse-Gas-Reporting-Rule-Issued",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Development of Emission Factors for Combustion of Biofuels",
    "apiurl": "/restapi/customnewscontentlvl2/news/Development-of-Emission-Factors-for-Combustion-of-Biofuels",
    "url": "/news/Development-of-Emission-Factors-for-Combustion-of-Biofuels",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Establishes New 1-hour Standard for Sulfur Dioxide",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Establishes-New-1-hour-Standard-for-Sulfur-Dioxide-",
    "url": "/news/EPA-Establishes-New-1-hour-Standard-for-Sulfur-Dioxide-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Permit Review Branch Manager Position in KDAQ Vacant",
    "apiurl": "/restapi/customnewscontentlvl2/news/Permit-Rev",
    "url": "/news/Permit-Rev",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE 3D Analyst 2.4 Expands Data and Results Visualization Capabilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-3D-Analyst-2-4-Expands-Data-and-Results-Visualization-Capabilities",
    "url": "/news/BREEZE-3D-Analyst-2-4-Expands-Data-and-Results-Visualization-Capabilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Statewide VOC Control Proposals",
    "apiurl": "/restapi/customnewscontentlvl2/news/Statewide-VOC-Control-Proposals-",
    "url": "/news/Statewide-VOC-Control-Proposals-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Division for Air Quality Compliance Reporting Now Available Online!",
    "apiurl": "/restapi/customnewscontentlvl2/news/Division-for-Air-Quality-Compliance-Reporting-Now-Available-Online!",
    "url": "/news/Division-for-Air-Quality-Compliance-Reporting-Now-Available-Online!",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Coal Combustion Residuals (CCR) in Arizona - What is the Status?",
    "apiurl": "/restapi/customnewscontentlvl2/news/Coal-Combustion-Residuals-(CCR)-in-Arizona---What-is-the-Status-",
    "url": "/news/Coal-Combustion-Residuals-(CCR)-in-Arizona---What-is-the-Status-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEP Adopted Revisions to Certain Sections of NAC 519A that Govern Reclamation of Land Subject to Mining Operations",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEP-Adopted-Revisions-to-Certain-Sections-of-NAC-519A-that-Govern-Reclamation-of-Land-Subject-to-Mining-Operations",
    "url": "/news/NDEP-Adopted-Revisions-to-Certain-Sections-of-NAC-519A-that-Govern-Reclamation-of-Land-Subject-to-Mining-Operations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revisions to the Texas SIP for the DFW Ozone Nonattainment Area",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revisions-to-the-Texas-SIP-for-the-DFW-Ozone-Nonattainment-Area",
    "url": "/news/Revisions-to-the-Texas-SIP-for-the-DFW-Ozone-Nonattainment-Area",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Transport Rule is the New CAIR",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Transport-Rule-is-the-New-CAIR",
    "url": "/news/EPA-Transport-Rule-is-the-New-CAIR",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revision to Illinois Motor Vehicle Emissions Budgets",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revision-to-Illinois-Motor-Vehicle-Emissions-Budgets",
    "url": "/news/Revision-to-Illinois-Motor-Vehicle-Emissions-Budgets",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Emission Inventories in New Mexico-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Emission-Inventories-in-New-Mexico-New-Mexico",
    "url": "/news/Air-Emission-Inventories-in-New-Mexico-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Environmental Activity and Sector Registry (EASR)",
    "apiurl": "/restapi/customnewscontentlvl2/news/Environmental-Activity-and-Sector-Registry-(EASR)",
    "url": "/news/Environmental-Activity-and-Sector-Registry-(EASR)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NSPS Subpart OOOOa – EPA Proposes More Challenges for the Oil & Gas Industry",
    "apiurl": "/restapi/customnewscontentlvl2/news/NSPS-Subpart-OOOOa-EPA-Proposes-More-Challenges-for-the-Oil-Gas-Industry",
    "url": "/news/NSPS-Subpart-OOOOa-EPA-Proposes-More-Challenges-for-the-Oil-Gas-Industry",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SIP Review Occurring during October Air Quality Board Meeting-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/SIP-Review-Occurring-during-October-Air-Quality-Board-Meeting-Utah",
    "url": "/news/SIP-Review-Occurring-during-October-Air-Quality-Board-Meeting-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Regulatory Requirements for Consumer Products & Aerosol Coating Products Effective on January 1, 2017",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Regulatory-Requirements-for-Consumer-Products-Aerosol-Coating-Products-Effective-on-January-1-2017",
    "url": "/news/New-Regulatory-Requirements-for-Consumer-Products-Aerosol-Coating-Products-Effective-on-January-1-2017",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NMED Releases Abbreviated NOI Application Form",
    "apiurl": "/restapi/customnewscontentlvl2/news/NMED-Releases-Abbreviated-NOI-Application-Form",
    "url": "/news/NMED-Releases-Abbreviated-NOI-Application-Form",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Annual Tier II Reporting in Nebraska-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/Annual-Tier-II-Reporting-in-Nebraska-Nebraska",
    "url": "/news/Annual-Tier-II-Reporting-in-Nebraska-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Pollution Watch List (APWL) 2016 Delisting Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Pollution-Watch-List-(APWL)-2016-Delisting-Updates",
    "url": "/news/Air-Pollution-Watch-List-(APWL)-2016-Delisting-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Opens Oregon Office",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Opens-Oregon-Office",
    "url": "/news/Trinity-Consultants-Opens-Oregon-Office",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Opens Oregon Office",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Opens-Oregon-Office",
    "url": "/news/company/Trinity-Consultants-Opens-Oregon-Office",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments to the Massachusetts Contingency Plan-Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendments-to-the-Massachusetts-Contingency-Plan-Massachusetts",
    "url": "/news/Proposed-Amendments-to-the-Massachusetts-Contingency-Plan-Massachusetts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated Air Dispersion Modeling Guidance",
    "apiurl": "/restapi/customnewscontentlvl2/news/updated-air-dispersion-modeling-guidance",
    "url": "/news/updated-air-dispersion-modeling-guidance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated Air Dispersion Modeling Guidance",
    "apiurl": "/restapi/customnewscontentlvl2/news/updated-air-dispersion-modeling-guidance",
    "url": "/states/updated-air-dispersion-modeling-guidance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDNR Starts on Electronic Air Permit Application System-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDNR-Starts-on-Electronic-Air-Permit-Application-System-Iowa",
    "url": "/news/IDNR-Starts-on-Electronic-Air-Permit-Application-System-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "OSHA Increases Enforcement Pressure",
    "apiurl": "/restapi/customnewscontentlvl2/news/OSHA-Increases-Enforcement-Pressure",
    "url": "/news/OSHA-Increases-Enforcement-Pressure",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposal to Redesignate the Missouri – St. Louis Area to Attainment for the 1997 8-hour Ozone Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposal-to-Redesignate-the-Missouri-St-Louis-Area-to-Attainment-for-the-1997-8-hour-Ozone-Standard",
    "url": "/news/EPA-Proposal-to-Redesignate-the-Missouri-St-Louis-Area-to-Attainment-for-the-1997-8-hour-Ozone-Standard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Utah Physicians for a Healthy Environment Bring Forward their Air Quality Concerns - Utah's Inland Port-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/Utah-Physicians-for-a-Healthy-Environment-Bring-Forward-their-Air-Quality-Concerns---Utah's-Inland-Port-Utah",
    "url": "/news/Utah-Physicians-for-a-Healthy-Environment-Bring-Forward-their-Air-Quality-Concerns---Utah's-Inland-Port-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Illinois Pollution Control Board Rules on Power Plant Emission Reductions",
    "apiurl": "/restapi/customnewscontentlvl2/news/Illinois-Pollution-Control-Board-Rules-on-Power-Plant-Emission-Reductions",
    "url": "/news/Illinois-Pollution-Control-Board-Rules-on-Power-Plant-Emission-Reductions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Sulfur Dioxide Nonattainment Areas in Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Sulfur-Dioxide-Nonattainment-Areas-in-Illinois",
    "url": "/news/Sulfur-Dioxide-Nonattainment-Areas-in-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Iowa COVID-19 Environmental Compliance Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/iowa-covid-19-environmental-compliance-updates",
    "url": "/news/iowa-covid-19-environmental-compliance-updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Wynnewood 2020 Decision Confirms Major Changes to PSM Applicability of Utilities and non-HHC Equipment",
    "apiurl": "/restapi/customnewscontentlvl2/news/wynnewood-2020-decision-confirms-major-changes-to-psm-applicability-of-utilities-and-non-hhc-equipment",
    "url": "/news/wynnewood-2020-decision-confirms-major-changes-to-psm-applicability-of-utilities-and-non-hhc-equipment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Toxics Emission Inventory Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/air-toxics-emission-inventory-update",
    "url": "/news/air-toxics-emission-inventory-update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Various MDNR Rule Updates and Actions",
    "apiurl": "/restapi/customnewscontentlvl2/news/Various-MDNR-Rule-Updates-and-Actions",
    "url": "/news/Various-MDNR-Rule-Updates-and-Actions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "WDNR Updates to NR 150 Go into Effect",
    "apiurl": "/restapi/customnewscontentlvl2/news/WDNR-Updates-to-NR-150-Go-into-Effect",
    "url": "/news/WDNR-Updates-to-NR-150-Go-into-Effect",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Software Updates x3: BREEZE AERMOD, AERSCREEN and AERMET to Include the Latest U.S. EPA Executables",
    "apiurl": "/restapi/customnewscontentlvl2/news/Software-Updates-x3-BREEZE-AERMOD-AERSCREEN-and-AERMET-to-Include-the-Latest-U-S-EPA-Executables",
    "url": "/news/Software-Updates-x3-BREEZE-AERMOD-AERSCREEN-and-AERMET-to-Include-the-Latest-U-S-EPA-Executables",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Other IDNR Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Other-IDNR-Updates",
    "url": "/news/Other-IDNR-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Yolo-Solano AQMD Solvents Rule Chang",
    "apiurl": "/restapi/customnewscontentlvl2/news/Yolo-Solano-AQMD-Solvents-Rule-Chang",
    "url": "/news/Yolo-Solano-AQMD-Solvents-Rule-Chang",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "AVAQMD Rule 1151.1 - Motor Vehicle Assembly Coating Operations-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/AVAQMD-Rule-1151-1---Motor-Vehicle-Assembly-Coating-Operations-California",
    "url": "/news/AVAQMD-Rule-1151-1---Motor-Vehicle-Assembly-Coating-Operations-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Reporting Requirements for Global Warming Potential (GWP) Greenhouse Gases",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Reporting-Requirements-for-Global-Warming-Potential-(GWP)-Greenhouse-Gases",
    "url": "/news/New-Reporting-Requirements-for-Global-Warming-Potential-(GWP)-Greenhouse-Gases",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes to Universal Application Forms and Submittal Requirements-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/Changes-to-Universal-Application-Forms-and-Submittal-Requirements-New-Mexico",
    "url": "/news/Changes-to-Universal-Application-Forms-and-Submittal-Requirements-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CMAS Rule Amendments Finalized-Oklahoma",
    "apiurl": "/restapi/customnewscontentlvl2/news/CMAS-Rule-Amendments-Finalized-Oklahoma",
    "url": "/news/CMAS-Rule-Amendments-Finalized-Oklahoma",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DHEC Agency Split",
    "apiurl": "/restapi/customnewscontentlvl2/news/DHEC-Agency-Split-",
    "url": "/news/DHEC-Agency-Split-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "AERMOD Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/AERMOD-Update",
    "url": "/news/AERMOD-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants’ Anthony Schroeder Designated as a Certified Consulting Meteorologist",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Anthony-Schroeder-Designated-as-a-Certified-Consulting-Meteorologist",
    "url": "/news/Trinity-Consultants-Anthony-Schroeder-Designated-as-a-Certified-Consulting-Meteorologist",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Utah’s Title V Fees are Anticipated to Increase",
    "apiurl": "/restapi/customnewscontentlvl2/news/Utah-s-Title-V-Fees-are-Anticipated-to-Increase-",
    "url": "/news/Utah-s-Title-V-Fees-are-Anticipated-to-Increase-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "AERMOD and AERMET Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/AERMOD-and-AERMET-Update",
    "url": "/news/AERMOD-and-AERMET-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD Hosting Public Workshop for Proposed Amendments to Regulation 6 Rule 5 on Feb 4",
    "apiurl": "/restapi/customnewscontentlvl2/news/baaqmd-hosting-public-workshop-for-proposed-amendments-to-regulation-6-rule-5-on-feb-4",
    "url": "/news/baaqmd-hosting-public-workshop-for-proposed-amendments-to-regulation-6-rule-5-on-feb-4",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "AirWaves Bulletin Available",
    "apiurl": "/restapi/customnewscontentlvl2/news/AirWaves-Bulletin-Available",
    "url": "/news/AirWaves-Bulletin-Available",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2013 Alabama Air Regulatory Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/2013-Alabama-Air-Regulatory-Update",
    "url": "/news/2013-Alabama-Air-Regulatory-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated Small Source BAT Guidance Memo",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updated-Small-Source-BAT-Guidance-Memo",
    "url": "/news/Updated-Small-Source-BAT-Guidance-Memo",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NC DAQ Policy on Area Source RICE",
    "apiurl": "/restapi/customnewscontentlvl2/news/NC-DAQ-Policy-on-Area-Source-RICE-",
    "url": "/news/NC-DAQ-Policy-on-Area-Source-RICE-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Revisions to DEQ Rules of Practice and Procedure",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Revisions-to-DEQ-Rules-of-Practice-and-Procedure",
    "url": "/news/Proposed-Revisions-to-DEQ-Rules-of-Practice-and-Procedure",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Kansas Diesel Grant Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/Kansas-Diesel-Grant-Program",
    "url": "/news/Kansas-Diesel-Grant-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DNREC Finalizes Revisions to Several Air Quality Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/DNREC-Fina",
    "url": "/news/DNREC-Fina",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Authorizes GHG Permitting Deferral for Biogenic Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Author",
    "url": "/news/EPA-Author",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KDAQ New eForms Application Submittal System is Now Live",
    "apiurl": "/restapi/customnewscontentlvl2/news/KDAQ-New-eForms-Application-Submittal-System-is-Now-Live",
    "url": "/news/KDAQ-New-eForms-Application-Submittal-System-is-Now-Live",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DHEC releases new guidance for simplifying the Air Permitting Process",
    "apiurl": "/restapi/customnewscontentlvl2/news/DHEC-releases-new-guidance-for-simplifying-the-Air-Permitting-Process",
    "url": "/news/DHEC-releases-new-guidance-for-simplifying-the-Air-Permitting-Process",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revised TCEQ Air Dispersion Modeling Guidance Released-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revised-TCEQ-Air-Dispersion-Modeling-Guidance-Released-Texas",
    "url": "/news/Revised-TCEQ-Air-Dispersion-Modeling-Guidance-Released-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ohio EPA Performing Modeling in Support of 1-hr SO2 Attainment Designations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ohio-EPA-Performing-Modeling-in-Support-of-1-hr-SO2-Attainment-Designations",
    "url": "/news/Ohio-EPA-Performing-Modeling-in-Support-of-1-hr-SO2-Attainment-Designations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "OEHHA's Air Toxics Hot Spots Guidance Manual Adopted",
    "apiurl": "/restapi/customnewscontentlvl2/news/OEHHA's-Air-Toxics-Hot-Spots-Guidance-Manual-Adopted-",
    "url": "/news/OEHHA's-Air-Toxics-Hot-Spots-Guidance-Manual-Adopted-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Boiler MACT Reconsideration and Proposed Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/Boiler-MACT-Reconsideration-and-Proposed-Amendments",
    "url": "/news/Boiler-MACT-Reconsideration-and-Proposed-Amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Albuquerque-Bernalillo County Air Quality Control Board Monthly Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Albuquerque-Bernalillo-County-Air-Quality-Control-Board-Monthly-Meeting",
    "url": "/news/Albuquerque-Bernalillo-County-Air-Quality-Control-Board-Monthly-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Changes to Wyoming Air Quality Standards and Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Changes-to-Wyoming-Air-Quality-Standards-and-Regulations",
    "url": "/news/Proposed-Changes-to-Wyoming-Air-Quality-Standards-and-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Electronic Permitting System Now Available for Submitting Air Construction and Approval Applications",
    "apiurl": "/restapi/customnewscontentlvl2/news/Electronic-Permitting-System-Now-Available-for-Submitting-Air-Construction-and-Approval-Applications",
    "url": "/news/Electronic-Permitting-System-Now-Available-for-Submitting-Air-Construction-and-Approval-Applications",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "General Assembly Alters Procedures for Receiving Environmental Enforcement Actions",
    "apiurl": "/restapi/customnewscontentlvl2/news/General-Assembly-Alters-Procedures-for-Receiving-Environmental-Enforcement-Actions",
    "url": "/news/General-Assembly-Alters-Procedures-for-Receiving-Environmental-Enforcement-Actions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Grants Final Action for Florida SSM SIP Call",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Grants",
    "url": "/news/EPA-Grants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Rule Amendments Proposed to Add GHG Applicability to the Title V Program.",
    "apiurl": "/restapi/customnewscontentlvl2/news/Rule-Amendments-Proposed-to-Add-GHG-Applicability-to-the-Title-V-Program-",
    "url": "/news/Rule-Amendments-Proposed-to-Add-GHG-Applicability-to-the-Title-V-Program-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "China’s Belt and Road Initiative: Environmental Impact",
    "apiurl": "/restapi/customnewscontentlvl2/news/China-s-Belt-and-Road-Initiative-Environmental-Impact",
    "url": "/news/China-s-Belt-and-Road-Initiative-Environmental-Impact",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to Georgia EPD's Emission Inventory System",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-to",
    "url": "/news/Updates-to",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Repeal of Affirmative Defense for Excess Emissions During SSM",
    "apiurl": "/restapi/customnewscontentlvl2/news/Repeal-of-Affirmative-Defense-for-Excess-Emissions-During-SSM",
    "url": "/news/Repeal-of-Affirmative-Defense-for-Excess-Emissions-During-SSM",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Repeal of Affirmative Defense for Excess Emissions During SSM",
    "apiurl": "/restapi/customnewscontentlvl2/news/Repeal-of-Affirmative-Defense-for-Excess-Emissions-During-SSM",
    "url": "/news/states/colorado/Repeal-of-Affirmative-Defense-for-Excess-Emissions-During-SSM",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Repeal of Affirmative Defense for Excess Emissions During SSM",
    "apiurl": "/restapi/customnewscontentlvl2/news/Repeal-of-Affirmative-Defense-for-Excess-Emissions-During-SSM",
    "url": "/news/repeal-of-affirmative-defense-for-excess-emissions-during-ssm/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Specialty APENs Revised",
    "apiurl": "/restapi/customnewscontentlvl2/news/Specialty-APENs-Revised",
    "url": "/news/Specialty-APENs-Revised",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDNR Proposes New CTG Rules for Surface Coating, Printing, and Solvent Cleaning Operations",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDNR-Proposes-New-CTG-Rules-for-Surface-Coating-Printing-and-Solvent-Cleaning-Operations",
    "url": "/news/MDNR-Proposes-New-CTG-Rules-for-Surface-Coating-Printing-and-Solvent-Cleaning-Operations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Limits on GHG Emissions from Cars",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Limits-on-GHG-Emissions-from-Cars",
    "url": "/news/New-Limits-on-GHG-Emissions-from-Cars",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD Adopts Regulation 11-18, Air Toxic Emissions Risk Reduction Rule-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/BAAQMD-Adopts-Regulation-11-18-Air-Toxic-Emissions-Risk-Reduction-Rule-California",
    "url": "/news/BAAQMD-Adopts-Regulation-11-18-Air-Toxic-Emissions-Risk-Reduction-Rule-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Washington Judge Rules that Ecology Must Regulate Greenhouse Gas Emissions",
    "apiurl": "/restapi/customnewscontentlvl2/news/Washington-Judge-Rules-that-Ecology-Must-Regulate-Greenhouse-Gas-Emissions",
    "url": "/news/Washington-Judge-Rules-that-Ecology-Must-Regulate-Greenhouse-Gas-Emissions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New NOx RACT Boiler and Indirect Heat Exchanger Emission Limits",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-NOx-RACT-Boiler-and-Indirect-Heat-Exchanger-Emission-Limits",
    "url": "/news/New-NOx-RACT-Boiler-and-Indirect-Heat-Exchanger-Emission-Limits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "FIPS for Six States Proposed to Reduce Interstate Transport of Ozone",
    "apiurl": "/restapi/customnewscontentlvl2/news/FIPS-for-Six-States-Proposed-to-Reduce-Interstate-Transport-of-Ozone",
    "url": "/news/FIPS-for-Six-States-Proposed-to-Reduce-Interstate-Transport-of-Ozone",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Letter to EPA Addressing Tailoring Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/TCEQ-Letter-to-EPA-Addressing-Tailoring-Rule",
    "url": "/news/TCEQ-Letter-to-EPA-Addressing-Tailoring-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Emission Standards for Hazardous Air Pollutants for Two Area Source Categories",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-Emis",
    "url": "/news/Final-Emis",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Seamlessly Process Met Data with BREEZE AERMET 7",
    "apiurl": "/restapi/customnewscontentlvl2/news/Seamlessly-Process-Met-Data-with-BREEZE-AERMET-7",
    "url": "/news/Seamlessly-Process-Met-Data-with-BREEZE-AERMET-7",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Governor Christi Puts Forth Vision for the Future of Energy in NJ",
    "apiurl": "/restapi/customnewscontentlvl2/news/Governor-Christi-Puts-Forth-Vision-for-the-Future-of-Energy-in-NJ",
    "url": "/news/Governor-Christi-Puts-Forth-Vision-for-the-Future-of-Energy-in-NJ",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Issues a New Readily Available Permit for Marine Loading",
    "apiurl": "/restapi/customnewscontentlvl2/news/tceq-issues-a-new-readily-available-permit-for-marine-loading",
    "url": "/news/tceq-issues-a-new-readily-available-permit-for-marine-loading",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Issues a New Readily Available Permit for Marine Loading",
    "apiurl": "/restapi/customnewscontentlvl2/news/tceq-issues-a-new-readily-available-permit-for-marine-loading",
    "url": "/state/tceq-issues-a-new-readily-available-permit-for-marine-loading",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Catherine Templeton Resigns as DHEC Head",
    "apiurl": "/restapi/customnewscontentlvl2/news/Catherine-Templeton-Resigns-as-DHEC-Head",
    "url": "/news/Catherine-Templeton-Resigns-as-DHEC-Head",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Redesignation of the Sullivan County Lead Nonattainment Area to Attainment",
    "apiurl": "/restapi/customnewscontentlvl2/news/Redesignation-of-the-Sullivan-County-Lead-Nonattainment-Area-to-Attainment",
    "url": "/news/Redesignation-of-the-Sullivan-County-Lead-Nonattainment-Area-to-Attainment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Latest NATA Released – Its Role and Implications",
    "apiurl": "/restapi/customnewscontentlvl2/news/latest-nata-released-its-role-and-implications",
    "url": "/news/latest-nata-released-its-role-and-implications",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Latest NATA Released – Its Role and Implications",
    "apiurl": "/restapi/customnewscontentlvl2/news/latest-nata-released-its-role-and-implications",
    "url": "/News/Federal/Latest-NATA-Released---Its-Role-and-Implications/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE Software Presents a Comparison Study in Response to the Proposed Replacement of CALINE3 with AERMOD in Appendix W",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-Software-Presents-a-Comparison-Study-in-Response-to-the-Proposed-Replacement-of-CALINE3-with-AERMOD-in-Appendix-W",
    "url": "/news/BREEZE-Software-Presents-a-Comparison-Study-in-Response-to-the-Proposed-Replacement-of-CALINE3-with-AERMOD-in-Appendix-W",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Kansas Environmental Conference",
    "apiurl": "/restapi/customnewscontentlvl2/news/Kansas-Environmental-Conference",
    "url": "/news/Kansas-Environmental-Conference",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Amendments to Env-A 500, Sources of Hazardous Air Pollutants-New Hampshire",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-Amendments-to-Env-A-500-Sources-of-Hazardous-Air-Pollutants-New-Hampshire",
    "url": "/news/Final-Amendments-to-Env-A-500-Sources-of-Hazardous-Air-Pollutants-New-Hampshire",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New NPDES Stormwater Discharge General Permit No. 1200-Z",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-npdes-stormwater-discharge-general-permit-no-1200-z",
    "url": "/news/new-npdes-stormwater-discharge-general-permit-no-1200-z",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New NPDES Stormwater Discharge General Permit No. 1200-Z",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-npdes-stormwater-discharge-general-permit-no-1200-z",
    "url": "/news/new-npdes-stormwater-discharge-general-permit-no.-1200-z",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Coast Air Quality Management District - Proposed Rule 1304.2 and Rule 1304.3",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Coast-Air-Quality-Management-District---Proposed-Rule-1304-2-and-Rule-1304-3",
    "url": "/news/South-Coast-Air-Quality-Management-District---Proposed-Rule-1304-2-and-Rule-1304-3",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Senate Ends Debate on Lieberman - Warner Climate Bill",
    "apiurl": "/restapi/customnewscontentlvl2/news/Senate-End",
    "url": "/news/Senate-End",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Albuquerque-Bernalillo County Air Quality Control Board Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Albuquerque-Bernalillo-County-Air-Quality-Control-Board-Meeting",
    "url": "/news/Albuquerque-Bernalillo-County-Air-Quality-Control-Board-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Coast Air Quality Management District - Proposed Amended Rule 1147",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Coast-Air-Quality-Management-District---Proposed-Amended-Rule-1147",
    "url": "/news/South-Coast-Air-Quality-Management-District---Proposed-Amended-Rule-1147",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Coast Air Quality Management District - Proposed Amended Rule 1147",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Coast-Air-Quality-Management-District---Proposed-Amended-Rule-1147",
    "url": "/news/South-Coast-Air-Quality-Management-District-Proposed-Amended-Rule-1147",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revised AQD General Permit (GP) Form",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revised-AQD-General-Permit-(GP)-Form",
    "url": "/news/Revised-AQD-General-Permit-(GP)-Form",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "303(d) Impaired Waters List",
    "apiurl": "/restapi/customnewscontentlvl2/news/303(d)-Impaired-Waters-List",
    "url": "/news/303(d)-Impaired-Waters-List",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Methane and Waste Prevention Rule on BLM Leases May Be Reinstated in Full",
    "apiurl": "/restapi/customnewscontentlvl2/news/methane-and-waste-prevention-rule-on-blm-leases-may-be-reinstated-in-full",
    "url": "/news/methane-and-waste-prevention-rule-on-blm-leases-may-be-reinstated-in-full",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Methane and Waste Prevention Rule on BLM Leases May Be Reinstated in Full",
    "apiurl": "/restapi/customnewscontentlvl2/news/methane-and-waste-prevention-rule-on-blm-leases-may-be-reinstated-in-full",
    "url": "/federal/methane-and-waste-prevention-rule-on-blm-leases-may-be-reinstated-in-full",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Virginia DEQ Issues Fast Track Rule to Revert Non-Road Definition to Match Federal",
    "apiurl": "/restapi/customnewscontentlvl2/news/Virginia-DEQ-Issues-Fast-Track-Rule-to-Revert-Non-Road-Definition-to-Match-Federal",
    "url": "/news/Virginia-DEQ-Issues-Fast-Track-Rule-to-Revert-Non-Road-Definition-to-Match-Federal",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Massachusetts Regional Haze SIP Revision Proposal",
    "apiurl": "/restapi/customnewscontentlvl2/news/massachusetts-regional-haze-sip-revision-proposal",
    "url": "/news/massachusetts-regional-haze-sip-revision-proposal",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Massachusetts Regional Haze SIP Revision Proposal",
    "apiurl": "/restapi/customnewscontentlvl2/news/massachusetts-regional-haze-sip-revision-proposal",
    "url": "/www.trinityconsultants.com/news/massachusetts-regional-haze-sip-revision-proposal",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Infrastructure State Implementation Plan Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/Infrastructure-State-Implementation-Plan-Requirements",
    "url": "/news/Infrastructure-State-Implementation-Plan-Requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes Revisions to NSPS IIII and JJJJ",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-Revisions-to-NSPS-IIII-and-JJJJ",
    "url": "/news/EPA-Proposes-Revisions-to-NSPS-IIII-and-JJJJ",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DFW's Re-Designation to Serious Nonattainment for Ozone",
    "apiurl": "/restapi/customnewscontentlvl2/news/DFW's-Re-Designation-to-Serious-Nonattainment-for-Ozone",
    "url": "/news/DFW's-Re-Designation-to-Serious-Nonattainment-for-Ozone",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2020 Reporting Reminders-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/2020-Reporting-Reminders-Nebraska",
    "url": "/news/2020-Reporting-Reminders-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Friendly Emissions Inventory Reminder!-Kentucky",
    "apiurl": "/restapi/customnewscontentlvl2/news/Friendly-Emissions-Inventory-Reminder!-Kentucky",
    "url": "/news/Friendly-Emissions-Inventory-Reminder!-Kentucky",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Highlights from CDPHE APCD Ozone ''Bump-Up'' Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Highlights-from-CDPHE-APCD-Ozone-''Bump-Up''-Meeting",
    "url": "/news/Highlights-from-CDPHE-APCD-Ozone-''Bump-Up''-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Clark County DAQ Implemented Adjusted Fee Schedules-Nevada",
    "apiurl": "/restapi/customnewscontentlvl2/news/Clark-County-DAQ-Implemented-Adjusted-Fee-Schedules-Nevada",
    "url": "/news/Clark-County-DAQ-Implemented-Adjusted-Fee-Schedules-Nevada",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GHG Tailoring Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/GHG-Tailoring-Rule",
    "url": "/news/GHG-Tailoring-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Boiler Blitz",
    "apiurl": "/restapi/customnewscontentlvl2/news/Boiler-Blitz",
    "url": "/news/Boiler-Blitz",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LDEQ Finalizes Water Quality Updates Affecting LPDES Permits-Louisiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/LDEQ-Finalizes-Water-Quality-Updates-Affecting-LPDES-Permits-Louisiana",
    "url": "/news/LDEQ-Finalizes-Water-Quality-Updates-Affecting-LPDES-Permits-Louisiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to IEPA Permitting Guidance Document",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-to-IEPA-Permitting-Guidance-Document",
    "url": "/news/Updates-to-IEPA-Permitting-Guidance-Document",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Noise and Odor Issues-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Noise-and-Odor-Issues-Colorado",
    "url": "/news/Noise-and-Odor-Issues-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Dakota Hazardous Waste Rules and Air Pollution Control Program Rules Updated-South Dakota",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Dakota-Hazardous-Waste-Rules-and-Air-Pollution-Control-Program-Rules-Updated-South-Dakota",
    "url": "/news/South-Dakota-Hazardous-Waste-Rules-and-Air-Pollution-Control-Program-Rules-Updated-South-Dakota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Potential Impacts of Hurricane Laura Emergency Order on Pending Permit Issuance in \"Emergency Areas\"",
    "apiurl": "/restapi/customnewscontentlvl2/news/potential-impacts-of-hurricane-laura-emergency-order-on-pending-permit-issuance-in-emergency-areas",
    "url": "/news/potential-impacts-of-hurricane-laura-emergency-order-on-pending-permit-issuance-in-emergency-areas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Massachusetts Proposes Amendments and Rescissions to Air Pollution Control Regulations-Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/Massachusetts-Proposes-Amendments-and-Rescissions-to-Air-Pollution-Control-Regulations-Massachusetts",
    "url": "/news/Massachusetts-Proposes-Amendments-and-Rescissions-to-Air-Pollution-Control-Regulations-Massachusetts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Regional Haze Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Regional-Haze-Updates",
    "url": "/news/Regional-Haze-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Executive Order Passed Enhancing Protection of Air, Water and Public Health in Virginia-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Executive-Order-Passed-Enhancing-Protection-of-Air-Water-and-Public-Health-in-Virginia-Virginia",
    "url": "/news/Executive-Order-Passed-Enhancing-Protection-of-Air-Water-and-Public-Health-in-Virginia-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Changes to 30 TAC Chapter 101, 115, and 117",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Changes-to-30-TAC-Chapter-101-115-and-117",
    "url": "/news/Proposed-Changes-to-30-TAC-Chapter-101-115-and-117",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NPRI Reports Due June 1, 2017-Ontario",
    "apiurl": "/restapi/customnewscontentlvl2/news/NPRI-Reports-Due-June-1-2017-Ontario",
    "url": "/news/NPRI-Reports-Due-June-1-2017-Ontario",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments to Volatile Organic Liquid Storage Tank Requirements in Indiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendments-to-Volatile-Organic-Liquid-Storage-Tank-Requirements-in-Indiana",
    "url": "/news/Proposed-Amendments-to-Volatile-Organic-Liquid-Storage-Tank-Requirements-in-Indiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA Approves Kansas SIP Submissions",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-Approves-Kansas-SIP-Submissions",
    "url": "/news/USEPA-Approves-Kansas-SIP-Submissions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Boiler MACT and Affiliated Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Boiler-MACT-and-Affiliated-Rules",
    "url": "/news/New-Boiler-MACT-and-Affiliated-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DID YOU KNOW? Your ''Lifetime'' New York Minor Air Facility Registration May Actually Expire!-New York",
    "apiurl": "/restapi/customnewscontentlvl2/news/DID-YOU-KNOW-Your-''Lifetime''-New-York-Minor-Air-Facility-Registration-May-Actually-Expire!-New-York",
    "url": "/news/DID-YOU-KNOW-Your-''Lifetime''-New-York-Minor-Air-Facility-Registration-May-Actually-Expire!-New-York",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EMIS Expert Leads DC Team",
    "apiurl": "/restapi/customnewscontentlvl2/news/EMIS-Expert-Leads-DC-Team",
    "url": "/news/EMIS-Expert-Leads-DC-Team",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Gasoline Distribution & Dispensing Are Source MACTs",
    "apiurl": "/restapi/customnewscontentlvl2/news/Gasoline-Distribution-Dispensing-Are-Source-MACTs",
    "url": "/news/Gasoline-Distribution-Dispensing-Are-Source-MACTs",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revisions to TCEQ Oil and Gas General Operating Permits 511 and 514-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revisions-to-TCEQ-Oil-and-Gas-General-Operating-Permits-511-and-514-Texas",
    "url": "/news/Revisions-to-TCEQ-Oil-and-Gas-General-Operating-Permits-511-and-514-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Issues 2021 MSGP for Industrial Stormwater Discharges for Idaho Facilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-issues-2021-msgp-for-industrial-stormwater-discharges-for-idaho-facilities",
    "url": "/news/epa-issues-2021-msgp-for-industrial-stormwater-discharges-for-idaho-facilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DOEE Proposes to Revise and Renew Source Category Permits for Emergency Engines Subject to RICE MACT",
    "apiurl": "/restapi/customnewscontentlvl2/news/doee-proposes-to-revise-and-renew-source-category-permits-for-emergency-engines-subject-to-rice-mact",
    "url": "/news/doee-proposes-to-revise-and-renew-source-category-permits-for-emergency-engines-subject-to-rice-mact",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Now Publishes Draft Statement of Bases for Air Permits on Website",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ-Now-Publishes-Draft-Statement-of-Bases-for-Air-Permits-on-Website",
    "url": "/news/ADEQ-Now-Publishes-Draft-Statement-of-Bases-for-Air-Permits-on-Website",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Letter from AWMA Modeling Committee to EPA Addresses Air Quality Modeling Challenges for PM2.5 and NO2 NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/Letter-from-AWMA-Modeling-Committee-to-EPA-Addresses-Air-Quality-Modeling-Challenges-for-PM2-5-and-NO2-NAAQS",
    "url": "/news/Letter-from-AWMA-Modeling-Committee-to-EPA-Addresses-Air-Quality-Modeling-Challenges-for-PM2-5-and-NO2-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Acquires Water Consultancy Vision Environment Australia",
    "apiurl": "/restapi/customnewscontentlvl2/news/trinity-acquires-water-consultancy-vision-environment-australia",
    "url": "/news/trinity-acquires-water-consultancy-vision-environment-australia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Acquires Water Consultancy Vision Environment Australia",
    "apiurl": "/restapi/customnewscontentlvl2/news/trinity-acquires-water-consultancy-vision-environment-australia",
    "url": "/company/trinity-acquires-water-consultancy-vision-environment-australia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Preparing for 2016 TSCA CDR Reporting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Preparing-for-2016-TSCA-CDR-Reporting",
    "url": "/news/Preparing-for-2016-TSCA-CDR-Reporting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Air Quality Regulations Incorporate GHG Tailoring Rule-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Air-Quality-Regulations-Incorporate-GHG-Tailoring-Rule-Nebraska",
    "url": "/news/Proposed-Air-Quality-Regulations-Incorporate-GHG-Tailoring-Rule-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "COVID-19 Impacts on Idaho Department of Environmental Quality Operations",
    "apiurl": "/restapi/customnewscontentlvl2/news/covid-19-impacts-on-idaho-department-of-environmental-quality-operations",
    "url": "/news/covid-19-impacts-on-idaho-department-of-environmental-quality-operations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "COVID-19 Impacts on Idaho Department of Environmental Quality Operations",
    "apiurl": "/restapi/customnewscontentlvl2/news/covid-19-impacts-on-idaho-department-of-environmental-quality-operations",
    "url": "/states/idaho/covid-19-impacts-on-idaho-department-of-environmental-quality-operations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cap-and-Trade November 2016 Joint-Auction Results Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/Cap-and-Trade-November-2016-Joint-Auction-Results-Released",
    "url": "/news/Cap-and-Trade-November-2016-Joint-Auction-Results-Released",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Recent Good News at Trinity",
    "apiurl": "/restapi/customnewscontentlvl2/news/recent-good-news-at-trinity",
    "url": "/news/recent-good-news-at-trinity",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Deep Dive into 401 KAR 63:020, Potentially Hazardous Matter or Toxic Substances-Kentucky",
    "apiurl": "/restapi/customnewscontentlvl2/news/Deep-Dive-into-401-KAR-63-020-Potentially-Hazardous-Matter-or-Toxic-Substances-Kentucky",
    "url": "/news/Deep-Dive-into-401-KAR-63-020-Potentially-Hazardous-Matter-or-Toxic-Substances-Kentucky",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes Limited Approval for Clark County NSR Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-Limited-Approval-for-Clark-County-NSR-Rules",
    "url": "/news/EPA-Proposes-Limited-Approval-for-Clark-County-NSR-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "North and South Dakota 2017 Monitoring Plans-North Dakota",
    "apiurl": "/restapi/customnewscontentlvl2/news/North-and-South-Dakota-2017-Monitoring-Plans-North-Dakota",
    "url": "/news/North-and-South-Dakota-2017-Monitoring-Plans-North-Dakota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Issuance of New Industrial General Stormwater Permit",
    "apiurl": "/restapi/customnewscontentlvl2/news/Issuance-of-New-Industrial-General-Stormwater-Permit",
    "url": "/news/Issuance-of-New-Industrial-General-Stormwater-Permit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA to Propose New GHG Provisions in Utility, Refinery NSPS-Oklahoma",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-to-Propose-New-GHG-Provisions-in-Utility-Refinery-NSPS-Oklahoma",
    "url": "/news/EPA-to-Propose-New-GHG-Provisions-in-Utility-Refinery-NSPS-Oklahoma",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Kansas Random Tip of the Month-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Kansas-Random-Tip-of-the-Month-Kansas",
    "url": "/news/Kansas-Random-Tip-of-the-Month-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "RCRA Improvement Rule Reminder-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/RCRA-Improvement-Rule-Reminder-Iowa",
    "url": "/news/RCRA-Improvement-Rule-Reminder-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TSCA Title VI Formaldehyde Rule Compliance Moved Up to June 1, 2018-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/TSCA-Title-VI-Formaldehyde-Rule-Compliance-Moved-Up-to-June-1-2018-California",
    "url": "/news/TSCA-Title-VI-Formaldehyde-Rule-Compliance-Moved-Up-to-June-1-2018-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MPCA Considering Removal of Old Permits from Website-Minnesota",
    "apiurl": "/restapi/customnewscontentlvl2/news/MPCA-Considering-Removal-of-Old-Permits-from-Website-Minnesota",
    "url": "/news/MPCA-Considering-Removal-of-Old-Permits-from-Website-Minnesota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EHS Quarterly Issue 4 - Forging a New Path",
    "apiurl": "/restapi/customnewscontentlvl2/news/ehs-quarterly-issue-4",
    "url": "/news/ehs-quarterly-issue-4",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Federal GHG Reporting Rule Proposed",
    "apiurl": "/restapi/customnewscontentlvl2/news/Federal-GHG-Reporting-Rule-Proposed",
    "url": "/news/Federal-GHG-Reporting-Rule-Proposed",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DEQ to Develop Regulations to Limit Methane from Natural Gas Infrastructure",
    "apiurl": "/restapi/customnewscontentlvl2/news/deq-to-develop-regulations-to-limit-methane-from-natural-gas-infrastructure",
    "url": "/news/deq-to-develop-regulations-to-limit-methane-from-natural-gas-infrastructure",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SLEIS Training Now Available Online",
    "apiurl": "/restapi/customnewscontentlvl2/news/SLEIS-Training-Now-Available-Online",
    "url": "/news/SLEIS-Training-Now-Available-Online",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ozone NAAQS Revisions Proposed-Mississippi",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ozone-NAAQS-Revisions-Proposed-Mississippi",
    "url": "/news/Ozone-NAAQS-Revisions-Proposed-Mississippi",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Online Applications for GOP-004 and GP-005B Now Available",
    "apiurl": "/restapi/customnewscontentlvl2/news/Online-Applications-for-GOP-004-and-GP-005B-Now-Available",
    "url": "/news/Online-Applications-for-GOP-004-and-GP-005B-Now-Available",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cleaner Air Oregon Procedures Continue to Evolve-Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/Cleaner-Air-Oregon-Procedures-Continue-to-Evolve-Oregon",
    "url": "/news/Cleaner-Air-Oregon-Procedures-Continue-to-Evolve-Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The CTDEP's 90-Day Agenda for Air Permitting",
    "apiurl": "/restapi/customnewscontentlvl2/news/The-CTDEP's-90-Day-Agenda-for-Air-Permitting",
    "url": "/news/The-CTDEP's-90-Day-Agenda-for-Air-Permitting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Environmental Federation of Oklahoma (EFO) Legislative Report",
    "apiurl": "/restapi/customnewscontentlvl2/news/Environmental-Federation-of-Oklahoma-(EFO)-Legislative-Report-",
    "url": "/news/Environmental-Federation-of-Oklahoma-(EFO)-Legislative-Report-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PADEP Guidance on AST Emergency Containment Structure Verification-Pennsylvania",
    "apiurl": "/restapi/customnewscontentlvl2/news/PADEP-Guidance-on-AST-Emergency-Containment-Structure-Verification-Pennsylvania",
    "url": "/news/PADEP-Guidance-on-AST-Emergency-Containment-Structure-Verification-Pennsylvania",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The Importance of Odour in Ontario",
    "apiurl": "/restapi/customnewscontentlvl2/news/The-Importance-of-Odour-in-Ontario",
    "url": "/news/The-Importance-of-Odour-in-Ontario",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Software Updates x2: BREEZE CALPUFF and 3D Analyst",
    "apiurl": "/restapi/customnewscontentlvl2/news/Software-Updates-x2-BREEZE-CALPUFF-and-3D-Analyst",
    "url": "/news/Software-Updates-x2-BREEZE-CALPUFF-and-3D-Analyst",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Minor Revisions to Modeling Guidance Documents",
    "apiurl": "/restapi/customnewscontentlvl2/news/Minor-Revisions-to-Modeling-Guidance-Documents",
    "url": "/news/Minor-Revisions-to-Modeling-Guidance-Documents",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revisions to Georgia VOC Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revisions-",
    "url": "/news/Revisions-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BOEM Issues Several NTLs Implementing the New Offshore Air Quality Regulations for the Gulf of Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/boem-issues-several-ntls-implementing-the-new-offshore-air-quality-regulations-for-the-gulf-of-mexico",
    "url": "/news/boem-issues-several-ntls-implementing-the-new-offshore-air-quality-regulations-for-the-gulf-of-mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BOEM Issues Several NTLs Implementing the New Offshore Air Quality Regulations for the Gulf of Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/boem-issues-several-ntls-implementing-the-new-offshore-air-quality-regulations-for-the-gulf-of-mexico",
    "url": "/news/federal/boem-issues-several-ntls-implementing-the-new-offshore-air-quality-regulations-for-the-gulf-of-mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ozone NAAQS Revisions Proposed   -Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ozone-NAAQS-Revisions-Proposed--Oregon",
    "url": "/news/Ozone-NAAQS-Revisions-Proposed--Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Effect of USEPA Proposed Ozone Standards in Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/Effect-of-USEPA-Proposed-Ozone-Standards-in-Utah-",
    "url": "/news/Effect-of-USEPA-Proposed-Ozone-Standards-in-Utah-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDNR Rule Updates-Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDNR-Rule-Updates-Missouri",
    "url": "/news/MDNR-Rule-Updates-Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Requirements for Development of Best Management Practices Plan (BMPP) for Industrial Sources of Odour-Ontario",
    "apiurl": "/restapi/customnewscontentlvl2/news/Requirements-for-Development-of-Best-Management-Practices-Plan-(BMPP)-for-Industrial-Sources-of-Odour-Ontario",
    "url": "/news/Requirements-for-Development-of-Best-Management-Practices-Plan-(BMPP)-for-Industrial-Sources-of-Odour-Ontario",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Federal and Missouri Reporting Reminders-Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/Federal-and-Missouri-Reporting-Reminders-Missouri",
    "url": "/news/Federal-and-Missouri-Reporting-Reminders-Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Arizona Proposes Bill on ''Opportunity to Correct'' Before Issuing NOVs",
    "apiurl": "/restapi/customnewscontentlvl2/news/Arizona-Proposes-Bill-on-''Opportunity-to-Correct''-Before-Issuing-NOVs",
    "url": "/news/Arizona-Proposes-Bill-on-''Opportunity-to-Correct''-Before-Issuing-NOVs",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Redesignation of Chicago as Attainment for 1997 Annual Fine PM2.5 Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/Redesignation-of-Chicago-as-Attainment-for-1997-Annual-Fine-PM2-5-Standard",
    "url": "/news/Redesignation-of-Chicago-as-Attainment-for-1997-Annual-Fine-PM2-5-Standard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEQ Proposed Changes to Title 129-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEQ-Proposed-Changes-to-Title-129-Nebraska",
    "url": "/news/NDEQ-Proposed-Changes-to-Title-129-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Ozone Background Data Addition and Restricted Operating Hours Guidance Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Ozone-Background-Data-Addition-and-Restricted-Operating-Hours-Guidance-Updates",
    "url": "/news/Proposed-Ozone-Background-Data-Addition-and-Restricted-Operating-Hours-Guidance-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Air Quality Rules Comment Period Deadline Extended-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Air-Quality-Rules-Comment-Period-Deadline-Extended-Iowa",
    "url": "/news/Proposed-Air-Quality-Rules-Comment-Period-Deadline-Extended-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Proposed Regulation 23 Regional Haze Limits",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-proposed-regulation-23-regional-haze-limits",
    "url": "/news/new-proposed-regulation-23-regional-haze-limits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Proposed Regulation 23 Regional Haze Limits",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-proposed-regulation-23-regional-haze-limits",
    "url": "/news/states/colorado/new-proposed-regulation-23-regional-haze-limits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Latest Iowa News",
    "apiurl": "/restapi/customnewscontentlvl2/news/Latest-Iowa-News",
    "url": "/news/Latest-Iowa-News",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD to Host Online Workshop Series Regarding Alternatives to Diesel Equipment on August 5 and August 19, 2020",
    "apiurl": "/restapi/customnewscontentlvl2/news/baaqmd-to-host-online-workshop-series-regarding-alternatives-to-diesel-equipment-on-august-5-and-august-19-2020",
    "url": "/news/baaqmd-to-host-online-workshop-series-regarding-alternatives-to-diesel-equipment-on-august-5-and-august-19-2020",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Exempt Source and Conditionally Insignificant Activities Rulemaking Updates-Minnesota",
    "apiurl": "/restapi/customnewscontentlvl2/news/Exempt-Source-and-Conditionally-Insignificant-Activities-Rulemaking-Updates-Minnesota",
    "url": "/news/Exempt-Source-and-Conditionally-Insignificant-Activities-Rulemaking-Updates-Minnesota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Upcoming Reporting Requirements for Illinois Facilities - March 2019-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Upcoming-Reporting-Requirements-for-Illinois-Facilities---March-2019-Illinois",
    "url": "/news/Upcoming-Reporting-Requirements-for-Illinois-Facilities---March-2019-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Recent Changes to  Oregon Air Permitting Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/Recent-Changes-to-Oregon-Air-Permitting-Rules",
    "url": "/news/Recent-Changes-to-Oregon-Air-Permitting-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Finalizes Boiler NESHAP",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Finalizes-Boiler-NESHAP",
    "url": "/news/EPA-Finalizes-Boiler-NESHAP",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Virginia Air Pollution Control Board Holds Meeting on Environmental Justice-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Virginia-Air-Pollution-Control-Board-Holds-Meeting-on-Environmental-Justice-Virginia",
    "url": "/news/Virginia-Air-Pollution-Control-Board-Holds-Meeting-on-Environmental-Justice-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Modifications to General Permit (GP-5) for Natural Gas, Coal Bed Methane or Gob Gas Production or Recovery Facilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/Modifications-to-General-Permit-(GP-5)-for-Natural-Gas-Coal-Bed-Methane-or-Gob-Gas-Production-or-Recovery-Facilities",
    "url": "/news/Modifications-to-General-Permit-(GP-5)-for-Natural-Gas-Coal-Bed-Methane-or-Gob-Gas-Production-or-Recovery-Facilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Revisions to ADEQ Air Quality Permitting Rules Survive Governor's Halt on Rulemaking",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-R",
    "url": "/news/Proposed-R",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Extension of ERIC Submittal and Changes for Reporting Year 2010",
    "apiurl": "/restapi/customnewscontentlvl2/news/Extension-of-ERIC-Submittal-and-Changes-for-Reporting-Year-2010",
    "url": "/news/Extension-of-ERIC-Submittal-and-Changes-for-Reporting-Year-2010",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Latest USEPA Guidance May Impact Illinois PSD Permitting Procedures",
    "apiurl": "/restapi/customnewscontentlvl2/news/Latest-USEPA-Guidance-May-Impact-Illinois-PSD-Permitting-Procedures",
    "url": "/news/Latest-USEPA-Guidance-May-Impact-Illinois-PSD-Permitting-Procedures",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Rule 10 CSR 10-6.161 Commercial and Industrial Solid Waste Incinerators",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Rule-10-CSR-10-6-161-Commercial-and-Industrial-Solid-Waste-Incinerators",
    "url": "/news/Proposed-Rule-10-CSR-10-6-161-Commercial-and-Industrial-Solid-Waste-Incinerators",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Schreiber Yonley & Associates Joins the Trinity Family",
    "apiurl": "/restapi/customnewscontentlvl2/news/Schreiber-Yonley-Associates-Joins-the-Trinity-Family",
    "url": "/news/Schreiber-Yonley-Associates-Joins-the-Trinity-Family",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The Differences Between AERMOD and CALPUFF",
    "apiurl": "/restapi/customnewscontentlvl2/news/the-differences-between-aermod-and-calpuff",
    "url": "/news/the-differences-between-aermod-and-calpuff",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The Differences Between AERMOD and CALPUFF",
    "apiurl": "/restapi/customnewscontentlvl2/news/the-differences-between-aermod-and-calpuff",
    "url": "/News/Technology/The-Differences-Between-AERMOD-and-CALPUFF/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Annual Toxic Release Inventory (TRI) Reports due July 1st-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/Annual-Toxic-Release-Inventory-(TRI)-Reports-due-July-1st-Nebraska",
    "url": "/news/Annual-Toxic-Release-Inventory-(TRI)-Reports-due-July-1st-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEM revises the Air Division Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEM-revises-the-Air-Division-Regulations",
    "url": "/news/ADEM-revises-the-Air-Division-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Recent New Mexico Environmental Department Modeling Changes in 2016",
    "apiurl": "/restapi/customnewscontentlvl2/news/Recent-New-Mexico-Environmental-Department-Modeling-Changes-in-2016",
    "url": "/news/Recent-New-Mexico-Environmental-Department-Modeling-Changes-in-2016",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ePermits Announcement-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/ePermits-Announcement-Texas",
    "url": "/news/ePermits-Announcement-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Emissions Banking and Trading (EBT) Online Reporting-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Emissions-Banking-and-Trading-(EBT)-Online-Reporting-Texas",
    "url": "/news/Emissions-Banking-and-Trading-(EBT)-Online-Reporting-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Rule - Air Plan and Operating Permit Program Approval: Revisions to Public Notice Provisions in Permitting Programs",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-Rule---Air-Plan-and-Operating-Permit-Program-Approval-Revisions-to-Public-Notice-Provisions-in-Permitting-Programs",
    "url": "/news/Final-Rule---Air-Plan-and-Operating-Permit-Program-Approval-Revisions-to-Public-Notice-Provisions-in-Permitting-Programs",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Guidance Documents for the Natural Gas Transmission and Storage Segment Program (September 2020)",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-guidance-documents-for-the-natural-gas-transmission-and-storage-segment-program-(september-2020)",
    "url": "/news/new-guidance-documents-for-the-natural-gas-transmission-and-storage-segment-program-(september-2020)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Guidance Documents for the Natural Gas Transmission and Storage Segment Program (September 2020)",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-guidance-documents-for-the-natural-gas-transmission-and-storage-segment-program-(september-2020)",
    "url": "/states/new-guidance-documents-for-the-natural-gas-transmission-and-storage-segment-program-september-2020",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2010 Emission Inventory Workshop",
    "apiurl": "/restapi/customnewscontentlvl2/news/2010-Emission-Inventory-Workshop",
    "url": "/news/2010-Emission-Inventory-Workshop",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Are you ready?  New Sulfur Standards for Fuels Effective January 2013.",
    "apiurl": "/restapi/customnewscontentlvl2/news/Are-you-ready-New-Sulfur-Standards-for-Fuels-Effective-January-2013-",
    "url": "/news/Are-you-ready-New-Sulfur-Standards-for-Fuels-Effective-January-2013-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Emission Inventory Questionnaire (EIQ) Rule Changes",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-Emission-Inventory-Questionnaire-(EIQ)-Rule-Changes",
    "url": "/news/Final-Emission-Inventory-Questionnaire-(EIQ)-Rule-Changes",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cap-and-Trade Investments Update – Opportunity for Public Comment and Grants",
    "apiurl": "/restapi/customnewscontentlvl2/news/Cap-and-Trade-Investments-Update-Opportunity-for-Public-Comment-and-Grants",
    "url": "/news/Cap-and-Trade-Investments-Update-Opportunity-for-Public-Comment-and-Grants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEQ Eliminates the Expedited Operating Permit Renewal Certification",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEQ-Eliminates-the-Expedited-Operating-Permit-Renewal-Certification",
    "url": "/news/NDEQ-Eliminates-the-Expedited-Operating-Permit-Renewal-Certification",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Withdrawal of BPA One-Hour Ozone Redesignation and SIP Revision",
    "apiurl": "/restapi/customnewscontentlvl2/news/proposed-withdrawal-of-bpa-one-hour-ozone-redesignation-and-sip-revision",
    "url": "/news/proposed-withdrawal-of-bpa-one-hour-ozone-redesignation-and-sip-revision",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Withdrawal of BPA One-Hour Ozone Redesignation and SIP Revision",
    "apiurl": "/restapi/customnewscontentlvl2/news/proposed-withdrawal-of-bpa-one-hour-ozone-redesignation-and-sip-revision",
    "url": "/news/state/texas/proposed-withdrawal-of-bpa-one-hour-ozone-redesignation-and-sip-revision",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DEQ’s Storage Tank Emissions Calculation Tool",
    "apiurl": "/restapi/customnewscontentlvl2/news/deq-s-storage-tank-emissions-calculation-tool-",
    "url": "/news/deq-s-storage-tank-emissions-calculation-tool-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DEQ’s Storage Tank Emissions Calculation Tool",
    "apiurl": "/restapi/customnewscontentlvl2/news/deq-s-storage-tank-emissions-calculation-tool-",
    "url": "/news/state/oklahoma/deq-s-storage-tank-emissions-calculation-tool-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "RICE MACT Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/RICE-MACT-Amendments",
    "url": "/news/RICE-MACT-Amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LMAPCD to Propose Changes to Strategic Toxic Air Reduction (STAR) Program and Related Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/LMAPCD-to-",
    "url": "/news/LMAPCD-to-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Dakota Oil & Gas Initiative",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Dakota-Oil-Gas-Initiative",
    "url": "/news/South-Dakota-Oil-Gas-Initiative",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Approval of Cross-Media Electronic Reporting for NPDES",
    "apiurl": "/restapi/customnewscontentlvl2/news/Approval-of-Cross-Media-Electronic-Reporting-for-NPDES",
    "url": "/news/Approval-of-Cross-Media-Electronic-Reporting-for-NPDES",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "OMB Requests Comments on Social Cost of Greenhouse Gases",
    "apiurl": "/restapi/customnewscontentlvl2/news/omb-requests-comments-on-social-cost-of-greenhouse-gases",
    "url": "/news/omb-requests-comments-on-social-cost-of-greenhouse-gases",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Delaware Adopts a New Area Source NESHAP",
    "apiurl": "/restapi/customnewscontentlvl2/news/Delaware-A",
    "url": "/news/Delaware-A",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA and ADEQ Target Three Arkansas Facilities for Special Treatment on NAAQS Protection Issues",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-and-ADEQ-Target-Three-Arkansas-Facilities-for-Special-Treatment-on-NAAQS-Protection-Issues",
    "url": "/news/EPA-and-ADEQ-Target-Three-Arkansas-Facilities-for-Special-Treatment-on-NAAQS-Protection-Issues",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Midwest Environmental Compliance Conference – May 11-13",
    "apiurl": "/restapi/customnewscontentlvl2/news/Midwest-Environmental-Compliance-Conference-May-11-13",
    "url": "/news/Midwest-Environmental-Compliance-Conference-May-11-13",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SJVAPCD Publishes Rule 4311 Draft Rule Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/sjvapcd-publishes-rule-4311-draft-rule-amendments",
    "url": "/news/sjvapcd-publishes-rule-4311-draft-rule-amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SJVAPCD Publishes Rule 4311 Draft Rule Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/sjvapcd-publishes-rule-4311-draft-rule-amendments",
    "url": "/states/california/sjvapcd-publishes-rule-4311-draft-rule-amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SSM Exemption in Limbo",
    "apiurl": "/restapi/customnewscontentlvl2/news/SSM-Exemption-in-Limbo",
    "url": "/news/SSM-Exemption-in-Limbo",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Part 1, Part 2, and Part 9 Final Air Pollution Control Rule Revisions Issued",
    "apiurl": "/restapi/customnewscontentlvl2/news/Part-1-Part-2-and-Part-9-Final-Air-Pollution-Control-Rule-Revisions-Issued",
    "url": "/news/Part-1-Part-2-and-Part-9-Final-Air-Pollution-Control-Rule-Revisions-Issued",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EQB Approves Final Rulemaking for Air Quality Program Fees",
    "apiurl": "/restapi/customnewscontentlvl2/news/eqb-approves-final-rulemaking-for-air-quality-program-fees",
    "url": "/news/eqb-approves-final-rulemaking-for-air-quality-program-fees",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EQB Approves Final Rulemaking for Air Quality Program Fees",
    "apiurl": "/restapi/customnewscontentlvl2/news/eqb-approves-final-rulemaking-for-air-quality-program-fees",
    "url": "/news/state/pennsylvania/eqb-approves-final-rulemaking-for-air-quality-program-fees",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Minnesota Reporting Reminders!",
    "apiurl": "/restapi/customnewscontentlvl2/news/Minnesota-Reporting-Reminders!-",
    "url": "/news/Minnesota-Reporting-Reminders!-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oregon Clean Fuels Program (CFP)",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oregon-Clean-Fuels-Program-(CFP)",
    "url": "/news/Oregon-Clean-Fuels-Program-(CFP)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reminder – WDNR's Air Program is Accepting e-Signatures for 2019 Official Reports-Wisconsin",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reminder-WDNR's-Air-Program-is-Accepting-e-Signatures-for-2019-Official-Reports-Wisconsin",
    "url": "/news/Reminder-WDNR's-Air-Program-is-Accepting-e-Signatures-for-2019-Official-Reports-Wisconsin",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LDEQ Proposes Amendments to MACT Determinations for Non-HON Sources-Louisiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/LDEQ-Proposes-Amendments-to-MACT-Determinations-for-Non-HON-Sources-Louisiana",
    "url": "/news/LDEQ-Proposes-Amendments-to-MACT-Determinations-for-Non-HON-Sources-Louisiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Salt Lake Area PM2.5 Serious Non-attainment State Implementation Plan (SIP) Approved by Air Quality Board-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/Salt-Lake-Area-PM2-5-Serious-Non-attainment-State-Implementation-Plan-(SIP)-Approved-by-Air-Quality-Board-Utah",
    "url": "/news/Salt-Lake-Area-PM2-5-Serious-Non-attainment-State-Implementation-Plan-(SIP)-Approved-by-Air-Quality-Board-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Forest County Potawatomi Community Proposed Air Quality Related Values",
    "apiurl": "/restapi/customnewscontentlvl2/news/Forest-County-Potawatomi-Community-Proposed-Air-Quality-Related-Values",
    "url": "/news/Forest-County-Potawatomi-Community-Proposed-Air-Quality-Related-Values",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Carbon Black MACT RTR – More Process Vents and Testing",
    "apiurl": "/restapi/customnewscontentlvl2/news/carbon-black-mact-rtr-more-process-vents-and-testing",
    "url": "/news/carbon-black-mact-rtr-more-process-vents-and-testing",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Adopts Revision to Reasonably Available Control Technology Rules for VOC Sources - December 2011",
    "apiurl": "/restapi/customnewscontentlvl2/news/TCEQ-Adopts-Revision-to-Reasonably-Available-Control-Technology-Rules-for-VOC-Sources---December-2011",
    "url": "/news/TCEQ-Adopts-Revision-to-Reasonably-Available-Control-Technology-Rules-for-VOC-Sources---December-2011",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Opens Fayetteville Branch Office",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Opens-Fayetteville-Branch-Office",
    "url": "/news/Trinity-Opens-Fayetteville-Branch-Office",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDNR News.....",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDNR-News-",
    "url": "/news/IDNR-News-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed PSD SIP for Washington",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-PSD-SIP-for-Washington",
    "url": "/news/Proposed-PSD-SIP-for-Washington",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Shoreline Response Programme Guidance",
    "apiurl": "/restapi/customnewscontentlvl2/news/shoreline-response-programme-guidance-",
    "url": "/news/shoreline-response-programme-guidance-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Shoreline Response Programme Guidance",
    "apiurl": "/restapi/customnewscontentlvl2/news/shoreline-response-programme-guidance-",
    "url": "/ehs-management/shoreline-response-programme-guidance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Specialty APENS and APEN/Permit Cancellation Forms Revised",
    "apiurl": "/restapi/customnewscontentlvl2/news/Speciality-APENS-and-APEN-Permit-Cancellation-Forms-Revised",
    "url": "/news/Speciality-APENS-and-APEN-Permit-Cancellation-Forms-Revised",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Monterey Bay Air Resources District Proposed Changes to New Source Review, Toxic Air Contaminant Guidelines, and Permit Exemptions",
    "apiurl": "/restapi/customnewscontentlvl2/news/Monterey-Bay-Air-Resources-District-Proposed-Changes-to-New-Source-Review-Toxic-Air-Contaminant-Guidelines-and-Permit-Exemptions",
    "url": "/news/Monterey-Bay-Air-Resources-District-Proposed-Changes-to-New-Source-Review-Toxic-Air-Contaminant-Guidelines-and-Permit-Exemptions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Approval of Illinois Vehicle Inspection & Maintenance (I/M) Program in the Chicago and Metro-East St. Louis for Illinois SIP Revision",
    "apiurl": "/restapi/customnewscontentlvl2/news/Approval-of-Illinois-Vehicle-Inspection-Maintenance-(I-M)-Program-in-the-Chicago-and-Metro-East-St-Louis-for-Illinois-SIP-Revision",
    "url": "/news/Approval-of-Illinois-Vehicle-Inspection-Maintenance-(I-M)-Program-in-the-Chicago-and-Metro-East-St-Louis-for-Illinois-SIP-Revision",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SJVAPCD Final Draft Staff Report – Update to District’s Risk Management Policy to Address OEHHA’s Revised Risk Assessment Guidance Document",
    "apiurl": "/restapi/customnewscontentlvl2/news/SJVAPCD-Final-Draft-Staff-Report-Update-to-District-s-Risk-Management-Policy-to-Address-OEHHA-s-Revised-Risk-Assessment-Guidance-Document",
    "url": "/news/SJVAPCD-Final-Draft-Staff-Report-Update-to-District-s-Risk-Management-Policy-to-Address-OEHHA-s-Revised-Risk-Assessment-Guidance-Document",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Title V Permits by Rule Supplemental Table",
    "apiurl": "/restapi/customnewscontentlvl2/news/title-v-permits-by-rule-supplemental-table",
    "url": "/news/title-v-permits-by-rule-supplemental-table",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Title V Permits by Rule Supplemental Table",
    "apiurl": "/restapi/customnewscontentlvl2/news/title-v-permits-by-rule-supplemental-table",
    "url": "/state/title-v-permits-by-rule-supplemental-table",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CDPHE Revising Operating and Maintenance Plan Templates for Oil & Gas Operations",
    "apiurl": "/restapi/customnewscontentlvl2/news/CDPHE-Revising-Operating-and-Maintenance-Plan-Templates-for-Oil-Gas-Operations",
    "url": "/news/CDPHE-Revising-Operating-and-Maintenance-Plan-Templates-for-Oil-Gas-Operations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Missouri CAIR Rules on Public Notice",
    "apiurl": "/restapi/customnewscontentlvl2/news/Missouri-CAIR-Rules-on-Public-Notice",
    "url": "/news/Missouri-CAIR-Rules-on-Public-Notice",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Upcoming New Mexico Minor Source Emission Inventory-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/Upcoming-New-Mexico-Minor-Source-Emission-Inventory-New-Mexico",
    "url": "/news/Upcoming-New-Mexico-Minor-Source-Emission-Inventory-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "25th Trinity Office Opens in Orlando, Florida",
    "apiurl": "/restapi/customnewscontentlvl2/news/25th-Trinity-Office-Opens-in-Orlando-Florida",
    "url": "/news/25th-Trinity-Office-Opens-in-Orlando-Florida",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Other GHG Reporting Subparts",
    "apiurl": "/restapi/customnewscontentlvl2/news/Other-GHG-Reporting-Subparts",
    "url": "/news/Other-GHG-Reporting-Subparts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CDPHE Revised Mining Operations APEN Form APCD-222 Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/CDPHE-Revised-Mining-Operations-APEN-Form-APCD-222-Released",
    "url": "/news/CDPHE-Revised-Mining-Operations-APEN-Form-APCD-222-Released",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Staff Spotlight: 20-Year EH&S Veteran Helps  Companies & Professionals Improve",
    "apiurl": "/restapi/customnewscontentlvl2/news/Staff-Spotlight-20-Year-EH-S-Veteran-Helps-Companies-Professionals-Improve",
    "url": "/news/Staff-Spotlight-20-Year-EH-S-Veteran-Helps-Companies-Professionals-Improve",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA’s Intended Designations for the Lead National Ambient Air Quality Standard (NAAQS) in Pennsylvania",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-s-Intended-Designations-for-the-Lead-National-Ambient-Air-Quality-Standard-(NAAQS)-in-Pennsylvania",
    "url": "/news/EPA-s-Intended-Designations-for-the-Lead-National-Ambient-Air-Quality-Standard-(NAAQS)-in-Pennsylvania",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Opens Office in Denver",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Opens-Office-in-Denver",
    "url": "/news/Trinity-Consultants-Opens-Office-in-Denver",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Updates to Illinois Mercury Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-U",
    "url": "/news/Proposed-U",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD Accepting Applications for Funding Zero-Emission Projects",
    "apiurl": "/restapi/customnewscontentlvl2/news/baaqmd-accepting-applications-for-funding-zero-emission-projects",
    "url": "/news/baaqmd-accepting-applications-for-funding-zero-emission-projects",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PM2.5 Nonattainment Areas Designations in Washington, Oregon, Idaho and Alaska",
    "apiurl": "/restapi/customnewscontentlvl2/news/PM2-5-Nona",
    "url": "/news/PM2-5-Nona",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NEW Version of AERMOD has been Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/NEW-Version-of-AERMOD-has-been-Released",
    "url": "/news/NEW-Version-of-AERMOD-has-been-Released",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SB14 Hazardous Waste Source Reduction Reminder",
    "apiurl": "/restapi/customnewscontentlvl2/news/SB14-Hazardous-Waste-Source-Reduction-Reminder",
    "url": "/news/SB14-Hazardous-Waste-Source-Reduction-Reminder",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Asphalt MACT Subpart AAAAAAA",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Asphalt-MACT-Subpart-AAAAAAA",
    "url": "/news/Proposed-Asphalt-MACT-Subpart-AAAAAAA",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEE Permitting Matrix Updated",
    "apiurl": "/restapi/customnewscontentlvl2/news/ndee-permitting-matrix-updated",
    "url": "/news/ndee-permitting-matrix-updated",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oregon Environmental Quality Commission Adopts Amendments to Hazard Index Benchmarks",
    "apiurl": "/restapi/customnewscontentlvl2/news/oregon-environmental-quality-commission-adopts-amendments-to-hazard-index-benchmarks-",
    "url": "/news/oregon-environmental-quality-commission-adopts-amendments-to-hazard-index-benchmarks-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDNR Air Quality Client Contact Meeting Highlights",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDNR-Air-Quality-Client-Contact-Meeting-Highlights",
    "url": "/news/IDNR-Air-Quality-Client-Contact-Meeting-Highlights",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "COVID19 Update for Training Registrants",
    "apiurl": "/restapi/customnewscontentlvl2/news/covid19-update-for-training-registrants",
    "url": "/news/covid19-update-for-training-registrants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MSGP DMR Deadline Extension and Upcoming Features in myDEQ for Stormwater Permitting",
    "apiurl": "/restapi/customnewscontentlvl2/news/MSGP-DMR-Deadline-Extension-and-Upcoming-Features-in-myDEQ-for-Stormwater-Permitting",
    "url": "/news/MSGP-DMR-Deadline-Extension-and-Upcoming-Features-in-myDEQ-for-Stormwater-Permitting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NYSDEC Requests EPA Impose Emission Limits on Sources Affecting Air Quality in New York, Including Sources in West Virginia-West Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/NYSDEC-Requests-EPA-Impose-Emission-Limits-on-Sources-Affecting-Air-Quality-in-New-York-Including-Sources-in-West-Virginia-West-Virginia",
    "url": "/news/NYSDEC-Requests-EPA-Impose-Emission-Limits-on-Sources-Affecting-Air-Quality-in-New-York-Including-Sources-in-West-Virginia-West-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Moderate PM2.5 SIP Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-Moderate-PM2-5-SIP-Amendments",
    "url": "/news/Final-Moderate-PM2-5-SIP-Amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Expresses Concerns Over New EPA Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ-Expresses-Concerns-Over-New-EPA-Regulations",
    "url": "/news/ADEQ-Expresses-Concerns-Over-New-EPA-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Software Updates x3: U.S. EPA 19191 Executables Now Available in BREEZE AERMOD, AERSCREEN and AERMET",
    "apiurl": "/restapi/customnewscontentlvl2/news/Software-Updates-x3-U-S-EPA-19191-Executables-Now-Available-in-BREEZE-AERMOD-AERSCREEN-and-AERMET",
    "url": "/news/Software-Updates-x3-U-S-EPA-19191-Executables-Now-Available-in-BREEZE-AERMOD-AERSCREEN-and-AERMET",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Bill Signed Requiring Effort to Sell Coal-Fired Power Plants-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Bill-Signed-Requiring-Effort-to-Sell-Coal-Fired-Power-Plants-Wyoming",
    "url": "/news/Bill-Signed-Requiring-Effort-to-Sell-Coal-Fired-Power-Plants-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2018 Reporting Reminders-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/2018-Reporting-Reminders-Iowa",
    "url": "/news/2018-Reporting-Reminders-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PM2.5 Workgroup",
    "apiurl": "/restapi/customnewscontentlvl2/news/PM2-5-Workgroup",
    "url": "/news/PM2-5-Workgroup",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "February 11, 2014 Iowa Chapter AWMA Meeting Highlights from IDNR",
    "apiurl": "/restapi/customnewscontentlvl2/news/February-11-2014-Iowa-Chapter-AWMA-Meeting-Highlights-from-IDNR",
    "url": "/news/February-11-2014-Iowa-Chapter-AWMA-Meeting-Highlights-from-IDNR",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Developing New Minor New Source Review Guidance",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ-Developing-New-Minor-New-Source-Review-Guidance",
    "url": "/news/ADEQ-Developing-New-Minor-New-Source-Review-Guidance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Executive Directive (11) of 2017 Announced - Reducing Carbon Dioxide Emissions from Electric Power Facilities-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Executive-Directive-(11)-of-2017-Announced---Reducing-Carbon-Dioxide-Emissions-from-Electric-Power-Facilities-Virginia",
    "url": "/news/Executive-Directive-(11)-of-2017-Announced---Reducing-Carbon-Dioxide-Emissions-from-Electric-Power-Facilities-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Future modeling for PSD projects in NC  will require the use of the newest version of AERMOD",
    "apiurl": "/restapi/customnewscontentlvl2/news/Future-modeling-for-PSD-projects-in-NC-will-require-the-use-of-the-newest-version-of-AERMOD",
    "url": "/news/Future-modeling-for-PSD-projects-in-NC-will-require-the-use-of-the-newest-version-of-AERMOD",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oklahoma Air Quality Rule Changes In Progress-Oklahoma",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oklahoma-Air-Quality-Rule-Changes-In-Progress-Oklahoma",
    "url": "/news/Oklahoma-Air-Quality-Rule-Changes-In-Progress-Oklahoma",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Fact Sheet on Permitting Diesel Engines",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Fact-Sheet-on-Permitting-Diesel-Engines",
    "url": "/news/New-Fact-Sheet-on-Permitting-Diesel-Engines",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Proposes Reissuing of the Multi-Sector General Permit or Stormwater Discharges",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ-Proposes-Reissuing-of-the-Multi-Sector-General-Permit-or-Stormwater-Discharges",
    "url": "/news/ADEQ-Proposes-Reissuing-of-the-Multi-Sector-General-Permit-or-Stormwater-Discharges",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA Finalizes Changes to Air Quality Modeling Guidance-Idaho",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-Finalizes-Changes-to-Air-Quality-Modeling-Guidance-Idaho",
    "url": "/news/USEPA-Finalizes-Changes-to-Air-Quality-Modeling-Guidance-Idaho",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD Proposed Warehouse Indirect Source Review for NOx and PM10 Reductions (Rule 2305)",
    "apiurl": "/restapi/customnewscontentlvl2/news/scaqmd-proposed-warehouse-indirect-source-review-for-nox-and-pm10-reductions-rule-2305",
    "url": "/news/scaqmd-proposed-warehouse-indirect-source-review-for-nox-and-pm10-reductions-rule-2305",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD Proposed Warehouse Indirect Source Review for NOx and PM10 Reductions (Rule 2305)",
    "apiurl": "/restapi/customnewscontentlvl2/news/scaqmd-proposed-warehouse-indirect-source-review-for-nox-and-pm10-reductions-rule-2305",
    "url": "/www.trinityconsultants.com/news/scaqmd-proposed-warehouse-indirect-source-review-for-nox-and-pm10-reductions-rule-2305",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Delaware Department of Natural Resources and Environmental Control (DNREC) Finalizes Amendments to Regulations of the Application of Spray Coatings",
    "apiurl": "/restapi/customnewscontentlvl2/news/Delaware-Department-of-Natural-Resources-and-Environmental-Control-(DNREC)-Finalizes-Amendments-to-Regulations-of-the-Application-of-Spray-Coatings",
    "url": "/news/Delaware-Department-of-Natural-Resources-and-Environmental-Control-(DNREC)-Finalizes-Amendments-to-Regulations-of-the-Application-of-Spray-Coatings",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Tier 2 E-Plan 2019 Submission & Training-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Tier-2-E-Plan-2019-Submission-Training-Iowa",
    "url": "/news/Tier-2-E-Plan-2019-Submission-Training-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NJDEP Amends Fees for Permitting of Stationary Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/NJDEP-Amends-Fees-for-Permitting-of-Stationary-Sources",
    "url": "/news/NJDEP-Amends-Fees-for-Permitting-of-Stationary-Sources",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated Permit Application Fees in New Mexico-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updated-Permit-Application-Fees-in-New-Mexico-New-Mexico",
    "url": "/news/Updated-Permit-Application-Fees-in-New-Mexico-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GHG Luncheon Seminar",
    "apiurl": "/restapi/customnewscontentlvl2/news/GHG-Luncheon-Seminar",
    "url": "/news/GHG-Luncheon-Seminar",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes to TSCA's Chemical Data Reporting (CDR) Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/Changes-to-TSCA's-Chemical-Data-Reporting-(CDR)-Requirements",
    "url": "/news/Changes-to-TSCA's-Chemical-Data-Reporting-(CDR)-Requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SJVAPCD Releases Draft of Amended Rule 4702 for Internal Combustion Engines",
    "apiurl": "/restapi/customnewscontentlvl2/news/sjvapcd-releases-draft-of-amended-rule-4702-for-internal-combustion-engines",
    "url": "/news/sjvapcd-releases-draft-of-amended-rule-4702-for-internal-combustion-engines",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PM2.5 Modeling Now Required for New Permits",
    "apiurl": "/restapi/customnewscontentlvl2/news/PM2-5-Modeling-Now-Required-for-New-Permits-",
    "url": "/news/PM2-5-Modeling-Now-Required-for-New-Permits-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Portland Cement MACT Proposal and Implications on Revised Boiler MACT",
    "apiurl": "/restapi/customnewscontentlvl2/news/Portland-C",
    "url": "/news/Portland-C",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Section 114 Requests - In The Line of Fire",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Section-114-Requests---In-The-Line-of-Fire",
    "url": "/news/EPA-Section-114-Requests---In-The-Line-of-Fire",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "WYDEQ Request for Information on Wellsite Equipment-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/WYDEQ-Request-for-Information-on-Wellsite-Equipment-Wyoming",
    "url": "/news/WYDEQ-Request-for-Information-on-Wellsite-Equipment-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Wyoming Given Authority to License and Inspect Mining and Milling of Uranium-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Wyoming-Given-Authority-to-License-and-Inspect-Mining-and-Milling-of-Uranium-Wyoming",
    "url": "/news/Wyoming-Given-Authority-to-License-and-Inspect-Mining-and-Milling-of-Uranium-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Connecticut SIP Revisions: 8-Hour Ozone Attainment Demonstration for Connecticut's Portion of the New York - N. New Jersey - Long Island Nonattainment Area-Connecticut",
    "apiurl": "/restapi/customnewscontentlvl2/news/Connecticut-SIP-Revisions-8-Hour-Ozone-Attainment-Demonstration-for-Connecticut's-Portion-of-the-New-York---N-New-Jersey---Long-Island-Nonattainment-Area-Connecticut",
    "url": "/news/Connecticut-SIP-Revisions-8-Hour-Ozone-Attainment-Demonstration-for-Connecticut's-Portion-of-the-New-York---N-New-Jersey---Long-Island-Nonattainment-Area-Connecticut",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Virginia DEQ Initiated Site Suitability NOIRA",
    "apiurl": "/restapi/customnewscontentlvl2/news/virginia-deq-initiated-site-suitability-noira",
    "url": "/news/virginia-deq-initiated-site-suitability-noira",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Quality Rule Changes",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Rule-Changes",
    "url": "/news/Air-Quality-Rule-Changes",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Indiana Coal Combustion Residuals Rulemaking Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/Indiana-Coal-Combustion-Residuals-Rulemaking-Update",
    "url": "/news/Indiana-Coal-Combustion-Residuals-Rulemaking-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDE Proposes Hazardous Waste Regulation Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/mde-proposes-hazardous-waste-regulation-updates",
    "url": "/news/mde-proposes-hazardous-waste-regulation-updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CAPCD Offers Training on Condensate Tank System-Wide Control & Reporting Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/CAPCD-Offers-Training-on-Condensate-Tank-System-Wide-Control-Reporting-Requirements",
    "url": "/news/CAPCD-Offers-Training-on-Condensate-Tank-System-Wide-Control-Reporting-Requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Missouri Air Permitting Changes Go into Effect-Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/Missouri-Air-Permitting-Changes-Go-into-Effect-Missouri",
    "url": "/news/Missouri-Air-Permitting-Changes-Go-into-Effect-Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Texas General Stormwater Permitting Updates: Multi-Sector General Permit and Stormwater Construction General Permit-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Texas-General-Stormwater-Permitting-Updates-Multi-Sector-General-Permit-and-Stormwater-Construction-General-Permit-Texas",
    "url": "/news/Texas-General-Stormwater-Permitting-Updates-Multi-Sector-General-Permit-and-Stormwater-Construction-General-Permit-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Pending Revisions to the NSR/Construction Permitting Regulation in Bernalillo County",
    "apiurl": "/restapi/customnewscontentlvl2/news/Pending-Revisions-to-the-NSR-Construction-Permitting-Regulation-in-Bernalillo-County",
    "url": "/news/Pending-Revisions-to-the-NSR-Construction-Permitting-Regulation-in-Bernalillo-County",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ODS Rule Updates – Are You Prepared?-Georgia",
    "apiurl": "/restapi/customnewscontentlvl2/news/ODS-Rule-Updates-Are-You-Prepared--Georgia",
    "url": "/news/ODS-Rule-Updates-Are-You-Prepared--Georgia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KDHE Updates Guidance Document for Hazardous Waste Determinations",
    "apiurl": "/restapi/customnewscontentlvl2/news/kdhe-updates-guidance-document-for-hazardous-waste-determinations",
    "url": "/news/kdhe-updates-guidance-document-for-hazardous-waste-determinations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KDHE Updates Guidance Document for Hazardous Waste Determinations",
    "apiurl": "/restapi/customnewscontentlvl2/news/kdhe-updates-guidance-document-for-hazardous-waste-determinations",
    "url": "/states/kansas/kdhe-updates-guidance-document-for-hazardous-waste-determinations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Greenhouse Gases Final Reporting Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Greenhouse-Gases-Final-Reporting-Rule",
    "url": "/news/Greenhouse-Gases-Final-Reporting-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Wisconsin Reporting/Certification Deadline Reminders!",
    "apiurl": "/restapi/customnewscontentlvl2/news/Wisconsin-Reporting-Certification-Deadline-Reminders!",
    "url": "/news/Wisconsin-Reporting-Certification-Deadline-Reminders!",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "UDAQ PM2.5 State Implementation Plan Progress",
    "apiurl": "/restapi/customnewscontentlvl2/news/UDAQ-PM2-5-State-Implementation-Plan-Progress",
    "url": "/news/UDAQ-PM2-5-State-Implementation-Plan-Progress",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "A&WMA Midwest Section Environmental Technical Conference, September 30 - October 1-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/A-WMA-Midwest-Section-Environmental-Technical-Conference-September-30---October-1-Nebraska",
    "url": "/news/A-WMA-Midwest-Section-Environmental-Technical-Conference-September-30---October-1-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Well Completion Numbers Up in 2017-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Well-Completion-Numbers-Up-in-2017-Wyoming",
    "url": "/news/Well-Completion-Numbers-Up-in-2017-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Real-Time Modeling Solutions Enable Powerful Impact Analyses",
    "apiurl": "/restapi/customnewscontentlvl2/news/Real-Time-Modeling-Solutions-Enable-Powerful-Impact-Analyses",
    "url": "/news/Real-Time-Modeling-Solutions-Enable-Powerful-Impact-Analyses",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD's New Reporting Tool for Annual Emission Reporting",
    "apiurl": "/restapi/customnewscontentlvl2/news/SCAQMD's-New-Reporting-Tool-for-Annual-Emission-Reporting",
    "url": "/news/SCAQMD's-New-Reporting-Tool-for-Annual-Emission-Reporting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "North Dakota Hazardous Waste Management Rules Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/North-Dakota-Hazardous-Waste-Management-Rules-Updates",
    "url": "/news/North-Dakota-Hazardous-Waste-Management-Rules-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ's Special SO2 Inventory for Sources that Reported > 10 tpy SO2 in 2009",
    "apiurl": "/restapi/customnewscontentlvl2/news/TCEQ's-Special-SO2-Inventory-for-Sources-that-Reported-10-tpy-SO2-in-2009",
    "url": "/news/TCEQ's-Special-SO2-Inventory-for-Sources-that-Reported-10-tpy-SO2-in-2009",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ISO 14001:2015 Environmental Management System Standard: Addressing Risk and Opportunity",
    "apiurl": "/restapi/customnewscontentlvl2/news/ISO-14001-2015-Environmental-Management-System-Standard-Addressing-Risk-and-Opportunity",
    "url": "/news/ISO-14001-2015-Environmental-Management-System-Standard-Addressing-Risk-and-Opportunity",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New AERMOD Met Data Sets Available",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-AERMOD-Met-Data-Sets-Available",
    "url": "/news/New-AERMOD-Met-Data-Sets-Available",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LDEQ Finalizes Fee Increase Updates-Louisiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/LDEQ-Finalizes-Fee-Increase-Updates-Louisiana",
    "url": "/news/LDEQ-Finalizes-Fee-Increase-Updates-Louisiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PM2.5 State Implementation Plan - Provo Area out for Public Comment-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/PM2-5-State-Implementation-Plan---Provo-Area-out-for-Public-Comment-Utah",
    "url": "/news/PM2-5-State-Implementation-Plan---Provo-Area-out-for-Public-Comment-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NOx RACT Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/NOx-RACT-R",
    "url": "/news/NOx-RACT-R",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reminder: CY2016 Title V Emission Fees Due for Payment-New Jersey",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reminder-CY2016-Title-V-Emission-Fees-Due-for-Payment-New-Jersey",
    "url": "/news/Reminder-CY2016-Title-V-Emission-Fees-Due-for-Payment-New-Jersey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Sets Stakes in Pittsburgh and Denver",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Sets-Stakes-in-Pittsburgh-and-Denver",
    "url": "/news/Trinity-Sets-Stakes-in-Pittsburgh-and-Denver",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD Accepting Comments for Updates to Draft Regulation 13: Climate Pollutants, Rule 5: Petroleum Refinery",
    "apiurl": "/restapi/customnewscontentlvl2/news/baaqmd-accepting-comments-for-updates-to-draft-regulation-13-climate-pollutants-rule-5-petroleum-refinery",
    "url": "/news/baaqmd-accepting-comments-for-updates-to-draft-regulation-13-climate-pollutants-rule-5-petroleum-refinery",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD Accepting Comments for Updates to Draft Regulation 13: Climate Pollutants, Rule 5: Petroleum Refinery",
    "apiurl": "/restapi/customnewscontentlvl2/news/baaqmd-accepting-comments-for-updates-to-draft-regulation-13-climate-pollutants-rule-5-petroleum-refinery",
    "url": "/news/states/california/baaqmd-accepting-comments-for-updates-to-draft-regulation-13--climate-pollutants-rule-5--petroleum-refinery",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA vs. TCEQ:  The Drama on the Flex Permit Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-vs-TCEQ-The-Drama-on-the-Flex-Permit-Program",
    "url": "/news/EPA-vs-TCEQ-The-Drama-on-the-Flex-Permit-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Williston Basin Petroleum Conference (WBPC) sees an all-time high-North Dakota",
    "apiurl": "/restapi/customnewscontentlvl2/news/Williston-Basin-Petroleum-Conference-(WBPC)-sees-an-all-time-high-North-Dakota",
    "url": "/news/Williston-Basin-Petroleum-Conference-(WBPC)-sees-an-all-time-high-North-Dakota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PA EQB Proposes New Fee Schedule-Pennsylvania",
    "apiurl": "/restapi/customnewscontentlvl2/news/PA-EQB-Proposes-New-Fee-Schedule-Pennsylvania",
    "url": "/news/PA-EQB-Proposes-New-Fee-Schedule-Pennsylvania",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Status Update on Maryland’s Short-Lived Climate Pollutants Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/status-update-on-maryland-s-short-lived-climate-pollutants-program",
    "url": "/news/status-update-on-maryland-s-short-lived-climate-pollutants-program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Status Update on Maryland’s Short-Lived Climate Pollutants Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/status-update-on-maryland-s-short-lived-climate-pollutants-program",
    "url": "/states/maryland/status-update-on-maryland-s-short-lived-climate-pollutants-program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Quality Advisory Board to Hold Public Hearing on Regional Haze Progress Report-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Advisory-Board-to-Hold-Public-Hearing-on-Regional-Haze-Progress-Report-Wyoming",
    "url": "/news/Air-Quality-Advisory-Board-to-Hold-Public-Hearing-on-Regional-Haze-Progress-Report-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Arizona Department of Environmental Quality Aquifer Protection Permit Application",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Arizona-Department-of-Environmental-Quality-Aquifer-Protection-Permit-Application",
    "url": "/news/New-Arizona-Department-of-Environmental-Quality-Aquifer-Protection-Permit-Application",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Arizona Department of Environmental Quality Aquifer Protection Permit Application",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Arizona-Department-of-Environmental-Quality-Aquifer-Protection-Permit-Application",
    "url": "/states/arizona/new-arizona-department-of-environmental-quality-aquifer-protection-permit-application",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Unified Hazardous Materials Spill/Release and Tier II Reporting System – North Dakota",
    "apiurl": "/restapi/customnewscontentlvl2/news/hazardous-materials-spill-release-tier-ii-reporting-n-dakota",
    "url": "/news/hazardous-materials-spill-release-tier-ii-reporting-n-dakota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Toxics Regulatory Update - New CAPCOA Notification Guidelines",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Toxics-Regulatory-Update---New-CAPCOA-Notification-Guidelines",
    "url": "/news/Air-Toxics-Regulatory-Update---New-CAPCOA-Notification-Guidelines",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Clean Power Plan in Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/Clean-Power-Plan-in-Missouri",
    "url": "/news/Clean-Power-Plan-in-Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Yolo-Solano Air Quality Management District Proposed Amendments to Architectural Coatings Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Yolo-Solano-Air-Quality-Management-District-Proposed-Amendments-to-Architectural-Coatings-Rule",
    "url": "/news/Yolo-Solano-Air-Quality-Management-District-Proposed-Amendments-to-Architectural-Coatings-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Establishes New 1-hour Standard for Sulfur Dioxide",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Establishes-New-1-hour-Standard-for-Sulfur-Dioxide",
    "url": "/news/EPA-Establishes-New-1-hour-Standard-for-Sulfur-Dioxide",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Storage Tank General Permit for Oil & Gas Industry Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Storage-Tank-General-Permit-for-Oil-Gas-Industry-Released",
    "url": "/news/New-Storage-Tank-General-Permit-for-Oil-Gas-Industry-Released",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDNR Field Office 5 Moving to Wallace Building in Des Moines-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDNR-Field-Office-5-Moving-to-Wallace-Building-in-Des-Moines-Iowa",
    "url": "/news/IDNR-Field-Office-5-Moving-to-Wallace-Building-in-Des-Moines-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Winter Ozone in the Upper Green-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Winter-Ozone-in-the-Upper-Green-Wyoming",
    "url": "/news/Winter-Ozone-in-the-Upper-Green-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ontario's Emissions Performance Standards (EPS)-Ontario",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ontario's-Emissions-Performance-Standards-(EPS)-Ontario",
    "url": "/news/Ontario's-Emissions-Performance-Standards-(EPS)-Ontario",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD Proposed Amended Rule 1148.1 - Oil and Gas Production Wells",
    "apiurl": "/restapi/customnewscontentlvl2/news/SCAQMD-Proposed-Amended-Rule-1148-1---Oil-and-Gas-Production-Wells",
    "url": "/news/SCAQMD-Proposed-Amended-Rule-1148-1---Oil-and-Gas-Production-Wells",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes to Approve Revisions to Vermont's State Implementation Plan-Vermont",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-to-Approve-Revisions-to-Vermont's-State-Implementation-Plan-Vermont",
    "url": "/news/EPA-Proposes-to-Approve-Revisions-to-Vermont's-State-Implementation-Plan-Vermont",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Upcoming Georgia EPD Permitting Projects",
    "apiurl": "/restapi/customnewscontentlvl2/news/Upcoming-G",
    "url": "/news/Upcoming-G",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Implements Expedited Permitting Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/TCEQ-Implements-Expedited-Permitting-Program-",
    "url": "/news/TCEQ-Implements-Expedited-Permitting-Program-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Acquires Building Commissioning Firm WorkingBuildings",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Acquires-Building-Commissioning-Firm-WorkingBuildings",
    "url": "/news/Trinity-Consultants-Acquires-Building-Commissioning-Firm-WorkingBuildings",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NC DAQ Issues Guidance for Combustion Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/NC-DAQ-Issues-Guidance-for-Combustion-Sources",
    "url": "/news/NC-DAQ-Issues-Guidance-for-Combustion-Sources",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NJDEP Proposes Revisions to Air Quality Risk Screening Worksheet - CRITICAL UPDATE-New Jersey",
    "apiurl": "/restapi/customnewscontentlvl2/news/NJDEP-Proposes-Revisions-to-Air-Quality-Risk-Screening-Worksheet---CRITICAL-UPDATE-New-Jersey",
    "url": "/news/NJDEP-Proposes-Revisions-to-Air-Quality-Risk-Screening-Worksheet---CRITICAL-UPDATE-New-Jersey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Energy and Environment Cabinet Presents Their Position on Greenhouse Gas Policy Implications for Kentucky",
    "apiurl": "/restapi/customnewscontentlvl2/news/Energy-and",
    "url": "/news/Energy-and",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity in 2020",
    "apiurl": "/restapi/customnewscontentlvl2/news/trinity-in-2020",
    "url": "/news/trinity-in-2020",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Sulfur Dioxide National Ambient Air Quality Standard Designations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Sulfur-Dioxide-National-Ambient-Air-Quality-Standard-Designations",
    "url": "/news/Sulfur-Dioxide-National-Ambient-Air-Quality-Standard-Designations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2018 KDHE CAAAG Meeting-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/2018-KDHE-CAAAG-Meeting-Kansas",
    "url": "/news/2018-KDHE-CAAAG-Meeting-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Clark County DAQ Releases New Mineral and Aggregate Processing Permitting Tool-Nevada",
    "apiurl": "/restapi/customnewscontentlvl2/news/Clark-County-DAQ-Releases-New-Mineral-and-Aggregate-Processing-Permitting-Tool-Nevada",
    "url": "/news/Clark-County-DAQ-Releases-New-Mineral-and-Aggregate-Processing-Permitting-Tool-Nevada",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Delaware Control of Volatile Organic Compounds (VOC) Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Delaware-C",
    "url": "/news/Delaware-C",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Visible Emissions Evaluation Procedures",
    "apiurl": "/restapi/customnewscontentlvl2/news/Visible-Emissions-Evaluation-Procedures",
    "url": "/news/Visible-Emissions-Evaluation-Procedures",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CARB Provides Additional EMFAC Off-Model Adjustment Factors for Carbon Dioxide",
    "apiurl": "/restapi/customnewscontentlvl2/news/carb-provides-additional-emfac-off-model-adjustment-factors-for-carbon-dioxide",
    "url": "/news/carb-provides-additional-emfac-off-model-adjustment-factors-for-carbon-dioxide",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CARB Provides Additional EMFAC Off-Model Adjustment Factors for Carbon Dioxide",
    "apiurl": "/restapi/customnewscontentlvl2/news/carb-provides-additional-emfac-off-model-adjustment-factors-for-carbon-dioxide",
    "url": "/news/state/california/carb-provides-additional-emfac-off-model-adjustment-factors-for-carbon-dioxide",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CARB Provides Additional EMFAC Off-Model Adjustment Factors for Carbon Dioxide",
    "apiurl": "/restapi/customnewscontentlvl2/news/carb-provides-additional-emfac-off-model-adjustment-factors-for-carbon-dioxide",
    "url": "/news/state/carb-provides-additional-emfac-off-model-adjustment-factors-for-carbon-dioxide",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Additional Environmental Topics Discussed at the November 19 Quarterly Air Quality Client Contact Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Additional-Environmental-Topics-Discussed-at-the-November-19-Quarterly-Air-Quality-Client-Contact-Meeting",
    "url": "/news/Additional-Environmental-Topics-Discussed-at-the-November-19-Quarterly-Air-Quality-Client-Contact-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes Revisions to Reciprocating Internal Combustion Engine (RICE) MACT",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-Revisions-to-Reciprocating-Internal-Combustion-Engine-(RICE)-MACT",
    "url": "/news/EPA-Proposes-Revisions-to-Reciprocating-Internal-Combustion-Engine-(RICE)-MACT",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revised Title 129 Air Quality Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revised-Title-129-Air-Quality-Regulations",
    "url": "/news/Revised-Title-129-Air-Quality-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEP Piloting Virtual Source Test Observation Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/ndep-piloting-virtual-source-test-observation-program",
    "url": "/news/ndep-piloting-virtual-source-test-observation-program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEP Piloting Virtual Source Test Observation Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/ndep-piloting-virtual-source-test-observation-program",
    "url": "/news/state/nevada/ndep-piloting-virtual-source-test-observation-program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Industrial Regulatory Impacts Imminent from PFAS Concerns",
    "apiurl": "/restapi/customnewscontentlvl2/news/industrial-regulatory-impacts-imminent-from-pfas-concerns",
    "url": "/news/industrial-regulatory-impacts-imminent-from-pfas-concerns",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Industrial Regulatory Impacts Imminent from PFAS Concerns",
    "apiurl": "/restapi/customnewscontentlvl2/news/industrial-regulatory-impacts-imminent-from-pfas-concerns",
    "url": "/News/Federal/Industrial-Regulatory-Impacts-Imminent-from-PFAS-Concerns/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cap-and-Trade November 2015 Joint-Auction Results Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/Cap-and-Trade-November-2015-Joint-Auction-Results-Released",
    "url": "/news/Cap-and-Trade-November-2015-Joint-Auction-Results-Released",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oil and Gas Sources \"Permit by Rule\"-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oil-and-Gas-Sources-Permit-by-Rule--Utah",
    "url": "/news/Oil-and-Gas-Sources-Permit-by-Rule--Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Industrial Noise and Community Impacts",
    "apiurl": "/restapi/customnewscontentlvl2/news/Industrial-Noise-and-Community-Impacts",
    "url": "/news/Industrial-Noise-and-Community-Impacts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NSPS Subpart OOO",
    "apiurl": "/restapi/customnewscontentlvl2/news/NSPS-Subpart-OOO",
    "url": "/news/NSPS-Subpart-OOO",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MassDEP Updates TURA Regulations-Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/MassDEP-Updates-TURA-Regulations-Massachusetts",
    "url": "/news/MassDEP-Updates-TURA-Regulations-Massachusetts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The Illinois General NPDES Permit for Industrial Activities (ILR00) is Now In Effect!-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/The-Illinois-General-NPDES-Permit-for-Industrial-Activities-(ILR00)-is-Now-In-Effect!-Illinois",
    "url": "/news/The-Illinois-General-NPDES-Permit-for-Industrial-Activities-(ILR00)-is-Now-In-Effect!-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oregon DEQ has Published Significant Sources for Regional Haze Planning-Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oregon-DEQ-has-Published-Significant-Sources-for-Regional-Haze-Planning-Oregon",
    "url": "/news/Oregon-DEQ-has-Published-Significant-Sources-for-Regional-Haze-Planning-Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA Finalizes Changes to Air Quality Modeling Guidance",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-Finalizes-Changes-to-Air-Quality-Modeling-Guidance",
    "url": "/news/USEPA-Finalizes-Changes-to-Air-Quality-Modeling-Guidance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MON and MACT Pressure Relief Management Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/mon-and-mact-pressure-relief-management-requirements",
    "url": "/news/mon-and-mact-pressure-relief-management-requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity and MCTA Presenting Air Compliance Program on November 29 -Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-and-MCTA-Presenting-Air-Compliance-Program-on-November-29--Massachusetts",
    "url": "/news/Trinity-and-MCTA-Presenting-Air-Compliance-Program-on-November-29--Massachusetts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Annual Compliance Certifications for Kentucky Air Permit Holders Due January 30, 2010",
    "apiurl": "/restapi/customnewscontentlvl2/news/Annual-Com",
    "url": "/news/Annual-Com",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Invitation to Participate in Fee Advisory Groups",
    "apiurl": "/restapi/customnewscontentlvl2/news/Invitation-to-Participate-in-Fee-Advisory-Groups",
    "url": "/news/Invitation-to-Participate-in-Fee-Advisory-Groups",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NC Will Hold Five Public Hearings on Ozone Non-Attainment Boundaries in January",
    "apiurl": "/restapi/customnewscontentlvl2/news/NC-Will-Hold-Five-Public-Hearings-on-Ozone-Non-Attainment-Boundaries-in-January-",
    "url": "/news/NC-Will-Hold-Five-Public-Hearings-on-Ozone-Non-Attainment-Boundaries-in-January-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE Releases AERSCREEN 1.5 to Support Latest U.S. EPA Executable 13350",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-Releases-AERSCREEN-1-5-to-Support-Latest-U-S-EPA-Executable-13350",
    "url": "/news/BREEZE-Releases-AERSCREEN-1-5-to-Support-Latest-U-S-EPA-Executable-13350",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Environmental Permit Streamlining Legislation Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/Environmental-Permit-Streamlining-Legislation-Update",
    "url": "/news/Environmental-Permit-Streamlining-Legislation-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PA DEP Issues Draft Guidance on Source Aggregation for the Oil and Gas Industry",
    "apiurl": "/restapi/customnewscontentlvl2/news/PA-DEP-Issues-Draft-Guidance-on-Source-Aggregation-for-the-Oil-and-Gas-Industry",
    "url": "/news/PA-DEP-Issues-Draft-Guidance-on-Source-Aggregation-for-the-Oil-and-Gas-Industry",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DNR Seeks Input on Plan to Reduce Sulfur Dioxide in Muscatine",
    "apiurl": "/restapi/customnewscontentlvl2/news/DNR-Seeks-Input-on-Plan-to-Reduce-Sulfur-Dioxide-in-Muscatine",
    "url": "/news/DNR-Seeks-Input-on-Plan-to-Reduce-Sulfur-Dioxide-in-Muscatine",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "UDAQ Develops Draft of Oil & Gas General Approval Order",
    "apiurl": "/restapi/customnewscontentlvl2/news/UDAQ-Develops-Draft-of-Oil-Gas-General-Approval-Order-",
    "url": "/news/UDAQ-Develops-Draft-of-Oil-Gas-General-Approval-Order-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on Illinois’ PM2.5 National Ambient Air Quality Standards Designations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-Illinois-PM2-5-National-Ambient-Air-Quality-Standards-Designations-",
    "url": "/news/Update-on-Illinois-PM2-5-National-Ambient-Air-Quality-Standards-Designations-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "RIDEM Proposes Regulation for Climate Resilience Fund-Rhode Island",
    "apiurl": "/restapi/customnewscontentlvl2/news/RIDEM-Proposes-Regulation-for-Climate-Resilience-Fund-Rhode-Island",
    "url": "/news/RIDEM-Proposes-Regulation-for-Climate-Resilience-Fund-Rhode-Island",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Emissions Inventory Extension until April 16, 2012",
    "apiurl": "/restapi/customnewscontentlvl2/news/Emissions-Inventory-Extension-until-April-16-2012",
    "url": "/news/Emissions-Inventory-Extension-until-April-16-2012",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Wyoming DEQ Annual Report-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Wyoming-DEQ-Annual-Report-Wyoming",
    "url": "/news/Wyoming-DEQ-Annual-Report-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Good News March 2021",
    "apiurl": "/restapi/customnewscontentlvl2/news/good-news-march-2021",
    "url": "/news/good-news-march-2021",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Good News March 2021",
    "apiurl": "/restapi/customnewscontentlvl2/news/good-news-march-2021",
    "url": "/www.trinityconsultants.com/good-news-mar-2021",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Scrap Metal Handling and Recycling – Compliance Advisory from NJDEP",
    "apiurl": "/restapi/customnewscontentlvl2/news/scrap-metal-handling-and-recycling-compliance-advisory-from-njdep",
    "url": "/news/scrap-metal-handling-and-recycling-compliance-advisory-from-njdep",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cap-and-Trade February 2017 Joint-Auction Results Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/Cap-and-Trade-February-2017-Joint-Auction-Results-Released",
    "url": "/news/Cap-and-Trade-February-2017-Joint-Auction-Results-Released",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Annual Compliance Certification Forms Available",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Annual-Compliance-Certification-Forms-Available",
    "url": "/news/New-Annual-Compliance-Certification-Forms-Available",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MassDEP 2019 Toxic Use Reduction (TUR) Plan Summary and Report Extension",
    "apiurl": "/restapi/customnewscontentlvl2/news/massdep-2019-toxic-use-reduction-(tur)-plan-summary-and-report-extension",
    "url": "/news/massdep-2019-toxic-use-reduction-(tur)-plan-summary-and-report-extension",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "AWMA Meetings",
    "apiurl": "/restapi/customnewscontentlvl2/news/AWMA-Meetings",
    "url": "/news/AWMA-Meetings",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Does Your SPCC Plan Make the Grade? Lessons Learned from EPA Inspections-North Carolina",
    "apiurl": "/restapi/customnewscontentlvl2/news/Does-Your-SPCC-Plan-Make-the-Grade-Lessons-Learned-from-EPA-Inspections-North-Carolina",
    "url": "/news/Does-Your-SPCC-Plan-Make-the-Grade-Lessons-Learned-from-EPA-Inspections-North-Carolina",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on Michigan Rulemaking-Michigan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-Michigan-Rulemaking-Michigan",
    "url": "/news/Update-on-Michigan-Rulemaking-Michigan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Renowned Semiconductor and Aerospace Expert Joins Trinity Consultants",
    "apiurl": "/restapi/customnewscontentlvl2/news/Renowned-Semiconductor-and-Aerospace-Expert-Joins-Trinity-Consultants",
    "url": "/news/Renowned-Semiconductor-and-Aerospace-Expert-Joins-Trinity-Consultants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed SO2 Nonattainment Area in Muscatine County",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-SO2-Nonattainment-Area-in-Muscatine-County",
    "url": "/news/Proposed-SO2-Nonattainment-Area-in-Muscatine-County",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New General Permit for Multi-Site Mineral Processing Under Development",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-General-Permit-for-Multi-Site-Mineral-Processing-Under-Development",
    "url": "/news/New-General-Permit-for-Multi-Site-Mineral-Processing-Under-Development",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE Releases AERMET 7.7 to Include Latest U.S. EPA AERMINUTE Executable 15272",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-Releases-AERMET-7-7-to-Include-Latest-U-S-EPA-AERMINUTE-Executable-15272",
    "url": "/news/BREEZE-Releases-AERMET-7-7-to-Include-Latest-U-S-EPA-AERMINUTE-Executable-15272",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Approves Louisiana's Clean-Air Plan for Transport of Pollutants to Other States-Louisiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Approves-Louisiana's-Clean-Air-Plan-for-Transport-of-Pollutants-to-Other-States-Louisiana",
    "url": "/news/EPA-Approves-Louisiana's-Clean-Air-Plan-for-Transport-of-Pollutants-to-Other-States-Louisiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Coast Air Quality Management District – Proposed Amendments to Regulation XX",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Coast-Air-Quality-Management-District-Proposed-Amendments-to-Regulation-XX",
    "url": "/news/South-Coast-Air-Quality-Management-District-Proposed-Amendments-to-Regulation-XX",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDE Proposes Incorporation of Revised NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDE-Proposes-Incorporation-of-Revised-NAAQS",
    "url": "/news/MDE-Proposes-Incorporation-of-Revised-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LDEQ Proposes Revisions to the Risk Evaluation/Corrective Action Program (RECAP)-Louisiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/LDEQ-Proposes-Revisions-to-the-Risk-Evaluation-Corrective-Action-Program-(RECAP)-Louisiana",
    "url": "/news/LDEQ-Proposes-Revisions-to-the-Risk-Evaluation-Corrective-Action-Program-(RECAP)-Louisiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD - More Stringent Emission Thresholds Might Mean Additional Permitting Requirements in Coachella Valley",
    "apiurl": "/restapi/customnewscontentlvl2/news/scaqmd---more-stringent-emission-thresholds-might-mean-additional-permitting-requirements-in-coachella-valley",
    "url": "/news/scaqmd---more-stringent-emission-thresholds-might-mean-additional-permitting-requirements-in-coachella-valley",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD - More Stringent Emission Thresholds Might Mean Additional Permitting Requirements in Coachella Valley",
    "apiurl": "/restapi/customnewscontentlvl2/news/scaqmd---more-stringent-emission-thresholds-might-mean-additional-permitting-requirements-in-coachella-valley",
    "url": "/states/california/scaqmd---more-stringent-emission-thresholds-might-mean-additional-permitting-requirements-in-coachella-valley",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Federal Transport Rule — the “New CAIR” Round 1",
    "apiurl": "/restapi/customnewscontentlvl2/news/Federal-Transport-Rule-the-New-CAIR-Round-1",
    "url": "/news/Federal-Transport-Rule-the-New-CAIR-Round-1",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NOx RACT Update in New Hampshire-New Hampshire",
    "apiurl": "/restapi/customnewscontentlvl2/news/NOx-RACT-Update-in-New-Hampshire-New-Hampshire",
    "url": "/news/NOx-RACT-Update-in-New-Hampshire-New-Hampshire",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEC Proposes to Incorporate PM2.5 Ambient Air Quality Standards",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEC-Proposes-to-Incorporate-PM2-5-Ambient-Air-Quality-Standards",
    "url": "/news/ADEC-Proposes-to-Incorporate-PM2-5-Ambient-Air-Quality-Standards",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposed SIP Call for Air Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposed-SIP-Call-for-Air-Rules",
    "url": "/news/EPA-Proposed-SIP-Call-for-Air-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Memorandum Proposes a Shift in NSR Program Applicability",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Memorandum-Proposes-a-Shift-in-NSR-Program-Applicability",
    "url": "/news/EPA-Memorandum-Proposes-a-Shift-in-NSR-Program-Applicability",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Pollution Control Program - 2014 Monitoring Network Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Pollution-Control-Program---2014-Monitoring-Network-Plan",
    "url": "/news/Air-Pollution-Control-Program---2014-Monitoring-Network-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Take Advantage of New Air Permit Review Opportunities",
    "apiurl": "/restapi/customnewscontentlvl2/news/Take-Advantage-of-New-Air-Permit-Review-Opportunities",
    "url": "/news/Take-Advantage-of-New-Air-Permit-Review-Opportunities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Puts Down New Roots in Mississippi",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Puts-Down-New-Roots-in-Mississippi",
    "url": "/news/Trinity-Consultants-Puts-Down-New-Roots-in-Mississippi",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MCM NESHAP RTR – Testing and SSM Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/mcm-neshap-rtr-testing-and-ssm-updates",
    "url": "/news/mcm-neshap-rtr-testing-and-ssm-updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Gov. Edwards Issues New Executive Orders Addressing GHG Emissions Reduction and Coastal Resilience",
    "apiurl": "/restapi/customnewscontentlvl2/news/gov-edwards-issues-new-executive-orders-addressing-ghg-emissions-reduction-and-coastal-resilience-",
    "url": "/news/gov-edwards-issues-new-executive-orders-addressing-ghg-emissions-reduction-and-coastal-resilience-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Gov. Edwards Issues New Executive Orders Addressing GHG Emissions Reduction and Coastal Resilience",
    "apiurl": "/restapi/customnewscontentlvl2/news/gov-edwards-issues-new-executive-orders-addressing-ghg-emissions-reduction-and-coastal-resilience-",
    "url": "/states/louisiana/gov--edwards-issues-new-executive-orders-addressing-ghg-emissions-reduction-and-coastal-resilience",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Modeling Tip: How Parallel Processing can Expedite Large AERMOD Model Runs",
    "apiurl": "/restapi/customnewscontentlvl2/news/Modeling-Tip-How-Parallel-Processing-can-Expedite-Large-AERMOD-Model-Runs-",
    "url": "/news/Modeling-Tip-How-Parallel-Processing-can-Expedite-Large-AERMOD-Model-Runs-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Approving Changes to Nonattainment New Source Review Permitting Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-approving-changes-to-nonattainment-new-source-review-permitting-rules",
    "url": "/news/epa-approving-changes-to-nonattainment-new-source-review-permitting-rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "State Hazardous Waste Management Program Revisions",
    "apiurl": "/restapi/customnewscontentlvl2/news/State-Hazardous-Waste-Management-Program-Revisions",
    "url": "/news/State-Hazardous-Waste-Management-Program-Revisions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "WDNR Adopting 1-Hour NO2 & SO2 NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/WDNR-Adopting-1-Hour-NO2-SO2-NAAQS",
    "url": "/news/WDNR-Adopting-1-Hour-NO2-SO2-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MassDEP Draft 2020 Air Monitoring Network Plan and 2020 Five-Year Network Assessment",
    "apiurl": "/restapi/customnewscontentlvl2/news/massdep-draft-2020-air-monitoring-network-plan-and-2020-five-year-network-assessment",
    "url": "/news/massdep-draft-2020-air-monitoring-network-plan-and-2020-five-year-network-assessment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MassDEP Draft 2020 Air Monitoring Network Plan and 2020 Five-Year Network Assessment",
    "apiurl": "/restapi/customnewscontentlvl2/news/massdep-draft-2020-air-monitoring-network-plan-and-2020-five-year-network-assessment",
    "url": "/news/state/massachusetts/massdep-draft-2020-air-monitoring-network-plan-and-2020-five-year-network-assessment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LDEQ November 2020 Environmental Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/ldeq-november-2020-environmental-updates",
    "url": "/news/ldeq-november-2020-environmental-updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MPCA Soliciting Comments on Proposed Mercury Air Emissions Reporting and Reduction Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/MPCA-Soliciting-Comments-on-Proposed-Mercury-Air-Emissions-Reporting-and-Reduction-Rules",
    "url": "/news/MPCA-Soliciting-Comments-on-Proposed-Mercury-Air-Emissions-Reporting-and-Reduction-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Aviation Facility Part 70 General Permit-Minnesota",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Aviation-Facility-Part-70-General-Permit-Minnesota",
    "url": "/news/New-Aviation-Facility-Part-70-General-Permit-Minnesota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Storage Tank and Vapor Control System Guidance-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Storage-Tank-and-Vapor-Control-System-Guidance-Colorado",
    "url": "/news/Storage-Tank-and-Vapor-Control-System-Guidance-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Expedited Review of Permits Now Available in Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Expedited-Review-of-Permits-Now-Available-in-Illinois",
    "url": "/news/Expedited-Review-of-Permits-Now-Available-in-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Midwest Environmental Compliance Conference May 17-18",
    "apiurl": "/restapi/customnewscontentlvl2/news/Midwest-Environmental-Compliance-Conference-May-17-18",
    "url": "/news/Midwest-Environmental-Compliance-Conference-May-17-18",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Two Major Updates to North Dakota Well Registration Workbook",
    "apiurl": "/restapi/customnewscontentlvl2/news/two-major-updates-to-north-dakota-well-registration-workbook-",
    "url": "/news/two-major-updates-to-north-dakota-well-registration-workbook-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Amendments to Chapter 100 – Definitions Regulation",
    "apiurl": "/restapi/customnewscontentlvl2/news/Amendments-to-Chapter-100-Definitions-Regulation",
    "url": "/news/Amendments-to-Chapter-100-Definitions-Regulation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "RACT Update in the Ozone Transport Region",
    "apiurl": "/restapi/customnewscontentlvl2/news/RACT-Update-in-the-Ozone-Transport-Region",
    "url": "/news/RACT-Update-in-the-Ozone-Transport-Region",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on Proposed MPCA Air and Water Permit Fee Change",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-Proposed-MPCA-Air-and-Water-Permit-Fee-Change-",
    "url": "/news/Update-on-Proposed-MPCA-Air-and-Water-Permit-Fee-Change-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Finalizes Amendments to 2012 and 2016 NSPS for Oil and Natural Gas Industry",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-finalizes-amendments-to-2012-and-2016-nsps-for-oil-and-natural-gas-industry",
    "url": "/news/epa-finalizes-amendments-to-2012-and-2016-nsps-for-oil-and-natural-gas-industry",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Finalizes Amendments to 2012 and 2016 NSPS for Oil and Natural Gas Industry",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-finalizes-amendments-to-2012-and-2016-nsps-for-oil-and-natural-gas-industry",
    "url": "/federal/epa-finalizes-amendments-to-2012-and-2016-nsps-for-oil-and-natural-gas-industry",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "OTC Proceeds with Public Hearing for Additional Control Measures Targeting Pennsylvania’s Coal-Fired EGUs-Pennsylvania",
    "apiurl": "/restapi/customnewscontentlvl2/news/OTC-Proceeds-with-Public-Hearing-for-Additional-Control-Measures-Targeting-Pennsylvania-s-Coal-Fired-EGUs-Pennsylvania",
    "url": "/news/OTC-Proceeds-with-Public-Hearing-for-Additional-Control-Measures-Targeting-Pennsylvania-s-Coal-Fired-EGUs-Pennsylvania",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Maryland Department of the Environment Proposes Hazardous Substance Reporting Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/Maryland-Department-of-the-Environment-Proposes-Hazardous-Substance-Reporting-Requirements",
    "url": "/news/Maryland-Department-of-the-Environment-Proposes-Hazardous-Substance-Reporting-Requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Incorporating NSPS by reference into Utah Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/Incorporating-NSPS-by-reference-into-Utah-Rules",
    "url": "/news/Incorporating-NSPS-by-reference-into-Utah-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Potential Impacts to Industry from the PSM and RMP Standards RFI",
    "apiurl": "/restapi/customnewscontentlvl2/news/Potential-Impacts-to-Industry-from-the-PSM-and-RMP-Standards-RFI",
    "url": "/news/Potential-Impacts-to-Industry-from-the-PSM-and-RMP-Standards-RFI",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Benzene Fenceline Monitoring for Refineries",
    "apiurl": "/restapi/customnewscontentlvl2/news/Benzene-Fenceline-Monitoring-for-Refineries",
    "url": "/news/Benzene-Fenceline-Monitoring-for-Refineries",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GHG NSPS for EGUs Published",
    "apiurl": "/restapi/customnewscontentlvl2/news/GHG-NSPS-for-EGUs-Published",
    "url": "/news/GHG-NSPS-for-EGUs-Published",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Data Manipulation Tools in 3D Analyst 3.0 Make Modeling Faster and Easier",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Data-Manipulation-Tools-in-3D-Analyst-3-0-Make-Modeling-Faster-and-Easier-",
    "url": "/news/New-Data-Manipulation-Tools-in-3D-Analyst-3-0-Make-Modeling-Faster-and-Easier-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MPCA Modeling Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/MPCA-Modeling-Updates",
    "url": "/news/MPCA-Modeling-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DOEE Publishes Title V Reporting Guidance Letter-Washington, DC",
    "apiurl": "/restapi/customnewscontentlvl2/news/DOEE-Publishes-Title-V-Reporting-Guidance-Letter-Washington-DC",
    "url": "/news/DOEE-Publishes-Title-V-Reporting-Guidance-Letter-Washington-DC",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DEQ Proposes Revisions to Three VPDES Permits-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/DEQ-Proposes-Revisions-to-Three-VPDES-Permits-Virginia",
    "url": "/news/DEQ-Proposes-Revisions-to-Three-VPDES-Permits-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "August 2014 California-Quebec Practice Auction",
    "apiurl": "/restapi/customnewscontentlvl2/news/August-2014-California-Quebec-Practice-Auction",
    "url": "/news/August-2014-California-Quebec-Practice-Auction",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Friendly Reminder - Check Your Fuel-Oil Tickets for Sulfur Content-Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/Friendly-Reminder---Check-Your-Fuel-Oil-Tickets-for-Sulfur-Content-Massachusetts",
    "url": "/news/Friendly-Reminder---Check-Your-Fuel-Oil-Tickets-for-Sulfur-Content-Massachusetts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Annual Compliance Certification and Semi-Annual Monitoring and Deviation Reporting Forms",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Annual-Compliance-Certification-and-Semi-Annual-Monitoring-and-Deviation-Reporting-Forms",
    "url": "/news/New-Annual-Compliance-Certification-and-Semi-Annual-Monitoring-and-Deviation-Reporting-Forms",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes SO2 One-Hour NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-SO2-One-Hour-NAAQS",
    "url": "/news/EPA-Proposes-SO2-One-Hour-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDEM Issues Updates to Article 2 Fix-up Rule for Final Adoption",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDEM-Issues-Updates-to-Article-2-Fix-up-Rule-for-Final-Adoption-",
    "url": "/news/IDEM-Issues-Updates-to-Article-2-Fix-up-Rule-for-Final-Adoption-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Greenhouse Gas Emissions Permitting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Greenhouse-Gas-Emissions-Permitting",
    "url": "/news/Greenhouse-Gas-Emissions-Permitting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MACT Final Rule for Spark Engines",
    "apiurl": "/restapi/customnewscontentlvl2/news/MACT-Final-Rule-for-Spark-Engines",
    "url": "/news/MACT-Final-Rule-for-Spark-Engines",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Are You Qualified for Conditional No-Exposure Exclusion for Stormwater Permit Requirements?",
    "apiurl": "/restapi/customnewscontentlvl2/news/are-you-qualified-for-conditional-no-exposure-exclusion-for-stormwater-permit-requirements",
    "url": "/news/are-you-qualified-for-conditional-no-exposure-exclusion-for-stormwater-permit-requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Coast Air Quality Management District – Proposed Amended Rule 1168-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Coast-Air-Quality-Management-District-Proposed-Amended-Rule-1168-California",
    "url": "/news/South-Coast-Air-Quality-Management-District-Proposed-Amended-Rule-1168-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The Benefits and Risks of Optical Gas Imaging (OGI) to Oil & Gas Operators",
    "apiurl": "/restapi/customnewscontentlvl2/news/the-benefits-and-risks-of-optical-gas-imaging-(ogi)-to-oil-gas-operators",
    "url": "/news/the-benefits-and-risks-of-optical-gas-imaging-(ogi)-to-oil-gas-operators",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The Benefits and Risks of Optical Gas Imaging (OGI) to Oil & Gas Operators",
    "apiurl": "/restapi/customnewscontentlvl2/news/the-benefits-and-risks-of-optical-gas-imaging-(ogi)-to-oil-gas-operators",
    "url": "/News/Federal/The-Benefits-and-Risks-of-Optical-Gas-Imaging-OGI-to-Oil---Gas-Operators/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Toxicology Update-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Toxicology-Update-Texas",
    "url": "/news/Toxicology-Update-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Quality Advisory Board Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Advisory-Board-Meeting",
    "url": "/news/Air-Quality-Advisory-Board-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PM2.5 Serious Nonattainment Work Progresses into 2018-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/PM2-5-Serious-Nonattainment-Work-Progresses-into-2018-Utah",
    "url": "/news/PM2-5-Serious-Nonattainment-Work-Progresses-into-2018-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Dispersion Modeling— New Downwash Calculations Change the Playing Field",
    "apiurl": "/restapi/customnewscontentlvl2/news/-Dispersion-Modeling-New-Downwash-Calculations-Change-the-Playing-Field",
    "url": "/news/-Dispersion-Modeling-New-Downwash-Calculations-Change-the-Playing-Field",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Emissions Electronic Reporting System",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Emissions-Electronic-Reporting-System",
    "url": "/news/Air-Emissions-Electronic-Reporting-System",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Current ADEQ Position On NAAQS Modeling",
    "apiurl": "/restapi/customnewscontentlvl2/news/Current-ADEQ-Position-On-NAAQS-Modeling",
    "url": "/news/Current-ADEQ-Position-On-NAAQS-Modeling",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Withdrawal of Direct Finals Rules Impacting Illinois-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Withdrawal-of-Direct-Finals-Rules-Impacting-Illinois-Illinois",
    "url": "/news/Withdrawal-of-Direct-Finals-Rules-Impacting-Illinois-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Increased AAL for Arsenic",
    "apiurl": "/restapi/customnewscontentlvl2/news/Increased-AAL-for-Arsenic-",
    "url": "/news/Increased-AAL-for-Arsenic-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA Guidance Memo Addresses Supreme Court GHG Permitting Ruling",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-Guid",
    "url": "/news/USEPA-Guid",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Emissions Inventory Requirements for Bexar County!-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Emissions-Inventory-Requirements-for-Bexar-County!-Texas",
    "url": "/news/New-Emissions-Inventory-Requirements-for-Bexar-County!-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDNR Title V Fees Stakeholder Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDNR-Title-V-Fees-Stakeholder-Meeting",
    "url": "/news/IDNR-Title-V-Fees-Stakeholder-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed California Environmental Quality Act Changes to Address Tribal Resources",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-California-Environmental-Quality-Act-Changes-to-Address-Tribal-Resources",
    "url": "/news/Proposed-California-Environmental-Quality-Act-Changes-to-Address-Tribal-Resources",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Public Hearing on New Maricopa County PM10 Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Public-Hearing-on-New-Maricopa-County-PM10-Plan",
    "url": "/news/Public-Hearing-on-New-Maricopa-County-PM10-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Clear and Reasonable Warning Revision Impacts on Proposition 65",
    "apiurl": "/restapi/customnewscontentlvl2/news/Clear-and-Reasonable-Warning-Revision-Impacts-on-Proposition-65",
    "url": "/news/Clear-and-Reasonable-Warning-Revision-Impacts-on-Proposition-65",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "California AB 1647 & SCAQMD Proposed Amended Rule 1180-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/California-AB-1647-SCAQMD-Proposed-Amended-Rule-1180-California",
    "url": "/news/California-AB-1647-SCAQMD-Proposed-Amended-Rule-1180-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Compliance Still Required for Nevada Method 9 Evaluations",
    "apiurl": "/restapi/customnewscontentlvl2/news/compliance-still-required-for-nevada-method-9-evaluations",
    "url": "/news/compliance-still-required-for-nevada-method-9-evaluations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Approves and Promulgates Re-Designation of Knoxville Area to Attainment for 2008 Ozone NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Approves-and-Promulgates-Re-Designation-of-Knoxville-Area-to-Attainment-for-2008-Ozone-NAAQS",
    "url": "/news/EPA-Approves-and-Promulgates-Re-Designation-of-Knoxville-Area-to-Attainment-for-2008-Ozone-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Emission Reporting Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Emission-Reporting-Requirements",
    "url": "/news/Air-Emission-Reporting-Requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Comments on Emissions During SSM Deadline Extended",
    "apiurl": "/restapi/customnewscontentlvl2/news/Comments-on-Emissions-During-SSM-Deadline-Extended",
    "url": "/news/Comments-on-Emissions-During-SSM-Deadline-Extended",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SafeBridge Announces Availability of Computational Predictive Toxicology Capabilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/SafeBridge-Announces-Availability-of-Computational-Predictive-Toxicology-Capabilities",
    "url": "/news/SafeBridge-Announces-Availability-of-Computational-Predictive-Toxicology-Capabilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SafeBridge Announces Availability of Computational Predictive Toxicology Capabilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/SafeBridge-Announces-Availability-of-Computational-Predictive-Toxicology-Capabilities",
    "url": "/news/SafeBridge-Consultants-Inc-Announces-Availability-of-Computational-Predictive-Toxicology-Capabilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Responding to Audit Surprises",
    "apiurl": "/restapi/customnewscontentlvl2/news/c6f366ef-c9c0-448f-a315-c37af33ffa9b",
    "url": "/news/c6f366ef-c9c0-448f-a315-c37af33ffa9b",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Have PSM or RMP Questions? We Can Help!-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Have-PSM-or-RMP-Questions-We-Can-Help!-Texas",
    "url": "/news/Have-PSM-or-RMP-Questions-We-Can-Help!-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Good News - September 2020",
    "apiurl": "/restapi/customnewscontentlvl2/news/good-news-sep",
    "url": "/news/good-news-sep",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Good News - September 2020",
    "apiurl": "/restapi/customnewscontentlvl2/news/good-news-sep",
    "url": "/company/good-news---sep",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Good News - September 2020",
    "apiurl": "/restapi/customnewscontentlvl2/news/good-news-sep",
    "url": "/news/good-news---sep",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Spill Prevention, Control, and Countermeasure (SPCC) Rule Amended",
    "apiurl": "/restapi/customnewscontentlvl2/news/-Spill-Prevention-Control-and-Countermeasure-(SPCC)-Rule-Amended",
    "url": "/news/-Spill-Prevention-Control-and-Countermeasure-(SPCC)-Rule-Amended",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Extension on Comment Period for EPA's Partial Approval and Disapproval of Arizona State Implementation Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Extension-on-Comment-Period-for-EPA's-Partial-Approval-and-Disapproval-of-Arizona-State-Implementation-Plan-",
    "url": "/news/Extension-on-Comment-Period-for-EPA's-Partial-Approval-and-Disapproval-of-Arizona-State-Implementation-Plan-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NJDEP ISG Meeting Notes",
    "apiurl": "/restapi/customnewscontentlvl2/news/NJDEP-ISG-Meeting-Notes",
    "url": "/news/NJDEP-ISG-Meeting-Notes",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Additional Time to Install Emergency CI Engines Without Triggering Tier 4 Emission Requirements - South Coast AQMD Revises Proposed Amended Rule 1470 On September 6, 2011",
    "apiurl": "/restapi/customnewscontentlvl2/news/Additional-Time-to-Install-Emergency-CI-Engines-Without-Triggering-Tier-4-Emission-Requirements---South-Coast-AQMD-Revises-Proposed-Amended-Rule-1470-On-September-6-2011",
    "url": "/news/Additional-Time-to-Install-Emergency-CI-Engines-Without-Triggering-Tier-4-Emission-Requirements---South-Coast-AQMD-Revises-Proposed-Amended-Rule-1470-On-September-6-2011",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DNREC Amends Air Quality Regulations for Chromium Testing Methods",
    "apiurl": "/restapi/customnewscontentlvl2/news/DNREC-Amen",
    "url": "/news/DNREC-Amen",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Greenhouse Gas Emissions Inventory for 2013 Posted on DNR Website",
    "apiurl": "/restapi/customnewscontentlvl2/news/Greenhouse-Gas-Emissions-Inventory-for-2013-Posted-on-DNR-Website",
    "url": "/news/Greenhouse-Gas-Emissions-Inventory-for-2013-Posted-on-DNR-Website",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Pennsylvania Regulatory Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Pennsylvania-Regulatory-Updates",
    "url": "/news/Pennsylvania-Regulatory-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New General APEN Form Released, APCD-200",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-General-APEN-Form-Released-APCD-200",
    "url": "/news/New-General-APEN-Form-Released-APCD-200",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Wyoming Triennial Emission Inventory for ALL Minor Emission Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/wyoming-triennial-emission-inventory-for-all-minor-emission-sources",
    "url": "/news/wyoming-triennial-emission-inventory-for-all-minor-emission-sources",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Knox County Air Pollution Control Board Public Hearing and Regulatory Revisions-Tennessee",
    "apiurl": "/restapi/customnewscontentlvl2/news/Knox-County-Air-Pollution-Control-Board-Public-Hearing-and-Regulatory-Revisions-Tennessee",
    "url": "/news/Knox-County-Air-Pollution-Control-Board-Public-Hearing-and-Regulatory-Revisions-Tennessee",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ventura County APCD Proposed Rule 74.33 - Liquefied Petroleum Gas Transfer or Dispensing",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ventura-County-APCD-Proposed-Rule-74-33---Liquefied-Petroleum-Gas-Transfer-or-Dispensing",
    "url": "/news/Ventura-County-APCD-Proposed-Rule-74-33---Liquefied-Petroleum-Gas-Transfer-or-Dispensing",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Air Quality Division Facility Information Form",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Air-Quality-Division-Facility-Information-Form",
    "url": "/news/New-Air-Quality-Division-Facility-Information-Form",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New AQD Penalty Guidance",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-AQD-Penalty-Guidance",
    "url": "/news/New-AQD-Penalty-Guidance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes Coming to Michigan PM2.5 Nonattainment Designations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Changes-Coming-to-Michigan-PM2-5-Nonattainment-Designations",
    "url": "/news/Changes-Coming-to-Michigan-PM2-5-Nonattainment-Designations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Carolina DHEC New Construction Permit Application Training",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Carolina-DHEC-New-Construction-Permit-Application-Training",
    "url": "/news/South-Carolina-DHEC-New-Construction-Permit-Application-Training",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposed NOx Hourly Limit",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposed-NOx-Hourly-Limit",
    "url": "/news/EPA-Proposed-NOx-Hourly-Limit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "May 2013 Cap-and-Trade GHG Allowance Auction Results Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/-May-2013-Cap-and-Trade-GHG-Allowance-Auction-Results-Released",
    "url": "/news/-May-2013-Cap-and-Trade-GHG-Allowance-Auction-Results-Released",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Nebraska DEQ Proposed Changes to Title 129-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/Nebraska-DEQ-Proposed-Changes-to-Title-129-Nebraska",
    "url": "/news/Nebraska-DEQ-Proposed-Changes-to-Title-129-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NEW Version of AERMOD Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/NEW-Version-of-AERMOD-Released",
    "url": "/news/NEW-Version-of-AERMOD-Released",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Changes to the Title 129 Air Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Changes-to-the-Title-129-Air-Regulations",
    "url": "/news/Proposed-Changes-to-the-Title-129-Air-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Fee Advisory Group Meeting-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Fee-Advisory-Group-Meeting-Iowa",
    "url": "/news/Fee-Advisory-Group-Meeting-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Mojave Desert Air Quality Management District - Proposed Rule Amendments to PSD Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/Mojave-Desert-Air-Quality-Management-District---Proposed-Rule-Amendments-to-PSD-Program",
    "url": "/news/Mojave-Desert-Air-Quality-Management-District---Proposed-Rule-Amendments-to-PSD-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Issues Temporary Waiver for Electronic Reporting of Certain Bypasses for POTWs",
    "apiurl": "/restapi/customnewscontentlvl2/news/tceq-issues-temporary-waiver-for-electronic-reporting-of-certain-bypasses-for-potws-",
    "url": "/news/tceq-issues-temporary-waiver-for-electronic-reporting-of-certain-bypasses-for-potws-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Issues Temporary Waiver for Electronic Reporting of Certain Bypasses for POTWs",
    "apiurl": "/restapi/customnewscontentlvl2/news/tceq-issues-temporary-waiver-for-electronic-reporting-of-certain-bypasses-for-potws-",
    "url": "/news/state/texas/tceq-issues-temporary-waiver-for-electronic-reporting-of-certain-bypasses-for-potws-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEM Rule Revisions Effective December 7, 2018",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEM-Rule-Revisions-Effective-December-7-2018",
    "url": "/news/ADEM-Rule-Revisions-Effective-December-7-2018",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEP’s Proposed Significant Fee Schedule Changes: Public Notice Period and New Administrative Permit Renewal Option-Nevada",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEP-s-Proposed-Significant-Fee-Schedule-Changes-Public-Notice-Period-and-New-Administrative-Permit-Renewal-Option-Nevada",
    "url": "/news/NDEP-s-Proposed-Significant-Fee-Schedule-Changes-Public-Notice-Period-and-New-Administrative-Permit-Renewal-Option-Nevada",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "May 2014 Cap-and-Trade GHG Allowance Auction Details Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/May-2014-Cap-and-Trade-GHG-Allowance-Auction-Details-Released",
    "url": "/news/May-2014-Cap-and-Trade-GHG-Allowance-Auction-Details-Released",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2015 Air Emissions Inventory Forms Now Online",
    "apiurl": "/restapi/customnewscontentlvl2/news/2015-Air-Emissions-Inventory-Forms-Now-Online",
    "url": "/news/2015-Air-Emissions-Inventory-Forms-Now-Online",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EH&S Employment Opportunities in a Down Market",
    "apiurl": "/restapi/customnewscontentlvl2/news/EH-S-Employment-Opportunities-in-a-Down-Market",
    "url": "/news/EH-S-Employment-Opportunities-in-a-Down-Market",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NC Air Toxics Reform",
    "apiurl": "/restapi/customnewscontentlvl2/news/NC-Air-Toxics-Reform",
    "url": "/news/NC-Air-Toxics-Reform",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Issues Final Decision to Deny OTR Expansion Petition-Rhode Island",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Issues-Final-Decision-to-Deny-OTR-Expansion-Petition-Rhode-Island",
    "url": "/news/EPA-Issues-Final-Decision-to-Deny-OTR-Expansion-Petition-Rhode-Island",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Maricopa County Proposed Updates to Surface Coating Operation Regulations (Rule 336)",
    "apiurl": "/restapi/customnewscontentlvl2/news/maricopa-county-proposed-updates-to-surface-coating-operation-regulations-(rule-336)",
    "url": "/news/maricopa-county-proposed-updates-to-surface-coating-operation-regulations-(rule-336)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Maricopa County Proposed Updates to Surface Coating Operation Regulations (Rule 336)",
    "apiurl": "/restapi/customnewscontentlvl2/news/maricopa-county-proposed-updates-to-surface-coating-operation-regulations-(rule-336)",
    "url": "/states/arizona/maricopa-county-proposed-updates-to-surface-coating-operation-regulations-rule-336",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Revisions to the Guideline on Air Quality Models",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Revisions-to-the-Guideline-on-Air-Quality-Models",
    "url": "/news/Proposed-Revisions-to-the-Guideline-on-Air-Quality-Models",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NHDES publishes final adopted amendments to Env-A 500",
    "apiurl": "/restapi/customnewscontentlvl2/news/NHDES-publishes-final-adopted-amendments-to-Env-A-500",
    "url": "/news/NHDES-publishes-final-adopted-amendments-to-Env-A-500",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Maryland's Marcellus Shale Safe Drilling Initiative",
    "apiurl": "/restapi/customnewscontentlvl2/news/Maryland's-Marcellus-Shale-Safe-Drilling-Initiative",
    "url": "/news/Maryland's-Marcellus-Shale-Safe-Drilling-Initiative",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Tennessee Annual Reporting Reminders",
    "apiurl": "/restapi/customnewscontentlvl2/news/Tennessee-Annual-Reporting-Reminders",
    "url": "/news/Tennessee-Annual-Reporting-Reminders",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Upcoming Reporting Requirements for Indiana Facilities-Indiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/Upcoming-Reporting-Requirements-for-Indiana-Facilities-Indiana",
    "url": "/news/Upcoming-Reporting-Requirements-for-Indiana-Facilities-Indiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Four Decades and  Growing Strong",
    "apiurl": "/restapi/customnewscontentlvl2/news/Four-Decades-and-Growing-Strong",
    "url": "/news/Four-Decades-and-Growing-Strong",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Amendments to Wastewater System Discharge Standards",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-Amendments-to-Wastewater-System-Discharge-Standards",
    "url": "/news/Final-Amendments-to-Wastewater-System-Discharge-Standards",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes to Approve MCAQD's PM10 Five Percent Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-to-Approve-MCAQD's-PM10-Five-Percent-Plan-",
    "url": "/news/EPA-Proposes-to-Approve-MCAQD's-PM10-Five-Percent-Plan-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Public Notice Update-Indiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/Public-Notice-Update-Indiana",
    "url": "/news/Public-Notice-Update-Indiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "VA DEQ Publishes Final NOx SIP Call Rule-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/VA-DEQ-Publishes-Final-NOx-SIP-Call-Rule-Virginia",
    "url": "/news/VA-DEQ-Publishes-Final-NOx-SIP-Call-Rule-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Takes Additional Steps Towards Greenhouse Gas Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Takes-",
    "url": "/news/EPA-Takes-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Federal Regulatory Update January 2013",
    "apiurl": "/restapi/customnewscontentlvl2/news/Federal-Regulatory-Update-January-2013",
    "url": "/news/Federal-Regulatory-Update-January-2013",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "North Carolina Not to Proceed with NC Greenhouse Gas Emissions Inventory Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/North-Carolina-Not-to-Proceed-with-NC-Greenhouse-Gas-Emissions-Inventory-Rule",
    "url": "/news/North-Carolina-Not-to-Proceed-with-NC-Greenhouse-Gas-Emissions-Inventory-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revised Emission Inventory Reporting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revised-Emission-Inventory-Reporting",
    "url": "/news/Revised-Emission-Inventory-Reporting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Permit By Rule for Small Boilers at CAAPP Sources-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-Permit-By-Rule-for-Small-Boilers-at-CAAPP-Sources-Illinois",
    "url": "/news/Final-Permit-By-Rule-for-Small-Boilers-at-CAAPP-Sources-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEP Releases Draft Baghouse Testing Requirements Determination Guidance Document-Nevada",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEP-Releases-Draft-Baghouse-Testing-Requirements-Determination-Guidance-Document-Nevada",
    "url": "/news/NDEP-Releases-Draft-Baghouse-Testing-Requirements-Determination-Guidance-Document-Nevada",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDEM Issues Draft Permit Fix-Up Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDEM-Issues-Draft-Permit-Fix-Up-Rule-",
    "url": "/news/IDEM-Issues-Draft-Permit-Fix-Up-Rule-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "North Dakota Regional Haze SIP Public Meeting to be Held",
    "apiurl": "/restapi/customnewscontentlvl2/news/North-Dakota-Regional-Haze-SIP-Public-Meeting-to-be-Held",
    "url": "/news/North-Dakota-Regional-Haze-SIP-Public-Meeting-to-be-Held",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LRAPA Identifies Facilities to Review under New Cleaner Air Oregon Rules-Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/LRAPA-Identifies-Facilities-to-Review-under-New-Cleaner-Air-Oregon-Rules-Oregon",
    "url": "/news/LRAPA-Identifies-Facilities-to-Review-under-New-Cleaner-Air-Oregon-Rules-Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Revises Definition of Solid Waste",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Revises-Definition-of-Solid-Waste",
    "url": "/news/EPA-Revises-Definition-of-Solid-Waste",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Stakeholder Meeting for Carbon Pollution Standards",
    "apiurl": "/restapi/customnewscontentlvl2/news/Stakeholder-Meeting-for-Carbon-Pollution-Standards",
    "url": "/news/Stakeholder-Meeting-for-Carbon-Pollution-Standards",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Mercury Emissions Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Mercury-Emissions-Rule",
    "url": "/news/Mercury-Emissions-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Issues Final 1-Hour NO2 NAAQS Area Designations",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Issues-Final-1-Hour-NO2-NAAQS-Area-Designations",
    "url": "/news/EPA-Issues-Final-1-Hour-NO2-NAAQS-Area-Designations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Introduction of SLEIS to KDHE Workshop Participants",
    "apiurl": "/restapi/customnewscontentlvl2/news/Introduction-of-SLEIS-to-KDHE-Workshop-Participants",
    "url": "/news/Introduction-of-SLEIS-to-KDHE-Workshop-Participants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Extends Comment Deadline for Proposed Cement Plant Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Extends-Comment-Deadline-for-Proposed-Cement-Plant-Rules",
    "url": "/news/EPA-Extends-Comment-Deadline-for-Proposed-Cement-Plant-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Raising the Bar on Sustainability Reporting in the Oil and Gas Industry",
    "apiurl": "/restapi/customnewscontentlvl2/news/Raising-the-Bar-on-Sustainability-Reporting-in-the-Oil-and-Gas-Industry-",
    "url": "/news/Raising-the-Bar-on-Sustainability-Reporting-in-the-Oil-and-Gas-Industry-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Complimentary Luncheons - Iowa Regulatory Updates-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Complimentary-Luncheons---Iowa-Regulatory-Updates-Iowa",
    "url": "/news/Complimentary-Luncheons---Iowa-Regulatory-Updates-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ambient Air Quality Objectives in Alberta-Alberta",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ambient-Air-Quality-Objectives-in-Alberta-Alberta",
    "url": "/news/Ambient-Air-Quality-Objectives-in-Alberta-Alberta",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Staff Spotlight: Atmospheric Chemist Addresses  California Air Quality Issues",
    "apiurl": "/restapi/customnewscontentlvl2/news/Staff-Spotlight-Atmospheric-Chemist-Addresses-California-Air-Quality-Issues",
    "url": "/news/Staff-Spotlight-Atmospheric-Chemist-Addresses-California-Air-Quality-Issues",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CAPCA Celebrates Their 45th Anniversary in Asheville",
    "apiurl": "/restapi/customnewscontentlvl2/news/CAPCA-Celebrates-Their-45th-Anniversary-in-Asheville",
    "url": "/news/CAPCA-Celebrates-Their-45th-Anniversary-in-Asheville",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revised TRI Reporting Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revised-TRI-Reporting-Requirements",
    "url": "/news/Revised-TRI-Reporting-Requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Upcoming Changes to ADEQ General Permit for Concrete Batching Plant",
    "apiurl": "/restapi/customnewscontentlvl2/news/Upcoming-Changes-to-ADEQ-General-Permit-for-Concrete-Batching-Plant",
    "url": "/news/Upcoming-Changes-to-ADEQ-General-Permit-for-Concrete-Batching-Plant",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Emission Standards for Turbine Powered Aircraft",
    "apiurl": "/restapi/customnewscontentlvl2/news/Emission-Standards-for-Turbine-Powered-Aircraft",
    "url": "/news/Emission-Standards-for-Turbine-Powered-Aircraft",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Title V Permit Fees",
    "apiurl": "/restapi/customnewscontentlvl2/news/Title-V-Permit-Fees",
    "url": "/news/Title-V-Permit-Fees",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "July 31, 2014 RMP RFI Highlights",
    "apiurl": "/restapi/customnewscontentlvl2/news/July-31-2014-RMP-RFI-Highlights",
    "url": "/news/July-31-2014-RMP-RFI-Highlights",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revisions to Industrial Solvent Cleaning Regulation for Chicago and Metro-East Areas Finalized",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revisions-to-Industrial-Solvent-Cleaning-Regulation-for-Chicago-and-Metro-East-Areas-Finalized",
    "url": "/news/Revisions-to-Industrial-Solvent-Cleaning-Regulation-for-Chicago-and-Metro-East-Areas-Finalized",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Georgia EPD GHG (Part 70) Application Supplement with Title V Application",
    "apiurl": "/restapi/customnewscontentlvl2/news/Georgia-EP",
    "url": "/news/Georgia-EP",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Earth Day Reflections from Team Trinity",
    "apiurl": "/restapi/customnewscontentlvl2/news/earth-day-reflections-from-team-trinity",
    "url": "/news/earth-day-reflections-from-team-trinity",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Publicly Available Tool Reports on Different Types of Pollution",
    "apiurl": "/restapi/customnewscontentlvl2/news/Publicly-Available-Tool-Reports-on-Different-Types-of-Pollution",
    "url": "/news/Publicly-Available-Tool-Reports-on-Different-Types-of-Pollution",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Need a Universal Waste Cheat Sheet",
    "apiurl": "/restapi/customnewscontentlvl2/news/Need-a-Universal-Waste-Cheat-Sheet",
    "url": "/news/Need-a-Universal-Waste-Cheat-Sheet",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Interim Approach to Applying the U.S. EPA Audit Policy to New Owners",
    "apiurl": "/restapi/customnewscontentlvl2/news/Interim-Ap",
    "url": "/news/Interim-Ap",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes “Franken-MACT” for Utilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-Franken-MACT-for-Utilities",
    "url": "/news/EPA-Proposes-Franken-MACT-for-Utilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPD Releases GHG Implementation Policy Following Recent Supreme Court Decision",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPD-Releas",
    "url": "/news/EPD-Releas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Comment Period Closes on Proposed Regulation to Cut Carbon Dioxide from Electric Power Facilities-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Comment-Period-Closes-on-Proposed-Regulation-to-Cut-Carbon-Dioxide-from-Electric-Power-Facilities-Virginia",
    "url": "/news/Comment-Period-Closes-on-Proposed-Regulation-to-Cut-Carbon-Dioxide-from-Electric-Power-Facilities-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "HFC Prohibition Rule in Effect in Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/hfc-prohibition-rule-finalized---310-cmr-7-76",
    "url": "/news/hfc-prohibition-rule-finalized---310-cmr-7-76",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "HFC Prohibition Rule in Effect in Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/hfc-prohibition-rule-finalized---310-cmr-7-76",
    "url": "/news/hfc-prohibition-rule-in-effect-in-massachusetts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "HFC Prohibition Rule in Effect in Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/hfc-prohibition-rule-finalized---310-cmr-7-76",
    "url": "/news/hfc-prohibition-rule-finalized-310-cmr-7-76",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Initiates Reconsideration of 2008 Ozone NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Initiates-Reconsideration-of-2008-Ozone-NAAQS",
    "url": "/news/EPA-Initiates-Reconsideration-of-2008-Ozone-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Further Revisions to the Definition of Solid Waste Rule-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Further-Revisions-to-the-Definition-of-Solid-Waste-Rule-Illinois",
    "url": "/news/Further-Revisions-to-the-Definition-of-Solid-Waste-Rule-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on 2008 Lead Standards for Chicago and Granite City Areas-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-2008-Lead-Standards-for-Chicago-and-Granite-City-Areas-Illinois",
    "url": "/news/Update-on-2008-Lead-Standards-for-Chicago-and-Granite-City-Areas-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Exemption and Recordkeeping Updates to SC NOx Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/exemption-and-recordkeeping-updates-to-sc-nox-standard",
    "url": "/news/exemption-and-recordkeeping-updates-to-sc-nox-standard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Exemption and Recordkeeping Updates to SC NOx Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/exemption-and-recordkeeping-updates-to-sc-nox-standard",
    "url": "/state/exemption-and-recordkeeping-updates-to-sc-nox-standard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Midwest Environmental Compliance Conference April 23-24-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/Midwest-Environmental-Compliance-Conference-April-23-24-Nebraska",
    "url": "/news/Midwest-Environmental-Compliance-Conference-April-23-24-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Progress Report on Fracking Study",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Progress-Report-on-Fracking-Study",
    "url": "/news/EPA-Progress-Report-on-Fracking-Study",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Missouri Air Permitting Rule Updates-Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/Missouri-Air-Permitting-Rule-Updates-Missouri",
    "url": "/news/Missouri-Air-Permitting-Rule-Updates-Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to NDEP's Proposed Significant Fee Schedule Changes and Draft Administrative Permit Renewal FAQ Document-Nevada",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-to-NDEP's-Proposed-Significant-Fee-Schedule-Changes-and-Draft-Administrative-Permit-Renewal-FAQ-Document-Nevada",
    "url": "/news/Updates-to-NDEP's-Proposed-Significant-Fee-Schedule-Changes-and-Draft-Administrative-Permit-Renewal-FAQ-Document-Nevada",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA to Propose Hourly NO2 Ambient Air Quality Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-to-Pro",
    "url": "/news/EPA-to-Pro",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final CISWI Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-CISWI-Rule-",
    "url": "/news/Final-CISWI-Rule-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Upcoming Annual Air Quality and EPCRA Reporting",
    "apiurl": "/restapi/customnewscontentlvl2/news/upcoming-annual-air-quality-and-epcra-reporting",
    "url": "/news/upcoming-annual-air-quality-and-epcra-reporting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes Revisions to RICE MACT and NSPS Rules Affecting Stationary Engines",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Propos",
    "url": "/news/EPA-Propos",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "General Air Permit for Oil & Gas Well-Site Production Operations Finalized",
    "apiurl": "/restapi/customnewscontentlvl2/news/General-Air-Permit-for-Oil-Gas-Well-Site-Production-Operations-Finalized",
    "url": "/news/General-Air-Permit-for-Oil-Gas-Well-Site-Production-Operations-Finalized",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "OSHA Process Safety Management - Potential Updates on the Horizon",
    "apiurl": "/restapi/customnewscontentlvl2/news/OSHA-Process-Safety-Management---Potential-Updates-on-the-Horizon",
    "url": "/news/OSHA-Process-Safety-Management---Potential-Updates-on-the-Horizon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Manufacturers and Importers Required to Submit TSCA CDR Reports in 2016-Tennessee",
    "apiurl": "/restapi/customnewscontentlvl2/news/Manufacturers-and-Importers-Required-to-Submit-TSCA-CDR-Reports-in-2016-Tennessee",
    "url": "/news/Manufacturers-and-Importers-Required-to-Submit-TSCA-CDR-Reports-in-2016-Tennessee",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NSPS IIII Engines Required to Use 15 ppm Sulfur Fuel by October 1, 2010",
    "apiurl": "/restapi/customnewscontentlvl2/news/NSPS-IIII-Engines-Required-to-Use-15-ppm-Sulfur-Fuel-by-October-1-2010-",
    "url": "/news/NSPS-IIII-Engines-Required-to-Use-15-ppm-Sulfur-Fuel-by-October-1-2010-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Extension of CAP Permit Option Comment Period and Sample CAP Now Available for Review",
    "apiurl": "/restapi/customnewscontentlvl2/news/Extension-of-CAP-Permit-Option-Comment-Period-and-Sample-CAP-Now-Available-for-Review",
    "url": "/news/Extension-of-CAP-Permit-Option-Comment-Period-and-Sample-CAP-Now-Available-for-Review",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Greenhouse Gas Cap and Trade in Ontario",
    "apiurl": "/restapi/customnewscontentlvl2/news/Greenhouse-Gas-Cap-and-Trade-in-Ontario",
    "url": "/news/Greenhouse-Gas-Cap-and-Trade-in-Ontario",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on Illinois’ Metro-East Area Ozone NAAQS Designations-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-Illinois-Metro-East-Area-Ozone-NAAQS-Designations-Illinois",
    "url": "/news/Update-on-Illinois-Metro-East-Area-Ozone-NAAQS-Designations-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "A&WMA Midwest Section Environmental Technical Conference, September 30 - October 1, 2019-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/A-WMA-Midwest-Section-Environmental-Technical-Conference-September-30---October-1-2019-Kansas",
    "url": "/news/A-WMA-Midwest-Section-Environmental-Technical-Conference-September-30---October-1-2019-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "AVAQMD Proposed Adoption of the 2015 8-Hour RACT SIP Analysis",
    "apiurl": "/restapi/customnewscontentlvl2/news/AVAQMD-Proposed-Adoption-of-the-2015-8-Hour-RACT-SIP-Analysis",
    "url": "/news/AVAQMD-Proposed-Adoption-of-the-2015-8-Hour-RACT-SIP-Analysis",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Adhesive and Sealant Use in Maryland: A Review of COMAR 26.11.35",
    "apiurl": "/restapi/customnewscontentlvl2/news/Adhesive-and-Sealant-Use-in-Maryland-A-Review-of-COMAR-26-11-35",
    "url": "/news/Adhesive-and-Sealant-Use-in-Maryland-A-Review-of-COMAR-26-11-35",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "WRAP Ozone Studies Prepare for 2018 Regional Haze SIP",
    "apiurl": "/restapi/customnewscontentlvl2/news/WRAP-Ozone-Studies-Prepare-for-2018-Regional-Haze-SIP",
    "url": "/news/WRAP-Ozone-Studies-Prepare-for-2018-Regional-Haze-SIP",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Clean Cars Nevada Rulemaking Process Underway",
    "apiurl": "/restapi/customnewscontentlvl2/news/clean-cars-nevada-rulemaking-process-underway",
    "url": "/news/clean-cars-nevada-rulemaking-process-underway",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Clean Cars Nevada Rulemaking Process Underway",
    "apiurl": "/restapi/customnewscontentlvl2/news/clean-cars-nevada-rulemaking-process-underway",
    "url": "/www.trinityconsultants.com/clean-cars-nevada-rulemaking-process-underway",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "RIDEM Proposes a Number of Revisions to Air Pollution Control Regulations-Rhode Island",
    "apiurl": "/restapi/customnewscontentlvl2/news/RIDEM-Proposes-a-Number-of-Revisions-to-Air-Pollution-Control-Regulations-Rhode-Island",
    "url": "/news/RIDEM-Proposes-a-Number-of-Revisions-to-Air-Pollution-Control-Regulations-Rhode-Island",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Certification Deadline for Industrial Solvent Cleaning Operations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Certification-Deadline-for-Industrial-Solvent-Cleaning-Operations",
    "url": "/news/Certification-Deadline-for-Industrial-Solvent-Cleaning-Operations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to Illinois Air Pollution Site Fee-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-to-Illinois-Air-Pollution-Site-Fee-Illinois",
    "url": "/news/Updates-to-Illinois-Air-Pollution-Site-Fee-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes New Air Quality Rules for the Oil & Natural Gas Industry",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-New-Air-Quality-Rules-for-the-Oil-Natural-Gas-Industry",
    "url": "/news/EPA-Proposes-New-Air-Quality-Rules-for-the-Oil-Natural-Gas-Industry",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Upcoming Changes to Maryland's Opacity Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Upcoming-Changes-to-Maryland's-Opacity-Regulations",
    "url": "/news/Upcoming-Changes-to-Maryland's-Opacity-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Quality Permits: Emission Summary Dispersion Modelling (ESDM) Report Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Permits-Emission-Summary-Dispersion-Modelling-(ESDM)-Report-Updates",
    "url": "/news/Air-Quality-Permits-Emission-Summary-Dispersion-Modelling-(ESDM)-Report-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NMED Releases 20.2.35 NMAC Clarification",
    "apiurl": "/restapi/customnewscontentlvl2/news/NMED-Releases-20-2-35-NMAC-Clarification",
    "url": "/news/NMED-Releases-20-2-35-NMAC-Clarification",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Guidance Document for Boiler Permitting Released by DEQ-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Guidance-Document-for-Boiler-Permitting-Released-by-DEQ-Virginia",
    "url": "/news/Guidance-Document-for-Boiler-Permitting-Released-by-DEQ-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Maryland Regulations to Control Sources of Volatile Organic Compounds",
    "apiurl": "/restapi/customnewscontentlvl2/news/Maryland-Regulations-to-Control-Sources-of-Volatile-Organic-Compounds",
    "url": "/news/Maryland-Regulations-to-Control-Sources-of-Volatile-Organic-Compounds",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Pre-2019 Winter Ozone Season Open House-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Pre-2019-Winter-Ozone-Season-Open-House-Wyoming",
    "url": "/news/Pre-2019-Winter-Ozone-Season-Open-House-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA Proposes Implementation Rule for PM2.5 Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-Proposes-Implementation-Rule-for-PM2-5-Standard",
    "url": "/news/USEPA-Proposes-Implementation-Rule-for-PM2-5-Standard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revised Annual Air Quality Emission Fees",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revised-Annual-Air-Quality-Emission-Fees",
    "url": "/news/Revised-Annual-Air-Quality-Emission-Fees",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "City of Albuquerque Permit Application Policy Changes",
    "apiurl": "/restapi/customnewscontentlvl2/news/City-of-Albuquerque-Permit-Application-Policy-Changes",
    "url": "/news/City-of-Albuquerque-Permit-Application-Policy-Changes",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NOX RACT Workgroups",
    "apiurl": "/restapi/customnewscontentlvl2/news/NOX-RACT-W",
    "url": "/news/NOX-RACT-W",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Coast Air Quality Management District – Proposed Amended Rule 1147-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Coast-Air-Quality-Management-District-Proposed-Amended-Rule-1147-California",
    "url": "/news/South-Coast-Air-Quality-Management-District-Proposed-Amended-Rule-1147-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Regional Haze Rule Second Planning Period-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Regional-Haze-Rule-Second-Planning-Period-Colorado",
    "url": "/news/Regional-Haze-Rule-Second-Planning-Period-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GOADS-2014: Data Collection Reminder",
    "apiurl": "/restapi/customnewscontentlvl2/news/GOADS-2014-Data-Collection-Reminder",
    "url": "/news/GOADS-2014-Data-Collection-Reminder",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Quality Rule Changes in Progress-Oklahoma",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Rule-Changes-in-Progress-Oklahoma",
    "url": "/news/Air-Quality-Rule-Changes-in-Progress-Oklahoma",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Recapitalization Positions Trinity Consultants for Future Growth and Stability",
    "apiurl": "/restapi/customnewscontentlvl2/news/Recapitalization-Positions-Trinity-Consultants-for-Future-Growth-and-Stability",
    "url": "/news/Recapitalization-Positions-Trinity-Consultants-for-Future-Growth-and-Stability",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Greenhouse Gases Regulatory Proposal",
    "apiurl": "/restapi/customnewscontentlvl2/news/Greenhouse-Gases-Regulatory-Proposal",
    "url": "/news/Greenhouse-Gases-Regulatory-Proposal",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Schedule of Air Quality Fees Proposal",
    "apiurl": "/restapi/customnewscontentlvl2/news/Schedule-of-Air-Quality-Fees-Proposal",
    "url": "/news/Schedule-of-Air-Quality-Fees-Proposal",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ's Designation Recommendations for the 2015 Ozone NAAQS - 3 New Counties Added",
    "apiurl": "/restapi/customnewscontentlvl2/news/TCEQ's-Designation-Recommendations-for-the-2015-Ozone-NAAQS---3-New-Counties-Added",
    "url": "/news/TCEQ's-Designation-Recommendations-for-the-2015-Ozone-NAAQS---3-New-Counties-Added",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "A Summary of Proposed Updates to Ontario Guidance Documents (O. Reg. 419/05)",
    "apiurl": "/restapi/customnewscontentlvl2/news/A-Summary-of-Proposed-Updates-to-Ontario-Guidance-Documents-(O-Reg-419-05)",
    "url": "/news/A-Summary-of-Proposed-Updates-to-Ontario-Guidance-Documents-(O-Reg-419-05)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants to Present Webinar on Costly Utility Regulation",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-to-Present-Webinar-on-Costly-Utility-Regulation",
    "url": "/news/Trinity-Consultants-to-Present-Webinar-on-Costly-Utility-Regulation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Delaware AES Deadline To Be Extended",
    "apiurl": "/restapi/customnewscontentlvl2/news/Delaware-AES-Deadline-To-Be-Extended",
    "url": "/news/Delaware-AES-Deadline-To-Be-Extended",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2020 Annual Ongoing SO2 Data Requirements Rule Report",
    "apiurl": "/restapi/customnewscontentlvl2/news/2020-annual-ongoing-so2-data-requirements-rule-report",
    "url": "/news/2020-annual-ongoing-so2-data-requirements-rule-report",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Greenhouse Gases (GHGs) Reporting for 2019",
    "apiurl": "/restapi/customnewscontentlvl2/news/greenhouse-gases-(ghgs)-reporting-for-2019",
    "url": "/news/greenhouse-gases-(ghgs)-reporting-for-2019",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Boiler MACT Delayed",
    "apiurl": "/restapi/customnewscontentlvl2/news/Boiler-MACT-Delayed",
    "url": "/news/Boiler-MACT-Delayed",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "WorkingBuildings Team Ensures a Safe Laboratory of Infectious Diseases for University",
    "apiurl": "/restapi/customnewscontentlvl2/news/working-buildings-team-ensures-a-safe-laboratory-of-infectious-diseases-for-university",
    "url": "/news/working-buildings-team-ensures-a-safe-laboratory-of-infectious-diseases-for-university",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "WorkingBuildings Team Ensures a Safe Laboratory of Infectious Diseases for University",
    "apiurl": "/restapi/customnewscontentlvl2/news/working-buildings-team-ensures-a-safe-laboratory-of-infectious-diseases-for-university",
    "url": "/news/company/working-buildings-team-ensures-a-safe-laboratory-of-infectious-diseases-for-university",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "WorkingBuildings Team Ensures a Safe Laboratory of Infectious Diseases for University",
    "apiurl": "/restapi/customnewscontentlvl2/news/working-buildings-team-ensures-a-safe-laboratory-of-infectious-diseases-for-university",
    "url": "/federal/working-buildings-team-ensures-a-safe-laboratory-of-infectious-diseases-for-university",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New NPD Government's 2017 Budget Update-British Columbia",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-NPD-Government's-2017-Budget-Update-British-Columbia",
    "url": "/news/New-NPD-Government's-2017-Budget-Update-British-Columbia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NC Air Toxics - Do I need to model anymore?",
    "apiurl": "/restapi/customnewscontentlvl2/news/NC-Air-Toxics---Do-I-need-to-model-anymore-",
    "url": "/news/NC-Air-Toxics---Do-I-need-to-model-anymore-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "‘Assessing Risk and Controlling Exposure to Potent Compounds During Pharmaceutical Packaging’ article by John Farris, Tablets & Capules May 8, 2010",
    "apiurl": "/restapi/customnewscontentlvl2/news/-Assessing-Risk-and-Controlling-Exposure-to-Potent-Compounds-During-Pharmaceutical-Packaging-article-by-John-Farris-Tablets-Capules-May-8-2010",
    "url": "/news/-Assessing-Risk-and-Controlling-Exposure-to-Potent-Compounds-During-Pharmaceutical-Packaging-article-by-John-Farris-Tablets-Capules-May-8-2010",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Designates Northern Kentucky Counties Nonattainment for Ozone NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Design",
    "url": "/news/EPA-Design",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GHG Regulation under the Clean Air Act – Recent Developments",
    "apiurl": "/restapi/customnewscontentlvl2/news/GHG-Regulation-under-the-Clean-Air-Act-Recent-Developments",
    "url": "/news/GHG-Regulation-under-the-Clean-Air-Act-Recent-Developments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oregon DEQ Proposed General Permits-Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oregon-DEQ-Proposed-General-Permits-Oregon",
    "url": "/news/Oregon-DEQ-Proposed-General-Permits-Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on Ozone Designations in Illinois-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-Ozone-Designations-in-Illinois-Illinois",
    "url": "/news/Update-on-Ozone-Designations-in-Illinois-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Provides Modeling Support for Chemical Munitions Storage and Disposal at Pine Bluff Arsenal",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Provides-Modeling-Support-for-Chemical-Munitions-Storage-and-Disposal-at-Pine-Bluff-Arsenal",
    "url": "/news/Trinity-Provides-Modeling-Support-for-Chemical-Munitions-Storage-and-Disposal-at-Pine-Bluff-Arsenal",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2014 Emissions Inventory",
    "apiurl": "/restapi/customnewscontentlvl2/news/2014-Emissions-Inventory",
    "url": "/news/2014-Emissions-Inventory",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "UDAQ’s Progression on PM2.5 SIP Development",
    "apiurl": "/restapi/customnewscontentlvl2/news/UDAQ-s-Progression-on-PM2-5-SIP-Development",
    "url": "/news/UDAQ-s-Progression-on-PM2-5-SIP-Development",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Lower VOC Standards for Architectural and Industrial Maintenance Coatings",
    "apiurl": "/restapi/customnewscontentlvl2/news/Lower-VOC-Standards-for-Architectural-and-Industrial-Maintenance-Coatings",
    "url": "/news/Lower-VOC-Standards-for-Architectural-and-Industrial-Maintenance-Coatings",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "UDAQ Proposes PM10 SIP Maintenance Plans",
    "apiurl": "/restapi/customnewscontentlvl2/news/UDAQ-Proposes-PM10-SIP-Maintenance-Plans",
    "url": "/news/UDAQ-Proposes-PM10-SIP-Maintenance-Plans",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MACT Wastewater Regulations that Overlap with the BWON",
    "apiurl": "/restapi/customnewscontentlvl2/news/mact-wastewater-regulations-that-overlap-with-the-bwon",
    "url": "/news/mact-wastewater-regulations-that-overlap-with-the-bwon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Public Hearing for Utah Air Permitting and Emission Inventory Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/public-hearing-for-utah-air-permitting-and-emission-inventory-requirements",
    "url": "/news/public-hearing-for-utah-air-permitting-and-emission-inventory-requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PM2.5 Guidance Documents Finalized",
    "apiurl": "/restapi/customnewscontentlvl2/news/PM2-5-Guidance-Documents-Finalized",
    "url": "/news/PM2-5-Guidance-Documents-Finalized",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Vision 2020 - Centralized Data for Environmental Reporting",
    "apiurl": "/restapi/customnewscontentlvl2/news/vision-2020---centralized-data-for-environmental-reporting",
    "url": "/news/vision-2020---centralized-data-for-environmental-reporting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Modeling Tip: Disabling Onsite and Offsite Receptors in BREEZE AERMOD",
    "apiurl": "/restapi/customnewscontentlvl2/news/Modeling-Tip-Disabling-Onsite-and-Offsite-Receptors-in-BREEZE-AERMOD",
    "url": "/news/Modeling-Tip-Disabling-Onsite-and-Offsite-Receptors-in-BREEZE-AERMOD",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Request Input on Paved Road Dust Controls",
    "apiurl": "/restapi/customnewscontentlvl2/news/adeq-request-input-on-paved-road-dust-controls",
    "url": "/news/adeq-request-input-on-paved-road-dust-controls",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Request Input on Paved Road Dust Controls",
    "apiurl": "/restapi/customnewscontentlvl2/news/adeq-request-input-on-paved-road-dust-controls",
    "url": "/states/arizona/adeq-request-input-on-paved-road-dust-controls",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "General Permit Renewals for Hot Mix Asphalt Plants and Crushing & Screening Plants Finalized",
    "apiurl": "/restapi/customnewscontentlvl2/news/General-Permit-Renewals-for-Hot-Mix-Asphalt-Plants-and-Crushing-Screening-Plants-Finalized",
    "url": "/news/General-Permit-Renewals-for-Hot-Mix-Asphalt-Plants-and-Crushing-Screening-Plants-Finalized",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Permit Waivers and Air Quality Nofiications for Certain Source Categories-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Permit-Waivers-and-Air-Quality-Nofiications-for-Certain-Source-Categories-New-Mexico",
    "url": "/news/Proposed-Permit-Waivers-and-Air-Quality-Nofiications-for-Certain-Source-Categories-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Latest on Chicago Area Ozone Nonattainment Redesignation from Moderate to Serious-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Latest-on-Chicago-Area-Ozone-Nonattainment-Redesignation-from-Moderate-to-Serious-Illinois",
    "url": "/news/Latest-on-Chicago-Area-Ozone-Nonattainment-Redesignation-from-Moderate-to-Serious-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GHG Emission Requirements for New On-Road Heavy-Duty Vehicle Manufacturers (Effective 1 Jan 2021)",
    "apiurl": "/restapi/customnewscontentlvl2/news/ghg-emission-requirements-for-new-on-road-heavy-duty-vehicle-manufacturers",
    "url": "/news/ghg-emission-requirements-for-new-on-road-heavy-duty-vehicle-manufacturers",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated Arizona Department of Environmental Quality Multi Sector General Permit",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updated-Arizona-Department-of-Environmental-Quality-Multi-Sector-General-Permit",
    "url": "/news/Updated-Arizona-Department-of-Environmental-Quality-Multi-Sector-General-Permit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated Arizona Department of Environmental Quality Multi Sector General Permit",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updated-Arizona-Department-of-Environmental-Quality-Multi-Sector-General-Permit",
    "url": "/states/arizona/updated-arizona-department-of-environmental-quality-multi-sector-general-permit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LDEQ Finalizes Revision to the Petition Provisions of the Part 70 Operating Permits Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/ldeq-finalizes-revision-to-the-petition-provisions-of-the-part-70-operating-permits-program",
    "url": "/news/ldeq-finalizes-revision-to-the-petition-provisions-of-the-part-70-operating-permits-program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MassDEP Proposes New Regulations to Curb Greenhouse Gas Emissions",
    "apiurl": "/restapi/customnewscontentlvl2/news/MassDEP-Proposes-New-Regulations-to-Curb-Greenhouse-Gas-Emissions",
    "url": "/news/MassDEP-Proposes-New-Regulations-to-Curb-Greenhouse-Gas-Emissions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Environmental Product Declarations - A New Framework for Communicating Environmental Responsibility",
    "apiurl": "/restapi/customnewscontentlvl2/news/Environmental-Product-Declarations---A-New-Framework-for-Communicating-Environmental-Responsibility",
    "url": "/news/Environmental-Product-Declarations---A-New-Framework-for-Communicating-Environmental-Responsibility",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Monitoring & Reporting Requirements for Mercury Emissions Proposed in Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Monitoring-Reporting-Requirements-for-Mercury-Emissions-Proposed-in-Massachusetts",
    "url": "/news/New-Monitoring-Reporting-Requirements-for-Mercury-Emissions-Proposed-in-Massachusetts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Delaware Proposes Amendment to Voluntary Demand Reduction Requirements for Control of Stationary Generator Emissions",
    "apiurl": "/restapi/customnewscontentlvl2/news/Delaware-P",
    "url": "/news/Delaware-P",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to the Toxics Reporting Inventory (TRI) Reporting RequirementsIdaho-Idaho",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-to-the-Toxics-Reporting-Inventory-(TRI)-Reporting-RequirementsIdaho-Idaho",
    "url": "/news/Updates-to-the-Toxics-Reporting-Inventory-(TRI)-Reporting-RequirementsIdaho-Idaho",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE ExDAM 8.4 Accelerates Explosion Modeling Capabilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-ExDAM-8-4-Accelerates-Explosion-Modeling-Capabilities",
    "url": "/news/BREEZE-ExDAM-8-4-Accelerates-Explosion-Modeling-Capabilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "40 CFR Part 81: Additional Air Quality Designations for the 2015 Ozone National Ambient Air Quality Standards-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/40-CFR-Part-81-Additional-Air-Quality-Designations-for-the-2015-Ozone-National-Ambient-Air-Quality-Standards-Texas",
    "url": "/news/40-CFR-Part-81-Additional-Air-Quality-Designations-for-the-2015-Ozone-National-Ambient-Air-Quality-Standards-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Plans to Disapprove Three Texas Air Permitting Programs",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Plans-to-Disapprove-Three-Texas-Air-Permitting-Programs",
    "url": "/news/EPA-Plans-to-Disapprove-Three-Texas-Air-Permitting-Programs",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Revisions to Regulation 7-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Revisions-to-Regulation-7-Colorado",
    "url": "/news/Proposed-Revisions-to-Regulation-7-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "San Diego APCD Proposed Amendments to NSR Rules 20.1, 20.2, 20.3, and 20.4",
    "apiurl": "/restapi/customnewscontentlvl2/news/San-Diego-APCD-Proposed-Amendments-to-NSR-Rules-20-1-20-2-20-3-and-20-4",
    "url": "/news/San-Diego-APCD-Proposed-Amendments-to-NSR-Rules-20-1-20-2-20-3-and-20-4",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MCAQD Proposed RACT Certification of Rule 348 is Good News for Aerospace Manufacturing and Rework Operations",
    "apiurl": "/restapi/customnewscontentlvl2/news/mcaqd-proposed-ract-certification-of-rule-348-is-good-news-for-aerospace-manufacturing-and-rework-operations",
    "url": "/news/mcaqd-proposed-ract-certification-of-rule-348-is-good-news-for-aerospace-manufacturing-and-rework-operations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDE Proposes to Allow Interprecursor Trading for NOx and VOC-Maryland",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDE-Proposes-to-Allow-Interprecursor-Trading-for-NOx-and-VOC-Maryland",
    "url": "/news/MDE-Proposes-to-Allow-Interprecursor-Trading-for-NOx-and-VOC-Maryland",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Welding Could Require Permitting Statewide - San Diego Data Puts Air Permitting Exemptions at Risk",
    "apiurl": "/restapi/customnewscontentlvl2/news/welding-could-require-permitting-statewide-san-diego-data-puts-air-permitting-exemptions-at-risk",
    "url": "/news/welding-could-require-permitting-statewide-san-diego-data-puts-air-permitting-exemptions-at-risk",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Welding Could Require Permitting Statewide - San Diego Data Puts Air Permitting Exemptions at Risk",
    "apiurl": "/restapi/customnewscontentlvl2/news/welding-could-require-permitting-statewide-san-diego-data-puts-air-permitting-exemptions-at-risk",
    "url": "/news/san-diego-apcd-data-puts-air-permitting-exemptions-at-risk---welding-may-require-permitting-statewide",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Welding Could Require Permitting Statewide - San Diego Data Puts Air Permitting Exemptions at Risk",
    "apiurl": "/restapi/customnewscontentlvl2/news/welding-could-require-permitting-statewide-san-diego-data-puts-air-permitting-exemptions-at-risk",
    "url": "/news/san-diego-apcd-data-puts-air-permitting-exemptions-at-risk-welding-may-require-permitting-statewide",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "North Dakota Reporting Reminders-North Dakota",
    "apiurl": "/restapi/customnewscontentlvl2/news/North-Dakota-Reporting-Reminders-North-Dakota",
    "url": "/news/North-Dakota-Reporting-Reminders-North-Dakota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "\"Other Information\" Guidance for Permitting Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/-Other-Information-Guidance-for-Permitting-Requirements",
    "url": "/news/-Other-Information-Guidance-for-Permitting-Requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MACT Startup, Shutdown, and Malfunction Exemption Removed",
    "apiurl": "/restapi/customnewscontentlvl2/news/MACT-Startup-Shutdown-and-Malfunction-Exemption-Removed",
    "url": "/news/MACT-Startup-Shutdown-and-Malfunction-Exemption-Removed",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Nonpoint Source Task Force Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Nonpoint-Source-Task-Force-Meeting",
    "url": "/news/Nonpoint-Source-Task-Force-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "POTW Reports and Notifications for Wastewater Discharges",
    "apiurl": "/restapi/customnewscontentlvl2/news/potw-reports-and-notifications-for-wastewater-discharges",
    "url": "/news/potw-reports-and-notifications-for-wastewater-discharges",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "POTW Reports and Notifications for Wastewater Discharges",
    "apiurl": "/restapi/customnewscontentlvl2/news/potw-reports-and-notifications-for-wastewater-discharges",
    "url": "/states/texas/potw-reports-and-notifications-for-wastewater-discharges",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDE Proposes Incorporation of Federal NSR PSD Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDE-Proposes-Incorporation-of-Federal-NSR-PSD-Program",
    "url": "/news/MDE-Proposes-Incorporation-of-Federal-NSR-PSD-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants and E5 Join Forces in Southern California",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-and-E5-Join-Forces-in-Southern-California",
    "url": "/news/Trinity-Consultants-and-E5-Join-Forces-in-Southern-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Issues GHG BACT Guidance",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Issues-GHG-BACT-Guidance",
    "url": "/news/EPA-Issues-GHG-BACT-Guidance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Fugitive Dust Emission Standards Rulemaking Petition",
    "apiurl": "/restapi/customnewscontentlvl2/news/Fugitive-Dust-Emission-Standards-Rulemaking-Petition",
    "url": "/news/Fugitive-Dust-Emission-Standards-Rulemaking-Petition",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Implementation of New EPA Rules Affecting Smaller Emissions Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/Implementation-of-New-EPA-Rules-Affecting-Smaller-Emissions-Sources",
    "url": "/news/Implementation-of-New-EPA-Rules-Affecting-Smaller-Emissions-Sources",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Rhode Island Department of Environmental Management Proposes Revisions to Air Pollution Control Regulation No. 9-Rhode Island",
    "apiurl": "/restapi/customnewscontentlvl2/news/Rhode-Island-Department-of-Environmental-Management-Proposes-Revisions-to-Air-Pollution-Control-Regulation-No-9-Rhode-Island",
    "url": "/news/Rhode-Island-Department-of-Environmental-Management-Proposes-Revisions-to-Air-Pollution-Control-Regulation-No-9-Rhode-Island",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Future of Startup, Shutdown, Malfunction Emissions in Arizona",
    "apiurl": "/restapi/customnewscontentlvl2/news/Future-of-Startup-Shutdown-Malfunction-Emissions-in-Arizona",
    "url": "/news/Future-of-Startup-Shutdown-Malfunction-Emissions-in-Arizona",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Governor Endorses 25 x 25",
    "apiurl": "/restapi/customnewscontentlvl2/news/Governor-Endorses-25-x-25",
    "url": "/news/Governor-Endorses-25-x-25",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDAQMD Changes to Rule 1160 Internal Combustion Engines-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDAQMD-Changes-to-Rule-1160-Internal-Combustion-Engines-California",
    "url": "/news/MDAQMD-Changes-to-Rule-1160-Internal-Combustion-Engines-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Changes to NOx RACT Regulations in the District",
    "apiurl": "/restapi/customnewscontentlvl2/news/proposed-changes-to-nox-ract-regulations-in-the-district",
    "url": "/news/proposed-changes-to-nox-ract-regulations-in-the-district",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Deadline Approaching for New Mexico SSM SIP Call",
    "apiurl": "/restapi/customnewscontentlvl2/news/Deadline-Approaching-for-New-Mexico-SSM-SIP-Call",
    "url": "/news/Deadline-Approaching-for-New-Mexico-SSM-SIP-Call",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Carbon Dioxide Emission Standards",
    "apiurl": "/restapi/customnewscontentlvl2/news/Carbon-Dioxide-Emission-Standards",
    "url": "/news/Carbon-Dioxide-Emission-Standards",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "6 NYCRR Part 570 - Regulation of Liquefied Natural Gas Facilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/6-NYCRR-Part-570---Regulation-of-Liquefied-Natural-Gas-Facilities",
    "url": "/news/6-NYCRR-Part-570---Regulation-of-Liquefied-Natural-Gas-Facilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Opens Birmingham, Alabama Office",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Opens-Birmingham-Alabama-Office",
    "url": "/news/Trinity-Consultants-Opens-Birmingham-Alabama-Office",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Opens Birmingham, Alabama Office",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Opens-Birmingham-Alabama-Office",
    "url": "/ehs-management/Trinity-Consultants-Opens-Birmingham-Alabama-Office",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Team Trinity Gears Up for March Madness",
    "apiurl": "/restapi/customnewscontentlvl2/news/team-trinity-gears-up-for-march-madness",
    "url": "/news/team-trinity-gears-up-for-march-madness",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Significant Proposed Rule for Aggregation of Oil and Gas Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/Significant-Proposed-Rule-for-Aggregation-of-Oil-and-Gas-Sources",
    "url": "/news/Significant-Proposed-Rule-for-Aggregation-of-Oil-and-Gas-Sources",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "California Air Resources Board – Land Use and Air Quality Technical Advisory Update-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/California-Air-Resources-Board-Land-Use-and-Air-Quality-Technical-Advisory-Update-California",
    "url": "/news/California-Air-Resources-Board-Land-Use-and-Air-Quality-Technical-Advisory-Update-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEQ's Air Division Staffing Status-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEQ's-Air-Division-Staffing-Status-Nebraska",
    "url": "/news/NDEQ's-Air-Division-Staffing-Status-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Quality Construction Permitting of Sand Processing Plants in Texas-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Construction-Permitting-of-Sand-Processing-Plants-in-Texas-Texas",
    "url": "/news/Air-Quality-Construction-Permitting-of-Sand-Processing-Plants-in-Texas-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed EGU NSPS for GHG and its Impact on Other Sectors",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-EGU-NSPS-for-GHG-and-its-Impact-on-Other-Sectors",
    "url": "/news/Proposed-EGU-NSPS-for-GHG-and-its-Impact-on-Other-Sectors",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDEM Issues Draft Statewide Degreasers Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDEM-Issues-Draft-Statewide-Degreasers-Rule",
    "url": "/news/IDEM-Issues-Draft-Statewide-Degreasers-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BWON Applicability at Chemical Plants",
    "apiurl": "/restapi/customnewscontentlvl2/news/bwon-applicability-at-chemical-plants",
    "url": "/news/bwon-applicability-at-chemical-plants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BWON Applicability at Chemical Plants",
    "apiurl": "/restapi/customnewscontentlvl2/news/bwon-applicability-at-chemical-plants",
    "url": "/federal/bwon-applicability-at-chemical-plants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New General Operating Permit (GOP-003) for the Permitting of Emergency Generators at Title V Facilities – Understanding of Potential to Emit (PTE) Determination for Emergency Generators",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-General-Operating-Permit-(GOP-003)-for-the-Permitting-of-Emergency-Generators-at-Title-V-Facilities-Understanding-of-Potential-to-Emit-(PTE)-Determination-for-Emergency-Generators",
    "url": "/news/New-General-Operating-Permit-(GOP-003)-for-the-Permitting-of-Emergency-Generators-at-Title-V-Facilities-Understanding-of-Potential-to-Emit-(PTE)-Determination-for-Emergency-Generators",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "An Update on International GHG Regulatory Programs",
    "apiurl": "/restapi/customnewscontentlvl2/news/An-Update-on-International-GHG-Regulatory-Programs",
    "url": "/news/An-Update-on-International-GHG-Regulatory-Programs",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes to GHG PSD and Title V Rules May Help Oil and Natural Gas Facilities Seeking to Expand",
    "apiurl": "/restapi/customnewscontentlvl2/news/Changes-to-GHG-PSD-and-Title-V-Rules-May-Help-Oil-and-Natural-Gas-Facilities-Seeking-to-Expand",
    "url": "/news/Changes-to-GHG-PSD-and-Title-V-Rules-May-Help-Oil-and-Natural-Gas-Facilities-Seeking-to-Expand",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ARB’s 2013 Consumer and Commercial Products Survey",
    "apiurl": "/restapi/customnewscontentlvl2/news/ARB-s-2013-Consumer-and-Commercial-Products-Survey",
    "url": "/news/ARB-s-2013-Consumer-and-Commercial-Products-Survey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Modeling Tip: Plot Your BREEZE Incident Analyst Modeling Results to Google Earth",
    "apiurl": "/restapi/customnewscontentlvl2/news/Modeling-Tip-Plot-Your-BREEZE-Incident-Analyst-Modeling-Results-to-Google-Earth-",
    "url": "/news/Modeling-Tip-Plot-Your-BREEZE-Incident-Analyst-Modeling-Results-to-Google-Earth-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA is Proposing to Approve a Revision to Missouri's SIP",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-is-Proposing-to-Approve-a-Revision-to-Missouri's-SIP",
    "url": "/news/USEPA-is-Proposing-to-Approve-a-Revision-to-Missouri's-SIP",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Using a Multimedia Approach for Environmental Reporting Consistency",
    "apiurl": "/restapi/customnewscontentlvl2/news/using-a-multimedia-approach-for-environmental-reporting-consistency",
    "url": "/news/using-a-multimedia-approach-for-environmental-reporting-consistency",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cap-and-Trade Rulemaking Proposed Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/Cap-and-Trade-Rulemaking-Proposed-Amendments",
    "url": "/news/Cap-and-Trade-Rulemaking-Proposed-Amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes to Ohio Fee Emission Reporting for RY 2016 - SCC Updates and New Validation Errors",
    "apiurl": "/restapi/customnewscontentlvl2/news/Changes-to-Ohio-Fee-Emission-Reporting-for-RY-2016---SCC-Updates-and-New-Validation-Errors",
    "url": "/news/Changes-to-Ohio-Fee-Emission-Reporting-for-RY-2016---SCC-Updates-and-New-Validation-Errors",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Table: Subpart C Data Elements Subject to August 31, 2011 Deadline",
    "apiurl": "/restapi/customnewscontentlvl2/news/Table-Subpart-C-Data-Elements-Subject-to-August-31-2011-Deadline",
    "url": "/news/Table-Subpart-C-Data-Elements-Subject-to-August-31-2011-Deadline",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Memphis & Shelby County Air Pollution Control Board Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/-Memphis-Shelby-County-Air-Pollution-Control-Board-Meeting",
    "url": "/news/-Memphis-Shelby-County-Air-Pollution-Control-Board-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Regulation 22 - Greenhouse Gas Reporting and Emission Reduction Requirements in Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Regulation-22---Greenhouse-Gas-Reporting-and-Emission-Reduction-Requirements-in-Colorado-Colorado",
    "url": "/news/Proposed-Regulation-22---Greenhouse-Gas-Reporting-and-Emission-Reduction-Requirements-in-Colorado-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Regulation 22 - Greenhouse Gas Reporting and Emission Reduction Requirements in Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Regulation-22---Greenhouse-Gas-Reporting-and-Emission-Reduction-Requirements-in-Colorado-Colorado",
    "url": "/news/Proposed-Regulation-22-Greenhouse-Gas-Reporting-and-Emission-Reduction-Requirements-in-Colorado-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CREG Report Released-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/CREG-Report-Released-Wyoming",
    "url": "/news/CREG-Report-Released-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Delaware's Proposed Revisions to VOC RACT Requirements for Surface Coating Operations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Delaware's",
    "url": "/news/Delaware's",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA’s Utility MACT - The Bell Tolls for Older Plants",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-s-Utility-MACT---The-Bell-Tolls-for-Older-Plants",
    "url": "/news/EPA-s-Utility-MACT---The-Bell-Tolls-for-Older-Plants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revised LDAR Inspection Form Template and Guidance Document-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revised-LDAR-Inspection-Form-Template-and-Guidance-Document-Colorado",
    "url": "/news/Revised-LDAR-Inspection-Form-Template-and-Guidance-Document-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Maryland Department of the Environment - Reporting of Hazardous Air Pollutant Emissions",
    "apiurl": "/restapi/customnewscontentlvl2/news/Maryland-Department-of-the-Environment---Reporting-of-Hazardous-Air-Pollutant-Emissions",
    "url": "/news/Maryland-Department-of-the-Environment---Reporting-of-Hazardous-Air-Pollutant-Emissions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Kentucky eForm Submission Changes",
    "apiurl": "/restapi/customnewscontentlvl2/news/Kentucky-eForm-Submission-Changes",
    "url": "/news/Kentucky-eForm-Submission-Changes",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Canadian Council of Ministers of the Environment Endorses New Air Quality Standards for NO2-Alberta",
    "apiurl": "/restapi/customnewscontentlvl2/news/Canadian-Council-of-Ministers-of-the-Environment-Endorses-New-Air-Quality-Standards-for-NO2-Alberta",
    "url": "/news/Canadian-Council-of-Ministers-of-the-Environment-Endorses-New-Air-Quality-Standards-for-NO2-Alberta",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Staffing Firm On Demand Environmental Becomes Trispyrian Resources to Reflect Broader Technical Capabilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/Staffing-Firm-On-Demand-Environmental-Becomes-Trispyrian-Resources-to-Reflect-Broader-Technical-Capabilities",
    "url": "/news/Staffing-Firm-On-Demand-Environmental-Becomes-Trispyrian-Resources-to-Reflect-Broader-Technical-Capabilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity/T3 Recognized as EMIS Technology Service Leader",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-T3-Recognized-as-EMIS-Technology-Service-Leader",
    "url": "/news/Trinity-T3-Recognized-as-EMIS-Technology-Service-Leader",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cap-and-Trade August 2014 Auction Results Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/Cap-and-Trade-August-2014-Auction-Results-Released",
    "url": "/news/Cap-and-Trade-August-2014-Auction-Results-Released",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2012 Reporting Reminders",
    "apiurl": "/restapi/customnewscontentlvl2/news/2012-Reporting-Reminders",
    "url": "/news/2012-Reporting-Reminders",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Publishes Guidance on PFAS Destruction and Disposal",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-publishes-guidance-on-pfas-destruction-and-disposal",
    "url": "/news/epa-publishes-guidance-on-pfas-destruction-and-disposal",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New National Pollutant Discharge Elimination System General Permit-Georgia",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-National-Pollutant-Discharge-Elimination-System-General-Permit-Georgia",
    "url": "/news/New-National-Pollutant-Discharge-Elimination-System-General-Permit-Georgia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Redesignation of the Atlanta  Area for 1997 8-hour Ozone",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Redesignation-of-the-Atlanta-Area-for-1997-8-hour-Ozone",
    "url": "/news/Proposed-Redesignation-of-the-Atlanta-Area-for-1997-8-hour-Ozone",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Withdraws Federal Plan and Approves Oklahoma's Air Plan for Public Service of Oklahoma",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Withdraws-Federal-Plan-and-Approves-Oklahoma's-Air-Plan-for-Public-Service-of-Oklahoma-",
    "url": "/news/EPA-Withdraws-Federal-Plan-and-Approves-Oklahoma's-Air-Plan-for-Public-Service-of-Oklahoma-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed One-Year Extension to Reclassification for DMNFR NAA-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-One-Year-Extension-to-Reclassification-for-DMNFR-NAA-Colorado",
    "url": "/news/Proposed-One-Year-Extension-to-Reclassification-for-DMNFR-NAA-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes to Underground Storage Tank Reporting Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/changes-to-underground-storage-tank-reporting-requirements",
    "url": "/news/changes-to-underground-storage-tank-reporting-requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes to Underground Storage Tank Reporting Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/changes-to-underground-storage-tank-reporting-requirements",
    "url": "/news/states/california/changes-to-underground-storage-tank-reporting-requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "A New Kind of Permit Limit...Resulting From Actual-to-Projected Actual PSD Netting",
    "apiurl": "/restapi/customnewscontentlvl2/news/A-New-Kind-of-Permit-Limit-Resulting-From-Actual-to-Projected-Actual-PSD-Netting",
    "url": "/news/A-New-Kind-of-Permit-Limit-Resulting-From-Actual-to-Projected-Actual-PSD-Netting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "California Air Resources Board’s (ARB’s) Revised Cap-and-Trade Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/California-Air-Resources-Board-s-(ARB-s)-Revised-Cap-and-Trade-Regulations-",
    "url": "/news/California-Air-Resources-Board-s-(ARB-s)-Revised-Cap-and-Trade-Regulations-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SO2 NAAQS Outreach Process and Stakeholder Discussions-Washington, DC",
    "apiurl": "/restapi/customnewscontentlvl2/news/SO2-NAAQS-Outreach-Process-and-Stakeholder-Discussions-Washington-DC",
    "url": "/news/SO2-NAAQS-Outreach-Process-and-Stakeholder-Discussions-Washington-DC",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Serious Ozone Nonattainment May Come Sooner-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Serious-Ozone-Nonattainment-May-Come-Sooner-Colorado",
    "url": "/news/Serious-Ozone-Nonattainment-May-Come-Sooner-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Merges with Meteorological Solutions Inc., Expanding into Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Merges-with-Meteorological-Solutions-Inc-Expanding-into-Utah",
    "url": "/news/Trinity-Consultants-Merges-with-Meteorological-Solutions-Inc-Expanding-into-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendment to 10 CSR 10-6.010 Ambient Air Quality Standards",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendment-to-10-CSR-10-6-010-Ambient-Air-Quality-Standards",
    "url": "/news/Proposed-Amendment-to-10-CSR-10-6-010-Ambient-Air-Quality-Standards",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Virginia DEQ Updates Application Fees For 2014",
    "apiurl": "/restapi/customnewscontentlvl2/news/Virginia-DEQ-Updates-Application-Fees-For-2014",
    "url": "/news/Virginia-DEQ-Updates-Application-Fees-For-2014",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Partners with the American Petroleum Institute to Distribute the SANGEA 4.1 Emissions Estimating System",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Partners-with-the-American-Petroleum-Institute-to-Distribute-the-SANGEA-4-1-Emissions-Estimating-System",
    "url": "/news/Trinity-Consultants-Partners-with-the-American-Petroleum-Institute-to-Distribute-the-SANGEA-4-1-Emissions-Estimating-System",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Kentucky's Next Steps to Deal with the Clean Energy Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Kentucky's",
    "url": "/news/Kentucky's",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MMEX Resources Announces Strategic Relationship with Trinity Consultants on Crude Oil Refinery in Permian Basin",
    "apiurl": "/restapi/customnewscontentlvl2/news/MMEX-Resources-Announces-Strategic-Relationship-with-Trinity-Consultants-on-Crude-Oil-Refinery-in-Permian-Basin",
    "url": "/news/MMEX-Resources-Announces-Strategic-Relationship-with-Trinity-Consultants-on-Crude-Oil-Refinery-in-Permian-Basin",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Quarterly Air Quality Client Contact Call Highlights - February 23, 2017",
    "apiurl": "/restapi/customnewscontentlvl2/news/Quarterly-Air-Quality-Client-Contact-Call-Highlights---February-23-2017",
    "url": "/news/Quarterly-Air-Quality-Client-Contact-Call-Highlights---February-23-2017",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Quarterly NJDEP Industrial Stakeholders Group Meeting Update-New Jersey",
    "apiurl": "/restapi/customnewscontentlvl2/news/Quarterly-NJDEP-Industrial-Stakeholders-Group-Meeting-Update-New-Jersey",
    "url": "/news/Quarterly-NJDEP-Industrial-Stakeholders-Group-Meeting-Update-New-Jersey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DEQ Releases Draft Power Plant CO2 Trading Rule, Hearing November 16-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/DEQ-Releases-Draft-Power-Plant-CO2-Trading-Rule-Hearing-November-16-Virginia",
    "url": "/news/DEQ-Releases-Draft-Power-Plant-CO2-Trading-Rule-Hearing-November-16-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "APCD Releases Volume 3 of FAQ for Regulation 7",
    "apiurl": "/restapi/customnewscontentlvl2/news/APCD-Releases-Volume-3-of-FAQ-for-Regulation-7-",
    "url": "/news/APCD-Releases-Volume-3-of-FAQ-for-Regulation-7-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Antelope Valley AQMD Proposed Amendment of Rule 1124",
    "apiurl": "/restapi/customnewscontentlvl2/news/Antelope-Valley-AQMD-Proposed-Amendment-of-Rule-1124",
    "url": "/news/Antelope-Valley-AQMD-Proposed-Amendment-of-Rule-1124",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CDPHE COVID-19 Response",
    "apiurl": "/restapi/customnewscontentlvl2/news/cdphe-covid-19-response",
    "url": "/news/cdphe-covid-19-response",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "U.S. EPA Issues Air Quality Designations for the 2012 Annual PM2.5 Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/U-S-EPA-Issues-Air-Quality-Designations-for-the-2012-Annual-PM2-5-Standard",
    "url": "/news/U-S-EPA-Issues-Air-Quality-Designations-for-the-2012-Annual-PM2-5-Standard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Nebraska Tip of the Month - Aerosol Can Waste-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/Nebraska-Tip-of-the-Month---Aerosol-Can-Waste-Nebraska",
    "url": "/news/Nebraska-Tip-of-the-Month---Aerosol-Can-Waste-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Powerful Software Solutions for EHS Risk Assessment, Planning, and Emergency Response",
    "apiurl": "/restapi/customnewscontentlvl2/news/Powerful-Software-Solutions-for-EHS-Risk-Assessment-Planning-and-Emergency-Response",
    "url": "/news/Powerful-Software-Solutions-for-EHS-Risk-Assessment-Planning-and-Emergency-Response",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MCAQD’s Updating & Creating New 300 Series Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/MCAQD-s-Updating-Creating-New-300-Series-Rule",
    "url": "/news/MCAQD-s-Updating-Creating-New-300-Series-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Removal of Startup, Shutdown, and Malfunction Exemptions",
    "apiurl": "/restapi/customnewscontentlvl2/news/Removal-of-Startup-Shutdown-and-Malfunction-Exemptions",
    "url": "/news/Removal-of-Startup-Shutdown-and-Malfunction-Exemptions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on the Illinois SO2 State Implementation Plan (SIP) for 8-hr SO2 National Ambient Air Quality Standards (NAAQS)",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-the-Illinois-SO2-State-Implementation-Plan-(SIP)-for-8-hr-SO2-National-Ambient-Air-Quality-Standards-(NAAQS)",
    "url": "/news/Update-on-the-Illinois-SO2-State-Implementation-Plan-(SIP)-for-8-hr-SO2-National-Ambient-Air-Quality-Standards-(NAAQS)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DEQ Announces New Environmental Justice Director and Coordinator",
    "apiurl": "/restapi/customnewscontentlvl2/news/deq-announces-new-environmental-justice-director-and-coordinator",
    "url": "/news/deq-announces-new-environmental-justice-director-and-coordinator",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EKAPCD Requires Commercial Solar Facilities to Obtain Air Permits",
    "apiurl": "/restapi/customnewscontentlvl2/news/EKAPCD-Requires-Commercial-Solar-Facilities-to-Obtain-Air-Permits",
    "url": "/news/EKAPCD-Requires-Commercial-Solar-Facilities-to-Obtain-Air-Permits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SLEIS Training Sessions-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/SLEIS-Training-Sessions-Iowa",
    "url": "/news/SLEIS-Training-Sessions-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes to Georgia EPD's 2009 Air Emissions Inventory",
    "apiurl": "/restapi/customnewscontentlvl2/news/Changes-to",
    "url": "/news/Changes-to",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD Accepting Comments for Refinery Emissions Inventory Guideline Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/baaqmd-accepting-comments-for-refinery-emissions-inventory-guideline-amendments",
    "url": "/news/baaqmd-accepting-comments-for-refinery-emissions-inventory-guideline-amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revision to the Illinois Definition for VOM",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revision-to-the-Illinois-Definition-for-VOM",
    "url": "/news/Revision-to-the-Illinois-Definition-for-VOM",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Managing HAPs in Air Permits: A Challenging New Reality in New Jersey-New Jersey",
    "apiurl": "/restapi/customnewscontentlvl2/news/Managing-HAPs-in-Air-Permits-A-Challenging-New-Reality-in-New-Jersey",
    "url": "/news/Managing-HAPs-in-Air-Permits-A-Challenging-New-Reality-in-New-Jersey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Managing HAPs in Air Permits: A Challenging New Reality in New Jersey-New Jersey",
    "apiurl": "/restapi/customnewscontentlvl2/news/Managing-HAPs-in-Air-Permits-A-Challenging-New-Reality-in-New-Jersey",
    "url": "/news/states/new-jersey/managing-haps-in-air-permits--a-challenging-new-reality-in-new-jersey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Managing HAPs in Air Permits: A Challenging New Reality in New Jersey-New Jersey",
    "apiurl": "/restapi/customnewscontentlvl2/news/Managing-HAPs-in-Air-Permits-A-Challenging-New-Reality-in-New-Jersey",
    "url": "/news/Managing-HAPs-in-Air-Permits-A-Challenging-New-Reality-in-New-Jersey-New-Jersey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CARB Considering Revisions to Recently Amended Refrigerant Regulation",
    "apiurl": "/restapi/customnewscontentlvl2/news/carb-considering-revisions-to-recently-amended-refrigerant-regulation",
    "url": "/news/carb-considering-revisions-to-recently-amended-refrigerant-regulation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CARB Considering Revisions to Recently Amended Refrigerant Regulation",
    "apiurl": "/restapi/customnewscontentlvl2/news/carb-considering-revisions-to-recently-amended-refrigerant-regulation",
    "url": "/www.trinityconsultants.com/news/carb-considering-revisions-to-recently-amended-refrigerant-regulation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EJSCREEN – New Federal Environmental Justice Tool",
    "apiurl": "/restapi/customnewscontentlvl2/news/EJSCREEN-New-Federal-Environmental-Justice-Tool",
    "url": "/news/EJSCREEN-New-Federal-Environmental-Justice-Tool",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Acquires St. Louis-Based Schreiber Yonley & Associates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Acquires-St-Louis-Based-Schreiber-Yonley-Associates",
    "url": "/news/Trinity-Consultants-Acquires-St-Louis-Based-Schreiber-Yonley-Associates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SDAPCD Toxic Chemical Updates-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/SDAPCD-Toxic-Chemical-Updates-California",
    "url": "/news/SDAPCD-Toxic-Chemical-Updates-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CDP Climate Change Disclosure: Opportunities for Performance Improvement",
    "apiurl": "/restapi/customnewscontentlvl2/news/CDP-Climate-Change-Disclosure-Opportunities-for-Performance-Improvement",
    "url": "/news/CDP-Climate-Change-Disclosure-Opportunities-for-Performance-Improvement",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CDP Climate Change Disclosure: Opportunities for Performance Improvement",
    "apiurl": "/restapi/customnewscontentlvl2/news/CDP-Climate-Change-Disclosure-Opportunities-for-Performance-Improvement",
    "url": "/news/0a95e12e-41df-4e6d-8d65-da0bc0fe5094",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Introduced HB20-1265 New Air Toxics Program Proposed for Colorado-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Introduced-HB20-1265-New-Air-Toxics-Program-Proposed-for-Colorado-Colorado",
    "url": "/news/Introduced-HB20-1265-New-Air-Toxics-Program-Proposed-for-Colorado-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDE Proposes New Regulations Applicable to the Portland Cement Industry",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDE-Proposes-New-Regulations-Applicable-to-the-Portland-Cement-Industry",
    "url": "/news/MDE-Proposes-New-Regulations-Applicable-to-the-Portland-Cement-Industry",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDAQMD - Proposed Changes to Rule 1158 and Rule 1162-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDAQMD---Proposed-Changes-to-Rule-1158-and-Rule-1162-California",
    "url": "/news/MDAQMD---Proposed-Changes-to-Rule-1158-and-Rule-1162-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New York State DEC Publishes Regulatory Guidance for Exemption of R&D Activities from Permitting",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-york-state-dec-publishes-regulatory-guidance-for-exemption-of-r-d-activities-from-permitting",
    "url": "/news/new-york-state-dec-publishes-regulatory-guidance-for-exemption-of-r-d-activities-from-permitting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Boiler MACT Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Boiler-MACT-Rule",
    "url": "/news/Boiler-MACT-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Draft Air Permitting Fee Rulemaking",
    "apiurl": "/restapi/customnewscontentlvl2/news/Draft-Air-Permitting-Fee-Rulemaking",
    "url": "/news/Draft-Air-Permitting-Fee-Rulemaking",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Permitting Path for Larger Covered Facilities under Hawaii’s Greenhouse Gas Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/permitting-path-for-larger-covered-facilities-under-hawaii-s-greenhouse-gas-program",
    "url": "/news/permitting-path-for-larger-covered-facilities-under-hawaii-s-greenhouse-gas-program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Permitting Path for Larger Covered Facilities under Hawaii’s Greenhouse Gas Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/permitting-path-for-larger-covered-facilities-under-hawaii-s-greenhouse-gas-program",
    "url": "/states/permitting-path-for-larger-covered-facilities-under-hawaii-s-greenhouse-gas-program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Floodplain Rules Changes to the COGCC Form 2A",
    "apiurl": "/restapi/customnewscontentlvl2/news/Floodplain-Rules-Changes-to-the-COGCC-Form-2A",
    "url": "/news/Floodplain-Rules-Changes-to-the-COGCC-Form-2A",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Method 9 Evaluation Requirements Still In Effect",
    "apiurl": "/restapi/customnewscontentlvl2/news/method-9-evaluation-requirements-still-in-effect",
    "url": "/news/method-9-evaluation-requirements-still-in-effect",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Method 9 Evaluation Requirements Still In Effect",
    "apiurl": "/restapi/customnewscontentlvl2/news/method-9-evaluation-requirements-still-in-effect",
    "url": "/states/arizona/method-9-evaluation-requirements-still-in-effect",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "After an Initial  GHG Inventory, What’s Next?",
    "apiurl": "/restapi/customnewscontentlvl2/news/After-an-Initial-GHG-Inventory-What-s-Next-",
    "url": "/news/After-an-Initial-GHG-Inventory-What-s-Next-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Quality Permits: March Emission Summary Dispersion Modelling (ESDM) Report Updates-Ontario",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Permits-March-Emission-Summary-Dispersion-Modelling-(ESDM)-Report-Updates-Ontario",
    "url": "/news/Air-Quality-Permits-March-Emission-Summary-Dispersion-Modelling-(ESDM)-Report-Updates-Ontario",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Workshops Outline SPCC Rule Changes",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Workshops-Outline-SPCC-Rule-Changes",
    "url": "/news/EPA-Workshops-Outline-SPCC-Rule-Changes",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Acquisition Strengthens Gulf Coast Capabilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/Acquisition-Strengthens-Gulf-Coast-Capabilities",
    "url": "/news/Acquisition-Strengthens-Gulf-Coast-Capabilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Expands and Relocates Iowa Office",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Expands-and-Relocates-Iowa-Office",
    "url": "/news/Trinity-Consultants-Expands-and-Relocates-Iowa-Office",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Virginia Cap and Trade Rule Approved by Air Quality Board-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Virginia-Cap-and-Trade-Rule-Approved-by-Air-Quality-Board-Virginia",
    "url": "/news/Virginia-Cap-and-Trade-Rule-Approved-by-Air-Quality-Board-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments of K.A.R. 28-19-720 and 28-19-750",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendments-of-K-A-R-28-19-720-and-28-19-750",
    "url": "/news/Proposed-Amendments-of-K-A-R-28-19-720-and-28-19-750",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Utah Lake Algal Bloom and Potential Permitting Impacts",
    "apiurl": "/restapi/customnewscontentlvl2/news/Utah-Lake-Algal-Bloom-and-Potential-Permitting-Impacts",
    "url": "/news/Utah-Lake-Algal-Bloom-and-Potential-Permitting-Impacts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes to Tier II Reporting-Michigan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Changes-to-Tier-II-Reporting-Michigan",
    "url": "/news/Changes-to-Tier-II-Reporting-Michigan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Coast Air Quality Management District – Proposed Amendments to Rules 1110.2 and 1420.2",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Coast-Air-Quality-Management-District-Proposed-Amendments-to-Rules-1110-2-and-1420-2",
    "url": "/news/South-Coast-Air-Quality-Management-District-Proposed-Amendments-to-Rules-1110-2-and-1420-2",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Message to SafeBridge Clients: COVID-19 Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/message-to-safebridge-clients-covid-19-updates",
    "url": "/news/message-to-safebridge-clients-covid-19-updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Orders Utah to Improve Haze Reduction at National Parks",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Orders-Utah-to-Improve-Haze-Reduction-at-National-Parks",
    "url": "/news/EPA-Orders-Utah-to-Improve-Haze-Reduction-at-National-Parks",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Boiler MACT Affected Sources Five-Year Tune-Up-North Carolina",
    "apiurl": "/restapi/customnewscontentlvl2/news/Boiler-MACT-Affected-Sources-Five-Year-Tune-Up-North-Carolina",
    "url": "/news/Boiler-MACT-Affected-Sources-Five-Year-Tune-Up-North-Carolina",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Boiler MACT Delayed",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-Boiler-MACT-Delayed",
    "url": "/news/Final-Boiler-MACT-Delayed",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD – Proposed Amended Rule 1180-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/SCAQMD-Proposed-Amended-Rule-1180-California",
    "url": "/news/SCAQMD-Proposed-Amended-Rule-1180-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NSPS and MACT Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/NSPS-and-MACT-Updates",
    "url": "/news/NSPS-and-MACT-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Pennsylvania's Clean Air Interstate Rule (CAIR) State Regulations Approved",
    "apiurl": "/restapi/customnewscontentlvl2/news/Pennsylvania's-Clean-Air-Interstate-Rule-(CAIR)-State-Regulations-Approved",
    "url": "/news/Pennsylvania's-Clean-Air-Interstate-Rule-(CAIR)-State-Regulations-Approved",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Implementation of New Air Toxics Rules by Washington Agencies-Washington",
    "apiurl": "/restapi/customnewscontentlvl2/news/Implementation-of-New-Air-Toxics-Rules-by-Washington-Agencies-Washington",
    "url": "/news/Implementation-of-New-Air-Toxics-Rules-by-Washington-Agencies-Washington",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MassDEP Preparing to finalize its Proposed Amendments to Air Pollution Control Regulations-Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/MassDEP-Preparing-to-finalize-its-Proposed-Amendments-to-Air-Pollution-Control-Regulations-Massachusetts",
    "url": "/news/MassDEP-Preparing-to-finalize-its-Proposed-Amendments-to-Air-Pollution-Control-Regulations-Massachusetts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "California Aboveground Petroleum Storage Act Program Updates and Applicability Expansion",
    "apiurl": "/restapi/customnewscontentlvl2/news/California-Aboveground-Petroleum-Storage-Act-Program-Updates-and-Applicability-Expansion",
    "url": "/news/California-Aboveground-Petroleum-Storage-Act-Program-Updates-and-Applicability-Expansion",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments to LAC 33:III.311 to Include Non-emergency Stationary Engines in Addition to Emergency Engines",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendments-to-LAC-33-III-311-to-Include-Non-emergency-Stationary-Engines-in-Addition-to-Emergency-Engines",
    "url": "/news/Proposed-Amendments-to-LAC-33-III-311-to-Include-Non-emergency-Stationary-Engines-in-Addition-to-Emergency-Engines",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Bay Area Air Quality Management District Proposes Amendments and Additions to Particulate Matter Regulation",
    "apiurl": "/restapi/customnewscontentlvl2/news/Bay-Area-Air-Quality-Management-District-Proposes-Amendments-and-Additions-to-Particulate-Matter-Regulation",
    "url": "/news/Bay-Area-Air-Quality-Management-District-Proposes-Amendments-and-Additions-to-Particulate-Matter-Regulation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Are You Ready? New Sulfur Standards for Fuels Effective November 2010 in New Jersey",
    "apiurl": "/restapi/customnewscontentlvl2/news/Are-You-Ready-New-Sulfur-Standards-for-Fuels-Effective-November-2010-in-New-Jersey",
    "url": "/news/Are-You-Ready-New-Sulfur-Standards-for-Fuels-Effective-November-2010-in-New-Jersey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Recent MPCA Reports",
    "apiurl": "/restapi/customnewscontentlvl2/news/Recent-MPCA-Reports",
    "url": "/news/Recent-MPCA-Reports",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Moves Forward with Developing the Hazardous Waste e-Manifest System",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Moves-Forward-with-Developing-the-Hazardous-Waste-e-Manifest-System",
    "url": "/news/EPA-Moves-Forward-with-Developing-the-Hazardous-Waste-e-Manifest-System",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Quarterly Air Quality Client Contact Call Highlights – May 25, 2017-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Quarterly-Air-Quality-Client-Contact-Call-Highlights-May-25-2017-Iowa",
    "url": "/news/Quarterly-Air-Quality-Client-Contact-Call-Highlights-May-25-2017-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DEQ Reissues Three VPDES Permits-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/DEQ-Reissues-Three-VPDES-Permits-Virginia",
    "url": "/news/DEQ-Reissues-Three-VPDES-Permits-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Environmental Federation of Oklahoma (EFO)",
    "apiurl": "/restapi/customnewscontentlvl2/news/Environmental-Federation-of-Oklahoma-(EFO)",
    "url": "/news/Environmental-Federation-of-Oklahoma-(EFO)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Developing a Boiler NESHAP Compliance Strategy",
    "apiurl": "/restapi/customnewscontentlvl2/news/Developing-a-Boiler-NESHAP-Compliance-Strategy",
    "url": "/news/Developing-a-Boiler-NESHAP-Compliance-Strategy",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Website - Expanded Expertise",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-website-expanded-expertise",
    "url": "/news/new-website-expanded-expertise",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Mississippi Department of Environmental Quality (MDEQ) News for March 2019-Mississippi",
    "apiurl": "/restapi/customnewscontentlvl2/news/Mississippi-Department-of-Environmental-Quality-(MDEQ)-News-for-March-2019-Mississippi",
    "url": "/news/Mississippi-Department-of-Environmental-Quality-(MDEQ)-News-for-March-2019-Mississippi",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Utah Hazardous Waste Generators Notification Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/utah-hazardous-waste-generators-notification-requirements",
    "url": "/news/utah-hazardous-waste-generators-notification-requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Second 15-day Modifications for California MRR and Cap-and-Trade",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Second-15-day-Modifications-for-California-MRR-and-Cap-and-Trade",
    "url": "/news/Proposed-Second-15-day-Modifications-for-California-MRR-and-Cap-and-Trade",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Iowa-Based Thompson Environmental Consulting Joins Trinity Consultants",
    "apiurl": "/restapi/customnewscontentlvl2/news/Iowa-Based-Thompson-Environmental-Consulting-Joins-Trinity-Consultants",
    "url": "/news/Iowa-Based-Thompson-Environmental-Consulting-Joins-Trinity-Consultants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Amendments to Greenhouse Gas Emissions Reporting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Amendments-to-Greenhouse-Gas-Emissions-Reporting",
    "url": "/news/Amendments-to-Greenhouse-Gas-Emissions-Reporting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update - EPA Finalizes Guidance on MERPs as a Demonstration Tool for PSD Permitting -Kentucky",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update---EPA-Finalizes-Guidance-on-MERPs-as-a-Demonstration-Tool-for-PSD-Permitting--Kentucky",
    "url": "/news/Update---EPA-Finalizes-Guidance-on-MERPs-as-a-Demonstration-Tool-for-PSD-Permitting--Kentucky",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Court Vacates SSM Exemptions",
    "apiurl": "/restapi/customnewscontentlvl2/news/Court-Vacates-SSM-Exemptions",
    "url": "/news/Court-Vacates-SSM-Exemptions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Employees are Earth Friendly",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Employees-are-Earth-Friendly",
    "url": "/news/Trinity-Employees-are-Earth-Friendly",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TDEC Air Pollution Control Board Public Hearing",
    "apiurl": "/restapi/customnewscontentlvl2/news/TDEC-Air-Pollution-Control-Board-Public-Hearing",
    "url": "/news/TDEC-Air-Pollution-Control-Board-Public-Hearing",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2020 Air Toxics Emission Inventory Reporting Forms Posted",
    "apiurl": "/restapi/customnewscontentlvl2/news/2020-air-toxics-emission-inventory-reporting-forms-posted",
    "url": "/news/2020-air-toxics-emission-inventory-reporting-forms-posted",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2020 Air Toxics Emission Inventory Reporting Forms Posted",
    "apiurl": "/restapi/customnewscontentlvl2/news/2020-air-toxics-emission-inventory-reporting-forms-posted",
    "url": "/www.trinityconsultants.com/news/2020-air-toxics-emission-inventory-reporting-forms-posted",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Secretary of State's Statement of Good Standing",
    "apiurl": "/restapi/customnewscontentlvl2/news/Secretary-of-State's-Statement-of-Good-Standing",
    "url": "/news/Secretary-of-State's-Statement-of-Good-Standing",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EHS Auditing Best Practices, Enforcement Initiatives, and Improving the Culture of Self Governance",
    "apiurl": "/restapi/customnewscontentlvl2/news/EHS-Auditing-Best-Practices-Enforcement-Initiatives-and-Improving-the-Culture-of-Self-Governance",
    "url": "/news/EHS-Auditing-Best-Practices-Enforcement-Initiatives-and-Improving-the-Culture-of-Self-Governance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Updates to MDNR Incinerator Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Updates-to-MDNR-Incinerator-Rules",
    "url": "/news/Proposed-Updates-to-MDNR-Incinerator-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ongoing Efforts to Revise Rules for DEQ Public Records Access-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ongoing-Efforts-to-Revise-Rules-for-DEQ-Public-Records-Access-Wyoming",
    "url": "/news/Ongoing-Efforts-to-Revise-Rules-for-DEQ-Public-Records-Access-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Adopts Updates to Applicable Federal Requirements for Operating Permits",
    "apiurl": "/restapi/customnewscontentlvl2/news/TCEQ-Adopts-Updates-to-Applicable-Federal-Requirements-for-Operating-Permits",
    "url": "/news/TCEQ-Adopts-Updates-to-Applicable-Federal-Requirements-for-Operating-Permits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Increased Fees Proposed for Kansas Air Sources-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Increased-Fees-Proposed-for-Kansas-Air-Sources-Kansas",
    "url": "/news/Increased-Fees-Proposed-for-Kansas-Air-Sources-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New England and US EPA COVID-19 Response",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-england-and-us-epa-covid-19-response",
    "url": "/news/new-england-and-us-epa-covid-19-response",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New England and US EPA COVID-19 Response",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-england-and-us-epa-covid-19-response",
    "url": "/states/massachusetts/new-england-and-us-epa-covid-19-response",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes Coming in 2016 to the Joint Health and Safety Committee Certification Training Program Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/Changes-Coming-in-2016-to-the-Joint-Health-and-Safety-Committee-Certification-Training-Program-Standard",
    "url": "/news/Changes-Coming-in-2016-to-the-Joint-Health-and-Safety-Committee-Certification-Training-Program-Standard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Surface Coating Operation Rule Revised: New daily applicability triggers & VOC limitation changes",
    "apiurl": "/restapi/customnewscontentlvl2/news/Surface-Coating-Operation-Rule-Revised-New-daily-applicability-triggers-VOC-limitation-changes",
    "url": "/news/Surface-Coating-Operation-Rule-Revised-New-daily-applicability-triggers-VOC-limitation-changes",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Virginia DEQ  Recommends Granting VMA’s Petition to Harmonize Virginia and Federal PSD Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Virginia-DEQ-Recommends-Granting-VMA-s-Petition-to-Harmonize-Virginia-and-Federal-PSD-Regulations",
    "url": "/news/Virginia-DEQ-Recommends-Granting-VMA-s-Petition-to-Harmonize-Virginia-and-Federal-PSD-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Massachusetts proposes amendments to 310 CMR 4.00, Timely Action Schedule and Fee Provisions-Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/Massachusetts-proposes-amendments-to-310-CMR-4-00-Timely-Action-Schedule-and-Fee-Provisions-Massachusetts",
    "url": "/news/Massachusetts-proposes-amendments-to-310-CMR-4-00-Timely-Action-Schedule-and-Fee-Provisions-Massachusetts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Governor Issues Executive Order Implementing State’s GHG Tailoring Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Governor-Issues-Executive-Order-Implementing-State-s-GHG-Tailoring-Rule",
    "url": "/news/Governor-Issues-Executive-Order-Implementing-State-s-GHG-Tailoring-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Issues Final Rules for Boilers and Incinerators",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Issues-Final-Rules-for-Boilers-and-Incinerators-",
    "url": "/news/EPA-Issues-Final-Rules-for-Boilers-and-Incinerators-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Maryland Demand Response Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/Maryland-Demand-Response-Update",
    "url": "/news/Maryland-Demand-Response-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA Proposes Reclassification of SJVAPCD from Moderate to Serious Nonattainment for the 1997 and 2006 PM2.5 NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-Proposes-Reclassification-of-SJVAPCD-from-Moderate-to-Serious-Nonattainment-for-the-1997-and-2006-PM2-5-NAAQS-",
    "url": "/news/USEPA-Proposes-Reclassification-of-SJVAPCD-from-Moderate-to-Serious-Nonattainment-for-the-1997-and-2006-PM2-5-NAAQS-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Mandatory Electronic Submittal of PA Emissions Inventory Reports-Pennsylvania",
    "apiurl": "/restapi/customnewscontentlvl2/news/Mandatory-Electronic-Submittal-of-PA-Emissions-Inventory-Reports-Pennsylvania",
    "url": "/news/Mandatory-Electronic-Submittal-of-PA-Emissions-Inventory-Reports-Pennsylvania",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Georgia Biomass Deferral",
    "apiurl": "/restapi/customnewscontentlvl2/news/Georgia-Bi",
    "url": "/news/Georgia-Bi",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDEQ Revising Air Toxics Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDEQ-Revising-Air-Toxics-Rules",
    "url": "/news/MDEQ-Revising-Air-Toxics-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDE SIP Revisions to 2010 SO2 and 2012 PM2.5 NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDE-SIP-Revisions-to-2010-SO2-and-2012-PM2-5-NAAQS",
    "url": "/news/MDE-SIP-Revisions-to-2010-SO2-and-2012-PM2-5-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Memphis & Shelby County Air Pollution Control Board Public Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Memphis-Shelby-County-Air-Pollution-Control-Board-Public-Meeting",
    "url": "/news/Memphis-Shelby-County-Air-Pollution-Control-Board-Public-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDNR Easy Air Application System-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDNR-Easy-Air-Application-System-Iowa",
    "url": "/news/IDNR-Easy-Air-Application-System-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Early Estimate of 2017 Air Emission Fees Announced",
    "apiurl": "/restapi/customnewscontentlvl2/news/Early-Estimate-of-2017-Air-Emission-Fees-Announced",
    "url": "/news/Early-Estimate-of-2017-Air-Emission-Fees-Announced",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Maine Submits Changes to SIP to Remove Portions from the OTR",
    "apiurl": "/restapi/customnewscontentlvl2/news/maine-submits-changes-to-sip-to-remove-portions-from-the-otr",
    "url": "/news/maine-submits-changes-to-sip-to-remove-portions-from-the-otr",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Maine Submits Changes to SIP to Remove Portions from the OTR",
    "apiurl": "/restapi/customnewscontentlvl2/news/maine-submits-changes-to-sip-to-remove-portions-from-the-otr",
    "url": "/news/states/maine/maine-submits-changes-to-sip-to-remove-portions-of-maine-from-the-otr",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Major Sources in Arizona - Different Than What You May Expect",
    "apiurl": "/restapi/customnewscontentlvl2/news/Major-Sources-in-Arizona---Different-Than-What-You-May-Expect",
    "url": "/news/Major-Sources-in-Arizona---Different-Than-What-You-May-Expect",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Residual Risk Settlement Affects Pulp & Paper Mills",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Residual-Risk-Settlement-Affects-Pulp-Paper-Mills-",
    "url": "/news/EPA-Residual-Risk-Settlement-Affects-Pulp-Paper-Mills-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Changes to 2009 Annual Emissions Statement due to NJDEP by May 15, 2010",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Changes-to-2009-Annual-Emissions-Statement-due-to-NJDEP-by-May-15-2010",
    "url": "/news/Proposed-Changes-to-2009-Annual-Emissions-Statement-due-to-NJDEP-by-May-15-2010",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Atmospheric Variables Measured During Balloon Fiesta® Flight",
    "apiurl": "/restapi/customnewscontentlvl2/news/Atmospheric-Variables-Measured-During-Balloon-Fiesta-Flight",
    "url": "/news/Atmospheric-Variables-Measured-During-Balloon-Fiesta-Flight",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Missouri SIP Approval - PM from Indirect Heaters",
    "apiurl": "/restapi/customnewscontentlvl2/news/Missouri-SIP-Approval---PM-from-Indirect-Heaters",
    "url": "/news/Missouri-SIP-Approval---PM-from-Indirect-Heaters",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on NEW 1-Hour SO2 Standards",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-NEW-1-Hour-SO2-Standards",
    "url": "/news/Update-on-NEW-1-Hour-SO2-Standards",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GHG Mandatory Reporting Updates and Reminders",
    "apiurl": "/restapi/customnewscontentlvl2/news/GHG-Mandatory-Reporting-Updates-and-Reminders",
    "url": "/news/GHG-Mandatory-Reporting-Updates-and-Reminders",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Registration of Small Source (ROSS) Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/Registration-of-Small-Source-(ROSS)-Update",
    "url": "/news/Registration-of-Small-Source-(ROSS)-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Expands West Coast Presence",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Expands-West-Coast-Presence",
    "url": "/news/Trinity-Expands-West-Coast-Presence",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA proposes to Approve SJVAPCD SIP Revisions for the 2006 24-hour PM2.5 NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-proposes-to-Approve-SJVAPCD-SIP-Revisions-for-the-2006-24-hour-PM2-5-NAAQS-",
    "url": "/news/USEPA-proposes-to-Approve-SJVAPCD-SIP-Revisions-for-the-2006-24-hour-PM2-5-NAAQS-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PART 75 Auditing and Protocol Overview",
    "apiurl": "/restapi/customnewscontentlvl2/news/PART-75-Auditing-and-Protocol-Overview",
    "url": "/news/PART-75-Auditing-and-Protocol-Overview",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Proposed Underground Injection Control Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/adeq-proposed-underground-injection-control-program",
    "url": "/news/adeq-proposed-underground-injection-control-program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Proposed Underground Injection Control Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/adeq-proposed-underground-injection-control-program",
    "url": "/states/arizona/adeq-proposed-underground-injection-control-program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes SO2 1-Hour NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-SO2-1-Hour-NAAQS",
    "url": "/news/EPA-Proposes-SO2-1-Hour-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "UDAQ Stakeholder Outreach in Preparation of Ozone Attainment Date",
    "apiurl": "/restapi/customnewscontentlvl2/news/udaq-stakeholder-outreach-in-preparation-of-ozone-attainment-date-",
    "url": "/news/udaq-stakeholder-outreach-in-preparation-of-ozone-attainment-date-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MassDEP Announces Draft Action Plan for Regulatory Reform",
    "apiurl": "/restapi/customnewscontentlvl2/news/MassDEP-Announces-Draft-Action-Plan-for-Regulatory-Reform",
    "url": "/news/MassDEP-Announces-Draft-Action-Plan-for-Regulatory-Reform",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Working with ADEQ:  NSPS and NESHAP Requirements in Permits",
    "apiurl": "/restapi/customnewscontentlvl2/news/Working-with-ADEQ-NSPS-and-NESHAP-Requirements-in-Permits-",
    "url": "/news/Working-with-ADEQ-NSPS-and-NESHAP-Requirements-in-Permits-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Wyoming Implements Withdrawal of \"Once In, Always In\" Policy-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Wyoming-Implements-Withdrawal-of-Once-In-Always-In-Policy-Wyoming",
    "url": "/news/Wyoming-Implements-Withdrawal-of-Once-In-Always-In-Policy-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "California Air Pollution Control Officers Association - Proposed Rule Amendments to PSD Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/California-Air-Pollution-Control-Officers-Association---Proposed-Rule-Amendments-to-PSD-Program",
    "url": "/news/California-Air-Pollution-Control-Officers-Association---Proposed-Rule-Amendments-to-PSD-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Manitowoc and Door Counties Redesignated to Attainment for 8-hour Ozone Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/Manitowoc-and-Door-Counties-Redesignated-to-Attainment-for-8-hour-Ozone-Standard",
    "url": "/news/Manitowoc-and-Door-Counties-Redesignated-to-Attainment-for-8-hour-Ozone-Standard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Midwest Environmental Compliance Conference April 23-24, 2019-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Midwest-Environmental-Compliance-Conference-April-23-24-2019-Kansas",
    "url": "/news/Midwest-Environmental-Compliance-Conference-April-23-24-2019-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DNREC Revises or Repeals Several Air Quality Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/DNREC-Revi",
    "url": "/news/DNREC-Revi",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TDEC Air Pollution Control Board Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/TDEC-Air-Pollution-Control-Board-Meeting",
    "url": "/news/TDEC-Air-Pollution-Control-Board-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GHG MRR Amendments – It’s Time  to Deal with Confidential Data",
    "apiurl": "/restapi/customnewscontentlvl2/news/GHG-MRR-Amendments-It-s-Time-to-Deal-with-Confidential-Data",
    "url": "/news/GHG-MRR-Amendments-It-s-Time-to-Deal-with-Confidential-Data",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CDPHE - Air Quality Control Division - Rulemaking Hearing Request to the Colorado Air Quality Control Commission",
    "apiurl": "/restapi/customnewscontentlvl2/news/cdphe---air-quality-control-division---rulemaking-hearing-request-to-the-colorado-air-quality-control-commission-",
    "url": "/news/cdphe---air-quality-control-division---rulemaking-hearing-request-to-the-colorado-air-quality-control-commission-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CDPHE - Air Quality Control Division - Rulemaking Hearing Request to the Colorado Air Quality Control Commission",
    "apiurl": "/restapi/customnewscontentlvl2/news/cdphe---air-quality-control-division---rulemaking-hearing-request-to-the-colorado-air-quality-control-commission-",
    "url": "/states/colorado/cdphe---air-quality-control-division---rulemaking-hearing-request-to-the-colorado-air-quality-control-commission",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Director for Illinois EPA",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Director-for-Illinois-EPA",
    "url": "/news/New-Director-for-Illinois-EPA",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Finalizes GHG Reporting for Oil and Natural Gas Operators",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Finalizes-GHG-Reporting-for-Oil-and-Natural-Gas-Operators",
    "url": "/news/EPA-Finalizes-GHG-Reporting-for-Oil-and-Natural-Gas-Operators",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Dispersion Modeling in the Absence of Meteorological Data",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Dispersion-Modeling-in-the-Absence-of-Meteorological-Data",
    "url": "/news/Air-Dispersion-Modeling-in-the-Absence-of-Meteorological-Data",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NMED Publishes Update to Universal Application Forms-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/NMED-Publishes-Update-to-Universal-Application-Forms-New-Mexico",
    "url": "/news/NMED-Publishes-Update-to-Universal-Application-Forms-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD RECLAIM Emissions Compliance Advisory: Fuel Usage Correction to Standard Conditions",
    "apiurl": "/restapi/customnewscontentlvl2/news/SCAQMD-RECLAIM-Emissions-Compliance-Advisory-Fuel-Usage-Correction-to-Standard-Conditions",
    "url": "/news/SCAQMD-RECLAIM-Emissions-Compliance-Advisory-Fuel-Usage-Correction-to-Standard-Conditions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Managing Liabilities Associated with Waste Disposal",
    "apiurl": "/restapi/customnewscontentlvl2/news/Managing-Liabilities-Associated-with-Waste-Disposal",
    "url": "/news/Managing-Liabilities-Associated-with-Waste-Disposal",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Managing Liabilities Associated with Waste Disposal",
    "apiurl": "/restapi/customnewscontentlvl2/news/Managing-Liabilities-Associated-with-Waste-Disposal",
    "url": "/news/federal/Managing-Liabilities-Associated-with-Waste-Disposal",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Quick Look at the New  Ozone Standard in New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/Quick-Look-at-the-New-Ozone-Standard-in-New-Mexico",
    "url": "/news/Quick-Look-at-the-New-Ozone-Standard-in-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Mercury and Air Toxics Standards Proposed for Power Industry",
    "apiurl": "/restapi/customnewscontentlvl2/news/Mercury-and-Air-Toxics-Standards-Proposed-for-Power-Industry",
    "url": "/news/Mercury-and-Air-Toxics-Standards-Proposed-for-Power-Industry",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Permit Fees Effective",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Permit-Fees-Effective",
    "url": "/news/New-Permit-Fees-Effective",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "UDAQ is Proposing to Amend Area Source Rules-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/UDAQ-is-Proposing-to-Amend-Area-Source-Rules-Utah",
    "url": "/news/UDAQ-is-Proposing-to-Amend-Area-Source-Rules-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reminder:  2015 Annual Reporting Requirements for Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reminder-2015-Annual-Reporting-Requirements-for-Illinois",
    "url": "/news/Reminder-2015-Annual-Reporting-Requirements-for-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NFPA Combustible Dust Industry Consensus Standard Gives OSHA a New Tool to Cite Employers",
    "apiurl": "/restapi/customnewscontentlvl2/news/nfpa-combustible-dust-industry-consensus-standard-gives-osha-a-new-tool-to-cite-employers",
    "url": "/news/nfpa-combustible-dust-industry-consensus-standard-gives-osha-a-new-tool-to-cite-employers",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NFPA Combustible Dust Industry Consensus Standard Gives OSHA a New Tool to Cite Employers",
    "apiurl": "/restapi/customnewscontentlvl2/news/nfpa-combustible-dust-industry-consensus-standard-gives-osha-a-new-tool-to-cite-employers",
    "url": "/federal/nfpa-combustible-dust-industry-consensus-standard-gives-osha-a-new-tool-to-cite-employers",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Status of HEAL Utah Petition for Air Quality Rule Making",
    "apiurl": "/restapi/customnewscontentlvl2/news/Status-of-HEAL-Utah-Petition-for-Air-Quality-Rule-Making",
    "url": "/news/Status-of-HEAL-Utah-Petition-for-Air-Quality-Rule-Making",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2014 Nebraska Environmental Conference",
    "apiurl": "/restapi/customnewscontentlvl2/news/2014-Nebraska-Environmental-Conference",
    "url": "/news/2014-Nebraska-Environmental-Conference",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Amendments to RCSA 22a-174-29 and 22a-174-3c",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-Amendments-to-RCSA-22a-174-29-and-22a-174-3c",
    "url": "/news/Final-Amendments-to-RCSA-22a-174-29-and-22a-174-3c",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Enforcement Considerations by Utah Air Quality Board - January 2019-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/Enforcement-Considerations-by-Utah-Air-Quality-Board---January-2019-Utah",
    "url": "/news/Enforcement-Considerations-by-Utah-Air-Quality-Board---January-2019-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "5 Steps to Digitize EHS Reporting Processes",
    "apiurl": "/restapi/customnewscontentlvl2/news/5-steps-to-proactive-reporting-with-digital-solutions",
    "url": "/news/5-steps-to-proactive-reporting-with-digital-solutions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "5 Steps to Digitize EHS Reporting Processes",
    "apiurl": "/restapi/customnewscontentlvl2/news/5-steps-to-proactive-reporting-with-digital-solutions",
    "url": "/5-Steps-to-Digitize-EHS-Reporting-Processes",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Source Performance Standards (NSPS) for Municipal Solid Waste (MSW) Landfills",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Source-Performance-Standards-(NSPS)-for-Municipal-Solid-Waste-(MSW)-Landfills",
    "url": "/news/New-Source-Performance-Standards-(NSPS)-for-Municipal-Solid-Waste-(MSW)-Landfills",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Permit Process Recommendations Announced by DNREC for Coastal Zone Conversion Permit Act-Delaware",
    "apiurl": "/restapi/customnewscontentlvl2/news/Permit-Process-Recommendations-Announced-by-DNREC-for-Coastal-Zone-Conversion-Permit-Act-Delaware",
    "url": "/news/Permit-Process-Recommendations-Announced-by-DNREC-for-Coastal-Zone-Conversion-Permit-Act-Delaware",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DOEE Proposes New Source Category Permit",
    "apiurl": "/restapi/customnewscontentlvl2/news/DOEE-Proposes-New-Source-Category-Permit",
    "url": "/news/DOEE-Proposes-New-Source-Category-Permit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Launches Redesigned Web Site",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Launches-Redesigned-Web-Site",
    "url": "/news/Trinity-Launches-Redesigned-Web-Site",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEP Air Program Implements New Fee Schedule-Nevada",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEP-Air-Program-Implements-New-Fee-Schedule-Nevada",
    "url": "/news/NDEP-Air-Program-Implements-New-Fee-Schedule-Nevada",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Quality Client Contact Meeting Highlights",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Client-Contact-Meeting-Highlights",
    "url": "/news/Air-Quality-Client-Contact-Meeting-Highlights",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Construction Permit Application Training Webinars",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Construction-Permit-Application-Training-Webinars",
    "url": "/news/Air-Construction-Permit-Application-Training-Webinars",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDNR Air Quality Contact Meeting-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDNR-Air-Quality-Contact-Meeting-Iowa",
    "url": "/news/IDNR-Air-Quality-Contact-Meeting-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Various Oregon Regulatory Updates:",
    "apiurl": "/restapi/customnewscontentlvl2/news/Various-Oregon-Regulatory-Updates-",
    "url": "/news/Various-Oregon-Regulatory-Updates-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MassDEP 2019 Source Registration and/or Greenhouse Gas Forms Available to Filers-Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/MassDEP-2019-Source-Registration-and-or-Greenhouse-Gas-Forms-Available-to-Filers-Massachusetts",
    "url": "/news/MassDEP-2019-Source-Registration-and-or-Greenhouse-Gas-Forms-Available-to-Filers-Massachusetts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Washington's Clean Air Rule Finalized",
    "apiurl": "/restapi/customnewscontentlvl2/news/Washington's-Clean-Air-Rule-Finalized",
    "url": "/news/Washington's-Clean-Air-Rule-Finalized",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Further Delays Ozone NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Furthe",
    "url": "/news/EPA-Furthe",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Boiler MACT Energy Assessment and How It Affects You-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/Boiler-MACT-Energy-Assessment-and-How-It-Affects-You-New-Mexico",
    "url": "/news/Boiler-MACT-Energy-Assessment-and-How-It-Affects-You-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cleaner Air Oregon Finalized-Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/Cleaner-Air-Oregon-Finalized-Oregon",
    "url": "/news/Cleaner-Air-Oregon-Finalized-Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DEQ Participates in EPA Ozone Advance Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/DEQ-Participates-in-EPA-Ozone-Advance-Program",
    "url": "/news/DEQ-Participates-in-EPA-Ozone-Advance-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "To BAT or Not to BAT?",
    "apiurl": "/restapi/customnewscontentlvl2/news/To-BAT-or-Not-to-BAT-",
    "url": "/news/To-BAT-or-Not-to-BAT-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Do you know when your Permit Renewal is due?",
    "apiurl": "/restapi/customnewscontentlvl2/news/Do-you-know-when-your-Permit-Renewal-is-due-",
    "url": "/news/Do-you-know-when-your-Permit-Renewal-is-due-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revised General Air Permit for Oil & Gas Facilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revised-General-Air-Permit-for-Oil-Gas-Facilities",
    "url": "/news/Revised-General-Air-Permit-for-Oil-Gas-Facilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Upcoming Conference - 2015 Iowa-Illinois Safety Council Professional Development Conference & Expo",
    "apiurl": "/restapi/customnewscontentlvl2/news/Upcoming-Conference---2015-Iowa-Illinois-Safety-Council-Professional-Development-Conference-Expo-",
    "url": "/news/Upcoming-Conference---2015-Iowa-Illinois-Safety-Council-Professional-Development-Conference-Expo-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Indiana Partners for Pollution Prevention – Annual Conference and Trade Show",
    "apiurl": "/restapi/customnewscontentlvl2/news/Indiana-Partners-for-Pollution-Prevention-Annual-Conference-and-Trade-Show",
    "url": "/news/Indiana-Partners-for-Pollution-Prevention-Annual-Conference-and-Trade-Show",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Policy DAR-10: NYSDEC Guidelines on Dispersion Modeling Procedures for Air Quality Impact Analysis",
    "apiurl": "/restapi/customnewscontentlvl2/news/final-policy-dar-10-nysdec-guidelines-on-dispersion-modeling-procedures-for-air-quality-impact-analysis",
    "url": "/news/final-policy-dar-10-nysdec-guidelines-on-dispersion-modeling-procedures-for-air-quality-impact-analysis",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Policy DAR-10: NYSDEC Guidelines on Dispersion Modeling Procedures for Air Quality Impact Analysis",
    "apiurl": "/restapi/customnewscontentlvl2/news/final-policy-dar-10-nysdec-guidelines-on-dispersion-modeling-procedures-for-air-quality-impact-analysis",
    "url": "/state/final-policy-dar-10-nysdec-guidelines-on-dispersion-modeling-procedures-for-air-quality-impact-analysis",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Georgia EPD Proposing to Update Air Permit Fee Manual",
    "apiurl": "/restapi/customnewscontentlvl2/news/Georgia-EPD-Proposing-to-Update-Air-Permit-Fee-Manual",
    "url": "/news/Georgia-EPD-Proposing-to-Update-Air-Permit-Fee-Manual",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Defining Solid Waste",
    "apiurl": "/restapi/customnewscontentlvl2/news/Defining-Solid-Waste",
    "url": "/news/Defining-Solid-Waste",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "FIPs for Six States Proposed to Reduce Interstate Transport of Ozone-Wisconsin",
    "apiurl": "/restapi/customnewscontentlvl2/news/FIPs-for-Six-States-Proposed-to-Reduce-Interstate-Transport-of-Ozone-Wisconsin",
    "url": "/news/FIPs-for-Six-States-Proposed-to-Reduce-Interstate-Transport-of-Ozone-Wisconsin",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Red Tape Reduction for Gasoline Dispensing Facilities Goes into Effect-Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/Red-Tape-Reduction-for-Gasoline-Dispensing-Facilities-Goes-into-Effect-Missouri",
    "url": "/news/Red-Tape-Reduction-for-Gasoline-Dispensing-Facilities-Goes-into-Effect-Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Issues Permitting Guidance for Greenhouse Gases",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Issues-Permitting-Guidance-for-Greenhouse-Gases",
    "url": "/news/EPA-Issues-Permitting-Guidance-for-Greenhouse-Gases",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Mandatory and Voluntary Carbon Markets: Current Status and Future Opportunities",
    "apiurl": "/restapi/customnewscontentlvl2/news/Mandatory-and-Voluntary-Carbon-Markets-Current-Status-and-Future-Opportunities",
    "url": "/news/Mandatory-and-Voluntary-Carbon-Markets-Current-Status-and-Future-Opportunities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2019 Condensate Tank Reporting Spreadsheet-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/2019-Condensate-Tank-Reporting-Spreadsheet-Colorado",
    "url": "/news/2019-Condensate-Tank-Reporting-Spreadsheet-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to Wyoming Air Quality Standards and Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-to-Wyoming-Air-Quality-Standards-and-Regulations",
    "url": "/news/Updates-to-Wyoming-Air-Quality-Standards-and-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revisions to South Carolina's State Implementation Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revisions-to-South-Carolina's-State-Implementation-Plan",
    "url": "/news/Revisions-to-South-Carolina's-State-Implementation-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Idaho DEQ Updates Air Dispersion Modeling Applicability Thresholds",
    "apiurl": "/restapi/customnewscontentlvl2/news/idaho-deq-updates-air-dispersion-modeling-applicability-thresholds",
    "url": "/news/idaho-deq-updates-air-dispersion-modeling-applicability-thresholds",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "UPDATE: Baton Rouge Region 2008 Ozone NAAQS Redesignation Request",
    "apiurl": "/restapi/customnewscontentlvl2/news/UPDATE-Baton-Rouge-Region-2008-Ozone-NAAQS-Redesignation-Request",
    "url": "/news/UPDATE-Baton-Rouge-Region-2008-Ozone-NAAQS-Redesignation-Request",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Maryland State Rule Updates Affecting Emergency Generator and Load Shaving Engines",
    "apiurl": "/restapi/customnewscontentlvl2/news/Maryland-State-Rule-Updates-Affecting-Emergency-Generator-and-Load-Shaving-Engines",
    "url": "/news/Maryland-State-Rule-Updates-Affecting-Emergency-Generator-and-Load-Shaving-Engines",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Revisions to Kentucky Standards of Performance for Indirect Heat Exchangers (401 KAR 59:015) After Comments",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Revisions-to-Kentucky-Standards-of-Performance-for-Indirect-Heat-Exchangers-(401-KAR-59-015)-After-Comments",
    "url": "/news/Proposed-Revisions-to-Kentucky-Standards-of-Performance-for-Indirect-Heat-Exchangers-(401-KAR-59-015)-After-Comments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates from the SafeBridge Analytical Laboratory",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-from-the-SafeBridge-Analytical-Laboratory",
    "url": "/news/Updates-from-the-SafeBridge-Analytical-Laboratory",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to Requirements for Heat Exchange Systems at Petroleum Refineries",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-to-Requirements-for-Heat-Exchange-Systems-at-Petroleum-Refineries",
    "url": "/news/Updates-to-Requirements-for-Heat-Exchange-Systems-at-Petroleum-Refineries",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Former Regulator Takes Reins in Trinity Consultants’ Albuquerque, NM Office",
    "apiurl": "/restapi/customnewscontentlvl2/news/Former-Regulator-Takes-Reins-in-Trinity-Consultants-Albuquerque-NM-Office",
    "url": "/news/Former-Regulator-Takes-Reins-in-Trinity-Consultants-Albuquerque-NM-Office",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Repeal of 20.2.37 NMAC - Petroleum Processing Facilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Repeal-of-20-2-37-NMAC---Petroleum-Processing-Facilities",
    "url": "/news/Proposed-Repeal-of-20-2-37-NMAC---Petroleum-Processing-Facilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Five Tips for Completing Your AWIA Emergency Response Plan Assessment",
    "apiurl": "/restapi/customnewscontentlvl2/news/five-tips-for-completing-your-awia-emergency-response-plan-assessment",
    "url": "/news/five-tips-for-completing-your-awia-emergency-response-plan-assessment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ohio EPA Updates Universal Waste Rules-Ohio",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ohio-EPA-Updates-Universal-Waste-Rules-Ohio",
    "url": "/news/Ohio-EPA-Updates-Universal-Waste-Rules-Ohio",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "COGCC Releases Notice to Operators-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/COGCC-Releases-Notice-to-Operators-Colorado",
    "url": "/news/COGCC-Releases-Notice-to-Operators-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Releases NEW AERSCREEN and AERMOD Models",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Releases-NEW-AERSCREEN-and-AERMOD-Models",
    "url": "/news/EPA-Releases-NEW-AERSCREEN-and-AERMOD-Models",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Electronic Submission of Reports to KDAQ",
    "apiurl": "/restapi/customnewscontentlvl2/news/Electronic",
    "url": "/news/Electronic",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEP Adopted Revisions to NAC 445B to Incorporate Federal Law",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEP-Adopted-Revisions-to-NAC-445B-to-Incorporate-Federal-Law-",
    "url": "/news/NDEP-Adopted-Revisions-to-NAC-445B-to-Incorporate-Federal-Law-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TDEC Division of Air Pollution Control Public Hearing",
    "apiurl": "/restapi/customnewscontentlvl2/news/TDEC-Division-of-Air-Pollution-Control-Public-Hearing-",
    "url": "/news/TDEC-Division-of-Air-Pollution-Control-Public-Hearing-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ProMax Level 2: Sour Gas Processing",
    "apiurl": "/restapi/customnewscontentlvl2/news/ProMax-Level-2-Sour-Gas-Processing",
    "url": "/news/ProMax-Level-2-Sour-Gas-Processing",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Changes to the Iowa Administrative Code",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Changes-to-the-Iowa-Administrative-Code",
    "url": "/news/Proposed-Changes-to-the-Iowa-Administrative-Code",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "VOC Recordkeeping for Surface Coating and Printing Operations; Emission Based Fee",
    "apiurl": "/restapi/customnewscontentlvl2/news/VOC-Recordkeeping-for-Surface-Coating-and-Printing-Operations-Emission-Based-Fee",
    "url": "/news/VOC-Recordkeeping-for-Surface-Coating-and-Printing-Operations-Emission-Based-Fee",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2014 Kansas Environmental Conference",
    "apiurl": "/restapi/customnewscontentlvl2/news/2014-Kansas-Environmental-Conference",
    "url": "/news/2014-Kansas-Environmental-Conference",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Recent Revisions to NJAC 7:27-16.3-New Jersey",
    "apiurl": "/restapi/customnewscontentlvl2/news/Recent-Revisions-to-NJAC-7-27-16-3-New-Jersey",
    "url": "/news/Recent-Revisions-to-NJAC-7-27-16-3-New-Jersey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Texas General Stormwater Permitting Updates: Stormwater Construction General Permit-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Texas-General-Stormwater-Permitting-Updates-Stormwater-Construction-General-Permit-Texas",
    "url": "/news/Texas-General-Stormwater-Permitting-Updates-Stormwater-Construction-General-Permit-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Upcoming Michigan Legislation for 2018-Michigan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Upcoming-Michigan-Legislation-for-2018-Michigan",
    "url": "/news/Upcoming-Michigan-Legislation-for-2018-Michigan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Emissions Fees Due by September 1, 2014",
    "apiurl": "/restapi/customnewscontentlvl2/news/Emissions-Fees-Due-by-September-1-2014",
    "url": "/news/Emissions-Fees-Due-by-September-1-2014",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Draft Rules for Utah’s Oil and Gas Industry",
    "apiurl": "/restapi/customnewscontentlvl2/news/Draft-Rules-for-Utah-s-Oil-and-Gas-Industry",
    "url": "/news/Draft-Rules-for-Utah-s-Oil-and-Gas-Industry",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Approves ADEM's Request to Redesignate Several AL Counties as Attainment",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Approves-ADEM's-Request-to-Redesignate-Several-AL-Counties-as-Attainment",
    "url": "/news/EPA-Approves-ADEM's-Request-to-Redesignate-Several-AL-Counties-as-Attainment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Control Measures to Reduce VOC Emissions from Surface Coating Operations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Control-Measures-to-Reduce-VOC-Emissions-from-Surface-Coating-Operations",
    "url": "/news/Control-Measures-to-Reduce-VOC-Emissions-from-Surface-Coating-Operations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendments",
    "url": "/news/Proposed-Amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "VMA Petition to Amend PSD Rules Progresses",
    "apiurl": "/restapi/customnewscontentlvl2/news/VMA-Petition-to-Amend-PSD-Rules-Progresses",
    "url": "/news/VMA-Petition-to-Amend-PSD-Rules-Progresses",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Promulgates the PSD and Title V GHG Tailoring Rule – Are You Ready to Respond?",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Promulgates-the-PSD-and-Title-V-GHG-Tailoring-Rule-Are-You-Ready-to-Respond-",
    "url": "/news/EPA-Promulgates-the-PSD-and-Title-V-GHG-Tailoring-Rule-Are-You-Ready-to-Respond-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EIQ Alert: Is your PTE Above 10 tpy?",
    "apiurl": "/restapi/customnewscontentlvl2/news/EIQ-Alert-Is-your-PTE-Above-10-tpy-",
    "url": "/news/EIQ-Alert-Is-your-PTE-Above-10-tpy-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2013 Reporting Reminders",
    "apiurl": "/restapi/customnewscontentlvl2/news/2013-Reporting-Reminders",
    "url": "/news/2013-Reporting-Reminders",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Additional Environmental Topics Discussed at the Air Quality Client Contact Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Additional-Environmental-Topics-Discussed-at-the-Air-Quality-Client-Contact-Meeting",
    "url": "/news/Additional-Environmental-Topics-Discussed-at-the-Air-Quality-Client-Contact-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Iowa RIDE Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/Iowa-RIDE-Program",
    "url": "/news/Iowa-RIDE-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Approves the Iowa Attainment Plan for Muscatine County",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-approves-iowa-attainment-plan-for-muscatine-county",
    "url": "/news/epa-approves-iowa-attainment-plan-for-muscatine-county",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NPRI Reports Due June 1, 2017-Alberta",
    "apiurl": "/restapi/customnewscontentlvl2/news/NPRI-Reports-Due-June-1-2017-Alberta",
    "url": "/news/NPRI-Reports-Due-June-1-2017-Alberta",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Annual Storm Water Inspections-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Annual-Storm-Water-Inspections-Kansas",
    "url": "/news/Annual-Storm-Water-Inspections-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD Accepting Comments for Regulation 6, Rule 5 Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/baaqmd-accepting-comments-for-regulation-6-rule-5-amendments",
    "url": "/news/baaqmd-accepting-comments-for-regulation-6-rule-5-amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD Accepting Comments for Regulation 6, Rule 5 Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/baaqmd-accepting-comments-for-regulation-6-rule-5-amendments",
    "url": "/state/baaqmd-accepting-comments-for-regulation-6-rule-5-amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Nebraska Public Records-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/Nebraska-Public-Records-Nebraska",
    "url": "/news/Nebraska-Public-Records-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ohio EPA and US EPA COVID-19 Response",
    "apiurl": "/restapi/customnewscontentlvl2/news/ohio-epa-and-us-epa-covid-19-response-",
    "url": "/news/ohio-epa-and-us-epa-covid-19-response-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ohio EPA and US EPA COVID-19 Response",
    "apiurl": "/restapi/customnewscontentlvl2/news/ohio-epa-and-us-epa-covid-19-response-",
    "url": "/states/ohio/ohio-epa-and-us-epa-covid-19-response",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Environmental Federation of Oklahoma (EFO)-Oklahoma",
    "apiurl": "/restapi/customnewscontentlvl2/news/Environmental-Federation-of-Oklahoma-(EFO)-Oklahoma",
    "url": "/news/Environmental-Federation-of-Oklahoma-(EFO)-Oklahoma",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Pennsylvania Governor Takes First Step to Join the Regional Greenhouse Gas Initiative-Pennsylvania",
    "apiurl": "/restapi/customnewscontentlvl2/news/Pennsylvania-Governor-Takes-First-Step-to-Join-the-Regional-Greenhouse-Gas-Initiative-Pennsylvania",
    "url": "/news/Pennsylvania-Governor-Takes-First-Step-to-Join-the-Regional-Greenhouse-Gas-Initiative-Pennsylvania",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New COGCC Rules Established Effective January 30, 2015",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-COGCC-Rules-Established-Effective-January-30-2015",
    "url": "/news/New-COGCC-Rules-Established-Effective-January-30-2015",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "California  Air Resources Board - Refrigerant Management Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/California-Air-Resources-Board---Refrigerant-Management-Program",
    "url": "/news/California-Air-Resources-Board---Refrigerant-Management-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Navigating NSPS Subpart Db for Boilers: A Case Study",
    "apiurl": "/restapi/customnewscontentlvl2/news/Navigating-NSPS-Subpart-Db-for-Boilers-A-Case-Study",
    "url": "/news/Navigating-NSPS-Subpart-Db-for-Boilers-A-Case-Study",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Midwest Environmental Compliance Conference May 11-13-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Midwest-Environmental-Compliance-Conference-May-11-13-Kansas",
    "url": "/news/Midwest-Environmental-Compliance-Conference-May-11-13-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2015 Ozone NAAQS Designations-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/2015-Ozone-NAAQS-Designations-Virginia",
    "url": "/news/2015-Ozone-NAAQS-Designations-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Maryland Department of the Environment Finalizes Rule Affecting Metal Parts and Products Coaters",
    "apiurl": "/restapi/customnewscontentlvl2/news/Maryland-Department-of-the-Environment-Finalizes-Rule-Affecting-Metal-Parts-and-Products-Coaters",
    "url": "/news/Maryland-Department-of-the-Environment-Finalizes-Rule-Affecting-Metal-Parts-and-Products-Coaters",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ozone Daily Forecasts Begin April 1-Mississippi",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ozone-Daily-Forecasts-Begin-April-1-Mississippi",
    "url": "/news/Ozone-Daily-Forecasts-Begin-April-1-Mississippi",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Latest News from TCEQ: Air Permitting Options for the Oil and Gas Industry",
    "apiurl": "/restapi/customnewscontentlvl2/news/latest-news-from-tceq-air-permitting-options-for-the-oil-and-gas-industry",
    "url": "/news/latest-news-from-tceq-air-permitting-options-for-the-oil-and-gas-industry",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Latest News from TCEQ: Air Permitting Options for the Oil and Gas Industry",
    "apiurl": "/restapi/customnewscontentlvl2/news/latest-news-from-tceq-air-permitting-options-for-the-oil-and-gas-industry",
    "url": "/latest-news-from-tceq-air-permitting-options-for-the-oil-and-gas-industry",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Change to the Annual Emission Statement Deadline in New Jersey-New Jersey",
    "apiurl": "/restapi/customnewscontentlvl2/news/Change-to-the-Annual-Emission-Statement-Deadline-in-New-Jersey-New-Jersey",
    "url": "/news/Change-to-the-Annual-Emission-Statement-Deadline-in-New-Jersey-New-Jersey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MassDEP Finalizes its Amendments to Air Pollution Control Regulations-Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/MassDEP-Finalizes-its-Amendments-to-Air-Pollution-Control-Regulations-Massachusetts",
    "url": "/news/MassDEP-Finalizes-its-Amendments-to-Air-Pollution-Control-Regulations-Massachusetts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Toxics Reduction Act Amendments-Ontario",
    "apiurl": "/restapi/customnewscontentlvl2/news/Toxics-Reduction-Act-Amendments-Ontario",
    "url": "/news/Toxics-Reduction-Act-Amendments-Ontario",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Preparing for the Major Source Boiler MACT Energy Assessment Deadline",
    "apiurl": "/restapi/customnewscontentlvl2/news/Preparing-for-the-Major-Source-Boiler-MACT-Energy-Assessment-Deadline",
    "url": "/news/Preparing-for-the-Major-Source-Boiler-MACT-Energy-Assessment-Deadline",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cook County Solid Waste and Recycling Ordinance",
    "apiurl": "/restapi/customnewscontentlvl2/news/Cook-County-Solid-Waste-and-Recycling-Ordinance",
    "url": "/news/Cook-County-Solid-Waste-and-Recycling-Ordinance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Updates, Instructions, and Clarifications for the 2020 Emission Inventory",
    "apiurl": "/restapi/customnewscontentlvl2/news/tceq-updates-instructions-and-clarifications-for-the-2020-emission-inventory",
    "url": "/news/tceq-updates-instructions-and-clarifications-for-the-2020-emission-inventory",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Quarterly Air Quality Client Contact Call Highlights - August 18, 2016",
    "apiurl": "/restapi/customnewscontentlvl2/news/Quarterly-Air-Quality-Client-Contact-Call-Highlights---August-18-2016",
    "url": "/news/Quarterly-Air-Quality-Client-Contact-Call-Highlights---August-18-2016",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Judge Blocks Oil & Gas Development on Wyoming Federal Land-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Judge-Blocks-Oil-Gas-Development-on-Wyoming-Federal-Land-Wyoming",
    "url": "/news/Judge-Blocks-Oil-Gas-Development-on-Wyoming-Federal-Land-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to AP-42 Emission Factors for Flares and Other Refinery Process Units",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-to-AP-42-Emission-Factors-for-Flares-and-Other-Refinery-Process-Units",
    "url": "/news/Updates-to-AP-42-Emission-Factors-for-Flares-and-Other-Refinery-Process-Units",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Official Ozone Non-Attainment Recommendations for Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/Official-Ozone-Non-Attainment-Recommendations-for-Utah",
    "url": "/news/Official-Ozone-Non-Attainment-Recommendations-for-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Iowans Invited to Help Set Water Quality Goals for Streams, Rivers",
    "apiurl": "/restapi/customnewscontentlvl2/news/Iowans-Invited-to-Help-Set-Water-Quality-Goals-for-Streams-Rivers",
    "url": "/news/Iowans-Invited-to-Help-Set-Water-Quality-Goals-for-Streams-Rivers",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Releases Draft Updates to Oil and Gas GOPs",
    "apiurl": "/restapi/customnewscontentlvl2/news/tceq-releases-draft-updates-to-oil-and-gas-gops",
    "url": "/news/tceq-releases-draft-updates-to-oil-and-gas-gops",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Virginia Air Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/Virginia-Air-Update",
    "url": "/news/Virginia-Air-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DNREC Finalizes Rule Limiting Emissions of Volatile Organic Compounds",
    "apiurl": "/restapi/customnewscontentlvl2/news/DNREC-Finalizes-Rule-Limiting-Emissions-of-Volatile-Organic-Compounds",
    "url": "/news/DNREC-Finalizes-Rule-Limiting-Emissions-of-Volatile-Organic-Compounds",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Governor Jan Brewer's Executive Order",
    "apiurl": "/restapi/customnewscontentlvl2/news/Governor-Jan-Brewer's-Executive-Order",
    "url": "/news/Governor-Jan-Brewer's-Executive-Order",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MCAQD Introduces a New, User-Friendly Interface System, IMPACT",
    "apiurl": "/restapi/customnewscontentlvl2/news/MCAQD-Introduces-a-New-User-Friendly-Interface-System-IMPACT",
    "url": "/news/MCAQD-Introduces-a-New-User-Friendly-Interface-System-IMPACT",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Draft of GP-5 and GP-5a Back Out for Comment-Pennsylvania",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-Draft-of-GP-5-and-GP-5a-Back-Out-for-Comment-Pennsylvania",
    "url": "/news/Final-Draft-of-GP-5-and-GP-5a-Back-Out-for-Comment-Pennsylvania",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity to Participate in Upcoming Clean Coal Webcast",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-to",
    "url": "/news/Trinity-to",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE ExDAM Featured at Process Safety Symposium – 2015",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-ExDAM-Featured-at-Process-Safety-Symposium-2015",
    "url": "/news/BREEZE-ExDAM-Featured-at-Process-Safety-Symposium-2015",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2011’s Big Four Clean Air Act Challenges",
    "apiurl": "/restapi/customnewscontentlvl2/news/Big-Four-Clean-Air-Act-Challenges",
    "url": "/news/Big-Four-Clean-Air-Act-Challenges",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Air Quality Rules Challenge Oil & Natural Gas Industry",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Air-Quality-Rules-Challenge-Oil-Natural-Gas-Industry",
    "url": "/news/New-Air-Quality-Rules-Challenge-Oil-Natural-Gas-Industry",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Modeling Tip: Importing a Base Map Image File in BREEZE AERMOD, CALPUFF, Incident Analyst, and 3D Analyst",
    "apiurl": "/restapi/customnewscontentlvl2/news/Modeling-Tip-Importing-a-Base-Map-Image-File-in-BREEZE-AERMOD-CALPUFF-Incident-Analyst-and-3D-Analyst",
    "url": "/news/Modeling-Tip-Importing-a-Base-Map-Image-File-in-BREEZE-AERMOD-CALPUFF-Incident-Analyst-and-3D-Analyst",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Heads Up for Oil and Gas Companies Regarding EPA’s National Enforcement Initiative",
    "apiurl": "/restapi/customnewscontentlvl2/news/Heads-Up-for-Oil-and-Gas-Companies-Regarding-EPA-s-National-Enforcement-Initiative",
    "url": "/news/Heads-Up-for-Oil-and-Gas-Companies-Regarding-EPA-s-National-Enforcement-Initiative",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Status Update on ISO 45001 - Occupational Health and Safety Management System Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/Status-Update-on-ISO-45001---Occupational-Health-and-Safety-Management-System-Standard",
    "url": "/news/Status-Update-on-ISO-45001---Occupational-Health-and-Safety-Management-System-Standard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Emissions Inventories Due by August 1, 2014",
    "apiurl": "/restapi/customnewscontentlvl2/news/Emissions-",
    "url": "/news/Emissions-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE AERMOD 7.9.2 Enhances the Productivity and Flexibility of the AERMOD Model",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-AERMOD-7-9-2-Enhances-the-Productivity-and-Flexibility-of-the-AERMOD-Model-",
    "url": "/news/BREEZE-AERMOD-7-9-2-Enhances-the-Productivity-and-Flexibility-of-the-AERMOD-Model-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LDEQ Finalizes AQ380S - Project Emissions and Offset Requirements-Louisiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/LDEQ-Finalizes-AQ380S---Project-Emissions-and-Offset-Requirements-Louisiana",
    "url": "/news/LDEQ-Finalizes-AQ380S---Project-Emissions-and-Offset-Requirements-Louisiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Tier I BACT: Exceptions and Alternate Controls-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Tier-I-BACT-Exceptions-and-Alternate-Controls-Texas",
    "url": "/news/Tier-I-BACT-Exceptions-and-Alternate-Controls-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Regulatory Summary - July 2009",
    "apiurl": "/restapi/customnewscontentlvl2/news/Regulatory-Summary---July-2009",
    "url": "/news/Regulatory-Summary---July-2009",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Kansas Tip of the Month - New Tier II Hazards-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Kansas-Tip-of-the-Month---New-Tier-II-Hazards-Kansas",
    "url": "/news/Kansas-Tip-of-the-Month---New-Tier-II-Hazards-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ecology Provides Update on Status of Washington Draft Greenhouse Gas Reporting Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ecology-Provides-Update-on-Status-of-Washington-Draft-Greenhouse-Gas-Reporting-Rule-",
    "url": "/news/Ecology-Provides-Update-on-Status-of-Washington-Draft-Greenhouse-Gas-Reporting-Rule-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Oil and Gas Maintenance, Start-up, and Shutdown Permit by Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/TCEQ-Oil-and-Gas-Maintenance-Start-up-and-Shutdown-Permit-by-Rule",
    "url": "/news/TCEQ-Oil-and-Gas-Maintenance-Start-up-and-Shutdown-Permit-by-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Nation's First Mandatory Market Based CO2 Reduction Initiative (RGGI) Completes a Successful One Year Run-Rhode Island",
    "apiurl": "/restapi/customnewscontentlvl2/news/Nation's-First-Mandatory-Market-Based-CO2-Reduction-Initiative-(RGGI)-Completes-a-Successful-One-Year-Run-Rhode-Island",
    "url": "/news/Nation's-First-Mandatory-Market-Based-CO2-Reduction-Initiative-(RGGI)-Completes-a-Successful-One-Year-Run-Rhode-Island",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GHG \"Tailoring\" Developments under PSD and Title V",
    "apiurl": "/restapi/customnewscontentlvl2/news/GHG-Tailoring-Developments-under-PSD-and-Title-V",
    "url": "/news/GHG-Tailoring-Developments-under-PSD-and-Title-V",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Title V Application Assistance-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Title-V-Application-Assistance-Iowa",
    "url": "/news/Title-V-Application-Assistance-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reporting Reminders-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reporting-Reminders-Iowa",
    "url": "/news/Reporting-Reminders-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Operating Permit Changes",
    "apiurl": "/restapi/customnewscontentlvl2/news/Operating-Permit-Changes",
    "url": "/news/Operating-Permit-Changes",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Annual Compliance Certification Forms Available-Oklahoma",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Annual-Compliance-Certification-Forms-Available-Oklahoma",
    "url": "/news/New-Annual-Compliance-Certification-Forms-Available-Oklahoma",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments to the SJVAPC District Rules 4306, 4320 and 4311",
    "apiurl": "/restapi/customnewscontentlvl2/news/proposed-amendments-to-the-sjvapc-district-rules-4306-4320-and-4311-",
    "url": "/news/proposed-amendments-to-the-sjvapc-district-rules-4306-4320-and-4311-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments to the SJVAPC District Rules 4306, 4320 and 4311",
    "apiurl": "/restapi/customnewscontentlvl2/news/proposed-amendments-to-the-sjvapc-district-rules-4306-4320-and-4311-",
    "url": "/news/state/california/proposed-amendments-to-the-sjvapc-district-rules-4306-4320-and-4311-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CalARP Regulation Amendments Effective Starting January 1, 2015",
    "apiurl": "/restapi/customnewscontentlvl2/news/CalARP-Regulation-Amendments-Effective-Starting-January-1-2015",
    "url": "/news/CalARP-Regulation-Amendments-Effective-Starting-January-1-2015",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CT DEEP Proposes Amendment to RCSA 22a-174-38 for Municipal Waste Combustors",
    "apiurl": "/restapi/customnewscontentlvl2/news/CT-DEEP-Pr",
    "url": "/news/CT-DEEP-Pr",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Visible Emissions Method 9-Mississippi",
    "apiurl": "/restapi/customnewscontentlvl2/news/Visible-Emissions-Method-9-Mississippi",
    "url": "/news/Visible-Emissions-Method-9-Mississippi",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Addressing Meteorological Data Requirements for RMP Offsite Consequence Analyses",
    "apiurl": "/restapi/customnewscontentlvl2/news/addressing-meteorological-data-requirements-for-rmp-offsite-consequence-analyses",
    "url": "/news/addressing-meteorological-data-requirements-for-rmp-offsite-consequence-analyses",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Addressing Meteorological Data Requirements for RMP Offsite Consequence Analyses",
    "apiurl": "/restapi/customnewscontentlvl2/news/addressing-meteorological-data-requirements-for-rmp-offsite-consequence-analyses",
    "url": "/News/Federal/Addressing-Meteorological-Data-Requirements-for-RMP-Offsite-Consequence-Analyses/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "An Inside Look: Trinity's EHS Digital Solutions Services",
    "apiurl": "/restapi/customnewscontentlvl2/news/an-inside-look-trinitys-ehs-digital-solutions-services",
    "url": "/news/an-inside-look-trinitys-ehs-digital-solutions-services",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Using Your EMS  to Improve Energy  Efficiency",
    "apiurl": "/restapi/customnewscontentlvl2/news/1ebc8ca3-cd53-40da-a20e-7710bb89c406",
    "url": "/news/1ebc8ca3-cd53-40da-a20e-7710bb89c406",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NMED Releases New Administrative Revision and Title V Amendment Forms-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/NMED-Releases-New-Administrative-Revision-and-Title-V-Amendment-Forms-New-Mexico",
    "url": "/news/NMED-Releases-New-Administrative-Revision-and-Title-V-Amendment-Forms-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Pennsylvania DEP COVID-19 Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/pennsylvania-dep-covid-19-updates",
    "url": "/news/pennsylvania-dep-covid-19-updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Pennsylvania DEP COVID-19 Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/pennsylvania-dep-covid-19-updates",
    "url": "/states/pennsylvania/pennsylvania-dep-covid-19-updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PCAQCD Begins Design of Their New Minor NSR Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/PCAQCD-Begins-Design-of-Their-New-Minor-NSR-Program",
    "url": "/news/PCAQCD-Begins-Design-of-Their-New-Minor-NSR-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Telephone Numbers for IDNR Air Quality Bureau",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Telephone-Numbers-for-IDNR-Air-Quality-Bureau",
    "url": "/news/New-Telephone-Numbers-for-IDNR-Air-Quality-Bureau",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Iowa Chapter of Air & Waste Management Association May Meeting-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Iowa-Chapter-of-Air-Waste-Management-Association-May-Meeting-Iowa",
    "url": "/news/Iowa-Chapter-of-Air-Waste-Management-Association-May-Meeting-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Comments Open on Missouri 2019 Monitoring Network Plan-Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/Comments-Open-on-Missouri-2019-Monitoring-Network-Plan-Missouri",
    "url": "/news/Comments-Open-on-Missouri-2019-Monitoring-Network-Plan-Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Nation's First Mandatory Market Based CO2 Reduction Initiative (RGGI) Completes a Successful One Year Run-New Hampshire",
    "apiurl": "/restapi/customnewscontentlvl2/news/Nation's-First-Mandatory-Market-Based-CO2-Reduction-Initiative-(RGGI)-Completes-a-Successful-One-Year-Run-New-Hampshire",
    "url": "/news/Nation's-First-Mandatory-Market-Based-CO2-Reduction-Initiative-(RGGI)-Completes-a-Successful-One-Year-Run-New-Hampshire",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Registration before Permitting for Hydraulic Fracturing in Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Registration-before-Permitting-for-Hydraulic-Fracturing-in-Illinois",
    "url": "/news/Registration-before-Permitting-for-Hydraulic-Fracturing-in-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DEQ Revises Regulations for Emissions Trading-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/DEQ-Revises-Regulations-for-Emissions-Trading-Virginia",
    "url": "/news/DEQ-Revises-Regulations-for-Emissions-Trading-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oklahoma Air Quality Rule Changes in Progress",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oklahoma-Air-Quality-Rule-Changes-in-Progress",
    "url": "/news/Oklahoma-Air-Quality-Rule-Changes-in-Progress",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Nebraska Reporting Reminders",
    "apiurl": "/restapi/customnewscontentlvl2/news/Nebraska-Reporting-Reminders",
    "url": "/news/Nebraska-Reporting-Reminders",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDE Publishes Draft General Permit to Construct for Emergency Generators (rated 373kW – 2000 kW)-Maryland",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDE-Publishes-Draft-General-Permit-to-Construct-for-Emergency-Generators-(rated-373kW-2000-kW)-Maryland",
    "url": "/news/MDE-Publishes-Draft-General-Permit-to-Construct-for-Emergency-Generators-(rated-373kW-2000-kW)-Maryland",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Bay Area AQMD Takes Initial Steps towards Rule Development Impacting Refineries and Toxic Air Contaminants from Existing Facilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/Bay-Area-AQMD-Takes-Initial-Steps-towards-Rule-Development-Impacting-Refineries-and-Toxic-Air-Contaminants-from-Existing-Facilities",
    "url": "/news/Bay-Area-AQMD-Takes-Initial-Steps-towards-Rule-Development-Impacting-Refineries-and-Toxic-Air-Contaminants-from-Existing-Facilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Kentucky Air Regulations and Permitting Training",
    "apiurl": "/restapi/customnewscontentlvl2/news/Kentucky-A",
    "url": "/news/Kentucky-A",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDNR Announces New eDMR System",
    "apiurl": "/restapi/customnewscontentlvl2/news/mdnr-announces-new-edmr-system",
    "url": "/news/mdnr-announces-new-edmr-system",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDNR Announces New eDMR System",
    "apiurl": "/restapi/customnewscontentlvl2/news/mdnr-announces-new-edmr-system",
    "url": "/news/state/missouri/mdnr-announces-new-edmr-system",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2019 Reporting Reminders-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/2019-Reporting-Reminders-Iowa",
    "url": "/news/2019-Reporting-Reminders-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DNREC Proposes Rule Amendments to Address EPA's SIP Call on Startup, Shutdown and Malfunction Emissions",
    "apiurl": "/restapi/customnewscontentlvl2/news/DNREC-Proposes-Rule-Amendments-to-Address-EPA's-SIP-Call-on-Startup-Shutdown-and-Malfunction-Emissions",
    "url": "/news/DNREC-Proposes-Rule-Amendments-to-Address-EPA's-SIP-Call-on-Startup-Shutdown-and-Malfunction-Emissions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Risk Assessments Now Needed for Nitrosamines in APIs and Drug Products",
    "apiurl": "/restapi/customnewscontentlvl2/news/risk-assessments-now-needed-for-nitrosamines-in-apis-and-drug",
    "url": "/news/risk-assessments-now-needed-for-nitrosamines-in-apis-and-drug",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD Drafts Initial Rules for Refinery Emission Limits and Reduction of Toxic Air Contaminants from Existing Facilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/BAAQMD-Drafts-Initial-Rules-for-Refinery-Emission-Limits-and-Reduction-of-Toxic-Air-Contaminants-from-Existing-Facilities",
    "url": "/news/BAAQMD-Drafts-Initial-Rules-for-Refinery-Emission-Limits-and-Reduction-of-Toxic-Air-Contaminants-from-Existing-Facilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Colorado RICE Off-Ramp Guidance Published",
    "apiurl": "/restapi/customnewscontentlvl2/news/Colorado-RICE-Off-Ramp-Guidance-Published",
    "url": "/news/Colorado-RICE-Off-Ramp-Guidance-Published",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NC Attorney General and DAQ set guidelines for determining what constitutes “solid waste incineration”",
    "apiurl": "/restapi/customnewscontentlvl2/news/NC-Attorney-General-and-DAQ-set-guidelines-for-determining-what-constitutes-solid-waste-incineration-",
    "url": "/news/NC-Attorney-General-and-DAQ-set-guidelines-for-determining-what-constitutes-solid-waste-incineration-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Missouri 2017 Monitoring Network Plan-Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/Missouri-2017-Monitoring-Network-Plan-Missouri",
    "url": "/news/Missouri-2017-Monitoring-Network-Plan-Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Doug McCormick Retires from Trinity’s Bakersfield Office",
    "apiurl": "/restapi/customnewscontentlvl2/news/Doug-McCormick-Retires-from-Trinity-s-Bakersfield-Office",
    "url": "/news/Doug-McCormick-Retires-from-Trinity-s-Bakersfield-Office",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Water and Waste Advisory Board Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Water-and-Waste-Advisory-Board-Meeting",
    "url": "/news/Water-and-Waste-Advisory-Board-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDNR Restructures Hazardous Waste Program-Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDNR-Restructures-Hazardous-Waste-Program-Missouri",
    "url": "/news/MDNR-Restructures-Hazardous-Waste-Program-Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Terminates Temporary Policy on COVID-19 Implications for Enforcement and Compliance",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-terminates-temporary-policy-on-covid-19-implications-for-enforcement-and-compliance",
    "url": "/news/epa-terminates-temporary-policy-on-covid-19-implications-for-enforcement-and-compliance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Terminates Temporary Policy on COVID-19 Implications for Enforcement and Compliance",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-terminates-temporary-policy-on-covid-19-implications-for-enforcement-and-compliance",
    "url": "/News/Federal/EPA-Terminates-Temporary-Policy-on-COVID-19-Implications-for-Enforcement-and-Compliance/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Montana CAAAC Meeting Updates-Montana",
    "apiurl": "/restapi/customnewscontentlvl2/news/Montana-CAAAC-Meeting-Updates-Montana",
    "url": "/news/Montana-CAAAC-Meeting-Updates-Montana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on PM2.5 NAAQS in Illinois - May 2019-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-PM2-5-NAAQS-in-Illinois---May-2019-Illinois",
    "url": "/news/Update-on-PM2-5-NAAQS-in-Illinois---May-2019-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Amendments to MCAQD Rule 241:  Minor New Source Review",
    "apiurl": "/restapi/customnewscontentlvl2/news/Amendments-to-MCAQD-Rule-241-Minor-New-Source-Review",
    "url": "/news/Amendments-to-MCAQD-Rule-241-Minor-New-Source-Review",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Sustainable Groundwater Management Act",
    "apiurl": "/restapi/customnewscontentlvl2/news/sustainable-groundwater-management-act",
    "url": "/news/sustainable-groundwater-management-act",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Sustainable Groundwater Management Act",
    "apiurl": "/restapi/customnewscontentlvl2/news/sustainable-groundwater-management-act",
    "url": "/states/sustainable-groundwater-management-act",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Establishes New 1-hour Standard for Sulfur Dioxide",
    "apiurl": "/restapi/customnewscontentlvl2/news/baefbdfd-8f28-416d-bf3f-fefdcc9677d3",
    "url": "/news/baefbdfd-8f28-416d-bf3f-fefdcc9677d3",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2014 Reporting Reminders",
    "apiurl": "/restapi/customnewscontentlvl2/news/2014-Reporting-Reminders",
    "url": "/news/2014-Reporting-Reminders",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reminder - 2010 Annual Emissions Statements Due to NJDEP by May 15, 2011",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reminder---2010-Annual-Emissions-Statements-Due-to-NJDEP-by-May-15-2011",
    "url": "/news/Reminder---2010-Annual-Emissions-Statements-Due-to-NJDEP-by-May-15-2011",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NMED Assumes Delegation of NSPS OOOO",
    "apiurl": "/restapi/customnewscontentlvl2/news/NMED-Assumes-Delegation-of-NSPS-OOOO",
    "url": "/news/NMED-Assumes-Delegation-of-NSPS-OOOO",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NMED Develops Electronic GIS Mapping Tool for Permitted Sources in New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/NMED-Develops-Electronic-GIS-Mapping-Tool-for-Permitted-Sources-in-New-Mexico",
    "url": "/news/NMED-Develops-Electronic-GIS-Mapping-Tool-for-Permitted-Sources-in-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "A New Approach to SSM Emissions Management",
    "apiurl": "/restapi/customnewscontentlvl2/news/A-New-Approach-to-SSM-Emissions-Management",
    "url": "/news/A-New-Approach-to-SSM-Emissions-Management",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Recent Boiler MACT Standard Developments",
    "apiurl": "/restapi/customnewscontentlvl2/news/Recent-Boi",
    "url": "/news/Recent-Boi",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Coming Soon in Wisconsin!-Wisconsin",
    "apiurl": "/restapi/customnewscontentlvl2/news/Coming-Soon-in-Wisconsin!-Wisconsin",
    "url": "/news/Coming-Soon-in-Wisconsin!-Wisconsin",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Air Quality Regulations Incorporate GHG Tailoring Rule-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Air-Quality-Regulations-Incorporate-GHG-Tailoring-Rule-Iowa",
    "url": "/news/Proposed-Air-Quality-Regulations-Incorporate-GHG-Tailoring-Rule-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Region 7 Meeting Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-region-7-meeting-updates",
    "url": "/news/epa-region-7-meeting-updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Effects of Proposed Ozone Standards on Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Effects-of-Proposed-Ozone-Standards-on-Wyoming",
    "url": "/news/Effects-of-Proposed-Ozone-Standards-on-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CSAPR - The New Transport Rule (Not a Very Friendly Ghost)",
    "apiurl": "/restapi/customnewscontentlvl2/news/CSAPR---The-New-Transport-Rule-(Not-a-Very-Friendly-Ghost)",
    "url": "/news/CSAPR---The-New-Transport-Rule-(Not-a-Very-Friendly-Ghost)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Substantive Changes to LDEQ Proposed Rule AQ380-Louisiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/Substantive-Changes-to-LDEQ-Proposed-Rule-AQ380-Louisiana",
    "url": "/news/Substantive-Changes-to-LDEQ-Proposed-Rule-AQ380-Louisiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Environmental Awareness Fuels a Career and Lifestyle",
    "apiurl": "/restapi/customnewscontentlvl2/news/-Environmental-Awareness-Fuels-a-Career-and-Lifestyle-",
    "url": "/news/-Environmental-Awareness-Fuels-a-Career-and-Lifestyle-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "State of Illinois - CUT THE RED TAPE!-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/State-of-Illinois---CUT-THE-RED-TAPE!-Illinois",
    "url": "/news/State-of-Illinois---CUT-THE-RED-TAPE!-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Acquires Canadian Water Quality Firm Minnow Environmental",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Acquires-Canadian-Water-Quality-Firm-Minnow-Environmental",
    "url": "/news/Trinity-Consultants-Acquires-Canadian-Water-Quality-Firm-Minnow-Environmental",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ NSR and Title V Permit Renewal Applications",
    "apiurl": "/restapi/customnewscontentlvl2/news/tceq-nsr-and-title-v-permit-renewal-applications",
    "url": "/news/tceq-nsr-and-title-v-permit-renewal-applications",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ NSR and Title V Permit Renewal Applications",
    "apiurl": "/restapi/customnewscontentlvl2/news/tceq-nsr-and-title-v-permit-renewal-applications",
    "url": "/states/texas/tceq-nsr-and-title-v-permit-renewal-applications",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Manufacturers and Importers Required to Submit TSCA CDR Reports in 2016",
    "apiurl": "/restapi/customnewscontentlvl2/news/Manufactur",
    "url": "/news/Manufactur",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Arizona SIP/Pinal County SIP",
    "apiurl": "/restapi/customnewscontentlvl2/news/Arizona-SIP-Pinal-County-SIP",
    "url": "/news/Arizona-SIP-Pinal-County-SIP",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes to the National Pollutant Release Inventory (NPRI) Reporting Requirements for 2016 and 2017",
    "apiurl": "/restapi/customnewscontentlvl2/news/Changes-to-the-National-Pollutant-Release-Inventory-(NPRI)-Reporting-Requirements-for-2016-and-2017",
    "url": "/news/Changes-to-the-National-Pollutant-Release-Inventory-(NPRI)-Reporting-Requirements-for-2016-and-2017",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "RIDEM Published Final Rule Amendments to Several Air Quality Regulations -Rhode Island",
    "apiurl": "/restapi/customnewscontentlvl2/news/RIDEM-Published-Final-Rule-Amendments-to-Several-Air-Quality-Regulations--Rhode-Island",
    "url": "/news/RIDEM-Published-Final-Rule-Amendments-to-Several-Air-Quality-Regulations--Rhode-Island",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Approved Revisions to Rhode Island State Implementation Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Approved-Revisions-to-Rhode-Island-State-Implementation-Plan",
    "url": "/news/Approved-Revisions-to-Rhode-Island-State-Implementation-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Regulation for Canadian Petroleum Refineries & Petrochemical Facilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-regulation-for-canadian-petroleum-refineries-petrochemical-facilities",
    "url": "/news/new-regulation-for-canadian-petroleum-refineries-petrochemical-facilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD to Remove Ammonia Split Limit from Rule Governing NOx Emissions from Boilers, Steam Generators, and Process Heaters",
    "apiurl": "/restapi/customnewscontentlvl2/news/scaqmd-to-remove-ammonia-split-limit-from-rule-governing-nox-emissions-from-boilers-steam-generators-and-process-heaters",
    "url": "/news/scaqmd-to-remove-ammonia-split-limit-from-rule-governing-nox-emissions-from-boilers-steam-generators-and-process-heaters",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD to Remove Ammonia Split Limit from Rule Governing NOx Emissions from Boilers, Steam Generators, and Process Heaters",
    "apiurl": "/restapi/customnewscontentlvl2/news/scaqmd-to-remove-ammonia-split-limit-from-rule-governing-nox-emissions-from-boilers-steam-generators-and-process-heaters",
    "url": "/states/california/scaqmd-to-remove-ammonia-split-limit-from-rule-governing-nox-emissions-from-boilers-steam-generators-and-process-heaters",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Legislative Activity from the Wyoming Joint Minerals, Business, and Economic Development Committee-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Legislative-Activity-from-the-Wyoming-Joint-Minerals-Business-and-Economic-Development-Committee-Wyoming",
    "url": "/news/Legislative-Activity-from-the-Wyoming-Joint-Minerals-Business-and-Economic-Development-Committee-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reminder of the Low Emitter Rule in Nebraska-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reminder-of-the-Low-Emitter-Rule-in-Nebraska-Nebraska",
    "url": "/news/Reminder-of-the-Low-Emitter-Rule-in-Nebraska-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Implementation of NSR Program for PM2.5",
    "apiurl": "/restapi/customnewscontentlvl2/news/Implementation-of-NSR-Program-for-PM2-5",
    "url": "/news/Implementation-of-NSR-Program-for-PM2-5",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oil and Gas Air Summit Explores Implications of Serious Ozone Nonattainment-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oil-and-Gas-Air-Summit-Explores-Implications-of-Serious-Ozone-Nonattainment-Colorado",
    "url": "/news/Oil-and-Gas-Air-Summit-Explores-Implications-of-Serious-Ozone-Nonattainment-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Opens Office in Albany New York",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Opens-Office-in-Albany-New-York",
    "url": "/news/Trinity-Consultants-Opens-Office-in-Albany-New-York",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Rule: Authorization of Alabama State Hazardous Waste Management Program Revisions",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Rule-Authorization-of-Alabama-State-Hazardous-Waste-Management-Program-Revisions",
    "url": "/news/Proposed-Rule-Authorization-of-Alabama-State-Hazardous-Waste-Management-Program-Revisions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Missouri Reporting Reminders!",
    "apiurl": "/restapi/customnewscontentlvl2/news/Missouri-Reporting-Reminders!",
    "url": "/news/Missouri-Reporting-Reminders!",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD Proposes Stricter Emission Limits for Ovens, Oxidizers, and More",
    "apiurl": "/restapi/customnewscontentlvl2/news/scaqmd-proposes-stricter-emission-limits-for-ovens-oxidizers-and-more",
    "url": "/news/scaqmd-proposes-stricter-emission-limits-for-ovens-oxidizers-and-more",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes Rule for GHG Endangerment Finding",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-Rule-for-GHG-Endangerment-Finding",
    "url": "/news/EPA-Proposes-Rule-for-GHG-Endangerment-Finding",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GHG Reporting Deadline",
    "apiurl": "/restapi/customnewscontentlvl2/news/GHG-Reporting-Deadline",
    "url": "/news/GHG-Reporting-Deadline",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Omnibus Air Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Omnibus-Air-Rule",
    "url": "/news/Proposed-Omnibus-Air-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Responsible Care® Support for the Chemical, Oil and Gas Industries",
    "apiurl": "/restapi/customnewscontentlvl2/news/responsible-care-support-for-the-chemical-oil-and-gas-industries",
    "url": "/news/responsible-care-support-for-the-chemical-oil-and-gas-industries",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Responsible Care® Support for the Chemical, Oil and Gas Industries",
    "apiurl": "/restapi/customnewscontentlvl2/news/responsible-care-support-for-the-chemical-oil-and-gas-industries",
    "url": "/federal/responsible-care-support-for-the-chemical-oil-and-gas-industries",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Groundwater Salinity Studies Continue-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Groundwater-Salinity-Studies-Continue-Wyoming",
    "url": "/news/Groundwater-Salinity-Studies-Continue-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final RICE MACT Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-RICE-MACT-Rule",
    "url": "/news/Final-RICE-MACT-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Public Feedback Requested for Sage Grouse Executive Order-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Public-Feedback-Requested-for-Sage-Grouse-Executive-Order-Wyoming",
    "url": "/news/Public-Feedback-Requested-for-Sage-Grouse-Executive-Order-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Top 10 EHS Auditing Best Practices for During and After the Pandemic",
    "apiurl": "/restapi/customnewscontentlvl2/news/top-10-ehs-auditing-best-practices-for-during-and-after-the-pandemic",
    "url": "/news/top-10-ehs-auditing-best-practices-for-during-and-after-the-pandemic",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Emissions Fees Due to EPD by September 1st",
    "apiurl": "/restapi/customnewscontentlvl2/news/Emissions-Fees-Due-to-EPD-by-September-1st",
    "url": "/news/Emissions-Fees-Due-to-EPD-by-September-1st",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Extended Expiration for General Stormwater Permits Expiring in 2017-North Carolina",
    "apiurl": "/restapi/customnewscontentlvl2/news/Extended-Expiration-for-General-Stormwater-Permits-Expiring-in-2017-North-Carolina",
    "url": "/news/Extended-Expiration-for-General-Stormwater-Permits-Expiring-in-2017-North-Carolina",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Iowa Reporting Reminders",
    "apiurl": "/restapi/customnewscontentlvl2/news/Iowa-Reporting-Reminders",
    "url": "/news/Iowa-Reporting-Reminders",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CAIR Remanded",
    "apiurl": "/restapi/customnewscontentlvl2/news/CAIR-Remanded",
    "url": "/news/CAIR-Remanded",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reminder - Solvent Degreaser Rule Statewide Applicability begins January 1st",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reminder---Solvent-Degreaser-Rule-Statewide-Applicability-begins-January-1st",
    "url": "/news/Reminder---Solvent-Degreaser-Rule-Statewide-Applicability-begins-January-1st",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MassDEP 2018 Source Registration Due on February 7, 2020 for Triennial Filers-Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/MassDEP-2018-Source-Registration-Due-on-February-7-2020-for-Triennial-Filers-Massachusetts",
    "url": "/news/MassDEP-2018-Source-Registration-Due-on-February-7-2020-for-Triennial-Filers-Massachusetts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Maryland’s Alternate Public Review Process for NSPS Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/Maryland-s-Alternate-Public-Review-Process-for-NSPS-Sources",
    "url": "/news/Maryland-s-Alternate-Public-Review-Process-for-NSPS-Sources",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed amendments to CO2 Budget Trading Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-amendments-to-CO2-Budget-Trading-Program",
    "url": "/news/Proposed-amendments-to-CO2-Budget-Trading-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ's Clarification of Affirmative Defense for Certain Excess Emissions",
    "apiurl": "/restapi/customnewscontentlvl2/news/TCEQ's-Clarification-of-Affirmative-Defense-for-Certain-Excess-Emissions",
    "url": "/news/TCEQ's-Clarification-of-Affirmative-Defense-for-Certain-Excess-Emissions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ISO 45001: 2018 Occupational Health and Safety Management System Standard: Operational Planning and Control",
    "apiurl": "/restapi/customnewscontentlvl2/news/ISO-45001-2018-Occupational-Health-and-Safety-Management-System-Standard-Operational-Planning-and-Control",
    "url": "/news/ISO-45001-2018-Occupational-Health-and-Safety-Management-System-Standard-Operational-Planning-and-Control",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ISO 45001: 2018 Occupational Health and Safety Management System Standard: Operational Planning and Control",
    "apiurl": "/restapi/customnewscontentlvl2/news/ISO-45001-2018-Occupational-Health-and-Safety-Management-System-Standard-Operational-Planning-and-Control",
    "url": "/news/ehs-management/ISO-45001-2018-Occupational-Health-and-Safety-Management-System-Standard-Operational-Planning-and-Control",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Developing a Boiler NESHAP Energy Assessment Strategy",
    "apiurl": "/restapi/customnewscontentlvl2/news/Developing-a-Boiler-NESHAP-Energy-Assessment-Strategy",
    "url": "/news/Developing-a-Boiler-NESHAP-Energy-Assessment-Strategy",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Acquires Toxicology and Industrial Hygiene Leader, SafeBridge Consultants",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Acquires-Toxicology-and-Industrial-Hygiene-Leader-SafeBridge-Consultants",
    "url": "/news/Trinity-Acquires-Toxicology-and-Industrial-Hygiene-Leader-SafeBridge-Consultants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New e-Reporting System – SLEIS",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-e-Reporting-System-SLEIS",
    "url": "/news/New-e-Reporting-System-SLEIS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "February AWMA Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/February-AWMA-Meeting",
    "url": "/news/February-AWMA-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Substantial Updates to NCDAQs PSD Modeling Guidance",
    "apiurl": "/restapi/customnewscontentlvl2/news/substantial-updates-to-ncdaqs-psd-modeling-guidance",
    "url": "/news/substantial-updates-to-ncdaqs-psd-modeling-guidance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revisions to the State Implementation Plan (SIP) for North Dakota",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revisions-to-the-State-Implementation-Plan-(SIP)-for-North-Dakota",
    "url": "/news/Revisions-to-the-State-Implementation-Plan-(SIP)-for-North-Dakota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ozone Nonattainment Area SIP Development Efforts",
    "apiurl": "/restapi/customnewscontentlvl2/news/-Ozone-Nonattainment-Area-SIP-Development-Efforts",
    "url": "/news/-Ozone-Nonattainment-Area-SIP-Development-Efforts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Permit Exemptions",
    "apiurl": "/restapi/customnewscontentlvl2/news/Permit-Exemptions",
    "url": "/news/Permit-Exemptions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Antelope Valley Attains Federal Ozone Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/Antelope-Valley-Attains-Federal-Ozone-Standard",
    "url": "/news/Antelope-Valley-Attains-Federal-Ozone-Standard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TDEC Publishes Draft Guidance on Low NOx Technology Requirements for New and Modified Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/tdec-publishes-draft-guidance-on-low-nox-technology-requirements-for-new-and-modified-sources",
    "url": "/news/tdec-publishes-draft-guidance-on-low-nox-technology-requirements-for-new-and-modified-sources",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MaineDEP 2020 Air Monitoring Network Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/mainedep-2020-air-monitoring-network-plan",
    "url": "/news/mainedep-2020-air-monitoring-network-plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MaineDEP 2020 Air Monitoring Network Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/mainedep-2020-air-monitoring-network-plan",
    "url": "/news/state/maine/mainedep-2020-air-monitoring-network-plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Michigan Reporting Reminders!",
    "apiurl": "/restapi/customnewscontentlvl2/news/Michigan-Reporting-Reminders!",
    "url": "/news/Michigan-Reporting-Reminders!",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Updates to National Enforcement Initiatives",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Updates-to-National-Enforcement-Initiatives",
    "url": "/news/Proposed-Updates-to-National-Enforcement-Initiatives",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2016 Status of Climate Change Strategies in California",
    "apiurl": "/restapi/customnewscontentlvl2/news/2016-Status-of-Climate-Change-Strategies-in-California",
    "url": "/news/2016-Status-of-Climate-Change-Strategies-in-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDNR Discusses Path Forward on SO2 NAAQS Modeling and Infrastructure and Nonattainment SIPs",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDNR-Discusses-Path-Forward-on-SO2-NAAQS-Modeling-and-Infrastructure-and-Nonattainment-SIPs",
    "url": "/news/MDNR-Discusses-Path-Forward-on-SO2-NAAQS-Modeling-and-Infrastructure-and-Nonattainment-SIPs",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Best of 2020: Training",
    "apiurl": "/restapi/customnewscontentlvl2/news/best-of-2020-training",
    "url": "/news/best-of-2020-training",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New NSPS OOOOa CEDRI Template Required for Annual Reports",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-nsps-ooooa-cedri-template-required-for-annual-reports",
    "url": "/news/new-nsps-ooooa-cedri-template-required-for-annual-reports",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PHA Inconsistency Series - Part II: The Cause of PHA Inconsistencies",
    "apiurl": "/restapi/customnewscontentlvl2/news/pha-inconsistency-series---part-ii-the-cause-of-pha-inconsistencies",
    "url": "/news/pha-inconsistency-series---part-ii-the-cause-of-pha-inconsistencies",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PHA Inconsistency Series - Part II: The Cause of PHA Inconsistencies",
    "apiurl": "/restapi/customnewscontentlvl2/news/pha-inconsistency-series---part-ii-the-cause-of-pha-inconsistencies",
    "url": "/Federal/PHA-Inconsistency-Series---Part-II--The-Cause-of-PHA-Inconsistencies/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NYSDEC Proposes Amendments to SEQR",
    "apiurl": "/restapi/customnewscontentlvl2/news/NYSDEC-Proposes-Amendments-to-SEQR",
    "url": "/news/NYSDEC-Proposes-Amendments-to-SEQR",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Missouri Air Conservation Commission (MACC) Meeting Updates-Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/Missouri-Air-Conservation-Commission-(MACC)-Meeting-Updates-Missouri",
    "url": "/news/Missouri-Air-Conservation-Commission-(MACC)-Meeting-Updates-Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Maintenance Fees",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Maintenance-Fees",
    "url": "/news/New-Maintenance-Fees",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "UDAQ to Recommend Emissions Fee Increase in 2017",
    "apiurl": "/restapi/customnewscontentlvl2/news/UDAQ-to-Recommend-Emissions-Fee-Increase-in-2017",
    "url": "/news/UDAQ-to-Recommend-Emissions-Fee-Increase-in-2017",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Approves Changes to Kentucky SIP for Air Toxics Regulation",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Approv",
    "url": "/news/EPA-Approv",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Next Steps to Take on EPA Proposed GHG Emissions Reporting Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Next-Steps",
    "url": "/news/Next-Steps",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Conditionally Exempt Sources and Insignificant Activity Rule Changes Deadlines-Minnesota",
    "apiurl": "/restapi/customnewscontentlvl2/news/Conditionally-Exempt-Sources-and-Insignificant-Activity-Rule-Changes-Deadlines-Minnesota",
    "url": "/news/Conditionally-Exempt-Sources-and-Insignificant-Activity-Rule-Changes-Deadlines-Minnesota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Second Annual Environmental Conference",
    "apiurl": "/restapi/customnewscontentlvl2/news/Second-Annual-Environmental-Conference",
    "url": "/news/Second-Annual-Environmental-Conference",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Stack Testing Final Adoption Repeal and Reenactment of R307-165",
    "apiurl": "/restapi/customnewscontentlvl2/news/stack-testing-final-adoption-repeal-and-reenactment-of-r307-165",
    "url": "/news/stack-testing-final-adoption-repeal-and-reenactment-of-r307-165",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Stack Testing Final Adoption Repeal and Reenactment of R307-165",
    "apiurl": "/restapi/customnewscontentlvl2/news/stack-testing-final-adoption-repeal-and-reenactment-of-r307-165",
    "url": "/states/stack-testing-final-adoption-repeal-and-reenactment-of-r307-165",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "State Recommended Redesignation Substitute (RS) SIP Revision for the DFW One-Hour and 1997 Eight-Hour Ozone Standard Nonattainment Area",
    "apiurl": "/restapi/customnewscontentlvl2/news/State-Recommended-Redesignation-Substitute-(RS)-SIP-Revision-for-the-DFW-One-Hour-and-1997-Eight-Hour-Ozone-Standard-Nonattainment-Area",
    "url": "/news/State-Recommended-Redesignation-Substitute-(RS)-SIP-Revision-for-the-DFW-One-Hour-and-1997-Eight-Hour-Ozone-Standard-Nonattainment-Area",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA Proposes to Approve Revised R307-107",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-Proposes-to-Approve-Revised-R307-107",
    "url": "/news/USEPA-Proposes-to-Approve-Revised-R307-107",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PM2.5 SIP Development Impacts on Emission Offsets",
    "apiurl": "/restapi/customnewscontentlvl2/news/PM2-5-SIP-Development-Impacts-on-Emission-Offsets",
    "url": "/news/PM2-5-SIP-Development-Impacts-on-Emission-Offsets",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Proposes NSR Rule Revisions",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ-Proposes-NSR-Rule-Revisions",
    "url": "/news/ADEQ-Proposes-NSR-Rule-Revisions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Wisconsin Reporting Reminders",
    "apiurl": "/restapi/customnewscontentlvl2/news/Wisconsin-Reporting-Reminders",
    "url": "/news/Wisconsin-Reporting-Reminders",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ISO 45001:2018 Occupational Health and Safety Management System Standard: Addressing Expectations of Other Interested Parties",
    "apiurl": "/restapi/customnewscontentlvl2/news/ISO-45001-2018-Occupational-Health-and-Safety-Management-System-Standard-Addressing-Expectations-of-Other-Interested-Parties",
    "url": "/news/ISO-45001-2018-Occupational-Health-and-Safety-Management-System-Standard-Addressing-Expectations-of-Other-Interested-Parties",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New PSM Enforcement Policies Effect Important Changes",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-PSM-Enforcement-Policies-Effect-Important-Changes-",
    "url": "/news/New-PSM-Enforcement-Policies-Effect-Important-Changes-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Changes to Oregon Air Permitting Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Changes-to-Oregon-Air-Permitting-Rules",
    "url": "/news/Proposed-Changes-to-Oregon-Air-Permitting-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREAKING - NMED Releases Draft Ozone Precursor Emissions Rules for Public Comment",
    "apiurl": "/restapi/customnewscontentlvl2/news/breaking---nmed-releases-draft-ozone-precursor-emissions-rules-for-public-comment",
    "url": "/news/breaking---nmed-releases-draft-ozone-precursor-emissions-rules-for-public-comment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREAKING - NMED Releases Draft Ozone Precursor Emissions Rules for Public Comment",
    "apiurl": "/restapi/customnewscontentlvl2/news/breaking---nmed-releases-draft-ozone-precursor-emissions-rules-for-public-comment",
    "url": "/states/new-mexico/breaking---nmed-releases-draft-ozone-precursor-emissions-rules-for-public-comment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Compliance Check-Up: Are You in Compliance with CEDRI Reporting Requirements?",
    "apiurl": "/restapi/customnewscontentlvl2/news/compliance-check-up-are-you-in-compliance-with-cedri-reporting-requirements",
    "url": "/news/compliance-check-up-are-you-in-compliance-with-cedri-reporting-requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Compliance Check-Up: Are You in Compliance with CEDRI Reporting Requirements?",
    "apiurl": "/restapi/customnewscontentlvl2/news/compliance-check-up-are-you-in-compliance-with-cedri-reporting-requirements",
    "url": "/news/federal/compliance-check-up--are-you-in-compliance-with-cedri-reporting-requirements-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Releases 1-hour SO2 Modeling Guidance and Initial Attainment Designation Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Releases-1-hour-SO2-Modeling-Guidance-and-Initial-Attainment-Designation-Plan",
    "url": "/news/EPA-Releases-1-hour-SO2-Modeling-Guidance-and-Initial-Attainment-Designation-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Requirements for Manifesting a Nonhazardous Special Waste",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-requirements-for-manifesting-a-nonhazardous-special-waste",
    "url": "/news/new-requirements-for-manifesting-a-nonhazardous-special-waste",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Requirements for Manifesting a Nonhazardous Special Waste",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-requirements-for-manifesting-a-nonhazardous-special-waste",
    "url": "/news/state/illinois/new-requirements-for-manifesting-a-nonhazardous-special-waste",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ozone NAAQS Revisions Proposed",
    "apiurl": "/restapi/customnewscontentlvl2/news/44e29767-32f9-4bde-9e28-0a5357f341c3",
    "url": "/news/44e29767-32f9-4bde-9e28-0a5357f341c3",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Annual Compliance Certification and Semi-Annual Monitoring & Deviation Reporting Forms",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Annual-Compliance-Certification-and-Semi-Annual-Monitoring-Deviation-Reporting-Forms",
    "url": "/news/New-Annual-Compliance-Certification-and-Semi-Annual-Monitoring-Deviation-Reporting-Forms",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revised BREEZE TankESP Software Accommodates Proposed EPA Emissions Methodologies",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revised-BREEZE-TankESP-Software-Accommodates-Proposed-EPA-Emissions-Methodologies",
    "url": "/news/Revised-BREEZE-TankESP-Software-Accommodates-Proposed-EPA-Emissions-Methodologies",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Amendments to APCR Regulation No. 5, Fugitive Dust",
    "apiurl": "/restapi/customnewscontentlvl2/news/Amendments-to-APCR-Regulation-No-5-Fugitive-Dust",
    "url": "/news/Amendments-to-APCR-Regulation-No-5-Fugitive-Dust",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TDEC Air Pollution Control Board Public Hearing-Tennessee",
    "apiurl": "/restapi/customnewscontentlvl2/news/TDEC-Air-Pollution-Control-Board-Public-Hearing-Tennessee",
    "url": "/news/TDEC-Air-Pollution-Control-Board-Public-Hearing-Tennessee",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NYSDEC Finalizes New Siting Considerations for Major Electric Generating Facilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/NYSDEC-Finalizes-New-Siting-Considerations-for-Major-Electric-Generating-Facilities",
    "url": "/news/NYSDEC-Finalizes-New-Siting-Considerations-for-Major-Electric-Generating-Facilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments to the Ferroalloys Production NESHAP",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendments-to-the-Ferroalloys-Production-NESHAP",
    "url": "/news/Proposed-Amendments-to-the-Ferroalloys-Production-NESHAP",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Clean Power Plan Finalized-South Carolina",
    "apiurl": "/restapi/customnewscontentlvl2/news/Clean-Power-Plan-Finalized-South-Carolina",
    "url": "/news/Clean-Power-Plan-Finalized-South-Carolina",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revised Part 212 Will Require Hot Mix Asphalt Plants in NY to Reduce NOx Emissions & Submit Plans by 3/1/2011",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revised-Part-212-Will-Require-Hot-Mix-Asphalt-Plants-in-NY-to-Reduce-NOx-Emissions-Submit-Plans-by-3-1-2011",
    "url": "/news/Revised-Part-212-Will-Require-Hot-Mix-Asphalt-Plants-in-NY-to-Reduce-NOx-Emissions-Submit-Plans-by-3-1-2011",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "COGCC’s New Mission and Appointments of New Objective Criteria for Existing Applications-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/COGCC-s-New-Mission-and-Appointments-of-New-Objective-Criteria-for-Existing-Applications-Colorado",
    "url": "/news/COGCC-s-New-Mission-and-Appointments-of-New-Objective-Criteria-for-Existing-Applications-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEQ Update - Air Quality Operating Permit Renewal Forms-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEQ-Update---Air-Quality-Operating-Permit-Renewal-Forms-Nebraska",
    "url": "/news/NDEQ-Update---Air-Quality-Operating-Permit-Renewal-Forms-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD Proposed Rule 1177 Liquefied Petroleum Gas Transfer and Dispensing",
    "apiurl": "/restapi/customnewscontentlvl2/news/SCAQMD-Proposed-Rule-1177-Liquefied-Petroleum-Gas-Transfer-and-Dispensing",
    "url": "/news/SCAQMD-Proposed-Rule-1177-Liquefied-Petroleum-Gas-Transfer-and-Dispensing",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Finalizes Guidance to Make PALs More User Friendly",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-finalizes-guidance-to-make-pals-more-user-friendly-",
    "url": "/news/epa-finalizes-guidance-to-make-pals-more-user-friendly-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Finalizes Guidance to Make PALs More User Friendly",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-finalizes-guidance-to-make-pals-more-user-friendly-",
    "url": "/news/federal/EPA-Finalizes-Guidance-to-Make-PALs-More-User-Friendly/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Finalizes Guidance to Make PALs More User Friendly",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-finalizes-guidance-to-make-pals-more-user-friendly-",
    "url": "/Federal/EPA-Finalizes-Guidance-to-Make-PALs-More-User-Friendly/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LDEQ Proposes Revisions to the Water Quality Regulations-Louisiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/LDEQ-Proposes-Revisions-to-the-Water-Quality-Regulations-Louisiana",
    "url": "/news/LDEQ-Proposes-Revisions-to-the-Water-Quality-Regulations-Louisiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Change in Montana De Minimis Levels",
    "apiurl": "/restapi/customnewscontentlvl2/news/Change-in-Montana-De-Minimis-Levels",
    "url": "/news/Change-in-Montana-De-Minimis-Levels",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Clean Power Plan Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/Clean-Power-Plan-Update",
    "url": "/news/Clean-Power-Plan-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Initiative to Update/Eliminate Outdated State Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Initiative-to-Update-Eliminate-Outdated-State-Regulations",
    "url": "/news/New-Initiative-to-Update-Eliminate-Outdated-State-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New IDNR Small Business Liaison Announced",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-IDNR-Small-Business-Liaison-Announced",
    "url": "/news/New-IDNR-Small-Business-Liaison-Announced",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Implications of the 2021 MSGP in Massachusetts and New Hampshire",
    "apiurl": "/restapi/customnewscontentlvl2/news/implications-of-the-2021-msgp-in-massachusetts-and-new-hampshire",
    "url": "/news/implications-of-the-2021-msgp-in-massachusetts-and-new-hampshire",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Permit by Rule for Small Boilers at CAAPP Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Permit-by-Rule-for-Small-Boilers-at-CAAPP-Sources",
    "url": "/news/Proposed-Permit-by-Rule-for-Small-Boilers-at-CAAPP-Sources",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Surface Coating Facilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/Surface-Coating-Facilities",
    "url": "/news/Surface-Coating-Facilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MassDEP Updates AQ02 & AQ03 Comprehensive Plan Approval Application Forms-Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/MassDEP-Updates-AQ02-AQ03-Comprehensive-Plan-Approval-Application-Forms-Massachusetts",
    "url": "/news/MassDEP-Updates-AQ02-AQ03-Comprehensive-Plan-Approval-Application-Forms-Massachusetts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Further Delay of Effective Date for EPA's Guideline on Air Quality Models",
    "apiurl": "/restapi/customnewscontentlvl2/news/Further-Delay-of-Effective-Date-for-EPA's-Guideline-on-Air-Quality-Models",
    "url": "/news/Further-Delay-of-Effective-Date-for-EPA's-Guideline-on-Air-Quality-Models",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Denver Ozone Redesignation Summary & FAQs-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Denver-Ozone-Redesignation-Summary-FAQs-Colorado",
    "url": "/news/Denver-Ozone-Redesignation-Summary-FAQs-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Public Comment Period on Adoption of VOC Content Standards-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Public-Comment-Period-on-Adoption-of-VOC-Content-Standards-Colorado",
    "url": "/news/Public-Comment-Period-on-Adoption-of-VOC-Content-Standards-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Carbon Pollution Standards for New, Modified, and Reconstructed Power Plants",
    "apiurl": "/restapi/customnewscontentlvl2/news/Carbon-Pollution-Standards-for-New-Modified-and-Reconstructed-Power-Plants",
    "url": "/news/Carbon-Pollution-Standards-for-New-Modified-and-Reconstructed-Power-Plants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ohio EPA’s eDocument Search Now Operational",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ohio-EPA-s-eDocument-Search-Now-Operational",
    "url": "/news/Ohio-EPA-s-eDocument-Search-Now-Operational",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to the GA Title V Software",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-to-the-GA-Title-V-Software",
    "url": "/news/Updates-to-the-GA-Title-V-Software",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Water Rules for Geologic Sequestration",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-Water-Rules-for-Geologic-Sequestration",
    "url": "/news/Final-Water-Rules-for-Geologic-Sequestration",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CA CARB 2020 Cap-and-Trade Forms and Guidance Posted",
    "apiurl": "/restapi/customnewscontentlvl2/news/ca-carb-2020-cap-and-trade-forms-and-guidance-posted",
    "url": "/news/ca-carb-2020-cap-and-trade-forms-and-guidance-posted",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Lead NAAQS Infrastructure SIP Available for Public Comment",
    "apiurl": "/restapi/customnewscontentlvl2/news/Lead-NAAQS-Infrastructure-SIP-Available-for-Public-Comment",
    "url": "/news/Lead-NAAQS-Infrastructure-SIP-Available-for-Public-Comment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Who Do I Send My Air Permit Reports To?",
    "apiurl": "/restapi/customnewscontentlvl2/news/Who-Do-I-Send-My-Air-Permit-Reports-To-",
    "url": "/news/Who-Do-I-Send-My-Air-Permit-Reports-To-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEE Guidance - Haul Road Requirements-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEE-Guidance---Haul-Road-Requirements-Nebraska",
    "url": "/news/NDEE-Guidance---Haul-Road-Requirements-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Pennsylvania DEP Evaluating Air Permitting Fee Changes-Pennsylvania",
    "apiurl": "/restapi/customnewscontentlvl2/news/Pennsylvania-DEP-Evaluating-Air-Permitting-Fee-Changes-Pennsylvania",
    "url": "/news/Pennsylvania-DEP-Evaluating-Air-Permitting-Fee-Changes-Pennsylvania",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Division for Air Quality Submits Recommended Nonattainment Areas for Revised 8-hr Ozone NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/Division-for-Air-Quality-Submits-Recommended-Nonattainment-Areas-for-Revised-8-hr-Ozone-NAAQS",
    "url": "/news/Division-for-Air-Quality-Submits-Recommended-Nonattainment-Areas-for-Revised-8-hr-Ozone-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "UPDATED - Changes to FER/EIS Reports for RY 2009",
    "apiurl": "/restapi/customnewscontentlvl2/news/UPDATED---Changes-to-FER-EIS-Reports-for-RY-2009",
    "url": "/news/UPDATED---Changes-to-FER-EIS-Reports-for-RY-2009",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Reverses Position On NAAQS Modeling/Evaluation",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ-Reverses-Position-On-NAAQS-Modeling-Evaluation",
    "url": "/news/ADEQ-Reverses-Position-On-NAAQS-Modeling-Evaluation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated Standard and General Air Quality Permit Conditions Now Available-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updated-Standard-and-General-Air-Quality-Permit-Conditions-Now-Available-Nebraska",
    "url": "/news/Updated-Standard-and-General-Air-Quality-Permit-Conditions-Now-Available-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Special Meeting on Proposed Changes to WAQSR, Chapter 8, Nonattainment Area Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Special-Meeting-on-Proposed-Changes-to-WAQSR-Chapter-8-Nonattainment-Area-Regulations",
    "url": "/news/Special-Meeting-on-Proposed-Changes-to-WAQSR-Chapter-8-Nonattainment-Area-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Does an Industry Need to Worry about Increased Usage of Sanitizers in SCAQMD?",
    "apiurl": "/restapi/customnewscontentlvl2/news/does-an-industry-need-to-worry-about-increased-usage-of-sanitizers-in-scaqmd-",
    "url": "/news/does-an-industry-need-to-worry-about-increased-usage-of-sanitizers-in-scaqmd-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ISO 45001: 2018 Occupational Health and Safety Management System Standard – Implementation of Integrated Management Systems",
    "apiurl": "/restapi/customnewscontentlvl2/news/iso-45001-2018-occupational-health-and-safety-management-system-standard-implementation-of-integrated-management-systems",
    "url": "/news/iso-45001-2018-occupational-health-and-safety-management-system-standard-implementation-of-integrated-management-systems",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes to Revise Definition of \"Waters of the United States\"",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-proposes-to-revise-definition-of-waters-of-the-united-states",
    "url": "/news/epa-proposes-to-revise-definition-of-waters-of-the-united-states",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes to Revise Definition of \"Waters of the United States\"",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-proposes-to-revise-definition-of-waters-of-the-united-states",
    "url": "/News/Federal/EPA-Proposes-to-Revise-Definition-of---Waters-of-the-United-States--/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes to Retain Current PM10 and PM2.5 NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-proposes-to-retain-current-pm10-and-pm2-5-naaqs",
    "url": "/news/epa-proposes-to-retain-current-pm10-and-pm2-5-naaqs",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes to Retain Current PM10 and PM2.5 NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-proposes-to-retain-current-pm10-and-pm2-5-naaqs",
    "url": "/federal/epa-proposes-to-retain-current-pm10-and-pm2-5-naaqs",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Extension of Comment Periods for Proposed Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Extension-of-Comment-Periods-for-Proposed-Regulations",
    "url": "/news/Extension-of-Comment-Periods-for-Proposed-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Interactive Tool Showing SO2 Reductions at Coal-Fired Power Plants",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Intera",
    "url": "/news/EPA-Intera",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PM10 Nonattainement Area Redesignation To Attainment-Montana",
    "apiurl": "/restapi/customnewscontentlvl2/news/PM10-Nonattainement-Area-Redesignation-To-Attainment-Montana",
    "url": "/news/PM10-Nonattainement-Area-Redesignation-To-Attainment-Montana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Solvent-based Cleaning Rule Revisions and New Requirements-Part 226-New York",
    "apiurl": "/restapi/customnewscontentlvl2/news/Solvent-based-Cleaning-Rule-Revisions-and-New-Requirements-Part-226-New-York",
    "url": "/news/Solvent-based-Cleaning-Rule-Revisions-and-New-Requirements-Part-226-New-York",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CARB Amends PERP and Portable Engine ATCM-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/CARB-Amends-PERP-and-Portable-Engine-ATCM-California",
    "url": "/news/CARB-Amends-PERP-and-Portable-Engine-ATCM-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GHG Reporting Registration",
    "apiurl": "/restapi/customnewscontentlvl2/news/GHG-Reporting-Registration",
    "url": "/news/GHG-Reporting-Registration",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposed Partial Approval of Arizona Regional Haze Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposed-Partial-Approval-of-Arizona-Regional-Haze-Plan",
    "url": "/news/EPA-Proposed-Partial-Approval-of-Arizona-Regional-Haze-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Title V Fee Increase for 2021-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Title-V-Fee-Increase-for-2021-Utah",
    "url": "/news/Proposed-Title-V-Fee-Increase-for-2021-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DNREC’s RACT SIP Revision Meets All 2015 Ozone NAAQS Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/dnrec-s-ract-sip-revision-meets-all-2015-ozone-naaqs-requirements",
    "url": "/news/dnrec-s-ract-sip-revision-meets-all-2015-ozone-naaqs-requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DNREC’s RACT SIP Revision Meets All 2015 Ozone NAAQS Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/dnrec-s-ract-sip-revision-meets-all-2015-ozone-naaqs-requirements",
    "url": "/news/state/delaware/dnrec-s-ract-sip-revision-meets-all-2015-ozone-naaqs-requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2015 Kansas Environmental Conference",
    "apiurl": "/restapi/customnewscontentlvl2/news/2015-Kansas-Environmental-Conference",
    "url": "/news/2015-Kansas-Environmental-Conference",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Updates to RCRA Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ-Updates-to-RCRA-Program",
    "url": "/news/ADEQ-Updates-to-RCRA-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Boiler MACT Compliance – Leveraging Lessons Learned From New Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/Boiler-MACT-Compliance-Leveraging-Lessons-Learned-From-New-Sources",
    "url": "/news/Boiler-MACT-Compliance-Leveraging-Lessons-Learned-From-New-Sources",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed New NJDEP Air Rulemaking Might Impact Your Facility in New Jersey!-New Jersey",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-New-NJDEP-Air-Rulemaking-Might-Impact-Your-Facility-in-New-Jersey!-New-Jersey",
    "url": "/news/Proposed-New-NJDEP-Air-Rulemaking-Might-Impact-Your-Facility-in-New-Jersey!-New-Jersey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cincinnati Environmental Justice Ordinance Summary",
    "apiurl": "/restapi/customnewscontentlvl2/news/Cincinnati-Environmental-Justice-Ordinance-Summary",
    "url": "/news/Cincinnati-Environmental-Justice-Ordinance-Summary",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "COP21 and What It Means for Companies",
    "apiurl": "/restapi/customnewscontentlvl2/news/COP21-and-What-It-Means-for-Companies-",
    "url": "/news/COP21-and-What-It-Means-for-Companies-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GHG Reporting in New Mexico UPDATE",
    "apiurl": "/restapi/customnewscontentlvl2/news/GHG-Reporting-in-New-Mexico-UPDATE",
    "url": "/news/GHG-Reporting-in-New-Mexico-UPDATE",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Potential Follow-up Investigations in Response to USA TODAY Special Report: \"The Smokestack Effect\"-Idaho",
    "apiurl": "/restapi/customnewscontentlvl2/news/Potential-Follow-up-Investigations-in-Response-to-USA-TODAY-Special-Report-The-Smokestack-Effect--Idaho",
    "url": "/news/Potential-Follow-up-Investigations-in-Response-to-USA-TODAY-Special-Report-The-Smokestack-Effect--Idaho",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Regional Haze Public Hearing",
    "apiurl": "/restapi/customnewscontentlvl2/news/Regional-Haze-Public-Hearing",
    "url": "/news/Regional-Haze-Public-Hearing",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants and Enviro One Join Forces in the Baton Rouge Market",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-and-Enviro-One-Join-Forces-in-the-Baton-Rouge-Market",
    "url": "/news/Trinity-Consultants-and-Enviro-One-Join-Forces-in-the-Baton-Rouge-Market",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on Expedited Permitting in Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-Expedited-Permitting-in-Texas",
    "url": "/news/Update-on-Expedited-Permitting-in-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Senior Staff in the Beehive State",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Senior-Staff-in-the-Beehive-State",
    "url": "/news/New-Senior-Staff-in-the-Beehive-State",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Approves Revised Virginia SIP",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-approves-revised-virginia-sip",
    "url": "/news/epa-approves-revised-virginia-sip",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Upcoming ADEM Public Hearings",
    "apiurl": "/restapi/customnewscontentlvl2/news/Upcoming-ADEM-Public-Hearings",
    "url": "/news/Upcoming-ADEM-Public-Hearings",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Water Quality Trading Program is Finalized by LDEQ-Louisiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/Water-Quality-Trading-Program-is-Finalized-by-LDEQ-Louisiana",
    "url": "/news/Water-Quality-Trading-Program-is-Finalized-by-LDEQ-Louisiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Pennsylvania's Final Draft of NSR for PM2.5 and Other Air Quality Regulation Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Pennsylvania's-Final-Draft-of-NSR-for-PM2-5-and-Other-Air-Quality-Regulation-Updates",
    "url": "/news/Pennsylvania's-Final-Draft-of-NSR-for-PM2-5-and-Other-Air-Quality-Regulation-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "District Department of the Environment (DDOE) Finalizes Amendments to Further Reduce Volatile Organic Compound and Hazardous Air Pollutant Emissions",
    "apiurl": "/restapi/customnewscontentlvl2/news/District-Department-of-the-Environment-(DDOE)-Finalizes-Amendments-to-Further-Reduce-Volatile-Organic-Compound-and-Hazardous-Air-Pollutant-Emissions",
    "url": "/news/District-Department-of-the-Environment-(DDOE)-Finalizes-Amendments-to-Further-Reduce-Volatile-Organic-Compound-and-Hazardous-Air-Pollutant-Emissions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revision to Missouri 2016 Monitoring Network Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revision-to-Missouri-2016-Monitoring-Network-Plan",
    "url": "/news/Revision-to-Missouri-2016-Monitoring-Network-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KDHE Revising SIP for the 2010 SO2 Primary NAAQS-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/KDHE-Revising-SIP-for-the-2010-SO2-Primary-NAAQS-Kansas",
    "url": "/news/KDHE-Revising-SIP-for-the-2010-SO2-Primary-NAAQS-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New 1-Hour SO2 NAAQS Standard affecting Missouri facilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-1-Hour-SO2-NAAQS-Standard-affecting-Missouri-facilities",
    "url": "/news/New-1-Hour-SO2-NAAQS-Standard-affecting-Missouri-facilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Suburban Cook County Liquid Hazardous Waste Reporting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Suburban-Cook-County-Liquid-Hazardous-Waste-Reporting",
    "url": "/news/Suburban-Cook-County-Liquid-Hazardous-Waste-Reporting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Permitting Regulation Changes in Oklahoma",
    "apiurl": "/restapi/customnewscontentlvl2/news/air-permitting-regulation-changes-in-oklahoma",
    "url": "/news/air-permitting-regulation-changes-in-oklahoma",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The Tailoring of Greenhouse Gases to the Clean Air Act – Challenges for PSD and Title V Permitting Ahead?",
    "apiurl": "/restapi/customnewscontentlvl2/news/The-Tailoring-of-Greenhouse-Gases-to-the-Clean-Air-Act-Challenges-for-PSD-and-Title-V-Permitting-Ahead-",
    "url": "/news/The-Tailoring-of-Greenhouse-Gases-to-the-Clean-Air-Act-Challenges-for-PSD-and-Title-V-Permitting-Ahead-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Overview of the Public Hearing Comments Regarding Public Notice Requirements of the Air Quality Standard Permit for Concrete Batch Plants",
    "apiurl": "/restapi/customnewscontentlvl2/news/Overview-of-the-Public-Hearing-Comments-Regarding-Public-Notice-Requirements-of-the-Air-Quality-Standard-Permit-for-Concrete-Batch-Plants",
    "url": "/news/Overview-of-the-Public-Hearing-Comments-Regarding-Public-Notice-Requirements-of-the-Air-Quality-Standard-Permit-for-Concrete-Batch-Plants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Alabama Annual Reporting Reminders",
    "apiurl": "/restapi/customnewscontentlvl2/news/Alabama-An",
    "url": "/news/Alabama-An",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Emission Inventory Changes",
    "apiurl": "/restapi/customnewscontentlvl2/news/Emission-Inventory-Changes",
    "url": "/news/Emission-Inventory-Changes",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Title V GHG Reporting Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/Title-V-GHG-Reporting-Requirements",
    "url": "/news/Title-V-GHG-Reporting-Requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Additional Information on NDEP’s Virtual Source Test Observation Program Pilot",
    "apiurl": "/restapi/customnewscontentlvl2/news/additional-information-on-ndep-s-virtual-source-test-observation-program-pilot",
    "url": "/news/additional-information-on-ndep-s-virtual-source-test-observation-program-pilot",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Additional Information on NDEP’s Virtual Source Test Observation Program Pilot",
    "apiurl": "/restapi/customnewscontentlvl2/news/additional-information-on-ndep-s-virtual-source-test-observation-program-pilot",
    "url": "/states/nevada/additional-information-on-ndep-s-virtual-source-test-observation-program-pilot",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BLM Waste Prevention Rule's Compliance Deadlines Delayed - Again-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/BLM-Waste-Prevention-Rule's-Compliance-Deadlines-Delayed---Again-Wyoming",
    "url": "/news/BLM-Waste-Prevention-Rule's-Compliance-Deadlines-Delayed---Again-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Odor Impact Service Offerings Available in Texas-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Odor-Impact-Service-Offerings-Available-in-Texas-Texas",
    "url": "/news/Odor-Impact-Service-Offerings-Available-in-Texas-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Delaware Department of Natural Resources and Environmental Control (DNREC) Proposes Amendments to Regulations for Emission Standards for Hazardous Air Pollutants for Source Categories",
    "apiurl": "/restapi/customnewscontentlvl2/news/Delaware-D",
    "url": "/news/Delaware-D",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Upcoming HMBP Deadline to Include New AB 1429 Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/upcoming-hmbp-deadline-to-include-new-ab-1429-requirements",
    "url": "/news/upcoming-hmbp-deadline-to-include-new-ab-1429-requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Upcoming HMBP Deadline to Include New AB 1429 Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/upcoming-hmbp-deadline-to-include-new-ab-1429-requirements",
    "url": "/news/states/california/upcoming-hmbp-deadline-to-include-new-ab-1429-requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated Version of AERMOD Released in December-South Carolina",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updated-Version-of-AERMOD-Released-in-December-South-Carolina",
    "url": "/news/Updated-Version-of-AERMOD-Released-in-December-South-Carolina",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ohio Air Permitting Update - US EPA Finally Approves the Less than 10 TPY BAT Exemption in Ohio's SIP-Ohio",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ohio-Air-Permitting-Update---US-EPA-Finally-Approves-the-Less-than-10-TPY-BAT-Exemption-in-Ohio's-SIP-Ohio",
    "url": "/news/Ohio-Air-Permitting-Update---US-EPA-Finally-Approves-the-Less-than-10-TPY-BAT-Exemption-in-Ohio's-SIP-Ohio",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "July-Aug: Pharmaceutical Outsourcing - Applying Health-Based Risk Assessments to Worker and Product Safety for Potent Pharmaceuticals in Contract Manufacturing Operations - Allan Ader, Tracy Kimmel, R",
    "apiurl": "/restapi/customnewscontentlvl2/news/July-Aug-Pharmaceutical-Outsourcing---Applying-Health-Based-Risk-Assessments-to-Worker-and-Product-Safety-for-Potent-Pharmaceuticals-in-Contract-Manufacturing-Operations---Allan-Ader-Tracy-Kimmel-R",
    "url": "/news/July-Aug-Pharmaceutical-Outsourcing---Applying-Health-Based-Risk-Assessments-to-Worker-and-Product-Safety-for-Potent-Pharmaceuticals-in-Contract-Manufacturing-Operations---Allan-Ader-Tracy-Kimmel-R",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "OSHA Process Safety Management - Potential Updates on the Horizon-Oklahoma",
    "apiurl": "/restapi/customnewscontentlvl2/news/OSHA-Process-Safety-Management---Potential-Updates-on-the-Horizon-Oklahoma",
    "url": "/news/OSHA-Process-Safety-Management---Potential-Updates-on-the-Horizon-Oklahoma",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Modeling Requirements in Bernalillo County",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Modeling-Requirements-in-Bernalillo-County",
    "url": "/news/New-Modeling-Requirements-in-Bernalillo-County",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Court Ruling Creates Uncertainty for Future RTR Rulemakings",
    "apiurl": "/restapi/customnewscontentlvl2/news/court-ruling-creates-uncertainty-for-future-rtr-rulemakings",
    "url": "/news/court-ruling-creates-uncertainty-for-future-rtr-rulemakings",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Court Ruling Creates Uncertainty for Future RTR Rulemakings",
    "apiurl": "/restapi/customnewscontentlvl2/news/court-ruling-creates-uncertainty-for-future-rtr-rulemakings",
    "url": "/federal/court-ruling-creates-uncertainty-for-future-rtr-rulemakings",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Issues Final Final 24-hour PM2.5 Designations",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Issues-Final-Final-24-hour-PM2-5-Designations",
    "url": "/news/EPA-Issues-Final-Final-24-hour-PM2-5-Designations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Mandatory GHG Reporting Rule Update: New Global Warming Potential Factors Effective January 1, 2014",
    "apiurl": "/restapi/customnewscontentlvl2/news/Mandatory-GHG-Reporting-Rule-Update-New-Global-Warming-Potential-Factors-Effective-January-1-2014",
    "url": "/news/Mandatory-GHG-Reporting-Rule-Update-New-Global-Warming-Potential-Factors-Effective-January-1-2014",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TDEC Show of the South-Tennessee",
    "apiurl": "/restapi/customnewscontentlvl2/news/TDEC-Show-of-the-South-Tennessee",
    "url": "/news/TDEC-Show-of-the-South-Tennessee",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Issues PCWP ICR to U.S. Wood Products Manufacturers-Idaho",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Issues-PCWP-ICR-to-U-S-Wood-Products-Manufacturers-Idaho",
    "url": "/news/EPA-Issues-PCWP-ICR-to-U-S-Wood-Products-Manufacturers-Idaho",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SO2 NAAQS Data Requirements Rule (DRR)",
    "apiurl": "/restapi/customnewscontentlvl2/news/SO2-NAAQS-Data-Requirements-Rule-(DRR)",
    "url": "/news/SO2-NAAQS-Data-Requirements-Rule-(DRR)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "RICE MACT Amendments Create New Challenges",
    "apiurl": "/restapi/customnewscontentlvl2/news/RICE-MACT-Amendments-Create-New-Challenges",
    "url": "/news/RICE-MACT-Amendments-Create-New-Challenges",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Rule for the Oil & Gas Industry",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Rule-for-the-Oil-Gas-Industry",
    "url": "/news/New-Rule-for-the-Oil-Gas-Industry",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "UDAQ Proposes Emissions Fee Increase for Fiscal Year 2016",
    "apiurl": "/restapi/customnewscontentlvl2/news/UDAQ-Proposes-Emissions-Fee-Increase-for-Fiscal-Year-2016",
    "url": "/news/UDAQ-Proposes-Emissions-Fee-Increase-for-Fiscal-Year-2016",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Georgia EPD Formalizes Nonattainment Area Air Quality Rule Change-Georgia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Georgia-EPD-Formalizes-Nonattainment-Area-Air-Quality-Rule-Change-Georgia",
    "url": "/news/Georgia-EPD-Formalizes-Nonattainment-Area-Air-Quality-Rule-Change-Georgia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SPCC Enforcement Action by EPA in Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/spcc-enforcement-action-by-epa-in-wyoming",
    "url": "/news/spcc-enforcement-action-by-epa-in-wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KDHE’s Website Now Referencing New EPA Guidance Database",
    "apiurl": "/restapi/customnewscontentlvl2/news/kdhe-s-website-now-referencing-new-epa-guidance-database",
    "url": "/news/kdhe-s-website-now-referencing-new-epa-guidance-database",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Getting Serious: The Latest on Ozone and Regulation Number 7 RACT Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/getting-serious-the-latest-on-ozone-and-regulation-number-7-ract-requirements",
    "url": "/news/getting-serious-the-latest-on-ozone-and-regulation-number-7-ract-requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Return of the Clean Air Interstate Rule—The Court Does CAIR",
    "apiurl": "/restapi/customnewscontentlvl2/news/Return-of-the-Clean-Air-Interstate-Rule-The-Court-Does-CAIR",
    "url": "/news/Return-of-the-Clean-Air-Interstate-Rule-The-Court-Does-CAIR",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA TRI Inquiries-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-TRI-Inquiries-Kansas",
    "url": "/news/EPA-TRI-Inquiries-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Emission Inventory Updates - When should you be submitting an emission inventory to the NMED",
    "apiurl": "/restapi/customnewscontentlvl2/news/emission-inventory-updates-when-should-you-be-submitting-an-emission-inventory-to-the-nmed",
    "url": "/news/emission-inventory-updates-when-should-you-be-submitting-an-emission-inventory-to-the-nmed",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Emission Inventory Updates - When should you be submitting an emission inventory to the NMED",
    "apiurl": "/restapi/customnewscontentlvl2/news/emission-inventory-updates-when-should-you-be-submitting-an-emission-inventory-to-the-nmed",
    "url": "/emission-inventory-updates---when-should-you-be-submitting-an-emission-inventory-to-the-nmed",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Joins Forces with  Atlanta-Based Smith Aldridge",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Joins-Forces-with-Atlanta-Based-Smith-Aldridge",
    "url": "/news/Trinity-Consultants-Joins-Forces-with-Atlanta-Based-Smith-Aldridge",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Fee Amendments to Asbestos Rules on Public Notice",
    "apiurl": "/restapi/customnewscontentlvl2/news/Fee-Amendments-to-Asbestos-Rules-on-Public-Notice",
    "url": "/news/Fee-Amendments-to-Asbestos-Rules-on-Public-Notice",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Coast Air Quality Management District - Toxic Air Contaminants",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Coast-Air-Quality-Management-District---Toxic-Air-Contaminants",
    "url": "/news/South-Coast-Air-Quality-Management-District---Toxic-Air-Contaminants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SJVAPCD Adopts 2012 PM2.5 Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/SJVAPCD-Adopts-2012-PM2-5-Plan-",
    "url": "/news/SJVAPCD-Adopts-2012-PM2-5-Plan-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Approval and Promulgation of Air Quality Implementation Plans (Update to Definition of VOM)",
    "apiurl": "/restapi/customnewscontentlvl2/news/Approval-and-Promulgation-of-Air-Quality-Implementation-Plans-(Update-to-Definition-of-VOM)",
    "url": "/news/Approval-and-Promulgation-of-Air-Quality-Implementation-Plans-(Update-to-Definition-of-VOM)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Amendments to NSPS Subpart Y for Coal Preparation and Coal Processing Plants",
    "apiurl": "/restapi/customnewscontentlvl2/news/Amendments-to-NSPS-Subpart-Y-for-Coal-Preparation-and-Coal-Processing-Plants",
    "url": "/news/Amendments-to-NSPS-Subpart-Y-for-Coal-Preparation-and-Coal-Processing-Plants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "WDEQ Releases New Oil & Gas Permitting Guidance",
    "apiurl": "/restapi/customnewscontentlvl2/news/WDEQ-Releases-New-Oil-Gas-Permitting-Guidance",
    "url": "/news/WDEQ-Releases-New-Oil-Gas-Permitting-Guidance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments to ARB's GHG Mandatory Reporting and Cap-and-Trade Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendments-to-ARB's-GHG-Mandatory-Reporting-and-Cap-and-Trade-Regulations",
    "url": "/news/Proposed-Amendments-to-ARB's-GHG-Mandatory-Reporting-and-Cap-and-Trade-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Changes to Formaldehyde Ambient Air Limits",
    "apiurl": "/restapi/customnewscontentlvl2/news/proposed-changes-to-formaldehyde-ambient-air-limits",
    "url": "/news/proposed-changes-to-formaldehyde-ambient-air-limits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Expedited Permitting Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Expedited-Permitting-Updates",
    "url": "/news/Expedited-Permitting-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Nonattainment New Source Review/Ammonia Significant Emission Rate",
    "apiurl": "/restapi/customnewscontentlvl2/news/Nonattainment-New-Source-Review-Ammonia-Significant-Emission-Rate",
    "url": "/news/Nonattainment-New-Source-Review-Ammonia-Significant-Emission-Rate",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ozone Nonattainment Redesignation - How Does it Impact your Permitting Plans for 2020?-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ozone-Nonattainment-Redesignation---How-Does-it-Impact-your-Permitting-Plans-for-2020--Texas",
    "url": "/news/Ozone-Nonattainment-Redesignation---How-Does-it-Impact-your-Permitting-Plans-for-2020--Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Updates Global Warming Potential Values in the GHG Reporting Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Updates-Global-Warming-Potential-Values-in-the-GHG-Reporting-Rule",
    "url": "/news/EPA-Updates-Global-Warming-Potential-Values-in-the-GHG-Reporting-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revisions to COGCC Oil and Gas Permitting Process",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revisions-to-COGCC-Oil-and-Gas-Permitting-Process-",
    "url": "/news/Revisions-to-COGCC-Oil-and-Gas-Permitting-Process-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BC Environmental Assessment Legislation Anticipated-British Columbia",
    "apiurl": "/restapi/customnewscontentlvl2/news/BC-Environmental-Assessment-Legislation-Anticipated-British-Columbia",
    "url": "/news/BC-Environmental-Assessment-Legislation-Anticipated-British-Columbia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDE Finalizes Updates to Hazardous Waste Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/mde-finalizes-updates-to-hazardous-waste-regulations",
    "url": "/news/mde-finalizes-updates-to-hazardous-waste-regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed WDNR Background Concentrations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-WDNR-Background-Concentrations",
    "url": "/news/Proposed-WDNR-Background-Concentrations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LDEQ Proposes AQ380 Rule-Louisiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/LDEQ-Proposes-AQ380-Rule-Louisiana",
    "url": "/news/LDEQ-Proposes-AQ380-Rule-Louisiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PADEP Proposes Updates to PM2.5 Nonattainment New Source Review Regulations-Pennsylvania",
    "apiurl": "/restapi/customnewscontentlvl2/news/PADEP-Proposes-Updates-to-PM2-5-Nonattainment-New-Source-Review-Regulations-Pennsylvania",
    "url": "/news/PADEP-Proposes-Updates-to-PM2-5-Nonattainment-New-Source-Review-Regulations-Pennsylvania",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Tip of the Month - Spill Plan Compliance-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/Tip-of-the-Month---Spill-Plan-Compliance-Nebraska",
    "url": "/news/Tip-of-the-Month---Spill-Plan-Compliance-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LDEQ Recommendations to EPA for 2015 Ozone NAAQS Designations",
    "apiurl": "/restapi/customnewscontentlvl2/news/LDEQ-Recommendations-to-EPA-for-2015-Ozone-NAAQS-Designations",
    "url": "/news/LDEQ-Recommendations-to-EPA-for-2015-Ozone-NAAQS-Designations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA is Proposing to Approve ADEM's Request for Revisions to the SIPs",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-is-Pro",
    "url": "/news/EPA-is-Pro",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Environmental Tips and Resources for Winter Storm Recovery",
    "apiurl": "/restapi/customnewscontentlvl2/news/environmental-tips-and-resources-for-winter-storm-recovery",
    "url": "/news/environmental-tips-and-resources-for-winter-storm-recovery",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Quality Research in Utah-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Research-in-Utah-Utah",
    "url": "/news/Air-Quality-Research-in-Utah-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Permitting of Fire Pumps as Exempt Units through an Administrative Revision-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/Permitting-of-Fire-Pumps-as-Exempt-Units-through-an-Administrative-Revision-New-Mexico",
    "url": "/news/Permitting-of-Fire-Pumps-as-Exempt-Units-through-an-Administrative-Revision-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LDEQ Proposed Air Quality Updates-Louisiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/LDEQ-Proposed-Air-Quality-Updates-Louisiana",
    "url": "/news/LDEQ-Proposed-Air-Quality-Updates-Louisiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA's E-Manifest System Goes Live June 30th-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA's-E-Manifest-System-Goes-Live-June-30th-Nebraska",
    "url": "/news/EPA's-E-Manifest-System-Goes-Live-June-30th-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Green House Gases Reporting Final Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Green-House-Gases-Reporting-Final-Rule",
    "url": "/news/Green-House-Gases-Reporting-Final-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Modeling Tip: How to Import BREEZE AERMOD files into BREEZE Risk Analyst for Human Health Risk Assessments",
    "apiurl": "/restapi/customnewscontentlvl2/news/Modeling-Tip-How-to-Import-BREEZE-AERMOD-files-into-BREEZE-Risk-Analyst-for-Human-Health-Risk-Assessments",
    "url": "/news/Modeling-Tip-How-to-Import-BREEZE-AERMOD-files-into-BREEZE-Risk-Analyst-for-Human-Health-Risk-Assessments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Upcoming Change for Title V ACC and SAM Reports Electronic Submissions to ADEQ",
    "apiurl": "/restapi/customnewscontentlvl2/news/Upcoming-Change-for-Title-V-ACC-and-SAM-Reports-Electronic-Submissions-to-ADEQ",
    "url": "/news/Upcoming-Change-for-Title-V-ACC-and-SAM-Reports-Electronic-Submissions-to-ADEQ",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on SIP Modeling Efforts for 1-hour SO2 NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-SIP-Modeling-Efforts-for-1-hour-SO2-NAAQS",
    "url": "/news/Update-on-SIP-Modeling-Efforts-for-1-hour-SO2-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Leak Detection Using FLIR Camera-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/Leak-Detection-Using-FLIR-Camera-New-Mexico",
    "url": "/news/Leak-Detection-Using-FLIR-Camera-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SJVAPCD Publishes Rule 4306 and Rule 4320 Draft Rule Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/sjvapcd-publishes-rule-4306-and-rule-4320-draft-rule-amendments",
    "url": "/news/sjvapcd-publishes-rule-4306-and-rule-4320-draft-rule-amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SJVAPCD Publishes Rule 4306 and Rule 4320 Draft Rule Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/sjvapcd-publishes-rule-4306-and-rule-4320-draft-rule-amendments",
    "url": "/states/california/sjvapcd-publishes-rule-4306-and-rule-4320-draft-rule-amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Possible Rule Revision for Temporary Operations in Indiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/Possible-Rule-Revision-for-Temporary-Operations-in-Indiana",
    "url": "/news/Possible-Rule-Revision-for-Temporary-Operations-in-Indiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Supreme Court Stays the Implementation of USEPAs Clean Power Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Supreme-Court-Stays-the-Implementation-of-USEPAs-Clean-Power-Plan",
    "url": "/news/Supreme-Court-Stays-the-Implementation-of-USEPAs-Clean-Power-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Approval of PSD Programs in Eastern Kern, Imperial County, Placer County, and Yolo-Solano District",
    "apiurl": "/restapi/customnewscontentlvl2/news/Approval-of-PSD-Programs-in-Eastern-Kern-Imperial-County-Placer-County-and-Yolo-Solano-District",
    "url": "/news/Approval-of-PSD-Programs-in-Eastern-Kern-Imperial-County-Placer-County-and-Yolo-Solano-District",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "5 Reasons to Perform a Consequence Modeling Analysis for Your Facility",
    "apiurl": "/restapi/customnewscontentlvl2/news/5-Reasons-to-Perform-a-Consequence-Modeling-Analysis-for-Your-Facility-",
    "url": "/news/5-Reasons-to-Perform-a-Consequence-Modeling-Analysis-for-Your-Facility-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Partners with Gryphon Investors",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Partners-with-Gryphon-Investors",
    "url": "/news/Trinity-Consultants-Partners-with-Gryphon-Investors",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "National Emission Standards for Hazardous Air Pollutants: Generic Maximum Achievable Control Technology Standards for Ethylene Production Residual Risk and Technology Review",
    "apiurl": "/restapi/customnewscontentlvl2/news/national-emission-standards-for-hazardous-air-pollutants-generic-maximum-achievable-control-technology-standards-for-ethylene-production-residual-risk-and-technology-review",
    "url": "/news/national-emission-standards-for-hazardous-air-pollutants-generic-maximum-achievable-control-technology-standards-for-ethylene-production-residual-risk-and-technology-review",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "National Emission Standards for Hazardous Air Pollutants: Generic Maximum Achievable Control Technology Standards for Ethylene Production Residual Risk and Technology Review",
    "apiurl": "/restapi/customnewscontentlvl2/news/national-emission-standards-for-hazardous-air-pollutants-generic-maximum-achievable-control-technology-standards-for-ethylene-production-residual-risk-and-technology-review",
    "url": "/federal/neshap-generic-emact-standards-rtr",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Missouri Hazardous Waste Fee Increase Fails in Missouri General Assembly",
    "apiurl": "/restapi/customnewscontentlvl2/news/missouri-hazardous-waste-fee-increase-fails-in-missouri-general-assembly",
    "url": "/news/missouri-hazardous-waste-fee-increase-fails-in-missouri-general-assembly",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Missouri Hazardous Waste Fee Increase Fails in Missouri General Assembly",
    "apiurl": "/restapi/customnewscontentlvl2/news/missouri-hazardous-waste-fee-increase-fails-in-missouri-general-assembly",
    "url": "/states/missouri/missouri-hazardous-waste-fee-increase-fails-in-missouri-general-assembly",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oregon Toxics Rulemaking Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oregon-Toxics-Rulemaking-Update",
    "url": "/news/Oregon-Toxics-Rulemaking-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Electronic System for Annual Emissions Reporting",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Electronic-System-for-Annual-Emissions-Reporting",
    "url": "/news/New-Electronic-System-for-Annual-Emissions-Reporting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KDHE  Update - KEIMS-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/KDHE-Update---KEIMS-Kansas",
    "url": "/news/KDHE-Update---KEIMS-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Amendments to Federal Regulations Incorporated by Reference",
    "apiurl": "/restapi/customnewscontentlvl2/news/Amendments-to-Federal-Regulations-Incorporated-by-Reference-",
    "url": "/news/Amendments-to-Federal-Regulations-Incorporated-by-Reference-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DNREC Proposes Changes to Carbon Dioxide Budget Trading Program-Delaware",
    "apiurl": "/restapi/customnewscontentlvl2/news/DNREC-Proposes-Changes-to-Carbon-Dioxide-Budget-Trading-Program-Delaware",
    "url": "/news/DNREC-Proposes-Changes-to-Carbon-Dioxide-Budget-Trading-Program-Delaware",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments to the 2011 CISWI Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendments-to-the-2011-CISWI-Rules",
    "url": "/news/Proposed-Amendments-to-the-2011-CISWI-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Impact on Utah Sources if USEPA Lowers the Ozone Standards",
    "apiurl": "/restapi/customnewscontentlvl2/news/Impact-on-Utah-Sources-if-USEPA-Lowers-the-Ozone-Standards",
    "url": "/news/Impact-on-Utah-Sources-if-USEPA-Lowers-the-Ozone-Standards",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oregon DEQ Launches New Online Portal",
    "apiurl": "/restapi/customnewscontentlvl2/news/oregon-deq-launches-new-online-portal",
    "url": "/news/oregon-deq-launches-new-online-portal",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NJDEP Officially Announces Annual Emission Fees for Fiscal Year (FY) 2014",
    "apiurl": "/restapi/customnewscontentlvl2/news/NJDEP-Officially-Announces-Annual-Emission-Fees-for-Fiscal-Year-(FY)-2014",
    "url": "/news/NJDEP-Officially-Announces-Annual-Emission-Fees-for-Fiscal-Year-(FY)-2014",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Conducting a Sustainability Assessment: Practical Six-Step Approach for Addressing Stakeholder Interests",
    "apiurl": "/restapi/customnewscontentlvl2/news/Conducting-a-Sustainability-Assessment-Practical-Six-Step-Approach-for-Addressing-Stakeholder-Interests",
    "url": "/news/Conducting-a-Sustainability-Assessment-Practical-Six-Step-Approach-for-Addressing-Stakeholder-Interests",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Source Review Preconstruction Permitting Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Source-Review-Preconstruction-Permitting-Program",
    "url": "/news/New-Source-Review-Preconstruction-Permitting-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA to Propose Rule to Curb Ozone Pollution Crossing State Lines by October",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-to-Propose-Rule-to-Curb-Ozone-Pollution-Crossing-State-Lines-by-October",
    "url": "/news/EPA-to-Propose-Rule-to-Curb-Ozone-Pollution-Crossing-State-Lines-by-October",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KDHE Updates Air Quality Performance Testing Guidance",
    "apiurl": "/restapi/customnewscontentlvl2/news/kdhe-updates-air-quality-performance-testing-guidance",
    "url": "/news/kdhe-updates-air-quality-performance-testing-guidance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KDHE Updates Air Quality Performance Testing Guidance",
    "apiurl": "/restapi/customnewscontentlvl2/news/kdhe-updates-air-quality-performance-testing-guidance",
    "url": "/news/state/kansas/kdhe-updates-air-quality-performance-testing-guidance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Boiler MACT is Effective in NC on May 20, 2019-North Carolina",
    "apiurl": "/restapi/customnewscontentlvl2/news/Boiler-MACT-is-Effective-in-NC-on-May-20-2019-North-Carolina",
    "url": "/news/Boiler-MACT-is-Effective-in-NC-on-May-20-2019-North-Carolina",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Regulations Respecting Reduction in the Release of Methane and Certain Volatile Organic Compounds (Upstream Oil and Gas Sector)-Ontario",
    "apiurl": "/restapi/customnewscontentlvl2/news/Regulations-Respecting-Reduction-in-the-Release-of-Methane-and-Certain-Volatile-Organic-Compounds-(Upstream-Oil-and-Gas-Sector)-Ontario",
    "url": "/news/Regulations-Respecting-Reduction-in-the-Release-of-Methane-and-Certain-Volatile-Organic-Compounds-(Upstream-Oil-and-Gas-Sector)-Ontario",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "August 2014 Cap-and-Trade GHG Allowance Auction Details Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/August-2014-Cap-and-Trade-GHG-Allowance-Auction-Details-Released",
    "url": "/news/August-2014-Cap-and-Trade-GHG-Allowance-Auction-Details-Released",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Effects of Proposed Ozone Standards on Wyoming-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/Effects-of-Proposed-Ozone-Standards-on-Wyoming-New-Mexico",
    "url": "/news/Effects-of-Proposed-Ozone-Standards-on-Wyoming-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Forthcoming Revisions to the Guideline on Air Quality Models",
    "apiurl": "/restapi/customnewscontentlvl2/news/Forthcoming-Revisions-to-the-Guideline-on-Air-Quality-Models",
    "url": "/news/Forthcoming-Revisions-to-the-Guideline-on-Air-Quality-Models",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Coast Air Quality Management District - Proposed Amendments to Rule 1402",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Coast-Air-Quality-Management-District---Proposed-Amendments-to-Rule-1402",
    "url": "/news/South-Coast-Air-Quality-Management-District---Proposed-Amendments-to-Rule-1402",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SJVAPCD AB 617 Expedited BARCT Rule Evaluation Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/sjvapcd-ab-617-expedited-barct-rule-evaluation-update",
    "url": "/news/sjvapcd-ab-617-expedited-barct-rule-evaluation-update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments to 6 NYCRR Part 227-2, Reasonably Available Control Technology (RACT) for Oxides of Nitrogen (NOx)",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendments-to-6-NYCRR-Part-227-2-Reasonably-Available-Control-Technology-(RACT)-for-Oxides-of-Nitrogen-(NOx)",
    "url": "/news/Proposed-Amendments-to-6-NYCRR-Part-227-2-Reasonably-Available-Control-Technology-(RACT)-for-Oxides-of-Nitrogen-(NOx)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New KDAQ Permit Review Branch Manager",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-KDAQ-P",
    "url": "/news/New-KDAQ-P",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NMED Begins Initial Stakeholder Process for Ozone Attainment Initiative (OAI)-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/NMED-Begins-Initial-Stakeholder-Process-for-Ozone-Attainment-Initiative-(OAI)-New-Mexico",
    "url": "/news/NMED-Begins-Initial-Stakeholder-Process-for-Ozone-Attainment-Initiative-(OAI)-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Strategically Addressing PSD Calculations-Florida",
    "apiurl": "/restapi/customnewscontentlvl2/news/Strategically-Addressing-PSD-Calculations-Florida",
    "url": "/news/Strategically-Addressing-PSD-Calculations-Florida",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants, Inc. is Finalist for the “2012 Consultancy of the Year” Award",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Inc-is-Finalist-for-the-2012-Consultancy-of-the-Year-Award",
    "url": "/news/Trinity-Consultants-Inc-is-Finalist-for-the-2012-Consultancy-of-the-Year-Award",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "In Case You Missed It...Chapter 115 Rule Changes and March 1, 2013 Compliance Dates",
    "apiurl": "/restapi/customnewscontentlvl2/news/In-Case-You-Missed-It-Chapter-115-Rule-Changes-and-March-1-2013-Compliance-Dates",
    "url": "/news/In-Case-You-Missed-It-Chapter-115-Rule-Changes-and-March-1-2013-Compliance-Dates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Notifications for Excess Emissions and Significant Revision Applications",
    "apiurl": "/restapi/customnewscontentlvl2/news/Notifications-for-Excess-Emissions-and-Significant-Revision-Applications",
    "url": "/news/Notifications-for-Excess-Emissions-and-Significant-Revision-Applications",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Utah Department of Air Quality's Response to Uinta Basin Ozone",
    "apiurl": "/restapi/customnewscontentlvl2/news/Utah-Department-of-Air-Quality's-Response-to-Uinta-Basin-Ozone",
    "url": "/news/Utah-Department-of-Air-Quality's-Response-to-Uinta-Basin-Ozone",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The Latest Developments Regarding NSR Aggregation",
    "apiurl": "/restapi/customnewscontentlvl2/news/The-Latest-Developments-Regarding-NSR-Aggregation",
    "url": "/news/The-Latest-Developments-Regarding-NSR-Aggregation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Air Quality Monitor in Laramie County-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Air-Quality-Monitor-in-Laramie-County-Wyoming",
    "url": "/news/New-Air-Quality-Monitor-in-Laramie-County-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Wisconsin Updates Modeling and PSD Baseline Information-Wisconsin",
    "apiurl": "/restapi/customnewscontentlvl2/news/Wisconsin-Updates-Modeling-and-PSD-Baseline-Information-Wisconsin",
    "url": "/news/Wisconsin-Updates-Modeling-and-PSD-Baseline-Information-Wisconsin",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD Suspends Rule Development for Regulation 13, Rule 2 and Regulation 13, Rule 3",
    "apiurl": "/restapi/customnewscontentlvl2/news/baaqmd-suspends-rule-development-for-regulation-13-rule-2-and-regulation-13-rule-3",
    "url": "/news/baaqmd-suspends-rule-development-for-regulation-13-rule-2-and-regulation-13-rule-3",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD Suspends Rule Development for Regulation 13, Rule 2 and Regulation 13, Rule 3",
    "apiurl": "/restapi/customnewscontentlvl2/news/baaqmd-suspends-rule-development-for-regulation-13-rule-2-and-regulation-13-rule-3",
    "url": "/states/baaqmd-suspends-rule-development-for-regulation-13-rule-2-and-regulation-13-rule-3",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Missouri Regulations on Public Comment",
    "apiurl": "/restapi/customnewscontentlvl2/news/Missouri-Regulations-on-Public-Comment",
    "url": "/news/Missouri-Regulations-on-Public-Comment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Connecticut Department of Energy and Environmental Protection (DEEP) Proposes Updates to State Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Connecticut-Department-of-Energy-and-Environmental-Protection-Proposes-Updates-to-State-Regulations",
    "url": "/news/Connecticut-Department-of-Energy-and-Environmental-Protection-Proposes-Updates-to-State-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Connecticut Department of Energy and Environmental Protection (DEEP) Proposes Updates to State Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Connecticut-Department-of-Energy-and-Environmental-Protection-Proposes-Updates-to-State-Regulations",
    "url": "/news/Connecticu",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Best of 2020: Industry Trade Shows & Presentations",
    "apiurl": "/restapi/customnewscontentlvl2/news/best-of-2020-industry-trade-shows-presentations",
    "url": "/news/best-of-2020-industry-trade-shows-presentations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Recognized in Dallas 100",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Recognized-in-Dallas-100",
    "url": "/news/Trinity-Consultants-Recognized-in-Dallas-100",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Emissions Inventory Workshops",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Emissions-Inventory-Workshops",
    "url": "/news/Air-Emissions-Inventory-Workshops",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Releases Final Control Techniques Guidelines for Reducing VOC Emissions from Existing O&G Equipment",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Releases-Final-Control-Techniques-Guidelines-for-Reducing-VOC-Emissions-from-Existing-O-G-Equipment",
    "url": "/news/EPA-Releases-Final-Control-Techniques-Guidelines-for-Reducing-VOC-Emissions-from-Existing-O-G-Equipment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Northeast Industrial Hygiene Conference: Risk Assessment and Control of Antibody-Drug Conjugates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Northeast-Industrial-Hygiene-Conference-Risk-Assessment-and-Control-of-Antibody-Drug-Conjugates",
    "url": "/news/Northeast-Industrial-Hygiene-Conference-Risk-Assessment-and-Control-of-Antibody-Drug-Conjugates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Boiler MACT Sets Aggressive Emission Limits",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Boiler-MACT-Sets-Aggressive-Emission-Limits",
    "url": "/news/Proposed-Boiler-MACT-Sets-Aggressive-Emission-Limits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DTSC – Proposal to List Unreacted Methylene Diphenyl Diisocyanates as a Priority Product-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/DTSC-Proposal-to-List-Unreacted-Methylene-Diphenyl-Diisocyanates-as-a-Priority-Product-California",
    "url": "/news/DTSC-Proposal-to-List-Unreacted-Methylene-Diphenyl-Diisocyanates-as-a-Priority-Product-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Area Source Boiler MACT Initial Notification",
    "apiurl": "/restapi/customnewscontentlvl2/news/Area-Source-Boiler-MACT-Initial-Notification",
    "url": "/news/Area-Source-Boiler-MACT-Initial-Notification",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "UDAQ to Amend Source Category Exemptions-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/UDAQ-to-Amend-Source-Category-Exemptions-Utah",
    "url": "/news/UDAQ-to-Amend-Source-Category-Exemptions-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Increase to Title V Permit Fees Finalized and Approved-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Increase-to-Title-V-Permit-Fees-Finalized-and-Approved-Virginia",
    "url": "/news/Increase-to-Title-V-Permit-Fees-Finalized-and-Approved-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NC Title V Air Permit Fees Increase",
    "apiurl": "/restapi/customnewscontentlvl2/news/NC-Title-V-Air-Permit-Fees-Increase",
    "url": "/news/NC-Title-V-Air-Permit-Fees-Increase",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendment to 10 CSR 10-6.220 Restriction of Emission of Visible Air Contaminants",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendment-to-10-CSR-10-6-220-Restriction-of-Emission-of-Visible-Air-Contaminants",
    "url": "/news/Proposed-Amendment-to-10-CSR-10-6-220-Restriction-of-Emission-of-Visible-Air-Contaminants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Green House Gas Reporting Program and Permitting Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Green-House-Gas-Reporting-Program-and-Permitting-Updates",
    "url": "/news/Green-House-Gas-Reporting-Program-and-Permitting-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Utah PM2.5 Serious Nonattainment SIPs – Next Steps-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/Utah-PM2-5-Serious-Nonattainment-SIPs-Next-Steps-Utah",
    "url": "/news/Utah-PM2-5-Serious-Nonattainment-SIPs-Next-Steps-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Takes Final Action on ADEQ NSR Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Takes-Final-Action-on-ADEQ-NSR-Program",
    "url": "/news/EPA-Takes-Final-Action-on-ADEQ-NSR-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Federal Standards Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/Federal-Standards-Update",
    "url": "/news/Federal-Standards-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KDHE Publishes Interim Guidance for CO2",
    "apiurl": "/restapi/customnewscontentlvl2/news/KDHE-Publishes-Interim-Guidance-for-CO2-",
    "url": "/news/KDHE-Publishes-Interim-Guidance-for-CO2-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Incorporating Mobile Solutions in EHS Information Management",
    "apiurl": "/restapi/customnewscontentlvl2/news/incorporating-mobile-solutions-in-ehs-information-management",
    "url": "/news/incorporating-mobile-solutions-in-ehs-information-management",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Incorporating Mobile Solutions in EHS Information Management",
    "apiurl": "/restapi/customnewscontentlvl2/news/incorporating-mobile-solutions-in-ehs-information-management",
    "url": "/News/Federal/Incorporating-Mobile-Solutions-in-EHS-Information-Management/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Rulemaking - Chapter 342: Exemption for Certain Quarries from the Aggregate Production Operation Registration Requirements of Texas Water Code, Chapter 28A-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Rulemaking---Chapter-342-Exemption-for-Certain-Quarries-from-the-Aggregate-Production-Operation-Registration-Requirements-of-Texas-Water-Code-Chapter-28A-Texas",
    "url": "/news/Proposed-Rulemaking---Chapter-342-Exemption-for-Certain-Quarries-from-the-Aggregate-Production-Operation-Registration-Requirements-of-Texas-Water-Code-Chapter-28A-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Carbon Disclosure Project (CDP) Gains Traction as Prominent Global GHG Database",
    "apiurl": "/restapi/customnewscontentlvl2/news/Carbon-Disclosure-Project-(CDP)-Gains-Traction-as-Prominent-Global-GHG-Database",
    "url": "/news/Carbon-Disclosure-Project-(CDP)-Gains-Traction-as-Prominent-Global-GHG-Database",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Three General VPDES Permits Proposed for Revision and Reissuance-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Three-General-VPDES-Permits-Proposed-for-Revision-and-Reissuance-Virginia",
    "url": "/news/Three-General-VPDES-Permits-Proposed-for-Revision-and-Reissuance-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Permitting Challenges for Spray Coating Operations in Washington",
    "apiurl": "/restapi/customnewscontentlvl2/news/Permitting-Challenges-for-Spray-Coating-Operations-in-Washington",
    "url": "/news/Permitting-Challenges-for-Spray-Coating-Operations-in-Washington",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Issues Intended Ozone NAAQS Nonattainment Boundaries for Clark County-Nevada",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Issues-Intended-Ozone-NAAQS-Nonattainment-Boundaries-for-Clark-County-Nevada",
    "url": "/news/EPA-Issues-Intended-Ozone-NAAQS-Nonattainment-Boundaries-for-Clark-County-Nevada",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "''Fugitive'' Sources Impacting Source Determinations-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/''Fugitive''-Sources-Impacting-Source-Determinations-Colorado",
    "url": "/news/''Fugitive''-Sources-Impacting-Source-Determinations-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DEQ Releases ASOP 10-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/DEQ-Releases-ASOP-10-Virginia",
    "url": "/news/DEQ-Releases-ASOP-10-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NY Proposes New Rule aligned with Climate Leadership and Community Protection Act for Oil and Natural Gas Sector",
    "apiurl": "/restapi/customnewscontentlvl2/news/ny-proposes-new-rule-aligned-with-climate-leadership-and-community-protection-act-for-oil-and-natural-gas-sector",
    "url": "/news/ny-proposes-new-rule-aligned-with-climate-leadership-and-community-protection-act-for-oil-and-natural-gas-sector",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Virginia DEQ Proposes Changes to Nonmetallic Mineral Processing General Permit",
    "apiurl": "/restapi/customnewscontentlvl2/news/virginia-deq-proposes-changes-to-nonmetallic-mineral-processing-general-permit",
    "url": "/news/virginia-deq-proposes-changes-to-nonmetallic-mineral-processing-general-permit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Environmental Protection Commission-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Environmental-Protection-Commission-Iowa",
    "url": "/news/Environmental-Protection-Commission-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NSPS OOOO Rule Finalized",
    "apiurl": "/restapi/customnewscontentlvl2/news/NSPS-OOOO-Rule-Finalized",
    "url": "/news/NSPS-OOOO-Rule-Finalized",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Outlook on Kansas DHE Air Regulatory Agenda-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Outlook-on-Kansas-DHE-Air-Regulatory-Agenda-Kansas",
    "url": "/news/Outlook-on-Kansas-DHE-Air-Regulatory-Agenda-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BWON and QQQ Overlap",
    "apiurl": "/restapi/customnewscontentlvl2/news/BWON-and-QQQ-Overlap",
    "url": "/news/BWON-and-QQQ-Overlap",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Illinois EPA Starts SO2 Modeling Process",
    "apiurl": "/restapi/customnewscontentlvl2/news/Illinois-EPA-Starts-SO2-Modeling-Process",
    "url": "/news/Illinois-EPA-Starts-SO2-Modeling-Process",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The EPA Continues to Comment on the TCEQ’s Air Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/The-EPA-Continues-to-Comment-on-the-TCEQ-s-Air-Program",
    "url": "/news/The-EPA-Continues-to-Comment-on-the-TCEQ-s-Air-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEQ Proposing Changes to Title 129 Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEQ-Proposing-Changes-to-Title-129-Regulations",
    "url": "/news/NDEQ-Proposing-Changes-to-Title-129-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on 2008 Ozone NAAQS Implementation",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-2008-Ozone-NAAQS-Implementation",
    "url": "/news/Update-on-2008-Ozone-NAAQS-Implementation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDNR Proposes New Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDNR-Proposes-New-Rules",
    "url": "/news/MDNR-Proposes-New-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "10 CSR 10-6.020 (amendment) Definitions and Common Reference Tables",
    "apiurl": "/restapi/customnewscontentlvl2/news/10-CSR-10-6-020-(amendment)-Definitions-and-Common-Reference-Tables",
    "url": "/news/10-CSR-10-6-020-(amendment)-Definitions-and-Common-Reference-Tables",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Clean Power Plan Finalized-North Carolina",
    "apiurl": "/restapi/customnewscontentlvl2/news/Clean-Power-Plan-Finalized-North-Carolina",
    "url": "/news/Clean-Power-Plan-Finalized-North-Carolina",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Stay Tuned – the Illinois General NPDES Permit for Industrial Activities to be Renewed Soon!",
    "apiurl": "/restapi/customnewscontentlvl2/news/Stay-Tuned-the-Illinois-General-NPDES-Permit-for-Industrial-Activities-to-be-Renewed-Soon!",
    "url": "/news/Stay-Tuned-the-Illinois-General-NPDES-Permit-for-Industrial-Activities-to-be-Renewed-Soon!",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update to Cedar Rapids Meteorological Data Used for Dispersion Modeling",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-to-Cedar-Rapids-Meteorological-Data-Used-for-Dispersion-Modeling",
    "url": "/news/Update-to-Cedar-Rapids-Meteorological-Data-Used-for-Dispersion-Modeling",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revisions to Oil and Gas Permit by Rule and Standard Permit Take Effect on April 1",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revisions-to-Oil-and-Gas-Permit-by-Rule-and-Standard-Permit-Take-Effect-on-April-1",
    "url": "/news/Revisions-to-Oil-and-Gas-Permit-by-Rule-and-Standard-Permit-Take-Effect-on-April-1",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Annual Compliance Certifications for Kentucky Permit Holders Due January 30, 2013",
    "apiurl": "/restapi/customnewscontentlvl2/news/Annual-Compliance-Certifications-for-Kentucky-Permit-Holders-Due-January-30-2013",
    "url": "/news/Annual-Compliance-Certifications-for-Kentucky-Permit-Holders-Due-January-30-2013",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New York to Adopt SNAP Program Rules at the State Level-New York",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-York-to-Adopt-SNAP-Program-Rules-at-the-State-Level-New-York",
    "url": "/news/New-York-to-Adopt-SNAP-Program-Rules-at-the-State-Level-New-York",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Michigan's Review of Interstate Transport of PM2.5",
    "apiurl": "/restapi/customnewscontentlvl2/news/Michigan's-Review-of-Interstate-Transport-of-PM2-5",
    "url": "/news/Michigan's-Review-of-Interstate-Transport-of-PM2-5",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ODS Rule Updates – Are You Prepared?",
    "apiurl": "/restapi/customnewscontentlvl2/news/ODS-Rule-Updates-Are-You-Prepared-",
    "url": "/news/ODS-Rule-Updates-Are-You-Prepared-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "WOTUS Update AND Impact to Protected Wetlands",
    "apiurl": "/restapi/customnewscontentlvl2/news/wotus-update-and-impact-to-protected-wetlands",
    "url": "/news/wotus-update-and-impact-to-protected-wetlands",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "WOTUS Update AND Impact to Protected Wetlands",
    "apiurl": "/restapi/customnewscontentlvl2/news/wotus-update-and-impact-to-protected-wetlands",
    "url": "/federal/wotus-update-and-impact-to-protected-wetlands",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated Air Quality Dispersion Modeling Manual Draft and Meteorological Data Available-Minnesota",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updated-Air-Quality-Dispersion-Modeling-Manual-Draft-and-Meteorological-Data-Available-Minnesota",
    "url": "/news/Updated-Air-Quality-Dispersion-Modeling-Manual-Draft-and-Meteorological-Data-Available-Minnesota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Pinal County Nonattainment Redesignation for PM10",
    "apiurl": "/restapi/customnewscontentlvl2/news/Pinal-County-Nonattainment-Redesignation-for-PM10",
    "url": "/news/Pinal-County-Nonattainment-Redesignation-for-PM10",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Emissions Inventory Workshop Presentation",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Emissions-Inventory-Workshop-Presentation",
    "url": "/news/Air-Emissions-Inventory-Workshop-Presentation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Frequently Asked Questions Regarding GHG Tailoring Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Frequently-Asked-Questions-Regarding-GHG-Tailoring-Rule",
    "url": "/news/Frequently-Asked-Questions-Regarding-GHG-Tailoring-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Virginia DEQ Begins Development of Regulations to Limit CO2 Emissions from Electric Power Facilities-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Virginia-DEQ-Begins-Development-of-Regulations-to-Limit-CO2-Emissions-from-Electric-Power-Facilities-Virginia",
    "url": "/news/Virginia-DEQ-Begins-Development-of-Regulations-to-Limit-CO2-Emissions-from-Electric-Power-Facilities-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to ADEQ's Air Quality Modeling Guidelines for Arizona Air Quality Permits",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-to-ADEQ's-Air-Quality-Modeling-Guidelines-for-Arizona-Air-Quality-Permits",
    "url": "/news/Updates-to-ADEQ's-Air-Quality-Modeling-Guidelines-for-Arizona-Air-Quality-Permits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Albuquerque-Bernalillo County Air Quality Control Board Meeting-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/Albuquerque-Bernalillo-County-Air-Quality-Control-Board-Meeting-New-Mexico",
    "url": "/news/Albuquerque-Bernalillo-County-Air-Quality-Control-Board-Meeting-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "General Air Permit for NESHAP Area Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/General-Air-Permit-for-NESHAP-Area-Sources",
    "url": "/news/General-Air-Permit-for-NESHAP-Area-Sources",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "All Louisiana Parishes Designated Attainment/Unclassifiable for 2015 Ozone NAAQS-Louisiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/All-Louisiana-Parishes-Designated-Attainment-Unclassifiable-for-2015-Ozone-NAAQS-Louisiana",
    "url": "/news/All-Louisiana-Parishes-Designated-Attainment-Unclassifiable-for-2015-Ozone-NAAQS-Louisiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Joins with Insight Environmental Consultants to Serve Central California",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Joins-with-Insight-Environmental-Consultants-to-Serve-Central-California",
    "url": "/news/Trinity-Joins-with-Insight-Environmental-Consultants-to-Serve-Central-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD Proposes to Hold Warehouse Owners Responsible for Truck Emissions, Other Districts Likely to Follow",
    "apiurl": "/restapi/customnewscontentlvl2/news/scaqmd-proposes-to-hold-warehouse-owners-responsible-for-truck-emissions-other-districts-likely-to-follow",
    "url": "/news/scaqmd-proposes-to-hold-warehouse-owners-responsible-for-truck-emissions-other-districts-likely-to-follow",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD Proposes to Hold Warehouse Owners Responsible for Truck Emissions, Other Districts Likely to Follow",
    "apiurl": "/restapi/customnewscontentlvl2/news/scaqmd-proposes-to-hold-warehouse-owners-responsible-for-truck-emissions-other-districts-likely-to-follow",
    "url": "/www.trinityconsultants.com/news/scaqmd-proposes-to-hold-warehouse-owners-responsible-for-truck-emissions-other-districts-likely-to-follow",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Forecast on Kansas Air Regulatory Agenda-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Forecast-on-Kansas-Air-Regulatory-Agenda-Kansas",
    "url": "/news/Forecast-on-Kansas-Air-Regulatory-Agenda-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NYSDEC Finalizes Revision to Title 6 Operating Permit Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/NYSDEC-Finalizes-Revision-to-Title-6-Operating-Permit-Program",
    "url": "/news/NYSDEC-Finalizes-Revision-to-Title-6-Operating-Permit-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDE Proposes New Regulations to Reduce Methane Emissions from Natural Gas Industry",
    "apiurl": "/restapi/customnewscontentlvl2/news/mde-proposes-new-regulations-to-reduce-methane-emissions-from-natural-gas-industry",
    "url": "/news/mde-proposes-new-regulations-to-reduce-methane-emissions-from-natural-gas-industry",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Report Released by Secretary of Natural Resources on Revitalizing Environmental Protection in Virginia-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Report-Released-by-Secretary-of-Natural-Resources-on-Revitalizing-Environmental-Protection-in-Virginia-Virginia",
    "url": "/news/Report-Released-by-Secretary-of-Natural-Resources-on-Revitalizing-Environmental-Protection-in-Virginia-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Highlights from the SB 19-181 Stakeholder Meeting-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Highlights-from-the-SB-19-181-Stakeholder-Meeting-Colorado",
    "url": "/news/Highlights-from-the-SB-19-181-Stakeholder-Meeting-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDNR EASY Air Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/idnr-easy-air-updates",
    "url": "/news/idnr-easy-air-updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Authorizes GHG Permitting Deferral for Biogenic Sources -Washington",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Authorizes-GHG-Permitting-Deferral-for-Biogenic-Sources--Washington",
    "url": "/news/EPA-Authorizes-GHG-Permitting-Deferral-for-Biogenic-Sources--Washington",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "From Marginal to Moderate: Can Northern Wasatch Front Prevent Ozone Nonattainment Reclassification?",
    "apiurl": "/restapi/customnewscontentlvl2/news/from-marginal-to-moderate-can-northern-wasatch-front-prevent-ozone-nonattainment-reclassification",
    "url": "/news/from-marginal-to-moderate-can-northern-wasatch-front-prevent-ozone-nonattainment-reclassification",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2017 Nebraska Safety Council Conference and Trade Show-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/2017-Nebraska-Safety-Council-Conference-and-Trade-Show-Nebraska",
    "url": "/news/2017-Nebraska-Safety-Council-Conference-and-Trade-Show-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Illinois Pollution Control Board Adopts New and Amended Rules to Establish PSD Permitting Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/illinois-pollution-control-board-adopts-new-and-amended-rules-to-establish-psd-permitting-program",
    "url": "/news/illinois-pollution-control-board-adopts-new-and-amended-rules-to-establish-psd-permitting-program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Illinois Pollution Control Board Adopts New and Amended Rules to Establish PSD Permitting Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/illinois-pollution-control-board-adopts-new-and-amended-rules-to-establish-psd-permitting-program",
    "url": "/states/illinois/illinois-pollution-control-board-adopts-new-and-amended-rules-to-establish-psd-permitting-program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Quarterly Air Quality Contact Highlights - November 8, 2018-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Quarterly-Air-Quality-Contact-Highlights---November-8-2018-Iowa",
    "url": "/news/Quarterly-Air-Quality-Contact-Highlights---November-8-2018-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes PM NAAQS Revisions-Washington, DC",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-PM-NAAQS-Revisions-Washington-DC",
    "url": "/news/EPA-Proposes-PM-NAAQS-Revisions-Washington-DC",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NJDEP proposes to repeal CO2 Budget Trading Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/NJDEP-proposes-to-repeal-CO2-Budget-Trading-Program",
    "url": "/news/NJDEP-proposes-to-repeal-CO2-Budget-Trading-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Response Required to U.S. EPA's Boiler MACT Section 114 Request for Information",
    "apiurl": "/restapi/customnewscontentlvl2/news/Response-R",
    "url": "/news/Response-R",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PM2.5 Attainment Determination – Currently in Public Comment",
    "apiurl": "/restapi/customnewscontentlvl2/news/pm2-5-attainment-determination-currently-in-public-comment",
    "url": "/news/pm2-5-attainment-determination-currently-in-public-comment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PM2.5 Attainment Determination – Currently in Public Comment",
    "apiurl": "/restapi/customnewscontentlvl2/news/pm2-5-attainment-determination-currently-in-public-comment",
    "url": "/states/pm2-5-attainment-determination-currently-in-public-comment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2010 Ambient Air Monitoring Network Assessment and Network Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/2010-Ambient-Air-Monitoring-Network-Assessment-and-Network-Plan",
    "url": "/news/2010-Ambient-Air-Monitoring-Network-Assessment-and-Network-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Rule 225 Variance for Natural Gas Combustion Emissions Renewed",
    "apiurl": "/restapi/customnewscontentlvl2/news/Rule-225-Variance-for-Natural-Gas-Combustion-Emissions-Renewed",
    "url": "/news/Rule-225-Variance-for-Natural-Gas-Combustion-Emissions-Renewed",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Preliminary Rule Development for Stationary Internal Combustion Engines Nitrogen Oxide Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Preliminary-Rule-Development-for-Stationary-Internal-Combustion-Engines-Nitrogen-Oxide-Rule",
    "url": "/news/Preliminary-Rule-Development-for-Stationary-Internal-Combustion-Engines-Nitrogen-Oxide-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Optimizing Workplace Ventilation to Reduce the Spread of COVID-19",
    "apiurl": "/restapi/customnewscontentlvl2/news/optimizing-workplace-ventilation-to-reduce-the-spread-of-covid-19",
    "url": "/news/optimizing-workplace-ventilation-to-reduce-the-spread-of-covid-19",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Optimizing Workplace Ventilation to Reduce the Spread of COVID-19",
    "apiurl": "/restapi/customnewscontentlvl2/news/optimizing-workplace-ventilation-to-reduce-the-spread-of-covid-19",
    "url": "/news/federal/optimizing-workplace-ventilation-to-reduce-the-spread-of-covid-19",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MPCA Requires Air Dispersion Modeling Protocol Forms",
    "apiurl": "/restapi/customnewscontentlvl2/news/MPCA-Requires-Air-Dispersion-Modeling-Protocol-Forms-",
    "url": "/news/MPCA-Requires-Air-Dispersion-Modeling-Protocol-Forms-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "VCAPCD Adopted Rule 74.33- Liquefied Petroleum Gas Transfer or Dispensing",
    "apiurl": "/restapi/customnewscontentlvl2/news/VCAPCD-Adopted-Rule-74-33--Liquefied-Petroleum-Gas-Transfer-or-Dispensing",
    "url": "/news/VCAPCD-Adopted-Rule-74-33--Liquefied-Petroleum-Gas-Transfer-or-Dispensing",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PM2.5 New Source Review - Rule Amendments and SIP Revision",
    "apiurl": "/restapi/customnewscontentlvl2/news/PM2-5-New-",
    "url": "/news/PM2-5-New-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ozone NAAQS Revisions Proposed-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ozone-NAAQS-Revisions-Proposed-Texas",
    "url": "/news/Ozone-NAAQS-Revisions-Proposed-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Phase 2 GHG Emission Standards for Heavy-Duty Vehicles Effective for 2021 and Later Model Years",
    "apiurl": "/restapi/customnewscontentlvl2/news/phase-2-ghg-emission-standards-for-heavy-duty-vehicles-effective-for-2021-and-later-model-years",
    "url": "/news/phase-2-ghg-emission-standards-for-heavy-duty-vehicles-effective-for-2021-and-later-model-years",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD Board Approves Critical Regulation 2 Rule Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/BAAQMD-Board-Approves-Critical-Regulation-2-Rule-Amendments",
    "url": "/news/BAAQMD-Board-Approves-Critical-Regulation-2-Rule-Amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New PSD Guidance Posted",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-PSD-Guidance-Posted",
    "url": "/news/New-PSD-Guidance-Posted",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Maryland’s Marcellus Shale Advisory Commission Held First Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Maryland-s-Marcellus-Shale-Advisory-Commission-Held-First-Meeting",
    "url": "/news/Maryland-s-Marcellus-Shale-Advisory-Commission-Held-First-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Environmental Approval Required-Alberta",
    "apiurl": "/restapi/customnewscontentlvl2/news/Environmental-Approval-Required-Alberta",
    "url": "/news/Environmental-Approval-Required-Alberta",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Virginia DEQ’s New Spill Reporting Portal",
    "apiurl": "/restapi/customnewscontentlvl2/news/virginia-deqs-new-spill-reporting-portal",
    "url": "/news/virginia-deqs-new-spill-reporting-portal",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Additional Designations for the 2015 Ozone National Ambient Air Quality Standard (NAAQS)-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/Additional-Designations-for-the-2015-Ozone-National-Ambient-Air-Quality-Standard-(NAAQS)-Utah",
    "url": "/news/Additional-Designations-for-the-2015-Ozone-National-Ambient-Air-Quality-Standard-(NAAQS)-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Annual Air Emission Inventory Reporting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Annual-Air-Emission-Inventory-Reporting",
    "url": "/news/Annual-Air-Emission-Inventory-Reporting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Signals Shift in PM2.5 Permitting Policies with LG&E Order",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Signal",
    "url": "/news/EPA-Signal",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ozone NAAQS Revisions Proposed",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ozone-NAAQS-Revisions-Proposed-",
    "url": "/news/Ozone-NAAQS-Revisions-Proposed-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Connecticut SIP Revisions: 8-Hour Ozone Attainment Demonstration for Connecticut's portion of the New York - Northern New Jersey - Long Island Nonattainment Area-Connecticut",
    "apiurl": "/restapi/customnewscontentlvl2/news/Connecticut-SIP-Revisions-8-Hour-Ozone-Attainment-Demonstration-for-Connecticut's-portion-of-the-New-York---Nortern-New-Jersey---Long-Island-Nonattainment-Area-Connecticut",
    "url": "/news/Connecticut-SIP-Revisions-8-Hour-Ozone-Attainment-Demonstration-for-Connecticut's-portion-of-the-New-York---Nortern-New-Jersey---Long-Island-Nonattainment-Area-Connecticut",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Diluent Cap Guidance from Virginia DEQ",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Diluent-Cap-Guidance-from-Virginia-DEQ",
    "url": "/news/New-Diluent-Cap-Guidance-from-Virginia-DEQ",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ New General Permit for Crushing and Screening Plants & Hot Mix Asphalt Plants",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ-New-General-Permit-for-Crushing-and-Screening-Plants-Hot-Mix-Asphalt-Plants",
    "url": "/news/ADEQ-New-General-Permit-for-Crushing-and-Screening-Plants-Hot-Mix-Asphalt-Plants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Amendments to Cross Program Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/Amendments-to-Cross-Program-Rules",
    "url": "/news/Amendments-to-Cross-Program-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Regulations Respecting Reduction in the Release of Volatile Organic Compounds (Petroleum Sector) - Updates-Ontario",
    "apiurl": "/restapi/customnewscontentlvl2/news/Regulations-Respecting-Reduction-in-the-Release-of-Volatile-Organic-Compounds-(Petroleum-Sector)---Updates-Ontario",
    "url": "/news/Regulations-Respecting-Reduction-in-the-Release-of-Volatile-Organic-Compounds-(Petroleum-Sector)---Updates-Ontario",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Friendly Reminder - Check Your Fuel-Oil Tickets for Sulfur Content-Connecticut",
    "apiurl": "/restapi/customnewscontentlvl2/news/Friendly-Reminder---Check-Your-Fuel-Oil-Tickets-for-Sulfur-Content-Connecticut",
    "url": "/news/Friendly-Reminder---Check-Your-Fuel-Oil-Tickets-for-Sulfur-Content-Connecticut",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Guidance for Addressing GHG Emissions in Washington SEPA Reviews",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Guidance-for-Addressing-GHG-Emissions-in-Washington-SEPA-Reviews",
    "url": "/news/New-Guidance-for-Addressing-GHG-Emissions-in-Washington-SEPA-Reviews",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Kentucky Division for Air Quality (KDAQ) Offices in Frankfort Move to a New Location",
    "apiurl": "/restapi/customnewscontentlvl2/news/Kentucky-D",
    "url": "/news/Kentucky-D",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants and Sierra Research Complete Merger",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-and-Sierra-Research-Complete-Merger",
    "url": "/news/Trinity-Consultants-and-Sierra-Research-Complete-Merger",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes Revisions to GHG Mandatory Reporting Rule for Stationary Combustion Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-Revisions-to-GHG-Mandatory-Reporting-Rule-for-Stationary-Combustion-Sources",
    "url": "/news/EPA-Proposes-Revisions-to-GHG-Mandatory-Reporting-Rule-for-Stationary-Combustion-Sources",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oil and Gas Facilities Subject to Non-Rule Barnett Shale Permitting - BACT Requirement",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oil-and-Gas-Facilities-Subject-to-Non-Rule-Barnett-Shale-Permitting---BACT-Requirement-",
    "url": "/news/Oil-and-Gas-Facilities-Subject-to-Non-Rule-Barnett-Shale-Permitting---BACT-Requirement-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "California Waste Discharge Requirements for Winery Process Water",
    "apiurl": "/restapi/customnewscontentlvl2/news/california-waste-discharge-requirements-for-winery-process-water",
    "url": "/news/california-waste-discharge-requirements-for-winery-process-water",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "California Waste Discharge Requirements for Winery Process Water",
    "apiurl": "/restapi/customnewscontentlvl2/news/california-waste-discharge-requirements-for-winery-process-water",
    "url": "/states/california/california-waste-discharge-requirements-for-winery-process-water",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EMIS Expert Takes the Helm in Trinity Consultants' Washington, D.C. Office",
    "apiurl": "/restapi/customnewscontentlvl2/news/EMIS-Expert-Takes-the-Helm-in-Trinity-Consultants'-Washington-D-C-Office",
    "url": "/news/EMIS-Expert-Takes-the-Helm-in-Trinity-Consultants'-Washington-D-C-Office",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revision to Gasoline Loading Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revision-to-Gasoline-Loading-Requirements",
    "url": "/news/Revision-to-Gasoline-Loading-Requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SafeBridge Consultants, Inc. (including its subsidiary SafeBridge Europe, Ltd.) has agreed to merge with Trinity Consultants, Inc. of Dallas, Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/SafeBridge-Consultants-Inc-(including-its-subsidiary-SafeBridge-Europe-Ltd-)-has-agreed-to-merge-with-Trinity-Consultants-Inc-of-Dallas-Texas",
    "url": "/news/SafeBridge-Consultants-Inc-(including-its-subsidiary-SafeBridge-Europe-Ltd-)-has-agreed-to-merge-with-Trinity-Consultants-Inc-of-Dallas-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Attainment Designations for Columbus & Cleveland Areas Likely to be Short-Lived",
    "apiurl": "/restapi/customnewscontentlvl2/news/Attainment-Designations-for-Columbus-Cleveland-Areas-Likely-to-be-Short-Lived",
    "url": "/news/Attainment-Designations-for-Columbus-Cleveland-Areas-Likely-to-be-Short-Lived",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "February 2016 California Cap-and-Trade and Québec Cap-and-Trade Joint Auction Notice Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/February-2016-California-Cap-and-Trade-and-Québec-Cap-and-Trade-Joint-Auction-Notice-Released",
    "url": "/news/February-2016-California-Cap-and-Trade-and-Québec-Cap-and-Trade-Joint-Auction-Notice-Released",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Amendments to Env-A 1400 Regulated Toxic Air Pollutants",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-Amendments-to-Env-A-1400-Regulated-Toxic-Air-Pollutants",
    "url": "/news/Final-Amendments-to-Env-A-1400-Regulated-Toxic-Air-Pollutants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Defers Sanctions to Future Offset and Highway Projects; SCAQMD",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Defers-Sanctions-to-Future-Offset-and-Highway-Projects-SCAQMD-",
    "url": "/news/EPA-Defers-Sanctions-to-Future-Offset-and-Highway-Projects-SCAQMD-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Clean Power Plan Implementation in Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/Clean-Power-Plan-Implementation-in-Utah",
    "url": "/news/Clean-Power-Plan-Implementation-in-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Nonattainment New Source Review and Prevention of Significant Deterioration Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/Nonattainment-New-Source-Review-and-Prevention-of-Significant-Deterioration-Amendments",
    "url": "/news/Nonattainment-New-Source-Review-and-Prevention-of-Significant-Deterioration-Amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Redesignation of the Knoxville 2006 24-Hour PM2.5 Nonattainment Area to Attainment-Tennessee",
    "apiurl": "/restapi/customnewscontentlvl2/news/Redesignation-of-the-Knoxville-2006-24-Hour-PM2-5-Nonattainment-Area-to-Attainment-Tennessee",
    "url": "/news/Redesignation-of-the-Knoxville-2006-24-Hour-PM2-5-Nonattainment-Area-to-Attainment-Tennessee",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Yolo-Solano AQMD Federal New Source Review at Major PM2.5 Sources-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/Yolo-Solano-AQMD-Federal-New-Source-Review-at-Major-PM2-5-Sources-California",
    "url": "/news/Yolo-Solano-AQMD-Federal-New-Source-Review-at-Major-PM2-5-Sources-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Federal Updates for Brick and Structural Clay Products Manufacturing and Clay Ceramics Manufacturing",
    "apiurl": "/restapi/customnewscontentlvl2/news/Federal-Updates-for-Brick-and-Structural-Clay-Products-Manufacturing-and-Clay-Ceramics-Manufacturing",
    "url": "/news/Federal-Updates-for-Brick-and-Structural-Clay-Products-Manufacturing-and-Clay-Ceramics-Manufacturing",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Clean Air Transport Rule Includes Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Clean-Air-Transport-Rule-Includes-Kansas",
    "url": "/news/Clean-Air-Transport-Rule-Includes-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "North Dakota Pollutant Discharge Elimination System Updates – Industrial Activities",
    "apiurl": "/restapi/customnewscontentlvl2/news/North-Dakota-Pollutant-Discharge-Elimination-System-Updates-Industrial-Activities",
    "url": "/news/North-Dakota-Pollutant-Discharge-Elimination-System-Updates-Industrial-Activities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Dispersion Modeling Requirements for Compressor Engines and Glycol Dehydration Units",
    "apiurl": "/restapi/customnewscontentlvl2/news/Dispersion-Modeling-Requirements-for-Compressor-Engines-and-Glycol-Dehydration-Units",
    "url": "/news/Dispersion-Modeling-Requirements-for-Compressor-Engines-and-Glycol-Dehydration-Units",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Kansas Environmental Conference-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Kansas-Environmental-Conference-Kansas",
    "url": "/news/Kansas-Environmental-Conference-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Public Meetings on Proposed Action on Visiblity",
    "apiurl": "/restapi/customnewscontentlvl2/news/Public-Meetings-on-Proposed-Action-on-Visiblity",
    "url": "/news/Public-Meetings-on-Proposed-Action-on-Visiblity",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Changes to EIQ Forms",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Changes-to-EIQ-Forms",
    "url": "/news/Proposed-Changes-to-EIQ-Forms",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MPCA Adopts Proposed Exempt Source and Conditionally Insignificant Activities Rulemaking Updates-Minnesota",
    "apiurl": "/restapi/customnewscontentlvl2/news/MPCA-Adopts-Proposed-Exempt-Source-and-Conditionally-Insignificant-Activities-Rulemaking-Updates-Minnesota",
    "url": "/news/MPCA-Adopts-Proposed-Exempt-Source-and-Conditionally-Insignificant-Activities-Rulemaking-Updates-Minnesota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendment to 10 CSR 10-6.040 Reference Methods",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendment-to-10-CSR-10-6-040-Reference-Methods",
    "url": "/news/Proposed-Amendment-to-10-CSR-10-6-040-Reference-Methods",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Colorado Regulation 7: Updated Inspection Requirements for Tanks Above 2 TPY VOC",
    "apiurl": "/restapi/customnewscontentlvl2/news/colorado-regulation-7-updated-inspection-requirements-for-tanks-above-2-tpy-voc",
    "url": "/news/colorado-regulation-7-updated-inspection-requirements-for-tanks-above-2-tpy-voc",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "UDAQ Proposes Changes to its O&G General Approval Order Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/UDAQ-Proposes-Changes-to-its-O-G-General-Approval-Order-Rule-",
    "url": "/news/UDAQ-Proposes-Changes-to-its-O-G-General-Approval-Order-Rule-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Amendments to MCAQD Rule 336:  Surface Coating Operations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Amendments-to-MCAQD-Rule-336-Surface-Coating-Operations",
    "url": "/news/Amendments-to-MCAQD-Rule-336-Surface-Coating-Operations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Portions of Missouri Cross-State Air Pollution Rule Approved",
    "apiurl": "/restapi/customnewscontentlvl2/news/Portions-of-Missouri-Cross-State-Air-Pollution-Rule-Approved",
    "url": "/news/Portions-of-Missouri-Cross-State-Air-Pollution-Rule-Approved",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Acquires Chemical Regulatory and  Risk Management Firm, The Redstone Group",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Acquires-Chemical-Regulatory-and-Risk-Management-Firm-The-Redstone-Group",
    "url": "/news/Trinity-Consultants-Acquires-Chemical-Regulatory-and-Risk-Management-Firm-The-Redstone-Group",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Acquires Chemical Regulatory and  Risk Management Firm, The Redstone Group",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Acquires-Chemical-Regulatory-and-Risk-Management-Firm-The-Redstone-Group",
    "url": "/news/company/Trinity-Consultants-Acquires-Chemical-Regulatory-and-Risk-Management-Firm-The-Redstone-Group",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CTDEEP Draft 2020 Air Monitoring Network Plan and 2020 Five-Year Network Assessment",
    "apiurl": "/restapi/customnewscontentlvl2/news/ctdeep-draft-2020-air-monitoring-network-plan-and-2020-five-year-network-assessment",
    "url": "/news/ctdeep-draft-2020-air-monitoring-network-plan-and-2020-five-year-network-assessment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to MDEQ Policy for Requiring Mercury Toxicology Impacts Analyses",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-to-MDEQ-Policy-for-Requiring-Mercury-Toxicology-Impacts-Analyses",
    "url": "/news/Updates-to-MDEQ-Policy-for-Requiring-Mercury-Toxicology-Impacts-Analyses",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Dakota Reporting Reminders-South Dakota",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Dakota-Reporting-Reminders-South-Dakota",
    "url": "/news/South-Dakota-Reporting-Reminders-South-Dakota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revisions to Wyoming Waste Rules-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revisions-to-Wyoming-Waste-Rules-Wyoming",
    "url": "/news/Revisions-to-Wyoming-Waste-Rules-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "November 2012 Cap-and-Trade GHG Allowance Auction Details Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/November-2012-Cap-and-Trade-GHG-Allowance-Auction-Details-Released",
    "url": "/news/November-2012-Cap-and-Trade-GHG-Allowance-Auction-Details-Released",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Mitigating Risk with Proactive EHS Compliance Management",
    "apiurl": "/restapi/customnewscontentlvl2/news/mitigating-risk-with-proactive-ehs-compliance-management",
    "url": "/news/mitigating-risk-with-proactive-ehs-compliance-management",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Addressing the Mechanical Integrity Requirements under RMP/PSM",
    "apiurl": "/restapi/customnewscontentlvl2/news/Addressing-the-Mechanical-Integrity-Requirements-under-RMP-PSM",
    "url": "/news/Addressing-the-Mechanical-Integrity-Requirements-under-RMP-PSM",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CARB Holds Workshop on Statewide Emissions Inventory of Locomotives",
    "apiurl": "/restapi/customnewscontentlvl2/news/carb-holds-workshop-on-statewide-emissions-inventory-of-locomotives",
    "url": "/news/carb-holds-workshop-on-statewide-emissions-inventory-of-locomotives",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CARB Holds Workshop on Statewide Emissions Inventory of Locomotives",
    "apiurl": "/restapi/customnewscontentlvl2/news/carb-holds-workshop-on-statewide-emissions-inventory-of-locomotives",
    "url": "/news/states/california/carb-holds-workshop-on-statewide-emissions-inventory-of-locomotives",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Stakeholder Advisors Review Water Quality Standards at Aug. 20 Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Stakeholder-Advisors-Review-Water-Quality-Standards-at-Aug-20-Meeting",
    "url": "/news/Stakeholder-Advisors-Review-Water-Quality-Standards-at-Aug-20-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Issues PCWP ICR to U.S. Wood Products Manufacturers-Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Issues-PCWP-ICR-to-U-S-Wood-Products-Manufacturers-Oregon",
    "url": "/news/EPA-Issues-PCWP-ICR-to-U-S-Wood-Products-Manufacturers-Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Carbon County Nonattainment Designation",
    "apiurl": "/restapi/customnewscontentlvl2/news/Carbon-County-Nonattainment-Designation",
    "url": "/news/Carbon-County-Nonattainment-Designation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Finalized Amendments to Rhode Island Air Pollution Control Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Finalized-Amendments-to-Rhode-Island-Air-Pollution-Control-Regulations",
    "url": "/news/Finalized-Amendments-to-Rhode-Island-Air-Pollution-Control-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New York to Lower Ozone Season NOx RACT Limits for SCCTs-New York",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-York-to-Lower-Ozone-Season-NOx-RACT-Limits-for-SCCTs-New-York",
    "url": "/news/New-York-to-Lower-Ozone-Season-NOx-RACT-Limits-for-SCCTs-New-York",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New York, N. New Jersey and Long Island May be Reclassified as Serious Nonattainment Areas-New York",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-York-N-New-Jersey-and-Long-Island-May-be-Reclassified-as-Serious-Nonattainment-Areas-New-York",
    "url": "/news/New-York-N-New-Jersey-and-Long-Island-May-be-Reclassified-as-Serious-Nonattainment-Areas-New-York",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Washington GHG Reporting Program:  Reporting Tool Strategy and Registration Deadline Extension",
    "apiurl": "/restapi/customnewscontentlvl2/news/Washington-GHG-Reporting-Program-Reporting-Tool-Strategy-and-Registration-Deadline-Extension-",
    "url": "/news/Washington-GHG-Reporting-Program-Reporting-Tool-Strategy-and-Registration-Deadline-Extension-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "U.S. EPA Designates St. Bernard Parish Nonattainment for SO2",
    "apiurl": "/restapi/customnewscontentlvl2/news/U-S-EPA-Designates-St-Bernard-Parish-Nonattainment-for-SO2",
    "url": "/news/U-S-EPA-Designates-St-Bernard-Parish-Nonattainment-for-SO2",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Hampshire Department of Environmental Services Air Resources Division proposes revisions to VOC RACT Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Hampshire-Department-of-Environmental-Services-Air-Resources-Division-proposes-revisions-to-VOC-RACT-Rule",
    "url": "/news/New-Hampshire-Department-of-Environmental-Services-Air-Resources-Division-proposes-revisions-to-VOC-RACT-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "AWMA April 2015 Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/AWMA-April-2015-Meeting",
    "url": "/news/AWMA-April-2015-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MPCA Updates Modeling Practices Regarding ADJ_U*",
    "apiurl": "/restapi/customnewscontentlvl2/news/MPCA-Updates-Modeling-Practices-Regarding-ADJ_U-",
    "url": "/news/MPCA-Updates-Modeling-Practices-Regarding-ADJ_U-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Electronic Submission of Notice Startup Form",
    "apiurl": "/restapi/customnewscontentlvl2/news/Electronic-Submission-of-Notice-Startup-Form",
    "url": "/news/Electronic-Submission-of-Notice-Startup-Form",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Workshops Outline SPCC Rule Changes-Oklahoma",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Workshops-Outline-SPCC-Rule-Changes-Oklahoma",
    "url": "/news/EPA-Workshops-Outline-SPCC-Rule-Changes-Oklahoma",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Memo Detailing Steps to Perform Flash Gas Liberation Analysis-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Memo-Detailing-Steps-to-Perform-Flash-Gas-Liberation-Analysis-Colorado",
    "url": "/news/New-Memo-Detailing-Steps-to-Perform-Flash-Gas-Liberation-Analysis-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Files Notice of Intent to Sue EPA",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ-Files-Notice-of-Intent-to-Sue-EPA",
    "url": "/news/ADEQ-Files-Notice-of-Intent-to-Sue-EPA",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Position Change at the Kentucky Division for Air Quality",
    "apiurl": "/restapi/customnewscontentlvl2/news/Position-Change-at-the-Kentucky-Division-for-Air-Quality",
    "url": "/news/Position-Change-at-the-Kentucky-Division-for-Air-Quality",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Kansas Tip of the Month - Annual Storm Water Inspections-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Kansas-Tip-of-the-Month---Annual-Storm-Water-Inspections-Kansas",
    "url": "/news/Kansas-Tip-of-the-Month---Annual-Storm-Water-Inspections-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ISO 45001:2018 OHS Management System Standard: The Role of Effective Governance",
    "apiurl": "/restapi/customnewscontentlvl2/news/ISO-45001-2018-OHS-Management-System-Standard-The-Role-of-Effective-Governance",
    "url": "/news/ISO-45001-2018-OHS-Management-System-Standard-The-Role-of-Effective-Governance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Rule: Alabama State Implementation Plan Revisions - CSAPR",
    "apiurl": "/restapi/customnewscontentlvl2/news/final-rule-alabama-state-implementation-plan-revisions---csapr",
    "url": "/news/final-rule-alabama-state-implementation-plan-revisions---csapr",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Rule: Alabama State Implementation Plan Revisions - CSAPR",
    "apiurl": "/restapi/customnewscontentlvl2/news/final-rule-alabama-state-implementation-plan-revisions---csapr",
    "url": "/states/alabama/final-rule-alabama-state-implementation-plan-revisions-csapr",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Upcoming ADEM public hearings",
    "apiurl": "/restapi/customnewscontentlvl2/news/Upcoming-ADEM-public-hearings-",
    "url": "/news/Upcoming-ADEM-public-hearings-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA Proposes to Redesignate Las Vegas Valley to Attainment for PM10",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-Proposes-to-Redesignate-Las-Vegas-Valley-to-Attainment-for-PM10",
    "url": "/news/USEPA-Proposes-to-Redesignate-Las-Vegas-Valley-to-Attainment-for-PM10",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MCAQD Ozone Related Rulemakings",
    "apiurl": "/restapi/customnewscontentlvl2/news/MCAQD-Ozone-Related-Rulemakings",
    "url": "/news/MCAQD-Ozone-Related-Rulemakings",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Decision to Remove Air Pollution Nuisance Rule from Ohio SIP Finalized",
    "apiurl": "/restapi/customnewscontentlvl2/news/decision-to-remove-air-pollution-nuisance-rule-from-ohio-sip-finalized",
    "url": "/news/decision-to-remove-air-pollution-nuisance-rule-from-ohio-sip-finalized",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Decision to Remove Air Pollution Nuisance Rule from Ohio SIP Finalized",
    "apiurl": "/restapi/customnewscontentlvl2/news/decision-to-remove-air-pollution-nuisance-rule-from-ohio-sip-finalized",
    "url": "/www.trinityconsultants.com/news/decision-to-remove-air-pollution-nuisance-rule-from-ohio-sip-finalized",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CDPHE Posts Informational Documents for Oil and Gas Industry Emissions",
    "apiurl": "/restapi/customnewscontentlvl2/news/CDPHE-Posts-Informational-Documents-for-Oil-and-Gas-Industry-Emissions",
    "url": "/news/CDPHE-Posts-Informational-Documents-for-Oil-and-Gas-Industry-Emissions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDNR Held the Quarterly Air Quality Client Contact Call on February 18",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDNR-Held-the-Quarterly-Air-Quality-Client-Contact-Call-on-February-18",
    "url": "/news/IDNR-Held-the-Quarterly-Air-Quality-Client-Contact-Call-on-February-18",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDEM Adopts USEPA Global Warming Potentials",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDEM-Adopts-USEPA-Global-Warming-Potentials",
    "url": "/news/IDEM-Adopts-USEPA-Global-Warming-Potentials",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Deputy Commissioner for Tennessee Department of Environment",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Deputy-Commissioner-for-Tennessee-Department-of-Environment",
    "url": "/news/New-Deputy-Commissioner-for-Tennessee-Department-of-Environment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on PSD Permitting in Illinois-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-PSD-Permitting-in-Illinois-Illinois",
    "url": "/news/Update-on-PSD-Permitting-in-Illinois-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Draft of Maricopa County Air Quality Permitting Rules Now Available",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Draft-of-Maricopa-County-Air-Quality-Permitting-Rules-Now-Available-",
    "url": "/news/New-Draft-of-Maricopa-County-Air-Quality-Permitting-Rules-Now-Available-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDEM and the GHG Tailoring Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDEM-and-the-GHG-Tailoring-Rule",
    "url": "/news/IDEM-and-the-GHG-Tailoring-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Department of Air Quality Renamed to Department of Environment and Sustainability-Nevada",
    "apiurl": "/restapi/customnewscontentlvl2/news/Department-of-Air-Quality-Renamed-to-Department-of-Environment-and-Sustainability-Nevada",
    "url": "/news/Department-of-Air-Quality-Renamed-to-Department-of-Environment-and-Sustainability-Nevada",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "July 2019 Newsletter",
    "apiurl": "/restapi/customnewscontentlvl2/news/July-2019-Newsletter",
    "url": "/news/July-2019-Newsletter",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDE Proposes Renewed State/NPDES General Discharge Permit for Stormwater",
    "apiurl": "/restapi/customnewscontentlvl2/news/mde-proposes-renewed-state-npdes-general-discharge-permit-for-stormwater",
    "url": "/news/mde-proposes-renewed-state-npdes-general-discharge-permit-for-stormwater",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on Changes to NC Air Toxics Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-Changes-to-NC-Air-Toxics-Rule",
    "url": "/news/Update-on-Changes-to-NC-Air-Toxics-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ozone Standard Unchanged",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ozone-Standard-Unchanged",
    "url": "/news/Ozone-Standard-Unchanged",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on the 2008 Ozone NAAQS Attachment Designations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-the-2008-Ozone-NAAQS-Attachment-Designations",
    "url": "/news/Update-on-the-2008-Ozone-NAAQS-Attachment-Designations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Nebraska Environmental Update Meetings",
    "apiurl": "/restapi/customnewscontentlvl2/news/Nebraska-Environmental-Update-Meetings",
    "url": "/news/Nebraska-Environmental-Update-Meetings",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Neither Snow nor Rain...",
    "apiurl": "/restapi/customnewscontentlvl2/news/Neither-Sn",
    "url": "/news/Neither-Sn",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revised Statute Will Significantly Change Scope of Washington's GHG Reporting Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revised-Statute-Will-Significantly-Change-Scope-of-Washington's-GHG-Reporting-Program",
    "url": "/news/Revised-Statute-Will-Significantly-Change-Scope-of-Washington's-GHG-Reporting-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPD Stakeholder Meeting for Expedited Permitting Process",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPD-Stakeh",
    "url": "/news/EPD-Stakeh",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LDEQ Regulatory Permit for Storage Vessels-Louisiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/LDEQ-Regulatory-Permit-for-Storage-Vessels-Louisiana",
    "url": "/news/LDEQ-Regulatory-Permit-for-Storage-Vessels-Louisiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Wyoming DEQ - Air Quality Division Proposes Changes to Oil & Gas Guidance-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Wyoming-DEQ---Air-Quality-Division-Proposes-Changes-to-Oil-Gas-Guidance-Wyoming",
    "url": "/news/Wyoming-DEQ---Air-Quality-Division-Proposes-Changes-to-Oil-Gas-Guidance-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Public Comment Period Open for Las Vegas Valley Carbon Monoxide Maintenance Plan-Nevada",
    "apiurl": "/restapi/customnewscontentlvl2/news/Public-Comment-Period-Open-for-Las-Vegas-Valley-Carbon-Monoxide-Maintenance-Plan-Nevada",
    "url": "/news/Public-Comment-Period-Open-for-Las-Vegas-Valley-Carbon-Monoxide-Maintenance-Plan-Nevada",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Virginia DEQ Received Petition to Harmonize Virginia and Federal PSD Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Virginia-DEQ-Received-Petition-to-Harmonize-Virginia-and-Federal-PSD-Regulations",
    "url": "/news/Virginia-DEQ-Received-Petition-to-Harmonize-Virginia-and-Federal-PSD-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Emissions Control Equipment Voluntary Monitoring Considerations",
    "apiurl": "/restapi/customnewscontentlvl2/news/emissions-control-equipment-voluntary-monitoring-considerations",
    "url": "/news/emissions-control-equipment-voluntary-monitoring-considerations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Emissions Control Equipment Voluntary Monitoring Considerations",
    "apiurl": "/restapi/customnewscontentlvl2/news/emissions-control-equipment-voluntary-monitoring-considerations",
    "url": "/state/emissions-control-equipment-voluntary-monitoring-considerations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Special Offer: TWO Free BRMS Runs - Ends March 31",
    "apiurl": "/restapi/customnewscontentlvl2/news/Special-Offer-TWO-Free-BRMS-Runs---Ends-March-31",
    "url": "/news/Special-Offer-TWO-Free-BRMS-Runs---Ends-March-31",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Dispersion Modeling Data and Guidance Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Dispersion-Modeling-Data-and-Guidance-Updates",
    "url": "/news/Proposed-Dispersion-Modeling-Data-and-Guidance-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Emission Factor Development for Mechanical Evaporators",
    "apiurl": "/restapi/customnewscontentlvl2/news/Emission-Factor-Development-for-Mechanical-Evaporators",
    "url": "/news/Emission-Factor-Development-for-Mechanical-Evaporators",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Curtain Incinerator GOP 518 Renewal",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Curtain-Incinerator-GOP-518-Renewal",
    "url": "/news/Air-Curtain-Incinerator-GOP-518-Renewal",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDE Proposes Changes to COMAR 26.11.02.07, .11 and .12",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDE-Proposes-Changes-to-COMAR-26-11-02-07-11-and-12",
    "url": "/news/MDE-Proposes-Changes-to-COMAR-26-11-02-07-11-and-12",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Thinking Ahead: 2015 Ozone NAAQS and County Designations in Texas-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Thinking-Ahead-2015-Ozone-NAAQS-and-County-Designations-in-Texas-Texas",
    "url": "/news/Thinking-Ahead-2015-Ozone-NAAQS-and-County-Designations-in-Texas-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revised Draft Guidance for Dispersion Modeling Requirements Affecting Michigan Permitting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revised-Draft-Guidance-for-Dispersion-Modeling-Requirements-Affecting-Michigan-Permitting-",
    "url": "/news/Revised-Draft-Guidance-for-Dispersion-Modeling-Requirements-Affecting-Michigan-Permitting-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Standardized Air Modeling Spreadsheets for Regulatory Air Modeling",
    "apiurl": "/restapi/customnewscontentlvl2/news/Standardized-Air-Modeling-Spreadsheets-for-Regulatory-Air-Modeling",
    "url": "/news/Standardized-Air-Modeling-Spreadsheets-for-Regulatory-Air-Modeling",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NY Issues Good Neighbor Petition-New York",
    "apiurl": "/restapi/customnewscontentlvl2/news/NY-Issues-Good-Neighbor-Petition-New-York",
    "url": "/news/NY-Issues-Good-Neighbor-Petition-New-York",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Industrial Stormwater 2015 Sampling Requirements Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Industrial-Stormwater-2015-Sampling-Requirements-Updates",
    "url": "/news/Industrial-Stormwater-2015-Sampling-Requirements-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Mark Your Calendars - AWMA Meeting Scheduled-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Mark-Your-Calendars---AWMA-Meeting-Scheduled-Iowa",
    "url": "/news/Mark-Your-Calendars---AWMA-Meeting-Scheduled-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "HEAL Utah Petition for Air Quality Rule Making",
    "apiurl": "/restapi/customnewscontentlvl2/news/HEAL-Utah-Petition-for-Air-Quality-Rule-Making",
    "url": "/news/HEAL-Utah-Petition-for-Air-Quality-Rule-Making",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "D.C. Department of Energy & Environment Finalizes Underground Storage Tank Regulations-Washington, DC",
    "apiurl": "/restapi/customnewscontentlvl2/news/D-C-Department-of-Energy-Environment-Finalizes-Underground-Storage-Tank-Regulations-Washington-DC",
    "url": "/news/D-C-Department-of-Energy-Environment-Finalizes-Underground-Storage-Tank-Regulations-Washington-DC",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA Issues Approval for SJVAPCD’s New Source Review Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-Issues-Approval-for-SJVAPCD-s-New-Source-Review-Rules",
    "url": "/news/USEPA-Issues-Approval-for-SJVAPCD-s-New-Source-Review-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Improving Corporate Performance through Effective Management of EHS Business Risk",
    "apiurl": "/restapi/customnewscontentlvl2/news/Improving-Corporate-Performance-through-Effective-Management-of-EHS-Business-Risk",
    "url": "/news/Improving-Corporate-Performance-through-Effective-Management-of-EHS-Business-Risk",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes to Redesignate the Tacoma Pierce County PM2.5 Nonattainment Area to Attainment Status",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-to-Redesignate-the-Tacoma-Pierce-County-PM2-5-Nonattainment-Area-to-Attainment-Status-",
    "url": "/news/EPA-Proposes-to-Redesignate-the-Tacoma-Pierce-County-PM2-5-Nonattainment-Area-to-Attainment-Status-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NESHAP for Miscellaneous Organic Chemical Manufacturing (MON) First Semiannual Compliance Report Submittal Deadline is February 28, 2009",
    "apiurl": "/restapi/customnewscontentlvl2/news/NESHAP-for",
    "url": "/news/NESHAP-for",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Control of Sulfur Emissions from Stationary Boilers",
    "apiurl": "/restapi/customnewscontentlvl2/news/Control-of-Sulfur-Emissions-from-Stationary-Boilers",
    "url": "/news/Control-of-Sulfur-Emissions-from-Stationary-Boilers",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Supreme Court Stays the Implementation of USEPA's Clean Power Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Supreme-Court-Stays-the-Implementation-of-USEPA's-Clean-Power-Plan",
    "url": "/news/Supreme-Court-Stays-the-Implementation-of-USEPA's-Clean-Power-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The Complex World of CAA and RCRA LDAR Overlap Provisions",
    "apiurl": "/restapi/customnewscontentlvl2/news/the-complex-world-of-caa-and-rcra-ldar-overlap-provisions",
    "url": "/news/the-complex-world-of-caa-and-rcra-ldar-overlap-provisions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The Complex World of CAA and RCRA LDAR Overlap Provisions",
    "apiurl": "/restapi/customnewscontentlvl2/news/the-complex-world-of-caa-and-rcra-ldar-overlap-provisions",
    "url": "/www.trinityconsultants.com/news/the-complex-world-of-caa-and-rcra-ldar-overlap-provisions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2016 Legislative Session – Environmental Bills",
    "apiurl": "/restapi/customnewscontentlvl2/news/2016-Legislative-Session-Environmental-Bills",
    "url": "/news/2016-Legislative-Session-Environmental-Bills",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPD to Submit Notice of Exceptional Events",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPD-to-Sub",
    "url": "/news/EPD-to-Sub",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Energy Assessment Deadline Rapidly Approaching",
    "apiurl": "/restapi/customnewscontentlvl2/news/Energy-Assessment-Deadline-Rapidly-Approaching",
    "url": "/news/Energy-Assessment-Deadline-Rapidly-Approaching",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Annual LDAR REports for Regulation No. 7 due May 31st-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Annual-LDAR-REports-for-Regulation-No-7-due-May-31st-Colorado",
    "url": "/news/Annual-LDAR-REports-for-Regulation-No-7-due-May-31st-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2012 Reporting Reminders-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/2012-Reporting-Reminders-Iowa",
    "url": "/news/2012-Reporting-Reminders-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Ozone NAAQS Delayed Until End of October",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Ozone-NAAQS-Delayed-Until-End-of-October",
    "url": "/news/New-Ozone-NAAQS-Delayed-Until-End-of-October",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Coast Air Quality Management District - Proposed Amended Rule 408-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Coast-Air-Quality-Management-District---Proposed-Amended-Rule-408-California",
    "url": "/news/South-Coast-Air-Quality-Management-District---Proposed-Amended-Rule-408-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEQ Air DVD and Website",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEQ-Air-DVD-and-Website",
    "url": "/news/NDEQ-Air-DVD-and-Website",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Pollution Fee Structure Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Pollution-Fee-Structure-Update",
    "url": "/news/Air-Pollution-Fee-Structure-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Regulatory Summary - May 2009",
    "apiurl": "/restapi/customnewscontentlvl2/news/Regulatory-Summary---May-2009",
    "url": "/news/Regulatory-Summary---May-2009",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Upcoming Complimentary Webinar on NC Air Toxics Program and Updates to 502 (b)(10)Notifications & Minor Permit Modifications",
    "apiurl": "/restapi/customnewscontentlvl2/news/Upcoming-Complimentary-Webinar-on-NC-Air-Toxics-Program-and-Updates-to-502-(b)(10)Notifications-Minor-Permit-Modifications",
    "url": "/news/Upcoming-Complimentary-Webinar-on-NC-Air-Toxics-Program-and-Updates-to-502-(b)(10)Notifications-Minor-Permit-Modifications",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Additional Information on Clark County DAQ's New Emissions Statement Requirement",
    "apiurl": "/restapi/customnewscontentlvl2/news/additional-information-on-clark-county-daqs-new-emissions-statement-requirement",
    "url": "/news/additional-information-on-clark-county-daqs-new-emissions-statement-requirement",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Modeling Tip: Importing a Base Map Image File in BREEZE ROADS",
    "apiurl": "/restapi/customnewscontentlvl2/news/Modeling-Tip-Importing-a-Base-Map-Image-File-in-BREEZE-ROADS",
    "url": "/news/Modeling-Tip-Importing-a-Base-Map-Image-File-in-BREEZE-ROADS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Short-Term Guidance for Storage Tanks Has Been Updated-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/TCEQ-Short-Term-Guidance-for-Storage-Tanks-Has-Been-Updated-Texas",
    "url": "/news/TCEQ-Short-Term-Guidance-for-Storage-Tanks-Has-Been-Updated-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CDP Climate Change Reporting and Disclosure:  The Value of Verification",
    "apiurl": "/restapi/customnewscontentlvl2/news/CDP-Climate-Change-Reporting-and-Disclosure-The-Value-of-Verification",
    "url": "/news/CDP-Climate-Change-Reporting-and-Disclosure-The-Value-of-Verification",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Quarterly Air Quality Client Contact Call Highlights – November 17, 2016",
    "apiurl": "/restapi/customnewscontentlvl2/news/Quarterly-Air-Quality-Client-Contact-Call-Highlights-November-17-2016",
    "url": "/news/Quarterly-Air-Quality-Client-Contact-Call-Highlights-November-17-2016",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PM2.5 Serious Non-Attainment State Implementation Plan – Next Steps",
    "apiurl": "/restapi/customnewscontentlvl2/news/PM2-5-Serious-Non-Attainment-State-Implementation-Plan-Next-Steps",
    "url": "/news/PM2-5-Serious-Non-Attainment-State-Implementation-Plan-Next-Steps",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PA DEP Launches Permit Review Process and Permit Decision Guarantee (PDG) Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/PA-DEP-Launches-Permit-Review-Process-and-Permit-Decision-Guarantee-(PDG)-Program",
    "url": "/news/PA-DEP-Launches-Permit-Review-Process-and-Permit-Decision-Guarantee-(PDG)-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Environmental Compliance Approval (ECA)",
    "apiurl": "/restapi/customnewscontentlvl2/news/Environmental-Compliance-Approval-(ECA)",
    "url": "/news/Environmental-Compliance-Approval-(ECA)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SJVAPCD Cut Allowable NOx Emissions from Boilers and Heaters",
    "apiurl": "/restapi/customnewscontentlvl2/news/sjvapcd-cut-allowable-nox-emissions-from-boilers-and-heaters",
    "url": "/news/sjvapcd-cut-allowable-nox-emissions-from-boilers-and-heaters",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SJVAPCD Cut Allowable NOx Emissions from Boilers and Heaters",
    "apiurl": "/restapi/customnewscontentlvl2/news/sjvapcd-cut-allowable-nox-emissions-from-boilers-and-heaters",
    "url": "/news/sjvapcd-adoption-of-rule-4306-rule-4320-amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Regulations on Use of Asphalt Pavement and Asphalt base Surface-Coatings in New York",
    "apiurl": "/restapi/customnewscontentlvl2/news/Regulations-on-Use-of-Asphalt-Pavement-and-Asphalt-base-Surface-Coatings-in-New-York",
    "url": "/news/Regulations-on-Use-of-Asphalt-Pavement-and-Asphalt-base-Surface-Coatings-in-New-York",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Nebraska Tip of the Month - Training Reminder-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/Nebraska-Tip-of-the-Month---Training-Reminder-Nebraska",
    "url": "/news/Nebraska-Tip-of-the-Month---Training-Reminder-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Is Your RICE MACT Monitoring Plan Ready?",
    "apiurl": "/restapi/customnewscontentlvl2/news/Is-Your-RICE-MACT-Monitoring-Plan-Ready-",
    "url": "/news/Is-Your-RICE-MACT-Monitoring-Plan-Ready-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDNR Proposing Three Amendments to the Code of State Regulations (CSR)",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDNR-Proposing-Three-Amendments-to-the-Code-of-State-Regulations-(CSR)",
    "url": "/news/MDNR-Proposing-Three-Amendments-to-the-Code-of-State-Regulations-(CSR)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Annual Emission Inventory Due April 1st",
    "apiurl": "/restapi/customnewscontentlvl2/news/Annual-Emission-Inventory-Due-April-1st",
    "url": "/news/Annual-Emission-Inventory-Due-April-1st",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Emission Inventories Due April 1st",
    "apiurl": "/restapi/customnewscontentlvl2/news/Emission-Inventories-Due-April-1st",
    "url": "/news/Emission-Inventories-Due-April-1st",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Remote Classification for Engines",
    "apiurl": "/restapi/customnewscontentlvl2/news/Remote-Classification-for-Engines",
    "url": "/news/Remote-Classification-for-Engines",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "McCrory Names New Head for NCDENR",
    "apiurl": "/restapi/customnewscontentlvl2/news/McCrory-Names-New-Head-for-NCDENR",
    "url": "/news/McCrory-Names-New-Head-for-NCDENR",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KDAQ Moves to Repeal 401 KAR 52:080, Regulatory Limit on Potential to Emit",
    "apiurl": "/restapi/customnewscontentlvl2/news/KDAQ-Moves",
    "url": "/news/KDAQ-Moves",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PHA Inconsistency Series – Part III: Mitigating the Risks",
    "apiurl": "/restapi/customnewscontentlvl2/news/pha-inconsistency-series-part-iii-mitigating-the-risks",
    "url": "/news/pha-inconsistency-series-part-iii-mitigating-the-risks",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PHA Inconsistency Series – Part III: Mitigating the Risks",
    "apiurl": "/restapi/customnewscontentlvl2/news/pha-inconsistency-series-part-iii-mitigating-the-risks",
    "url": "/new/federal/pha-inconsistency-series-part-iii-mitigating-the-risks",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Permit Electronic Reporting in Arkansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/air-permit-electronic-reporting-in-arkansas",
    "url": "/news/air-permit-electronic-reporting-in-arkansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MassDEP Now Accepting 2016 Source Registrations and GHG Reports-Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/MassDEP-Now-Accepting-2016-Source-Registrations-and-GHG-Reports-Massachusetts",
    "url": "/news/MassDEP-Now-Accepting-2016-Source-Registrations-and-GHG-Reports-Massachusetts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to Mojave Desert AQMD's Comprehensive Emission Inventory Program-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-to-Mojave-Desert-AQMD's-Comprehensive-Emission-Inventory-Program-California",
    "url": "/news/Updates-to-Mojave-Desert-AQMD's-Comprehensive-Emission-Inventory-Program-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MCAQD Daily BACT Limit Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/MCAQD-Daily-BACT-Limit-Updates",
    "url": "/news/MCAQD-Daily-BACT-Limit-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Modeling Tip: Creating Animations with Incident Analyst Results using BREEZE 3D Analyst",
    "apiurl": "/restapi/customnewscontentlvl2/news/Modeling-Tip-Creating-Animations-with-Incident-Analyst-Results-using-BREEZE-3D-Analyst",
    "url": "/news/Modeling-Tip-Creating-Animations-with-Incident-Analyst-Results-using-BREEZE-3D-Analyst",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Modeling Tip: Using 3D Receptor Grid in AERMOD",
    "apiurl": "/restapi/customnewscontentlvl2/news/Modeling-Tip-Using-3D-Receptor-Grid-in-AERMOD-",
    "url": "/news/Modeling-Tip-Using-3D-Receptor-Grid-in-AERMOD-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MBUAPCD Proposed Revisions to Rule 201",
    "apiurl": "/restapi/customnewscontentlvl2/news/MBUAPCD-Proposed-Revisions-to-Rule-201",
    "url": "/news/MBUAPCD-Proposed-Revisions-to-Rule-201",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Addressing Odor Complaints",
    "apiurl": "/restapi/customnewscontentlvl2/news/Addressing-Odor-Complaints",
    "url": "/news/Addressing-Odor-Complaints",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Portland Cement MACT",
    "apiurl": "/restapi/customnewscontentlvl2/news/Portland-Cement-MACT",
    "url": "/news/Portland-Cement-MACT",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Upcoming Modeling Guidelines May Soften Modeling Costs",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ-Upcoming-Modeling-Guidelines-May-Soften-Modeling-Costs",
    "url": "/news/ADEQ-Upcoming-Modeling-Guidelines-May-Soften-Modeling-Costs",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Finalizes Controversial Rules for Boilers/Heaters, Incinerators, and Cement Kilns",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Finalizes-Controversial-Rules-for-Boilers-Heaters-Incinerators-and-Cement-Kilns",
    "url": "/news/EPA-Finalizes-Controversial-Rules-for-Boilers-Heaters-Incinerators-and-Cement-Kilns",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Greenhouse Gas Global Warming Potential",
    "apiurl": "/restapi/customnewscontentlvl2/news/Greenhouse-Gas-Global-Warming-Potential",
    "url": "/news/Greenhouse-Gas-Global-Warming-Potential",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDAQMD Approves Amendments to NSR & PSD Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/mdaqmd-approves-amendments-to-nsr-psd-rules",
    "url": "/news/mdaqmd-approves-amendments-to-nsr-psd-rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDAQMD Approves Amendments to NSR & PSD Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/mdaqmd-approves-amendments-to-nsr-psd-rules",
    "url": "/www.trinityconsultants.com/news/mdaqmd-approves-amendments-to-nsr-psd-rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Wood Pellet Plant – Greenfield Permitting-Georgia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Wood-Pellet-Plant-Greenfield-Permitting-Georgia",
    "url": "/news/Wood-Pellet-Plant-Greenfield-Permitting-Georgia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reminder: ADEQ Deadline of February 17, 2014, Approaching for Permit Applications for Stationary Engines",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reminder-ADEQ-Deadline-of-February-17-2014-Approaching-for-Permit-Applications-for-Stationary-Engines-",
    "url": "/news/Reminder-ADEQ-Deadline-of-February-17-2014-Approaching-for-Permit-Applications-for-Stationary-Engines-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Arizona SIP Revision",
    "apiurl": "/restapi/customnewscontentlvl2/news/Arizona-SIP-Revision",
    "url": "/news/Arizona-SIP-Revision",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Opens New Office in China",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Opens-New-Office-in-China",
    "url": "/news/Trinity-Consultants-Opens-New-Office-in-China",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Confirms Title V Flexible Air Permitting (FAP)",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Confirms-Title-V-Flexible-Air-Permitting-(FAP)",
    "url": "/news/EPA-Confirms-Title-V-Flexible-Air-Permitting-(FAP)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Title V Application Completeness Review Checklist",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Title-V-Application-Completeness-Review-Checklist",
    "url": "/news/New-Title-V-Application-Completeness-Review-Checklist",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Regional Haze and Prong 4 SIP Revisions-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Regional-Haze-and-Prong-4-SIP-Revisions-Iowa",
    "url": "/news/Regional-Haze-and-Prong-4-SIP-Revisions-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NYSDEC Amends Regulations Under 6 NYCRR 200.1 to Revise the Definition of “Nonattainment Area” for Fine Particulate Matter (PM-2.5)",
    "apiurl": "/restapi/customnewscontentlvl2/news/NYSDEC-Amends-Regulations-Under-6-NYCRR-200-1-to-Revise-the-Definition-of-Nonattainment-Area-for-Fine-Particulate-Matter-(PM-2-5)",
    "url": "/news/NYSDEC-Amends-Regulations-Under-6-NYCRR-200-1-to-Revise-the-Definition-of-Nonattainment-Area-for-Fine-Particulate-Matter-(PM-2-5)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Uinta Basin Ozone Nonattainment Area Potential Reclassification",
    "apiurl": "/restapi/customnewscontentlvl2/news/uinta-basin-ozone-nonattainment-area-potential-reclassification",
    "url": "/news/uinta-basin-ozone-nonattainment-area-potential-reclassification",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Uinta Basin Ozone Nonattainment Area Potential Reclassification",
    "apiurl": "/restapi/customnewscontentlvl2/news/uinta-basin-ozone-nonattainment-area-potential-reclassification",
    "url": "/news/states/utah/uinta-basin-ozone-nonattainment-area-potential-reclassification",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Developing Collocation Policy for Rock Products Industry",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ-Developing-Collocation-Policy-for-Rock-Products-Industry-",
    "url": "/news/ADEQ-Developing-Collocation-Policy-for-Rock-Products-Industry-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Improving Environmental Permitting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Improving-Environmental-Permitting",
    "url": "/news/Improving-Environmental-Permitting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Federal Court Strikes Down EPA's Policy on Source Aggregation",
    "apiurl": "/restapi/customnewscontentlvl2/news/Federal-Court-Strikes-Down-EPA's-Policy-on-Source-Aggregation",
    "url": "/news/Federal-Court-Strikes-Down-EPA's-Policy-on-Source-Aggregation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New IDNR Emissions Reporting System Available for Testing",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-IDNR-Emissions-Reporting-System-Available-for-Testing",
    "url": "/news/New-IDNR-Emissions-Reporting-System-Available-for-Testing",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CAIR Reinstated",
    "apiurl": "/restapi/customnewscontentlvl2/news/CAIR-Reins",
    "url": "/news/CAIR-Reins",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Environmental Emergency Regulations (E2 Regulations)",
    "apiurl": "/restapi/customnewscontentlvl2/news/Environmental-Emergency-Regulations-(E2-Regulations)",
    "url": "/news/Environmental-Emergency-Regulations-(E2-Regulations)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "REMINDER: Required Maricopa County Annual Emissions Inventory",
    "apiurl": "/restapi/customnewscontentlvl2/news/REMINDER-Required-Maricopa-County-Annual-Emissions-Inventory",
    "url": "/news/REMINDER-Required-Maricopa-County-Annual-Emissions-Inventory",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Guidance on Utah’s R307-130 - General Penalty Policy-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/Guidance-on-Utah-s-R307-130---General-Penalty-Policy-Utah",
    "url": "/news/Guidance-on-Utah-s-R307-130---General-Penalty-Policy-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDNR Appoints New Program Directors for Water & Hazardous Waste Programs-Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDNR-Appoints-New-Program-Directors-for-Water-Hazardous-Waste-Programs-Missouri",
    "url": "/news/MDNR-Appoints-New-Program-Directors-for-Water-Hazardous-Waste-Programs-Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DHEC Air Program Funding",
    "apiurl": "/restapi/customnewscontentlvl2/news/DHEC-Air-Program-Funding",
    "url": "/news/DHEC-Air-Program-Funding",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New EPA White Papers May Lead to Additional Oil & Gas Regulation",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-EPA-White-Papers-May-Lead-to-Additional-Oil-Gas-Regulation",
    "url": "/news/New-EPA-White-Papers-May-Lead-to-Additional-Oil-Gas-Regulation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Revision to Delaware’s State Implementation Plan (SIP) for Ozone NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Revision-to-Delaware-s-State-Implementation-Plan-(SIP)-for-Ozone-NAAQS",
    "url": "/news/Proposed-Revision-to-Delaware-s-State-Implementation-Plan-(SIP)-for-Ozone-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Adam Schnieders Selected as New DNR Water Quality Coordinator",
    "apiurl": "/restapi/customnewscontentlvl2/news/Adam-Schnieders-Selected-as-New-DNR-Water-Quality-Coordinator",
    "url": "/news/Adam-Schnieders-Selected-as-New-DNR-Water-Quality-Coordinator",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "COGCC Form 42 Revisions",
    "apiurl": "/restapi/customnewscontentlvl2/news/COGCC-Form-42-Revisions",
    "url": "/news/COGCC-Form-42-Revisions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Coast Air Quality Management District - New Source Review Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Coast-Air-Quality-Management-District---New-Source-Review-Amendments",
    "url": "/news/South-Coast-Air-Quality-Management-District---New-Source-Review-Amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDNR Fee Stakeholder Meetings",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDNR-Fee-Stakeholder-Meetings",
    "url": "/news/MDNR-Fee-Stakeholder-Meetings",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Annual Emission Inventories Due April 1st",
    "apiurl": "/restapi/customnewscontentlvl2/news/Annual-Emission-Inventories-Due-April-1st",
    "url": "/news/Annual-Emission-Inventories-Due-April-1st",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CDPHE Oil & Gas Stakeholders Meeting Scheudled",
    "apiurl": "/restapi/customnewscontentlvl2/news/CDPHE-Oil-Gas-Stakeholders-Meeting-Scheudled",
    "url": "/news/CDPHE-Oil-Gas-Stakeholders-Meeting-Scheudled",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2015 Important Dates Related to Arkansas Air Permitting",
    "apiurl": "/restapi/customnewscontentlvl2/news/2015-Important-Dates-Related-to-Arkansas-Air-Permitting",
    "url": "/news/2015-Important-Dates-Related-to-Arkansas-Air-Permitting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DOEE Proposes Changes to Air Quality Permitting Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/DOEE-Proposes-Changes-to-Air-Quality-Permitting-Regulations",
    "url": "/news/DOEE-Proposes-Changes-to-Air-Quality-Permitting-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Iowa Strategic Goals Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/Iowa-Strategic-Goals-Program",
    "url": "/news/Iowa-Strategic-Goals-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Endangerment Finding Clears Path for GHG Regulation",
    "apiurl": "/restapi/customnewscontentlvl2/news/Endangerme",
    "url": "/news/Endangerme",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Hazardous Waste Generator Improvements Rule to Become Effective April 2018 in Virginia-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Hazardous-Waste-Generator-Improvements-Rule-to-Become-Effective-April-2018-in-Virginia-Virginia",
    "url": "/news/Hazardous-Waste-Generator-Improvements-Rule-to-Become-Effective-April-2018-in-Virginia-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE Incident Analyst – New Enhancements and Getting Started Video Series",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-Incident-Analyst-New-Enhancements-and-Getting-Started-Video-Series",
    "url": "/news/BREEZE-Incident-Analyst-New-Enhancements-and-Getting-Started-Video-Series",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ARB’s Amendments to Cap-and-Trade Regulations and Offset Protocols",
    "apiurl": "/restapi/customnewscontentlvl2/news/ARB-s-Amendments-to-Cap-and-Trade-Regulations-and-Offset-Protocols-",
    "url": "/news/ARB-s-Amendments-to-Cap-and-Trade-Regulations-and-Offset-Protocols-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Finalized Changes to AP-42 Chapter 7.1 - Organic Liquid Storage Tanks",
    "apiurl": "/restapi/customnewscontentlvl2/news/finalized-changes-to-ap-42-chapter-7-1-organic-liquid-storage-tanks",
    "url": "/news/finalized-changes-to-ap-42-chapter-7-1-organic-liquid-storage-tanks",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Finalized Changes to AP-42 Chapter 7.1 - Organic Liquid Storage Tanks",
    "apiurl": "/restapi/customnewscontentlvl2/news/finalized-changes-to-ap-42-chapter-7-1-organic-liquid-storage-tanks",
    "url": "/news/finalized-changes-to-ap-42-chapter-7.1---organic-liquid-storage-tanks",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Finalized Changes to AP-42 Chapter 7.1 - Organic Liquid Storage Tanks",
    "apiurl": "/restapi/customnewscontentlvl2/news/finalized-changes-to-ap-42-chapter-7-1-organic-liquid-storage-tanks",
    "url": "/News/Federal/Finalized-Changes-to-AP-42-Chapter-7-1---Organic-Liquid-Storage-Tanks/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Canada's Environmental Emergency (E2) Regulations – 2019-Ontario",
    "apiurl": "/restapi/customnewscontentlvl2/news/Canada's-Environmental-Emergency-(E2)-Regulations-2019-Ontario",
    "url": "/news/Canada's-Environmental-Emergency-(E2)-Regulations-2019-Ontario",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Revisions to the Rhode Island’s RACT SIP-Rhode Island",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Revisions-to-the-Rhode-Island-s-RACT-SIP-Rhode-Island",
    "url": "/news/Proposed-Revisions-to-the-Rhode-Island-s-RACT-SIP-Rhode-Island",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE AERMOD 7.4 Enhancements Streamline U.S. NAAQS Modeling",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-AERMOD-7-4-Enhancements-Streamline-U-S-NAAQS-Modeling-",
    "url": "/news/BREEZE-AERMOD-7-4-Enhancements-Streamline-U-S-NAAQS-Modeling-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CARB Adopts New Risk Management Guidance for Stationary Source Air Toxics",
    "apiurl": "/restapi/customnewscontentlvl2/news/CARB-Adopts-New-Risk-Management-Guidance-for-Stationary-Source-Air-Toxics",
    "url": "/news/CARB-Adopts-New-Risk-Management-Guidance-for-Stationary-Source-Air-Toxics",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Pending Discontinuation of NJDEP’s General Permit for Research & Development Facilities (GP-020) Requires Action",
    "apiurl": "/restapi/customnewscontentlvl2/news/pending-discontinuation-njdeps-general-permit-for-research-development-facilities-gp-020-requires-action",
    "url": "/news/pending-discontinuation-njdeps-general-permit-for-research-development-facilities-gp-020-requires-action",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Delaware Department of Natural Resources and Environmental Control (DNREC) Finalizes Regulations on Volatile Organic Compound Emissions from Printing Operations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Delaware-Department-of-Natural-Resources-and-Environmental-Control-(DNREC)-Finalizes-Regulations-on-Volatile-Organic-Compound-Emissions-from-Printing-Operations",
    "url": "/news/Delaware-Department-of-Natural-Resources-and-Environmental-Control-(DNREC)-Finalizes-Regulations-on-Volatile-Organic-Compound-Emissions-from-Printing-Operations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Federal Plan for Municipal Solid Waste Landfills",
    "apiurl": "/restapi/customnewscontentlvl2/news/final-federal-plan-for-municipal-solid-waste-landfills",
    "url": "/news/final-federal-plan-for-municipal-solid-waste-landfills",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Colorado Implements Withdrawal of \"Once In, always In\" Policy-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Colorado-Implements-Withdrawal-of-Once-In-always-In-Policy-Colorado",
    "url": "/news/Colorado-Implements-Withdrawal-of-Once-In-always-In-Policy-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Continues to Revise and Update NSR Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ-Continues-to-Revise-and-Update-NSR-Program",
    "url": "/news/ADEQ-Continues-to-Revise-and-Update-NSR-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Local Air Agency Status.....",
    "apiurl": "/restapi/customnewscontentlvl2/news/Local-Air-Agency-Status-",
    "url": "/news/Local-Air-Agency-Status-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The State of Tennessee Makes Recommendation for  SO2 Designations",
    "apiurl": "/restapi/customnewscontentlvl2/news/The-State-of-Tennessee-Makes-Recommendation-for-SO2-Designations",
    "url": "/news/The-State-of-Tennessee-Makes-Recommendation-for-SO2-Designations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Refinery Sector Rule Upcoming Deadlines-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Refinery-Sector-Rule-Upcoming-Deadlines-Texas",
    "url": "/news/Refinery-Sector-Rule-Upcoming-Deadlines-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments to Indiana ESP and CLEAN Programs",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendments-to-Indiana-ESP-and-CLEAN-Programs",
    "url": "/news/Proposed-Amendments-to-Indiana-ESP-and-CLEAN-Programs",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Draft Air Permitting Fee Rulemaking-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Draft-Air-Permitting-Fee-Rulemaking-Iowa",
    "url": "/news/Draft-Air-Permitting-Fee-Rulemaking-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MCAQD Workshops",
    "apiurl": "/restapi/customnewscontentlvl2/news/MCAQD-Workshops-",
    "url": "/news/MCAQD-Workshops-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Registration Requirements for Stationary ICE",
    "apiurl": "/restapi/customnewscontentlvl2/news/Registration-Requirements-for-Stationary-ICE",
    "url": "/news/Registration-Requirements-for-Stationary-ICE",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed New Regulations under Chapter 115 for Oil & Natural Gas Service in Ozone Nonattainment Areas",
    "apiurl": "/restapi/customnewscontentlvl2/news/proposed-new-regulations-under-chapter-115-for-oil-natural-gas-service-in-ozone-nonattainment-areas",
    "url": "/news/proposed-new-regulations-under-chapter-115-for-oil-natural-gas-service-in-ozone-nonattainment-areas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Delays GHG Reporting Deadline",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Delays-GHG-Reporting-Deadline",
    "url": "/news/EPA-Delays-GHG-Reporting-Deadline",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Hydrocarbon Loading Specialty APEN",
    "apiurl": "/restapi/customnewscontentlvl2/news/Hydrocarbon-Loading-Specialty-APEN",
    "url": "/news/Hydrocarbon-Loading-Specialty-APEN",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Governor's Environmental Awards Deadline - September 15",
    "apiurl": "/restapi/customnewscontentlvl2/news/Governor's-Environmental-Awards-Deadline---September-15",
    "url": "/news/Governor's-Environmental-Awards-Deadline---September-15",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "All-In Clark County GHG Reduction Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/all-in-clark-county-ghg-reduction-program",
    "url": "/news/all-in-clark-county-ghg-reduction-program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "All-In Clark County GHG Reduction Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/all-in-clark-county-ghg-reduction-program",
    "url": "/news/states/nevada/all-in-clark-county-ghg-reduction-program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NESHAP SSM Exemption Vacatur Mandated by the  DC Circuit",
    "apiurl": "/restapi/customnewscontentlvl2/news/NESHAP-SSM-Exemption-Vacatur-Mandated-by-the-DC-Circuit",
    "url": "/news/NESHAP-SSM-Exemption-Vacatur-Mandated-by-the-DC-Circuit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments to CARB HFC Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/proposed-amendments-to-carb-hfc-regulations",
    "url": "/news/proposed-amendments-to-carb-hfc-regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments to CARB HFC Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/proposed-amendments-to-carb-hfc-regulations",
    "url": "/news/states/california/proposed-amendments-to-carb-hfc-regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SJVAPCD Rule 3110 Update-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/SJVAPCD-Rule-3110-Update-California",
    "url": "/news/SJVAPCD-Rule-3110-Update-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Preparing for 2021 Reporting Season in the Pacific Northwest",
    "apiurl": "/restapi/customnewscontentlvl2/news/preparing-for-2021-reporting-season-in-the-pacific-northwest",
    "url": "/news/preparing-for-2021-reporting-season-in-the-pacific-northwest",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Preparing for 2021 Reporting Season in the Pacific Northwest",
    "apiurl": "/restapi/customnewscontentlvl2/news/preparing-for-2021-reporting-season-in-the-pacific-northwest",
    "url": "/preparing-for-2021-reporting-season-in-the-pacific-northwest",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Regulatory Dispersion Model AERMOD Updated",
    "apiurl": "/restapi/customnewscontentlvl2/news/Regulatory",
    "url": "/news/Regulatory",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Toxics Release Inventory (TRI) Training",
    "apiurl": "/restapi/customnewscontentlvl2/news/Toxics-Release-Inventory-(TRI)-Training",
    "url": "/news/Toxics-Release-Inventory-(TRI)-Training",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "12 Common SPCC Misconceptions",
    "apiurl": "/restapi/customnewscontentlvl2/news/12-common-spcc-misconceptions",
    "url": "/news/12-common-spcc-misconceptions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "12 Common SPCC Misconceptions",
    "apiurl": "/restapi/customnewscontentlvl2/news/12-common-spcc-misconceptions",
    "url": "/News/Federal/12-Common-SPCC-Misconceptions/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Acquires Chemical Regulatory and Risk Management Firm, The Redstone Group",
    "apiurl": "/restapi/customnewscontentlvl2/news/d53b9bad-009d-431a-a9d7-c9e6a0c5f826",
    "url": "/news/d53b9bad-009d-431a-a9d7-c9e6a0c5f826",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Does Your Facility Have a Pandemic Response and/or Preparedness Plan?",
    "apiurl": "/restapi/customnewscontentlvl2/news/does-your-facility-have-a-pandemic-response-and-or-preparedness-plan-",
    "url": "/news/does-your-facility-have-a-pandemic-response-and-or-preparedness-plan-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEE Inviting Comments on Air Permit Conditions I and II-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEE-Inviting-Comments-on-Air-Permit-Conditions-I-and-II-Nebraska",
    "url": "/news/NDEE-Inviting-Comments-on-Air-Permit-Conditions-I-and-II-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reporting TAPS in your Annual Emission Statement in 2019-New Jersey",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reporting-TAPS-in-your-Annual-Emission-Statement-in-2019-New-Jersey",
    "url": "/news/Reporting-TAPS-in-your-Annual-Emission-Statement-in-2019-New-Jersey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ventura County APCD Draft Amendments to Rules 71, 71.1, and 71.3",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ventura-County-APCD-Draft-Amendments-to-Rules-71-71-1-and-71-3",
    "url": "/news/Ventura-County-APCD-Draft-Amendments-to-Rules-71-71-1-and-71-3",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Pollutant Discharge Elimination System Multi-Sector General Permit (MSGP) Changes Effective January",
    "apiurl": "/restapi/customnewscontentlvl2/news/Pollutant-Discharge-Elimination-System-Multi-Sector-General-Permit-(MSGP)-Changes-Effective-January-",
    "url": "/news/Pollutant-Discharge-Elimination-System-Multi-Sector-General-Permit-(MSGP)-Changes-Effective-January-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA Finalizes Chicagoland Ozone Attainment Discussions",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-Finalizes-Chicagoland-Ozone-Attainment-Discussions",
    "url": "/news/USEPA-Finalizes-Chicagoland-Ozone-Attainment-Discussions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ's VESP Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ's-VESP-Program",
    "url": "/news/ADEQ's-VESP-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Interactive Data Analysis Tool for Utah PM 2.5 State Implementation Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Interactive-Data-Analysis-Tool-for-Utah-PM-2-5-State-Implementation-Plan",
    "url": "/news/Interactive-Data-Analysis-Tool-for-Utah-PM-2-5-State-Implementation-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Mandatory and Voluntary Carbon Markets: Current Status and Future Opportunities",
    "apiurl": "/restapi/customnewscontentlvl2/news/b17ffabc-27aa-459d-bcd0-9476880f6d45",
    "url": "/news/b17ffabc-27aa-459d-bcd0-9476880f6d45",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "California Air Resources Board’s (ARB’s) Greenhouse Gas Reporting Deadline Extension:",
    "apiurl": "/restapi/customnewscontentlvl2/news/California-Air-Resources-Board-s-(ARB-s)-Greenhouse-Gas-Reporting-Deadline-Extension-",
    "url": "/news/California-Air-Resources-Board-s-(ARB-s)-Greenhouse-Gas-Reporting-Deadline-Extension-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "OEHHA’s Air Toxics Hot Spots Draft Guidance Manual Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/OEHHA-s-Air-Toxics-Hot-Spots-Draft-Guidance-Manual-Released-",
    "url": "/news/OEHHA-s-Air-Toxics-Hot-Spots-Draft-Guidance-Manual-Released-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MEDQ's Proposed SO2 SIP",
    "apiurl": "/restapi/customnewscontentlvl2/news/MEDQs-Proposed-SO2-SIP",
    "url": "/news/MEDQs-Proposed-SO2-SIP",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MEDQ's Proposed SO2 SIP",
    "apiurl": "/restapi/customnewscontentlvl2/news/MEDQs-Proposed-SO2-SIP",
    "url": "/news/MEDQ-s-Proposed-SO2-SIP",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DOEE Finalizes Synthetic Minor and Air Permit Fees Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/doee-finalizes-synthetic-minor-and-air-permit-fees-regulations",
    "url": "/news/doee-finalizes-synthetic-minor-and-air-permit-fees-regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DOEE Finalizes Synthetic Minor and Air Permit Fees Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/doee-finalizes-synthetic-minor-and-air-permit-fees-regulations",
    "url": "/state/doee-finalizes-synthetic-minor-and-air-permit-fees-regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Supreme Court Ruling Allows CSAPR to Proceed-Wisconsin",
    "apiurl": "/restapi/customnewscontentlvl2/news/Supreme-Court-Ruling-Allows-CSAPR-to-Proceed-Wisconsin",
    "url": "/news/Supreme-Court-Ruling-Allows-CSAPR-to-Proceed-Wisconsin",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New EPA Region 6 Administrator",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-EPA-Region-6-Administrator",
    "url": "/news/New-EPA-Region-6-Administrator",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Sets Stake in Philadelphia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Sets-Stake-in-Philadelphia",
    "url": "/news/Trinity-Consultants-Sets-Stake-in-Philadelphia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPD Publishes New Antidegradation Analysis Guidelines",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPD-Publis",
    "url": "/news/EPD-Publis",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Draft Regulations Proposed by PADEP Requiring Phasedown of HFC use and Manufacturing",
    "apiurl": "/restapi/customnewscontentlvl2/news/draft-regulations-proposed-by-padep-requiring-phasedown-of-hfc-use-and-manufacturing",
    "url": "/news/draft-regulations-proposed-by-padep-requiring-phasedown-of-hfc-use-and-manufacturing",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Addendum to 2018 Ambient Air Monitoring Plan-Georgia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Addendum-to-2018-Ambient-Air-Monitoring-Plan-Georgia",
    "url": "/news/Addendum-to-2018-Ambient-Air-Monitoring-Plan-Georgia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes to MCAQD Startup, Shutdown, and Malfunction Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Changes-to-MCAQD-Startup-Shutdown-and-Malfunction-Rule",
    "url": "/news/Changes-to-MCAQD-Startup-Shutdown-and-Malfunction-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Particulate Matter, PM2.5 New Source Review (NSR) and Greenhouse Gas Tailoring Amendments to 6 NYCRR, Part 231 Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Particulate-Matter-PM2-5-New-Source-Review-(NSR)-and-Greenhouse-Gas-Tailoring-Amendments-to-6-NYCRR-Part-231-Regulations",
    "url": "/news/Particulate-Matter-PM2-5-New-Source-Review-(NSR)-and-Greenhouse-Gas-Tailoring-Amendments-to-6-NYCRR-Part-231-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ozone NAAQS Revisions Proposed",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ozone-NAAQS-Revisions-Proposed",
    "url": "/news/Ozone-NAAQS-Revisions-Proposed",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments to Fuel Sulfur Content Limitations in Env-A 1600-New Hampshire",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendments-to-Fuel-Sulfur-Content-Limitations-in-Env-A-1600-New-Hampshire",
    "url": "/news/Proposed-Amendments-to-Fuel-Sulfur-Content-Limitations-in-Env-A-1600-New-Hampshire",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEQ Proposed Haul Road Policy Change",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEQ-Proposed-Haul-Road-Policy-Change",
    "url": "/news/NDEQ-Proposed-Haul-Road-Policy-Change",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GHG Reporting Reminder – New 10,000 tonne CO2 eq Threshold for Report Due June 1, 2018-Alberta",
    "apiurl": "/restapi/customnewscontentlvl2/news/GHG-Reporting-Reminder-New-10-000-tonne-CO2-eq-Threshold-for-Report-Due-June-1-2018-Alberta",
    "url": "/news/GHG-Reporting-Reminder-New-10-000-tonne-CO2-eq-Threshold-for-Report-Due-June-1-2018-Alberta",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "U.S. EPA Proposes Rule to Address Nonattainment New Source Review in Former 1-Hour Ozone Nonattainment Areas",
    "apiurl": "/restapi/customnewscontentlvl2/news/U-S-EPA-Proposes-Rule-to-Address-Nonattainment-New-Source-Review-in-Former-1-Hour-Ozone-Nonattainment-Areas",
    "url": "/news/U-S-EPA-Proposes-Rule-to-Address-Nonattainment-New-Source-Review-in-Former-1-Hour-Ozone-Nonattainment-Areas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Fugitive Component Leak Form from APEN",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Fugitive-Component-Leak-Form-from-APEN-",
    "url": "/news/New-Fugitive-Component-Leak-Form-from-APEN-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Federal Cap-and-Trade Legislation Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/Federal-Cap-and-Trade-Legislation-Update",
    "url": "/news/Federal-Cap-and-Trade-Legislation-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Region 5 - Regional Administrator Named-Minnesota",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Region-5---Regional-Administrator-Named-Minnesota",
    "url": "/news/EPA-Region-5---Regional-Administrator-Named-Minnesota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Self Certification Guidance",
    "apiurl": "/restapi/customnewscontentlvl2/news/Self-Certification-Guidance",
    "url": "/news/Self-Certification-Guidance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Engineering Guide #71 Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Engineering-Guide-71-Updates",
    "url": "/news/Engineering-Guide-71-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE ExDAM 9.0 Improved for High Explosive and Vapor Cloud Explosion Modeling",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-ExDAM-9-0-Improved-for-High-Explosive-and-Vapor-Cloud-Explosion-Modeling",
    "url": "/news/BREEZE-ExDAM-9-0-Improved-for-High-Explosive-and-Vapor-Cloud-Explosion-Modeling",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Imperial County Revised Regulation VIII",
    "apiurl": "/restapi/customnewscontentlvl2/news/Imperial-County-Revised-Regulation-VIII",
    "url": "/news/Imperial-County-Revised-Regulation-VIII",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Year Brings New MRR Subpart W Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Year-Brings-New-MRR-Subpart-W-Amendments",
    "url": "/news/New-Year-Brings-New-MRR-Subpart-W-Amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "RIDEM Proposes Revisions to Surface Coating Regulations-Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/RIDEM-Proposes-Revisions-to-Surface-Coating-Regulations-Massachusetts",
    "url": "/news/RIDEM-Proposes-Revisions-to-Surface-Coating-Regulations-Massachusetts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Linn County Air Quality Program Update-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Linn-County-Air-Quality-Program-Update-Iowa",
    "url": "/news/Linn-County-Air-Quality-Program-Update-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Guidance on New Virginia UST Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/guidance-on-new-virginia-ust-requirements",
    "url": "/news/guidance-on-new-virginia-ust-requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Minnesota Specific Reporting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Minnesota-Specific-Reporting",
    "url": "/news/Minnesota-Specific-Reporting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "August 2009 Federal Register Notices",
    "apiurl": "/restapi/customnewscontentlvl2/news/August-2009-Federal-Register-Notices",
    "url": "/news/August-2009-Federal-Register-Notices",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Revisions to Ambient Monitoring Quality Assurance and Other Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Revisions-to-Ambient-Monitoring-Quality-Assurance-and-Other-Requirements",
    "url": "/news/Proposed-Revisions-to-Ambient-Monitoring-Quality-Assurance-and-Other-Requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Rule Updates of Residual Risk and Technology Review for NESHAP Miscellaneous Organic Chemical Manufacturing",
    "apiurl": "/restapi/customnewscontentlvl2/news/final-rule-updates-of-residual-risk-and-technology-review-for-neshap-miscellaneous-organic-chemical-manufacturing-",
    "url": "/news/final-rule-updates-of-residual-risk-and-technology-review-for-neshap-miscellaneous-organic-chemical-manufacturing-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Rule Updates of Residual Risk and Technology Review for NESHAP Miscellaneous Organic Chemical Manufacturing",
    "apiurl": "/restapi/customnewscontentlvl2/news/final-rule-updates-of-residual-risk-and-technology-review-for-neshap-miscellaneous-organic-chemical-manufacturing-",
    "url": "/news/federal/final-rule-updates-of-residual-risk-and-technology-review-for-neshap-miscellaneous-organic-chemical-manufacturing",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Texas Discharge Monitoring Reports (DMRS) for Multi-Sector General Permit (MSGP) Stormwater Permittees-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Texas-Discharge-Monitoring-Reports-(DMRS)-for-Multi-Sector-General-Permit-(MSGP)-Stormwater-Permittees-Texas",
    "url": "/news/Texas-Discharge-Monitoring-Reports-(DMRS)-for-Multi-Sector-General-Permit-(MSGP)-Stormwater-Permittees-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Approaching Regulatory Deadlines-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/Approaching-Regulatory-Deadlines-New-Mexico",
    "url": "/news/Approaching-Regulatory-Deadlines-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Draft Title V EZ Mod Form",
    "apiurl": "/restapi/customnewscontentlvl2/news/Draft-Title-V-EZ-Mod-Form",
    "url": "/news/Draft-Title-V-EZ-Mod-Form",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LDEQ Minor Source Air Permit Renewal Due Dates",
    "apiurl": "/restapi/customnewscontentlvl2/news/LDEQ-Minor-Source-Air-Permit-Renewal-Due-Dates",
    "url": "/news/LDEQ-Minor-Source-Air-Permit-Renewal-Due-Dates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Canadian Water Firm Minnow Environmental Joins Trinity Consultants",
    "apiurl": "/restapi/customnewscontentlvl2/news/Canadian-Water-Firm-Minnow-Environmental-Joins-Trinity-Consultants",
    "url": "/news/Canadian-Water-Firm-Minnow-Environmental-Joins-Trinity-Consultants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Draft General Air Permit (GP-009A) for Boiler(s) and Indirect Fired Process Heater(s) Each Greater Than or Equal to 10 MMBTU/hr and Less Than 50 MMBTU/hr",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Draft-General-Air-Permit-(GP-009A)-for-Boiler(s)-and-Indirect-Fired-Process-Heater(s)-Each-Greater-Than-or-Equal-to-10-MMBTU-hr-and-Less-Than-50-MMBTU-hr",
    "url": "/news/New-Draft-General-Air-Permit-(GP-009A)-for-Boiler(s)-and-Indirect-Fired-Process-Heater(s)-Each-Greater-Than-or-Equal-to-10-MMBTU-hr-and-Less-Than-50-MMBTU-hr",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Selects New Leader for Rocky Mountain States",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Selects-New-Leader-for-Rocky-Mountain-States",
    "url": "/news/Trinity-Consultants-Selects-New-Leader-for-Rocky-Mountain-States",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed SIP Approval for Fuel Sulfur Limitations – New Hampshire",
    "apiurl": "/restapi/customnewscontentlvl2/news/proposed-sip-approval-for-fuel-sulfur-limitations-new-hampshire",
    "url": "/news/proposed-sip-approval-for-fuel-sulfur-limitations-new-hampshire",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Electric Power Expert Leads  Roanoke Office",
    "apiurl": "/restapi/customnewscontentlvl2/news/Electric-Power-Expert-Leads-Roanoke-Office",
    "url": "/news/Electric-Power-Expert-Leads-Roanoke-Office",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NOx Trading Program Sunset Provisions for Non-Electric Generating Units",
    "apiurl": "/restapi/customnewscontentlvl2/news/NOx-Trading-Program-Sunset-Provisions-for-Non-Electric-Generating-Units",
    "url": "/news/NOx-Trading-Program-Sunset-Provisions-for-Non-Electric-Generating-Units",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "VTDEC Updates CO2 Budget Trading Regulations-Vermont",
    "apiurl": "/restapi/customnewscontentlvl2/news/VTDEC-Updates-CO2-Budget-Trading-Regulations-Vermont",
    "url": "/news/VTDEC-Updates-CO2-Budget-Trading-Regulations-Vermont",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "e-Manifest - New York Hazardous Waste Program to Differ Slightly from New EPA Program-New York",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-York-Hazardous-Waste-Program-to-Differ-Slightly-from-New-EPA-Program-New-York",
    "url": "/news/New-York-Hazardous-Waste-Program-to-Differ-Slightly-from-New-EPA-Program-New-York",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "e-Manifest - New York Hazardous Waste Program to Differ Slightly from New EPA Program-New York",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-York-Hazardous-Waste-Program-to-Differ-Slightly-from-New-EPA-Program-New-York",
    "url": "/news/e-Manifest---New-York-Hazardous-Waste-Program-to-Differ-Slightly-from-New-EPA-Program-New-York",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NSPS and MACT Update in New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/NSPS-and-MACT-Update-in-New-Mexico",
    "url": "/news/NSPS-and-MACT-Update-in-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "RIDEM Proposes Revisions to Several Air Quality Regulations-Rhode Island",
    "apiurl": "/restapi/customnewscontentlvl2/news/RIDEM-Proposes-Revisions-to-Several-Air-Quality-Regulations-Rhode-Island",
    "url": "/news/RIDEM-Proposes-Revisions-to-Several-Air-Quality-Regulations-Rhode-Island",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KDHE Issues Draft 5-Year Ambient Air Monitoring Network Assessment",
    "apiurl": "/restapi/customnewscontentlvl2/news/kdhe-issues-draft-5-year-ambient-air-monitoring-network-assessment",
    "url": "/news/kdhe-issues-draft-5-year-ambient-air-monitoring-network-assessment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KDHE Issues Draft 5-Year Ambient Air Monitoring Network Assessment",
    "apiurl": "/restapi/customnewscontentlvl2/news/kdhe-issues-draft-5-year-ambient-air-monitoring-network-assessment",
    "url": "/news/state/kansas/kdhe-issues-draft-5-year-ambient-air-monitoring-network-assessment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Missouri Chamber of Commerce and Industry hosts 2015 Missouri Environmental & Energy Conference-Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/Missouri-Chamber-of-Commerce-and-Industry-hosts-2015-Missouri-Environmental-Energy-Conference-Missouri",
    "url": "/news/Missouri-Chamber-of-Commerce-and-Industry-hosts-2015-Missouri-Environmental-Energy-Conference-Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Emergency Rule Making for Material Storage and Handling: How may these affect your facility?",
    "apiurl": "/restapi/customnewscontentlvl2/news/Emergency-Rule-Making-for-Material-Storage-and-Handling-How-may-these-affect-your-facility-",
    "url": "/news/Emergency-Rule-Making-for-Material-Storage-and-Handling-How-may-these-affect-your-facility-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEM revises the Air Division Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEM-revis",
    "url": "/news/ADEM-revis",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DEP Schedules Listening Sessions on the Clean Power Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/DEP-Schedules-Listening-Sessions-on-the-Clean-Power-Plan",
    "url": "/news/DEP-Schedules-Listening-Sessions-on-the-Clean-Power-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Regional Haze Rule Second Planning Period-Montana",
    "apiurl": "/restapi/customnewscontentlvl2/news/Regional-Haze-Rule-Second-Planning-Period-Montana",
    "url": "/news/Regional-Haze-Rule-Second-Planning-Period-Montana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes Revisions to Reciprocating Internal Combustion Engine (RICE) MACT-Montana",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-Revisions-to-Reciprocating-Internal-Combustion-Engine-(RICE)-MACT-Montana",
    "url": "/news/EPA-Proposes-Revisions-to-Reciprocating-Internal-Combustion-Engine-(RICE)-MACT-Montana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Snow Means Ozone (Maybe) in the Upper Green-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Snow-Means-Ozone-(Maybe)-in-the-Upper-Green-Wyoming",
    "url": "/news/Snow-Means-Ozone-(Maybe)-in-the-Upper-Green-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants’ President/CEO Jay Hofmann Elected to Board of Directors for the Council of Industrial Boiler Owners",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-President-CEO-Jay-Hofmann-Elected-to-Board-of-Directors-for-the-Council-of-Industrial-Boiler-Owners",
    "url": "/news/Trinity-Consultants-President-CEO-Jay-Hofmann-Elected-to-Board-of-Directors-for-the-Council-of-Industrial-Boiler-Owners",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Small but Important Changes to Utah’s Permitting Rule R307-401",
    "apiurl": "/restapi/customnewscontentlvl2/news/small-but-important-changes-to-utah-s-permitting-rule-r307-401",
    "url": "/news/small-but-important-changes-to-utah-s-permitting-rule-r307-401",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Small but Important Changes to Utah’s Permitting Rule R307-401",
    "apiurl": "/restapi/customnewscontentlvl2/news/small-but-important-changes-to-utah-s-permitting-rule-r307-401",
    "url": "/states/small-but-important-changes-to-utah-s-permitting-rule-r307-401",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on Ozone Designations in Indiana-Indiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-Ozone-Designations-in-Indiana-Indiana",
    "url": "/news/Update-on-Ozone-Designations-in-Indiana-Indiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Finalizes Ozone Attainment Designations",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Finalizes-Ozone-Attainment-Designations-",
    "url": "/news/EPA-Finalizes-Ozone-Attainment-Designations-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Pennsylvania's New GP - 5",
    "apiurl": "/restapi/customnewscontentlvl2/news/Pennsylvania's-New-GP---5",
    "url": "/news/Pennsylvania's-New-GP---5",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEP to Extend 2018 Annual Emissions Reporting Deadline for Major Sources and Roll Out New Electronic Reporting System-Nevada",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEP-to-Extend-2018-Annual-Emissions-Reporting-Deadline-for-Major-Sources-and-Roll-Out-New-Electronic-Reporting-System-Nevada",
    "url": "/news/NDEP-to-Extend-2018-Annual-Emissions-Reporting-Deadline-for-Major-Sources-and-Roll-Out-New-Electronic-Reporting-System-Nevada",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Quarterly Air Quality Client Contact Meeting Highlights",
    "apiurl": "/restapi/customnewscontentlvl2/news/Quarterly-Air-Quality-Client-Contact-Meeting-Highlights",
    "url": "/news/Quarterly-Air-Quality-Client-Contact-Meeting-Highlights",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments and Additions to COMAR 26.09 Maryland CO2 Budget Trading Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendments-and-Additions-to-COMAR-26-09-Maryland-CO2-Budget-Trading-Program",
    "url": "/news/Proposed-Amendments-and-Additions-to-COMAR-26-09-Maryland-CO2-Budget-Trading-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Virginia DEQ Proposes Amendments to SIP to Incorporate Federal SO2 Emission Guidelines",
    "apiurl": "/restapi/customnewscontentlvl2/news/Virginia-DEQ-Proposes-Amendments-to-SIP-to-Incorporate-Federal-SO2-Emission-Guidelines",
    "url": "/news/Virginia-DEQ-Proposes-Amendments-to-SIP-to-Incorporate-Federal-SO2-Emission-Guidelines",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IPCB Adopts NOx Rule Revisions for Combustion Engines",
    "apiurl": "/restapi/customnewscontentlvl2/news/IPCB-Adopt",
    "url": "/news/IPCB-Adopt",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Effective Air Compliance Auditing Drives Business Improvement",
    "apiurl": "/restapi/customnewscontentlvl2/news/Effective-Air-Compliance-Auditing-Drives-Business-Improvement",
    "url": "/news/Effective-Air-Compliance-Auditing-Drives-Business-Improvement",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Warm Wishes for the Holiday Season from Trinity Consultants and its Affiliates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Warm-Wishes-for-the-Holiday-Season-from-Trinity-Consultants-and-its-Affiliates",
    "url": "/news/Warm-Wishes-for-the-Holiday-Season-from-Trinity-Consultants-and-its-Affiliates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Guidance for Permit Exempt Facilities-Oklahoma",
    "apiurl": "/restapi/customnewscontentlvl2/news/Guidance-for-Permit-Exempt-Facilities-Oklahoma",
    "url": "/news/Guidance-for-Permit-Exempt-Facilities-Oklahoma",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Maryland SO2 NAAQS Designations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Maryland-SO2-NAAQS-Designations",
    "url": "/news/Maryland-SO2-NAAQS-Designations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Permitting Nonroad Engines in New Mexico-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/Permitting-Nonroad-Engines-in-New-Mexico-New-Mexico",
    "url": "/news/Permitting-Nonroad-Engines-in-New-Mexico-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposed RICE Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposed-RICE-Rules",
    "url": "/news/EPA-Proposed-RICE-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Craig W. Butler, Director",
    "apiurl": "/restapi/customnewscontentlvl2/news/Craig-W-Butler-Director",
    "url": "/news/Craig-W-Butler-Director",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Renewed Focus on Environmental Justice with Biden EPA Pick",
    "apiurl": "/restapi/customnewscontentlvl2/news/renewed-focus-on-environmental-justice-with-biden-epa-pick",
    "url": "/news/renewed-focus-on-environmental-justice-with-biden-epa-pick",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Class I Area Impact Analyses- Upcoming Changes Affecting Sources Near Mammoth Cave NP",
    "apiurl": "/restapi/customnewscontentlvl2/news/Class-I-Ar",
    "url": "/news/Class-I-Ar",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Did you know about the recent Amendments to Cap and Trade Program Regulation and Quantification, Reporting and Verification of Greenhouse Gas Emissions Ontario Regulation?-Ontario",
    "apiurl": "/restapi/customnewscontentlvl2/news/Did-you-know-about-the-recent-Amendments-to-Cap-and-Trade-Program-Regulation-and-Quantification-Reporting-and-Verification-of-Greenhouse-Gas-Emissions-Ontario-Regulation--Ontario",
    "url": "/news/Did-you-know-about-the-recent-Amendments-to-Cap-and-Trade-Program-Regulation-and-Quantification-Reporting-and-Verification-of-Greenhouse-Gas-Emissions-Ontario-Regulation--Ontario",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEM to Hold Hearing on Proposed Revisions to Division 3",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEM-to-Hold-Hearing-on-Proposed-Revisions-to-Division-3",
    "url": "/news/ADEM-to-Hold-Hearing-on-Proposed-Revisions-to-Division-3",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PCAQCD One-time Doubling Expedited Rulemaking",
    "apiurl": "/restapi/customnewscontentlvl2/news/PCAQCD-One-time-Doubling-Expedited-Rulemaking-",
    "url": "/news/PCAQCD-One-time-Doubling-Expedited-Rulemaking-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MassDEP 2018 Source Registration and/or Greenhouse Gas Reports Due on February 26, 2020 for Annual Filers-Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/MassDEP-2018-Source-Registration-and-or-Greenhouse-Gas-Reports-Due-on-February-26-2020-for-Annual-Filers-Massachusetts",
    "url": "/news/MassDEP-2018-Source-Registration-and-or-Greenhouse-Gas-Reports-Due-on-February-26-2020-for-Annual-Filers-Massachusetts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Illinois Permitting News",
    "apiurl": "/restapi/customnewscontentlvl2/news/Illinois-Permitting-News",
    "url": "/news/Illinois-Permitting-News",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GHG Quantification Reporting and Lifecycle Assessment: Does One Size Fit All?",
    "apiurl": "/restapi/customnewscontentlvl2/news/-GHG-Quantification-Reporting-and-Lifecycle-Assessment-Does-One-Size-Fit-All-",
    "url": "/news/-GHG-Quantification-Reporting-and-Lifecycle-Assessment-Does-One-Size-Fit-All-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SPCC Compliance Date Extension Proposed",
    "apiurl": "/restapi/customnewscontentlvl2/news/SPCC-Compliance-Date-Extension-Proposed",
    "url": "/news/SPCC-Compliance-Date-Extension-Proposed",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to the Georgia EPD Website",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-to-the-Georgia-EPD-Website",
    "url": "/news/Updates-to-the-Georgia-EPD-Website",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DHEQ Proposes Revisions to Air Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/DHEQ-Proposes-Revisions-to-Air-Regulations",
    "url": "/news/DHEQ-Proposes-Revisions-to-Air-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Consolidating Resources to Enhance Chemical Sector Support",
    "apiurl": "/restapi/customnewscontentlvl2/news/Consolidating-Resources-to-Enhance-Chemical-Sector-Support",
    "url": "/news/Consolidating-Resources-to-Enhance-Chemical-Sector-Support",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA's Evolving SSM Policy - The Future of SSM and Affirmative Defense",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA's-Evolving-SSM-Policy---The-Future-of-SSM-and-Affirmative-Defense",
    "url": "/news/EPA's-Evolving-SSM-Policy---The-Future-of-SSM-and-Affirmative-Defense",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Latest on Florida's SSM SIP Call",
    "apiurl": "/restapi/customnewscontentlvl2/news/Latest-on-Florida's-SSM-SIP-Call",
    "url": "/news/Latest-on-Florida's-SSM-SIP-Call",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Clean Energy Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/Clean-Energy-Standard-",
    "url": "/news/Clean-Energy-Standard-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Sponsors Hot Air Balloon",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Sponsors-Hot-Air-Balloon",
    "url": "/news/Trinity-Consultants-Sponsors-Hot-Air-Balloon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Annual Monitoring Network Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Annual-Monitoring-Network-Plan",
    "url": "/news/Annual-Monitoring-Network-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated list of non-PFOS based Chrome Plating Chemical Fume Suppressants",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updated-list-of-non-PFOS-based-Chrome-Plating-Chemical-Fume-Suppressants",
    "url": "/news/Updated-list-of-non-PFOS-based-Chrome-Plating-Chemical-Fume-Suppressants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEP Application Fees Increase July 1",
    "apiurl": "/restapi/customnewscontentlvl2/news/ndep-application-fees-increase-july-1",
    "url": "/news/ndep-application-fees-increase-july-1",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEP Application Fees Increase July 1",
    "apiurl": "/restapi/customnewscontentlvl2/news/ndep-application-fees-increase-july-1",
    "url": "/states/ndep-application-fees-increase-july-1",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Updating STEERS-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/TCEQ-Updating-STEERS-Texas",
    "url": "/news/TCEQ-Updating-STEERS-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Upcoming EPA Hazardous Waste Inspections in Kentucky-Kentucky",
    "apiurl": "/restapi/customnewscontentlvl2/news/Upcoming-EPA-Hazardous-Waste-Inspections-in-Kentucky-Kentucky",
    "url": "/news/Upcoming-EPA-Hazardous-Waste-Inspections-in-Kentucky-Kentucky",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Online General Construction Permitting System",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Online-General-Construction-Permitting-System",
    "url": "/news/New-Online-General-Construction-Permitting-System",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Clarification Concerning Emission Fees for Title V Facilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/Clarification-Concerning-Emission-Fees-for-Title-V-Facilities",
    "url": "/news/Clarification-Concerning-Emission-Fees-for-Title-V-Facilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes to GCP-O&G Registration Form and Challenges of Permitting Path-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/Changes-to-GCP-O-G-Registration-Form-and-Challenges-of-Permitting-Path-New-Mexico",
    "url": "/news/Changes-to-GCP-O-G-Registration-Form-and-Challenges-of-Permitting-Path-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Acquires ASK Consulting Engineers of Brisbane, Australia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Acquires-ASK-Consulting-Engineers-of-Brisbane-Australia",
    "url": "/news/Trinity-Consultants-Acquires-ASK-Consulting-Engineers-of-Brisbane-Australia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Acquires ASK Consulting Engineers of Brisbane, Australia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Acquires-ASK-Consulting-Engineers-of-Brisbane-Australia",
    "url": "/www.trinityconsultants.com/news/Trinity-Consultants-Acquires-ASK-Consulting-Engineers-of-Brisbane-Australia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PADEP Proposes Changes to Plan Approval Exemption List and GP - 11",
    "apiurl": "/restapi/customnewscontentlvl2/news/PADEP-Proposes-Changes-to-Plan-Approval-Exemption-List-and-GP---11",
    "url": "/news/PADEP-Proposes-Changes-to-Plan-Approval-Exemption-List-and-GP---11",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DHEC Implementation of One-Hour SO2 NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/DHEC-Implementation-of-One-Hour-SO2-NAAQS",
    "url": "/news/DHEC-Implementation-of-One-Hour-SO2-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "San Antonio Emission Source Registration Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/san-antonio-emission-source-registration-requirements",
    "url": "/news/san-antonio-emission-source-registration-requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The Shifting Sands of GHG Regulation",
    "apiurl": "/restapi/customnewscontentlvl2/news/The-Shifting-Sands-of-GHG-Regulation",
    "url": "/news/The-Shifting-Sands-of-GHG-Regulation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Receives  Accreditation to  Perform California AB 32 GHG Verification",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Receives-Accreditation-to-Perform-California-AB-32-GHG-Verification",
    "url": "/news/Trinity-Receives-Accreditation-to-Perform-California-AB-32-GHG-Verification",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Approves State of Texas' Plan to Reduce Ozone-Creating Emissions for Greater Houston Area-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Approves-State-of-Texas'-Plan-to-Reduce-Ozone-Creating-Emissions-for-Greater-Houston-Area-Texas",
    "url": "/news/EPA-Approves-State-of-Texas'-Plan-to-Reduce-Ozone-Creating-Emissions-for-Greater-Houston-Area-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Maricopa County Air Quality Department's Proposed Minor New Source Review Air Dispersion Modeling Guideline",
    "apiurl": "/restapi/customnewscontentlvl2/news/Maricopa-County-Air-Quality-Department's-Proposed-Minor-New-Source-Review-Air-Dispersion-Modeling-Guideline",
    "url": "/news/Maricopa-County-Air-Quality-Department's-Proposed-Minor-New-Source-Review-Air-Dispersion-Modeling-Guideline",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DEP Announces Tool for Electronic Submittal of Permit Applications",
    "apiurl": "/restapi/customnewscontentlvl2/news/dep-announces-tool-for-electronic-submittal-of-permit-applications",
    "url": "/news/dep-announces-tool-for-electronic-submittal-of-permit-applications",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DEP Announces Tool for Electronic Submittal of Permit Applications",
    "apiurl": "/restapi/customnewscontentlvl2/news/dep-announces-tool-for-electronic-submittal-of-permit-applications",
    "url": "/states/dep-announces-tool-for-electronic-submittal-of-permit-applications",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NC Recommends Postponement of SO2 Designations for Wilmington Area",
    "apiurl": "/restapi/customnewscontentlvl2/news/NC-Recommends-Postponement-of-SO2-Designations-for-Wilmington-Area",
    "url": "/news/NC-Recommends-Postponement-of-SO2-Designations-for-Wilmington-Area",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Kentucky Office Staff Speaking at AWMA Guideline on Air Quality Models Conference",
    "apiurl": "/restapi/customnewscontentlvl2/news/Kentucky-O",
    "url": "/news/Kentucky-O",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Regional Offices Restructure-Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Regional-Offices-Restructure-Missouri",
    "url": "/news/EPA-Regional-Offices-Restructure-Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Short Term Backup Unit Permit Exemption-Indiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Short-Term-Backup-Unit-Permit-Exemption-Indiana",
    "url": "/news/Proposed-Short-Term-Backup-Unit-Permit-Exemption-Indiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Coast Air Quality Management District – Proposed Amended Rule 1420",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Coast-Air-Quality-Management-District-Proposed-Amended-Rule-1420",
    "url": "/news/South-Coast-Air-Quality-Management-District-Proposed-Amended-Rule-1420",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Redesignation of Georgia (Chattanooga Area) Nonattainment Area",
    "apiurl": "/restapi/customnewscontentlvl2/news/Redesignat",
    "url": "/news/Redesignat",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SafeBridge Adds Hazard Communication and Chemical Regulatory Services",
    "apiurl": "/restapi/customnewscontentlvl2/news/SafeBridge-Adds-Hazard-Communication-and-Chemical-Regulatory-Services",
    "url": "/news/SafeBridge-Adds-Hazard-Communication-and-Chemical-Regulatory-Services",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "What method is your facility utilizing for compliance with the Industrial Cleaning Solvent rule?",
    "apiurl": "/restapi/customnewscontentlvl2/news/what-method-is-your-facility-utilizing-for-compliance-with-the-industrial-cleaning-solvent-rule",
    "url": "/news/what-method-is-your-facility-utilizing-for-compliance-with-the-industrial-cleaning-solvent-rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2013 Reporting Reminders-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/2013-Reporting-Reminders-Iowa",
    "url": "/news/2013-Reporting-Reminders-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update – Deadline Clarification for the Illinois General NPDES Permit for Industrial Activities (ILR00)!-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-Deadline-Clarification-for-the-Illinois-General-NPDES-Permit-for-Industrial-Activities-(ILR00)!-Illinois",
    "url": "/news/Update-Deadline-Clarification-for-the-Illinois-General-NPDES-Permit-for-Industrial-Activities-(ILR00)!-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Possible Changes to Title 129 Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/Possible-Changes-to-Title-129-Rules",
    "url": "/news/Possible-Changes-to-Title-129-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Virginia Air Pollution Control Board Rejects Petition Reducing CO2 in the Commonwealth-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Virginia-Air-Pollution-Control-Board-Rejects-Petition-Reducing-CO2-in-the-Commonwealth-Virginia",
    "url": "/news/Virginia-Air-Pollution-Control-Board-Rejects-Petition-Reducing-CO2-in-the-Commonwealth-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revisions to Utah's Hazardous Waste Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revisions-to-Utah's-Hazardous-Waste-Rules",
    "url": "/news/Revisions-to-Utah's-Hazardous-Waste-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Extends Comment Deadline for Proposed Cement Plant Rules-Washington",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Extends-Comment-Deadline-for-Proposed-Cement-Plant-Rules-Washington",
    "url": "/news/EPA-Extends-Comment-Deadline-for-Proposed-Cement-Plant-Rules-Washington",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MECT and HECT Annual Reporting Deadline-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/MECT-and-HECT-Annual-Reporting-Deadline-Texas",
    "url": "/news/MECT-and-HECT-Annual-Reporting-Deadline-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Revisions to MO SIP – Open Burning",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Revisions-to-MO-SIP-Open-Burning",
    "url": "/news/Proposed-Revisions-to-MO-SIP-Open-Burning",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NMED Releases GCP-O&G-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/NMED-Releases-GCP-O-G-New-Mexico",
    "url": "/news/NMED-Releases-GCP-O-G-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Boiler MACT-Oklahoma",
    "apiurl": "/restapi/customnewscontentlvl2/news/Boiler-MACT-Oklahoma",
    "url": "/news/Boiler-MACT-Oklahoma",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Guidance Documents Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Guidan",
    "url": "/news/New-Guidan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New NO2 Air Standards  Prove Technically Challenging",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-NO2-Air-Standards-Prove-Technically-Challenging",
    "url": "/news/New-NO2-Air-Standards-Prove-Technically-Challenging",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reminder:  New Permitting and Modeling Changes Starting in 2013",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reminder-New-Permitting-and-Modeling-Changes-Starting-in-2013",
    "url": "/news/Reminder-New-Permitting-and-Modeling-Changes-Starting-in-2013",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "What is a BWON Waste",
    "apiurl": "/restapi/customnewscontentlvl2/news/what-is-a-bwon-waste",
    "url": "/news/what-is-a-bwon-waste",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "What is a BWON Waste",
    "apiurl": "/restapi/customnewscontentlvl2/news/what-is-a-bwon-waste",
    "url": "/news/federal/what-is-a-bwon-waste",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE Releases AERMOD 7.10 and AERMET 7.6 to Include Latest U.S. EPA AERMOD Executable 15181",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-Releases-AERMOD-7-10-and-AERMET-7-6-to-Include-Latest-U-S-EPA-AERMOD-Executable-15181-",
    "url": "/news/BREEZE-Releases-AERMOD-7-10-and-AERMET-7-6-to-Include-Latest-U-S-EPA-AERMOD-Executable-15181-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2018 Report Card on Ambient Air Quality and Changes to Wyoming's Ambient Monitoring Network-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/2018-Report-Card-on-Ambient-Air-Quality-and-Changes-to-Wyoming's-Ambient-Monitoring-Network-Wyoming",
    "url": "/news/2018-Report-Card-on-Ambient-Air-Quality-and-Changes-to-Wyoming's-Ambient-Monitoring-Network-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ISO 50001, Energy Management System: The Other Boiler MACT Option",
    "apiurl": "/restapi/customnewscontentlvl2/news/ISO-50001-Energy-Management-System-The-Other-Boiler-MACT-Option",
    "url": "/news/ISO-50001-Energy-Management-System-The-Other-Boiler-MACT-Option",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDE Finalizes Changes to Distributed Generation Regulations-Maryland",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDE-Finalizes-Changes-to-Distributed-Generation-Regulations-Maryland",
    "url": "/news/MDE-Finalizes-Changes-to-Distributed-Generation-Regulations-Maryland",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Expected Ozone Reclassification for DFW/HGB Areas to Serious: More Stringent NNSR and Title V Major Source Thresholds-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Expected-Ozone-Reclassification-for-DFW-HGB-Areas-to-Serious-More-Stringent-NNSR-and-Title-V-Major-Source-Thresholds-Texas",
    "url": "/news/Expected-Ozone-Reclassification-for-DFW-HGB-Areas-to-Serious-More-Stringent-NNSR-and-Title-V-Major-Source-Thresholds-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "States Act in Absence of Boiler MACT",
    "apiurl": "/restapi/customnewscontentlvl2/news/States-Act-in-Absence-of-Boiler-MACT-",
    "url": "/news/States-Act-in-Absence-of-Boiler-MACT-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Environmental Groups Petition EPA to Re-Open 34 NESHAP Categories",
    "apiurl": "/restapi/customnewscontentlvl2/news/Environmen",
    "url": "/news/Environmen",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CARB Adopts Regulation Requiring Reporting of Heavy-Duty Vehicle Operations",
    "apiurl": "/restapi/customnewscontentlvl2/news/carb-adopts-regulation-requiring-reporting-of-heavy-duty-vehicle-operations",
    "url": "/news/carb-adopts-regulation-requiring-reporting-of-heavy-duty-vehicle-operations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CARB Adopts Regulation Requiring Reporting of Heavy-Duty Vehicle Operations",
    "apiurl": "/restapi/customnewscontentlvl2/news/carb-adopts-regulation-requiring-reporting-of-heavy-duty-vehicle-operations",
    "url": "/states/california/carb-adopts-regulation-requiring-reporting-of-heavy-duty-vehicle-operations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Draft Air Quality Guidance for Existing and New Oilfield Waste Disposal",
    "apiurl": "/restapi/customnewscontentlvl2/news/draft-air-quality-guidance-for-existing-and-new-oilfield-waste-disposal",
    "url": "/news/draft-air-quality-guidance-for-existing-and-new-oilfield-waste-disposal",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Opens Office in Cheyenne, Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Opens-Office-in-Cheyenne-Wyoming",
    "url": "/news/Trinity-Consultants-Opens-Office-in-Cheyenne-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Effects of Proposed Ozone Standards on Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Effects-of-Proposed-Ozone-Standards-on-Colorado",
    "url": "/news/Effects-of-Proposed-Ozone-Standards-on-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "RR9 Requires Extensive Air and Noise Analysis",
    "apiurl": "/restapi/customnewscontentlvl2/news/RR9-Requires-Extensive-Air-and-Noise-Analysis",
    "url": "/news/RR9-Requires-Extensive-Air-and-Noise-Analysis",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEE Issues New Inspection and Return to Compliance Guidance",
    "apiurl": "/restapi/customnewscontentlvl2/news/ndee-issues-new-inspection-and-return-to-compliance-guidance",
    "url": "/news/ndee-issues-new-inspection-and-return-to-compliance-guidance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEE Issues New Inspection and Return to Compliance Guidance",
    "apiurl": "/restapi/customnewscontentlvl2/news/ndee-issues-new-inspection-and-return-to-compliance-guidance",
    "url": "/news/state/nebraska/ndee-issues-new-inspection-and-return-to-compliance-guidance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Title V and Greenhouse Gases in SJVAPCD",
    "apiurl": "/restapi/customnewscontentlvl2/news/Title-V-and-Greenhouse-Gases-in-SJVAPCD",
    "url": "/news/Title-V-and-Greenhouse-Gases-in-SJVAPCD",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Rule Amendment to Increase Title V Fees on Public Notice-Minnesota",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Rule-Amendment-to-Increase-Title-V-Fees-on-Public-Notice-Minnesota",
    "url": "/news/Proposed-Rule-Amendment-to-Increase-Title-V-Fees-on-Public-Notice-Minnesota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "California Continues with Low Carbon Fuel Standard Implementation Despite COVID-19 Delays",
    "apiurl": "/restapi/customnewscontentlvl2/news/california-continues-with-low-carbon-fuel-standard-implementation-despite-covid-19-delays",
    "url": "/news/california-continues-with-low-carbon-fuel-standard-implementation-despite-covid-19-delays",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Streamlining Enterprise Emissions Reporting at a Large Oil & Gas Company",
    "apiurl": "/restapi/customnewscontentlvl2/news/Streamlining-Enterprise-Emissions-Reporting-at-a-Large-Oil-Gas-Company",
    "url": "/news/Streamlining-Enterprise-Emissions-Reporting-at-a-Large-Oil-Gas-Company",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ozone Reclassification for DFW/HGB Areas Published-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ozone-Reclassification-for-DFW-HGB-Areas-Published-Texas",
    "url": "/news/Ozone-Reclassification-for-DFW-HGB-Areas-Published-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Revisions to the Proposed Regulation 7 Changes -Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Revisions-to-the-Proposed-Regulation-7-Changes--Colorado",
    "url": "/news/New-Revisions-to-the-Proposed-Regulation-7-Changes--Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Tank Experts Rob Ferry and Randy Kissell Join Trinity",
    "apiurl": "/restapi/customnewscontentlvl2/news/Tank-Experts-Rob-Ferry-and-Randy-Kissell-Join-Trinity",
    "url": "/news/Tank-Experts-Rob-Ferry-and-Randy-Kissell-Join-Trinity",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Virginia to Review \"Grandfather Facilities\"",
    "apiurl": "/restapi/customnewscontentlvl2/news/Virginia-to-Review-Grandfather-Facilities-",
    "url": "/news/Virginia-to-Review-Grandfather-Facilities-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Utah Department of Water Quality Released the 2016 Impaired Waters Report",
    "apiurl": "/restapi/customnewscontentlvl2/news/Utah-Department-of-Water-Quality-Released-the-2016-Impaired-Waters-Report",
    "url": "/news/Utah-Department-of-Water-Quality-Released-the-2016-Impaired-Waters-Report",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Jersey to Rejoin RGGI-New Jersey",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Jersey-to-Rejoin-RGGI-New-Jersey",
    "url": "/news/New-Jersey-to-Rejoin-RGGI-New-Jersey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Biomass Energy Generator Permit for a Pilot Test Facility",
    "apiurl": "/restapi/customnewscontentlvl2/news/Biomass-Energy-Generator-Permit-for-a-Pilot-Test-Facility",
    "url": "/news/Biomass-Energy-Generator-Permit-for-a-Pilot-Test-Facility",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oregon Greenhouse Gas Reporting and Clean Fuels Program Update-Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oregon-Greenhouse-Gas-Reporting-and-Clean-Fuels-Program-Update-Oregon",
    "url": "/news/Oregon-Greenhouse-Gas-Reporting-and-Clean-Fuels-Program-Update-Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GCP-O&G Transition Notification Deadline Fast Approaching-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/GCP-O-G-Transition-Notification-Deadline-Fast-Approaching-New-Mexico",
    "url": "/news/GCP-O-G-Transition-Notification-Deadline-Fast-Approaching-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Requirements Finalized in RICE NESHAP",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Requirements-Finalized-in-RICE-NESHAP",
    "url": "/news/New-Requirements-Finalized-in-RICE-NESHAP",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Position on Aggregation after Summit Court Ruling",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Position-on-Aggregation-after-Summit-Court-Ruling",
    "url": "/news/EPA-Position-on-Aggregation-after-Summit-Court-Ruling",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE Incident Analyst 1.4 Improves Chemical Database Edit Capabilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-Incident-Analyst-1-4-Improves-Chemical-Database-Edit-Capabilities",
    "url": "/news/BREEZE-Incident-Analyst-1-4-Improves-Chemical-Database-Edit-Capabilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Amendments to Env-A 3300 Municipal Waste Combustion Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-Amendments-to-Env-A-3300-Municipal-Waste-Combustion-Rule",
    "url": "/news/Final-Amendments-to-Env-A-3300-Municipal-Waste-Combustion-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Emissions Inventory Workshop",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Emissions-Inventory-Workshop",
    "url": "/news/Air-Emissions-Inventory-Workshop",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Web Portal for Illinois Environmental Permitting Process",
    "apiurl": "/restapi/customnewscontentlvl2/news/Web-Portal-for-Illinois-Environmental-Permitting-Process",
    "url": "/news/Web-Portal-for-Illinois-Environmental-Permitting-Process",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NMED Releases New GHG Guidance",
    "apiurl": "/restapi/customnewscontentlvl2/news/NMED-Releases-New-GHG-Guidance",
    "url": "/news/NMED-Releases-New-GHG-Guidance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "December 9, 2013 PSM RFI Highlights",
    "apiurl": "/restapi/customnewscontentlvl2/news/December-9-2013-PSM-RFI-Highlights",
    "url": "/news/December-9-2013-PSM-RFI-Highlights",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2016 Top 10 OSHA Violations",
    "apiurl": "/restapi/customnewscontentlvl2/news/2016-Top-10-OSHA-Violations",
    "url": "/news/2016-Top-10-OSHA-Violations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Rule Revisions for Financial Assurance Proceed to the Environmental Quality Council-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Rule-Revisions-for-Financial-Assurance-Proceed-to-the-Environmental-Quality-Council-Wyoming",
    "url": "/news/Proposed-Rule-Revisions-for-Financial-Assurance-Proceed-to-the-Environmental-Quality-Council-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Disapproves TCEQ's Qualified Facility Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Disapproves-TCEQ's-Qualified-Facility-Program",
    "url": "/news/EPA-Disapproves-TCEQ's-Qualified-Facility-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Proposed Rule in Maryland - NOx RACT-Maryland",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Proposed-Rule-in-Maryland---NOx-RACT-Maryland",
    "url": "/news/New-Proposed-Rule-in-Maryland---NOx-RACT-Maryland",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Quality Advisory Council Meeting on January 16",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Advisory-Council-Meeting-on-January-16",
    "url": "/news/Air-Quality-Advisory-Council-Meeting-on-January-16",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Bureau of Land Management’s Proposed Waste Prevention Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Bureau-of-Land-Management-s-Proposed-Waste-Prevention-Rule",
    "url": "/news/Bureau-of-Land-Management-s-Proposed-Waste-Prevention-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TDEC Air Pollution Control Board Public Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/TDEC-Air-Pollution-Control-Board-Public-Meeting",
    "url": "/news/TDEC-Air-Pollution-Control-Board-Public-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Steps in the Rulemaking Process for the MCAQD",
    "apiurl": "/restapi/customnewscontentlvl2/news/Steps-in-the-Rulemaking-Process-for-the-MCAQD-",
    "url": "/news/Steps-in-the-Rulemaking-Process-for-the-MCAQD-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Virginia DEQ Revised PSD Regulations Take Effect Today!",
    "apiurl": "/restapi/customnewscontentlvl2/news/Virginia-DEQ-Revised-PSD-Regulations-Take-Effect-Today!",
    "url": "/news/Virginia-DEQ-Revised-PSD-Regulations-Take-Effect-Today!",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD to Restrict Use of Materials Above VOC Limits",
    "apiurl": "/restapi/customnewscontentlvl2/news/scaqmd-to-restrict-use-of-materials-above-voc-limits",
    "url": "/news/scaqmd-to-restrict-use-of-materials-above-voc-limits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LADCO Proposes SO2 Modeling Protocol",
    "apiurl": "/restapi/customnewscontentlvl2/news/LADCO-Proposes-SO2-Modeling-Protocol",
    "url": "/news/LADCO-Proposes-SO2-Modeling-Protocol",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE Releases AERMET 7.5.1 to Include Latest U.S. EPA AERMINUTE Executable 14237",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-Releases-AERMET-7-5-1-to-Include-Latest-U-S-EPA-AERMINUTE-Executable-14237",
    "url": "/news/BREEZE-Releases-AERMET-7-5-1-to-Include-Latest-U-S-EPA-AERMINUTE-Executable-14237",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DEQ Proposes Temporary Revisions to Address Supreme Court GHG Ruling",
    "apiurl": "/restapi/customnewscontentlvl2/news/DEQ-Proposes-Temporary-Revisions-to-Address-Supreme-Court-GHG-Ruling",
    "url": "/news/DEQ-Proposes-Temporary-Revisions-to-Address-Supreme-Court-GHG-Ruling",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Quality Bureau Title V Workshop",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Bureau-Title-V-Workshop",
    "url": "/news/Air-Quality-Bureau-Title-V-Workshop",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PSD Permitting Strategy for GHG Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/PSD-Permit",
    "url": "/news/PSD-Permit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Arizona NSR Program Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Arizona-NSR-Program-Updates",
    "url": "/news/Arizona-NSR-Program-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Boiler MACT Energy Assessment and How It Affects You",
    "apiurl": "/restapi/customnewscontentlvl2/news/Boiler-MACT-Energy-Assessment-and-How-It-Affects-You",
    "url": "/news/Boiler-MACT-Energy-Assessment-and-How-It-Affects-You",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE AERMOD 7.12.1 Enables High Speed Modeling with the 16216r Executable",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-AERMOD-7-12-1-Enables-High-Speed-Modeling-with-the-16216r-Executable",
    "url": "/news/BREEZE-AERMOD-7-12-1-Enables-High-Speed-Modeling-with-the-16216r-Executable",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reissuance of the General Permit for Discharges of Storm Water from Construction Activities Five (5) Acres or Greater",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reissuance-of-the-General-Permit-for-Discharges-of-Storm-Water-from-Construction-Activities-Five-(5)-Acres-or-Greater",
    "url": "/news/Reissuance-of-the-General-Permit-for-Discharges-of-Storm-Water-from-Construction-Activities-Five-(5)-Acres-or-Greater",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDNR Field Office & Water Supply Sections Office Relocation",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDNR-Field-Office-Water-Supply-Sections-Office-Relocation",
    "url": "/news/IDNR-Field-Office-Water-Supply-Sections-Office-Relocation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Clark County DAQ Proposes Rule Changes",
    "apiurl": "/restapi/customnewscontentlvl2/news/clark-county-daq-proposes-rule-changes",
    "url": "/news/clark-county-daq-proposes-rule-changes",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Increasing Focus on Air Emissions from Hazardous Waste Generators",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-increasing-focus-on-air-emissions-from-hazardous-waste-generators",
    "url": "/news/epa-increasing-focus-on-air-emissions-from-hazardous-waste-generators",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Increasing Focus on Air Emissions from Hazardous Waste Generators",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-increasing-focus-on-air-emissions-from-hazardous-waste-generators",
    "url": "/federal/epa-increasing-focus-on-air-emissions-from-hazardous-waste-generators",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated LDAR Annual Report Form and Guidance Document-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updated-LDAR-Annual-Report-Form-and-Guidance-Document-Colorado",
    "url": "/news/Updated-LDAR-Annual-Report-Form-and-Guidance-Document-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Massachusetts Joins Other U.S. Climate Alliance States to Roll-Out State Specific GHG Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/massachusetts-joins-other-u-s-climate-alliance-states-to-roll-out-state-specific-ghg-regulations",
    "url": "/news/massachusetts-joins-other-u-s-climate-alliance-states-to-roll-out-state-specific-ghg-regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Massachusetts Joins Other U.S. Climate Alliance States to Roll-Out State Specific GHG Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/massachusetts-joins-other-u-s-climate-alliance-states-to-roll-out-state-specific-ghg-regulations",
    "url": "/states/massachusetts/massachusetts-joins-other-u-s--climate-alliance-states-to-roll-out-state-specific-ghg-regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Your Facility’s General Permit to Limit Potential to Emit (GPLPE) is Expiring November 8th and Action is Required",
    "apiurl": "/restapi/customnewscontentlvl2/news/your-facility-s-general-permit-to-limit-potential-to-emit-gplpe-is-expiring-november-8th-and-action-is-required",
    "url": "/news/your-facility-s-general-permit-to-limit-potential-to-emit-gplpe-is-expiring-november-8th-and-action-is-required",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Your Facility’s General Permit to Limit Potential to Emit (GPLPE) is Expiring November 8th and Action is Required",
    "apiurl": "/restapi/customnewscontentlvl2/news/your-facility-s-general-permit-to-limit-potential-to-emit-gplpe-is-expiring-november-8th-and-action-is-required",
    "url": "/states/connecticut/your-connecticut-facility-s-general-permit-to-limit-potential-to-emit-gplpe-is-expiring-november-8th-and-action-is-required",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SDAPCD Proposed Amendments to Rule 11 and Rule 66.1",
    "apiurl": "/restapi/customnewscontentlvl2/news/SDAPCD-Proposed-Amendments-to-Rule-11-and-Rule-66-1",
    "url": "/news/SDAPCD-Proposed-Amendments-to-Rule-11-and-Rule-66-1",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated Version of AERMOD Released in December",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updated-Ve",
    "url": "/news/Updated-Ve",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Carolina Stormwater Permit",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Carolina-Stormwater-Permit",
    "url": "/news/South-Carolina-Stormwater-Permit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Individual Air Permit Reissuance Applications May Be Submitted Through e-Services-Minnesota",
    "apiurl": "/restapi/customnewscontentlvl2/news/Individual-Air-Permit-Reissuance-Applications-May-Be-Submitted-Through-e-Services-Minnesota",
    "url": "/news/Individual-Air-Permit-Reissuance-Applications-May-Be-Submitted-Through-e-Services-Minnesota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Newly Proposed NESHAP for Brick and Structural Clay Products Manufacturing and Clay Ceramics Manufacturing",
    "apiurl": "/restapi/customnewscontentlvl2/news/Newly-Proposed-NESHAP-for-Brick-and-Structural-Clay-Products-Manufacturing-and-Clay-Ceramics-Manufacturing",
    "url": "/news/Newly-Proposed-NESHAP-for-Brick-and-Structural-Clay-Products-Manufacturing-and-Clay-Ceramics-Manufacturing",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Looking Ahead:  Internal Combustion Engine Fuel Usage in 2018-Minnesota",
    "apiurl": "/restapi/customnewscontentlvl2/news/Looking-Ahead-Internal-Combustion-Engine-Fuel-Usage-in-2018-Minnesota",
    "url": "/news/Looking-Ahead-Internal-Combustion-Engine-Fuel-Usage-in-2018-Minnesota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "UDAQ Aircraft Studies for PM2.5 and Ozone",
    "apiurl": "/restapi/customnewscontentlvl2/news/UDAQ-Aircraft-Studies-for-PM2-5-and-Ozone",
    "url": "/news/UDAQ-Aircraft-Studies-for-PM2-5-and-Ozone",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Three Ways to Prepare for 2021 Reporting Season",
    "apiurl": "/restapi/customnewscontentlvl2/news/three-ways-to-prepare-for-2021-reporting-season",
    "url": "/news/three-ways-to-prepare-for-2021-reporting-season",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Three Ways to Prepare for 2021 Reporting Season",
    "apiurl": "/restapi/customnewscontentlvl2/news/three-ways-to-prepare-for-2021-reporting-season",
    "url": "/news/federal/three-ways-to-prepare-for-2021-reporting-season",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Dakota Reporting Reminders!",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Dakota-Reporting-Reminders!",
    "url": "/news/South-Dakota-Reporting-Reminders!",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Eight-Hour Ozone Standard for Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Eight-Hour-Ozone-Standard-for-Texas",
    "url": "/news/Eight-Hour-Ozone-Standard-for-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MassDEP 2017 Source Registrations Now Due-Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/MassDEP-2017-Source-Registrations-Now-Due-Massachusetts",
    "url": "/news/MassDEP-2017-Source-Registrations-Now-Due-Massachusetts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Determines Attainment of 1997 8-hour Ozone Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Determines-Attainment-of-1997-8-hour-Ozone-Standard",
    "url": "/news/EPA-Determines-Attainment-of-1997-8-hour-Ozone-Standard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Position Change at the Louisville Air Pollution District",
    "apiurl": "/restapi/customnewscontentlvl2/news/Position-C",
    "url": "/news/Position-C",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New U.S. EPA Guidance Allows Use of Prognostic Meteorological Data Processed Using WRF & MM5 Meteorological Models",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-U-S-EPA-Guidance-Allows-Use-of-Prognostic-Meteorological-Data-Processed-Using-WRF-MM5-Meteorological-Models-",
    "url": "/news/New-U-S-EPA-Guidance-Allows-Use-of-Prognostic-Meteorological-Data-Processed-Using-WRF-MM5-Meteorological-Models-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2014 Title V Emissions Fee Due July 1, 2015",
    "apiurl": "/restapi/customnewscontentlvl2/news/2014-Title-V-Emissions-Fee-Due-July-1-2015",
    "url": "/news/2014-Title-V-Emissions-Fee-Due-July-1-2015",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE Software Introduces Redesigned AERMOD Start Page",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-Software-Introduces-Redesigned-AERMOD-Start-Page-",
    "url": "/news/BREEZE-Software-Introduces-Redesigned-AERMOD-Start-Page-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Modeling Emissions from Offshore Drilling",
    "apiurl": "/restapi/customnewscontentlvl2/news/-Modeling-Emissions-from-Offshore-Drilling",
    "url": "/news/-Modeling-Emissions-from-Offshore-Drilling",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CMAS Rule Amendments Finalized",
    "apiurl": "/restapi/customnewscontentlvl2/news/CMAS-Rule-Amendments-Finalized",
    "url": "/news/CMAS-Rule-Amendments-Finalized",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Delaware Department of Natural Resources and Environmental Control (DNREC) Amends Regulations on Volatile Organic Compound Emissions from Printing Operations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Delaware-Department-of-Natural-Resources-and-Environmental-Control-(DNREC)-Amends-Regulations-on-Volatile-Organic-Compound-Emissions-from-Printing-Operations",
    "url": "/news/Delaware-Department-of-Natural-Resources-and-Environmental-Control-(DNREC)-Amends-Regulations-on-Volatile-Organic-Compound-Emissions-from-Printing-Operations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revisions to Michigan's Hazardous Waste Regulations-Michigan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revisions-to-Michigan's-Hazardous-Waste-Regulations-Michigan",
    "url": "/news/Revisions-to-Michigan's-Hazardous-Waste-Regulations-Michigan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Delists VOC Compounds",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Delists-VOC-Compounds",
    "url": "/news/EPA-Delists-VOC-Compounds",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Carolina Department of Health and Environmental Control Restructure",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Carolina-Department-of-Health-and-Environmental-Control-Restructure",
    "url": "/news/South-Carolina-Department-of-Health-and-Environmental-Control-Restructure",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CARB Proposes Draft Updates to SB 350 2030 GHG Planning Target Ranges",
    "apiurl": "/restapi/customnewscontentlvl2/news/carb-proposes-draft-updates-to-sb-350-2030-ghg-planning-target-ranges",
    "url": "/news/carb-proposes-draft-updates-to-sb-350-2030-ghg-planning-target-ranges",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CARB Proposes Draft Updates to SB 350 2030 GHG Planning Target Ranges",
    "apiurl": "/restapi/customnewscontentlvl2/news/carb-proposes-draft-updates-to-sb-350-2030-ghg-planning-target-ranges",
    "url": "/news/states/california/carb-proposes-draft-updates-to-sb-350-2030-ghg-planning-target-ranges",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Meteorological Data Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/Meteorological-Data-Update",
    "url": "/news/Meteorological-Data-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDEP Proposes Changes to Chapter 101: Visible Emissions Regulations-Maine",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDEP-Proposes-Changes-to-Chapter-101-Visible-Emissions-Regulations-Maine",
    "url": "/news/MDEP-Proposes-Changes-to-Chapter-101-Visible-Emissions-Regulations-Maine",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Amended Subchapter 9 Effective July 1",
    "apiurl": "/restapi/customnewscontentlvl2/news/Amended-Subchapter-9-Effective-July-1",
    "url": "/news/Amended-Subchapter-9-Effective-July-1",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DDOE Proposes Amendments to the Volatile Organic Compounds Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/DDOE-Proposes-Amendments-to-the-Volatile-Organic-Compounds-Regulations",
    "url": "/news/DDOE-Proposes-Amendments-to-the-Volatile-Organic-Compounds-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NYSDEC Requests EPA Impose Emission Limits on Sources Affecting Air Quality in New York, Including Sources in Virginia-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/NYSDEC-Requests-EPA-Impose-Emission-Limits-on-Sources-Affecting-Air-Quality-in-New-York-Including-Sources-in-Virginia-Virginia",
    "url": "/news/NYSDEC-Requests-EPA-Impose-Emission-Limits-on-Sources-Affecting-Air-Quality-in-New-York-Including-Sources-in-Virginia-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Maine DEP Draft Air Monitoring Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/maine-dep-draft-air-monitoring-plan",
    "url": "/news/maine-dep-draft-air-monitoring-plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Maine DEP Draft Air Monitoring Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/maine-dep-draft-air-monitoring-plan",
    "url": "/www.trinityconsultants.com/news/maine-dep-draft-air-monitoring-plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NOx RACT Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/NOx-RACT-Update",
    "url": "/news/NOx-RACT-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Several Changes to Online Interaction with the Wyoming DEQ",
    "apiurl": "/restapi/customnewscontentlvl2/news/several-changes-to-online-interaction-with-the-wyoming-deq",
    "url": "/news/several-changes-to-online-interaction-with-the-wyoming-deq",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Several Changes to Online Interaction with the Wyoming DEQ",
    "apiurl": "/restapi/customnewscontentlvl2/news/several-changes-to-online-interaction-with-the-wyoming-deq",
    "url": "/news/state/wyoming/several-changes-to-online-interaction-with-the-wyoming-deq",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes Approval of SJVAPCD Rule 2410- Prevention of Significant Deterioration",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-Approval-of-SJVAPCD-Rule-2410--Prevention-of-Significant-Deterioration",
    "url": "/news/EPA-Proposes-Approval-of-SJVAPCD-Rule-2410--Prevention-of-Significant-Deterioration",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oil and Gas Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oil-and-Gas-Update",
    "url": "/news/Oil-and-Gas-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DEQ Revises EIR Procedures Manual-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/DEQ-Revises-EIR-Procedures-Manual-Virginia",
    "url": "/news/DEQ-Revises-EIR-Procedures-Manual-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BWON in the Post-Consent Decree Era",
    "apiurl": "/restapi/customnewscontentlvl2/news/bwon-in-the-post-consent-decree-era",
    "url": "/news/bwon-in-the-post-consent-decree-era",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Pennsylvania's RACT Program to be Amended",
    "apiurl": "/restapi/customnewscontentlvl2/news/Pennsylvania's-RACT-Program-to-be-Amended",
    "url": "/news/Pennsylvania's-RACT-Program-to-be-Amended",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDAQMD Updates to Rule 461, Rule 462, and Rule 463-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDAQMD-Updates-to-Rule-461-Rule-462-and-Rule-463-California",
    "url": "/news/MDAQMD-Updates-to-Rule-461-Rule-462-and-Rule-463-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments to Ontario’s Emissions Performance Standards Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/proposed-amendments-to-ontario-s-emissions-performance-standards-program",
    "url": "/news/proposed-amendments-to-ontario-s-emissions-performance-standards-program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposed GHG Inventory Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposed-GHG-Inventory-Rule",
    "url": "/news/EPA-Proposed-GHG-Inventory-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "COVID-19: EHS Regulatory Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/covid-19-ehs-regulatory-updates",
    "url": "/news/covid-19-ehs-regulatory-updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "COVID-19: EHS Regulatory Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/covid-19-ehs-regulatory-updates",
    "url": "/federal/covid-19-ehs-regulatory-updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Modeling Workshop in Atlanta",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Modeli",
    "url": "/news/EPA-Modeli",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Powerful Planning and Response Tools for Hazardous Releases, Fires, and Explosions",
    "apiurl": "/restapi/customnewscontentlvl2/news/Powerful-Planning-and-Response-Tools-for-Hazardous-Releases-Fires-and-Explosions",
    "url": "/news/Powerful-Planning-and-Response-Tools-for-Hazardous-Releases-Fires-and-Explosions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Washington Changes Annual Reporting System for 2018-Washington",
    "apiurl": "/restapi/customnewscontentlvl2/news/Washington-Changes-Annual-Reporting-System-for-2018-Washington",
    "url": "/news/Washington-Changes-Annual-Reporting-System-for-2018-Washington",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TRI Reporting Updates and Program News",
    "apiurl": "/restapi/customnewscontentlvl2/news/tri-reporting-updates-and-program-news",
    "url": "/news/tri-reporting-updates-and-program-news",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TRI Reporting Updates and Program News",
    "apiurl": "/restapi/customnewscontentlvl2/news/tri-reporting-updates-and-program-news",
    "url": "/news/federal/tri-reporting-updates-and-program-news",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Accepting Comments on Updates to Air Quality Construction Permits Application Forms until Dec. 17",
    "apiurl": "/restapi/customnewscontentlvl2/news/Accepting-Comments-on-Updates-to-Air-Quality-Construction-Permits-Application-Forms-until-Dec-17",
    "url": "/news/Accepting-Comments-on-Updates-to-Air-Quality-Construction-Permits-Application-Forms-until-Dec-17",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ARB’s Consumer and Commercial Products Survey Deadlines and Extensions",
    "apiurl": "/restapi/customnewscontentlvl2/news/ARB-s-Consumer-and-Commercial-Products-Survey-Deadlines-and-Extensions",
    "url": "/news/ARB-s-Consumer-and-Commercial-Products-Survey-Deadlines-and-Extensions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Court Vacature of CAIR",
    "apiurl": "/restapi/customnewscontentlvl2/news/Court-Vaca",
    "url": "/news/Court-Vaca",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Chemical Plant – Accidental Release Quantification-Tennessee",
    "apiurl": "/restapi/customnewscontentlvl2/news/Chemical-Plant-Accidental-Release-Quantification-Tennessee",
    "url": "/news/Chemical-Plant-Accidental-Release-Quantification-Tennessee",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ozone Nonattainment International and Exceptional Events Consideration Status Update-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ozone-Nonattainment-International-and-Exceptional-Events-Consideration-Status-Update-Colorado",
    "url": "/news/Ozone-Nonattainment-International-and-Exceptional-Events-Consideration-Status-Update-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CDPHE New Boiler APEN Form APCD-200 Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/CDPHE-New-Boiler-APEN-Form-APCD-200-Released",
    "url": "/news/CDPHE-New-Boiler-APEN-Form-APCD-200-Released",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2015 Construction Permit Dual LEAN Events",
    "apiurl": "/restapi/customnewscontentlvl2/news/2015-Construction-Permit-Dual-LEAN-Events",
    "url": "/news/2015-Construction-Permit-Dual-LEAN-Events",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes to Stay Effectiveness of CAIR for Minnesota",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-to-Stay-Effectiveness-of-CAIR-for-Minnesota",
    "url": "/news/EPA-Proposes-to-Stay-Effectiveness-of-CAIR-for-Minnesota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Maine DEP - May 2019 Proposed Rules-Maine",
    "apiurl": "/restapi/customnewscontentlvl2/news/Maine-DEP---May-2019-Proposed-Rules-Maine",
    "url": "/news/Maine-DEP---May-2019-Proposed-Rules-Maine",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The Utah Roadmap-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/The-Utah-Roadmap-Utah",
    "url": "/news/The-Utah-Roadmap-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Massachusetts Climate Bill Becomes Law",
    "apiurl": "/restapi/customnewscontentlvl2/news/massachusetts-climate-bill-becomes-law",
    "url": "/news/massachusetts-climate-bill-becomes-law",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Massachusetts Climate Bill Becomes Law",
    "apiurl": "/restapi/customnewscontentlvl2/news/massachusetts-climate-bill-becomes-law",
    "url": "/www.trinityconsultants.com/news/massachusetts-climate-bill-becomes-law",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Kansas Air Emissions Inventory - 2012 Calendar Year Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Kansas-Air-Emissions-Inventory---2012-Calendar-Year-Updates",
    "url": "/news/Kansas-Air-Emissions-Inventory---2012-Calendar-Year-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "US EPA Communities Initiative – Improved US EPA Visibility in Kenosha/Racine",
    "apiurl": "/restapi/customnewscontentlvl2/news/US-EPA-Communities-Initiative-Improved-US-EPA-Visibility-in-Kenosha-Racine",
    "url": "/news/US-EPA-Communities-Initiative-Improved-US-EPA-Visibility-in-Kenosha-Racine",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The Value of an EHS Gap Assessment to Prevent a Formal Audit",
    "apiurl": "/restapi/customnewscontentlvl2/news/The-Value-of-an-EHS-Gap-Assessment-to-Prevent-a-Formal-Audit",
    "url": "/news/The-Value-of-an-EHS-Gap-Assessment-to-Prevent-a-Formal-Audit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The Value of an EHS Gap Assessment to Prevent a Formal Audit",
    "apiurl": "/restapi/customnewscontentlvl2/news/The-Value-of-an-EHS-Gap-Assessment-to-Prevent-a-Formal-Audit",
    "url": "/ehs-management/the-value-of-an-ehs-gap-assessment-to-prevent-a-formal-audit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2021 Brings New Hazardous Notification Requirement",
    "apiurl": "/restapi/customnewscontentlvl2/news/2021-brings-new-hazardous-notification-requirement",
    "url": "/news/2021-brings-new-hazardous-notification-requirement",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2021 Brings New Hazardous Notification Requirement",
    "apiurl": "/restapi/customnewscontentlvl2/news/2021-brings-new-hazardous-notification-requirement",
    "url": "/news/federal/2021-brings-new-hazardous-notification-requirement",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Title V Deferred Sources - Electronic Reporting Required for Certified Emissions Statements for Calendar Year 2017-West Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Title-V-Deferred-Sources---Electronic-Reporting-Required-for-Certified-Emissions-Statements-for-Calendar-Year-2017-West-Virginia",
    "url": "/news/Title-V-Deferred-Sources---Electronic-Reporting-Required-for-Certified-Emissions-Statements-for-Calendar-Year-2017-West-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "WDNR's New Registration Construction Permit RCP-G02 and Registration Operating Permit ROP-G02-Wisconsin",
    "apiurl": "/restapi/customnewscontentlvl2/news/WDNR's-New-Registration-Construction-Permit-RCP-G02-and-Registration-Operating-Permit-ROP-G02-Wisconsin",
    "url": "/news/WDNR's-New-Registration-Construction-Permit-RCP-G02-and-Registration-Operating-Permit-ROP-G02-Wisconsin",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Information Collection Requests for Boilers, Waste Incinerators, and Electric Utilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/Informatio",
    "url": "/news/Informatio",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Maine DEP Proposes New Rule for GHG Inventory Reporting",
    "apiurl": "/restapi/customnewscontentlvl2/news/maine-dep-proposes-new-rule-for-ghg-inventory-reporting",
    "url": "/news/maine-dep-proposes-new-rule-for-ghg-inventory-reporting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SPCC Rule Delayed Again",
    "apiurl": "/restapi/customnewscontentlvl2/news/SPCC-Rule-Delayed-Again",
    "url": "/news/SPCC-Rule-Delayed-Again",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Electronic Filing Required for Stormwater General Permit Discharge Monitoring Reports (DMRs)-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Electronic-Filing-Required-for-Stormwater-General-Permit-Discharge-Monitoring-Reports-(DMRs)-Texas",
    "url": "/news/Electronic-Filing-Required-for-Stormwater-General-Permit-Discharge-Monitoring-Reports-(DMRs)-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Initiates Reconsideration of the Ozone NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Initia",
    "url": "/news/EPA-Initia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Key NJDEP Air Program Changes in 2019-New Jersey",
    "apiurl": "/restapi/customnewscontentlvl2/news/Key-NJDEP-Air-Program-Changes-in-2019-New-Jersey",
    "url": "/news/Key-NJDEP-Air-Program-Changes-in-2019-New-Jersey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Good News - July",
    "apiurl": "/restapi/customnewscontentlvl2/news/good-news-july",
    "url": "/news/good-news-july",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Good News - July",
    "apiurl": "/restapi/customnewscontentlvl2/news/good-news-july",
    "url": "/news/good-news---july",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "San Diego AB 2588 Hot Spots Report",
    "apiurl": "/restapi/customnewscontentlvl2/news/San-Diego-AB-2588-Hot-Spots-Report",
    "url": "/news/San-Diego-AB-2588-Hot-Spots-Report",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Friendly Reminder - Check Your Fuel-Oil Tickets for Sulfur Content-Maine",
    "apiurl": "/restapi/customnewscontentlvl2/news/Friendly-Reminder---Check-Your-Fuel-Oil-Tickets-for-Sulfur-Content-Maine",
    "url": "/news/Friendly-Reminder---Check-Your-Fuel-Oil-Tickets-for-Sulfur-Content-Maine",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Updates to NSR Permitting Tools-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/TCEQ-Updates-to-NSR-Permitting-Tools-Texas",
    "url": "/news/TCEQ-Updates-to-NSR-Permitting-Tools-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PM2.5 Nonattainment Areas Designations in Washington, Oregon, Idaho and Alaska-Washington",
    "apiurl": "/restapi/customnewscontentlvl2/news/PM2-5-Nonattainment-Areas-Designations-in-Washington-Oregon-Idaho-and-Alaska-Washington",
    "url": "/news/PM2-5-Nonattainment-Areas-Designations-in-Washington-Oregon-Idaho-and-Alaska-Washington",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MPCA Summer Open House-Minnesota",
    "apiurl": "/restapi/customnewscontentlvl2/news/MPCA-Summer-Open-House-Minnesota",
    "url": "/news/MPCA-Summer-Open-House-Minnesota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Area Source Boiler NESHAP Deadline Reminders: The Clock is Ticking!",
    "apiurl": "/restapi/customnewscontentlvl2/news/Area-Source-Boiler-NESHAP-Deadline-Reminders-The-Clock-is-Ticking!",
    "url": "/news/Area-Source-Boiler-NESHAP-Deadline-Reminders-The-Clock-is-Ticking!",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MPCA Modeling Guidance Update Summary",
    "apiurl": "/restapi/customnewscontentlvl2/news/MPCA-Modeling-Guidance-Update-Summary",
    "url": "/news/MPCA-Modeling-Guidance-Update-Summary",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Minimize Your Exposure with an LDAR Gap Assessment",
    "apiurl": "/restapi/customnewscontentlvl2/news/minimize-your-exposure-with-an-ldar-gap-assessment",
    "url": "/news/minimize-your-exposure-with-an-ldar-gap-assessment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Minimize Your Exposure with an LDAR Gap Assessment",
    "apiurl": "/restapi/customnewscontentlvl2/news/minimize-your-exposure-with-an-ldar-gap-assessment",
    "url": "/federal/minimize-your-exposure-with-an-ldar-gap-assessment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Annual Air Emission Inventories Due March 31, 2018-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/Annual-Air-Emission-Inventories-Due-March-31-2018-Nebraska",
    "url": "/news/Annual-Air-Emission-Inventories-Due-March-31-2018-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Deviation Reports and Reasonable Inquiry",
    "apiurl": "/restapi/customnewscontentlvl2/news/Deviation-Reports-and-Reasonable-Inquiry",
    "url": "/news/Deviation-Reports-and-Reasonable-Inquiry",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Environmental Compliance - Preparing for Success in 2014",
    "apiurl": "/restapi/customnewscontentlvl2/news/Environmental-Compliance---Preparing-for-Success-in-2014",
    "url": "/news/Environmental-Compliance---Preparing-for-Success-in-2014",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Virginia DEQ Proposes New VOC Control Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/Virginia-DEQ-Proposes-New-VOC-Control-Requirements",
    "url": "/news/Virginia-DEQ-Proposes-New-VOC-Control-Requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Arizona Air Quality Permitting Rules to Debut in December",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Arizona-Air-Quality-Permitting-Rules-to-Debut-in-December",
    "url": "/news/New-Arizona-Air-Quality-Permitting-Rules-to-Debut-in-December",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated APEN Form for Fugitive Component Leak Detection-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updated-APEN-Form-for-Fugitive-Component-Leak-Detection-Colorado",
    "url": "/news/Updated-APEN-Form-for-Fugitive-Component-Leak-Detection-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Launch of the WY Air Quality Division's Open Air Website-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Launch-of-the-WY-Air-Quality-Division's-Open-Air-Website-Wyoming",
    "url": "/news/Launch-of-the-WY-Air-Quality-Division's-Open-Air-Website-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Improving Site Represntation Using a Meteorological Tower-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/Improving-Site-Represntation-Using-a-Meteorological-Tower-New-Mexico",
    "url": "/news/Improving-Site-Represntation-Using-a-Meteorological-Tower-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated IDNR COVID-19 Enforcement and Compliance Protocol",
    "apiurl": "/restapi/customnewscontentlvl2/news/updated-idnr-covid-19-enforcement-and-compliance-protocol",
    "url": "/news/updated-idnr-covid-19-enforcement-and-compliance-protocol",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated IDNR COVID-19 Enforcement and Compliance Protocol",
    "apiurl": "/restapi/customnewscontentlvl2/news/updated-idnr-covid-19-enforcement-and-compliance-protocol",
    "url": "/states/updated-idnr-covid-19-enforcement-and-compliance-protocol",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SIP Revision for Controlling Emissions During Episodes of High Air Pollution Potential",
    "apiurl": "/restapi/customnewscontentlvl2/news/SIP-Revision-for-Controlling-Emissions-During-Episodes-of-High-Air-Pollution-Potential-",
    "url": "/news/SIP-Revision-for-Controlling-Emissions-During-Episodes-of-High-Air-Pollution-Potential-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Introducing BREEZE CALPUFF 2.4",
    "apiurl": "/restapi/customnewscontentlvl2/news/Introducing-BREEZE-CALPUFF-2-4",
    "url": "/news/Introducing-BREEZE-CALPUFF-2-4",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SJVAPCD Proposes BACT Policy Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/sjvapcd-proposes-bact-policy-update",
    "url": "/news/sjvapcd-proposes-bact-policy-update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Resource for Title V Permitting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Resource-for-Title-V-Permitting",
    "url": "/news/Resource-for-Title-V-Permitting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Manufacturers and Importers Required to Submit TSCA CDR Reports in 2016",
    "apiurl": "/restapi/customnewscontentlvl2/news/Manufacturers-and-Importers-Required-to-Submit-TSCA-CDR-Reports-in-2016",
    "url": "/news/Manufacturers-and-Importers-Required-to-Submit-TSCA-CDR-Reports-in-2016",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updated SO2 and NO2 Backgrounds",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updated-SO2-and-NO2-Backgrounds",
    "url": "/news/Updated-SO2-and-NO2-Backgrounds",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Oil and Gas Audit Program-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Oil-and-Gas-Audit-Program-Colorado",
    "url": "/news/EPA-Oil-and-Gas-Audit-Program-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Source Registration Submittal Deadlines for 2010",
    "apiurl": "/restapi/customnewscontentlvl2/news/Source-Registration-Submittal-Deadlines-for-2010",
    "url": "/news/Source-Registration-Submittal-Deadlines-for-2010",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "George Schewe joins Trinity",
    "apiurl": "/restapi/customnewscontentlvl2/news/George-Schewe-joins-Trinity",
    "url": "/news/George-Schewe-joins-Trinity",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Opposes EPA Control Strategy to Reduce Visibility Impact from Arizona Electricity Generating Stations",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ-Opposes-EPA-Control-Strategy-to-Reduce-Visibility-Impact-from-Arizona-Electricity-Generating-Stations-",
    "url": "/news/ADEQ-Opposes-EPA-Control-Strategy-to-Reduce-Visibility-Impact-from-Arizona-Electricity-Generating-Stations-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "OEHHA's Revised Air Toxics Hot Spots Guidance Manual Leads to Rule Revisions and New ARB Guidance",
    "apiurl": "/restapi/customnewscontentlvl2/news/OEHHA's-Revised-Air-Toxics-Hot-Spots-Guidance-Manual-Leads-to-Rule-Revisions-and-New-ARB-Guidance-",
    "url": "/news/OEHHA's-Revised-Air-Toxics-Hot-Spots-Guidance-Manual-Leads-to-Rule-Revisions-and-New-ARB-Guidance-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Periodic Rule Review Deadline",
    "apiurl": "/restapi/customnewscontentlvl2/news/Periodic-Rule-Review-Deadline",
    "url": "/news/Periodic-Rule-Review-Deadline",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Permitting Notices",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Permitting-Notices",
    "url": "/news/Air-Permitting-Notices",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Imperial County Released Draft 2013 SIP for PM2.5",
    "apiurl": "/restapi/customnewscontentlvl2/news/Imperial-County-Released-Draft-2013-SIP-for-PM2-5-",
    "url": "/news/Imperial-County-Released-Draft-2013-SIP-for-PM2-5-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEQ Hosting Environmental Update Workshops",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEQ-Hosting-Environmental-Update-Workshops",
    "url": "/news/NDEQ-Hosting-Environmental-Update-Workshops",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEP Revises Class I and Class II Air Permit Applications and Guidance Documents-Nevada",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEP-Revises-Class-I-and-Class-II-Air-Permit-Applications-and-Guidance-Documents-Nevada",
    "url": "/news/NDEP-Revises-Class-I-and-Class-II-Air-Permit-Applications-and-Guidance-Documents-Nevada",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2020 TSCA Chemical Data Reporting – Not Just for Chemical Manufacturers",
    "apiurl": "/restapi/customnewscontentlvl2/news/2020-tsca-chemical-data-reporting-not-just-for-chemical-manufacturers",
    "url": "/news/2020-tsca-chemical-data-reporting-not-just-for-chemical-manufacturers",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2020 TSCA Chemical Data Reporting – Not Just for Chemical Manufacturers",
    "apiurl": "/restapi/customnewscontentlvl2/news/2020-tsca-chemical-data-reporting-not-just-for-chemical-manufacturers",
    "url": "/federal/2020-tsca-chemical-data-reporting---not-just-for-chemical-manufacturers",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Mexico prepares to Adopt NSPS and Emission Guidelines for Municipal Solid Waste Landfills",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Mexico-prepares-to-Adopt-NSPS-and-Emission-Guidelines-for-Municipal-Solid-Waste-Landfills",
    "url": "/news/New-Mexico-prepares-to-Adopt-NSPS-and-Emission-Guidelines-for-Municipal-Solid-Waste-Landfills",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Controlling Hazardous Drug Exposure in Patient Care Areas",
    "apiurl": "/restapi/customnewscontentlvl2/news/controlling-hazardous-drug-exposure-in-patient-care-areas",
    "url": "/news/controlling-hazardous-drug-exposure-in-patient-care-areas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NYSDEC Amends Regulations under 6 NYCRR 200 and 6 NYCRR 212 for Process Emission Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/NYSDEC-Amends-Regulations-under-6-NYCRR-200-and-6-NYCRR-212-for-Process-Emission-Sources",
    "url": "/news/NYSDEC-Amends-Regulations-under-6-NYCRR-200-and-6-NYCRR-212-for-Process-Emission-Sources",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SDAPCD Notice of Portable Diesel Engine Fleet Emission Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/SDAPCD-Notice-of-Portable-Diesel-Engine-Fleet-Emission-Requirements",
    "url": "/news/SDAPCD-Notice-of-Portable-Diesel-Engine-Fleet-Emission-Requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Guidance Document Clarifying Not-to-Exceed Limits for NSPS IIII",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Guidance-Document-Clarifying-Not-to-Exceed-Limits-for-NSPS-IIII",
    "url": "/news/EPA-Guidance-Document-Clarifying-Not-to-Exceed-Limits-for-NSPS-IIII",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes Clean Power Plan to Reduce GHGs from Power Sector",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-Clean-Power-Plan-to-Reduce-GHGs-from-Power-Sector-",
    "url": "/news/EPA-Proposes-Clean-Power-Plan-to-Reduce-GHGs-from-Power-Sector-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Joins Forces with Sierra Research",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Joins-Forces-with-Sierra-Research",
    "url": "/news/Trinity-Joins-Forces-with-Sierra-Research",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Approval of Alabama's Air Plan - PSD Replacement Units",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Approval-of-Alabama's-Air-Plan---PSD-Replacement-Units",
    "url": "/news/Proposed-Approval-of-Alabama's-Air-Plan---PSD-Replacement-Units",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Approval of Alabama's Air Plan - PSD Replacement Units",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Approval-of-Alabama's-Air-Plan---PSD-Replacement-Units",
    "url": "/states/alabama/proposed-approval-of-alabama-s-air-plan---psd-replacement-units",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Suit Filed Against EPA Concerning Utah's PM2.5 SIP",
    "apiurl": "/restapi/customnewscontentlvl2/news/Suit-Filed-Against-EPA-Concerning-Utah's-PM2-5-SIP",
    "url": "/news/Suit-Filed-Against-EPA-Concerning-Utah's-PM2-5-SIP",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Electronic Filing Required for Stormwater Construction General Permit (TXR150000)-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Electronic-Filing-Required-for-Stormwater-Construction-General-Permit-(TXR150000)-Texas",
    "url": "/news/Electronic-Filing-Required-for-Stormwater-Construction-General-Permit-(TXR150000)-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NMED Releases Revised UA3",
    "apiurl": "/restapi/customnewscontentlvl2/news/NMED-Releases-Revised-UA3",
    "url": "/news/NMED-Releases-Revised-UA3",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "VTDEC 2020 Air Monitoring Network Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/vtdec-2020-air-monitoring-network-plan",
    "url": "/news/vtdec-2020-air-monitoring-network-plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "VTDEC 2020 Air Monitoring Network Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/vtdec-2020-air-monitoring-network-plan",
    "url": "/news/state/vermont/vtdec-2020-air-monitoring-network-plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Bibb and Floyd County Nonattainment Areas Re-designated by the EPA",
    "apiurl": "/restapi/customnewscontentlvl2/news/Bibb-and-F",
    "url": "/news/Bibb-and-F",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD Releases Second Round of Proposed NSR/Title V Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/BAAQMD-Releases-Second-Round-of-Proposed-NSR-Title-V-Regulations",
    "url": "/news/BAAQMD-Releases-Second-Round-of-Proposed-NSR-Title-V-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New ADEQ Forms",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-ADEQ-Forms",
    "url": "/news/New-ADEQ-Forms",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CARB:  Recent Proceedings Related to California's Cap-and-Trade Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/CARB-Recent-Proceedings-Related-to-California's-Cap-and-Trade-Program",
    "url": "/news/CARB-Recent-Proceedings-Related-to-California's-Cap-and-Trade-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Regulatory Air Dispersion Modelling using AERMOD Discussed in Melbourne, Australia during the CASANZ 22nd Conference",
    "apiurl": "/restapi/customnewscontentlvl2/news/Regulatory-Air-Dispersion-Modelling-using-AERMOD-Discussed-in-Melbourne-Australia-during-the-CASANZ-22nd-Conference",
    "url": "/news/Regulatory-Air-Dispersion-Modelling-using-AERMOD-Discussed-in-Melbourne-Australia-during-the-CASANZ-22nd-Conference",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TSCA Title VI Formaldehyde Rule Compliance Moved Up to June 1, 2018-Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/TSCA-Title-VI-Formaldehyde-Rule-Compliance-Moved-Up-to-June-1-2018-Oregon",
    "url": "/news/TSCA-Title-VI-Formaldehyde-Rule-Compliance-Moved-Up-to-June-1-2018-Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "General Permit for Small & Area Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/General-Permit-for-Small-Area-Sources",
    "url": "/news/General-Permit-for-Small-Area-Sources",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cyanide Chemicals MACT Proposed Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/cyanide-chemicals-mact-proposed-amendments",
    "url": "/news/cyanide-chemicals-mact-proposed-amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Do You Need a Permit for Your Routine or Predictable Gas Venting Emissions?",
    "apiurl": "/restapi/customnewscontentlvl2/news/do-you-need-a-permit-for-your-routine-or-predictable-gas-venting-emissions",
    "url": "/news/do-you-need-a-permit-for-your-routine-or-predictable-gas-venting-emissions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Do You Need a Permit for Your Routine or Predictable Gas Venting Emissions?",
    "apiurl": "/restapi/customnewscontentlvl2/news/do-you-need-a-permit-for-your-routine-or-predictable-gas-venting-emissions",
    "url": "/www.trinityconsultants.com/do-you-need-a-permit-for-your-routine-or-predictable-gas-venting-emissions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Requirements and Developments in Business Sustainability Reporting and Disclosure",
    "apiurl": "/restapi/customnewscontentlvl2/news/Requirements-and-Developments-in-Business-Sustainability-Reporting-and-Disclosure",
    "url": "/news/Requirements-and-Developments-in-Business-Sustainability-Reporting-and-Disclosure",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Hires Esteemed Air Quality Modeler",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Hi",
    "url": "/news/Trinity-Hi",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oil and Gas Industry Faces Significant New Air Quality Requirements",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oil-and-Gas-Industry-Faces-Significant-New-Air-Quality-Requirements",
    "url": "/news/Oil-and-Gas-Industry-Faces-Significant-New-Air-Quality-Requirements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Public Comment Period Open for Oregon GHG Reporting Protocols",
    "apiurl": "/restapi/customnewscontentlvl2/news/Public-Comment-Period-Open-for-Oregon-GHG-Reporting-Protocols",
    "url": "/news/Public-Comment-Period-Open-for-Oregon-GHG-Reporting-Protocols",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Tier II Chemical Reporting Program Moves from the Texas Department of State Health Services to the TCEQ",
    "apiurl": "/restapi/customnewscontentlvl2/news/Tier-II-Chemical-Reporting-Program-Moves-from-the-Texas-Department-of-State-Health-Services-to-the-TCEQ",
    "url": "/news/Tier-II-Chemical-Reporting-Program-Moves-from-the-Texas-Department-of-State-Health-Services-to-the-TCEQ",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New NJDEP Air Rules Adoption Might Impact Your Facility in New Jersey",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-NJDEP-Air-Rules-Adoption-Might-Impact-Your-Facility-in-NJ",
    "url": "/news/New-NJDEP-Air-Rules-Adoption-Might-Impact-Your-Facility-in-NJ",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "APEN Updated for Asphalt Paving Materials Plants-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/APEN-Updated-for-Asphalt-Paving-Materials-Plants-Colorado",
    "url": "/news/APEN-Updated-for-Asphalt-Paving-Materials-Plants-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Supreme Court Rules on GHG Regulatory Approach",
    "apiurl": "/restapi/customnewscontentlvl2/news/Supreme-Court-Rules-on-GHG-Regulatory-Approach",
    "url": "/news/Supreme-Court-Rules-on-GHG-Regulatory-Approach",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New NMED GCP-Temporary Control Permit-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-NMED-GCP-Temporary-Control-Permit-New-Mexico",
    "url": "/news/New-NMED-GCP-Temporary-Control-Permit-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Missouri Reporting Reminders",
    "apiurl": "/restapi/customnewscontentlvl2/news/Missouri-Reporting-Reminders",
    "url": "/news/Missouri-Reporting-Reminders",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Three new MACT Area Source Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/Three-new-MACT-Area-Source-Rules",
    "url": "/news/Three-new-MACT-Area-Source-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Hearings on Proposed Rule Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/Hearings-on-Proposed-Rule-Amendments",
    "url": "/news/Hearings-on-Proposed-Rule-Amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed 2016 Annual Ambient Air Monitoring Network Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-2016-Annual-Ambient-Air-Monitoring-Network-Plan",
    "url": "/news/Proposed-2016-Annual-Ambient-Air-Monitoring-Network-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Leak Repair Provisions No Longer Applicable to Substitute Refrigerants",
    "apiurl": "/restapi/customnewscontentlvl2/news/leak-repair-provisions-no-longer-applicable-to-substitute-refrigerants",
    "url": "/news/leak-repair-provisions-no-longer-applicable-to-substitute-refrigerants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Leak Repair Provisions No Longer Applicable to Substitute Refrigerants",
    "apiurl": "/restapi/customnewscontentlvl2/news/leak-repair-provisions-no-longer-applicable-to-substitute-refrigerants",
    "url": "/federal/leak-repair-provisions-no-longer-applicable-to-substitute-refrigerants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The 2019 Reporting Season is Upon Us",
    "apiurl": "/restapi/customnewscontentlvl2/news/The-2019-Reporting-Season-is-Upon-Us",
    "url": "/news/The-2019-Reporting-Season-is-Upon-Us",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The 2019 Reporting Season is Upon Us",
    "apiurl": "/restapi/customnewscontentlvl2/news/The-2019-Reporting-Season-is-Upon-Us",
    "url": "/states/arizona/the-2019-reporting-season-is-upon-us",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SafeBridge Consultants Announces New Leadership Appointments",
    "apiurl": "/restapi/customnewscontentlvl2/news/SafeBridge-Consultants-Announces-New-Leadership-Appointments",
    "url": "/news/SafeBridge-Consultants-Announces-New-Leadership-Appointments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NOx RACT Update-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/NOx-RACT-Update-Illinois",
    "url": "/news/NOx-RACT-Update-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDE Proposed to Adopt New Regulations to Reduce Hydrofluorocarbons",
    "apiurl": "/restapi/customnewscontentlvl2/news/mde-proposed-to-adopt-new-regulations-to-reduce-hydrofluorocarbons",
    "url": "/news/mde-proposed-to-adopt-new-regulations-to-reduce-hydrofluorocarbons",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The Engine Rules: Ten Key Elements",
    "apiurl": "/restapi/customnewscontentlvl2/news/The-Engine-Rules-Ten-Key-Elements",
    "url": "/news/The-Engine-Rules-Ten-Key-Elements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New K-REACH Preregistration Deadline Approaching - June 30",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-K-REACH-Preregistration-Deadline-Approaching---June-30",
    "url": "/news/New-K-REACH-Preregistration-Deadline-Approaching---June-30",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Public Comment for IDNR Rule Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Public-Comment-for-IDNR-Rule-Updates",
    "url": "/news/Public-Comment-for-IDNR-Rule-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CFATS Reauthorization and Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/cfats-reauthorization-and-updates-",
    "url": "/news/cfats-reauthorization-and-updates-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CFATS Reauthorization and Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/cfats-reauthorization-and-updates-",
    "url": "/ehs-management/cfats-reauthorization-and-updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD - RECLAIM-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/SCAQMD---RECLAIM-California",
    "url": "/news/SCAQMD---RECLAIM-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Acquires SafeBridge Consultants, Inc., a Leader in Toxicology and Industrial Hygiene Services",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Acquires-SafeBridge-Consultants-Inc-a-Leader-in-Toxicology-and-Industrial-Hygiene-Services",
    "url": "/news/Trinity-Consultants-Acquires-SafeBridge-Consultants-Inc-a-Leader-in-Toxicology-and-Industrial-Hygiene-Services",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Is Modification to an IDNR Air Construction Permit Needed?",
    "apiurl": "/restapi/customnewscontentlvl2/news/Is-Modification-to-an-IDNR-Air-Construction-Permit-Needed-",
    "url": "/news/Is-Modification-to-an-IDNR-Air-Construction-Permit-Needed-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "RICE Responsibilities Transfer from EPA to IDNR; Amnesty Period for Compliance Established",
    "apiurl": "/restapi/customnewscontentlvl2/news/RICE-Responsibilities-Transfer-from-EPA-to-IDNR-Amnesty-Period-for-Compliance-Established",
    "url": "/news/RICE-Responsibilities-Transfer-from-EPA-to-IDNR-Amnesty-Period-for-Compliance-Established",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Nation's First Mandatory Market Based CO2 Reduction Initiative (RGGI) Completes a Successful One Year Run",
    "apiurl": "/restapi/customnewscontentlvl2/news/Nation's-First-Mandatory-Market-Based-CO2-Reduction-Initiative-(RGGI)-Completes-a-Successful-One-Year-Run",
    "url": "/news/Nation's-First-Mandatory-Market-Based-CO2-Reduction-Initiative-(RGGI)-Completes-a-Successful-One-Year-Run",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Albuquerque Office Manager",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Albuquerque-Office-Manager",
    "url": "/news/New-Albuquerque-Office-Manager",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "May AWMA Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/May-AWMA-Meeting",
    "url": "/news/May-AWMA-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Provides Option for Rescinding EPA-Issued Tailoring Rule Step 2 PSD Permits",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Provides-Option-for-Rescinding-EPA-Issued-Tailoring-Rule-Step-2-PSD-Permits",
    "url": "/news/EPA-Provides-Option-for-Rescinding-EPA-Issued-Tailoring-Rule-Step-2-PSD-Permits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DEQ Proposing Rulemaking to Modify GHG Reporting Program-Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/DEQ-Proposing-Rulemaking-to-Modify-GHG-Reporting-Program-Oregon",
    "url": "/news/DEQ-Proposing-Rulemaking-to-Modify-GHG-Reporting-Program-Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Using Your EMS  to Improve Energy  Efficiency",
    "apiurl": "/restapi/customnewscontentlvl2/news/Using-Your-EMS-to-Improve-Energy-Efficiency",
    "url": "/news/Using-Your-EMS-to-Improve-Energy-Efficiency",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Approves Arizona State Plan for Implementing NSPS Cf",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-approves-arizona-state-plan-for-implementing-nsps-cf",
    "url": "/news/epa-approves-arizona-state-plan-for-implementing-nsps-cf",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Approves Arizona State Plan for Implementing NSPS Cf",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-approves-arizona-state-plan-for-implementing-nsps-cf",
    "url": "/states/arizona/epa-approves-arizona-state-plan-for-implementing-nsps-cf",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Stormwater Construction General Permit: Low Erosivity Waiver-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Stormwater-Construction-General-Permit-Low-Erosivity-Waiver-New-Mexico",
    "url": "/news/EPA-Stormwater-Construction-General-Permit-Low-Erosivity-Waiver-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Stormwater Multi-Sector General Permit (MSGP) NetDMR Electronic Reporting Waiver Issued-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Stormwater-Multi-Sector-General-Permit-(MSGP)-NetDMR-Electronic-Reporting-Waiver-Issued-Texas",
    "url": "/news/Stormwater-Multi-Sector-General-Permit-(MSGP)-NetDMR-Electronic-Reporting-Waiver-Issued-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Emissions Inventory Reporting for Class II Permits Changed to Triennial Reporting as of June 1, 2021",
    "apiurl": "/restapi/customnewscontentlvl2/news/emissions-inventory-reporting-for-class-ii-permits-changed-to-triennial-reporting-as-of-june-1-2021",
    "url": "/news/emissions-inventory-reporting-for-class-ii-permits-changed-to-triennial-reporting-as-of-june-1-2021",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Emissions Inventory Reporting for Class II Permits Changed to Triennial Reporting as of June 1, 2021",
    "apiurl": "/restapi/customnewscontentlvl2/news/emissions-inventory-reporting-for-class-ii-permits-changed-to-triennial-reporting-as-of-june-1-2021",
    "url": "/www.trinityconsultants.com/news/emissions-inventory-reporting-for-class-ii-permits-changed-to-triennial-reporting-as-of-june-1-2021",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Turkey REACH",
    "apiurl": "/restapi/customnewscontentlvl2/news/Turkey-REACH",
    "url": "/news/Turkey-REACH",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Annual Electronic Emissions Statement Reporting in Connecticut",
    "apiurl": "/restapi/customnewscontentlvl2/news/Annual-Ele",
    "url": "/news/Annual-Ele",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Alberta's Air Monitoring Directive-Alberta",
    "apiurl": "/restapi/customnewscontentlvl2/news/Alberta's-Air-Monitoring-Directive-Alberta",
    "url": "/news/Alberta's-Air-Monitoring-Directive-Alberta",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Revision to Arizona's State Implementation Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Revision-to-Arizonas-State-Implementation-Plan",
    "url": "/news/Proposed-Revision-to-Arizonas-State-Implementation-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Revision to Arizona's State Implementation Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Revision-to-Arizonas-State-Implementation-Plan",
    "url": "/news/Proposed-Revision-to-Arizona's-State-Implementation-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Greenhouse Gases \"Tailoring\" Proposal",
    "apiurl": "/restapi/customnewscontentlvl2/news/Greenhouse-Gases-Tailoring-Proposal",
    "url": "/news/Greenhouse-Gases-Tailoring-Proposal",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Proposes Revisions to the Permit by Rule and Standard Permit New Source Review for Oil & Gas Operations",
    "apiurl": "/restapi/customnewscontentlvl2/news/TCEQ-Proposes-Revisions-to-the-Permit-by-Rule-and-Standard-Permit-New-Source-Review-for-Oil-Gas-Operations",
    "url": "/news/TCEQ-Proposes-Revisions-to-the-Permit-by-Rule-and-Standard-Permit-New-Source-Review-for-Oil-Gas-Operations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PADEP Publishes Draft Revisions to the Air Quality Permit Exemptions List",
    "apiurl": "/restapi/customnewscontentlvl2/news/padep-publishes-draft-revisions-to-the-air-quality-permit-exemptions-list",
    "url": "/news/padep-publishes-draft-revisions-to-the-air-quality-permit-exemptions-list",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PADEP Publishes Draft Revisions to the Air Quality Permit Exemptions List",
    "apiurl": "/restapi/customnewscontentlvl2/news/padep-publishes-draft-revisions-to-the-air-quality-permit-exemptions-list",
    "url": "/news/state/pennsylvania/padep-publishes-draft-revisions-to-the-air-quality-permit-exemptions-list",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GP09 and GP10: General Permits for Well Production Facilities-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/GP09-and-GP10-General-Permits-for-Well-Production-Facilities-Colorado",
    "url": "/news/GP09-and-GP10-General-Permits-for-Well-Production-Facilities-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final Rules RCSA-22a-174-22e and RCSA-22a-174-22f are Effective!",
    "apiurl": "/restapi/customnewscontentlvl2/news/Final-Rules-RCSA-22a-174-22e-and-RCSA-22a-174-22f-are-Effective!",
    "url": "/news/Final-Rules-RCSA-22a-174-22e-and-RCSA-22a-174-22f-are-Effective!",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE Releases AERMOD 7.9 to Include Latest U.S. EPA Executable 14134",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-Releases-AERMOD-7-9-to-Include-Latest-U-S-EPA-Executable-14134",
    "url": "/news/BREEZE-Releases-AERMOD-7-9-to-Include-Latest-U-S-EPA-Executable-14134",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reminder of the Month - Boiler MACT Compliance Certification Due January 31st-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reminder-of-the-Month---Boiler-MACT-Compliance-Certification-Due-January-31st-Kansas",
    "url": "/news/Reminder-of-the-Month---Boiler-MACT-Compliance-Certification-Due-January-31st-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Polk County Permit Forms",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Polk-County-Permit-Forms",
    "url": "/news/New-Polk-County-Permit-Forms",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NMED Publishes Update to Universal Application Forms",
    "apiurl": "/restapi/customnewscontentlvl2/news/NMED-Publishes-Update-to-Universal-Application-Forms",
    "url": "/news/NMED-Publishes-Update-to-Universal-Application-Forms",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Acts on 2009 NOx Ozone Season Allocations for NC Facilities Under CAIR",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Acts-on-2009-NOx-Ozone-Season-Allocations-for-NC-Facilities-Under-CAIR",
    "url": "/news/EPA-Acts-on-2009-NOx-Ozone-Season-Allocations-for-NC-Facilities-Under-CAIR",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New O&M Templates Must Be Used for Oil and Gas Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-O-M-Templates-Must-Be-Used-for-Oil-and-Gas-Sources",
    "url": "/news/New-O-M-Templates-Must-Be-Used-for-Oil-and-Gas-Sources",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Definition of Solid Waste",
    "apiurl": "/restapi/customnewscontentlvl2/news/Definition-of-Solid-Waste",
    "url": "/news/Definition-of-Solid-Waste",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DEP Releases New Public eComment System and Updates to Technical Guidance Policy Document",
    "apiurl": "/restapi/customnewscontentlvl2/news/DEP-Releases-New-Public-eComment-System-and-Updates-to-Technical-Guidance-Policy-Document",
    "url": "/news/DEP-Releases-New-Public-eComment-System-and-Updates-to-Technical-Guidance-Policy-Document",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA Proposes to Re-designate the Salt Lake City, Provo, and Logan Areas as Serious Non-Attainment for PM2.5",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-Proposes-to-Re-designate-the-Salt-Lake-City-Provo-and-Logan-Areas-as-Serious-Non-Attainment-for-PM2-5",
    "url": "/news/USEPA-Proposes-to-Re-designate-the-Salt-Lake-City-Provo-and-Logan-Areas-as-Serious-Non-Attainment-for-PM2-5",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Asbestos Notification Fee Increase-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Asbestos-Notification-Fee-Increase-Iowa",
    "url": "/news/Asbestos-Notification-Fee-Increase-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Toxic Release Inventory Reporting Revisions",
    "apiurl": "/restapi/customnewscontentlvl2/news/Toxic-Rele",
    "url": "/news/Toxic-Rele",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "California Developing Program to Reduce Emissions of Short-Lived Climate Pollutants",
    "apiurl": "/restapi/customnewscontentlvl2/news/California-Developing-Program-to-Reduce-Emissions-of-Short-Lived-Climate-Pollutants",
    "url": "/news/California-Developing-Program-to-Reduce-Emissions-of-Short-Lived-Climate-Pollutants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NOI O&G Quick Application-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/NOI-O-G-Quick-Application-New-Mexico",
    "url": "/news/NOI-O-G-Quick-Application-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA’s Ruling on ADEQ’s Proposed Revised SIP",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-s-Ruling-on-ADEQ-s-Proposed-Revised-SIP",
    "url": "/news/USEPA-s-Ruling-on-ADEQ-s-Proposed-Revised-SIP",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CO2 Budget Trading Program-Maryland",
    "apiurl": "/restapi/customnewscontentlvl2/news/CO2-Budget-Trading-Program-Maryland",
    "url": "/news/CO2-Budget-Trading-Program-Maryland",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MassDEP Issues Violations and Collects Thousands in Fines in the First Quarter",
    "apiurl": "/restapi/customnewscontentlvl2/news/MassDEP-Issues-Violations-and-Collects-Thousands-in-Fines-in-the-First-Quarter",
    "url": "/news/MassDEP-Issues-Violations-and-Collects-Thousands-in-Fines-in-the-First-Quarter",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Amendments to 10 CSR 10-6.130 Controlling Emissions During Episodes of High Air Pollution Potential",
    "apiurl": "/restapi/customnewscontentlvl2/news/Amendments-to-10-CSR-10-6-130-Controlling-Emissions-During-Episodes-of-High-Air-Pollution-Potential",
    "url": "/news/Amendments-to-10-CSR-10-6-130-Controlling-Emissions-During-Episodes-of-High-Air-Pollution-Potential",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes Changes to the Risk Management Program (40 CFR Part 68)",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-Changes-to-the-Risk-Management-Program-(40-CFR-Part-68)",
    "url": "/news/EPA-Proposes-Changes-to-the-Risk-Management-Program-(40-CFR-Part-68)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CAIR CSP Allowance Proposal",
    "apiurl": "/restapi/customnewscontentlvl2/news/CAIR-CSP-Allowance-Proposal",
    "url": "/news/CAIR-CSP-Allowance-Proposal",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Mexico Governor Signs Executive Order Committing State to Climate Change Action-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Mexico-Governor-Signs-Executive-Order-Committing-State-to-Climate-Change-Action-New-Mexico",
    "url": "/news/New-Mexico-Governor-Signs-Executive-Order-Committing-State-to-Climate-Change-Action-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Important TCEQ Updates-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Important-TCEQ-Updates-Texas",
    "url": "/news/Important-TCEQ-Updates-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PADEP Guidance on Storage Tank Modification and Maintenance, Operator Training Requirements-Pennsylvania",
    "apiurl": "/restapi/customnewscontentlvl2/news/PADEP-Guidance-on-Storage-Tank-Modification-and-Maintenance-Operator-Training-Requirements-Pennsylvania",
    "url": "/news/PADEP-Guidance-on-Storage-Tank-Modification-and-Maintenance-Operator-Training-Requirements-Pennsylvania",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Quick Look at the New Ozone Standard in Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Quick-Look-at-the-New-Ozone-Standard-in-Colorado",
    "url": "/news/Quick-Look-at-the-New-Ozone-Standard-in-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Draft IDEM Non-Rule Policy for Revocation of Air Construction and/or Operating Permits-Indiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/Draft-IDEM-Non-Rule-Policy-for-Revocation-of-Air-Construction-and-or-Operating-Permits-Indiana",
    "url": "/news/Draft-IDEM-Non-Rule-Policy-for-Revocation-of-Air-Construction-and-or-Operating-Permits-Indiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Environmental Protection Committee Notice of Intended Action to Amend Chapter 33 of the IAC",
    "apiurl": "/restapi/customnewscontentlvl2/news/Environmental-Protection-Committee-Notice-of-Intended-Action-to-Amend-Chapter-33-of-the-IAC",
    "url": "/news/Environmental-Protection-Committee-Notice-of-Intended-Action-to-Amend-Chapter-33-of-the-IAC",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD RECLAIM Facility Shutdown Workshop",
    "apiurl": "/restapi/customnewscontentlvl2/news/SCAQMD-RECLAIM-Facility-Shutdown-Workshop",
    "url": "/news/SCAQMD-RECLAIM-Facility-Shutdown-Workshop",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Amendments to 10 CSR 10-6.020 Definitions and Common Reference Tables",
    "apiurl": "/restapi/customnewscontentlvl2/news/Amendments-to-10-CSR-10-6-020-Definitions-and-Common-Reference-Tables",
    "url": "/news/Amendments-to-10-CSR-10-6-020-Definitions-and-Common-Reference-Tables",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Uniform Standards Pave Path for Greater Regulatory Burden",
    "apiurl": "/restapi/customnewscontentlvl2/news/Uniform-Standards-Pave-Path-for-Greater-Regulatory-Burden",
    "url": "/news/Uniform-Standards-Pave-Path-for-Greater-Regulatory-Burden",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Keeping the Increasing Complexity of Air Dispersion Modeling in Check",
    "apiurl": "/restapi/customnewscontentlvl2/news/Keeping-the-Increasing-Complexity-of-Air-Dispersion-Modeling-in-Check",
    "url": "/news/Keeping-the-Increasing-Complexity-of-Air-Dispersion-Modeling-in-Check",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Clark County Department of Air Quality Revises Permitting Applicability Policy for Emergency Engines",
    "apiurl": "/restapi/customnewscontentlvl2/news/Clark-County-Department-of-Air-Quality-Revises-Permitting-Applicability-Policy-for-Emergency-Engines",
    "url": "/news/Clark-County-Department-of-Air-Quality-Revises-Permitting-Applicability-Policy-for-Emergency-Engines",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Establishes New 1-hour Standard for Sulfur Dioxide -Montana",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Establishes-New-1-hour-Standard-for-Sulfur-Dioxide--Montana",
    "url": "/news/EPA-Establishes-New-1-hour-Standard-for-Sulfur-Dioxide--Montana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "San Diego County APCD Proposed Amendments to Rule 67.12.1 – Polyester Resin Operations",
    "apiurl": "/restapi/customnewscontentlvl2/news/San-Diego-County-APCD-Proposed-Amendments-to-Rule-67-12-1-Polyester-Resin-Operations",
    "url": "/news/San-Diego-County-APCD-Proposed-Amendments-to-Rule-67-12-1-Polyester-Resin-Operations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Only Charlotte Area Designated as Nonattainment Under 2008 Ozone Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/Only-Charlotte-Area-Designated-as-Nonattainment-Under-2008-Ozone-Standard",
    "url": "/news/Only-Charlotte-Area-Designated-as-Nonattainment-Under-2008-Ozone-Standard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Additional Changes to More Stringent Emissions Regulations Proposed Under SCAQMD Rule 1110.2",
    "apiurl": "/restapi/customnewscontentlvl2/news/Additional-Changes-to-More-Stringent-Emissions-Regulations-Proposed-Under-SCAQMD-Rule-1110-2-",
    "url": "/news/Additional-Changes-to-More-Stringent-Emissions-Regulations-Proposed-Under-SCAQMD-Rule-1110-2-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PCAQCD Proposes Rule Updates for Annual Emissions Inventory Questionnaire and Emissions Statements",
    "apiurl": "/restapi/customnewscontentlvl2/news/pcaqcd-proposes-rule-updates-for-annual-emissions-inventory-questionnaire-and-emissions-statements",
    "url": "/news/pcaqcd-proposes-rule-updates-for-annual-emissions-inventory-questionnaire-and-emissions-statements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PCAQCD Proposes Rule Updates for Annual Emissions Inventory Questionnaire and Emissions Statements",
    "apiurl": "/restapi/customnewscontentlvl2/news/pcaqcd-proposes-rule-updates-for-annual-emissions-inventory-questionnaire-and-emissions-statements",
    "url": "/states/arizona/pcaqcd-proposes-rule-updates-for-annual-emissions-inventory-questionnaire-and-emissions-statements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Collection of Air Permits (CAP) Option Now Available",
    "apiurl": "/restapi/customnewscontentlvl2/news/Collection-of-Air-Permits-(CAP)-Option-Now-Available",
    "url": "/news/Collection-of-Air-Permits-(CAP)-Option-Now-Available",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "South Coast Air Quality Management District – Proposed Rule 1466",
    "apiurl": "/restapi/customnewscontentlvl2/news/South-Coast-Air-Quality-Management-District-Proposed-Rule-1466",
    "url": "/news/South-Coast-Air-Quality-Management-District-Proposed-Rule-1466",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Inland Port Air Quality Monitors Installed",
    "apiurl": "/restapi/customnewscontentlvl2/news/inland-port-air-quality-monitors-installed",
    "url": "/news/inland-port-air-quality-monitors-installed",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates on Proposed Rule: 10 CSR 10-6.261 Control of Sulfur Dioxide Emissions",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-on-Proposed-Rule-10-CSR-10-6-261-Control-of-Sulfur-Dioxide-Emissions",
    "url": "/news/Updates-on-Proposed-Rule-10-CSR-10-6-261-Control-of-Sulfur-Dioxide-Emissions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NJDEP Evaluating New Rulemaking for Hazardous Air Pollutants-New Jersey",
    "apiurl": "/restapi/customnewscontentlvl2/news/NJDEP-Evaluating-New-Rulemaking-for-Hazardous-Air-Pollutants-New-Jersey",
    "url": "/news/NJDEP-Evaluating-New-Rulemaking-for-Hazardous-Air-Pollutants-New-Jersey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NJDEP Evaluating New Rulemaking for Hazardous Air Pollutants-New Jersey",
    "apiurl": "/restapi/customnewscontentlvl2/news/NJDEP-Evaluating-New-Rulemaking-for-Hazardous-Air-Pollutants-New-Jersey",
    "url": "/news/states/new-jersey/new-njdep-air-rules-adoption-might-impact-your-facility-in-nj",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Impacts of Proposed Ozone NAAQS Revisions in Kentucky",
    "apiurl": "/restapi/customnewscontentlvl2/news/Impacts-of",
    "url": "/news/Impacts-of",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Title V Fees",
    "apiurl": "/restapi/customnewscontentlvl2/news/Title-V-Fees",
    "url": "/news/Title-V-Fees",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Streamlining the Application Process in 2019-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Streamlining-the-Application-Process-in-2019-Texas",
    "url": "/news/Streamlining-the-Application-Process-in-2019-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revised Collection of Air Permits (CAP) Option Available for Review",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revised-Collection-of-Air-Permits-(CAP)-Option-Available-for-Review",
    "url": "/news/Revised-Collection-of-Air-Permits-(CAP)-Option-Available-for-Review",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Boiler MACT Reporting Reminder - First Annual Compliance Report Due January 31, 2017 for Gas 1 Units",
    "apiurl": "/restapi/customnewscontentlvl2/news/Boiler-MACT-Reporting-Reminder---First-Annual-Compliance-Report-Due-January-31-2017-for-Gas-1-Units",
    "url": "/news/Boiler-MACT-Reporting-Reminder---First-Annual-Compliance-Report-Due-January-31-2017-for-Gas-1-Units",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Brian Holland Earns the AMS Certified Consulting Meteorologist Designation",
    "apiurl": "/restapi/customnewscontentlvl2/news/Brian-Holland-Earns-the-AMS-Certified-Consulting-Meteorologist-Designation",
    "url": "/news/Brian-Holland-Earns-the-AMS-Certified-Consulting-Meteorologist-Designation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KDHE Issues Updated Air Regulatory Enforcement Policy and SEP Policy",
    "apiurl": "/restapi/customnewscontentlvl2/news/kdhe-issues-updated-air-regulatory-enforcement-policy-and-sep-policy",
    "url": "/news/kdhe-issues-updated-air-regulatory-enforcement-policy-and-sep-policy",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Names New Director of Mergers and Acquisitions",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Names-New-Director-of-Mergers-and-Acquisitions",
    "url": "/news/Trinity-Names-New-Director-of-Mergers-and-Acquisitions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD Proposed Rule 1148.2 - Drilling and Well Completion",
    "apiurl": "/restapi/customnewscontentlvl2/news/SCAQMD-Proposed-Rule-1148-2---Drilling-and-Well-Completion-",
    "url": "/news/SCAQMD-Proposed-Rule-1148-2---Drilling-and-Well-Completion-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SPCC Plans for Farms",
    "apiurl": "/restapi/customnewscontentlvl2/news/SPCC-Plans-for-Farms",
    "url": "/news/SPCC-Plans-for-Farms",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEM Revises the Air Division Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEM-Revises-the-Air-Division-Regulations-",
    "url": "/news/ADEM-Revises-the-Air-Division-Regulations-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Permits in Indian Country",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Permits-in-Indian-Country",
    "url": "/news/EPA-Permits-in-Indian-Country",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Federal and Kansas Reporting Reminders",
    "apiurl": "/restapi/customnewscontentlvl2/news/Federal-and-Kansas-Reporting-Reminders",
    "url": "/news/Federal-and-Kansas-Reporting-Reminders",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ten Tips to Streamline Your Permit Renewal",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ten-Tips-to-Streamline-Your-Permit-Renewal",
    "url": "/news/Ten-Tips-to-Streamline-Your-Permit-Renewal",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ SO2 NAAQS State Implementation Plan Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/TCEQ-SO2-NAAQS-State-Implementation-Plan-Update",
    "url": "/news/TCEQ-SO2-NAAQS-State-Implementation-Plan-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Redesignation of Indiana Counties for 1997 Annual Standard for Fine Particulate Matter",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Redesignation-of-Indiana-Counties-for-1997-Annual-Standard-for-Fine-Particulate-Matter",
    "url": "/news/Proposed-Redesignation-of-Indiana-Counties-for-1997-Annual-Standard-for-Fine-Particulate-Matter",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Proposes Additional Refinement to its Air Permitting Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ-Proposes-Additional-Refinement-to-its-Air-Permitting-Program",
    "url": "/news/ADEQ-Proposes-Additional-Refinement-to-its-Air-Permitting-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEM revises Air Emissions Electronic Reporting System (AEERS) Responsible Official Registration Form",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEM-revises-Air-Emissions-Electronic-Reporting-System-(AEERS)-Responsible-Official-Registration-Form",
    "url": "/news/ADEM-revises-Air-Emissions-Electronic-Reporting-System-(AEERS)-Responsible-Official-Registration-Form",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Plan Approval: NOx-Tennessee",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Plan-Approval-NOx-Tennessee",
    "url": "/news/Air-Plan-Approval-NOx-Tennessee",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Printing Industry - UDAQ Reviews Air Quality Permitting and Regulatory Requirements-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/Printing-Industry---UDAQ-Reviews-Air-Quality-Permitting-and-Regulatory-Requirements-Utah",
    "url": "/news/Printing-Industry---UDAQ-Reviews-Air-Quality-Permitting-and-Regulatory-Requirements-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Finalized WDNR Air Quality Backgrounds",
    "apiurl": "/restapi/customnewscontentlvl2/news/Finalized-WDNR-Air-Quality-Backgrounds",
    "url": "/news/Finalized-WDNR-Air-Quality-Backgrounds",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MassDEP 2017 Source Registration Due on December 13, 2019-Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/MassDEP-2017-Source-Registration-Due-on-December-13-2019-Massachusetts",
    "url": "/news/MassDEP-2017-Source-Registration-Due-on-December-13-2019-Massachusetts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Dispersion Modeling Data and Guidance Updates Available for Use",
    "apiurl": "/restapi/customnewscontentlvl2/news/Dispersion-Modeling-Data-and-Guidance-Updates-Available-for-Use",
    "url": "/news/Dispersion-Modeling-Data-and-Guidance-Updates-Available-for-Use",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Texas Tier II Reporting – 2017 Reports-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Texas-Tier-II-Reporting-2017-Reports-Texas",
    "url": "/news/Texas-Tier-II-Reporting-2017-Reports-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Employee Spotlight: Jim Eggenschwiler",
    "apiurl": "/restapi/customnewscontentlvl2/news/employee-spotlight-jim-eggenschwiler",
    "url": "/news/employee-spotlight-jim-eggenschwiler",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Launch of Colorado Environmental Online Services System-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Launch-of-Colorado-Environmental-Online-Services-System-Colorado",
    "url": "/news/Launch-of-Colorado-Environmental-Online-Services-System-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DOEE Proposes Updates to RACT Regulations-Washington, DC",
    "apiurl": "/restapi/customnewscontentlvl2/news/DOEE-Proposes-Updates-to-RACT-Regulations-Washington-DC",
    "url": "/news/DOEE-Proposes-Updates-to-RACT-Regulations-Washington-DC",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Ambient Monitor in Johnson County-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Ambient-Monitor-in-Johnson-County-Wyoming",
    "url": "/news/New-Ambient-Monitor-in-Johnson-County-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Regulation 7 Semi-Annual Reports-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Regulation-7-Semi-Annual-Reports-Colorado",
    "url": "/news/Regulation-7-Semi-Annual-Reports-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Staffing Division Takes New Name to Reflect Broader Technical Capabilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/Staffing-Division-Takes-New-Name-to-Reflect-Broader-Technical-Capabilities",
    "url": "/news/Staffing-Division-Takes-New-Name-to-Reflect-Broader-Technical-Capabilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Opens Office in San Francisco Bay Area to Serve Northern California",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Opens-Office-in-San-Francisco-Bay-Area-to-Serve-Northern-California",
    "url": "/news/Trinity-Opens-Office-in-San-Francisco-Bay-Area-to-Serve-Northern-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Requirements for Triennial Emission Inventories",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Requirements-for-Triennial-Emission-Inventories",
    "url": "/news/New-Requirements-for-Triennial-Emission-Inventories",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Protecting \"Overburdened Communities\" Through Environmental Justice",
    "apiurl": "/restapi/customnewscontentlvl2/news/Protecting-Overburdened-Communities-Through-Environmental-Justice",
    "url": "/news/Protecting-Overburdened-Communities-Through-Environmental-Justice",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Utah AQB Hearing for PM2.5 Non-Attainment SIP Amendments-Utah",
    "apiurl": "/restapi/customnewscontentlvl2/news/Utah-AQB-Hearing-for-PM2-5-Non-Attainment-SIP-Amendments-Utah",
    "url": "/news/Utah-AQB-Hearing-for-PM2-5-Non-Attainment-SIP-Amendments-Utah",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Michigan's Plan for Compliance with the Clean Power Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/Michigan's-Plan-for-Compliance-with-the-Clean-Power-Plan",
    "url": "/news/Michigan's-Plan-for-Compliance-with-the-Clean-Power-Plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to Colorado’s Regulation 7 That You Don’t Want to Miss",
    "apiurl": "/restapi/customnewscontentlvl2/news/updates-to-colorado-s-regulation-7-that-you-don-t-want-to-miss",
    "url": "/news/updates-to-colorado-s-regulation-7-that-you-don-t-want-to-miss",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEQ Proposed Changes to Title 129 Made Final-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEQ-Proposed-Changes-to-Title-129-Made-Final-Nebraska",
    "url": "/news/NDEQ-Proposed-Changes-to-Title-129-Made-Final-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Overview of the TCEQ Stakeholder Meeting on Proposed Rulemaking Regarding Petroleum Storage Tanks-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Overview-of-the-TCEQ-Stakeholder-Meeting-on-Proposed-Rulemaking-Regarding-Petroleum-Storage-Tanks-Texas",
    "url": "/news/Overview-of-the-TCEQ-Stakeholder-Meeting-on-Proposed-Rulemaking-Regarding-Petroleum-Storage-Tanks-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GHG Reporting Applicability Screening Calculator",
    "apiurl": "/restapi/customnewscontentlvl2/news/GHG-Reporting-Applicability-Screening-Calculator",
    "url": "/news/GHG-Reporting-Applicability-Screening-Calculator",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TDEC Submits Official Redesignation Request to EPA for Knoxville Ozone Nonattainment Area",
    "apiurl": "/restapi/customnewscontentlvl2/news/TDEC-Submits-Official-Redesignation-Request-to-EPA-for-Knoxville-Ozone-Nonattainment-Area",
    "url": "/news/TDEC-Submits-Official-Redesignation-Request-to-EPA-for-Knoxville-Ozone-Nonattainment-Area",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "October Regulatory Summaries",
    "apiurl": "/restapi/customnewscontentlvl2/news/October-Regulatory-Summaries",
    "url": "/news/October-Regulatory-Summaries",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Breaking Down Ohio EPA Construction Allowances",
    "apiurl": "/restapi/customnewscontentlvl2/news/breaking-down-ohio-epa-construction-allowances",
    "url": "/news/breaking-down-ohio-epa-construction-allowances",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Electronic NPDES and Industrial Wastewater Pretreatment Permit Reporting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Electronic-NPDES-and-Industrial-Wastewater-Pretreatment-Permit-Reporting",
    "url": "/news/Electronic-NPDES-and-Industrial-Wastewater-Pretreatment-Permit-Reporting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reporting Deadline Extension",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reporting-",
    "url": "/news/Reporting-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Mark Your Calendars - AWMA Meeting Scheduled",
    "apiurl": "/restapi/customnewscontentlvl2/news/Mark-Your-Calendars---AWMA-Meeting-Scheduled",
    "url": "/news/Mark-Your-Calendars---AWMA-Meeting-Scheduled",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Changes to Emission Inventory Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/proposed-changes-to-emission-inventory-rule",
    "url": "/news/proposed-changes-to-emission-inventory-rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Online Access to Industrial Hygiene Analytical Services",
    "apiurl": "/restapi/customnewscontentlvl2/news/Online-Access-to-Industrial-Hygiene-Analytical-Services",
    "url": "/news/Online-Access-to-Industrial-Hygiene-Analytical-Services",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Adds Nonylphenol Category for TRI Reporting",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Adds-Nonylphenol-Category-for-TRI-Reporting",
    "url": "/news/EPA-Adds-Nonylphenol-Category-for-TRI-Reporting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA’s Enforcement Train: Now Arriving at MON Station",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-s-Enforcement-Train-Now-Arriving-at-MON-Station",
    "url": "/news/EPA-s-Enforcement-Train-Now-Arriving-at-MON-Station",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Efficiently Upgrading to the New ISO 9001:2015 Standard",
    "apiurl": "/restapi/customnewscontentlvl2/news/Efficiently-Upgrading-to-the-New-ISO-9001-2015-Standard",
    "url": "/news/Efficiently-Upgrading-to-the-New-ISO-9001-2015-Standard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Delaware Continues to Prepare Clean Power Plan Implementation",
    "apiurl": "/restapi/customnewscontentlvl2/news/Delaware-Continues-to-Prepare-Clean-Power-Plan-Implementation",
    "url": "/news/Delaware-Continues-to-Prepare-Clean-Power-Plan-Implementation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDE Finalizes Proposed Regulations for Reducing Hydrofluorocarbons",
    "apiurl": "/restapi/customnewscontentlvl2/news/mde-finalizes-proposed-regulations-for-reducing-hydrofluorocarbons",
    "url": "/news/mde-finalizes-proposed-regulations-for-reducing-hydrofluorocarbons",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Voluntary GHG Reporting via CDP",
    "apiurl": "/restapi/customnewscontentlvl2/news/Voluntary-GHG-Reporting-via-CDP",
    "url": "/news/Voluntary-GHG-Reporting-via-CDP",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Voluntary GHG Reporting via CDP",
    "apiurl": "/restapi/customnewscontentlvl2/news/Voluntary-GHG-Reporting-via-CDP",
    "url": "/news/federal/Voluntary-GHG-Reporting-via-CDP",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Washington Greenhouse Gas Reporting Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/Washington-Greenhouse-Gas-Reporting-Update",
    "url": "/news/Washington-Greenhouse-Gas-Reporting-Update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Opens New Maryland Office",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Opens-New-Maryland-Office",
    "url": "/news/Trinity-Consultants-Opens-New-Maryland-Office",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cross-State Air Pollution Rule (CSAPR)",
    "apiurl": "/restapi/customnewscontentlvl2/news/Cross-State-Air-Pollution-Rule-(CSAPR)",
    "url": "/news/Cross-State-Air-Pollution-Rule-(CSAPR)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NMED Satellite ABQ Office Relocated",
    "apiurl": "/restapi/customnewscontentlvl2/news/NMED-Satellite-ABQ-Office-Relocated",
    "url": "/news/NMED-Satellite-ABQ-Office-Relocated",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Initial Notification for Area Source RICE due August 31, 2010",
    "apiurl": "/restapi/customnewscontentlvl2/news/Initial-Notification-for-Area-Source-RICE-due-August-31-2010",
    "url": "/news/Initial-Notification-for-Area-Source-RICE-due-August-31-2010",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Clean Power Plan Finalized",
    "apiurl": "/restapi/customnewscontentlvl2/news/Clean-Power-Plan-Finalized",
    "url": "/news/Clean-Power-Plan-Finalized",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "USEPA Proposes Approval of SJVAPCD's Rule 4702",
    "apiurl": "/restapi/customnewscontentlvl2/news/USEPA-Proposes-Approval-of-SJVAPCD's-Rule-4702",
    "url": "/news/USEPA-Proposes-Approval-of-SJVAPCD's-Rule-4702",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Sac Metro AQ Management District Friant Ranch CEQA Guidance",
    "apiurl": "/restapi/customnewscontentlvl2/news/sacramento-metropolitan-aq-management-district-friant-ranch-ceqa-guidance",
    "url": "/news/sacramento-metropolitan-aq-management-district-friant-ranch-ceqa-guidance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Sac Metro AQ Management District Friant Ranch CEQA Guidance",
    "apiurl": "/restapi/customnewscontentlvl2/news/sacramento-metropolitan-aq-management-district-friant-ranch-ceqa-guidance",
    "url": "/www.trinityconsultants.com/news/sacramento-metropolitan-aq-management-district-friant-ranch-ceqa-guidance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MPCA Greenhouse Gas Reporting Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/MPCA-Greenhouse-Gas-Reporting-Updates",
    "url": "/news/MPCA-Greenhouse-Gas-Reporting-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Title V Permit Application Forms Revised to Accommodate New Application Fees",
    "apiurl": "/restapi/customnewscontentlvl2/news/Title-V-Permit-Application-Forms-Revised-to-Accommodate-New-Application-Fees",
    "url": "/news/Title-V-Permit-Application-Forms-Revised-to-Accommodate-New-Application-Fees",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Recent NC Modeling Developments",
    "apiurl": "/restapi/customnewscontentlvl2/news/Recent-NC-Modeling-Developments",
    "url": "/news/Recent-NC-Modeling-Developments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes Approving New York's SIP for PM2.5 NSR Requirements and Greenhouse Gases under PSD and Title V Programs",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-Approving-New-York's-SIP-for-PM2-5-NSR-Requirements-and-Greenhouse-Gases-under-PSD-and-Title-V-Programs",
    "url": "/news/EPA-Proposes-Approving-New-York's-SIP-for-PM2-5-NSR-Requirements-and-Greenhouse-Gases-under-PSD-and-Title-V-Programs",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reclassification on DFW and HGB to Serious Ozone Nonattainment: Permitting and RACT Implications-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reclassification-on-DFW-and-HGB-to-Serious-Ozone-Nonattainment-Permitting-and-RACT-Implications-Texas",
    "url": "/news/Reclassification-on-DFW-and-HGB-to-Serious-Ozone-Nonattainment-Permitting-and-RACT-Implications-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NW Complimentary Webinar: Overview of the Proposed Boiler MACT, Area Source Boiler GACT, and CISWI Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/NW-Complimentary-Webinar-Overview-of-the-Proposed-Boiler-MACT-Area-Source-Boiler-GACT-and-CISWI-Rules-",
    "url": "/news/NW-Complimentary-Webinar-Overview-of-the-Proposed-Boiler-MACT-Area-Source-Boiler-GACT-and-CISWI-Rules-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREAKING: TCEQ Adopts Rule to Allow for Commencement of Construction While a Permit Amendment Application is Pending",
    "apiurl": "/restapi/customnewscontentlvl2/news/breaking-tceq-adopts-rule-to-allow-for-commencement-of-construction-while-a-permit-amendment-application-is-pending",
    "url": "/news/breaking-tceq-adopts-rule-to-allow-for-commencement-of-construction-while-a-permit-amendment-application-is-pending",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREAKING: TCEQ Adopts Rule to Allow for Commencement of Construction While a Permit Amendment Application is Pending",
    "apiurl": "/restapi/customnewscontentlvl2/news/breaking-tceq-adopts-rule-to-allow-for-commencement-of-construction-while-a-permit-amendment-application-is-pending",
    "url": "/news/states/texas/breaking--tceq-adopts-rule-to-allow-for-commencement-of-construction-while-a-permit-amendment-application-is-pending",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes to FER/EIS Reports for RY 2011",
    "apiurl": "/restapi/customnewscontentlvl2/news/Changes-to-FER-EIS-Reports-for-RY-2011",
    "url": "/news/Changes-to-FER-EIS-Reports-for-RY-2011",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Pennsylvania proposes Revisions to Chapter 245 Storage Tank Rules-Pennsylvania",
    "apiurl": "/restapi/customnewscontentlvl2/news/Pennsylvania-proposes-Revisions-to-Chapter-245-Storage-Tank-Rules-Pennsylvania",
    "url": "/news/Pennsylvania-proposes-Revisions-to-Chapter-245-Storage-Tank-Rules-Pennsylvania",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Draft 2020 KS Ambient Air Monitoring Network Plan Published by KDHE",
    "apiurl": "/restapi/customnewscontentlvl2/news/draft-2020-ks-ambient-air-monitoring-network-plan-published-by-kdhe",
    "url": "/news/draft-2020-ks-ambient-air-monitoring-network-plan-published-by-kdhe",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The Tangled Web of LDAR Requirements for the Oil and Gas Industry",
    "apiurl": "/restapi/customnewscontentlvl2/news/the-tangled-web-of-ldar-requirements-for-the-oil-and-gas-industry",
    "url": "/news/the-tangled-web-of-ldar-requirements-for-the-oil-and-gas-industry",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The Tangled Web of LDAR Requirements for the Oil and Gas Industry",
    "apiurl": "/restapi/customnewscontentlvl2/news/the-tangled-web-of-ldar-requirements-for-the-oil-and-gas-industry",
    "url": "/News/Federal/The-Tangled-Web-of-LDAR-Requirements-for-the-Oil-and-Gas-Industry/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Training Offered for Condensate Tank System-Wide Control and Reporting Requirement",
    "apiurl": "/restapi/customnewscontentlvl2/news/Training-Offered-for-Condensate-Tank-System-Wide-Control-and-Reporting-Requirement",
    "url": "/news/Training-Offered-for-Condensate-Tank-System-Wide-Control-and-Reporting-Requirement",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Quality Regulations and Permitting in Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Regulations-and-Permitting-in-Wyoming",
    "url": "/news/Air-Quality-Regulations-and-Permitting-in-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Risk Management Plans - Are You Up to Date?",
    "apiurl": "/restapi/customnewscontentlvl2/news/risk-management-plans---are-you-up-to-date-",
    "url": "/news/risk-management-plans---are-you-up-to-date-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Risk Management Plans - Are You Up to Date?",
    "apiurl": "/restapi/customnewscontentlvl2/news/risk-management-plans---are-you-up-to-date-",
    "url": "/federal/risk-management-plans---are-you-up-to-date-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "What the 2015 MSGP expiration means for you and how to make sure you stay in compliance",
    "apiurl": "/restapi/customnewscontentlvl2/news/what-the-2015-msgp-expiration-means-for-you-and-how-to-make-sure-you-stay-in-compliance",
    "url": "/news/what-the-2015-msgp-expiration-means-for-you-and-how-to-make-sure-you-stay-in-compliance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEM Issues Two Air Reports in June 2014",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEM-Issues-Two-Air-Reports-in-June-2014",
    "url": "/news/ADEM-Issues-Two-Air-Reports-in-June-2014",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CARB Focuses on “Fleet Rules” and Enforcement",
    "apiurl": "/restapi/customnewscontentlvl2/news/carb-focuses-on-fleet-rules-and-enforcement",
    "url": "/news/carb-focuses-on-fleet-rules-and-enforcement",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CARB Focuses on “Fleet Rules” and Enforcement",
    "apiurl": "/restapi/customnewscontentlvl2/news/carb-focuses-on-fleet-rules-and-enforcement",
    "url": "/states/carb-focuses-on-fleet-rules-and-enforcement",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Issues Draft Guidance for 1-Hour NAAQS SIP Submissions",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Issues-Draft-Guidance-for-1-Hour-NAAQS-SIP-Submissions",
    "url": "/news/EPA-Issues-Draft-Guidance-for-1-Hour-NAAQS-SIP-Submissions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "WDNR is Not Planning to Implement State-Specific Regulations on GHG Emissions to Replace the Provisions that EPA is No Longer Allowed to Enforce",
    "apiurl": "/restapi/customnewscontentlvl2/news/WDNR-is-Not-Planning-to-Implement-State-Specific-Regulations-on-GHG-Emissions-to-Replace-the-Provisions-that-EPA-is-No-Longer-Allowed-to-Enforce-",
    "url": "/news/WDNR-is-Not-Planning-to-Implement-State-Specific-Regulations-on-GHG-Emissions-to-Replace-the-Provisions-that-EPA-is-No-Longer-Allowed-to-Enforce-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD Hosts Webinar on BACT Requirements for Large Standby Diesel Engines",
    "apiurl": "/restapi/customnewscontentlvl2/news/baaqmd-hosts-webinar-on-bact-requirements-for-large-standby-diesel-engines",
    "url": "/news/baaqmd-hosts-webinar-on-bact-requirements-for-large-standby-diesel-engines",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Washington 2013 GHG Reporting Deadline Extended",
    "apiurl": "/restapi/customnewscontentlvl2/news/Washington-2013-GHG-Reporting-Deadline-Extended",
    "url": "/news/Washington-2013-GHG-Reporting-Deadline-Extended",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BWON Annual Reports",
    "apiurl": "/restapi/customnewscontentlvl2/news/bwon-annual-reports",
    "url": "/news/bwon-annual-reports",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Recent Changes to NMED Flare Monitoring Protocol",
    "apiurl": "/restapi/customnewscontentlvl2/news/Recent-Changes-to-NMED-Flare-Monitoring-Protocol",
    "url": "/news/Recent-Changes-to-NMED-Flare-Monitoring-Protocol",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ODEQ Is Asking 12 Sources for Regional Haze Controls Analyses",
    "apiurl": "/restapi/customnewscontentlvl2/news/odeq-is-asking-12-sources-for-regional-haze-controls-analyses",
    "url": "/news/odeq-is-asking-12-sources-for-regional-haze-controls-analyses",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ODEQ Is Asking 12 Sources for Regional Haze Controls Analyses",
    "apiurl": "/restapi/customnewscontentlvl2/news/odeq-is-asking-12-sources-for-regional-haze-controls-analyses",
    "url": "/states/odeq-is-asking-12-sources-for-regional-haze-controls-analyses",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DENR Recommends PM2.5 Attainment Designation for Entire State of NC",
    "apiurl": "/restapi/customnewscontentlvl2/news/DENR-Recommends-PM2-5-Attainment-Designation-for-Entire-State-of-NC",
    "url": "/news/DENR-Recommends-PM2-5-Attainment-Designation-for-Entire-State-of-NC",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revision to Lower Sulfur Standard in Heating Oil from 500ppm to 15ppm is Now Final; Enforcement Suspended Until February 28, 2021",
    "apiurl": "/restapi/customnewscontentlvl2/news/revision-to-lower-sulfur-standard-in-heating-oil-from-500ppm-to-15ppm-is-now-final-enforcement-suspended-until-february-28-2021",
    "url": "/news/revision-to-lower-sulfur-standard-in-heating-oil-from-500ppm-to-15ppm-is-now-final-enforcement-suspended-until-february-28-2021",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revision to Lower Sulfur Standard in Heating Oil from 500ppm to 15ppm is Now Final; Enforcement Suspended Until February 28, 2021",
    "apiurl": "/restapi/customnewscontentlvl2/news/revision-to-lower-sulfur-standard-in-heating-oil-from-500ppm-to-15ppm-is-now-final-enforcement-suspended-until-february-28-2021",
    "url": "/news/state/pennsylvania/revision-to-lower-sulfur-standard-in-heating-oil-from-500ppm-to-15ppm-is-now-final-enforcement-suspended-until-february-28-2021",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Endangerment Finding Clears Path for GHG Regulation",
    "apiurl": "/restapi/customnewscontentlvl2/news/Endangerment-Finding-Clears-Path-for-GHG-Regulation",
    "url": "/news/Endangerment-Finding-Clears-Path-for-GHG-Regulation",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes to COGCC Rule 308A and Form 5 Guidance",
    "apiurl": "/restapi/customnewscontentlvl2/news/Changes-to-COGCC-Rule-308A-and-Form-5-Guidance",
    "url": "/news/Changes-to-COGCC-Rule-308A-and-Form-5-Guidance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Mandatory Reporting Requirement (MRR) Updates-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/Mandatory-Reporting-Requirement-(MRR)-Updates-California",
    "url": "/news/Mandatory-Reporting-Requirement-(MRR)-Updates-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "May 17 IDNR Client Contact Meeting Notes",
    "apiurl": "/restapi/customnewscontentlvl2/news/May-17-IDNR-Client-Contact-Meeting-Notes",
    "url": "/news/May-17-IDNR-Client-Contact-Meeting-Notes",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Revises Non-Criteria Pollutant Control Strategy",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ-Revises-Non-Criteria-Pollutant-Control-Strategy",
    "url": "/news/ADEQ-Revises-Non-Criteria-Pollutant-Control-Strategy",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revisions to the PSD and Title V GHG Permitting Regulations and Establishment of a SER for GHG Emissions under the PSD Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revisions-to-the-PSD-and-Title-V-GHG-Permitting-Regulations-and-Establishment-of-a-SER-for-GHG-Emissions-under-the-PSD-Program",
    "url": "/news/Revisions-to-the-PSD-and-Title-V-GHG-Permitting-Regulations-and-Establishment-of-a-SER-for-GHG-Emissions-under-the-PSD-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ's Changing Leadership-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/TCEQ's-Changing-Leadership-Texas",
    "url": "/news/TCEQ's-Changing-Leadership-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Releases Revised Non-Criteria Pollutant Control Strategy",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ-Releases-Revised-Non-Criteria-Pollutant-Control-Strategy",
    "url": "/news/ADEQ-Releases-Revised-Non-Criteria-Pollutant-Control-Strategy",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Issuance of Renewed Stormwater Permit: 2016 TPDES Multi-Sector General Permit",
    "apiurl": "/restapi/customnewscontentlvl2/news/Issuance-of-Renewed-Stormwater-Permit-2016-TPDES-Multi-Sector-General-Permit",
    "url": "/news/Issuance-of-Renewed-Stormwater-Permit-2016-TPDES-Multi-Sector-General-Permit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TSCA Reset Active/Inactive Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/TSCA-Reset-Active-Inactive-Rule",
    "url": "/news/TSCA-Reset-Active-Inactive-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Illinois Vehicle Inspection & Maintenance Program Revision",
    "apiurl": "/restapi/customnewscontentlvl2/news/Illinois-Vehicle-Inspection-Maintenance-Program-Revision",
    "url": "/news/Illinois-Vehicle-Inspection-Maintenance-Program-Revision",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Finalized Architectural and Industrial Maintenance Coating Standards Under COMAR 26.11.39",
    "apiurl": "/restapi/customnewscontentlvl2/news/Finalized-Architectural-and-Industrial-Maintenance-Coating-Standards-Under-COMAR-26-11-39",
    "url": "/news/Finalized-Architectural-and-Industrial-Maintenance-Coating-Standards-Under-COMAR-26-11-39",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Strategic Partnership with Aires Servicos Ambientais Further Expands BREEZE Software and Services in Brazil",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Strategic-Partnership-with-Aires-Servicos-Ambientais-Further-Expands-BREEZE-Software-and-Services-in-Brazil",
    "url": "/news/New-Strategic-Partnership-with-Aires-Servicos-Ambientais-Further-Expands-BREEZE-Software-and-Services-in-Brazil",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "An Update on Semi-Annual Monitoring Reporting for Recently Renewed CAAPP Permits",
    "apiurl": "/restapi/customnewscontentlvl2/news/An-Update-on-Semi-Annual-Monitoring-Reporting-for-Recently-Renewed-CAAPP-Permits",
    "url": "/news/An-Update-on-Semi-Annual-Monitoring-Reporting-for-Recently-Renewed-CAAPP-Permits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Requirements Under Chapter 117",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Requirements-Under-Chapter-117",
    "url": "/news/New-Requirements-Under-Chapter-117",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Regulatory Services to Support CLP Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Regulatory-Services-to-Support-CLP-Regulations-",
    "url": "/news/Regulatory-Services-to-Support-CLP-Regulations-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "California Air Resources Board’s (ARB’s) New Compliance Offset Protocol for Mine Methane Capture Projects",
    "apiurl": "/restapi/customnewscontentlvl2/news/California-Air-Resources-Board-s-(ARB-s)-New-Compliance-Offset-Protocol-for-Mine-Methane-Capture-Projects-",
    "url": "/news/California-Air-Resources-Board-s-(ARB-s)-New-Compliance-Offset-Protocol-for-Mine-Methane-Capture-Projects-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NMED Announces Minor Source Emissions Inventory for 2020-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/NMED-Announces-Minor-Source-Emissions-Inventory-for-2020-New-Mexico",
    "url": "/news/NMED-Announces-Minor-Source-Emissions-Inventory-for-2020-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Promulgates PSD/Title V GHG Tailoring Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Promulgates-PSD-Title-V-GHG-Tailoring-Rule",
    "url": "/news/EPA-Promulgates-PSD-Title-V-GHG-Tailoring-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA's Guidance Document on Modeling SO2 Emissions and Implications for Kentucky",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA's-Guid",
    "url": "/news/EPA's-Guid",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Ozone Nonattainment Designations in Tennessee",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Ozone-Nonattainment-Designations-in-Tennessee",
    "url": "/news/Proposed-Ozone-Nonattainment-Designations-in-Tennessee",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "OK Conservation Commission to Certify Carbon Sequestration",
    "apiurl": "/restapi/customnewscontentlvl2/news/OK-Conservation-Commission-to-Certify-Carbon-Sequestration",
    "url": "/news/OK-Conservation-Commission-to-Certify-Carbon-Sequestration",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Compliance Regulations for Trucks and Buses in California",
    "apiurl": "/restapi/customnewscontentlvl2/news/Compliance-Regulations-for-Trucks-and-Buses-in-California-",
    "url": "/news/Compliance-Regulations-for-Trucks-and-Buses-in-California-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Pollution Fee Structure Update-Missouri",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Pollution-Fee-Structure-Update-Missouri",
    "url": "/news/Air-Pollution-Fee-Structure-Update-Missouri",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "RIDEM Draft 2020 Air Monitoring Network Plan and 2020 Five-Year Network Assessment",
    "apiurl": "/restapi/customnewscontentlvl2/news/ridem-draft-2020-air-monitoring-network-plan-and-2020-five-year-network-assessment",
    "url": "/news/ridem-draft-2020-air-monitoring-network-plan-and-2020-five-year-network-assessment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Best of 2020: News & Publications",
    "apiurl": "/restapi/customnewscontentlvl2/news/best-of-2020-news-publications",
    "url": "/news/best-of-2020-news-publications",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SJVAPCD PASPort – Facility Information Portal Update-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/SJVAPCD-PASPort-Facility-Information-Portal-Update-California",
    "url": "/news/SJVAPCD-PASPort-Facility-Information-Portal-Update-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes to Strengthen the Ozone NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-to-Strengthen-the-Ozone-NAAQS",
    "url": "/news/EPA-Proposes-to-Strengthen-the-Ozone-NAAQS",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Are You Ready for the New Refrigerant Management Requirements?-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Are-You-Ready-for-the-New-Refrigerant-Management-Requirements--Texas",
    "url": "/news/Are-You-Ready-for-the-New-Refrigerant-Management-Requirements--Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CEC Renewable Fuels Program Awards",
    "apiurl": "/restapi/customnewscontentlvl2/news/CEC-Renewable-Fuels-Program-Awards",
    "url": "/news/CEC-Renewable-Fuels-Program-Awards",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "North Dakota Department of Health Releases Bakken VOC Consent Decree",
    "apiurl": "/restapi/customnewscontentlvl2/news/North-Dakota-Department-of-Health-Releases-Bakken-VOC-Consent-Decree",
    "url": "/news/North-Dakota-Department-of-Health-Releases-Bakken-VOC-Consent-Decree",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Publishes PFAS Air Testing Method OTM-45",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-publishes-pfas-air-testing-method-otm-45",
    "url": "/news/epa-publishes-pfas-air-testing-method-otm-45",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Permit-by-Rule for Combined Heat-and-Power Systems",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-P",
    "url": "/news/Proposed-P",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Consultant Spotlight: Don Cordell",
    "apiurl": "/restapi/customnewscontentlvl2/news/Consultant-Spotlight-Don-Cordell",
    "url": "/news/Consultant-Spotlight-Don-Cordell",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New NPDES Industrial Storm Water General Permit",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-NPDES-Industrial-Storm-Water-General-Permit",
    "url": "/news/New-NPDES-Industrial-Storm-Water-General-Permit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Minnesota's Attainment Everywhere Status in Jeopardy?",
    "apiurl": "/restapi/customnewscontentlvl2/news/Minnesota's-Attainment-Everywhere-Status-in-Jeopardy-",
    "url": "/news/Minnesota's-Attainment-Everywhere-Status-in-Jeopardy-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Regulatory Change Under a Re-Invented TSCA",
    "apiurl": "/restapi/customnewscontentlvl2/news/regulatory-change-under-a-re-invented-tsca",
    "url": "/news/regulatory-change-under-a-re-invented-tsca",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Regulatory Change Under a Re-Invented TSCA",
    "apiurl": "/restapi/customnewscontentlvl2/news/regulatory-change-under-a-re-invented-tsca",
    "url": "/news/federal/regulatory-change-under-a-re-invented-tsca",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CDPHE Revamping Emission Reduction Credits Program-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/CDPHE-Revamping-Emission-Reduction-Credits-Program-Colorado",
    "url": "/news/CDPHE-Revamping-Emission-Reduction-Credits-Program-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Illinois Adopts Federal Hazardous Waste Generator Improvements Rule-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Illinois-Adopts-Federal-Hazardous-Waste-Generator-Improvements-Rule-Illinois",
    "url": "/news/Illinois-Adopts-Federal-Hazardous-Waste-Generator-Improvements-Rule-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New NJDEP Compliance Advisory - NOx RACT Boiler and Indirect Heat Exchanger Emission Limits",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-NJDEP-Compliance-Advisory---NOx-RACT-Boiler-and-Indirect-Heat-Exchanger-Emission-Limits-",
    "url": "/news/New-NJDEP-Compliance-Advisory---NOx-RACT-Boiler-and-Indirect-Heat-Exchanger-Emission-Limits-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Department of Environmental Quality Proposes Revision to SIP for PM2.5 NAAQS-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Department-of-Environmental-Quality-Proposes-Revision-to-SIP-for-PM2-5-NAAQS-Virginia",
    "url": "/news/Department-of-Environmental-Quality-Proposes-Revision-to-SIP-for-PM2-5-NAAQS-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Wisconsin Air Permitting Case Decided",
    "apiurl": "/restapi/customnewscontentlvl2/news/Wisconsin-Air-Permitting-Case-Decided",
    "url": "/news/Wisconsin-Air-Permitting-Case-Decided",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "John Farris and Robert Sussman Quoted in Pharmaceutical Technology Article on High Potency Manufacturing",
    "apiurl": "/restapi/customnewscontentlvl2/news/John-Farris-and-Robert-Sussman-Quoted-in-Pharmaceutical-Technology-Article-on-High-Potency-Manufacturing",
    "url": "/news/John-Farris-and-Robert-Sussman-Quoted-in-Pharmaceutical-Technology-Article-on-High-Potency-Manufacturing",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on PM2.5 NAAQS in Illinois - March 2019-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-PM2-5-NAAQS-in-Illinois---March-2019-Illinois",
    "url": "/news/Update-on-PM2-5-NAAQS-in-Illinois---March-2019-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Accelerate Dispersion Model Runtimes with BREEZE AERMOD Parallel",
    "apiurl": "/restapi/customnewscontentlvl2/news/Accelerate-Dispersion-Model-Runtimes-with-BREEZE-AERMOD-Parallel",
    "url": "/news/Accelerate-Dispersion-Model-Runtimes-with-BREEZE-AERMOD-Parallel",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MassDEP Proposes Ban on Clean Gypsum Wallboard Disposal",
    "apiurl": "/restapi/customnewscontentlvl2/news/MassDEP-Proposes-Ban-on-Clean-Gypsum-Wallboard-Disposal",
    "url": "/news/MassDEP-Proposes-Ban-on-Clean-Gypsum-Wallboard-Disposal",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Ecology Proposes Updates to Toxic Air Pollutant Rule-Washington",
    "apiurl": "/restapi/customnewscontentlvl2/news/Ecology-Proposes-Updates-to-Toxic-Air-Pollutant-Rule-Washington",
    "url": "/news/Ecology-Proposes-Updates-to-Toxic-Air-Pollutant-Rule-Washington",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Veteran Auditor Deepens Trinity’s EHS Performance and Risk Management Capabilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/Veteran-Auditor-Deepens-Trinity-s-EHS-Performance-and-Risk-Management-Capabilities",
    "url": "/news/Veteran-Auditor-Deepens-Trinity-s-EHS-Performance-and-Risk-Management-Capabilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to Administrative Rules of South Dakota Article 74:36",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-to-Administrative-Rules-of-South-Dakota-Article-74-36",
    "url": "/news/Updates-to-Administrative-Rules-of-South-Dakota-Article-74-36",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Connecticut Enacts Two Major Climate Change Laws-Connecticut",
    "apiurl": "/restapi/customnewscontentlvl2/news/Connecticut-Enacts-Two-Major-Climate-Change-Laws-Connecticut",
    "url": "/news/Connecticut-Enacts-Two-Major-Climate-Change-Laws-Connecticut",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Issues Endangerment Finding for CO2",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Issues-Endangerment-Finding-for-CO2",
    "url": "/news/EPA-Issues-Endangerment-Finding-for-CO2",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GHG Reporting Using eGGRT",
    "apiurl": "/restapi/customnewscontentlvl2/news/GHG-Reporting-Using-eGGRT",
    "url": "/news/GHG-Reporting-Using-eGGRT",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New York State DEC Proposes Updates to Requirements for Federally Enforceable Permit Conditions",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-York-State-DEC-Proposes-Updates-to-Requirements-for-Federally-Enforceable-Permit-Conditions",
    "url": "/news/New-York-State-DEC-Proposes-Updates-to-Requirements-for-Federally-Enforceable-Permit-Conditions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SafeBridge Consultants, Inc. Announces Improved Sensitivity for Naproxen Sodium Air Samples",
    "apiurl": "/restapi/customnewscontentlvl2/news/SafeBridge-Consultants-Inc-Announces-Improved-Sensitivity-for-Naproxen-Sodium-Air-Samples",
    "url": "/news/SafeBridge-Consultants-Inc-Announces-Improved-Sensitivity-for-Naproxen-Sodium-Air-Samples",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LDEQ Finalizes Revisions to Closure Requirements for Surface Impoundments-Louisiana",
    "apiurl": "/restapi/customnewscontentlvl2/news/LDEQ-Finalizes-Revisions-to-Closure-Requirements-for-Surface-Impoundments-Louisiana",
    "url": "/news/LDEQ-Finalizes-Revisions-to-Closure-Requirements-for-Surface-Impoundments-Louisiana",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Region 5 - Regional Administrator Named-Wisconsin",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Region-5---Regional-Administrator-Named-Wisconsin",
    "url": "/news/EPA-Region-5---Regional-Administrator-Named-Wisconsin",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New York City DEP Implements Smoke Testing or Stack Testing Requirements for Generators",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-York-City-DEP-Implements-Smoke-Testing-or-Stack-Testing-Requirements-for-Generators",
    "url": "/news/New-York-City-DEP-Implements-Smoke-Testing-or-Stack-Testing-Requirements-for-Generators",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MassDEP Proposes Amendments to Improve Greenhouse Gas Reporting Efficiency",
    "apiurl": "/restapi/customnewscontentlvl2/news/MassDEP-Proposes-Amendments-to-Improve-Greenhouse-Gas-Reporting-Efficiency",
    "url": "/news/MassDEP-Proposes-Amendments-to-Improve-Greenhouse-Gas-Reporting-Efficiency",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DOEE Proposes New Source Category Permits for Diesel-Fired and Natural Gas-Fired Emergency Engines",
    "apiurl": "/restapi/customnewscontentlvl2/news/DOEE-Proposes-New-Source-Category-Permits-for-Diesel-Fired-and-Natural-Gas-Fired-Emergency-Engines",
    "url": "/news/DOEE-Proposes-New-Source-Category-Permits-for-Diesel-Fired-and-Natural-Gas-Fired-Emergency-Engines",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New 1-Hour NO2 and SO2 Modeling Requirements for New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-1-Hour-NO2-and-SO2-Modeling-Requirements-for-New-Mexico",
    "url": "/news/New-1-Hour-NO2-and-SO2-Modeling-Requirements-for-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Revises Air Quality Designations for PM2.5 in Kentucky",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Revises-Air-Quality-Designations-for-PM2-5-in-Kentucky",
    "url": "/news/EPA-Revises-Air-Quality-Designations-for-PM2-5-in-Kentucky",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Utah's Regional Haze SIP in Public Comment",
    "apiurl": "/restapi/customnewscontentlvl2/news/Utah's-Regional-Haze-SIP-in-Public-Comment",
    "url": "/news/Utah's-Regional-Haze-SIP-in-Public-Comment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Redesignation of Milwaukee-Racine Nonattainment Area",
    "apiurl": "/restapi/customnewscontentlvl2/news/Redesignation-of-Milwaukee-Racine-Nonattainment-Area",
    "url": "/news/Redesignation-of-Milwaukee-Racine-Nonattainment-Area",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Tip of the Month - Wastewater Discharges-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/Tip-of-the-Month---Wastewater-Discharges-Nebraska",
    "url": "/news/Tip-of-the-Month---Wastewater-Discharges-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Launches Stormwater Permitting in myDEQ",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ-Launches-Stormwater-Permitting-in-myDEQ",
    "url": "/news/ADEQ-Launches-Stormwater-Permitting-in-myDEQ",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Attainment/Unclassifiable Designations for the 2015 Ozone National Ambient Air Quality Standards (NAAQS) Are Now Final!",
    "apiurl": "/restapi/customnewscontentlvl2/news/Attainment-Unclassifiable-Designations-for-the-2015-Ozone-National-Ambient-Air-Quality-Standards-(NAAQS)-Are-Now-Final!",
    "url": "/news/Attainment-Unclassifiable-Designations-for-the-2015-Ozone-National-Ambient-Air-Quality-Standards-(NAAQS)-Are-Now-Final!",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "District Department of the Environment (DDOE) Proposes Further Reduction of Volatile Organic Compounds and Hazardous Air Pollutant Emissions",
    "apiurl": "/restapi/customnewscontentlvl2/news/District-Department-of-the-Environment-(DDOE)-Proposes-Further-Reduction-of-Volatile-Organic-Compounds-and-Hazardous-Air-Pollutant-Emissions",
    "url": "/news/District-Department-of-the-Environment-(DDOE)-Proposes-Further-Reduction-of-Volatile-Organic-Compounds-and-Hazardous-Air-Pollutant-Emissions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Annual Toxic Release Inventory (TRI) Reports due July 1st-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Annual-Toxic-Release-Inventory-(TRI)-Reports-due-July-1st-Kansas",
    "url": "/news/Annual-Toxic-Release-Inventory-(TRI)-Reports-due-July-1st-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Information Collection Request for Pulp and Paper Sector NSPS and NESHAP - Residual Risk and Technology Review (RTR)",
    "apiurl": "/restapi/customnewscontentlvl2/news/Information-Collection-Request-for-Pulp-and-Paper-Sector-NSPS-and-NESHAP---Residual-Risk-and-Technology-Review-(RTR)",
    "url": "/news/Information-Collection-Request-for-Pulp-and-Paper-Sector-NSPS-and-NESHAP---Residual-Risk-and-Technology-Review-(RTR)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Joins Indiana Partners for Pollution Prevention",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Joins-Indiana-Partners-for-Pollution-Prevention",
    "url": "/news/Trinity-Joins-Indiana-Partners-for-Pollution-Prevention",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Nevada DEP Proposes Significant Fee Schedule Changes for 2020-Nevada",
    "apiurl": "/restapi/customnewscontentlvl2/news/Nevada-DEP-Proposes-Significant-Fee-Schedule-Changes-for-2020-Nevada",
    "url": "/news/Nevada-DEP-Proposes-Significant-Fee-Schedule-Changes-for-2020-Nevada",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DNREC Asks for Public Input on Coastal Zone Conversion Permit Act-Delaware",
    "apiurl": "/restapi/customnewscontentlvl2/news/DNREC-Asks-for-Public-Input-on-Coastal-Zone-Conversion-Permit-Act-Delaware",
    "url": "/news/DNREC-Asks-for-Public-Input-on-Coastal-Zone-Conversion-Permit-Act-Delaware",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "City of Sheridan Redesignated Attainment for Particulate-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/City-of-Sheridan-Redesignated-Attainment-for-Particulate-Wyoming",
    "url": "/news/City-of-Sheridan-Redesignated-Attainment-for-Particulate-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Toxic Release Inventory",
    "apiurl": "/restapi/customnewscontentlvl2/news/Toxic-Release-Inventory",
    "url": "/news/Toxic-Release-Inventory",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates from TCEQ San Patricio County Public Forum-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-from-TCEQ-San-Patricio-County-Public-Forum-Texas",
    "url": "/news/Updates-from-TCEQ-San-Patricio-County-Public-Forum-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Delegated Authority To Implement Some Part 63 MACT Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ-Delegated-Authority-To-Implement-Some-Part-63-MACT-Regulations",
    "url": "/news/ADEQ-Delegated-Authority-To-Implement-Some-Part-63-MACT-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments to Env-A 1700 Permit Application Forms-New Hampshire",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendments-to-Env-A-1700-Permit-Application-Forms-New-Hampshire",
    "url": "/news/Proposed-Amendments-to-Env-A-1700-Permit-Application-Forms-New-Hampshire",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes Updates to CISWI Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-Updates-to-CISWI-Rules",
    "url": "/news/EPA-Proposes-Updates-to-CISWI-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CARB Air Toxics Hot Spots EI Criteria Guideline Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/carb-air-toxics-hot-spots-ei-criteria-guideline-amendments",
    "url": "/news/carb-air-toxics-hot-spots-ei-criteria-guideline-amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "The ISO Standards, They Are a Changin’",
    "apiurl": "/restapi/customnewscontentlvl2/news/The-ISO-Standards-They-Are-a-Changin-",
    "url": "/news/The-ISO-Standards-They-Are-a-Changin-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Rulemaking Hearing to Address Reasonably Available Control Technology-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Rulemaking-Hearing-to-Address-Reasonably-Available-Control-Technology-Colorado",
    "url": "/news/Rulemaking-Hearing-to-Address-Reasonably-Available-Control-Technology-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Four-Factor Source Analysis: Guidance on Regional Haze SIPs for the Second Implementation Period",
    "apiurl": "/restapi/customnewscontentlvl2/news/four-factor-source-analysis-guidance-on-regional-haze-sips-for-the-second-implementation-period",
    "url": "/news/four-factor-source-analysis-guidance-on-regional-haze-sips-for-the-second-implementation-period",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Four-Factor Source Analysis: Guidance on Regional Haze SIPs for the Second Implementation Period",
    "apiurl": "/restapi/customnewscontentlvl2/news/four-factor-source-analysis-guidance-on-regional-haze-sips-for-the-second-implementation-period",
    "url": "/news/four-factor-source-analysis--guidance-on-regional-haze-sips-for-the-second-implementation-period",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Permitting Challenges for Spray Coating Operations in Idaho",
    "apiurl": "/restapi/customnewscontentlvl2/news/Permitting-Challenges-for-Spray-Coating-Operations-in-Idaho",
    "url": "/news/Permitting-Challenges-for-Spray-Coating-Operations-in-Idaho",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Prevention of Significant Deterioration Program Delegation to MassDEP",
    "apiurl": "/restapi/customnewscontentlvl2/news/Prevention-of-Significant-Deterioration-Program-Delegation-to-MassDEP",
    "url": "/news/Prevention-of-Significant-Deterioration-Program-Delegation-to-MassDEP",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Changes to WAQSR, Chapter 8, Nonattainment Area Regulations Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Changes-to-WAQSR-Chapter-8-Nonattainment-Area-Regulations-Meeting",
    "url": "/news/Proposed-Changes-to-WAQSR-Chapter-8-Nonattainment-Area-Regulations-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Issues Final Decision to Deny OTR Expansion Petition-Vermont",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Issues-Final-Decision-to-Deny-OTR-Expansion-Petition-Vermont",
    "url": "/news/EPA-Issues-Final-Decision-to-Deny-OTR-Expansion-Petition-Vermont",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LDEQ Finalizes AQ388",
    "apiurl": "/restapi/customnewscontentlvl2/news/ldeq-finalizes-aq388",
    "url": "/news/ldeq-finalizes-aq388",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "WDNR Publishes Revised Approach to Dispersion Modeling for Permits",
    "apiurl": "/restapi/customnewscontentlvl2/news/WDNR-Publishes-Revised-Approach-to-Dispersion-Modeling-for-Permits",
    "url": "/news/WDNR-Publishes-Revised-Approach-to-Dispersion-Modeling-for-Permits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Issues SIP Approval of PSD Regulation for SJVAPCD",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Issues-SIP-Approval-of-PSD-Regulation-for-SJVAPCD-",
    "url": "/news/EPA-Issues-SIP-Approval-of-PSD-Regulation-for-SJVAPCD-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "AWMA Meeting - February 11, 2014",
    "apiurl": "/restapi/customnewscontentlvl2/news/AWMA-Meeting---February-11-2014",
    "url": "/news/AWMA-Meeting---February-11-2014",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Defers Certain GHG Reporting Elements",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Defers-Certain-GHG-Reporting-Elements",
    "url": "/news/EPA-Defers-Certain-GHG-Reporting-Elements",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Region 5 - Regional Administrator Named",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Region-5---Regional-Administrator-Named",
    "url": "/news/EPA-Region-5---Regional-Administrator-Named",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "More Digital Updates to Air Quality Bureau Compliance Reporting Increases Efficiency-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/More-Digital-Updates-to-Air-Quality-Bureau-Compliance-Reporting-Increases-Efficiency-New-Mexico",
    "url": "/news/More-Digital-Updates-to-Air-Quality-Bureau-Compliance-Reporting-Increases-Efficiency-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDNR Environmental Emergency Reporting Hotline Number Change",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDNR-Environmental-Emergency-Reporting-Hotline-Number-Change",
    "url": "/news/IDNR-Environmental-Emergency-Reporting-Hotline-Number-Change",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Meeting Stringent SO2 and NO2 NAAQS - Practical Measures to Achieve Compliance with the 1-Hour Averaging Period",
    "apiurl": "/restapi/customnewscontentlvl2/news/Meeting-Stringent-SO2-and-NO2-NAAQS---Practical-Measures-to-Achieve-Compliance-with-the-1-Hour-Averaging-Period",
    "url": "/news/Meeting-Stringent-SO2-and-NO2-NAAQS---Practical-Measures-to-Achieve-Compliance-with-the-1-Hour-Averaging-Period",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Workshop on the Impact of REACH and CLP Regulations on Companies Exporting Chemicals to the EU presented in Partnership with H2 Compliance on December 7, 2010 in New Brunswick, NJ",
    "apiurl": "/restapi/customnewscontentlvl2/news/Workshop-on-the-Impact-of-REACH-and-CLP-Regulations-on-Companies-Exporting-Chemicals-to-the-EU-presented-in-Partnership-with-H2-Compliance-on-December-7-2010-in-New-Brunswick-NJ",
    "url": "/news/Workshop-on-the-Impact-of-REACH-and-CLP-Regulations-on-Companies-Exporting-Chemicals-to-the-EU-presented-in-Partnership-with-H2-Compliance-on-December-7-2010-in-New-Brunswick-NJ",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "LMAPCD's Ozone Monitoring Data is Questionable",
    "apiurl": "/restapi/customnewscontentlvl2/news/LMAPCD's-O",
    "url": "/news/LMAPCD's-O",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oil & Gas Area Emissions",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oil-Gas-Area-Emissions",
    "url": "/news/Oil-Gas-Area-Emissions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Iowa's 2014 Air Monitoring Network Plan Available for Public Review and Comment",
    "apiurl": "/restapi/customnewscontentlvl2/news/Iowa's-2014-Air-Monitoring-Network-Plan-Available-for-Public-Review-and-Comment",
    "url": "/news/Iowa's-2014-Air-Monitoring-Network-Plan-Available-for-Public-Review-and-Comment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Natural Gas Operations to Submit Air Emissions Data for 2011 to PADEP",
    "apiurl": "/restapi/customnewscontentlvl2/news/Natural-Gas-Operations-to-Submit-Air-Emissions-Data-for-2011-to-PADEP",
    "url": "/news/Natural-Gas-Operations-to-Submit-Air-Emissions-Data-for-2011-to-PADEP",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Clark County DAQ to Implement Adjusted Fee Schedules-Nevada",
    "apiurl": "/restapi/customnewscontentlvl2/news/Clark-County-DAQ-to-Implement-Adjusted-Fee-Schedules-Nevada",
    "url": "/news/Clark-County-DAQ-to-Implement-Adjusted-Fee-Schedules-Nevada",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Knox County Air Pollution Control Board Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Knox-County-Air-Pollution-Control-Board-Meeting",
    "url": "/news/Knox-County-Air-Pollution-Control-Board-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Refrigerant Chronic Leaker Reports Due Mar 1",
    "apiurl": "/restapi/customnewscontentlvl2/news/refrigerant-chronic-leaker-reports-due-mar-1",
    "url": "/news/refrigerant-chronic-leaker-reports-due-mar-1",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Hires Experienced Consultant and FERC Certification Expert",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Hires-Experienced-Consultant-and-FERC-Certification-Expert",
    "url": "/news/Trinity-Consultants-Hires-Experienced-Consultant-and-FERC-Certification-Expert",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE Releases AERMOD 7.5 to Include Latest  U.S. EPA Executable 12060",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-Releases-AERMOD-7-5-to-Include-Latest-U-S-EPA-Executable-12060-",
    "url": "/news/BREEZE-Releases-AERMOD-7-5-to-Include-Latest-U-S-EPA-Executable-12060-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE Remote Modeling System - AERMOD Runtimes Up To 100 Times Faster!",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-Remote-Modeling-System---AERMOD-Runtimes-Up-To-100-Times-Faster!",
    "url": "/news/BREEZE-Remote-Modeling-System---AERMOD-Runtimes-Up-To-100-Times-Faster!",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reminder:  Certification Deadline for Industrial Solvent Cleaning Operations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reminder-Certification-Deadline-for-Industrial-Solvent-Cleaning-Operations",
    "url": "/news/Reminder-Certification-Deadline-for-Industrial-Solvent-Cleaning-Operations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Permitting & Regulatory Updates for New Jersey",
    "apiurl": "/restapi/customnewscontentlvl2/news/air-permitting-regulatory-updates-for-new-jersey",
    "url": "/news/air-permitting-regulatory-updates-for-new-jersey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Permitting & Regulatory Updates for New Jersey",
    "apiurl": "/restapi/customnewscontentlvl2/news/air-permitting-regulatory-updates-for-new-jersey",
    "url": "/states/new-jersey/air-permitting-and-regulatory-updates-for-new-jersey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Exemption Revoked, New General Construction Permit for Routine O&G Venting Emissions",
    "apiurl": "/restapi/customnewscontentlvl2/news/exemption-revoked-new-general-construction-permit-for-routine-o-g-venting-emissions",
    "url": "/news/exemption-revoked-new-general-construction-permit-for-routine-o-g-venting-emissions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Exemption Revoked, New General Construction Permit for Routine O&G Venting Emissions",
    "apiurl": "/restapi/customnewscontentlvl2/news/exemption-revoked-new-general-construction-permit-for-routine-o-g-venting-emissions",
    "url": "/news/state/colorado/exemption-revoked-new-general-construction-permit-for-routine-o-g-venting-emissions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NYSDEC Proposes DAR-21: Economic and Technical Analysis for Variances pursuant to Subdivision 222.5(a) of Part 222",
    "apiurl": "/restapi/customnewscontentlvl2/news/NYSDEC-Proposes-DAR-21-Economic-and-Technical-Analysis-for-Variances-pursuant-to-Subdivision-222-5(a)-of-Part-222",
    "url": "/news/NYSDEC-Proposes-DAR-21-Economic-and-Technical-Analysis-for-Variances-pursuant-to-Subdivision-222-5(a)-of-Part-222",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Federal Court Vacates GHG Permitting Deferral for Biogenic Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/Federal-Court-Vacates-GHG-Permitting-Deferral-for-Biogenic-Sources",
    "url": "/news/Federal-Court-Vacates-GHG-Permitting-Deferral-for-Biogenic-Sources",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Fee Amendments to Permitting Rules on Public Notice",
    "apiurl": "/restapi/customnewscontentlvl2/news/Fee-Amendments-to-Permitting-Rules-on-Public-Notice",
    "url": "/news/Fee-Amendments-to-Permitting-Rules-on-Public-Notice",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Quality Fees Adopted by the Environmental Protection Commission",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Fees-Adopted-by-the-Environmental-Protection-Commission",
    "url": "/news/Air-Quality-Fees-Adopted-by-the-Environmental-Protection-Commission",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DOEE Finalizes Updates to RACT Regulations-Washington, DC",
    "apiurl": "/restapi/customnewscontentlvl2/news/DOEE-Finalizes-Updates-to-RACT-Regulations-Washington-DC",
    "url": "/news/DOEE-Finalizes-Updates-to-RACT-Regulations-Washington-DC",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reporting Reminders",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reporting-Reminders",
    "url": "/news/Reporting-Reminders",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Hazardous Air Pollutant Rules Facing Area Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Hazard",
    "url": "/news/New-Hazard",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Federal Appeals Court Affirms Dismissal of Alaska Village’s Climate Change Nuisance Claim Against Multiple Oil and Energy Companies",
    "apiurl": "/restapi/customnewscontentlvl2/news/Federal-Appeals-Court-Affirms-Dismissal-of-Alaska-Village-s-Climate-Change-Nuisance-Claim-Against-Multiple-Oil-and-Energy-Companies",
    "url": "/news/Federal-Appeals-Court-Affirms-Dismissal-of-Alaska-Village-s-Climate-Change-Nuisance-Claim-Against-Multiple-Oil-and-Energy-Companies",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Permitting Requirements for Sources in Indian Country",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Permitting-Requirements-for-Sources-in-Indian-Country",
    "url": "/news/New-Permitting-Requirements-for-Sources-in-Indian-Country",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MACT Startup, Shutdown, and Malfunction Exemption Court Decision",
    "apiurl": "/restapi/customnewscontentlvl2/news/MACT-Start",
    "url": "/news/MACT-Start",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Highlights of the Proposed Revision to MDEQ’s Air Toxics Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/Highlights-of-the-Proposed-Revision-to-MDEQ-s-Air-Toxics-Rules",
    "url": "/news/Highlights-of-the-Proposed-Revision-to-MDEQ-s-Air-Toxics-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cap-and-Trade November 2017 Joint-Auction Results Released-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/Cap-and-Trade-November-2017-Joint-Auction-Results-Released-California",
    "url": "/news/Cap-and-Trade-November-2017-Joint-Auction-Results-Released-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Holman Named New Director of NCDAQ",
    "apiurl": "/restapi/customnewscontentlvl2/news/Holman-Named-New-Director-of-NCDAQ",
    "url": "/news/Holman-Named-New-Director-of-NCDAQ",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Major Natural Gas Project Approved for Uintah County",
    "apiurl": "/restapi/customnewscontentlvl2/news/Major-Natural-Gas-Project-Approved-for-Uintah-County",
    "url": "/news/Major-Natural-Gas-Project-Approved-for-Uintah-County",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DAQ's Implementation of NHSM  Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/DAQ's-Implementation-of-NHSM-Regulations",
    "url": "/news/DAQ's-Implementation-of-NHSM-Regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "North Carolina's GHG Tailoring Rule on Hold",
    "apiurl": "/restapi/customnewscontentlvl2/news/North-Carolina's-GHG-Tailoring-Rule-on-Hold",
    "url": "/news/North-Carolina's-GHG-Tailoring-Rule-on-Hold",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed 2010 Primary NO2 NAAQS Infrastructure SIP Open for Comments",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-2010-Primary-NO2-NAAQS-Infrastructure-SIP-Open-for-Comments",
    "url": "/news/Proposed-2010-Primary-NO2-NAAQS-Infrastructure-SIP-Open-for-Comments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reminder of Indiana Department of Homeland Security Notifications for Storage Tank Installations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reminder-of-Indiana-Department-of-Homeland-Security-Notifications-for-Storage-Tank-Installations",
    "url": "/news/Reminder-of-Indiana-Department-of-Homeland-Security-Notifications-for-Storage-Tank-Installations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Rule - Restriction of Emission of Odors",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Rule---Restriction-of-Emission-of-Odors",
    "url": "/news/Proposed-Rule---Restriction-of-Emission-of-Odors",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Introducing BREEZE ExDAM 8.6 and ExDAM 3D Extend Module",
    "apiurl": "/restapi/customnewscontentlvl2/news/Introducing-BREEZE-ExDAM-8-6-and-ExDAM-3D-Extend-Module",
    "url": "/news/Introducing-BREEZE-ExDAM-8-6-and-ExDAM-3D-Extend-Module",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDE Finalizes New General Permit for Emergency Generators-Maryland",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDE-Finalizes-New-General-Permit-for-Emergency-Generators-Maryland",
    "url": "/news/MDE-Finalizes-New-General-Permit-for-Emergency-Generators-Maryland",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New PBR Permit Option for Oil & Gas Facilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-PBR-Permit-Option-for-Oil-Gas-Facilities",
    "url": "/news/New-PBR-Permit-Option-for-Oil-Gas-Facilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Dispersion Modeling Notes - Feb 2014",
    "apiurl": "/restapi/customnewscontentlvl2/news/Dispersion-Modeling-Notes---Feb-2014",
    "url": "/news/Dispersion-Modeling-Notes---Feb-2014",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DOEE Finalizes Revised Source Category Permits for Emergency Engines Subject to RICE MACT",
    "apiurl": "/restapi/customnewscontentlvl2/news/doee-finalizes-revised-source-category-permits-for-emergency-engines-subject-to-rice-mact",
    "url": "/news/doee-finalizes-revised-source-category-permits-for-emergency-engines-subject-to-rice-mact",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DOEE Finalizes Revised Source Category Permits for Emergency Engines Subject to RICE MACT",
    "apiurl": "/restapi/customnewscontentlvl2/news/doee-finalizes-revised-source-category-permits-for-emergency-engines-subject-to-rice-mact",
    "url": "/states/washington-dc/doee-finalizes-revised-source-category-permits-for-emergency-engines-subject-to-rice-mact",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes in Permit Fees",
    "apiurl": "/restapi/customnewscontentlvl2/news/Changes-in",
    "url": "/news/Changes-in",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Regulations for NOx Emissions from Fuel Burning Equipment",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Regulations-for-NOx-Emissions-from-Fuel-Burning-Equipment",
    "url": "/news/Proposed-Regulations-for-NOx-Emissions-from-Fuel-Burning-Equipment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Withdraws Approval of New SIP Revision in New Hampshire-New Hampshire",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Withdraws-Approval-of-New-SIP-Revision-in-New-Hampshire-New-Hampshire",
    "url": "/news/EPA-Withdraws-Approval-of-New-SIP-Revision-in-New-Hampshire-New-Hampshire",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Acquires TGB Partnership",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Acquires-TGB-Partnership",
    "url": "/news/Trinity-Consultants-Acquires-TGB-Partnership",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "APCD Releases New Forms (APCD-105 and 102)",
    "apiurl": "/restapi/customnewscontentlvl2/news/APCD-Releases-New-Forms-(APCD-105-and-102)",
    "url": "/news/APCD-Releases-New-Forms-(APCD-105-and-102)",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NYSDEC Proposes NOx and PM Limitations for Demand Response Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/NYSDEC-Proposes-NOx-and-PM-Limitations-for-Demand-Response-Sources",
    "url": "/news/NYSDEC-Proposes-NOx-and-PM-Limitations-for-Demand-Response-Sources",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Texas Guidance on Once-In-Always-In MACT Policy-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Texas-Guidance-on-Once-In-Always-In-MACT-Policy-Texas",
    "url": "/news/Texas-Guidance-on-Once-In-Always-In-MACT-Policy-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Best of 2020: Employee Highlights",
    "apiurl": "/restapi/customnewscontentlvl2/news/best-of-2020-employee-highlights",
    "url": "/news/best-of-2020-employee-highlights",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Permit by Rule and Standard Permit Online Submittal-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Permit-by-Rule-and-Standard-Permit-Online-Submittal-Texas",
    "url": "/news/Permit-by-Rule-and-Standard-Permit-Online-Submittal-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Trinity Office Opens in Birmingham, Alabama",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Trinity-Office-Opens-in-Birmingham-Alabama",
    "url": "/news/New-Trinity-Office-Opens-in-Birmingham-Alabama",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Trinity Office Opens in Birmingham, Alabama",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Trinity-Office-Opens-in-Birmingham-Alabama",
    "url": "/ehs-management/New-Trinity-Office-Opens-in-Birmingham-Alabama",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "CPCN Waiver Threshold Increase",
    "apiurl": "/restapi/customnewscontentlvl2/news/CPCN-Waiver-Threshold-Increase",
    "url": "/news/CPCN-Waiver-Threshold-Increase",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Modeling for NAAQS Part 2: How to select the appropriate output for SO2",
    "apiurl": "/restapi/customnewscontentlvl2/news/Modeling-for-NAAQS-Part-2-How-to-select-the-appropriate-output-for-SO2",
    "url": "/news/Modeling-for-NAAQS-Part-2-How-to-select-the-appropriate-output-for-SO2",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PM Test Method Amendments Proposed: An end to the transition period for CPM?",
    "apiurl": "/restapi/customnewscontentlvl2/news/PM-Test-Method-Amendments-Proposed-An-end-to-the-transition-period-for-CPM-",
    "url": "/news/PM-Test-Method-Amendments-Proposed-An-end-to-the-transition-period-for-CPM-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KDHE Bureau of Air COVID-19 Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/kdhe-bureau-of-air-covid-19-update",
    "url": "/news/kdhe-bureau-of-air-covid-19-update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KDHE Bureau of Air COVID-19 Update",
    "apiurl": "/restapi/customnewscontentlvl2/news/kdhe-bureau-of-air-covid-19-update",
    "url": "/state/news/kdhe-bureau-of-air-covid-19-update",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Finalizes Amendments to the 2012 and 2016 NSPS for Oil and Natural Gas Industry",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-finalizes-amendments-to-the-2012-and-2016-nsps-for-oil-and-natural-gas-industry",
    "url": "/news/epa-finalizes-amendments-to-the-2012-and-2016-nsps-for-oil-and-natural-gas-industry",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Finalizes Amendments to the 2012 and 2016 NSPS for Oil and Natural Gas Industry",
    "apiurl": "/restapi/customnewscontentlvl2/news/epa-finalizes-amendments-to-the-2012-and-2016-nsps-for-oil-and-natural-gas-industry",
    "url": "/federal/epa-finalizes-amendments-to-the-2012-and-2016-nsps-for-oil-and-natural-gas-industry",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Polk County Air Quality Fees-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Polk-County-Air-Quality-Fees-Iowa",
    "url": "/news/Polk-County-Air-Quality-Fees-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Nonattainment New Source Review (NNSR) Procedures and Offset Requirements in Specified Parishes Revised",
    "apiurl": "/restapi/customnewscontentlvl2/news/Nonattainment-New-Source-Review-(NNSR)-Procedures-and-Offset-Requirements-in-Specified-Parishes-Revised",
    "url": "/news/Nonattainment-New-Source-Review-(NNSR)-Procedures-and-Offset-Requirements-in-Specified-Parishes-Revised",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "KDAQ Issues Emergency New Source Review Regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/KDAQ-Issue",
    "url": "/news/KDAQ-Issue",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Approvals in Ontario-Ontario",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Approvals-in-Ontario-Ontario",
    "url": "/news/Air-Approvals-in-Ontario-Ontario",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "1-day Workshop on Common RCRA Violations and How to Avoid Them",
    "apiurl": "/restapi/customnewscontentlvl2/news/1-day-Workshop-on-Common-RCRA-Violations-and-How-to-Avoid-Them",
    "url": "/news/1-day-Workshop-on-Common-RCRA-Violations-and-How-to-Avoid-Them",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "What’s New with ISO 14001? The Long-Awaited Changes Have Finally Arrived",
    "apiurl": "/restapi/customnewscontentlvl2/news/What-s-New-with-ISO-14001-The-Long-Awaited-Changes-Have-Finally-Arrived",
    "url": "/news/What-s-New-with-ISO-14001-The-Long-Awaited-Changes-Have-Finally-Arrived",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revised Draft of GCP for Oil & Gas-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revised-Draft-of-GCP-for-Oil-Gas-New-Mexico",
    "url": "/news/Revised-Draft-of-GCP-for-Oil-Gas-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EKAPCD Adopts RACT SIP for 2015 Ozone NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/ekapcd-adopts-ract-sip-for-2015-ozone-naaqs",
    "url": "/news/ekapcd-adopts-ract-sip-for-2015-ozone-naaqs",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EKAPCD Adopts RACT SIP for 2015 Ozone NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/ekapcd-adopts-ract-sip-for-2015-ozone-naaqs",
    "url": "/news/states/california/ekapcd-adopts-ract-sip-for-2015-ozone-naaqs",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Navigating the World of Sustainability Disclosure",
    "apiurl": "/restapi/customnewscontentlvl2/news/navigating-the-world-of-sustainability-disclosure",
    "url": "/news/navigating-the-world-of-sustainability-disclosure",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Navigating the World of Sustainability Disclosure",
    "apiurl": "/restapi/customnewscontentlvl2/news/navigating-the-world-of-sustainability-disclosure",
    "url": "/ehs-management/navigating-the-world-of-sustainability-disclosure",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "California Waste Discharge Requirements Order for Winery Process Water Adopted",
    "apiurl": "/restapi/customnewscontentlvl2/news/california-waste-discharge-requirements-order-for-winery-process-water-adopted",
    "url": "/news/california-waste-discharge-requirements-order-for-winery-process-water-adopted",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes Hourly Nitrogen Oxide Limit",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-Hourly-Nitrogen-Oxide-Limit-",
    "url": "/news/EPA-Proposes-Hourly-Nitrogen-Oxide-Limit-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Iowa Environmental Compliance Updates - Aug 2020",
    "apiurl": "/restapi/customnewscontentlvl2/news/iowa-environmental-compliance-updates",
    "url": "/news/iowa-environmental-compliance-updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oil and Gas Industry Emissions Calculation & Regulatory Analysis Workbook-Colorado",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oil-and-Gas-Industry-Emissions-Calculation-Regulatory-Analysis-Workbook-Colorado",
    "url": "/news/Oil-and-Gas-Industry-Emissions-Calculation-Regulatory-Analysis-Workbook-Colorado",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Partners with American Electric Power on Air Permitting Award-Winning Power Plant",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Partners-with-American-Electric-Power-on-Air-Permitting-Award-Winning-Power-Plant",
    "url": "/news/Trinity-Consultants-Partners-with-American-Electric-Power-on-Air-Permitting-Award-Winning-Power-Plant",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revisions to St. Louis City Ordinance",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revisions-to-St-Louis-City-Ordinance",
    "url": "/news/Revisions-to-St-Louis-City-Ordinance",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDE Finalizes New Permit to Construct Forms",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDE-Finalizes-New-Permit-to-Construct-Forms",
    "url": "/news/MDE-Finalizes-New-Permit-to-Construct-Forms",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposed Revisions to NE SIP and Title V Permits-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposed-Revisions-to-NE-SIP-and-Title-V-Permits-Nebraska",
    "url": "/news/EPA-Proposed-Revisions-to-NE-SIP-and-Title-V-Permits-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MDNR Rejects Delegation of Authority for Area Source NESHAP Standards",
    "apiurl": "/restapi/customnewscontentlvl2/news/MDNR-Rejects-Delegation-of-Authority-for-Area-Source-NESHAP-Standards",
    "url": "/news/MDNR-Rejects-Delegation-of-Authority-for-Area-Source-NESHAP-Standards",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Houston-based Argent Consulting Services Joins Trinity Consultants",
    "apiurl": "/restapi/customnewscontentlvl2/news/Houston-based-Argent-Consulting-Services-Joins-Trinity-Consultants",
    "url": "/news/Houston-based-Argent-Consulting-Services-Joins-Trinity-Consultants",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Updates to Air Dispersion Modeling Guidelines-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/Updates-to-Air-Dispersion-Modeling-Guidelines-New-Mexico",
    "url": "/news/Updates-to-Air-Dispersion-Modeling-Guidelines-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final rule: Alabama State Implementation Plan Revisions – NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/final-rule-alabama-state-implementation-plan-revisions-naaqs",
    "url": "/news/final-rule-alabama-state-implementation-plan-revisions-naaqs",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Final rule: Alabama State Implementation Plan Revisions – NAAQS",
    "apiurl": "/restapi/customnewscontentlvl2/news/final-rule-alabama-state-implementation-plan-revisions-naaqs",
    "url": "/states/alabama/final-rule-alabama-state-implementation-plan-revisions-naaqs",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oregon DEQ Assigning More Rigorous Thresholds for Select Toxic Pollutants-Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oregon-DEQ-Assigning-More-Rigorous-Thresholds-for-Select-Toxic-Pollutants-Oregon",
    "url": "/news/Oregon-DEQ-Assigning-More-Rigorous-Thresholds-for-Select-Toxic-Pollutants-Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Tip of the Month - Wastewater Discharges-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Tip-of-the-Month---Wastewater-Discharges-Kansas",
    "url": "/news/Tip-of-the-Month---Wastewater-Discharges-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "10 Strategies for Obtaining a Flexible Permit",
    "apiurl": "/restapi/customnewscontentlvl2/news/10-Strategies-for-Obtaining-a-Flexible-Permit",
    "url": "/news/10-Strategies-for-Obtaining-a-Flexible-Permit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DOEE Finalizes New AQ Regulations for Demand Response Generating Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/doee-finalizes-new-aq-regulations-for-demand-response-generating-sources-",
    "url": "/news/doee-finalizes-new-aq-regulations-for-demand-response-generating-sources-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Knox County Air Pollution Control Board Public Hearing and Regulatory Revisions",
    "apiurl": "/restapi/customnewscontentlvl2/news/Knox-County-Air-Pollution-Control-Board-Public-Hearing-and-Regulatory-Revisions",
    "url": "/news/Knox-County-Air-Pollution-Control-Board-Public-Hearing-and-Regulatory-Revisions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Names Industry Leader for the Chemical Sector",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Names-Industry-Leader-for-the-Chemical-Sector",
    "url": "/news/Trinity-Consultants-Names-Industry-Leader-for-the-Chemical-Sector",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Climate Change Performance Excellence Through CDP Reporting and Disclosure",
    "apiurl": "/restapi/customnewscontentlvl2/news/Climate-Change-Performance-Excellence-Through-CDP-Reporting-and-Disclosure",
    "url": "/news/Climate-Change-Performance-Excellence-Through-CDP-Reporting-and-Disclosure",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ODEQ Releases Air Data Report for 2019",
    "apiurl": "/restapi/customnewscontentlvl2/news/odeq-releases-air-data-report-for-2019",
    "url": "/news/odeq-releases-air-data-report-for-2019",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DNREC Amends Air Quality Definition of Volatile Organic Compounds",
    "apiurl": "/restapi/customnewscontentlvl2/news/DNREC-Amends-Air-Quality-Definition-of-Volatile-Organic-Compounds",
    "url": "/news/DNREC-Amends-Air-Quality-Definition-of-Volatile-Organic-Compounds",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Missouri's Basic State Operating Permit",
    "apiurl": "/restapi/customnewscontentlvl2/news/Missouri's-Basic-State-Operating-Permit",
    "url": "/news/Missouri's-Basic-State-Operating-Permit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NHDES 2020 Air Monitoring Network Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/nhdes-2020-air-monitoring-network-plan",
    "url": "/news/nhdes-2020-air-monitoring-network-plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NHDES 2020 Air Monitoring Network Plan",
    "apiurl": "/restapi/customnewscontentlvl2/news/nhdes-2020-air-monitoring-network-plan",
    "url": "/news/state/new-hampshire/nhdes-2020-air-monitoring-network-plan",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Hazardous Waste Fee Recommendation Posted",
    "apiurl": "/restapi/customnewscontentlvl2/news/Hazardous-Waste-Fee-Recommendation-Posted",
    "url": "/news/Hazardous-Waste-Fee-Recommendation-Posted",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Proposes Revisions to EPA GHG Mandatory Reporting Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Proposes-Revisions-to-EPA-GHG-Mandatory-Reporting-Rule",
    "url": "/news/EPA-Proposes-Revisions-to-EPA-GHG-Mandatory-Reporting-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants to Present at the Conference on the Environment on November 7th-Minnesota",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-to-Present-at-the-Conference-on-the-Environment-on-November-7th-Minnesota",
    "url": "/news/Trinity-Consultants-to-Present-at-the-Conference-on-the-Environment-on-November-7th-Minnesota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Energy Assessment Deadline Rapidly Approaching-Tennessee",
    "apiurl": "/restapi/customnewscontentlvl2/news/Energy-Assessment-Deadline-Rapidly-Approaching-Tennessee",
    "url": "/news/Energy-Assessment-Deadline-Rapidly-Approaching-Tennessee",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Request for Stakeholders-Iowa",
    "apiurl": "/restapi/customnewscontentlvl2/news/Request-for-Stakeholders-Iowa",
    "url": "/news/Request-for-Stakeholders-Iowa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reports on Wyoming Resources, Hazards, and Interactive Tool Available-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reports-on-Wyoming-Resources-Hazards-and-Interactive-Tool-Available-Wyoming",
    "url": "/news/Reports-on-Wyoming-Resources-Hazards-and-Interactive-Tool-Available-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Regulatory Revisions to Address PM-2.5 and GHGs are Final",
    "apiurl": "/restapi/customnewscontentlvl2/news/Regulatory-Revisions-to-Address-PM-2-5-and-GHGs-are-Final-",
    "url": "/news/Regulatory-Revisions-to-Address-PM-2-5-and-GHGs-are-Final-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MassDEP Updates their RGGI Regulations-Massachusetts",
    "apiurl": "/restapi/customnewscontentlvl2/news/MassDEP-Updates-their-RGGI-Regulations-Massachusetts",
    "url": "/news/MassDEP-Updates-their-RGGI-Regulations-Massachusetts",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "North Carolina Submits Proposed Ozone Nonattainment Areas",
    "apiurl": "/restapi/customnewscontentlvl2/news/North-Carolina-Submits-Proposed-Ozone-Nonattainment-Areas",
    "url": "/news/North-Carolina-Submits-Proposed-Ozone-Nonattainment-Areas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Electronic Reporting Policy",
    "apiurl": "/restapi/customnewscontentlvl2/news/Electronic-Reporting-Policy",
    "url": "/news/Electronic-Reporting-Policy",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Federal Court Vacates GHG Permitting Deferral for Biogenic Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/4d04a3eb-cc4e-4ae0-8486-b77176442950",
    "url": "/news/4d04a3eb-cc4e-4ae0-8486-b77176442950",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EHS Auditing Best Practices Part 5: Using Tools & Technology",
    "apiurl": "/restapi/customnewscontentlvl2/news/ehs-auditing-best-practices-part-5-using-tools-technology",
    "url": "/news/ehs-auditing-best-practices-part-5-using-tools-technology",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Removal of NC Air Toxic Limits",
    "apiurl": "/restapi/customnewscontentlvl2/news/Removal-of-NC-Air-Toxic-Limits",
    "url": "/news/Removal-of-NC-Air-Toxic-Limits",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SJVAPCD 2020 RACT Demonstration and Emissions Statement Program Certification",
    "apiurl": "/restapi/customnewscontentlvl2/news/sjvapcd-2020-ract-demonstration-and-emissions-statement-program-certification",
    "url": "/news/sjvapcd-2020-ract-demonstration-and-emissions-statement-program-certification",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SJVAPCD 2020 RACT Demonstration and Emissions Statement Program Certification",
    "apiurl": "/restapi/customnewscontentlvl2/news/sjvapcd-2020-ract-demonstration-and-emissions-statement-program-certification",
    "url": "/states/sjvapcd-2020-ract-demonstration-and-emissions-statement-program-certification",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Approval of Wisconsin State Implementation Plan for PSD Greenhouse Gas Tailoring and Biomass Deferral Rule",
    "apiurl": "/restapi/customnewscontentlvl2/news/Approval-of-Wisconsin-State-Implementation-Plan-for-PSD-Greenhouse-Gas-Tailoring-and-Biomass-Deferral-Rule",
    "url": "/news/Approval-of-Wisconsin-State-Implementation-Plan-for-PSD-Greenhouse-Gas-Tailoring-and-Biomass-Deferral-Rule",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposal to Add Aerosol Cans to Universal Waste Regulations-Kansas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposal-to-Add-Aerosol-Cans-to-Universal-Waste-Regulations-Kansas",
    "url": "/news/Proposal-to-Add-Aerosol-Cans-to-Universal-Waste-Regulations-Kansas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Canadian Council of Ministers of the Environment Endorses New Air Quality Standards for SO2",
    "apiurl": "/restapi/customnewscontentlvl2/news/Canadian-Council-of-Ministers-of-the-Environment-Endorses-New-Air-Quality-Standards-for-SO2",
    "url": "/news/Canadian-Council-of-Ministers-of-the-Environment-Endorses-New-Air-Quality-Standards-for-SO2",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Response to 2015 Ozone NAAQS Designations-California",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Response-to-2015-Ozone-NAAQS-Designations-California",
    "url": "/news/EPA-Response-to-2015-Ozone-NAAQS-Designations-California",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "RICE MACT Monitoring Plan Reminder",
    "apiurl": "/restapi/customnewscontentlvl2/news/RICE-MACT-Monitoring-Plan-Reminder",
    "url": "/news/RICE-MACT-Monitoring-Plan-Reminder",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PFAS Discharge Permit Survey",
    "apiurl": "/restapi/customnewscontentlvl2/news/pfas-discharge-permit-survey",
    "url": "/news/pfas-discharge-permit-survey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PFAS Discharge Permit Survey",
    "apiurl": "/restapi/customnewscontentlvl2/news/pfas-discharge-permit-survey",
    "url": "/states/pfas-discharge-permit-survey",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Quality Bureau Fee Advisory Group",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Bureau-Fee-Advisory-Group",
    "url": "/news/Air-Quality-Bureau-Fee-Advisory-Group",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Amendments of Regulation 61-62 Set for Approval",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Amendments-of-Regulation-61-62-Set-for-Approval",
    "url": "/news/Proposed-Amendments-of-Regulation-61-62-Set-for-Approval",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Potential Follow-up Investigations in Response to USA TODAY Special Report: \"The Smokestack Effect\"",
    "apiurl": "/restapi/customnewscontentlvl2/news/Potential-Follow-up-Investigations-in-Response-to-USA-TODAY-Special-Report-The-Smokestack-Effect-",
    "url": "/news/Potential-Follow-up-Investigations-in-Response-to-USA-TODAY-Special-Report-The-Smokestack-Effect-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Georgia Cited by EPA for Failure to Submit a SIP",
    "apiurl": "/restapi/customnewscontentlvl2/news/Georgia-Ci",
    "url": "/news/Georgia-Ci",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on Michigan’s PM2.5 National Ambient Air Quality Standards Designations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-Michigan-s-PM2-5-National-Ambient-Air-Quality-Standards-Designations-",
    "url": "/news/Update-on-Michigan-s-PM2-5-National-Ambient-Air-Quality-Standards-Designations-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Are you ready for Air Compliance in 2011?",
    "apiurl": "/restapi/customnewscontentlvl2/news/Are-you-ready-for-Air-Compliance-in-2011-",
    "url": "/news/Are-you-ready-for-Air-Compliance-in-2011-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Engine Compliance Lessons Learned",
    "apiurl": "/restapi/customnewscontentlvl2/news/Engine-Compliance-Lessons-Learned",
    "url": "/news/Engine-Compliance-Lessons-Learned",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "OPR in Process of Updating the CEQA Guidelines",
    "apiurl": "/restapi/customnewscontentlvl2/news/OPR-in-Process-of-Updating-the-CEQA-Guidelines",
    "url": "/news/OPR-in-Process-of-Updating-the-CEQA-Guidelines",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Hourly NO to NO2 Conversion Methods in AERMOD",
    "apiurl": "/restapi/customnewscontentlvl2/news/hourly-no-to-no2-conversion-methods-in-aermod",
    "url": "/news/hourly-no-to-no2-conversion-methods-in-aermod",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Hourly NO to NO2 Conversion Methods in AERMOD",
    "apiurl": "/restapi/customnewscontentlvl2/news/hourly-no-to-no2-conversion-methods-in-aermod",
    "url": "/News/Technology/Hourly-NO-to-NO2-Conversion-Methods-in-AERMOD/",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "SCAQMD – Proposed Amendments to Rule 1113",
    "apiurl": "/restapi/customnewscontentlvl2/news/SCAQMD-Proposed-Amendments-to-Rule-1113",
    "url": "/news/SCAQMD-Proposed-Amendments-to-Rule-1113",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "California Air Resources Board – Refrigerant Management Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/California-Air-Resources-Board-Refrigerant-Management-Program",
    "url": "/news/California-Air-Resources-Board-Refrigerant-Management-Program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DOEE Proposes GHG Intensity Limits for Fuels Used in Fuel-Burning Equipment-Washington, DC",
    "apiurl": "/restapi/customnewscontentlvl2/news/DOEE-Proposes-GHG-Intensity-Limits-for-Fuels-Used-in-Fuel-Burning-Equipment-Washington-DC",
    "url": "/news/DOEE-Proposes-GHG-Intensity-Limits-for-Fuels-Used-in-Fuel-Burning-Equipment-Washington-DC",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Nation's First Mandatory Market Based CO2 Reduction Initiative (RGGI) Completes a Successful One Year Run-Vermont",
    "apiurl": "/restapi/customnewscontentlvl2/news/Nation's-First-Mandatory-Market-Based-CO2-Reduction-Initiative-(RGGI)-Completes-a-Successful-One-Year-Run-Vermont",
    "url": "/news/Nation's-First-Mandatory-Market-Based-CO2-Reduction-Initiative-(RGGI)-Completes-a-Successful-One-Year-Run-Vermont",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Opportunity to Submit Air Quality Client Contact Meeting Agenda Items",
    "apiurl": "/restapi/customnewscontentlvl2/news/Opportunity-to-Submit-Air-Quality-Client-Contact-Meeting-Agenda-Items",
    "url": "/news/Opportunity-to-Submit-Air-Quality-Client-Contact-Meeting-Agenda-Items",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDNR Provides Information on RICE NESHAP",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDNR-Provides-Information-on-RICE-NESHAP-",
    "url": "/news/IDNR-Provides-Information-on-RICE-NESHAP-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Supreme Court Ruling Allows CSAPR to Proceed",
    "apiurl": "/restapi/customnewscontentlvl2/news/Supreme-Court-Ruling-Allows-CSAPR-to-Proceed",
    "url": "/news/Supreme-Court-Ruling-Allows-CSAPR-to-Proceed",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Reminder: 2010 Toxics Release Inventory Report Due to U.S. EPA by July 1, 2011",
    "apiurl": "/restapi/customnewscontentlvl2/news/Reminder-",
    "url": "/news/Reminder-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PADEP Issues Final Revised GP-5 for Natural Gas Facilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/PADEP-Issues-Final-Revised-GP-5-for-Natural-Gas-Facilities-",
    "url": "/news/PADEP-Issues-Final-Revised-GP-5-for-Natural-Gas-Facilities-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEM proposes to amend GHG PSD and MSOP regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEM-proposes-to-amend-GHG-PSD-and-MSOP-regulations",
    "url": "/news/ADEM-proposes-to-amend-GHG-PSD-and-MSOP-regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Acquires Toxicology Consulting Firm",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Acquires-Toxicology-Consulting-Firm",
    "url": "/news/Trinity-Consultants-Acquires-Toxicology-Consulting-Firm",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "North and South Dakota 2017 Monitoring Plans-South Dakota",
    "apiurl": "/restapi/customnewscontentlvl2/news/North-and-South-Dakota-2017-Monitoring-Plans-South-Dakota",
    "url": "/news/North-and-South-Dakota-2017-Monitoring-Plans-South-Dakota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Fourth Circuit Court of Appeals Remands Air Permit to APCB-Virginia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Fourth-Circuit-Court-of-Appeals-Remands-Air-Permit-to-APCB-Virginia",
    "url": "/news/Fourth-Circuit-Court-of-Appeals-Remands-Air-Permit-to-APCB-Virginia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Toxicology Regulatory Services (TRS) Joins SafeBridge",
    "apiurl": "/restapi/customnewscontentlvl2/news/Toxicology-Regulatory-Services-TRS-Joins-SafeBridge",
    "url": "/news/Toxicology-Regulatory-Services-TRS-Joins-SafeBridge",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New MCAQD Requirement for Performance Test Protocol Submittals",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-mcaqd-requirement-for-performance-test-protocol-submittals",
    "url": "/news/new-mcaqd-requirement-for-performance-test-protocol-submittals",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New MCAQD Requirement for Performance Test Protocol Submittals",
    "apiurl": "/restapi/customnewscontentlvl2/news/new-mcaqd-requirement-for-performance-test-protocol-submittals",
    "url": "/states/arizona/new-mcaqd-requirement-for-performance-test-protocol-submittals",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed SIP Revisions",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-SIP-Revisions",
    "url": "/news/Proposed-SIP-Revisions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Additional Construction Permit Exemptions",
    "apiurl": "/restapi/customnewscontentlvl2/news/Additional-Construction-Permit-Exemptions",
    "url": "/news/Additional-Construction-Permit-Exemptions",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Authorizes GHG Permitting Deferral for Biogenic Sources",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Authorizes-GHG-Permitting-Deferral-for-Biogenic-Sources-",
    "url": "/news/EPA-Authorizes-GHG-Permitting-Deferral-for-Biogenic-Sources-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Changes to the National Pollutant Release Inventory (NPRI) Reporting Requirements for 2016 and 2017-Ontario",
    "apiurl": "/restapi/customnewscontentlvl2/news/Changes-to-the-National-Pollutant-Release-Inventory-(NPRI)-Reporting-Requirements-for-2016-and-2017-Ontario",
    "url": "/news/Changes-to-the-National-Pollutant-Release-Inventory-(NPRI)-Reporting-Requirements-for-2016-and-2017-Ontario",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Acquires AWN Consulting",
    "apiurl": "/restapi/customnewscontentlvl2/news/trinity-acquires-awn-consulting",
    "url": "/news/trinity-acquires-awn-consulting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Approval of Increase in Missouri Permitting Fees",
    "apiurl": "/restapi/customnewscontentlvl2/news/Approval-of-Increase-in-Missouri-Permitting-Fees",
    "url": "/news/Approval-of-Increase-in-Missouri-Permitting-Fees",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Kansas Reporting Reminders",
    "apiurl": "/restapi/customnewscontentlvl2/news/Kansas-Reporting-Reminders",
    "url": "/news/Kansas-Reporting-Reminders",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Statewide Air Permit System Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/Statewide-Air-Permit-System-Amendments",
    "url": "/news/Statewide-Air-Permit-System-Amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "2016 Air Emissions Inventory Reporting",
    "apiurl": "/restapi/customnewscontentlvl2/news/2016-Air-Emissions-Inventory-Reporting",
    "url": "/news/2016-Air-Emissions-Inventory-Reporting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Illinois EPA Document Explorer",
    "apiurl": "/restapi/customnewscontentlvl2/news/Illinois-EPA-Document-Explorer",
    "url": "/news/Illinois-EPA-Document-Explorer",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Good News May 2021",
    "apiurl": "/restapi/customnewscontentlvl2/news/good-news-may-2021",
    "url": "/news/good-news-may-2021",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Good News May 2021",
    "apiurl": "/restapi/customnewscontentlvl2/news/good-news-may-2021",
    "url": "/www.trinityconsultants.com/news/good-news-may-2021",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Gillette College to Host EPA Listening Session on Clean Power Plan-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Gillette-College-to-Host-EPA-Listening-Session-on-Clean-Power-Plan-Wyoming",
    "url": "/news/Gillette-College-to-Host-EPA-Listening-Session-on-Clean-Power-Plan-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Cap-and-Trade May 2016 Joint-Auction Results Released",
    "apiurl": "/restapi/customnewscontentlvl2/news/Cap-and-Trade-May-2016-Joint-Auction-Results-Released",
    "url": "/news/Cap-and-Trade-May-2016-Joint-Auction-Results-Released",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "GHG Reporting Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/GHG-Reporting-Updates",
    "url": "/news/GHG-Reporting-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Regulatory Update:  PaDEP proposes updated NOx RACT",
    "apiurl": "/restapi/customnewscontentlvl2/news/Regulatory-Update-PaDEP-proposes-updated-NOx-RACT",
    "url": "/news/Regulatory-Update-PaDEP-proposes-updated-NOx-RACT",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Public Hearing Regarding the 2010 1-Hour NO2 NAAQS Infrastructure",
    "apiurl": "/restapi/customnewscontentlvl2/news/Public-Hea",
    "url": "/news/Public-Hea",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Employee Spotlight: Kate McDaniel, PE",
    "apiurl": "/restapi/customnewscontentlvl2/news/employee-spotlight-kate-mcdaniel-pe",
    "url": "/news/employee-spotlight-kate-mcdaniel-pe",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on SIP Modeling Efforts for 1-hour SO2 NAAQS-Washington",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-SIP-Modeling-Efforts-for-1-hour-SO2-NAAQS-Washington",
    "url": "/news/Update-on-SIP-Modeling-Efforts-for-1-hour-SO2-NAAQS-Washington",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPD Proposes Amendments to the Georgia Rules for Air Quality Control",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPD-Propos",
    "url": "/news/EPD-Propos",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Revised Air Permit for Oil & Gas Facilities",
    "apiurl": "/restapi/customnewscontentlvl2/news/Revised-Air-Permit-for-Oil-Gas-Facilities",
    "url": "/news/Revised-Air-Permit-for-Oil-Gas-Facilities",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Public Hearing to Discuss Proposed Fine Particulate Control Strategy in Muscatine",
    "apiurl": "/restapi/customnewscontentlvl2/news/Public-Hearing-to-Discuss-Proposed-Fine-Particulate-Control-Strategy-in-Muscatine",
    "url": "/news/Public-Hearing-to-Discuss-Proposed-Fine-Particulate-Control-Strategy-in-Muscatine",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BAAQMD Hearing to Adopt Amendments for Particulate Emissions from Refineries",
    "apiurl": "/restapi/customnewscontentlvl2/news/baaqmd-holding-public-hearing-for-the-adoption-of-proposed-amendments-to-regulation-6-rule-5-(particulate-emissions-from-fluidized-catalytic-cracking-units)-on-june-2-2021",
    "url": "/news/baaqmd-holding-public-hearing-for-the-adoption-of-proposed-amendments-to-regulation-6-rule-5-(particulate-emissions-from-fluidized-catalytic-cracking-units)-on-june-2-2021",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Pollution Control Regulation Proposed Updates",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Pollution-Control-Regulation-Proposed-Updates",
    "url": "/news/Air-Pollution-Control-Regulation-Proposed-Updates",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "IDEM Kicks-Off Article 2 Rule-Making Initiative",
    "apiurl": "/restapi/customnewscontentlvl2/news/IDEM-Kicks-Off-Article-2-Rule-Making-Initiative",
    "url": "/news/IDEM-Kicks-Off-Article-2-Rule-Making-Initiative",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Arkansas Air Permitting Specialist a 'Natural' for Trinity's Natural State Office",
    "apiurl": "/restapi/customnewscontentlvl2/news/Arkansas-Air-Permitting-Specialist-a-'Natural'-for-Trinity's-Natural-State-Office",
    "url": "/news/Arkansas-Air-Permitting-Specialist-a-'Natural'-for-Trinity's-Natural-State-Office",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Welcome the Return of Jenna Glahn to Trinity’s New Jersey Office",
    "apiurl": "/restapi/customnewscontentlvl2/news/Welcome-the-Return-of-Jenna-Glahn-to-Trinity-s-New-Jersey-Office",
    "url": "/news/Welcome-the-Return-of-Jenna-Glahn-to-Trinity-s-New-Jersey-Office",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Public Comment Period for Proposed Measures prepared by the Ozone Transport Commission – Stationary and Area Source Committee",
    "apiurl": "/restapi/customnewscontentlvl2/news/Public-Comment-Period-for-Proposed-Measures-prepared-by-the-Ozone-Transport-Commission-Stationary-and-Area-Source-Committee",
    "url": "/news/Public-Comment-Period-for-Proposed-Measures-prepared-by-the-Ozone-Transport-Commission-Stationary-and-Area-Source-Committee",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Disapproves SSM Affirmative Defense... What does this mean for facilities located in New Mexico?",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Disapproves-SSM-Affirmative-Defense-What-does-this-mean-for-facilities-located-in-New-Mexico-",
    "url": "/news/EPA-Disapproves-SSM-Affirmative-Defense-What-does-this-mean-for-facilities-located-in-New-Mexico-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "5 Tips for Completing Your AWIA Risk and Resilience Assessment",
    "apiurl": "/restapi/customnewscontentlvl2/news/5-tips-for-completing-your-awia-risk-and-resilience-assessment",
    "url": "/news/5-tips-for-completing-your-awia-risk-and-resilience-assessment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "5 Tips for Completing Your AWIA Risk and Resilience Assessment",
    "apiurl": "/restapi/customnewscontentlvl2/news/5-tips-for-completing-your-awia-risk-and-resilience-assessment",
    "url": "/states/texas/5-tips-for-completing-your-awia-risk-and-resilience-assessment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Regulations Respecting Reduction in the Release of Methane and Certain Volatile Organic Compounds (Upstream Oil and Gas Sector)-British Columbia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Regulations-Respecting-Reduction-in-the-Release-of-Methane-and-Certain-Volatile-Organic-Compounds-(Upstream-Oil-and-Gas-Sector)-British-Columbia",
    "url": "/news/Regulations-Respecting-Reduction-in-the-Release-of-Methane-and-Certain-Volatile-Organic-Compounds-(Upstream-Oil-and-Gas-Sector)-British-Columbia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "OLD MACT Residual Risk and Technology Review Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/old-mact-residual-risk-and-technology-review-amendments",
    "url": "/news/old-mact-residual-risk-and-technology-review-amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "OLD MACT Residual Risk and Technology Review Amendments",
    "apiurl": "/restapi/customnewscontentlvl2/news/old-mact-residual-risk-and-technology-review-amendments",
    "url": "/federal/old-mact-residual-risk-and-technology-review-amendments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NC Air Quality Fees Increasing for 2015",
    "apiurl": "/restapi/customnewscontentlvl2/news/NC-Air-Quality-Fees-Increasing-for-2015",
    "url": "/news/NC-Air-Quality-Fees-Increasing-for-2015",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "ADEQ Stakeholder Group for Carbon Dioxide Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/ADEQ-Stakeholder-Group-for-Carbon-Dioxide-Rules",
    "url": "/news/ADEQ-Stakeholder-Group-for-Carbon-Dioxide-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Supreme Court Stays the Implementation of USEPA's Clean Power Plan-Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/Supreme-Court-Stays-the-Implementation-of-USEPA's-Clean-Power-Plan-Oregon",
    "url": "/news/Supreme-Court-Stays-the-Implementation-of-USEPA's-Clean-Power-Plan-Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on Indiana SIP Modeling Efforts for 1-Hour SO2",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-Indiana-SIP-Modeling-Efforts-for-1-Hour-SO2",
    "url": "/news/Update-on-Indiana-SIP-Modeling-Efforts-for-1-Hour-SO2",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "“Representative” Gas Samples – State Level Actions-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Representative-Gas-Samples-State-Level-Actions-Texas",
    "url": "/news/Representative-Gas-Samples-State-Level-Actions-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "“Representative” Gas Samples – State Level Actions-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/Representative-Gas-Samples-State-Level-Actions-Texas",
    "url": "/news/-Representative-Gas-Samples-State-Level-Actions-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PM Test Method Proposed",
    "apiurl": "/restapi/customnewscontentlvl2/news/PM-Test-Method-Proposed",
    "url": "/news/PM-Test-Method-Proposed",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MON Final Amendments: Guidance for the Implementation of the New Work Practice Standards",
    "apiurl": "/restapi/customnewscontentlvl2/news/mon-final-amendments-guidance-for-the-implementation-of-the-new-work-practice-standards-",
    "url": "/news/mon-final-amendments-guidance-for-the-implementation-of-the-new-work-practice-standards-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MON Final Amendments: Guidance for the Implementation of the New Work Practice Standards",
    "apiurl": "/restapi/customnewscontentlvl2/news/mon-final-amendments-guidance-for-the-implementation-of-the-new-work-practice-standards-",
    "url": "/federal/mon-final-amendments---guidance-for-the-implementation-of-the-new-work-practice-standards",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Rule Change to Chapter 116 to adopt Project Emissions Accounting (PEA) under New Source Review (NSR) Preconstruction Permitting Program",
    "apiurl": "/restapi/customnewscontentlvl2/news/proposed-rule-change-to-chapter-116-to-adopt-project-emissions-accounting-(pea)-under-new-source-review-(nsr)-preconstruction-permitting-program",
    "url": "/news/proposed-rule-change-to-chapter-116-to-adopt-project-emissions-accounting-(pea)-under-new-source-review-(nsr)-preconstruction-permitting-program",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Virtual Water Conference and America’s Water Infrastructure Act",
    "apiurl": "/restapi/customnewscontentlvl2/news/tceq-virtual-water-conference-and-america-s-water-infrastructure-act",
    "url": "/news/tceq-virtual-water-conference-and-america-s-water-infrastructure-act",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ Virtual Water Conference and America’s Water Infrastructure Act",
    "apiurl": "/restapi/customnewscontentlvl2/news/tceq-virtual-water-conference-and-america-s-water-infrastructure-act",
    "url": "/news/state/texas/tceq-virtual-water-conference-and-america-s-water-infrastructure-act",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Permit Application Fees Effective March 1, 2012",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Permit-Application-Fees-Effective-March-1-2012",
    "url": "/news/New-Permit-Application-Fees-Effective-March-1-2012",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Summary of the 2015 Emissions Inventory Workshop",
    "apiurl": "/restapi/customnewscontentlvl2/news/Summary-of-the-2015-Emissions-Inventory-Workshop-",
    "url": "/news/Summary-of-the-2015-Emissions-Inventory-Workshop-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Status of Boiler MACT and Proposed Amendments to Case-by-Case MACT Rules",
    "apiurl": "/restapi/customnewscontentlvl2/news/Status-of-Boiler-MACT-and-Proposed-Amendments-to-Case-by-Case-MACT-Rules",
    "url": "/news/Status-of-Boiler-MACT-and-Proposed-Amendments-to-Case-by-Case-MACT-Rules",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EHS Auditing Best Practices Part 2: Audit Planning",
    "apiurl": "/restapi/customnewscontentlvl2/news/ehs-auditing-best-practices-part-2-audit-planning",
    "url": "/news/ehs-auditing-best-practices-part-2-audit-planning",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Navigating the NEPA Environmental Review Process",
    "apiurl": "/restapi/customnewscontentlvl2/news/Navigating-the-NEPA-Environmental-Review-Process",
    "url": "/news/Navigating-the-NEPA-Environmental-Review-Process",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "BREEZE Releases AERMET 7.5 to Include U.S. EPA AERMET Executable 14134",
    "apiurl": "/restapi/customnewscontentlvl2/news/BREEZE-Releases-AERMET-7-5-to-Include-U-S-EPA-AERMET-Executable-14134",
    "url": "/news/BREEZE-Releases-AERMET-7-5-to-Include-U-S-EPA-AERMET-Executable-14134",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Rule - Control of Sulfur Emissions from Stationary Boilers",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Rule---Control-of-Sulfur-Emissions-from-Stationary-Boilers",
    "url": "/news/Proposed-Rule---Control-of-Sulfur-Emissions-from-Stationary-Boilers",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Addition of Chlorhexidine to Schedule 1 of CEPA",
    "apiurl": "/restapi/customnewscontentlvl2/news/proposed-addition-of-chlorhexidine-to-schedule-1-of-cepa",
    "url": "/news/proposed-addition-of-chlorhexidine-to-schedule-1-of-cepa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Addition of Chlorhexidine to Schedule 1 of CEPA",
    "apiurl": "/restapi/customnewscontentlvl2/news/proposed-addition-of-chlorhexidine-to-schedule-1-of-cepa",
    "url": "/www.trinityconsultants.com/news/proposed-addition-of-chlorhexidine-to-schedule-1-of-cepa",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Oregon Toxics Rulemaking Update and Risk Assessments",
    "apiurl": "/restapi/customnewscontentlvl2/news/Oregon-Toxics-Rulemaking-Update-and-Risk-Assessments",
    "url": "/news/Oregon-Toxics-Rulemaking-Update-and-Risk-Assessments",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "DNREC Proposes Revision to SIP Concerning PM Emission Standards",
    "apiurl": "/restapi/customnewscontentlvl2/news/DNREC-Prop",
    "url": "/news/DNREC-Prop",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New System for Completing and Submitting Biennial Hazardous Waste Reports",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-System-for-Completing-and-Submitting-Biennial-Hazardous-Waste-Reports",
    "url": "/news/New-System-for-Completing-and-Submitting-Biennial-Hazardous-Waste-Reports",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NFPA 61 Requires Dust Hazard Analyses for Agricultural and Food Processing by End of 2021",
    "apiurl": "/restapi/customnewscontentlvl2/news/nfpa-61-requires-dust-hazard-analyses-for-agricultural-and-food-processing-by-end-of-2021",
    "url": "/news/nfpa-61-requires-dust-hazard-analyses-for-agricultural-and-food-processing-by-end-of-2021",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Facilities Subject to CAO Requirements Will Soon Receive LRAPA’s Prioritization Results-Oregon",
    "apiurl": "/restapi/customnewscontentlvl2/news/Facilities-Subject-to-CAO-Requirements-Will-Soon-Receive-LRAPA-s-Prioritization-Results-Oregon",
    "url": "/news/Facilities-Subject-to-CAO-Requirements-Will-Soon-Receive-LRAPA-s-Prioritization-Results-Oregon",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Q&A Session With KDHE",
    "apiurl": "/restapi/customnewscontentlvl2/news/q-a-session-with-kdhe",
    "url": "/news/q-a-session-with-kdhe",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Q&A Session With KDHE",
    "apiurl": "/restapi/customnewscontentlvl2/news/q-a-session-with-kdhe",
    "url": "/news/states/kansas/q---a-session-with-kdhe",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants and Sierra Research Announce Intent to Merge",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-and-Sierra-Research-Announce-Intent-to-Merge",
    "url": "/news/Trinity-Consultants-and-Sierra-Research-Announce-Intent-to-Merge",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "HEAL Utah - Rule Petition Submitted to Air Quality Board",
    "apiurl": "/restapi/customnewscontentlvl2/news/HEAL-Utah---Rule-Petition-Submitted-to-Air-Quality-Board",
    "url": "/news/HEAL-Utah---Rule-Petition-Submitted-to-Air-Quality-Board",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Illinois Hazardous Waste Updates (RCRA Subtitle C)-Illinois",
    "apiurl": "/restapi/customnewscontentlvl2/news/Illinois-Hazardous-Waste-Updates-(RCRA-Subtitle-C)-Illinois",
    "url": "/news/Illinois-Hazardous-Waste-Updates-(RCRA-Subtitle-C)-Illinois",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEQ Updating Permit Conditions in Air Quality Permits-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEQ-Updating-Permit-Conditions-in-Air-Quality-Permits-Nebraska",
    "url": "/news/NDEQ-Updating-Permit-Conditions-in-Air-Quality-Permits-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NJDEP Compliance Advisory - Phase II Vapor Recovery Systems",
    "apiurl": "/restapi/customnewscontentlvl2/news/njdep-compliance-advisory---phase-ii-vapor-recovery-systems",
    "url": "/news/njdep-compliance-advisory---phase-ii-vapor-recovery-systems",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "PM2.5 Reclassification to Severe Non-Attainment",
    "apiurl": "/restapi/customnewscontentlvl2/news/PM2-5-Reclassification-to-Severe-Non-Attainment",
    "url": "/news/PM2-5-Reclassification-to-Severe-Non-Attainment",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ ePermits Updates: Case-By-Case Renewals and Confidential Information-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/TCEQ-ePermits-Updates-Case-By-Case-Renewals-and-Confidential-Information-Texas",
    "url": "/news/TCEQ-ePermits-Updates-Case-By-Case-Renewals-and-Confidential-Information-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Upcoming NM Minor Source Emission Inventory News-New Mexico",
    "apiurl": "/restapi/customnewscontentlvl2/news/Upcoming-NM-Minor-Source-Emission-Inventory-News-New-Mexico",
    "url": "/news/Upcoming-NM-Minor-Source-Emission-Inventory-News-New-Mexico",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Nevada DEP Publishes Stationary Internal Combustion Engine FAQ Document-Nevada",
    "apiurl": "/restapi/customnewscontentlvl2/news/Nevada-DEP-Publishes-Stationary-Internal-Combustion-Engine-FAQ-Document-Nevada",
    "url": "/news/Nevada-DEP-Publishes-Stationary-Internal-Combustion-Engine-FAQ-Document-Nevada",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Trinity Consultants Expands in the Northwest with New Office in Boise, Idaho",
    "apiurl": "/restapi/customnewscontentlvl2/news/Trinity-Consultants-Expands-in-the-Northwest-with-New-Office-in-Boise-Idaho",
    "url": "/news/Trinity-Consultants-Expands-in-the-Northwest-with-New-Office-in-Boise-Idaho",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Hazardous Substance Reporting Fees",
    "apiurl": "/restapi/customnewscontentlvl2/news/Hazardous-",
    "url": "/news/Hazardous-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "MPCA Winter Air Modeling Seminar-Minnesota",
    "apiurl": "/restapi/customnewscontentlvl2/news/MPCA-Winter-Air-Modeling-Seminar-Minnesota",
    "url": "/news/MPCA-Winter-Air-Modeling-Seminar-Minnesota",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Proposed Revisions to Ozone-Depleting Substance Standards",
    "apiurl": "/restapi/customnewscontentlvl2/news/Proposed-Revisions-to-Ozone-Depleting-Substance-Standards",
    "url": "/news/Proposed-Revisions-to-Ozone-Depleting-Substance-Standards",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Update on Operating Permit Fees for Title V Facilities in New York",
    "apiurl": "/restapi/customnewscontentlvl2/news/Update-on-Operating-Permit-Fees-for-Title-V-Facilities-in-New-York",
    "url": "/news/Update-on-Operating-Permit-Fees-for-Title-V-Facilities-in-New-York",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Vacated MACT's",
    "apiurl": "/restapi/customnewscontentlvl2/news/Vacated-MACT's",
    "url": "/news/Vacated-MACT's",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Environmental Emergency Regulations (E2 Regulations)-British Columbia",
    "apiurl": "/restapi/customnewscontentlvl2/news/Environmental-Emergency-Regulations-(E2-Regulations)-British-Columbia",
    "url": "/news/Environmental-Emergency-Regulations-(E2-Regulations)-British-Columbia",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "WVDEP G80-A Permit",
    "apiurl": "/restapi/customnewscontentlvl2/news/WVDEP-G80-A-Permit",
    "url": "/news/WVDEP-G80-A-Permit",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "TCEQ 2019 Trade Fair Updates for NSR Workbook and EMEW-Texas",
    "apiurl": "/restapi/customnewscontentlvl2/news/TCEQ-2019-Trade-Fair-Updates-for-NSR-Workbook-and-EMEW-Texas",
    "url": "/news/TCEQ-2019-Trade-Fair-Updates-for-NSR-Workbook-and-EMEW-Texas",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "San Diego APCD Overhauls Fuel Combustion Rules and Permitting",
    "apiurl": "/restapi/customnewscontentlvl2/news/san-diego-apcd-overhauls-fuel-combustion-rules-and-permitting",
    "url": "/news/san-diego-apcd-overhauls-fuel-combustion-rules-and-permitting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Are You Ready for GHG Reporting?",
    "apiurl": "/restapi/customnewscontentlvl2/news/Are-You-Ready-for-GHG-Reporting-",
    "url": "/news/Are-You-Ready-for-GHG-Reporting-",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Highlights from the April 27th Wyoming Air Quality Advisory Board Meeting-Wyoming",
    "apiurl": "/restapi/customnewscontentlvl2/news/Highlights-from-the-April-27th-Wyoming-Air-Quality-Advisory-Board-Meeting-Wyoming",
    "url": "/news/Highlights-from-the-April-27th-Wyoming-Air-Quality-Advisory-Board-Meeting-Wyoming",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEQ Air Program Workshop",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEQ-Air-Program-Workshop",
    "url": "/news/NDEQ-Air-Program-Workshop",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "NDEE  Update - SLEIS-Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/NDEE-Update---SLEIS-Nebraska",
    "url": "/news/NDEE-Update---SLEIS-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Selected Air Pollution Control Rule Changes in Wisconsin",
    "apiurl": "/restapi/customnewscontentlvl2/news/Selected-Air-Pollution-Control-Rule-Changes-in-Wisconsin",
    "url": "/news/Selected-Air-Pollution-Control-Rule-Changes-in-Wisconsin",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Public hearing on Aug. 6 to consider revisions to TDEC's air pollution control regulations",
    "apiurl": "/restapi/customnewscontentlvl2/news/Public-hearing-on-Aug-6-to-consider-revisions-to-TDEC's-air-pollution-control-regulations",
    "url": "/news/Public-hearing-on-Aug-6-to-consider-revisions-to-TDEC's-air-pollution-control-regulations",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "New Policy for Dispersion Modeling of Intermittent Operating Units",
    "apiurl": "/restapi/customnewscontentlvl2/news/New-Policy-for-Dispersion-Modeling-of-Intermittent-Operating-Units",
    "url": "/news/New-Policy-for-Dispersion-Modeling-of-Intermittent-Operating-Units",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Residual Risk Settlement Affects Pulp and Paper Mills",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Residual-Risk-Settlement-Affects-Pulp-and-Paper-Mills",
    "url": "/news/EPA-Residual-Risk-Settlement-Affects-Pulp-and-Paper-Mills",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "EPA Sued Over GHG 'Endangerment'",
    "apiurl": "/restapi/customnewscontentlvl2/news/EPA-Sued-Over-GHG-'Endangerment'",
    "url": "/news/EPA-Sued-Over-GHG-'Endangerment'",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Clean Air Transport Rule Includes Nebraska",
    "apiurl": "/restapi/customnewscontentlvl2/news/Clean-Air-Transport-Rule-Includes-Nebraska",
    "url": "/news/Clean-Air-Transport-Rule-Includes-Nebraska",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Air Quality Advisory Council Meeting",
    "apiurl": "/restapi/customnewscontentlvl2/news/Air-Quality-Advisory-Council-Meeting",
    "url": "/news/Air-Quality-Advisory-Council-Meeting",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "How New York’s CLCPA May Affect Your Next Air Permitting Activity",
    "apiurl": "/restapi/customnewscontentlvl2/news/how-new-yorks-clcpa-may-affect-your-next-air-permitting-activity",
    "url": "/news/how-new-yorks-clcpa-may-affect-your-next-air-permitting-activity",
    "template": "new-news-article",
    "section": "news"
  },
  {
    "name": "Other",
    "apiurl": "/restapi/customcontent/contact-us/other",
    "url": "/contact-us/other",
    "template": "general_content",
    "section": "other"
  },
  {
    "name": "Tank Consulting Services",
    "apiurl": "/restapi/customcontent/contact-us/tank-consulting-services",
    "url": "/contact-us/tank-consulting-services",
    "template": "general_content",
    "section": "tank-consulting-services"
  },
  {
    "name": "Custom Solutions",
    "apiurl": "/restapi/customcontent/contact-us/custom-solutions",
    "url": "/contact-us/custom-solutions",
    "template": "general_content",
    "section": "custom-solutions"
  },
  {
    "name": "Hazardous Release Modeling",
    "apiurl": "/restapi/customcontent/contact-us/hazardous-release-modeling",
    "url": "/contact-us/hazardous-release-modeling",
    "template": "general_content",
    "section": "hazardous-release-modeling"
  },
  {
    "name": "High Explosive Explosion Modeling",
    "apiurl": "/restapi/customcontent/contact-us/high-explosive-explosion-modeling",
    "url": "/contact-us/high-explosive-explosion-modeling",
    "template": "general_content",
    "section": "high-explosive-explosion-modeling"
  },
  {
    "name": "Air Dispersion Modeling",
    "apiurl": "/restapi/customcontent/contact-us/air-dispersion-modeling",
    "url": "/contact-us/air-dispersion-modeling",
    "template": "general_content",
    "section": "air-dispersion-modeling"
  },
  {
    "name": "Vapor Cloud Explosion Modeling",
    "apiurl": "/restapi/customcontent/contact-us/vapor-cloud-explosion-modeling",
    "url": "/contact-us/vapor-cloud-explosion-modeling",
    "template": "general_content",
    "section": "vapor-cloud-explosion-modeling"
  },
  {
    "name": "Thermal Radiation (Fire) Fire Modeling",
    "apiurl": "/restapi/customcontent/contact-us/thermal-radiation-(fire)-fire-modeling",
    "url": "/contact-us/thermal-radiation-(fire)-fire-modeling",
    "template": "general_content",
    "section": "thermal-radiation-(fire)-fire-modeling"
  },
  {
    "name": "Yearly",
    "apiurl": "/restapi/customcontent/contact-us/yearly",
    "url": "/contact-us/yearly",
    "template": "general_content",
    "section": "yearly"
  },
  {
    "name": "Monthly",
    "apiurl": "/restapi/customcontent/contact-us/monthly",
    "url": "/contact-us/monthly",
    "template": "general_content",
    "section": "monthly"
  },
  {
    "name": "Industry",
    "apiurl": "/restapi/customtrainingcontentlvl2/training/industry",
    "url": "/training/industry",
    "template": "new-training-category",
    "section": "training"
  },
  {
    "name": "Webinar",
    "apiurl": "/restapi/customtrainingcontentlvl2/training/webinar",
    "url": "/training/webinar",
    "template": "new-training-format",
    "section": "training"
  },
  {
    "name": "All Courses",
    "apiurl": "/restapi/customtrainingcontentlvl2/training/all-courses",
    "url": "/training/all-courses",
    "template": "new-training-all-courses",
    "section": "training"
  },
  {
    "name": "Software Courses",
    "apiurl": "/restapi/customtrainingcontentlvl2/training/software",
    "url": "/training/software",
    "template": "training-software-course",
    "section": "training"
  },
  {
    "name": "Software Courses",
    "apiurl": "/restapi/customtrainingcontentlvl2/training/software",
    "url": "/software/software-courses",
    "template": "training-software-course",
    "section": "training"
  },
  {
    "name": "Software Courses",
    "apiurl": "/restapi/customtrainingcontentlvl2/training/software",
    "url": "/training/software-courses",
    "template": "training-software-course",
    "section": "training"
  },
  {
    "name": "Complimentary",
    "apiurl": "/restapi/customtrainingcontentlvl2/training/free",
    "url": "/training/free",
    "template": "new-training-format",
    "section": "training"
  },
  {
    "name": "Complimentary",
    "apiurl": "/restapi/customtrainingcontentlvl2/training/free",
    "url": "/training/Complimentary",
    "template": "new-training-format",
    "section": "training"
  },
  {
    "name": "Seminar",
    "apiurl": "/restapi/customtrainingcontentlvl2/training/seminar",
    "url": "/training/seminar",
    "template": "new-training-format",
    "section": "training"
  },
  {
    "name": "Category",
    "apiurl": "/restapi/customtrainingcontentlvl2/training/course-by-category",
    "url": "/training/course-by-category",
    "template": "training-schedule",
    "section": "training"
  },
  {
    "name": "Search",
    "apiurl": "/restapi/customtrainingcontentlvl2/training/search",
    "url": "/training/search",
    "template": "new-training-search",
    "section": "training"
  },
  {
    "name": "Location Specific",
    "apiurl": "/restapi/customtrainingcontentlvl2/training/location-specific",
    "url": "/training/location-specific",
    "template": "new-training-location-specific",
    "section": "training"
  },
  {
    "name": "Classroom",
    "apiurl": "/restapi/customtrainingcontentlvl2/training/classroom",
    "url": "/training/classroom",
    "template": "new-training-format",
    "section": "training"
  },
  {
    "name": "eLearning",
    "apiurl": "/restapi/customtrainingcontentlvl2/training/elearning",
    "url": "/training/elearning",
    "template": "new-training-format",
    "section": "training"
  },
  {
    "name": "News",
    "apiurl": "/restapi/customnewscontentlvl1/news",
    "url": "/news",
    "template": "new-tri-news",
    "section": "news"
  },
  {
    "name": "Report a problem with the website",
    "apiurl": "/restapi/customcontent/report-problem",
    "url": "/report-problem",
    "template": "general_content",
    "section": "report-a-problem-with-the-website"
  },
  {
    "name": "Education Pricing",
    "apiurl": "/restapi/customcontent/contact-us/education-pricing",
    "url": "/contact-us/education-pricing",
    "template": "general_content",
    "section": "education-pricing"
  },
  {
    "name": "Regulatory Agency Program",
    "apiurl": "/restapi/customcontent/contact-us/regulatory-agency-program",
    "url": "/contact-us/regulatory-agency-program",
    "template": "general_content",
    "section": "regulatory-agency-program"
  },
  {
    "name": "China Pricing",
    "apiurl": "/restapi/customcontent/contact-us/china-pricing",
    "url": "/contact-us/china-pricing",
    "template": "general_content",
    "section": "china-pricing"
  },
  {
    "name": "Volume Discounts",
    "apiurl": "/restapi/customcontent/contact-us/volume-discounts",
    "url": "/contact-us/volume-discounts",
    "template": "general_content",
    "section": "volume-discounts"
  },
  {
    "name": "TankESP",
    "apiurl": "/restapi/customcontent/software/tanks/tankesp/tankesp-system-requirements",
    "url": "/software/tanks/tankesp/tankesp-system-requirements",
    "template": "general_content",
    "section": "tankesp"
  },
  {
    "name": "TankESP",
    "apiurl": "/restapi/customcontent/software/tanks/tankesp/tankesp-system-requirements",
    "url": "/software/tank-emissions/tankesp/tankesp-system-requirements",
    "template": "general_content",
    "section": "tankesp"
  },
  {
    "name": "BREEZE AERSCREEN",
    "apiurl": "/restapi/customcontent/software/dispersion/aerscreen/breeze-aerscreen-system-requirements",
    "url": "/software/dispersion/aerscreen/breeze-aerscreen-system-requirements",
    "template": "general_content",
    "section": "breeze-aerscreen"
  },
  {
    "name": "VASDIP",
    "apiurl": "/restapi/customcontent/software/explosion/vasdip/vasdip-hardware-requirements",
    "url": "/software/explosion/vasdip/vasdip-hardware-requirements",
    "template": "general_content",
    "section": "vasdip"
  },
  {
    "name": "VASDIP",
    "apiurl": "/restapi/customcontent/software/explosion/vasdip/vasdip-hardware-requirements",
    "url": "/software/explosion/vasdip/hardware-requirements",
    "template": "general_content",
    "section": "vasdip"
  },
  {
    "name": "ExDAM System Requirements",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/exdam-system-requirements",
    "url": "/software/explosion/exdam/exdam-system-requirements",
    "template": "general_content",
    "section": "exdam-system-requirements"
  },
  {
    "name": "BREEZE CALPUFF",
    "apiurl": "/restapi/customcontent/software/dispersion/calpuff/breeze-calpuff",
    "url": "/software/dispersion/calpuff/breeze-calpuff",
    "template": "general_content",
    "section": "breeze-calpuff"
  },
  {
    "name": "Downwash Analyst",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/downwash-analyst/downwash-analyst",
    "url": "/software/air-dispersion---data-visualization/downwash-analyst/downwash-analyst",
    "template": "general_content",
    "section": "downwash-analyst"
  },
  {
    "name": "Downwash Analyst",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/downwash-analyst/downwash-analyst",
    "url": "/software/air-dispersion-data-visualization/downwash-analyst/downwash-analyst",
    "template": "general_content",
    "section": "downwash-analyst"
  },
  {
    "name": "Downwash Analyst",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/downwash-analyst/downwash-analyst",
    "url": "/software/air-dispersion---data/downwash-analyst/downwash-analyst",
    "template": "general_content",
    "section": "downwash-analyst"
  },
  {
    "name": "BREEZE MetView",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/metview/breeze-metview-system-requirements",
    "url": "/software/air-dispersion---data-visualization/metview/breeze-metview-system-requirements",
    "template": "general_content",
    "section": "breeze-metview"
  },
  {
    "name": "BREEZE MetView",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/metview/breeze-metview-system-requirements",
    "url": "/software/air-dispersion-data-visualization/metview/breeze-metview-system-requirements",
    "template": "general_content",
    "section": "breeze-metview"
  },
  {
    "name": "BREEZE MetView",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/metview/breeze-metview-system-requirements",
    "url": "/software/air-dispersion---data/metview/breeze-metview-system-requirements",
    "template": "general_content",
    "section": "breeze-metview"
  },
  {
    "name": "BREEZE AERMET",
    "apiurl": "/restapi/customcontent/software/dispersion/aermet/breeze-aermet-system-requirements",
    "url": "/software/dispersion/aermet/breeze-aermet-system-requirements",
    "template": "general_content",
    "section": "breeze-aermet"
  },
  {
    "name": "SCREEN3",
    "apiurl": "/restapi/customcontent/software/dispersion/screen3/screen3",
    "url": "/software/dispersion/screen3/screen3",
    "template": "general_content",
    "section": "screen3"
  },
  {
    "name": "BREEZE 3D Analyst",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/breeze-3d-analyst",
    "url": "/software/air-dispersion---data-visualization/3d-analyst/breeze-3d-analyst",
    "template": "general_content",
    "section": "breeze-3d-analyst"
  },
  {
    "name": "BREEZE 3D Analyst",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/breeze-3d-analyst",
    "url": "/software/air-dispersion-data-visualization/3d-analyst/breeze-3d-analyst",
    "template": "general_content",
    "section": "breeze-3d-analyst"
  },
  {
    "name": "BREEZE 3D Analyst",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/breeze-3d-analyst",
    "url": "/software/air-dispersion---data/3d-analyst/breeze-3d-analyst",
    "template": "general_content",
    "section": "breeze-3d-analyst"
  },
  {
    "name": "LFG Fire/Risk",
    "apiurl": "/restapi/customcontent/software/hazard/lfg-fire-risk/lfg-fire-risk",
    "url": "/software/hazard/lfg-fire-risk/lfg-fire-risk",
    "template": "general_content",
    "section": "lfg-firerisk"
  },
  {
    "name": "LFG Fire/Risk",
    "apiurl": "/restapi/customcontent/software/hazard/lfg-fire-risk/lfg-fire-risk",
    "url": "/software/hazard/lfg-fire-risk-modeling/lfg-fire-risk",
    "template": "general_content",
    "section": "lfg-firerisk"
  },
  {
    "name": "Incident Analyst",
    "apiurl": "/restapi/customcontent/software/hazard/incident-analyst/incident-analyst",
    "url": "/software/hazard/incident-analyst/incident-analyst",
    "template": "general_content",
    "section": "incident-analyst"
  },
  {
    "name": "BREEZE AERMOD",
    "apiurl": "/restapi/customcontent/software/dispersion/aermod/breeze-aermod-system-requirements",
    "url": "/software/dispersion/aermod/breeze-aermod-system-requirements",
    "template": "general_content",
    "section": "breeze-aermod"
  },
  {
    "name": "BREEZE Risk Analyst",
    "apiurl": "/restapi/customcontent/software/health-risk/risk-analyst/breeze-risk-analyst-system-requirements",
    "url": "/software/health-risk/risk-analyst/breeze-risk-analyst-system-requirements",
    "template": "general_content",
    "section": "breeze-risk-analyst"
  },
  {
    "name": "BREEZE ROADS",
    "apiurl": "/restapi/customcontent/software/dispersion/roads/breeze-roads",
    "url": "/software/dispersion/roads/breeze-roads",
    "template": "general_content",
    "section": "breeze-roads"
  },
  {
    "name": "Jeanine Duke",
    "apiurl": "/restapi/customcontent/contact-us/jeanine-duke",
    "url": "/contact-us/jeanine-duke",
    "template": "general_content",
    "section": "jeanine-duke"
  },
  {
    "name": "raja konda",
    "apiurl": "/restapi/customcontent/contact-us/raja-konda",
    "url": "/contact-us/raja-konda",
    "template": "general_content",
    "section": "raja-konda"
  },
  {
    "name": "Chantel Campbell",
    "apiurl": "/restapi/customcontent/contact-us/chantel-campbell",
    "url": "/contact-us/chantel-campbell",
    "template": "general_content",
    "section": "chantel-campbell"
  },
  {
    "name": "Jay",
    "apiurl": "/restapi/customcontent/contact-us/jay",
    "url": "/contact-us/jay",
    "template": "general_content",
    "section": "jay"
  },
  {
    "name": "Angelica Zureikat",
    "apiurl": "/restapi/customcontent/contact-us/angelica-zureikat",
    "url": "/contact-us/angelica-zureikat",
    "template": "general_content",
    "section": "angelica-zureikat"
  },
  {
    "name": "Universal Transverse Mercator (UTM)",
    "apiurl": "/restapi/customcontent/contact-us/universal-transverse-mercator-(utm)",
    "url": "/contact-us/universal-transverse-mercator-(utm)",
    "template": "general_content",
    "section": "universal-transverse-mercator-(utm)"
  },
  {
    "name": "Latitude",
    "apiurl": "/restapi/customcontent/contact-us/latitude",
    "url": "/contact-us/latitude",
    "template": "general_content",
    "section": "latitude"
  },
  {
    "name": "Latitude and Longitude",
    "apiurl": "/restapi/customcontent/contact-us/latitude-and-longitude",
    "url": "/contact-us/latitude-and-longitude",
    "template": "general_content",
    "section": "latitude-and-longitude"
  },
  {
    "name": "Longitude",
    "apiurl": "/restapi/customcontent/contact-us/longitude",
    "url": "/contact-us/longitude",
    "template": "general_content",
    "section": "longitude"
  },
  {
    "name": "BREEZE Software Regulatory Agency Program",
    "apiurl": "/restapi/customcontent/regulatory-agency-program",
    "url": "/regulatory-agency-program",
    "template": "general_content",
    "section": "breeze-software-regulatory-agency-program"
  },
  {
    "name": "Training",
    "apiurl": "/restapi/customtrainingcontent/training",
    "url": "/training",
    "template": "new-training-landing",
    "section": "training"
  },
  {
    "name": "Training",
    "apiurl": "/restapi/customtrainingcontent/training",
    "url": "/services/training",
    "template": "new-training-landing",
    "section": "training"
  },
  {
    "name": "Training",
    "apiurl": "/restapi/customtrainingcontent/training",
    "url": "/training-test",
    "template": "new-training-landing",
    "section": "training"
  },
  {
    "name": "Software",
    "apiurl": "/restapi/customsoftwarecontent/software",
    "url": "/software",
    "template": "new-software-landing",
    "section": "software"
  },
  {
    "name": "Key Features",
    "apiurl": "/restapi/customcontent/software/explosion/vasdip/key-features",
    "url": "/software/explosion/vasdip/key-features",
    "template": "general_content",
    "section": "key-features"
  },
  {
    "name": "What's New in Version 8.0",
    "apiurl": "/restapi/customcontent/software/dispersion/aermet/what-is-new-in-latest-version",
    "url": "/software/dispersion/aermet/what-is-new-in-latest-version",
    "template": "general_content",
    "section": "what's-new-in-version-8.0"
  },
  {
    "name": "What's New in Version 8.0",
    "apiurl": "/restapi/customcontent/software/dispersion/aermet/what-is-new-in-latest-version",
    "url": "/software/dispersion/aermet/what's-new-in-latest-version",
    "template": "general_content",
    "section": "what's-new-in-version-8.0"
  },
  {
    "name": "CAL3QHCR Model",
    "apiurl": "/restapi/customcontent/software/dispersion/roads/cal3qhcr-model",
    "url": "/software/dispersion/roads/cal3qhcr-model",
    "template": "general_content",
    "section": "cal3qhcr-model"
  },
  {
    "name": "Append Data",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/metview/append-data",
    "url": "/software/air-dispersion---data-visualization/metview/append-data",
    "template": "general_content",
    "section": "append-data"
  },
  {
    "name": "Append Data",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/metview/append-data",
    "url": "/software/air-dispersion-data-visualization/metview/append-data",
    "template": "general_content",
    "section": "append-data"
  },
  {
    "name": "Append Data",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/metview/append-data",
    "url": "/software/air-dispersion---data/metview/append-data",
    "template": "general_content",
    "section": "append-data"
  },
  {
    "name": "Technical Features",
    "apiurl": "/restapi/customcontent/software/tanks/tankesp/technical-features",
    "url": "/software/tanks/tankesp/technical-features",
    "template": "general_content",
    "section": "technical-features"
  },
  {
    "name": "Technical Features",
    "apiurl": "/restapi/customcontent/software/tanks/tankesp/technical-features",
    "url": "/software/tank-emissions/tankesp/technical-features",
    "template": "general_content",
    "section": "technical-features"
  },
  {
    "name": "DEGADIS Model Features",
    "apiurl": "/restapi/customcontent/software/hazard/lfg-fire-risk/degadis-model-features",
    "url": "/software/hazard/lfg-fire-risk/degadis-model-features",
    "template": "general_content",
    "section": "degadis-model-features"
  },
  {
    "name": "DEGADIS Model Features",
    "apiurl": "/restapi/customcontent/software/hazard/lfg-fire-risk/degadis-model-features",
    "url": "/software/hazard/lfg-fire-risk-modeling/degadis-model-features",
    "template": "general_content",
    "section": "degadis-model-features"
  },
  {
    "name": "Power and Flexibility",
    "apiurl": "/restapi/customcontent/software/dispersion/aermet/power-and-flexibility",
    "url": "/software/dispersion/aermet/power-and-flexibility",
    "template": "general_content",
    "section": "power-and-flexibility"
  },
  {
    "name": "Basic Features",
    "apiurl": "/restapi/customcontent/software/tanks/tankesp/basic-features",
    "url": "/software/tanks/tankesp/basic-features",
    "template": "general_content",
    "section": "basic-features"
  },
  {
    "name": "Basic Features",
    "apiurl": "/restapi/customcontent/software/tanks/tankesp/basic-features",
    "url": "/software/tank-emissions/tankesp/basic-features",
    "template": "general_content",
    "section": "basic-features"
  },
  {
    "name": "3D Tools",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/3d-tools",
    "url": "/software/air-dispersion---data-visualization/3d-analyst/3d-tools",
    "template": "general_content",
    "section": "3d-tools"
  },
  {
    "name": "3D Tools",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/3d-tools",
    "url": "/software/air-dispersion---data/3d-analyst/3d-tools",
    "template": "general_content",
    "section": "3d-tools"
  },
  {
    "name": "3D Tools",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/3d-tools",
    "url": "/software/air-dispersion-data-visualization/3d-analyst/3d-tools",
    "template": "general_content",
    "section": "3d-tools"
  },
  {
    "name": "Basic Features",
    "apiurl": "/restapi/customcontent/software/dispersion/roads/basic-features",
    "url": "/software/dispersion/roads/basic-features",
    "template": "general_content",
    "section": "basic-features"
  },
  {
    "name": "Data Rose",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/metview/data-rose",
    "url": "/software/air-dispersion---data-visualization/metview/data-rose",
    "template": "general_content",
    "section": "data-rose"
  },
  {
    "name": "What's New in Version 4.0",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/what's-new-in-version-4.0",
    "url": "/software/air-dispersion---data-visualization/3d-analyst/what's-new-in-version-4.0",
    "template": "general_content",
    "section": "what's-new-in-version-4.0"
  },
  {
    "name": "What's New in Version 4.0",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/what's-new-in-version-4.0",
    "url": "/software/air-dispersion-data-visualization/3d-analyst/what's-new-in-version-4.0",
    "template": "general_content",
    "section": "what's-new-in-version-4.0"
  },
  {
    "name": "What's New in Version 4.0",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/what's-new-in-version-4.0",
    "url": "/software/air-dispersion---data/3d-analyst/what's-new-in-version-4.0",
    "template": "general_content",
    "section": "what's-new-in-version-4.0"
  },
  {
    "name": "Basic Features",
    "apiurl": "/restapi/customcontent/software/dispersion/aermod/basic-features",
    "url": "/software/dispersion/aermod/basic-features",
    "template": "general_content",
    "section": "basic-features"
  },
  {
    "name": "Edition Features",
    "apiurl": "/restapi/customcontent/software/tanks/tankesp/edition-features",
    "url": "/software/tanks/tankesp/edition-features",
    "template": "general_content",
    "section": "edition-features"
  },
  {
    "name": "Edition Features",
    "apiurl": "/restapi/customcontent/software/tanks/tankesp/edition-features",
    "url": "/software/tank-emissions/tankesp/edition-features",
    "template": "general_content",
    "section": "edition-features"
  },
  {
    "name": "What's New in Version 2.0",
    "apiurl": "/restapi/customcontent/software/dispersion/aerscreen/what-is-new-in-latest-version",
    "url": "/software/dispersion/aerscreen/what-is-new-in-latest-version",
    "template": "general_content",
    "section": "what's-new-in-version-2.0"
  },
  {
    "name": "What's New in Version 2.0",
    "apiurl": "/restapi/customcontent/software/dispersion/aerscreen/what-is-new-in-latest-version",
    "url": "/software/dispersion/aerscreen/what's-new-in-latest-version",
    "template": "general_content",
    "section": "what's-new-in-version-2.0"
  },
  {
    "name": "What's New in Version 4.0",
    "apiurl": "/restapi/customcontent/software/hazard/incident-analyst/what's-new-in-version-4.0",
    "url": "/software/hazard/incident-analyst/what's-new-in-version-4.0",
    "template": "general_content",
    "section": "what's-new-in-version-4.0"
  },
  {
    "name": "Scientific Model Features",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/features-scientific-model",
    "url": "/software/explosion/exdam/features-scientific-model",
    "template": "general_content",
    "section": "scientific-model-features"
  },
  {
    "name": "Scientific Model Features",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/features-scientific-model",
    "url": "/software/explosion/exdam/exdam-hexdam",
    "template": "general_content",
    "section": "scientific-model-features"
  },
  {
    "name": "What's New in Version 3.0",
    "apiurl": "/restapi/customcontent/software/dispersion/calpuff/what's-new-in-version-3.0",
    "url": "/software/dispersion/calpuff/what's-new-in-version-3.0",
    "template": "general_content",
    "section": "what's-new-in-version-3.0"
  },
  {
    "name": "Program Characteristics",
    "apiurl": "/restapi/customcontent/software/hazard/incident-analyst/program-characteristics",
    "url": "/software/hazard/incident-analyst/program-characteristics",
    "template": "general_content",
    "section": "program-characteristics"
  },
  {
    "name": "Results Analysis Features",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/features-results-analysis",
    "url": "/software/explosion/exdam/features-results-analysis",
    "template": "general_content",
    "section": "results-analysis-features"
  },
  {
    "name": "Results Analysis Features",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/features-results-analysis",
    "url": "/software/explosion/exdam/exdam-vexdam",
    "template": "general_content",
    "section": "results-analysis-features"
  },
  {
    "name": "Key Features",
    "apiurl": "/restapi/customcontent/software/dispersion/roads/key-features",
    "url": "/software/dispersion/roads/key-features",
    "template": "general_content",
    "section": "key-features"
  },
  {
    "name": "Post-Processing Tools",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/post-processing-tools",
    "url": "/software/air-dispersion---data-visualization/3d-analyst/post-processing-tools",
    "template": "general_content",
    "section": "post-processing-tools"
  },
  {
    "name": "User Interface Features",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/features-user-interface",
    "url": "/software/explosion/exdam/features-user-interface",
    "template": "general_content",
    "section": "user-interface-features"
  },
  {
    "name": "User Interface Features",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/features-user-interface",
    "url": "/software/explosion/exdam/exdam-key-features",
    "template": "general_content",
    "section": "user-interface-features"
  },
  {
    "name": "Key Features",
    "apiurl": "/restapi/customcontent/software/health-risk/risk-analyst/key-features",
    "url": "/software/health-risk/risk-analyst/key-features",
    "template": "general_content",
    "section": "key-features"
  },
  {
    "name": "Basic Features",
    "apiurl": "/restapi/customcontent/software/dispersion/aerscreen/basic-features",
    "url": "/software/dispersion/aerscreen/basic-features",
    "template": "general_content",
    "section": "basic-features"
  },
  {
    "name": "Technical Features",
    "apiurl": "/restapi/customcontent/software/dispersion/aermod/technical-features",
    "url": "/software/dispersion/aermod/technical-features",
    "template": "general_content",
    "section": "technical-features"
  },
  {
    "name": "CALINE4 Model",
    "apiurl": "/restapi/customcontent/software/dispersion/roads/caline4-model",
    "url": "/software/dispersion/roads/caline4-model",
    "template": "general_content",
    "section": "caline4-model"
  },
  {
    "name": "Other Model Features",
    "apiurl": "/restapi/customcontent/software/hazard/lfg-fire-risk/other-model-features",
    "url": "/software/hazard/lfg-fire-risk/other-model-features",
    "template": "general_content",
    "section": "other-model-features"
  },
  {
    "name": "Other Model Features",
    "apiurl": "/restapi/customcontent/software/hazard/lfg-fire-risk/other-model-features",
    "url": "/software/hazard/lfg-fire-risk-modeling/other-model-features",
    "template": "general_content",
    "section": "other-model-features"
  },
  {
    "name": "Basic Features",
    "apiurl": "/restapi/customcontent/software/dispersion/calpuff/basic-features",
    "url": "/software/dispersion/calpuff/basic-features",
    "template": "general_content",
    "section": "basic-features"
  },
  {
    "name": "Features",
    "apiurl": "/restapi/customcontent/software/hazard/lfg-fire-risk/features",
    "url": "/software/hazard/lfg-fire-risk/features",
    "template": "general_content",
    "section": "features"
  },
  {
    "name": "Features",
    "apiurl": "/restapi/customcontent/software/hazard/lfg-fire-risk/features",
    "url": "/software/hazard/lfg-fire-risk-modeling/features",
    "template": "general_content",
    "section": "features"
  },
  {
    "name": "What's New in Latest Version",
    "apiurl": "/restapi/customcontent/software/tanks/tankesp/what-is-new-in-latest-version",
    "url": "/software/tanks/tankesp/what-is-new-in-latest-version",
    "template": "general_content",
    "section": "what's-new-in-latest-version"
  },
  {
    "name": "What's New in Latest Version",
    "apiurl": "/restapi/customcontent/software/tanks/tankesp/what-is-new-in-latest-version",
    "url": "/software/tank-emissions/tankesp/what-is-new-in-latest-version",
    "template": "general_content",
    "section": "what's-new-in-latest-version"
  },
  {
    "name": "What's New in Latest Version",
    "apiurl": "/restapi/customcontent/software/tanks/tankesp/what-is-new-in-latest-version",
    "url": "/software/tanks/tankesp/what's-new-in-latest-version",
    "template": "general_content",
    "section": "what's-new-in-latest-version"
  },
  {
    "name": "Key Features",
    "apiurl": "/restapi/customcontent/software/dispersion/aerscreen/key-features",
    "url": "/software/dispersion/aerscreen/key-features",
    "template": "general_content",
    "section": "key-features"
  },
  {
    "name": "Results Visualization",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/results-visualization",
    "url": "/software/air-dispersion---data-visualization/3d-analyst/results-visualization",
    "template": "general_content",
    "section": "results-visualization"
  },
  {
    "name": "Results Visualization",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/results-visualization",
    "url": "/software/air-dispersion-data-visualization/3d-analyst/results-visualization",
    "template": "general_content",
    "section": "results-visualization"
  },
  {
    "name": "Results Visualization",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/results-visualization",
    "url": "/software/air-dispersion---data/3d-analyst/results-visualization",
    "template": "general_content",
    "section": "results-visualization"
  },
  {
    "name": "What's New in Version 9.1",
    "apiurl": "/restapi/customcontent/software/dispersion/aermod/what-is-new-in-latest-version",
    "url": "/software/dispersion/aermod/what-is-new-in-latest-version",
    "template": "general_content",
    "section": "what's-new-in-version-9.1"
  },
  {
    "name": "What's New in Version 9.1",
    "apiurl": "/restapi/customcontent/software/dispersion/aermod/what-is-new-in-latest-version",
    "url": "/software/dispersion/aermod/what's-new-in-latest-version",
    "template": "general_content",
    "section": "what's-new-in-version-9.1"
  },
  {
    "name": "Ease of Use",
    "apiurl": "/restapi/customcontent/software/dispersion/aermet/ease-of-use",
    "url": "/software/dispersion/aermet/ease-of-use",
    "template": "general_content",
    "section": "ease-of-use"
  },
  {
    "name": "Technical Features",
    "apiurl": "/restapi/customcontent/software/dispersion/calpuff/technical-features",
    "url": "/software/dispersion/calpuff/technical-features",
    "template": "general_content",
    "section": "technical-features"
  },
  {
    "name": "Features",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/downwash-analyst/features",
    "url": "/software/air-dispersion---data-visualization/downwash-analyst/features",
    "template": "general_content",
    "section": "features"
  },
  {
    "name": "Features",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/downwash-analyst/features",
    "url": "/software/air-dispersion---data/downwash-analyst/features",
    "template": "general_content",
    "section": "features"
  },
  {
    "name": "Features",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/downwash-analyst/features",
    "url": "/software/air-dispersion-data-visualization/downwash-analyst/features",
    "template": "general_content",
    "section": "features"
  },
  {
    "name": "Fire (Thermal Radiation) and Explosion (Overpressure) Models",
    "apiurl": "/restapi/customcontent/software/hazard/incident-analyst/fire-(thermal-radiation)-and-explosion-(overpressure)-models",
    "url": "/software/hazard/incident-analyst/fire-(thermal-radiation)-and-explosion-(overpressure)-models",
    "template": "general_content",
    "section": "fire-(thermal-radiation)-and-explosion-(overpressure)-models"
  },
  {
    "name": "CAL3QHC Model",
    "apiurl": "/restapi/customcontent/software/dispersion/roads/cal3qhc-model",
    "url": "/software/dispersion/roads/cal3qhc-model",
    "template": "general_content",
    "section": "cal3qhc-model"
  },
  {
    "name": "Visualizations",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/metview/visualizations",
    "url": "/software/air-dispersion---data-visualization/metview/visualizations",
    "template": "general_content",
    "section": "visualizations"
  },
  {
    "name": "Visualizations",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/metview/visualizations",
    "url": "/software/air-dispersion-data-visualization/metview/visualizations",
    "template": "general_content",
    "section": "visualizations"
  },
  {
    "name": "Visualizations",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/metview/visualizations",
    "url": "/software/air-dispersion---data/metview/visualizations",
    "template": "general_content",
    "section": "visualizations"
  },
  {
    "name": "Tabular Data Analysis",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/metview/tabular-data-analysis",
    "url": "/software/air-dispersion---data-visualization/metview/tabular-data-analysis",
    "template": "general_content",
    "section": "tabular-data-analysis"
  },
  {
    "name": "Tabular Data Analysis",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/metview/tabular-data-analysis",
    "url": "/software/air-dispersion-data-visualization/metview/tabular-data-analysis",
    "template": "general_content",
    "section": "tabular-data-analysis"
  },
  {
    "name": "Tabular Data Analysis",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/metview/tabular-data-analysis",
    "url": "/software/air-dispersion---data/metview/tabular-data-analysis",
    "template": "general_content",
    "section": "tabular-data-analysis"
  },
  {
    "name": "What's New in Version 9.0",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/features-version9",
    "url": "/software/explosion/exdam/features-version9",
    "template": "general_content",
    "section": "what's-new-in-version-9.0"
  },
  {
    "name": "What's New in Version 9.0",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/features-version9",
    "url": "/software/explosion/exdam/3d-extend-extension",
    "template": "general_content",
    "section": "what's-new-in-version-9.0"
  },
  {
    "name": "Source5 Model Features",
    "apiurl": "/restapi/customcontent/software/hazard/lfg-fire-risk/source5-model-features",
    "url": "/software/hazard/lfg-fire-risk/source5-model-features",
    "template": "general_content",
    "section": "source5-model-features"
  },
  {
    "name": "Source5 Model Features",
    "apiurl": "/restapi/customcontent/software/hazard/lfg-fire-risk/source5-model-features",
    "url": "/software/hazard/lfg-fire-risk-modeling/source5-model-features",
    "template": "general_content",
    "section": "source5-model-features"
  },
  {
    "name": "Regulatory Compliance",
    "apiurl": "/restapi/customcontent/software/dispersion/aermet/regulatory-compliance",
    "url": "/software/dispersion/aermet/regulatory-compliance",
    "template": "general_content",
    "section": "regulatory-compliance"
  },
  {
    "name": "Toxic/Flammable Gas Dispersion Models",
    "apiurl": "/restapi/customcontent/software/hazard/incident-analyst/toxic-flammable-gas-dispersion-models",
    "url": "/software/hazard/incident-analyst/toxic-flammable-gas-dispersion-models",
    "template": "general_content",
    "section": "toxicflammable-gas-dispersion-models"
  },
  {
    "name": "Export Options",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/export-options",
    "url": "/software/air-dispersion---data-visualization/3d-analyst/export-options",
    "template": "general_content",
    "section": "export-options"
  },
  {
    "name": "Export Options",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/export-options",
    "url": "/software/air-dispersion---data/3d-analyst/export-options",
    "template": "general_content",
    "section": "export-options"
  },
  {
    "name": "Export Options",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/export-options",
    "url": "/software/air-dispersion-data-visualization/3d-analyst/export-options",
    "template": "general_content",
    "section": "export-options"
  },
  {
    "name": "Features",
    "apiurl": "/restapi/customcontent/software/dispersion/screen3/features",
    "url": "/software/dispersion/screen3/features",
    "template": "general_content",
    "section": "features"
  },
  {
    "name": "England",
    "apiurl": "/restapi/customcontent/contact-us/england",
    "url": "/contact-us/england",
    "template": "general_content",
    "section": "england"
  },
  {
    "name": "Ireland",
    "apiurl": "/restapi/customcontent/contact-us/ireland",
    "url": "/contact-us/ireland",
    "template": "general_content",
    "section": "ireland"
  },
  {
    "name": "New Zealand",
    "apiurl": "/restapi/customcontent/contact-us/new-zealand",
    "url": "/contact-us/new-zealand",
    "template": "general_content",
    "section": "new-zealand"
  },
  {
    "name": "United Kingdom",
    "apiurl": "/restapi/customcontent/contact-us/united-kingdom",
    "url": "/contact-us/united-kingdom",
    "template": "general_content",
    "section": "united-kingdom"
  },
  {
    "name": "India",
    "apiurl": "/restapi/customcontent/contact-us/india",
    "url": "/contact-us/india",
    "template": "general_content",
    "section": "india"
  },
  {
    "name": "China",
    "apiurl": "/restapi/customcontent/contact-us/china",
    "url": "/contact-us/china",
    "template": "general_content",
    "section": "china"
  },
  {
    "name": "United States of America",
    "apiurl": "/restapi/customcontent/contact-us/united-states-of-america",
    "url": "/contact-us/united-states-of-america",
    "template": "general_content",
    "section": "united-states-of-america"
  },
  {
    "name": "Australia",
    "apiurl": "/restapi/customcontent/contact-us/australia",
    "url": "/contact-us/australia",
    "template": "general_content",
    "section": "australia"
  },
  {
    "name": "Careers",
    "apiurl": "/restapi/customcareerscontent/careers",
    "url": "/careers",
    "template": "new-trinity-career",
    "section": "careers"
  },
  {
    "name": "Careers",
    "apiurl": "/restapi/customcareerscontent/careers",
    "url": "/environmental-consultant-career",
    "template": "new-trinity-career",
    "section": "careers"
  },
  {
    "name": "Careers",
    "apiurl": "/restapi/customcareerscontent/careers",
    "url": "/career",
    "template": "new-trinity-career",
    "section": "careers"
  },
  {
    "name": "Careers",
    "apiurl": "/restapi/customcareerscontent/careers",
    "url": "/additional-links/careers",
    "template": "new-trinity-career",
    "section": "careers"
  },
  {
    "name": "Careers",
    "apiurl": "/restapi/customcareerscontent/careers",
    "url": "/about/careers",
    "template": "new-trinity-career",
    "section": "careers"
  },
  {
    "name": "Facebook",
    "apiurl": "/restapi/customcontent/contact-us/facebook",
    "url": "/contact-us/facebook",
    "template": "general_content",
    "section": "facebook"
  },
  {
    "name": "Ads",
    "apiurl": "/restapi/customcontent/contact-us/ads",
    "url": "/contact-us/ads",
    "template": "general_content",
    "section": "ads"
  },
  {
    "name": "Environmental Expert",
    "apiurl": "/restapi/customcontent/contact-us/environmental-expert",
    "url": "/contact-us/environmental-expert",
    "template": "general_content",
    "section": "environmental-expert"
  },
  {
    "name": "Web Search",
    "apiurl": "/restapi/customcontent/contact-us/web-search",
    "url": "/contact-us/web-search",
    "template": "general_content",
    "section": "web-search"
  },
  {
    "name": "Conference",
    "apiurl": "/restapi/customcontent/contact-us/conference",
    "url": "/contact-us/conference",
    "template": "general_content",
    "section": "conference"
  },
  {
    "name": "Colleague",
    "apiurl": "/restapi/customcontent/contact-us/colleague",
    "url": "/contact-us/colleague",
    "template": "general_content",
    "section": "colleague"
  },
  {
    "name": "LinkedIn",
    "apiurl": "/restapi/customcontent/contact-us/linkedin",
    "url": "/contact-us/linkedin",
    "template": "general_content",
    "section": "linkedin"
  },
  {
    "name": "EHS Regulations",
    "apiurl": "/restapi/customcontent/training/ehs-regulations",
    "url": "/training/ehs-regulations",
    "template": "general_content",
    "section": "ehs-regulations"
  },
  {
    "name": "Training by Category",
    "apiurl": "/restapi/customcontent/training/training-by-category",
    "url": "/training/training-by-category",
    "template": "general_content",
    "section": "training-by-category"
  },
  {
    "name": "ehs management",
    "apiurl": "/restapi/customcontent/training/ehs-management",
    "url": "/training/ehs-management",
    "template": "general_content",
    "section": "ehs-management"
  },
  {
    "name": "Training by Industry",
    "apiurl": "/restapi/customcontent/training/training-by-industry",
    "url": "/training/training-by-industry",
    "template": "general_content",
    "section": "training-by-industry"
  },
  {
    "name": "Engineering",
    "apiurl": "/restapi/customconsultinglvl2content/consulting/engineering",
    "url": "/consulting/engineering",
    "template": "new-consulting-category",
    "section": "engineering"
  },
  {
    "name": "Engineering",
    "apiurl": "/restapi/customconsultinglvl2content/consulting/engineering",
    "url": "/areas-of-expertise/engineering",
    "template": "new-consulting-category",
    "section": "engineering"
  },
  {
    "name": "Science",
    "apiurl": "/restapi/customconsultinglvl2content/consulting/science",
    "url": "/consulting/science",
    "template": "new-consulting-category",
    "section": "science"
  },
  {
    "name": "Science",
    "apiurl": "/restapi/customconsultinglvl2content/consulting/science",
    "url": "/environmental-consulting/science",
    "template": "new-consulting-category",
    "section": "science"
  },
  {
    "name": "Science",
    "apiurl": "/restapi/customconsultinglvl2content/consulting/science",
    "url": "/areas-of-expertise/science",
    "template": "new-consulting-category",
    "section": "science"
  },
  {
    "name": "Science",
    "apiurl": "/restapi/customconsultinglvl2content/consulting/science",
    "url": "/environmental-consulting/science2",
    "template": "new-consulting-category",
    "section": "science"
  },
  {
    "name": "Environmental Health & Safety",
    "apiurl": "/restapi/customconsultinglvl2content/consulting/ehs",
    "url": "/consulting/ehs",
    "template": "new-consulting-category",
    "section": "environmental-health-safety"
  },
  {
    "name": "Environmental Health & Safety",
    "apiurl": "/restapi/customconsultinglvl2content/consulting/ehs",
    "url": "/areas-of-expertise/environmental-health-safety",
    "template": "new-consulting-category",
    "section": "environmental-health-safety"
  },
  {
    "name": "Staffing",
    "apiurl": "/restapi/customstaffingcontent/staffinges",
    "url": "/staffinges",
    "template": "new-stafﬁng-landing",
    "section": "staffing"
  },
  {
    "name": "Staffing",
    "apiurl": "/restapi/customstaffingcontent/staffinges",
    "url": "/staffings",
    "template": "new-stafﬁng-landing",
    "section": "staffing"
  },
  {
    "name": "Staffing",
    "apiurl": "/restapi/customstaffingcontent/staffinges",
    "url": "/services/Staffing",
    "template": "new-stafﬁng-landing",
    "section": "staffing"
  },
  {
    "name": "Staffing",
    "apiurl": "/restapi/customstaffingcontent/staffinges",
    "url": "/staffing",
    "template": "new-stafﬁng-landing",
    "section": "staffing"
  },
  {
    "name": "Staffing",
    "apiurl": "/restapi/customstaffingcontent/staffinges",
    "url": "/staffinges/",
    "template": "new-stafﬁng-landing",
    "section": "staffing"
  },
  {
    "name": "TEST",
    "apiurl": "/restapi/customcontent/default-trinitytraining/default-trainingschedule/default-trainingcategorytypes/test",
    "url": "/default-trinitytraining/default-trainingschedule/default-trainingcategorytypes/test",
    "template": "general_content",
    "section": "test"
  },
  {
    "name": "TEST",
    "apiurl": "/restapi/customcontent/default-trinitytraining/default-trainingschedule/default-trainingcategorytypes/test",
    "url": "/training/test",
    "template": "general_content",
    "section": "test"
  },
  {
    "name": "TEST",
    "apiurl": "/restapi/customcontent/default-trinitytraining/default-trainingschedule/default-trainingcategorytypes/test",
    "url": "/training-to-test/test",
    "template": "general_content",
    "section": "test"
  },
  {
    "name": "New York",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/new-york",
    "url": "/locations/north-america/united-states/new-york",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Utah",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/utah",
    "url": "/locations/north-america/united-states/utah",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Connecticut",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/connecticut",
    "url": "/locations/north-america/united-states/connecticut",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Missouri",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/missouri",
    "url": "/locations/north-america/united-states/missouri",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Virginia",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/virginia",
    "url": "/locations/north-america/united-states/virginia",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Texas",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/texas",
    "url": "/locations/north-america/united-states/texas",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Texas",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/texas",
    "url": "/locations/texas",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Texas",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/texas",
    "url": "/location/north-america/united-states/texas",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Ontario",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/canada/ontario",
    "url": "/locations/north-america/canada/ontario",
    "template": "new-individual-state",
    "section": "canada"
  },
  {
    "name": "Ontario",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/canada/ontario",
    "url": "/locations/north-america/canada/toronto",
    "template": "new-individual-state",
    "section": "canada"
  },
  {
    "name": "Indiana",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/indiana",
    "url": "/locations/north-america/united-states/indiana",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "New Hampshire",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/new-hampshire",
    "url": "/locations/north-america/united-states/new-hampshire",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Puerto Rico",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/puerto-rico",
    "url": "/locations/north-america/united-states/puerto-rico",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Washington",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/washington",
    "url": "/locations/north-america/united-states/washington",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Delaware",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/delaware",
    "url": "/locations/north-america/united-states/delaware",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Hawaii",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/hawaii",
    "url": "/locations/north-america/united-states/hawaii",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "West Virginia",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/west-virginia",
    "url": "/locations/north-america/united-states/west-virginia",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Pennsylvania",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/pennsylvania",
    "url": "/locations/north-america/united-states/pennsylvania",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Wisconsin",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/wisconsin",
    "url": "/locations/north-america/united-states/wisconsin",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Maryland",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/maryland",
    "url": "/locations/north-america/united-states/maryland",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Maryland",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/maryland",
    "url": "/locations/north-america/united-states/washington-dc",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Kansas",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/kansas",
    "url": "/locations/north-america/united-states/kansas",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "China",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/asia/china/asia-pacific-state",
    "url": "/locations/asia/china/asia-pacific-state",
    "template": "new-individual-state",
    "section": "china"
  },
  {
    "name": "China",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/asia/china/asia-pacific-state",
    "url": "/locations/asia-pacific/asia-pacific-country/asia-pacific-state",
    "template": "new-individual-state",
    "section": "china"
  },
  {
    "name": "China",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/asia/china/asia-pacific-state",
    "url": "/locations/asia/asia-pacific-country/asia-pacific-state",
    "template": "new-individual-state",
    "section": "china"
  },
  {
    "name": "Nevada",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/nevada",
    "url": "/locations/north-america/united-states/nevada",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Florida",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/florida",
    "url": "/locations/north-america/united-states/florida",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Tennessee",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/tennessee",
    "url": "/locations/north-america/united-states/tennessee",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Kentucky",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/kentucky",
    "url": "/locations/north-america/united-states/kentucky",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Wyoming",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/wyoming",
    "url": "/locations/north-america/united-states/wyoming",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Oklahoma",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/oklahoma",
    "url": "/locations/north-america/united-states/oklahoma",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Illinois",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/illinois",
    "url": "/locations/north-america/united-states/illinois",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "North Dakota",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/north-dakota",
    "url": "/locations/north-america/united-states/north-dakota",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Idaho",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/idaho",
    "url": "/locations/north-america/united-states/idaho",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Mississippi",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/mississippi",
    "url": "/locations/north-america/united-states/mississippi",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Texas",
    "apiurl": "/restapi/customlocationcontentlvl2/default-mainlocation/northamerica/unitedstates/texas",
    "url": "/default-mainlocation/northamerica/unitedstates/texas",
    "template": "new-individual-state",
    "section": "unitedstates"
  },
  {
    "name": "Texas",
    "apiurl": "/restapi/customlocationcontentlvl2/default-mainlocation/northamerica/unitedstates/texas",
    "url": "/northamerica/unitedstates/texas",
    "template": "new-individual-state",
    "section": "unitedstates"
  },
  {
    "name": "Queensland",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/australia/australia/Queensland",
    "url": "/locations/australia/australia/Queensland",
    "template": "new-individual-state",
    "section": "australia"
  },
  {
    "name": "Queensland",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/australia/australia/Queensland",
    "url": "/locations/australia/australia/qld",
    "template": "new-individual-state",
    "section": "australia"
  },
  {
    "name": "Texas",
    "apiurl": "/restapi/customlocationcontentlvl2/default-mainlocation/location/north-america/texas",
    "url": "/default-mainlocation/location/north-america/texas",
    "template": "new-individual-state",
    "section": "north-america"
  },
  {
    "name": "Nebraska",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/nebraska",
    "url": "/locations/north-america/united-states/nebraska",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "South Carolina",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/south-carolina",
    "url": "/locations/north-america/united-states/south-carolina",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Georgia",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/georgia",
    "url": "/locations/north-america/united-states/georgia",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "California",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/california",
    "url": "/locations/north-america/united-states/california",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "California",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/california",
    "url": "/locations/california",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Michigan",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/michigan",
    "url": "/locations/north-america/united-states/michigan",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Oregon",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/oregon",
    "url": "/locations/north-america/united-states/oregon",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Australia State 1",
    "apiurl": "/restapi/customlocationcontentlvl2/default-mainlocation/australia/australia/austalia-test-1",
    "url": "/default-mainlocation/australia/australia/austalia-test-1",
    "template": "new-individual-state",
    "section": "australia"
  },
  {
    "name": "Australia State 1",
    "apiurl": "/restapi/customlocationcontentlvl2/default-mainlocation/australia/australia/austalia-test-1",
    "url": "/australia/australia/austalia-test-1",
    "template": "new-individual-state",
    "section": "australia"
  },
  {
    "name": "United Kingdom",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/europe/europe-country/europe-state",
    "url": "/locations/europe/europe-country/europe-state",
    "template": "new-individual-state",
    "section": "europe-country"
  },
  {
    "name": "Minnesota",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/minnesota",
    "url": "/locations/north-america/united-states/minnesota",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "South Island",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/australia/new-zealand/south-island",
    "url": "/locations/australia/new-zealand/south-island",
    "template": "new-individual-state",
    "section": "new-zealand"
  },
  {
    "name": "British Columbia",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/canada/british-columbia",
    "url": "/locations/north-america/canada/british-columbia",
    "template": "new-individual-state",
    "section": "canada"
  },
  {
    "name": "New Mexico",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/new-mexico",
    "url": "/locations/north-america/united-states/new-mexico",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Massachusetts",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/massachusetts",
    "url": "/locations/north-america/united-states/massachusetts",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Vermont",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/vermont",
    "url": "/locations/north-america/united-states/vermont",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Alaska",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/alaska",
    "url": "/locations/north-america/united-states/alaska",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "North Carolina",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/north-carolina",
    "url": "/locations/north-america/united-states/north-carolina",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "North Carolina",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/north-carolina",
    "url": "/locations/north-carolina",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Colorado",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/colorado",
    "url": "/locations/north-america/united-states/colorado",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "South Dakota",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/south-dakota",
    "url": "/locations/north-america/united-states/south-dakota",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Arizona",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/arizona",
    "url": "/locations/north-america/united-states/arizona",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "New South Wales",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/australia/australia/new-south-wales",
    "url": "/locations/australia/australia/new-south-wales",
    "template": "new-individual-state",
    "section": "australia"
  },
  {
    "name": "New South Wales",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/australia/australia/new-south-wales",
    "url": "/locations/australia/australia/nsw",
    "template": "new-individual-state",
    "section": "australia"
  },
  {
    "name": "Saskatchewan",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/canada/saskatchewan",
    "url": "/locations/north-america/canada/saskatchewan",
    "template": "new-individual-state",
    "section": "canada"
  },
  {
    "name": "Ireland",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/europe/ireland/dublin",
    "url": "/locations/europe/ireland/dublin",
    "template": "new-individual-state",
    "section": "ireland"
  },
  {
    "name": "Louisiana",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/louisiana",
    "url": "/locations/north-america/united-states/louisiana",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Louisiana",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/louisiana",
    "url": "/locations/louisiana",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Montana",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/montana",
    "url": "/locations/north-america/united-states/montana",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Iowa",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/iowa",
    "url": "/locations/north-america/united-states/iowa",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Alabama",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/alabama",
    "url": "/locations/north-america/united-states/alabama",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Alabama",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/alabama",
    "url": "/locations/alabama",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Arkansas",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/arkansas",
    "url": "/locations/north-america/united-states/arkansas",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Ohio",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/ohio",
    "url": "/locations/north-america/united-states/ohio",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Maine",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/maine",
    "url": "/locations/north-america/united-states/maine",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "New Jersey",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/new-jersey",
    "url": "/locations/north-america/united-states/new-jersey",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Washington D.C.",
    "apiurl": "/restapi/customlocationcontentlvl2/locations/north-america/united-states/washington-d.c",
    "url": "/locations/north-america/united-states/washington-d.c",
    "template": "new-individual-state",
    "section": "united-states"
  },
  {
    "name": "Part 61 NESHAP Compliance Support",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/air-quality/NESHAP-and-NSPS-Compliance/Part-61-Neshap-Compliance-Support",
    "url": "/consulting/ehs/air-quality/NESHAP-and-NSPS-Compliance/Part-61-Neshap-Compliance-Support",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "Part 61 NESHAP Compliance Support",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/air-quality/NESHAP-and-NSPS-Compliance/Part-61-Neshap-Compliance-Support",
    "url": "/consulting/ehs/air-quality/NESHAP-and-NSPS-Compliance/Part-61-Neshap-Compliance",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "NAEM Research Report: The Emergence of Virtual EHS Audits",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/ehs-management/Auditing-and-Verification/naem-research-report-the-emergence-of-virtual-ehs-audits",
    "url": "/consulting/ehs/ehs-management/Auditing-and-Verification/naem-research-report-the-emergence-of-virtual-ehs-audits",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "Virtual and Remote Auditing eBook",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/ehs-management/Auditing-and-Verification/virtual-and-remote-auditing-ebook",
    "url": "/consulting/ehs/ehs-management/Auditing-and-Verification/virtual-and-remote-auditing-ebook",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "Virtual and Remote Auditing eBook",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/ehs-management/Auditing-and-Verification/virtual-and-remote-auditing-ebook",
    "url": "/auditing-ebook",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "Mechanical Integrity",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/chemical-compliance/PSM-RMP-Support/mechanical-integrity",
    "url": "/consulting/ehs/chemical-compliance/PSM-RMP-Support/mechanical-integrity",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "Permit By Rule (PBR)",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/air-quality/Air-Quality-Permitting/permit-by-rule",
    "url": "/consulting/ehs/air-quality/Air-Quality-Permitting/permit-by-rule",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "Photochemical Grid Modeling",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/air-quality/Air-Dispersion-Modeling/photochemical-modeling",
    "url": "/consulting/ehs/air-quality/Air-Dispersion-Modeling/photochemical-modeling",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "Photochemical Grid Modeling",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/air-quality/Air-Dispersion-Modeling/photochemical-modeling",
    "url": "/consulting/ehs-services/air-quality/Air-Dispersion-Modeling/photochemical-modeling",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "Applied Meteorology",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/air-quality/ambient-monitoring-service-integration/applied-meteorology",
    "url": "/consulting/ehs/air-quality/ambient-monitoring-service-integration/applied-meteorology",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "Applied Meteorology",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/air-quality/ambient-monitoring-service-integration/applied-meteorology",
    "url": "/consulting/ehs-services/air-quality/ambient-and-meteorological-monitoring/applied-meteorology",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "Applied Meteorology",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/air-quality/ambient-monitoring-service-integration/applied-meteorology",
    "url": "/consulting/ehs/air-quality/ambient-and-meteorological-monitoring/applied-meteorology",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "Applied Meteorology",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/air-quality/ambient-monitoring-service-integration/applied-meteorology",
    "url": "/environmental-consulting/ehs-services/air-quality/ambient-and-meteorological-monitoring/applied-meteorology",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "Ambient Monitoring",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/air-quality/ambient-monitoring-service-integration/ambient-monitoring",
    "url": "/consulting/ehs/air-quality/ambient-monitoring-service-integration/ambient-monitoring",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "Ambient Monitoring",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/air-quality/ambient-monitoring-service-integration/ambient-monitoring",
    "url": "/consulting/ehs/air-quality/ambient-and-meteorological-monitoring/ambient-monitoring",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "Meteorological Monitoring",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/air-quality/ambient-monitoring-service-integration/meteorological-monitoring",
    "url": "/consulting/ehs/air-quality/ambient-monitoring-service-integration/meteorological-monitoring",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "Meteorological Monitoring",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/air-quality/ambient-monitoring-service-integration/meteorological-monitoring",
    "url": "/consulting/ehs/air-quality/ambient-and-meteorological-monitoring/meteorological-monitoring",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "Meteorological Monitoring",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/air-quality/ambient-monitoring-service-integration/meteorological-monitoring",
    "url": "/consulting/ehs-services/air-quality/ambient-and-meteorological-monitoring/meteorological-monitoring",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "Meteorological Monitoring",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/air-quality/ambient-monitoring-service-integration/meteorological-monitoring",
    "url": "/environmental-consulting/ehs-services/air-quality/ambient-and-meteorological-monitoring/meteorological-monitoring",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "Automation Engineering",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/engineering/biopharma-engineering-services/automation-engineering/automation-engineering",
    "url": "/consulting/engineering/biopharma-engineering-services/automation-engineering/automation-engineering",
    "template": "new-consulting-individual-category-detail-type",
    "section": "engineering"
  },
  {
    "name": "Automation Engineering",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/engineering/biopharma-engineering-services/automation-engineering/automation-engineering",
    "url": "/consulting/engineering/biopharma-services/automation-engineering/automation-engineering",
    "template": "new-consulting-individual-category-detail-type",
    "section": "engineering"
  },
  {
    "name": "Automation Engineering",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/engineering/biopharma-engineering-services/automation-engineering/automation-engineering",
    "url": "/consulting/engineering/biopharma-services/automation-engineering-technology/automation-engineering-technology",
    "template": "new-consulting-individual-category-detail-type",
    "section": "engineering"
  },
  {
    "name": "Automation Engineering",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/engineering/biopharma-engineering-services/automation-engineering/automation-engineering",
    "url": "/consulting/engineering/biopharma-services/automation-engineering-technology/automation-engineering",
    "template": "new-consulting-individual-category-detail-type",
    "section": "engineering"
  },
  {
    "name": "Regional Haze Rule Background",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/air-quality/Regional-Haze/rule-background",
    "url": "/consulting/ehs/air-quality/Regional-Haze/rule-background",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "PSM/RMP Mechanical Integrity",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/health-safety/psm-rmp-support/mechanical-integrity",
    "url": "/consulting/ehs/health-safety/psm-rmp-support/mechanical-integrity",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "PSM/RMP Mechanical Integrity",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/health-safety/psm-rmp-support/mechanical-integrity",
    "url": "/consulting/ehs/health-safety/psm-rmp-support/psm-rmp-mechanical-integrity",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "NSPS Compliance Support",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/air-quality/NESHAP-and-NSPS-Compliance/NSPS-Compliance-support",
    "url": "/consulting/ehs/air-quality/NESHAP-and-NSPS-Compliance/NSPS-Compliance-support",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "NSPS Compliance Support",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/air-quality/NESHAP-and-NSPS-Compliance/NSPS-Compliance-support",
    "url": "/consulting/ehs/air-quality/NESHAP-and-NSPS-Compliance/NSPS-Compliance",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "Procedure for Sample Submission",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/science/industrial-hygiene-analytical-laboratory/sample-analysis/procedure-for-sample-submission",
    "url": "/consulting/science/industrial-hygiene-analytical-laboratory/sample-analysis/procedure-for-sample-submission",
    "template": "new-consulting-individual-category-detail-type",
    "section": "science"
  },
  {
    "name": "PSM/RMP Compliance Auditing",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/health-safety/psm-rmp-support/compliance-auditing",
    "url": "/consulting/ehs/health-safety/psm-rmp-support/compliance-auditing",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "Part 63 NESHAP Compliance Support",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/air-quality/NESHAP-and-NSPS-Compliance/part-63-neshap-compliance-support",
    "url": "/consulting/ehs/air-quality/NESHAP-and-NSPS-Compliance/part-63-neshap-compliance-support",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "Compliance Audits",
    "apiurl": "/restapi/customconsultinglvl5content/consulting/ehs/chemical-compliance/PSM-RMP-Support/compliance-audits",
    "url": "/consulting/ehs/chemical-compliance/PSM-RMP-Support/compliance-audits",
    "template": "new-consulting-individual-category-detail-type",
    "section": "environmental-health-safety"
  },
  {
    "name": "Life Science Technical Services",
    "apiurl": "/restapi/customcontent/contact-us/life-science-technical-services",
    "url": "/contact-us/life-science-technical-services",
    "template": "general_content",
    "section": "life-science-technical-services"
  },
  {
    "name": "EHS Consulting",
    "apiurl": "/restapi/customcontent/contact-us/ehs-consulting",
    "url": "/contact-us/ehs-consulting",
    "template": "general_content",
    "section": "ehs-consulting"
  },
  {
    "name": "BREEZE",
    "apiurl": "/restapi/customcontent/contact-us/breeze",
    "url": "/contact-us/breeze",
    "template": "general_content",
    "section": "breeze"
  },
  {
    "name": "Digital Solutions",
    "apiurl": "/restapi/customcontent/contact-us/digital-solutions",
    "url": "/contact-us/digital-solutions",
    "template": "general_content",
    "section": "digital-solutions"
  },
  {
    "name": "General FAQs",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/general-faqs",
    "url": "/software/explosion/exdam/general-faqs",
    "template": "general_content",
    "section": "general-faqs"
  },
  {
    "name": "ExDAM Technical Questions",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/exdam-technical-questions",
    "url": "/software/explosion/exdam/exdam-technical-questions",
    "template": "general_content",
    "section": "exdam-technical-questions"
  },
  {
    "name": "Bio-Pharma Science Services",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/science/biopharma-science-services",
    "url": "/consulting/science/biopharma-science-services",
    "template": "new-consulting-individual-category",
    "section": "science"
  },
  {
    "name": "Bio-Pharma Science Services",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/science/biopharma-science-services",
    "url": "/environmental-consulting/science/biopharma-services",
    "template": "new-consulting-individual-category",
    "section": "science"
  },
  {
    "name": "Bio-Pharma Science Services",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/science/biopharma-science-services",
    "url": "/consulting/science/biopharma-services",
    "template": "new-consulting-individual-category",
    "section": "science"
  },
  {
    "name": "Chemical Compliance",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/ehs/chemical-compliance",
    "url": "/consulting/ehs/chemical-compliance",
    "template": "new-consulting-individual-category",
    "section": "environmental-health-safety"
  },
  {
    "name": "Chemical Compliance",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/ehs/chemical-compliance",
    "url": "/consulting/environmental-health-safety/chemical-compliance",
    "template": "new-consulting-individual-category",
    "section": "environmental-health-safety"
  },
  {
    "name": "Chemical Compliance",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/ehs/chemical-compliance",
    "url": "/environmental-consulting/ehs-services/chemical-compliance",
    "template": "new-consulting-individual-category",
    "section": "environmental-health-safety"
  },
  {
    "name": "Chemical Compliance",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/ehs/chemical-compliance",
    "url": "/consulting/ehs-services/chemical-compliance",
    "template": "new-consulting-individual-category",
    "section": "environmental-health-safety"
  },
  {
    "name": "Air Quality",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/ehs/air-quality",
    "url": "/consulting/ehs/air-quality",
    "template": "new-consulting-individual-category",
    "section": "environmental-health-safety"
  },
  {
    "name": "Process Safety",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/engineering/process-safety",
    "url": "/consulting/engineering/process-safety",
    "template": "new-consulting-individual-category",
    "section": "engineering"
  },
  {
    "name": "Bio-Pharma Engineering Services",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/engineering/biopharma-engineering-services",
    "url": "/consulting/engineering/biopharma-engineering-services",
    "template": "new-consulting-individual-category",
    "section": "engineering"
  },
  {
    "name": "Bio-Pharma Engineering Services",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/engineering/biopharma-engineering-services",
    "url": "/advent/biopharma-services",
    "template": "new-consulting-individual-category",
    "section": "engineering"
  },
  {
    "name": "Bio-Pharma Engineering Services",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/engineering/biopharma-engineering-services",
    "url": "/consulting/engineering/biopharma-services",
    "template": "new-consulting-individual-category",
    "section": "engineering"
  },
  {
    "name": "Toxicology",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/science/toxicology",
    "url": "/consulting/science/toxicology",
    "template": "new-consulting-individual-category",
    "section": "science"
  },
  {
    "name": "Health & Safety",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/ehs/health-safety",
    "url": "/consulting/ehs/health-safety",
    "template": "new-consulting-individual-category",
    "section": "environmental-health-safety"
  },
  {
    "name": "Industrial Hygiene Analytical Laboratory",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/science/industrial-hygiene-analytical-laboratory",
    "url": "/consulting/science/industrial-hygiene-analytical-laboratory",
    "template": "new-consulting-individual-category",
    "section": "science"
  },
  {
    "name": "Pharmacy Compounding Program Support",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/engineering/pharmacy-compounding-program-support",
    "url": "/consulting/engineering/pharmacy-compounding-program-support",
    "template": "new-consulting-individual-category",
    "section": "engineering"
  },
  {
    "name": "EHS Litigation Support",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/ehs/litigation-support",
    "url": "/consulting/ehs/litigation-support",
    "template": "new-consulting-individual-category",
    "section": "environmental-health-safety"
  },
  {
    "name": "Terrestrial Ecology",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/science/terrestrial-ecology",
    "url": "/consulting/science/terrestrial-ecology",
    "template": "new-consulting-individual-category",
    "section": "science"
  },
  {
    "name": "Water Quality",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/ehs/water-quality",
    "url": "/consulting/ehs/water-quality",
    "template": "new-consulting-individual-category",
    "section": "environmental-health-safety"
  },
  {
    "name": "Water Quality",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/ehs/water-quality",
    "url": "/consulting/ehs/water-quality-regulations",
    "template": "new-consulting-individual-category",
    "section": "environmental-health-safety"
  },
  {
    "name": "Waste Management",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/ehs/waste-management",
    "url": "/consulting/ehs/waste-management",
    "template": "new-consulting-individual-category",
    "section": "environmental-health-safety"
  },
  {
    "name": "Waste Management",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/ehs/waste-management",
    "url": "/consulting/environmental-health-safety/waste-management",
    "template": "new-consulting-individual-category",
    "section": "environmental-health-safety"
  },
  {
    "name": "Waste Management",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/ehs/waste-management",
    "url": "/consulting/ehs-services/waste-management",
    "template": "new-consulting-individual-category",
    "section": "environmental-health-safety"
  },
  {
    "name": "Waste Management",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/ehs/waste-management",
    "url": "/environmental-consulting/ehs-services/waste-management",
    "template": "new-consulting-individual-category",
    "section": "environmental-health-safety"
  },
  {
    "name": "EHS Management",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/ehs/ehs-management",
    "url": "/consulting/ehs/ehs-management",
    "template": "new-consulting-individual-category",
    "section": "environmental-health-safety"
  },
  {
    "name": "EHS Management",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/ehs/ehs-management",
    "url": "/environmental-consulting/ehs-services/ehs-management",
    "template": "new-consulting-individual-category",
    "section": "environmental-health-safety"
  },
  {
    "name": "EHS Management",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/ehs/ehs-management",
    "url": "/consulting/environmental-health-safety/ehs-management",
    "template": "new-consulting-individual-category",
    "section": "environmental-health-safety"
  },
  {
    "name": "EHS Management",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/ehs/ehs-management",
    "url": "/consulting/ehs-services/ehs-management",
    "template": "new-consulting-individual-category",
    "section": "environmental-health-safety"
  },
  {
    "name": "Climate Change and Sustainability",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/ehs/climate-change-and-sustainability",
    "url": "/consulting/ehs/climate-change-and-sustainability",
    "template": "new-consulting-individual-category",
    "section": "environmental-health-safety"
  },
  {
    "name": "Tank Roof Design",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/engineering/tank-roof-design",
    "url": "/consulting/engineering/tank-roof-design",
    "template": "new-consulting-individual-category",
    "section": "engineering"
  },
  {
    "name": "Engine Certification",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/engineering/engine-certification",
    "url": "/consulting/engineering/engine-certification",
    "template": "new-consulting-individual-category",
    "section": "engineering"
  },
  {
    "name": "Aquatic Environmental Services",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/science/aquatic-ecology",
    "url": "/consulting/science/aquatic-ecology",
    "template": "new-consulting-individual-category",
    "section": "science"
  },
  {
    "name": "Aquatic Environmental Services",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/science/aquatic-ecology",
    "url": "/environmental-consulting/science2/aquatic-ecology",
    "template": "new-consulting-individual-category",
    "section": "science"
  },
  {
    "name": "Aquatic Environmental Services",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/science/aquatic-ecology",
    "url": "/environmental-consulting/science/aquatic-ecology",
    "template": "new-consulting-individual-category",
    "section": "science"
  },
  {
    "name": "Aquatic Environmental Services",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/science/aquatic-ecology",
    "url": "/consulting/air-quality/aquatic-ecology",
    "template": "new-consulting-individual-category",
    "section": "science"
  },
  {
    "name": "Aquatic Environmental Services",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/science/aquatic-ecology",
    "url": "/consulting/science2/aquatic-ecology",
    "template": "new-consulting-individual-category",
    "section": "science"
  },
  {
    "name": "Ingredient Approval and Product Safety",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/science/ingredient-approval",
    "url": "/consulting/science/ingredient-approval",
    "template": "new-consulting-individual-category",
    "section": "science"
  },
  {
    "name": "Ingredient Approval and Product Safety",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/science/ingredient-approval",
    "url": "/environmental-consulting/science/ingredient-approval",
    "template": "new-consulting-individual-category",
    "section": "science"
  },
  {
    "name": "Ingredient Approval and Product Safety",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/science/ingredient-approval",
    "url": "/environmental-consulting/science/regulatory-services-for-ingredient-approval",
    "template": "new-consulting-individual-category",
    "section": "science"
  },
  {
    "name": "Building Services",
    "apiurl": "/restapi/customconsultinglvl3content/consulting/engineering/building-services",
    "url": "/consulting/engineering/building-services",
    "template": "new-consulting-individual-category",
    "section": "engineering"
  },
  {
    "name": "BRMS Access Request",
    "apiurl": "/restapi/customcontent/software-request-key",
    "url": "/software-request-key",
    "template": "general_content",
    "section": "brms-access-request"
  },
  {
    "name": "Asia & Pacific",
    "apiurl": "/restapi/customcontent/default-mainlocation/asia-pacific",
    "url": "/default-mainlocation/asia-pacific",
    "template": "general_content",
    "section": "asia-pacific"
  },
  {
    "name": "Asia & Pacific",
    "apiurl": "/restapi/customcontent/default-mainlocation/asia-pacific",
    "url": "/asia-pacific",
    "template": "general_content",
    "section": "asia-pacific"
  },
  {
    "name": "Australia",
    "apiurl": "/restapi/customcontent/default-mainlocation/australia",
    "url": "/default-mainlocation/australia",
    "template": "general_content",
    "section": "australia"
  },
  {
    "name": "Australia",
    "apiurl": "/restapi/customcontent/default-mainlocation/australia",
    "url": "/australia",
    "template": "general_content",
    "section": "australia"
  },
  {
    "name": "Asia",
    "apiurl": "/restapi/customcontent/locations/asia",
    "url": "/locations/asia",
    "template": "general_content",
    "section": "asia"
  },
  {
    "name": "Asia",
    "apiurl": "/restapi/customcontent/locations/asia",
    "url": "/locations/asia-pacific",
    "template": "general_content",
    "section": "asia"
  },
  {
    "name": "Australia",
    "apiurl": "/restapi/customcontent/locations/australia",
    "url": "/locations/australia",
    "template": "general_content",
    "section": "australia"
  },
  {
    "name": "Location",
    "apiurl": "/restapi/customcontent/default-mainlocation/location",
    "url": "/default-mainlocation/location",
    "template": "general_content",
    "section": "location"
  },
  {
    "name": "Location",
    "apiurl": "/restapi/customcontent/default-mainlocation/location",
    "url": "/location",
    "template": "general_content",
    "section": "location"
  },
  {
    "name": "North America",
    "apiurl": "/restapi/customcontent/locations/north-america",
    "url": "/locations/north-america",
    "template": "general_content",
    "section": "north-america"
  },
  {
    "name": "North America",
    "apiurl": "/restapi/customcontent/locations/north-america",
    "url": "/location/north-america",
    "template": "general_content",
    "section": "north-america"
  },
  {
    "name": "Europe",
    "apiurl": "/restapi/customcontent/locations/europe",
    "url": "/locations/europe",
    "template": "general_content",
    "section": "europe"
  },
  {
    "name": "North America",
    "apiurl": "/restapi/customcontent/default-mainlocation/northamerica",
    "url": "/default-mainlocation/northamerica",
    "template": "general_content",
    "section": "north-america"
  },
  {
    "name": "North America",
    "apiurl": "/restapi/customcontent/default-mainlocation/northamerica",
    "url": "/northamerica",
    "template": "general_content",
    "section": "north-america"
  },
  {
    "name": "Europe",
    "apiurl": "/restapi/customcontent/default-mainlocation/europe",
    "url": "/default-mainlocation/europe",
    "template": "general_content",
    "section": "europe"
  },
  {
    "name": "Europe",
    "apiurl": "/restapi/customcontent/default-mainlocation/europe",
    "url": "/europe",
    "template": "general_content",
    "section": "europe"
  },
  {
    "name": "Process Design",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/biopharma-engineering-services/process-design",
    "url": "/consulting/engineering/biopharma-engineering-services/process-design",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "Process Design",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/biopharma-engineering-services/process-design",
    "url": "/environmental-consulting/engineering/biopharma-services/process-design",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "Process Design",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/biopharma-engineering-services/process-design",
    "url": "/consulting/engineering/biopharma-services/process-design",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "Hazard Communications and GHS Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/chemical-compliance/Hazard-Communications-and-GHS-services",
    "url": "/consulting/ehs/chemical-compliance/Hazard-Communications-and-GHS-services",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Hazard Communications and GHS Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/chemical-compliance/Hazard-Communications-and-GHS-services",
    "url": "/consulting/ehs/chemical-compliance/Hazard-Communications-and-GHS",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Hazard Communications and GHS Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/chemical-compliance/Hazard-Communications-and-GHS-services",
    "url": "/consulting/ehs/chemical-compliance/hazard-communication-and-ghs-services",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Hazard Communications and GHS Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/chemical-compliance/Hazard-Communications-and-GHS-services",
    "url": "/consulting/ehs/chemical-compliance/Hazard-Communication-and-GHS-Services",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Hazard Communications and GHS Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/chemical-compliance/Hazard-Communications-and-GHS-services",
    "url": "/consulting/ehs/chemical-compliance/Hazard-Communication-and-GHS",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "LDAR Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/air-quality/LDAR-Support",
    "url": "/consulting/ehs/air-quality/LDAR-Support",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Fuels Regulations Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/air-quality/fuels-regulations",
    "url": "/consulting/ehs/air-quality/fuels-regulations",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Fuels Regulations Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/air-quality/fuels-regulations",
    "url": "/consulting/ehs/air-quality/fuels-regulations-services",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Lighting Impact\tServices",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/building-services/lighting-impact-services",
    "url": "/consulting/engineering/building-services/lighting-impact-services",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "Lighting Impact\tServices",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/building-services/lighting-impact-services",
    "url": "/environmental-consulting/engineering/building-services/lighting-impact-services",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "Tank Roof Design Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/tank-roof-design/tank-roof-design-services",
    "url": "/consulting/engineering/tank-roof-design/tank-roof-design-services",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "NESHAP and NSPS Compliance",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/air-quality/NESHAP-and-NSPS-Compliance",
    "url": "/consulting/ehs/air-quality/NESHAP-and-NSPS-Compliance",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Analytical Methods",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/industrial-hygiene-analytical-laboratory/analytical-methods",
    "url": "/consulting/science/industrial-hygiene-analytical-laboratory/analytical-methods",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Sample Analysis",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/industrial-hygiene-analytical-laboratory/sample-analysis",
    "url": "/consulting/science/industrial-hygiene-analytical-laboratory/sample-analysis",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Sample Analysis",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/industrial-hygiene-analytical-laboratory/sample-analysis",
    "url": "/environmental-consulting/science/industrial-hygiene-analytical-laboratory/sample-analysis",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Due Diligence Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/Due-Diligence-Support",
    "url": "/consulting/ehs/ehs-management/Due-Diligence-Support",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Due Diligence Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/Due-Diligence-Support",
    "url": "/environmental-consulting/ehs-services/ehs-management/Due-Diligence-Support",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Due Diligence Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/Due-Diligence-Support",
    "url": "/consulting/ehs-services/ehs-management/Due-Diligence-Support",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Statistical Analysis of Environmental Data",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/statistical-analysis-environmental-data",
    "url": "/consulting/science/aquatic-ecology/statistical-analysis-environmental-data",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Statistical Analysis of Environmental Data",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/statistical-analysis-environmental-data",
    "url": "/consulting/science/aquatic-ecology/statistical-analysis-of-environmental-data",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Statistical Analysis of Environmental Data",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/statistical-analysis-environmental-data",
    "url": "/environmental-consulting/science/aquatic-ecology/statistical-analysis-of-environmental-data",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Fish and Fish Habitat Studies",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/fish-and-fish-habitat-studies",
    "url": "/consulting/science/aquatic-ecology/fish-and-fish-habitat-studies",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Fish and Fish Habitat Studies",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/fish-and-fish-habitat-studies",
    "url": "/environmental-consulting/science/aquatic-ecology/fish-and-fish-habitat-studies",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "sample string 823",
    "apiurl": "/restapi/customconsultinglvl4content/sampledata1",
    "url": "/sampledata1",
    "template": "new-consulting-individual-category-detail",
    "section": "sample-string-823"
  },
  {
    "name": "EHS Management Systems",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/EHS-Management-Systems",
    "url": "/consulting/ehs/ehs-management/EHS-Management-Systems",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "EHS Management Systems",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/EHS-Management-Systems",
    "url": "/consulting/ehs-services/ehs-management/EHS-Management-Systems",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "EHS Management Systems",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/EHS-Management-Systems",
    "url": "/environmental-consulting/ehs-services/ehs-management/EHS-Management-Systems",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Toxic Release Inventory (TRI)",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/chemical-compliance/Toxic-Release-Inventory",
    "url": "/consulting/ehs/chemical-compliance/Toxic-Release-Inventory",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Toxic Release Inventory (TRI)",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/chemical-compliance/Toxic-Release-Inventory",
    "url": "/consulting/ehs/chemical-compliance/Toxics-Release-Inventory",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Toxic Substance Control Act & Reporting Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/chemical-compliance/toxic-substance-control-act-and-reporting",
    "url": "/consulting/ehs/chemical-compliance/toxic-substance-control-act-and-reporting",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Toxic Substance Control Act & Reporting Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/chemical-compliance/toxic-substance-control-act-and-reporting",
    "url": "/environmental-consulting/ehs-services/chemical-compliance/toxic-substance-control-act-tsca-reporting-services",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Toxic Substance Control Act & Reporting Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/chemical-compliance/toxic-substance-control-act-and-reporting",
    "url": "/services/chemical-compliance/toxic-substance-control-act-and-reporting-services",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Toxic Substance Control Act & Reporting Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/chemical-compliance/toxic-substance-control-act-and-reporting",
    "url": "/consulting/ehs-services/chemical-compliance/toxic-substance-control-act-tsca-reporting-services",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Toxic Substance Control Act & Reporting Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/chemical-compliance/toxic-substance-control-act-and-reporting",
    "url": "/consulting/ehs/chemical-compliance/toxic-substance-control-act-and-reporting-services",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Toxic Substance Control Act & Reporting Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/chemical-compliance/toxic-substance-control-act-and-reporting",
    "url": "/consulting/ehs/chemical-compliance/toxic-substance-control-act-tsca-reporting-services",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Industrial Air Quality Litigation Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/litigation-support/industrial-air-quality-litigation",
    "url": "/consulting/ehs/litigation-support/industrial-air-quality-litigation",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Industrial Air Quality Litigation Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/litigation-support/industrial-air-quality-litigation",
    "url": "/consulting/ehs/litigation-support/industrial-air-quality-litigation-support",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Permitting and Compliance",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/water-quality/Permitting-and-Compliance",
    "url": "/consulting/ehs/water-quality/Permitting-and-Compliance",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Permitting and Compliance",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/water-quality/Permitting-and-Compliance",
    "url": "/consulting/ehs-services/water-quality-regulations/Permitting-and-Compliance",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Permitting and Compliance",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/water-quality/Permitting-and-Compliance",
    "url": "/environmental-consulting/ehs-services/water-quality-regulations/Permitting-and-Compliance",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Permitting and Compliance",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/water-quality/Permitting-and-Compliance",
    "url": "/consulting/ehs/water-quality-regulations/Permitting-and-Compliance",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Ecological Assessment",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/terrestrial-ecology/ecological-assessment",
    "url": "/consulting/science/terrestrial-ecology/ecological-assessment",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Ecological Assessment",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/terrestrial-ecology/ecological-assessment",
    "url": "/consulting/science/terrestrial-ecology/planning-applications-development",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Weather Related Litigation Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/litigation-support/weather-related-litigation",
    "url": "/consulting/ehs/litigation-support/weather-related-litigation",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Weather Related Litigation Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/litigation-support/weather-related-litigation",
    "url": "/consulting/ehs/litigation-support/weather-related-litigation-support",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "NEPA and CEQA Environmental Impact Assessment",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/NEPA-and-CEQA-Environmental-Impact-Assessment",
    "url": "/consulting/ehs/ehs-management/NEPA-and-CEQA-Environmental-Impact-Assessment",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "NEPA and CEQA Environmental Impact Assessment",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/NEPA-and-CEQA-Environmental-Impact-Assessment",
    "url": "/environmental-consulting/ehs-services/ehs-management/NEPA-and-CEQA-Environmental-Impact-Assessment",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "NEPA and CEQA Environmental Impact Assessment",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/NEPA-and-CEQA-Environmental-Impact-Assessment",
    "url": "/consulting/ehs-services/ehs-management/NEPA-and-CEQA-Environmental-Impact-Assessment",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Industrial Odor Analysis",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/Odor-Analysis",
    "url": "/consulting/ehs/ehs-management/Odor-Analysis",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Industrial Odor Analysis",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/Odor-Analysis",
    "url": "/consulting/ehs-services/ehs-management/Odor-Analysis",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Industrial Odor Analysis",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/Odor-Analysis",
    "url": "/environmental-consulting/ehs-services/ehs-management/Odor-Analysis",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "sample string 8",
    "apiurl": "/restapi/customconsultinglvl4content/sampledata",
    "url": "/sampledata",
    "template": "new-consulting-individual-category-detail",
    "section": "sample-string-8"
  },
  {
    "name": "Commissioning, Qualification and Validation",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/biopharma-engineering-services/commissioning-qualification-and-validation",
    "url": "/consulting/engineering/biopharma-engineering-services/commissioning-qualification-and-validation",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "Commissioning, Qualification and Validation",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/biopharma-engineering-services/commissioning-qualification-and-validation",
    "url": "/consulting/engineering/biopharma-services/commissioning-qualification-and-validation",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "Commissioning, Qualification and Validation",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/biopharma-engineering-services/commissioning-qualification-and-validation",
    "url": "/environmental-consulting/engineering/biopharma-services/commissioning-qualification-and-validation",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "Overview",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/litigation-support/overview",
    "url": "/consulting/ehs/litigation-support/overview",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Technical Support and Training",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/technical-support-and-training",
    "url": "/consulting/science/aquatic-ecology/technical-support-and-training",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Technical Support and Training",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/technical-support-and-training",
    "url": "/environmental-consulting/science/aquatic-ecology/technical-support-and-training",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Quality Assurance",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/ingredient-approval/quality-assurance",
    "url": "/consulting/science/ingredient-approval/quality-assurance",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Quality Assurance",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/ingredient-approval/quality-assurance",
    "url": "/environmental-consulting/science/regulatory-services-for-ingredient-approval/quality-assurance",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Quality Assurance",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/ingredient-approval/quality-assurance",
    "url": "/environmental-consulting/science/ingredient-approval/quality-assurance",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Aquatic Biology",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/water-quality/Aquatic-Biology",
    "url": "/consulting/ehs/water-quality/Aquatic-Biology",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Aquatic Biology",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/water-quality/Aquatic-Biology",
    "url": "/consulting/ehs-services/water-quality-regulations/Aquatic-Biology",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Aquatic Biology",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/water-quality/Aquatic-Biology",
    "url": "/environmental-consulting/ehs-services/water-quality-regulations/Aquatic-Biology",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Aquatic Biology",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/water-quality/Aquatic-Biology",
    "url": "/consulting/ehs/water-quality-regulations/Aquatic-Biology",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Regional Haze Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/air-quality/Regional-Haze",
    "url": "/consulting/ehs/air-quality/Regional-Haze",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Pharmacy Compounding Program Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/pharmacy-compounding-program-support/pharmacy-compounding-program-support",
    "url": "/consulting/engineering/pharmacy-compounding-program-support/pharmacy-compounding-program-support",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "Ecological Survey",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/terrestrial-ecology/ecological-survey",
    "url": "/consulting/science/terrestrial-ecology/ecological-survey",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Ecological Survey",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/terrestrial-ecology/ecological-survey",
    "url": "/consulting/science/terrestrial-ecology/ecological-survey-and-assessment",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Ambient Monitoring and Service Integration",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/air-quality/ambient-monitoring-service-integration",
    "url": "/consulting/ehs/air-quality/ambient-monitoring-service-integration",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Ambient Monitoring and Service Integration",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/air-quality/ambient-monitoring-service-integration",
    "url": "/consulting/ehs/air-quality/ambient-and-meteorological-monitoring",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Environmental Geochemistry",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/environmental-geochemistry",
    "url": "/consulting/science/aquatic-ecology/environmental-geochemistry",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Environmental Geochemistry",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/environmental-geochemistry",
    "url": "/environmental-consulting/science/aquatic-ecology/environmental-geochemistry",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Regulatory Permitting, Authorizations, and Compliance",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/regulatory-permitting-authorizations-and-compliance",
    "url": "/consulting/science/aquatic-ecology/regulatory-permitting-authorizations-and-compliance",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Environmental Effects Monitoring (EEM)",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/environmental-effects-monitoring",
    "url": "/consulting/science/aquatic-ecology/environmental-effects-monitoring",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Environmental Effects Monitoring (EEM)",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/environmental-effects-monitoring",
    "url": "/consulting/science/aquatic-ecology/environmental-effects-monitoring-eem",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Health Risk Assessment",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/health-safety/Health-Risk-Assessment",
    "url": "/consulting/ehs/health-safety/Health-Risk-Assessment",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Health Risk Assessment",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/health-safety/Health-Risk-Assessment",
    "url": "/consulting/ehs/health-safety/Risk-Assessment",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Tank Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/Tank-Services",
    "url": "/consulting/ehs/ehs-management/Tank-Services",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Tank Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/Tank-Services",
    "url": "/environmental-consulting/ehs-services/ehs-management/Tank-Services",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Tank Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/Tank-Services",
    "url": "/consulting/ehs-services/ehs-management/Tank-Services",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Environmental and Sustainability Reporting",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/Environmental-and-Sustainability-Reporting",
    "url": "/consulting/ehs/ehs-management/Environmental-and-Sustainability-Reporting",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Environmental and Sustainability Reporting",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/Environmental-and-Sustainability-Reporting",
    "url": "/environmental-consulting/ehs-services/ehs-management/Environmental-and-Sustainability-Reporting",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Environmental and Sustainability Reporting",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/Environmental-and-Sustainability-Reporting",
    "url": "/consulting/ehs-services/ehs-management/Environmental-and-Sustainability-Reporting",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Building Acoustics Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/building-services/acoustics-support",
    "url": "/consulting/engineering/building-services/acoustics-support",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "Mobile Source Support and Engine Certification",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/engine-certification/mobile-source-support-and-engine-certification",
    "url": "/consulting/engineering/engine-certification/mobile-source-support-and-engine-certification",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "Mobile Source Support and Engine Certification",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/engine-certification/mobile-source-support-and-engine-certification",
    "url": "/environmental-consulting/engineering/engine-certification/mobile-source-support-and-engine-certification",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "CDP Verification and Assurance",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/climate-change-and-sustainability/cdp-verification-and-assurance",
    "url": "/consulting/ehs/climate-change-and-sustainability/cdp-verification-and-assurance",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "CDP Verification and Assurance",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/climate-change-and-sustainability/cdp-verification-and-assurance",
    "url": "/consulting/ehs/ehs-management/CDP-Verification-and-Assurance",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Air Dispersion Modeling",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/air-quality/Air-Dispersion-Modeling",
    "url": "/consulting/ehs/air-quality/Air-Dispersion-Modeling",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Process Safety Management/Risk Management Program Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/health-safety/psm-rmp-support",
    "url": "/consulting/ehs/health-safety/psm-rmp-support",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Process Safety Management/Risk Management Program Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/health-safety/psm-rmp-support",
    "url": "/consulting/ehs/chemical-compliance/psm-rmp-compliance",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Ecological Mitigation and Enhancement",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/terrestrial-ecology/ecological-mitigation-enhancement",
    "url": "/consulting/science/terrestrial-ecology/ecological-mitigation-enhancement",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Ecological Mitigation and Enhancement",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/terrestrial-ecology/ecological-mitigation-enhancement",
    "url": "/consulting/science/terrestrial-ecology/biodiversity-mitigation-solutions",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Monitoring and Sampling Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/water-quality/monitoring-sampling",
    "url": "/consulting/ehs/water-quality/monitoring-sampling",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Monitoring and Sampling Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/water-quality/monitoring-sampling",
    "url": "/environmental-consulting/ehs-services/water-quality-regulations/monitoring-sampling",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Monitoring and Sampling Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/water-quality/monitoring-sampling",
    "url": "/consulting/ehs/water-quality-regulations/monitoring-sampling",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Monitoring and Sampling Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/water-quality/monitoring-sampling",
    "url": "/consulting/ehs-services/water-quality-regulations/monitoring-sampling",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Analytical Laboratory",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/industrial-hygiene-analytical-laboratory/analytical-laboratory",
    "url": "/consulting/science/industrial-hygiene-analytical-laboratory/analytical-laboratory",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Safety Testing Program Management",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/ingredient-approval/study-design",
    "url": "/consulting/science/ingredient-approval/study-design",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Safety Testing Program Management",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/ingredient-approval/study-design",
    "url": "/environmental-consulting/science/ingredient-approval/study-design",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Aquatic Biological and Ecological Assessment",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/aquatic-biological-and-ecological-assessment",
    "url": "/consulting/science/aquatic-ecology/aquatic-biological-and-ecological-assessment",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Aquatic Biological and Ecological Assessment",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/aquatic-biological-and-ecological-assessment",
    "url": "/environmental-consulting/science/aquatic-ecology/aquatic-biological-and-ecological-assessment",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Aquatic Environmental Monitoring and Assessment",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/aquatic-environmental-monitoring-and-assessment",
    "url": "/consulting/science/aquatic-ecology/aquatic-environmental-monitoring-and-assessment",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Aquatic Environmental Monitoring and Assessment",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/aquatic-environmental-monitoring-and-assessment",
    "url": "/environmental-consulting/science/aquatic-ecology/aquatic-environmental-monitoring-and-assessment",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Contaminant Dispersion and Hydrodynamic Mixing in Aquatic Systems",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/contaminant-dispersion-hydrodynamic-mixing",
    "url": "/consulting/science/aquatic-ecology/contaminant-dispersion-hydrodynamic-mixing",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Contaminant Dispersion and Hydrodynamic Mixing in Aquatic Systems",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/contaminant-dispersion-hydrodynamic-mixing",
    "url": "/consulting/science/aquatic-ecology/contaminant-dispersion-and-hydrodynamic-mixing-in-aquatic-systems",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Contaminant Dispersion and Hydrodynamic Mixing in Aquatic Systems",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/contaminant-dispersion-hydrodynamic-mixing",
    "url": "/environmental-consulting/science/aquatic-ecology/contaminant-dispersion-and-hydrodynamic-mixing-in-aquatic-systems",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "CDP Verification and Assurance",
    "apiurl": "/restapi/customconsultinglvl4content/cdp-verification-and-assurance",
    "url": "/cdp-verification-and-assurance",
    "template": "new-consulting-individual-category-detail",
    "section": "cdp-verification-and-assurance"
  },
  {
    "name": "Industrial Hygiene and Occupational Safety",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/health-safety/industrial-hygiene-occupational-safety",
    "url": "/consulting/ehs/health-safety/industrial-hygiene-occupational-safety",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Industrial Hygiene and Occupational Safety",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/health-safety/industrial-hygiene-occupational-safety",
    "url": "/consulting/ehs/health-safety/industrial-hygiene-and-occupational-safety-services",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Pandemic Response Planning",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/health-safety/pandemic-response-planning",
    "url": "/consulting/ehs/health-safety/pandemic-response-planning",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Pandemic Response Planning",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/health-safety/pandemic-response-planning",
    "url": "/consulting/ehs/health-safety/pandemic-response-plan",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "PSI & Data Management",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/process-safety/psi-data-management",
    "url": "/consulting/engineering/process-safety/psi-data-management",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "Antimicrobials and Specialty Chemical Regulatory Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/ingredient-approval/antimicrobials-and-specialty-chemical-regulatory-support",
    "url": "/consulting/science/ingredient-approval/antimicrobials-and-specialty-chemical-regulatory-support",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Cap-and-Trade Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/air-quality/Cap-and-Trade",
    "url": "/consulting/ehs/air-quality/Cap-and-Trade",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Cap-and-Trade Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/air-quality/Cap-and-Trade",
    "url": "/consulting/ehs/air-quality/Cap-and-Trade-Services",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Toxicology Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/toxicology/toxicology-services",
    "url": "/consulting/science/toxicology/toxicology-services",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Environmental Health & Safety Program Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/health-safety/EHS",
    "url": "/consulting/ehs/health-safety/EHS",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Environmental Health & Safety Program Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/health-safety/EHS",
    "url": "/consulting/environmental-health-safety/health-safety/EHS",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Environmental Health & Safety Program Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/health-safety/EHS",
    "url": "/environmental-consulting/ehs-services/health-safety/EHS",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Environmental Health & Safety Program Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/health-safety/EHS",
    "url": "/consulting/ehs-services/health-safety/EHS",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "California Proposition 65 Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/chemical-compliance/California-Proposition-65",
    "url": "/consulting/ehs/chemical-compliance/California-Proposition-65",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "California Proposition 65 Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/chemical-compliance/California-Proposition-65",
    "url": "/consulting/ehs/chemical-compliance/California-Proposition-65-Support",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Pressure Relief Systems",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/process-safety/pressure-relief-systems",
    "url": "/consulting/engineering/process-safety/pressure-relief-systems",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "Industrial Hygiene for Life Sciences",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/health-safety/industrial-hygiene-for-life-sciences",
    "url": "/consulting/ehs/health-safety/industrial-hygiene-for-life-sciences",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "CFATS Compliance",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/chemical-compliance/CFATS-Compliance",
    "url": "/consulting/ehs/chemical-compliance/CFATS-Compliance",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Energy Management",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/climate-change-and-sustainability/energy-management",
    "url": "/consulting/ehs/climate-change-and-sustainability/energy-management",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Energy Management",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/climate-change-and-sustainability/energy-management",
    "url": "/consulting/ehs/ehs-management/Energy-Management",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Enterprise Sustainability Program Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/climate-change-and-sustainability/enterprise-sustainability-program-support",
    "url": "/consulting/ehs/climate-change-and-sustainability/enterprise-sustainability-program-support",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Combustible Dust Risk Management",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/health-safety/combustible-dust-risk-management",
    "url": "/consulting/ehs/health-safety/combustible-dust-risk-management",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Combustible Dust Risk Management",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/health-safety/combustible-dust-risk-management",
    "url": "/Services/EHS-Management/Combustible-Dust-Risk-Management/",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Air Quality Permitting",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/air-quality/Air-Quality-Permitting",
    "url": "/consulting/ehs/air-quality/Air-Quality-Permitting",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Air Quality Permitting",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/air-quality/Air-Quality-Permitting",
    "url": "/consulting/ehs-services/air-quality/Air-Quality-Permitting",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Air Quality Permitting",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/air-quality/Air-Quality-Permitting",
    "url": "/environmental-consulting/ehs-services/air-quality/Air-Quality-Permitting",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Environmental Justice",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/environmental-justice",
    "url": "/consulting/ehs/ehs-management/environmental-justice",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Emissions Inventory and Reporting",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/air-quality/Emissions-Reporting",
    "url": "/consulting/ehs/air-quality/Emissions-Reporting",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Ecological Licensing, Mitigation and Enhancement",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/terrestrial-ecology/ecological-licensing-mitigation-enhancement",
    "url": "/consulting/science/terrestrial-ecology/ecological-licensing-mitigation-enhancement",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Ecological Licensing, Mitigation and Enhancement",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/terrestrial-ecology/ecological-licensing-mitigation-enhancement",
    "url": "/consulting/science/terrestrial-ecology/ecological-contracting",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "General Process Safety Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/process-safety/general-process-safety-services",
    "url": "/consulting/engineering/process-safety/general-process-safety-services",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "General Process Safety Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/process-safety/general-process-safety-services",
    "url": "/consulting/engineering/process-safety/general-process-safety",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "Process Development for Biopharmaceuticals",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/biopharma-science-services/process-development-for-pharmaceuticals",
    "url": "/consulting/science/biopharma-science-services/process-development-for-pharmaceuticals",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Process Development for Biopharmaceuticals",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/biopharma-science-services/process-development-for-pharmaceuticals",
    "url": "/consulting/science/biopharma-services/process-development-for-pharmaceuticals",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Aquatic Habitat Evaluations",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/aquatic-habitat-evaluations",
    "url": "/consulting/science/aquatic-ecology/aquatic-habitat-evaluations",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Aquatic Habitat Evaluations",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/aquatic-habitat-evaluations",
    "url": "/environmental-consulting/science/aquatic-ecology/aquatic-habitat-evaluations",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Emissions Testing",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/air-quality/Emissions-Testing",
    "url": "/consulting/ehs/air-quality/Emissions-Testing",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Emissions Testing",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/air-quality/Emissions-Testing",
    "url": "/consulting/ehs-services/air-quality/Emissions-Testing",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Emissions Testing",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/air-quality/Emissions-Testing",
    "url": "/environmental-consulting/ehs-services/air-quality/Emissions-Testing",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "EHS Business Risk Management",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/EHS-Business-Risk-Management",
    "url": "/consulting/ehs/ehs-management/EHS-Business-Risk-Management",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "EHS Business Risk Management",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/EHS-Business-Risk-Management",
    "url": "/environmental-consulting/ehs-services/ehs-management/EHS-Business-Risk-Management",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "EHS Business Risk Management",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/EHS-Business-Risk-Management",
    "url": "/consulting/ehs-services/ehs-management/EHS-Business-Risk-Management",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Photochemical Grid Modeling",
    "apiurl": "/restapi/customconsultinglvl4content/photochemical-grid-modeling",
    "url": "/photochemical-grid-modeling",
    "template": "new-consulting-individual-category-detail",
    "section": "photochemical-grid-modeling"
  },
  {
    "name": "Automation Engineering",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/biopharma-engineering-services/automation-engineering",
    "url": "/consulting/engineering/biopharma-engineering-services/automation-engineering",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "Automation Engineering",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/biopharma-engineering-services/automation-engineering",
    "url": "/environmental-consulting/engineering/biopharma-services/automation-engineering-technology",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "Automation Engineering",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/biopharma-engineering-services/automation-engineering",
    "url": "/consulting/engineering/biopharma-services/automation-engineering-technology",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "Automation Engineering",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/biopharma-engineering-services/automation-engineering",
    "url": "/consulting/engineering/biopharma-services/automation-engineering",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "Aquatic Toxicological Studies",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/aquatic-toxicological-studies",
    "url": "/consulting/science/aquatic-ecology/aquatic-toxicological-studies",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Aquatic Toxicological Studies",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/aquatic-toxicological-studies",
    "url": "/environmental-consulting/science/aquatic-ecology/aquatic-toxicological-studies",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Analytical Laboratory",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/health-safety/Analytical-Laboratory",
    "url": "/consulting/ehs/health-safety/Analytical-Laboratory",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Aquatic Chemistry Studies",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/aquatic-chemistry-studies",
    "url": "/consulting/science/aquatic-ecology/aquatic-chemistry-studies",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Aquatic Chemistry Studies",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/aquatic-chemistry-studies",
    "url": "/environmental-consulting/science/aquatic-ecology/6-aquatic-chemistry-studies",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Aquatic Chemistry Studies",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/aquatic-chemistry-studies",
    "url": "/consulting/science/aquatic-ecology/6-aquatic-chemistry-studies",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Potent Compound Safety Certification",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/health-safety/Potent-Compound-Safety",
    "url": "/consulting/ehs/health-safety/Potent-Compound-Safety",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Potent Compound Safety Certification",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/health-safety/Potent-Compound-Safety",
    "url": "/consulting/ehs-services/health-safety/Potent-Compound-Safety-Triangle",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Potent Compound Safety Certification",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/health-safety/Potent-Compound-Safety",
    "url": "/environmental-consulting/ehs-services/health-safety/Potent-Compound-Safety-Triangle",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Potent Compound Safety Certification",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/health-safety/Potent-Compound-Safety",
    "url": "/consulting/ehs/health-safety/Potent-Compound-Safety-Triangle",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Potent Compound Safety Certification",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/health-safety/Potent-Compound-Safety",
    "url": "/consulting/environmental-health-safety/health-safety/Potent-Compound-Safety-Triangle",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "California Third-Party Verification Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/climate-change-and-sustainability/california-third-party-verification-services",
    "url": "/consulting/ehs/climate-change-and-sustainability/california-third-party-verification-services",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "California Third-Party Verification Services",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/climate-change-and-sustainability/california-third-party-verification-services",
    "url": "/consulting/ehs/ehs-management/california-third-party-verification-services",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Project Management",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/biopharma-engineering-services/project-management",
    "url": "/consulting/engineering/biopharma-engineering-services/project-management",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "Project Management",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/biopharma-engineering-services/project-management",
    "url": "/environmental-consulting/engineering/biopharma-services/project-management",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "Project Management",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/biopharma-engineering-services/project-management",
    "url": "/consulting/engineering/biopharma-services/project-management",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "Industrial and Solid Waste Management",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/waste-management/Industrial-and-Solid-Waste-Management",
    "url": "/consulting/ehs/waste-management/Industrial-and-Solid-Waste-Management",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Spill Prevention, Control, and Countermeasure Plan",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/water-quality/Spill-Prevention-Control-Countermeasure-Plan",
    "url": "/consulting/ehs/water-quality/Spill-Prevention-Control-Countermeasure-Plan",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Spill Prevention, Control, and Countermeasure Plan",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/water-quality/Spill-Prevention-Control-Countermeasure-Plan",
    "url": "/consulting/ehs/water-quality-regulations/Spill-Prevention-Control-Countermeasure-Plan",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Spill Prevention, Control, and Countermeasure Plan",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/water-quality/Spill-Prevention-Control-Countermeasure-Plan",
    "url": "/consulting/ehs/water-quality-regulations/Spill-Prevention-Control-and-Countermeasure-Plan",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Mechanical Integrity & Inspections",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/process-safety/mechanical-integrity-inspections",
    "url": "/consulting/engineering/process-safety/mechanical-integrity-inspections",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "Mechanical Integrity & Inspections",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/process-safety/mechanical-integrity-inspections",
    "url": "/consulting/engineering/process-safety/fixed-equipment-mechanical-integrity-inspections",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "Emissions Monitoring Support (CEMS)",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/air-quality/Emissions-Monitoring-Support",
    "url": "/consulting/ehs/air-quality/Emissions-Monitoring-Support",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Combustion Specialty",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/waste-management/Combustion-Specialty",
    "url": "/consulting/ehs/waste-management/Combustion-Specialty",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Sustainability Program Implementation and Management",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/climate-change-and-sustainability/sustainability-program-implementation-and-management",
    "url": "/consulting/ehs/climate-change-and-sustainability/sustainability-program-implementation-and-management",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Noise and Vibration",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/Noise-and-Vibration",
    "url": "/consulting/ehs/ehs-management/Noise-and-Vibration",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Noise and Vibration",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/Noise-and-Vibration",
    "url": "/environmental-consulting/ehs-services/ehs-management/Noise-and-Vibration",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Noise and Vibration",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/Noise-and-Vibration",
    "url": "/consulting/ehs-services/ehs-management/Noise-and-Vibration",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Sustainability Strategy Development",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/climate-change-and-sustainability/sustainability-strategy-development",
    "url": "/consulting/ehs/climate-change-and-sustainability/sustainability-strategy-development",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Aquatic Environmental Impact Assessment",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/aquatic-environmental-impact-assessment",
    "url": "/consulting/science/aquatic-ecology/aquatic-environmental-impact-assessment",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Aquatic Environmental Impact Assessment",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/aquatic-environmental-impact-assessment",
    "url": "/environmental-consulting/science/aquatic-ecology/aquatic-environmental-impact-assessment",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Food and Beverage Regulatory Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/ingredient-approval/food-and-beverage-regulatory-support",
    "url": "/consulting/science/ingredient-approval/food-and-beverage-regulatory-support",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Auditing and Verification",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/Auditing-and-Verification",
    "url": "/consulting/ehs/ehs-management/Auditing-and-Verification",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Auditing and Verification",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/Auditing-and-Verification",
    "url": "/auditing-and-verification",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Auditing and Verification",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/Auditing-and-Verification",
    "url": "/environmental-consulting/ehs-services/ehs-management/Auditing-and-Verification",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Auditing and Verification",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/ehs-management/Auditing-and-Verification",
    "url": "/consulting/ehs-services/ehs-management/Auditing-and-Verification",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Chemical Inventory Reporting",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/chemical-compliance/chemical-inventory-reporting",
    "url": "/consulting/ehs/chemical-compliance/chemical-inventory-reporting",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "PSM / RMP Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/chemical-compliance/PSM-RMP-Support",
    "url": "/consulting/ehs/chemical-compliance/PSM-RMP-Support",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "PSM / RMP Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/chemical-compliance/PSM-RMP-Support",
    "url": "/environmental-consulting/ehs-services/chemical-compliance/PSM-RMP-Support",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "PSM / RMP Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/chemical-compliance/PSM-RMP-Support",
    "url": "/consulting/ehs-services/chemical-compliance/PSM-RMP-Support",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "IPL Lifecycle Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/process-safety/ipl-lifecycle-support",
    "url": "/consulting/engineering/process-safety/ipl-lifecycle-support",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "Aquatic Environmental Monitoring",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/aquatic-ecology/aquatic-environmental-monitoring",
    "url": "/consulting/science/aquatic-ecology/aquatic-environmental-monitoring",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Air Quality and Noise Litigation Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/litigation-support/air-quality-noise-litigation",
    "url": "/consulting/ehs/litigation-support/air-quality-noise-litigation",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Air Quality and Noise Litigation Support",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/litigation-support/air-quality-noise-litigation",
    "url": "/consulting/ehs/litigation-support/air-quality-noise-litigation-support",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "PHA and Risk Assessments",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/process-safety/pha-and-risk-assessments",
    "url": "/consulting/engineering/process-safety/pha-and-risk-assessments",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "PHA and Risk Assessments",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/engineering/process-safety/pha-and-risk-assessments",
    "url": "/consulting/engineering/process-safety/pha-risk-assessments",
    "template": "new-consulting-individual-category-detail",
    "section": "engineering"
  },
  {
    "name": "Safety and Loss Control",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/health-safety/Safety-Loss-Control",
    "url": "/consulting/ehs/health-safety/Safety-Loss-Control",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Safety and Loss Control",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/health-safety/Safety-Loss-Control",
    "url": "/consulting/ehs/health-safety/Safety-and-Loss-Control",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Refrigerant Management Services (ODS)",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/chemical-compliance/refrigerant-management",
    "url": "/consulting/ehs/chemical-compliance/refrigerant-management",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Refrigerant Management Services (ODS)",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/chemical-compliance/refrigerant-management",
    "url": "/consulting/ehs/chemical-compliance/refrigerant-management-services",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Scientific and Regulatory Affairs",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/ingredient-approval/regulatory-interface",
    "url": "/consulting/science/ingredient-approval/regulatory-interface",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Scientific and Regulatory Affairs",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/ingredient-approval/regulatory-interface",
    "url": "/environmental-consulting/science/ingredient-approval/regulatory-interface",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Scientific and Regulatory Affairs",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/science/ingredient-approval/regulatory-interface",
    "url": "/environmental-consulting/science/regulatory-services-for-ingredient-approval/regulatory-interface",
    "template": "new-consulting-individual-category-detail",
    "section": "science"
  },
  {
    "name": "Facility Response Plans (FRP)",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/chemical-compliance/facility-response-plans-frp",
    "url": "/consulting/ehs/chemical-compliance/facility-response-plans-frp",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Alternative Fuels and Beneficial Reuse",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/waste-management/Alternative-Fuel-Beneficial-Reuse",
    "url": "/consulting/ehs/waste-management/Alternative-Fuel-Beneficial-Reuse",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Alternative Fuels and Beneficial Reuse",
    "apiurl": "/restapi/customconsultinglvl4content/consulting/ehs/waste-management/Alternative-Fuel-Beneficial-Reuse",
    "url": "/consulting/ehs/waste-management/Alternative-Fuel-and-Beneficial-Reuse",
    "template": "new-consulting-individual-category-detail",
    "section": "environmental-health-safety"
  },
  {
    "name": "Romania",
    "apiurl": "/restapi/customcontent/contact-us/romania",
    "url": "/contact-us/romania",
    "template": "general_content",
    "section": "romania"
  },
  {
    "name": "Bangladesh",
    "apiurl": "/restapi/customcontent/contact-us/bangladesh",
    "url": "/contact-us/bangladesh",
    "template": "general_content",
    "section": "bangladesh"
  },
  {
    "name": "Nepal",
    "apiurl": "/restapi/customcontent/contact-us/nepal",
    "url": "/contact-us/nepal",
    "template": "general_content",
    "section": "nepal"
  },
  {
    "name": "Malaysia",
    "apiurl": "/restapi/customcontent/contact-us/malaysia",
    "url": "/contact-us/malaysia",
    "template": "general_content",
    "section": "malaysia"
  },
  {
    "name": "Indonesia",
    "apiurl": "/restapi/customcontent/contact-us/indonesia",
    "url": "/contact-us/indonesia",
    "template": "general_content",
    "section": "indonesia"
  },
  {
    "name": "Mexico",
    "apiurl": "/restapi/customcontent/contact-us/mexico",
    "url": "/contact-us/mexico",
    "template": "general_content",
    "section": "mexico"
  },
  {
    "name": "Brazil",
    "apiurl": "/restapi/customcontent/contact-us/brazil",
    "url": "/contact-us/brazil",
    "template": "general_content",
    "section": "brazil"
  },
  {
    "name": "South Africa",
    "apiurl": "/restapi/customcontent/contact-us/south-africa",
    "url": "/contact-us/south-africa",
    "template": "general_content",
    "section": "south-africa"
  },
  {
    "name": "Turkey",
    "apiurl": "/restapi/customcontent/contact-us/turkey",
    "url": "/contact-us/turkey",
    "template": "general_content",
    "section": "turkey"
  },
  {
    "name": "Singapore",
    "apiurl": "/restapi/customcontent/contact-us/singapore",
    "url": "/contact-us/singapore",
    "template": "general_content",
    "section": "singapore"
  },
  {
    "name": "Chile",
    "apiurl": "/restapi/customcontent/contact-us/chile",
    "url": "/contact-us/chile",
    "template": "general_content",
    "section": "chile"
  },
  {
    "name": "Sri Lanka",
    "apiurl": "/restapi/customcontent/contact-us/sri-lanka",
    "url": "/contact-us/sri-lanka",
    "template": "general_content",
    "section": "sri-lanka"
  },
  {
    "name": "Sultanate of Oman",
    "apiurl": "/restapi/customcontent/contact-us/sultanate-of-oman",
    "url": "/contact-us/sultanate-of-oman",
    "template": "general_content",
    "section": "sultanate-of-oman"
  },
  {
    "name": "United Arab Emirates",
    "apiurl": "/restapi/customcontent/contact-us/united-arab-emirates",
    "url": "/contact-us/united-arab-emirates",
    "template": "general_content",
    "section": "united-arab-emirates"
  },
  {
    "name": "Italy",
    "apiurl": "/restapi/customcontent/contact-us/italy",
    "url": "/contact-us/italy",
    "template": "general_content",
    "section": "italy"
  },
  {
    "name": "Peru",
    "apiurl": "/restapi/customcontent/contact-us/peru",
    "url": "/contact-us/peru",
    "template": "general_content",
    "section": "peru"
  },
  {
    "name": "Philippines",
    "apiurl": "/restapi/customcontent/contact-us/philippines",
    "url": "/contact-us/philippines",
    "template": "general_content",
    "section": "philippines"
  },
  {
    "name": "Israel",
    "apiurl": "/restapi/customcontent/contact-us/israel",
    "url": "/contact-us/israel",
    "template": "general_content",
    "section": "israel"
  },
  {
    "name": "Poland",
    "apiurl": "/restapi/customcontent/contact-us/poland",
    "url": "/contact-us/poland",
    "template": "general_content",
    "section": "poland"
  },
  {
    "name": "Colombia",
    "apiurl": "/restapi/customcontent/contact-us/colombia",
    "url": "/contact-us/colombia",
    "template": "general_content",
    "section": "colombia"
  },
  {
    "name": "Vietnam",
    "apiurl": "/restapi/customcontent/contact-us/vietnam",
    "url": "/contact-us/vietnam",
    "template": "general_content",
    "section": "vietnam"
  },
  {
    "name": "South Korea",
    "apiurl": "/restapi/customcontent/contact-us/south-korea",
    "url": "/contact-us/south-korea",
    "template": "general_content",
    "section": "south-korea"
  },
  {
    "name": "Argentina",
    "apiurl": "/restapi/customcontent/contact-us/argentina",
    "url": "/contact-us/argentina",
    "template": "general_content",
    "section": "argentina"
  },
  {
    "name": "Create Account",
    "apiurl": "/restapi/customcontent/create-account",
    "url": "/create-account",
    "template": "general_content",
    "section": "create-account"
  },
  {
    "name": "Technology",
    "apiurl": "/restapi/customtechnologycontent/technology",
    "url": "/technology",
    "template": "new-technology-landing",
    "section": "technology"
  },
  {
    "name": "SafeBridge Regulatory & Life Sciences Group",
    "apiurl": "/restapi/customservicebrandcontent/safebridge-regulatory-life-sciences-group",
    "url": "/safebridge-regulatory-life-sciences-group",
    "template": "new-trinity-service-brand",
    "section": "safebridge-regulatory-life-sciences-group"
  },
  {
    "name": "SafeBridge Regulatory & Life Sciences Group",
    "apiurl": "/restapi/customservicebrandcontent/safebridge-regulatory-life-sciences-group",
    "url": "/safebridge",
    "template": "new-trinity-service-brand",
    "section": "safebridge-regulatory-life-sciences-group"
  },
  {
    "name": "Minnow Aquatic Environmental Services",
    "apiurl": "/restapi/customservicebrandcontent/Minnow-Aquatic-Environmental-Services",
    "url": "/Minnow-Aquatic-Environmental-Services",
    "template": "new-trinity-service-brand",
    "section": "minnow-aquatic-environmental-services"
  },
  {
    "name": "Minnow Aquatic Environmental Services",
    "apiurl": "/restapi/customservicebrandcontent/Minnow-Aquatic-Environmental-Services",
    "url": "/minnow",
    "template": "new-trinity-service-brand",
    "section": "minnow-aquatic-environmental-services"
  },
  {
    "name": "Advent Engineering Life Sciences Solutions",
    "apiurl": "/restapi/customservicebrandcontent/advent-life-sciences-engineering-services",
    "url": "/advent-life-sciences-engineering-services",
    "template": "new-trinity-service-brand",
    "section": "advent-engineering-life-sciences-solutions"
  },
  {
    "name": "Advent Engineering Life Sciences Solutions",
    "apiurl": "/restapi/customservicebrandcontent/advent-life-sciences-engineering-services",
    "url": "/Advent-Engineering-Life-Science-Solutions",
    "template": "new-trinity-service-brand",
    "section": "advent-engineering-life-sciences-solutions"
  },
  {
    "name": "Advent Engineering Life Sciences Solutions",
    "apiurl": "/restapi/customservicebrandcontent/advent-life-sciences-engineering-services",
    "url": "/Advent",
    "template": "new-trinity-service-brand",
    "section": "advent-engineering-life-sciences-solutions"
  },
  {
    "name": "Safety Training Specialist - Mining & Metals Industry",
    "apiurl": "/restapi/customstaffinglvl3content/staffinges/available-positions/safety-training-specialist",
    "url": "/staffinges/available-positions/safety-training-specialist",
    "template": "new-stafﬁng-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Safety Training Specialist - Mining & Metals Industry",
    "apiurl": "/restapi/customstaffinglvl3content/staffinges/available-positions/safety-training-specialist",
    "url": "/staffings/available-positions/safety-training-specialist",
    "template": "new-stafﬁng-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Safety Training Specialist - Mining & Metals Industry",
    "apiurl": "/restapi/customstaffinglvl3content/staffinges/available-positions/safety-training-specialist",
    "url": "/staffing/available-positions/safety-training-specialist",
    "template": "new-stafﬁng-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Safety Training Specialist - Mining & Metals Industry",
    "apiurl": "/restapi/customstaffinglvl3content/staffinges/available-positions/safety-training-specialist",
    "url": "/staffinges/available-positions/safety-training-specialist---mining-metals-industry",
    "template": "new-stafﬁng-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Environmental, Health and Safety (EH&S) Manager",
    "apiurl": "/restapi/customstaffinglvl3content/staffinges/available-positions/environmental-health-and-safety-ehs-manager",
    "url": "/staffinges/available-positions/environmental-health-and-safety-ehs-manager",
    "template": "new-stafﬁng-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Environmental, Health and Safety (EH&S) Manager",
    "apiurl": "/restapi/customstaffinglvl3content/staffinges/available-positions/environmental-health-and-safety-ehs-manager",
    "url": "/staffing/available-positions/environmental-health-and-safety-ehs-manager",
    "template": "new-stafﬁng-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Individual Position",
    "apiurl": "/restapi/customstaffinglvl3content/default-trinitystaffing/default-category/individual-position",
    "url": "/default-trinitystaffing/default-category/individual-position",
    "template": "new-stafﬁng-individual-position",
    "section": "moved-items"
  },
  {
    "name": "Individual Position",
    "apiurl": "/restapi/customstaffinglvl3content/default-trinitystaffing/default-category/individual-position",
    "url": "/available-positions/individual-position",
    "template": "new-stafﬁng-individual-position",
    "section": "moved-items"
  },
  {
    "name": "Individual Position",
    "apiurl": "/restapi/customstaffinglvl3content/default-trinitystaffing/default-category/individual-position",
    "url": "/ehs-recruiters/available-positions/available-positions/individual-position",
    "template": "new-stafﬁng-individual-position",
    "section": "moved-items"
  },
  {
    "name": "test position",
    "apiurl": "/restapi/customstaffinglvl3content/default-trinitystaffing/default-category/test-position",
    "url": "/default-trinitystaffing/default-category/test-position",
    "template": "new-stafﬁng-individual-position",
    "section": "moved-items"
  },
  {
    "name": "test position",
    "apiurl": "/restapi/customstaffinglvl3content/default-trinitystaffing/default-category/test-position",
    "url": "/default-subcategory/test-position",
    "template": "new-stafﬁng-individual-position",
    "section": "moved-items"
  },
  {
    "name": "test position",
    "apiurl": "/restapi/customstaffinglvl3content/default-trinitystaffing/default-category/test-position",
    "url": "/test-position/test-position",
    "template": "new-stafﬁng-individual-position",
    "section": "moved-items"
  },
  {
    "name": "test position",
    "apiurl": "/restapi/customstaffinglvl3content/default-trinitystaffing/default-category/test-position",
    "url": "/default-trinitystaffing/default-category/default-subcategory/test-position",
    "template": "new-stafﬁng-individual-position",
    "section": "moved-items"
  },
  {
    "name": "test position",
    "apiurl": "/restapi/customstaffinglvl3content/default-trinitystaffing/default-category/test-position",
    "url": "/staffing/available-positions/test-position/test-position",
    "template": "new-stafﬁng-individual-position",
    "section": "moved-items"
  },
  {
    "name": "test position",
    "apiurl": "/restapi/customstaffinglvl3content/default-trinitystaffing/default-category/test-position",
    "url": "/ehs-recruiters/available-positions/test-position/test-position",
    "template": "new-stafﬁng-individual-position",
    "section": "moved-items"
  },
  {
    "name": "Industrial Hygienist - Biotechnology Industry",
    "apiurl": "/restapi/customstaffinglvl3content/staffinges/available-positions/industrial-hygienist",
    "url": "/staffinges/available-positions/industrial-hygienist",
    "template": "new-stafﬁng-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Industrial Hygienist - Biotechnology Industry",
    "apiurl": "/restapi/customstaffinglvl3content/staffinges/available-positions/industrial-hygienist",
    "url": "/staffing/available-positions/industrial-hygienist",
    "template": "new-stafﬁng-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Industrial Hygienist - Biotechnology Industry",
    "apiurl": "/restapi/customstaffinglvl3content/staffinges/available-positions/industrial-hygienist",
    "url": "/staffings/available-positions/industrial-hygienist",
    "template": "new-stafﬁng-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Individual Position",
    "apiurl": "/restapi/customcontent/apply-for-job",
    "url": "/apply-for-job",
    "template": "general_content",
    "section": "individual-position"
  },
  {
    "name": "Review Order",
    "apiurl": "/restapi/customcontent/shopping-cart/attendees/review-order",
    "url": "/shopping-cart/attendees/review-order",
    "template": "review-order",
    "section": "add-attendees"
  },
  {
    "name": "AERMOD-Ready",
    "apiurl": "/restapi/customcontent/contact-us/aermod-ready",
    "url": "/contact-us/aermod-ready",
    "template": "general_content",
    "section": "aermod-ready"
  },
  {
    "name": "Meta 2",
    "apiurl": "/restapi/customcontent/contact-us/meta-2",
    "url": "/contact-us/meta-2",
    "template": "general_content",
    "section": "meta-2"
  },
  {
    "name": "ISC-Ready",
    "apiurl": "/restapi/customcontent/contact-us/isc-ready",
    "url": "/contact-us/isc-ready",
    "template": "general_content",
    "section": "isc-ready"
  },
  {
    "name": "NED Terrain",
    "apiurl": "/restapi/customcontent/contact-us/ned-terrain",
    "url": "/contact-us/ned-terrain",
    "template": "general_content",
    "section": "ned-terrain"
  },
  {
    "name": "CAL3QHCR-Ready",
    "apiurl": "/restapi/customcontent/contact-us/cal3qhcr-ready",
    "url": "/contact-us/cal3qhcr-ready",
    "template": "general_content",
    "section": "cal3qhcr-ready"
  },
  {
    "name": "DEM Terrain",
    "apiurl": "/restapi/customcontent/contact-us/dem-terrain",
    "url": "/contact-us/dem-terrain",
    "template": "general_content",
    "section": "dem-terrain"
  },
  {
    "name": "AERMET-Ready",
    "apiurl": "/restapi/customcontent/contact-us/aermet-ready",
    "url": "/contact-us/aermet-ready",
    "template": "general_content",
    "section": "aermet-ready"
  },
  {
    "name": "Custom",
    "apiurl": "/restapi/customcontent/contact-us/custom",
    "url": "/contact-us/custom",
    "template": "general_content",
    "section": "custom"
  },
  {
    "name": "Meta 1",
    "apiurl": "/restapi/customcontent/contact-us/meta-1",
    "url": "/contact-us/meta-1",
    "template": "general_content",
    "section": "meta-1"
  },
  {
    "name": "STAR",
    "apiurl": "/restapi/customcontent/contact-us/star",
    "url": "/contact-us/star",
    "template": "general_content",
    "section": "star"
  },
  {
    "name": "CALPUFF-Ready",
    "apiurl": "/restapi/customcontent/contact-us/calpuff-ready",
    "url": "/contact-us/calpuff-ready",
    "template": "general_content",
    "section": "calpuff-ready"
  },
  {
    "name": "ADMS",
    "apiurl": "/restapi/customcontent/contact-us/adms",
    "url": "/contact-us/adms",
    "template": "general_content",
    "section": "adms"
  },
  {
    "name": "CALMET-Ready",
    "apiurl": "/restapi/customcontent/contact-us/calmet-ready",
    "url": "/contact-us/calmet-ready",
    "template": "general_content",
    "section": "calmet-ready"
  },
  {
    "name": "Industry Specific",
    "apiurl": "/restapi/customtrainingcontentlvl3/training/industry/industry-specific",
    "url": "/training/industry/industry-specific",
    "template": "new-training-individual-category",
    "section": "industry"
  },
  {
    "name": "Industry Specific",
    "apiurl": "/restapi/customtrainingcontentlvl3/training/industry/industry-specific",
    "url": "/training/training-by-Industry/industry-specific",
    "template": "new-training-individual-category",
    "section": "industry"
  },
  {
    "name": "Environmental Analysis",
    "apiurl": "/restapi/customtrainingcontentlvl3/training/course-by-category/environmental-analysis",
    "url": "/training/course-by-category/environmental-analysis",
    "template": "new-training-individual-category",
    "section": "category"
  },
  {
    "name": "Environmental Analysis",
    "apiurl": "/restapi/customtrainingcontentlvl3/training/course-by-category/environmental-analysis",
    "url": "/training/course-by-category/environmentalanalysis",
    "template": "new-training-individual-category",
    "section": "category"
  },
  {
    "name": "Location Specific",
    "apiurl": "/restapi/customtrainingcontentlvl3/training/course-by-category/location-specific",
    "url": "/training/course-by-category/location-specific",
    "template": "new-training-individual-category",
    "section": "category"
  },
  {
    "name": "Environmental Reporting",
    "apiurl": "/restapi/customtrainingcontentlvl3/training/course-by-category/environmental-reporting",
    "url": "/training/course-by-category/environmental-reporting",
    "template": "new-training-individual-category",
    "section": "category"
  },
  {
    "name": "Air Quality Modeling",
    "apiurl": "/restapi/customtrainingcontentlvl3/training/course-by-category/air-quality-modeling",
    "url": "/training/course-by-category/air-quality-modeling",
    "template": "new-training-individual-category",
    "section": "category"
  },
  {
    "name": "EHS Regulations",
    "apiurl": "/restapi/customtrainingcontentlvl3/training/course-by-category/ehs-regulations",
    "url": "/training/course-by-category/ehs-regulations",
    "template": "new-training-individual-category",
    "section": "category"
  },
  {
    "name": "Software Courses",
    "apiurl": "/restapi/customtrainingcontentlvl3/training/software/software-courses",
    "url": "/training/software/software-courses",
    "template": "new-training-individual-category",
    "section": "software-courses"
  },
  {
    "name": "Software Courses",
    "apiurl": "/restapi/customtrainingcontentlvl3/training/software/software-courses",
    "url": "/training/software-courses/software-courses",
    "template": "new-training-individual-category",
    "section": "software-courses"
  },
  {
    "name": "Software Courses",
    "apiurl": "/restapi/customtrainingcontentlvl3/training/software/software-courses",
    "url": "/training/software-courses/tanks-course",
    "template": "new-training-individual-category",
    "section": "software-courses"
  },
  {
    "name": "EHS&S Management",
    "apiurl": "/restapi/customtrainingcontentlvl3/training/course-by-category/ehs-s-management",
    "url": "/training/course-by-category/ehs-s-management",
    "template": "new-training-individual-category",
    "section": "category"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/john-iwanski",
    "url": "/about-us/operational-leaders/individual-bio/john-iwanski",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/john-iwanski",
    "url": "/about-us1/operational-leaders",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/vineet-masuraha",
    "url": "/about-us/operational-leaders/individual-bio/vineet-masuraha",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/vineet-masuraha",
    "url": "/about-us1/operational-leaders",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/shishir-mohan",
    "url": "/about-us/operational-leaders/individual-bio/shishir-mohan",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/shishir-mohan",
    "url": "/about-us1/operational-leaders",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/brian-burdorf",
    "url": "/about-us/operational-leaders/individual-bio/brian-burdorf",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/brian-burdorf",
    "url": "/about-us1/operational-leaders",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/eddie-al-rayes",
    "url": "/about-us/operational-leaders/individual-bio/eddie-al-rayes",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/eddie-al-rayes",
    "url": "/about-us1/operational-leaders",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/chuck-buttry",
    "url": "/about-us/operational-leaders/individual-bio/chuck-buttry",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/chuck-buttry",
    "url": "/about-us1/operational-leaders",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/christine-chambers",
    "url": "/about-us/operational-leaders/individual-bio/christine-chambers",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/christine-chambers",
    "url": "/about-us1/operational-leaders",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/tony-jabon",
    "url": "/about-us/operational-leaders/individual-bio/tony-jabon",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/tony-jabon",
    "url": "/about-us1/operational-leaders",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/rich-jenks",
    "url": "/about-us/operational-leaders/individual-bio/rich-jenks",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/rich-jenks",
    "url": "/about-us1/operational-leaders",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/robert-liles",
    "url": "/about-us/operational-leaders/individual-bio/robert-liles",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/robert-liles",
    "url": "/about-us1/operational-leaders",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/kirk-lowery",
    "url": "/about-us/operational-leaders/individual-bio/kirk-lowery",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/kirk-lowery",
    "url": "/about-us1/operational-leaders",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/tom-muscenti",
    "url": "/about-us/operational-leaders/individual-bio/tom-muscenti",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/tom-muscenti",
    "url": "/about-us1/operational-leaders",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/cynthia-russel",
    "url": "/about-us/operational-leaders/individual-bio/cynthia-russel",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/cynthia-russel",
    "url": "/about-us1/operational-leaders",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/david-wall",
    "url": "/about-us/operational-leaders/individual-bio/david-wall",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/david-wall",
    "url": "/about-us1/operational-leaders",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/weiping-dai",
    "url": "/about-us/operational-leaders/individual-bio/weiping-dai",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/weiping-dai",
    "url": "/about-us1/operational-leaders",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/inaas-darrat",
    "url": "/about-us/operational-leaders/individual-bio/inaas-darrat",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/inaas-darrat",
    "url": "/about-us1/operational-leaders",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/casey-lenhart",
    "url": "/about-us/operational-leaders/individual-bio/casey-lenhart",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/casey-lenhart",
    "url": "/about-us1/operational-leaders",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/rich-pandullo",
    "url": "/about-us/operational-leaders/individual-bio/rich-pandullo",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/rich-pandullo",
    "url": "/about-us1/operational-leaders",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/jason-schmitz",
    "url": "/about-us/operational-leaders/individual-bio/jason-schmitz",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/jason-schmitz",
    "url": "/about-us1/operational-leaders",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/allan-ader",
    "url": "/about-us/operational-leaders/individual-bio/allan-ader",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/allan-ader",
    "url": "/about-us1/operational-leaders",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/robert-sussman",
    "url": "/about-us/operational-leaders/individual-bio/robert-sussman",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/robert-sussman",
    "url": "/about-us1/operational-leaders",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/albert-dyrness",
    "url": "/about-us/operational-leaders/individual-bio/albert-dyrness",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/albert-dyrness",
    "url": "/about-us1/operational-leaders",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/pierre-stecko",
    "url": "/about-us/operational-leaders/individual-bio/pierre-stecko",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/pierre-stecko",
    "url": "/about-us1/operational-leaders",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/kim-connors",
    "url": "/about-us/operational-leaders/individual-bio/kim-connors",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders/individual-bio/kim-connors",
    "url": "/about-us1/operational-leaders",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders",
    "url": "/about-us/operational-leaders",
    "template": "new-operational-leaders",
    "section": "about-us"
  },
  {
    "name": "Operational Leaders",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/operational-leaders",
    "url": "/about-us1/operational-leaders",
    "template": "new-operational-leaders",
    "section": "about-us"
  },
  {
    "name": "Railroads & Rail Yards",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/railroads",
    "url": "/industries/manufacturing-industrial-mining/railroads",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Electric Power",
    "apiurl": "/restapi/customindustrylvl3content/industries/energy/electric-power",
    "url": "/industries/energy/electric-power",
    "template": "new-industry-individual-service",
    "section": "energy"
  },
  {
    "name": "Chemical",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/chemical",
    "url": "/industries/manufacturing-industrial-mining/chemical",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Chemical",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/chemical",
    "url": "/industries/non-industrial-consultants/chemical-pharmaceutical",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Chemical",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/chemical",
    "url": "/industries/manufacturing-industrial-mining/chemical-pharmaceutical",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Chemical",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/chemical",
    "url": "/industries/non-industrial/chemical-pharmaceutical",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Chemical",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/chemical",
    "url": "/industries/industrial-consultants/chemical-pharmaceutical",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Aerospace",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/aerospace",
    "url": "/industries/manufacturing-industrial-mining/aerospace",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Lime",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/lime",
    "url": "/industries/manufacturing-industrial-mining/lime",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Lime",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/lime",
    "url": "/industries/industrial-consultants/lime-aggregates",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Lime",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/lime",
    "url": "/industries/manufacturing-industrial-mining/lime-aggregates",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Petroleum Refining",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/petroleum-refining",
    "url": "/industries/manufacturing-industrial-mining/petroleum-refining",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Petroleum Refining",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/petroleum-refining",
    "url": "/test/non-industrial/petroleum-refining",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Petroleum Refining",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/petroleum-refining",
    "url": "/industries/industrial-consultants/petroleum-refining",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Petroleum Refining",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/petroleum-refining",
    "url": "/test/non-industrial-consultants/petroleum-refining",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Petroleum Refining",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/petroleum-refining",
    "url": "/industries/non-industrial-consultants/petroleum-refining",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "General Manufacturing",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/general-manufacturing",
    "url": "/industries/manufacturing-industrial-mining/general-manufacturing",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Food & Beverage",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/food-beverage",
    "url": "/industries/manufacturing-industrial-mining/food-beverage",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Pulp, Paper & Tissue",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/pulp-paper",
    "url": "/industries/manufacturing-industrial-mining/pulp-paper",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Pulp, Paper & Tissue",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/pulp-paper",
    "url": "/test/non-industrial/pulp-paper",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Pulp, Paper & Tissue",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/pulp-paper",
    "url": "/test/non-industrial-consultants/pulp-paper",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Pulp, Paper & Tissue",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/pulp-paper",
    "url": "/industries/industrial-consultants/pulp-paper",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Pulp, Paper & Tissue",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/pulp-paper",
    "url": "/industries/non-industrial-consultants/pulp-paper",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Life Sciences",
    "apiurl": "/restapi/customindustrylvl3content/industries/life-sciences/life-science",
    "url": "/industries/life-sciences/life-science",
    "template": "new-industry-individual-service",
    "section": "life-sciences"
  },
  {
    "name": "Life Sciences",
    "apiurl": "/restapi/customindustrylvl3content/industries/life-sciences/life-science",
    "url": "/industries/life-sciences/general-life-science",
    "template": "new-industry-individual-service",
    "section": "life-sciences"
  },
  {
    "name": "Life Sciences",
    "apiurl": "/restapi/customindustrylvl3content/industries/life-sciences/life-science",
    "url": "/industries/life-sciences/life-science---test",
    "template": "new-industry-individual-service",
    "section": "life-sciences"
  },
  {
    "name": "Life Sciences",
    "apiurl": "/restapi/customindustrylvl3content/industries/life-sciences/life-science",
    "url": "/industries/life-sciences/life-sciences",
    "template": "new-industry-individual-service",
    "section": "life-sciences"
  },
  {
    "name": "Wood Products",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/wood-products",
    "url": "/industries/manufacturing-industrial-mining/wood-products",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Semiconductor",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/semiconductor",
    "url": "/industries/manufacturing-industrial-mining/semiconductor",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Terminals",
    "apiurl": "/restapi/customindustrylvl3content/industries/energy/terminals",
    "url": "/industries/energy/terminals",
    "template": "new-industry-individual-service",
    "section": "energy"
  },
  {
    "name": "Terminals",
    "apiurl": "/restapi/customindustrylvl3content/industries/energy/terminals",
    "url": "/test/energy/terminals",
    "template": "new-industry-individual-service",
    "section": "energy"
  },
  {
    "name": "Aggregates",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/aggregates",
    "url": "/industries/manufacturing-industrial-mining/aggregates",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Deepwater Ports, Offshore E&P",
    "apiurl": "/restapi/customindustrylvl3content/industries/energy/deepwater-ports-offshore-e-p",
    "url": "/industries/energy/deepwater-ports-offshore-e-p",
    "template": "new-industry-individual-service",
    "section": "energy"
  },
  {
    "name": "Deepwater Ports, Offshore E&P",
    "apiurl": "/restapi/customindustrylvl3content/industries/energy/deepwater-ports-offshore-e-p",
    "url": "/test/energy/deepwater-ports-lng-terminals-offshore-e-p",
    "template": "new-industry-individual-service",
    "section": "energy"
  },
  {
    "name": "Deepwater Ports, Offshore E&P",
    "apiurl": "/restapi/customindustrylvl3content/industries/energy/deepwater-ports-offshore-e-p",
    "url": "/industries/energy/deepwater-ports-lng-terminals-offshore-e-p",
    "template": "new-industry-individual-service",
    "section": "energy"
  },
  {
    "name": "Agriculture",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/agriculture",
    "url": "/industries/manufacturing-industrial-mining/agriculture",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Portland Cement",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/portland-cement",
    "url": "/industries/manufacturing-industrial-mining/portland-cement",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Portland Cement",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/portland-cement",
    "url": "/industries/industrial-consultants/portland-cement",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Portland Cement",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/portland-cement",
    "url": "/test/non-industrial/portland-cement",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Portland Cement",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/portland-cement",
    "url": "/test/non-industrial-consultants/portland-cement",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Portland Cement",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/portland-cement",
    "url": "/industries/non-industrial-consultants/portland-cement",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Metals Mining",
    "apiurl": "/restapi/customindustrylvl3content/industries/manufacturing-industrial-mining/metals-mining",
    "url": "/industries/manufacturing-industrial-mining/metals-mining",
    "template": "new-industry-individual-service",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "Oil & Gas",
    "apiurl": "/restapi/customindustrylvl3content/industries/energy/oil-gas",
    "url": "/industries/energy/oil-gas",
    "template": "new-industry-individual-service",
    "section": "energy"
  },
  {
    "name": "Oil & Gas",
    "apiurl": "/restapi/customindustrylvl3content/industries/energy/oil-gas",
    "url": "/test/energy/oil-gas",
    "template": "new-industry-individual-service",
    "section": "energy"
  },
  {
    "name": "Government",
    "apiurl": "/restapi/customindustrylvl3content/industries/commercial-institutional/government",
    "url": "/industries/commercial-institutional/government",
    "template": "new-industry-individual-service",
    "section": "commercial/institutional"
  },
  {
    "name": "Government",
    "apiurl": "/restapi/customindustrylvl3content/industries/commercial-institutional/government",
    "url": "/industries/commercial-institutional/environmental-permitting-and-compliance-for-government-facilities",
    "template": "new-industry-individual-service",
    "section": "commercial/institutional"
  },
  {
    "name": "Solid Waste & Recycling",
    "apiurl": "/restapi/customindustrylvl3content/industries/commercial-institutional/solid-waste-recycling",
    "url": "/industries/commercial-institutional/solid-waste-recycling",
    "template": "new-industry-individual-service",
    "section": "commercial/institutional"
  },
  {
    "name": "VASDIP",
    "apiurl": "/restapi/customcontent/contact-us/vasdip",
    "url": "/contact-us/vasdip",
    "template": "general_content",
    "section": "vasdip"
  },
  {
    "name": "HEXDAM",
    "apiurl": "/restapi/customcontent/contact-us/hexdam",
    "url": "/contact-us/hexdam",
    "template": "general_content",
    "section": "hexdam"
  },
  {
    "name": "Privacy Policy",
    "apiurl": "/restapi/customcontent/privacy-policy",
    "url": "/privacy-policy",
    "template": "general_content",
    "section": "privacy-policy"
  },
  {
    "name": "Custom Training",
    "apiurl": "/restapi/customcontent/request-training-quote",
    "url": "/request-training-quote",
    "template": "general_content",
    "section": "custom-training"
  },
  {
    "name": "Custom Training",
    "apiurl": "/restapi/customcontent/request-training-quote",
    "url": "/training/request-training-quote",
    "template": "general_content",
    "section": "custom-training"
  },
  {
    "name": "Shopping Cart",
    "apiurl": "/restapi/customcontent/shopping-cart/attendees/review-order/payment",
    "url": "/shopping-cart/attendees/review-order/payment",
    "template": "payment",
    "section": "review-order"
  },
  {
    "name": "Globals",
    "apiurl": "/restapi/customcontent/contact-us",
    "url": "/contact-us",
    "template": "general_content",
    "section": "globals"
  },
  {
    "name": "Janet Martin",
    "apiurl": "/restapi/customcontent/contact-us/janet-martin",
    "url": "/contact-us/janet-martin",
    "template": "general_content",
    "section": "janet-martin"
  },
  {
    "name": "Christina Ridge",
    "apiurl": "/restapi/customcontent/contact-us/christina-ridge",
    "url": "/contact-us/christina-ridge",
    "template": "general_content",
    "section": "christina-ridge"
  },
  {
    "name": "Pressure-Impulse Data",
    "apiurl": "/restapi/customcontent/software/explosion/vasdip/pressure-impulse-data",
    "url": "/software/explosion/vasdip/pressure-impulse-data",
    "template": "general_content",
    "section": "pressure-impulse-data"
  },
  {
    "name": "Model Run and Results Analysis",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/model-run-results-analysis",
    "url": "/software/explosion/exdam/model-run-results-analysis",
    "template": "general_content",
    "section": "model-run-and-results-analysis"
  },
  {
    "name": "Model Setup",
    "apiurl": "/restapi/customcontent/software/health-risk/risk-analyst/model-setup",
    "url": "/software/health-risk/risk-analyst/model-setup",
    "template": "general_content",
    "section": "model-setup"
  },
  {
    "name": "Surface Data",
    "apiurl": "/restapi/customcontent/software/dispersion/aermet/surface-data",
    "url": "/software/dispersion/aermet/surface-data",
    "template": "general_content",
    "section": "surface-data"
  },
  {
    "name": "Post-Processing Tools",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/post-processing-tools",
    "url": "/software/air-dispersion-data-visualization/3d-analyst/post-processing-tools",
    "template": "general_content",
    "section": "post-processing-tools"
  },
  {
    "name": "Post-Processing Tools",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/post-processing-tools",
    "url": "/software/air-dispersion---data/3d-analyst/post-processing-tools",
    "template": "general_content",
    "section": "post-processing-tools"
  },
  {
    "name": "Site and Meteorological Data",
    "apiurl": "/restapi/customcontent/software/tanks/tankesp/site-and-meteorological-data",
    "url": "/software/tanks/tankesp/site-and-meteorological-data",
    "template": "general_content",
    "section": "site-and-meteorological-data"
  },
  {
    "name": "Site and Meteorological Data",
    "apiurl": "/restapi/customcontent/software/tanks/tankesp/site-and-meteorological-data",
    "url": "/software/tank-emissions/tankesp/site-and-meteorological-data",
    "template": "general_content",
    "section": "site-and-meteorological-data"
  },
  {
    "name": "Wind Roses and Plotting",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/metview/wind-roses-and-plotting",
    "url": "/software/air-dispersion---data-visualization/metview/wind-roses-and-plotting",
    "template": "general_content",
    "section": "wind-roses-and-plotting"
  },
  {
    "name": "Wind Roses and Plotting",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/metview/wind-roses-and-plotting",
    "url": "/software/air-dispersion-data-visualization/metview/wind-roses-and-plotting",
    "template": "general_content",
    "section": "wind-roses-and-plotting"
  },
  {
    "name": "Wind Roses and Plotting",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/metview/wind-roses-and-plotting",
    "url": "/software/air-dispersion---data/metview/wind-roses-and-plotting",
    "template": "general_content",
    "section": "wind-roses-and-plotting"
  },
  {
    "name": "Source5 Model",
    "apiurl": "/restapi/customcontent/software/hazard/lfg-fire-risk/source5-model",
    "url": "/software/hazard/lfg-fire-risk/source5-model",
    "template": "general_content",
    "section": "source5-model"
  },
  {
    "name": "Source5 Model",
    "apiurl": "/restapi/customcontent/software/hazard/lfg-fire-risk/source5-model",
    "url": "/software/hazard/lfg-fire-risk-modeling/source5-model",
    "template": "general_content",
    "section": "source5-model"
  },
  {
    "name": "Multiple Sources and Receptors",
    "apiurl": "/restapi/customcontent/software/dispersion/screen3/multiple-sources-and-receptors",
    "url": "/software/dispersion/screen3/multiple-sources-and-receptors",
    "template": "general_content",
    "section": "multiple-sources-and-receptors"
  },
  {
    "name": "Data Entry",
    "apiurl": "/restapi/customcontent/software/tanks/tankesp/data-entry",
    "url": "/software/tanks/tankesp/data-entry",
    "template": "general_content",
    "section": "data-entry"
  },
  {
    "name": "Data Entry",
    "apiurl": "/restapi/customcontent/software/tanks/tankesp/data-entry",
    "url": "/software/tank-emissions/tankesp/data-entry",
    "template": "general_content",
    "section": "data-entry"
  },
  {
    "name": "Chemical Database",
    "apiurl": "/restapi/customcontent/software/health-risk/risk-analyst/chemical-database",
    "url": "/software/health-risk/risk-analyst/chemical-database",
    "template": "general_content",
    "section": "chemical-database"
  },
  {
    "name": "BPIP Output Mode",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/downwash-analyst/bpip-output-mode",
    "url": "/software/air-dispersion---data-visualization/downwash-analyst/bpip-output-mode",
    "template": "general_content",
    "section": "bpip-output-mode"
  },
  {
    "name": "BPIP Output Mode",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/downwash-analyst/bpip-output-mode",
    "url": "/software/air-dispersion---data/downwash-analyst/bpip-output-mode",
    "template": "general_content",
    "section": "bpip-output-mode"
  },
  {
    "name": "BPIP Output Mode",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/downwash-analyst/bpip-output-mode",
    "url": "/software/air-dispersion-data-visualization/downwash-analyst/bpip-output-mode",
    "template": "general_content",
    "section": "bpip-output-mode"
  },
  {
    "name": "Integrated Tools",
    "apiurl": "/restapi/customcontent/software/hazard/lfg-fire-risk/integrated-tools",
    "url": "/software/hazard/lfg-fire-risk/integrated-tools",
    "template": "general_content",
    "section": "integrated-tools"
  },
  {
    "name": "Integrated Tools",
    "apiurl": "/restapi/customcontent/software/hazard/lfg-fire-risk/integrated-tools",
    "url": "/software/hazard/lfg-fire-risk-modeling/integrated-tools",
    "template": "general_content",
    "section": "integrated-tools"
  },
  {
    "name": "Standalone Editions",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/standalone-editions",
    "url": "/software/air-dispersion---data-visualization/3d-analyst/standalone-editions",
    "template": "general_content",
    "section": "standalone-editions"
  },
  {
    "name": "Standalone Editions",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/standalone-editions",
    "url": "/software/air-dispersion---data/3d-analyst/standalone-editions",
    "template": "general_content",
    "section": "standalone-editions"
  },
  {
    "name": "Standalone Editions",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/standalone-editions",
    "url": "/software/air-dispersion-data-visualization/3d-analyst/standalone-editions",
    "template": "general_content",
    "section": "standalone-editions"
  },
  {
    "name": "Results and Mapping",
    "apiurl": "/restapi/customcontent/software/health-risk/risk-analyst/results-and-mapping",
    "url": "/software/health-risk/risk-analyst/results-and-mapping",
    "template": "general_content",
    "section": "results-and-mapping"
  },
  {
    "name": "Parallel Processing",
    "apiurl": "/restapi/customcontent/software/dispersion/aermod/parallel-processing",
    "url": "/software/dispersion/aermod/parallel-processing",
    "template": "general_content",
    "section": "parallel-processing"
  },
  {
    "name": "Results Analysis ",
    "apiurl": "/restapi/customcontent/software/hazard/incident-analyst/results-analysis",
    "url": "/software/hazard/incident-analyst/results-analysis",
    "template": "general_content",
    "section": "results-analysis-"
  },
  {
    "name": "Scenario Development Tools",
    "apiurl": "/restapi/customcontent/software/dispersion/calpuff/scenario-development-tools",
    "url": "/software/dispersion/calpuff/scenario-development-tools",
    "template": "general_content",
    "section": "scenario-development-tools"
  },
  {
    "name": "Charts and Tables",
    "apiurl": "/restapi/customcontent/software/dispersion/screen3/charts-and-tables",
    "url": "/software/dispersion/screen3/charts-and-tables",
    "template": "general_content",
    "section": "charts-and-tables"
  },
  {
    "name": "Model Setup and Execution",
    "apiurl": "/restapi/customcontent/software/dispersion/aerscreen/model-setup-and-execution",
    "url": "/software/dispersion/aerscreen/model-setup-and-execution",
    "template": "general_content",
    "section": "model-setup-and-execution"
  },
  {
    "name": "Graphical Results",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/graphical-results",
    "url": "/software/air-dispersion---data-visualization/3d-analyst/graphical-results",
    "template": "general_content",
    "section": "graphical-results"
  },
  {
    "name": "Graphical Results",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/graphical-results",
    "url": "/software/air-dispersion-data-visualization/3d-analyst/graphical-results",
    "template": "general_content",
    "section": "graphical-results"
  },
  {
    "name": "Graphical Results",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/graphical-results",
    "url": "/software/air-dispersion---data/3d-analyst/graphical-results",
    "template": "general_content",
    "section": "graphical-results"
  },
  {
    "name": "PRIME Plume Rise View",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/downwash-analyst/prime-plume-rise-view",
    "url": "/software/air-dispersion---data-visualization/downwash-analyst/prime-plume-rise-view",
    "template": "general_content",
    "section": "prime-plume-rise-view"
  },
  {
    "name": "PRIME Plume Rise View",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/downwash-analyst/prime-plume-rise-view",
    "url": "/software/air-dispersion---data/downwash-analyst/prime-plume-rise-view",
    "template": "general_content",
    "section": "prime-plume-rise-view"
  },
  {
    "name": "PRIME Plume Rise View",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/downwash-analyst/prime-plume-rise-view",
    "url": "/software/air-dispersion-data-visualization/downwash-analyst/prime-plume-rise-view",
    "template": "general_content",
    "section": "prime-plume-rise-view"
  },
  {
    "name": "Fire Models",
    "apiurl": "/restapi/customcontent/software/hazard/lfg-fire-risk/fire-models",
    "url": "/software/hazard/lfg-fire-risk/fire-models",
    "template": "general_content",
    "section": "fire-models"
  },
  {
    "name": "Fire Models",
    "apiurl": "/restapi/customcontent/software/hazard/lfg-fire-risk/fire-models",
    "url": "/software/hazard/lfg-fire-risk-modeling/fire-models",
    "template": "general_content",
    "section": "fire-models"
  },
  {
    "name": "CALINE Series of Models",
    "apiurl": "/restapi/customcontent/software/dispersion/roads/caline-series-of-models",
    "url": "/software/dispersion/roads/caline-series-of-models",
    "template": "general_content",
    "section": "caline-series-of-models"
  },
  {
    "name": "Damage Data Calculations",
    "apiurl": "/restapi/customcontent/software/explosion/vasdip/damage-data-calculations",
    "url": "/software/explosion/vasdip/damage-data-calculations",
    "template": "general_content",
    "section": "damage-data-calculations"
  },
  {
    "name": "Sources and Receptors",
    "apiurl": "/restapi/customcontent/software/dispersion/roads/sources-and-receptors",
    "url": "/software/dispersion/roads/sources-and-receptors",
    "template": "general_content",
    "section": "sources-and-receptors"
  },
  {
    "name": "Onsite Station Data",
    "apiurl": "/restapi/customcontent/software/dispersion/aermet/onsite-station-data",
    "url": "/software/dispersion/aermet/onsite-station-data",
    "template": "general_content",
    "section": "onsite-station-data"
  },
  {
    "name": "Model Objects",
    "apiurl": "/restapi/customcontent/software/dispersion/aerscreen/model-objects",
    "url": "/software/dispersion/aerscreen/model-objects",
    "template": "general_content",
    "section": "model-objects"
  },
  {
    "name": "12 Industry-Standard Models",
    "apiurl": "/restapi/customcontent/software/hazard/incident-analyst/12-industry-standard-models",
    "url": "/software/hazard/incident-analyst/12-industry-standard-models",
    "template": "general_content",
    "section": "12-industry-standard-models"
  },
  {
    "name": "Integrated User Interface ",
    "apiurl": "/restapi/customcontent/software/dispersion/screen3/integrated-user-interface",
    "url": "/software/dispersion/screen3/integrated-user-interface",
    "template": "general_content",
    "section": "integrated-user-interface-"
  },
  {
    "name": "Source Term Wizard",
    "apiurl": "/restapi/customcontent/software/hazard/incident-analyst/source-term-wizard",
    "url": "/software/hazard/incident-analyst/source-term-wizard",
    "template": "general_content",
    "section": "source-term-wizard"
  },
  {
    "name": "Meteorology",
    "apiurl": "/restapi/customcontent/software/dispersion/roads/meteorology",
    "url": "/software/dispersion/roads/meteorology",
    "template": "general_content",
    "section": "meteorology"
  },
  {
    "name": "Programs and Processors",
    "apiurl": "/restapi/customcontent/software/dispersion/calpuff/programs-and-processors",
    "url": "/software/dispersion/calpuff/programs-and-processors",
    "template": "general_content",
    "section": "programs-and-processors"
  },
  {
    "name": "Results Analysis",
    "apiurl": "/restapi/customcontent/software/dispersion/aerscreen/results-analysis",
    "url": "/software/dispersion/aerscreen/results-analysis",
    "template": "general_content",
    "section": "results-analysis"
  },
  {
    "name": "Roadways",
    "apiurl": "/restapi/customcontent/software/dispersion/roads/roadways",
    "url": "/software/dispersion/roads/roadways",
    "template": "general_content",
    "section": "roadways"
  },
  {
    "name": "Model Objects",
    "apiurl": "/restapi/customcontent/software/dispersion/calpuff/model-objects",
    "url": "/software/dispersion/calpuff/model-objects",
    "template": "general_content",
    "section": "model-objects"
  },
  {
    "name": "GEP Stack Height View",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/downwash-analyst/gep-stack-height-view",
    "url": "/software/air-dispersion---data-visualization/downwash-analyst/gep-stack-height-view",
    "template": "general_content",
    "section": "gep-stack-height-view"
  },
  {
    "name": "GEP Stack Height View",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/downwash-analyst/gep-stack-height-view",
    "url": "/software/air-dispersion---data/downwash-analyst/gep-stack-height-view",
    "template": "general_content",
    "section": "gep-stack-height-view"
  },
  {
    "name": "GEP Stack Height View",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/downwash-analyst/gep-stack-height-view",
    "url": "/software/air-dispersion-data-visualization/downwash-analyst/gep-stack-height-view",
    "template": "general_content",
    "section": "gep-stack-height-view"
  },
  {
    "name": "Risk Modules",
    "apiurl": "/restapi/customcontent/software/health-risk/risk-analyst/risk-modules",
    "url": "/software/health-risk/risk-analyst/risk-modules",
    "template": "general_content",
    "section": "risk-modules"
  },
  {
    "name": "Meteorology",
    "apiurl": "/restapi/customcontent/software/dispersion/aerscreen/meteorology",
    "url": "/software/dispersion/aerscreen/meteorology",
    "template": "general_content",
    "section": "meteorology"
  },
  {
    "name": "Model Objects",
    "apiurl": "/restapi/customcontent/software/dispersion/aermod/model-objects",
    "url": "/software/dispersion/aermod/model-objects",
    "template": "general_content",
    "section": "model-objects"
  },
  {
    "name": "TankESP Editions",
    "apiurl": "/restapi/customcontent/software/tanks/tankesp/tankesp-editions",
    "url": "/software/tanks/tankesp/tankesp-editions",
    "template": "general_content",
    "section": "tankesp-editions"
  },
  {
    "name": "TankESP Editions",
    "apiurl": "/restapi/customcontent/software/tanks/tankesp/tankesp-editions",
    "url": "/software/tank-emissions/tankesp/tankesp-editions",
    "template": "general_content",
    "section": "tankesp-editions"
  },
  {
    "name": "Seamless Integration",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/seamless-integration",
    "url": "/software/air-dispersion---data-visualization/3d-analyst/seamless-integration",
    "template": "general_content",
    "section": "seamless-integration"
  },
  {
    "name": "Seamless Integration",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/seamless-integration",
    "url": "/software/air-dispersion-data-visualization/3d-analyst/seamless-integration",
    "template": "general_content",
    "section": "seamless-integration"
  },
  {
    "name": "Seamless Integration",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/seamless-integration",
    "url": "/software/air-dispersion---data/3d-analyst/seamless-integration",
    "template": "general_content",
    "section": "seamless-integration"
  },
  {
    "name": "Vulnerability Parameters for Export",
    "apiurl": "/restapi/customcontent/software/explosion/vasdip/vulnerability-parameters-for-export",
    "url": "/software/explosion/vasdip/vulnerability-parameters-for-export",
    "template": "general_content",
    "section": "vulnerability-parameters-for-export"
  },
  {
    "name": "Integration with BREEZE 3D Analyst",
    "apiurl": "/restapi/customcontent/software/dispersion/calpuff/integration-with-breeze-3d-analyst",
    "url": "/software/dispersion/calpuff/integration-with-breeze-3d-analyst",
    "template": "general_content",
    "section": "integration-with-breeze-3d-analyst"
  },
  {
    "name": "Advanced Science",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/advanced-science",
    "url": "/software/explosion/exdam/advanced-science",
    "template": "general_content",
    "section": "advanced-science"
  },
  {
    "name": "Scenario Development Tools",
    "apiurl": "/restapi/customcontent/software/dispersion/aermod/scenario-development-tools",
    "url": "/software/dispersion/aermod/scenario-development-tools",
    "template": "general_content",
    "section": "scenario-development-tools"
  },
  {
    "name": "Land Use Data",
    "apiurl": "/restapi/customcontent/software/dispersion/aermet/land-use-data",
    "url": "/software/dispersion/aermet/land-use-data",
    "template": "general_content",
    "section": "land-use-data"
  },
  {
    "name": "Diagnostics",
    "apiurl": "/restapi/customcontent/software/dispersion/screen3/diagnostics",
    "url": "/software/dispersion/screen3/diagnostics",
    "template": "general_content",
    "section": "diagnostics"
  },
  {
    "name": "Chemical Database",
    "apiurl": "/restapi/customcontent/software/hazard/incident-analyst/chemical-database",
    "url": "/software/hazard/incident-analyst/chemical-database",
    "template": "general_content",
    "section": "chemical-database"
  },
  {
    "name": "Who Should Use ExDAM",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/who-should-use",
    "url": "/software/explosion/exdam/who-should-use",
    "template": "general_content",
    "section": "who-should-use-exdam"
  },
  {
    "name": "Who Should Use ExDAM",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/who-should-use",
    "url": "/software/explosion/exdam/model-run-and-analysis",
    "template": "general_content",
    "section": "who-should-use-exdam"
  },
  {
    "name": "Results and Reporting",
    "apiurl": "/restapi/customcontent/software/tanks/tankesp/results-and-reporting",
    "url": "/software/tanks/tankesp/results-and-reporting",
    "template": "general_content",
    "section": "results-and-reporting"
  },
  {
    "name": "Results and Reporting",
    "apiurl": "/restapi/customcontent/software/tanks/tankesp/results-and-reporting",
    "url": "/software/tank-emissions/tankesp/results-and-reporting",
    "template": "general_content",
    "section": "results-and-reporting"
  },
  {
    "name": "Upper Air Data",
    "apiurl": "/restapi/customcontent/software/dispersion/aermet/upper-air-data",
    "url": "/software/dispersion/aermet/upper-air-data",
    "template": "general_content",
    "section": "upper-air-data"
  },
  {
    "name": "Height of Wake Effect View",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/downwash-analyst/height-of-wake-effect-view",
    "url": "/software/air-dispersion---data-visualization/downwash-analyst/height-of-wake-effect-view",
    "template": "general_content",
    "section": "height-of-wake-effect-view"
  },
  {
    "name": "Height of Wake Effect View",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/downwash-analyst/height-of-wake-effect-view",
    "url": "/software/air-dispersion---data/downwash-analyst/height-of-wake-effect-view",
    "template": "general_content",
    "section": "height-of-wake-effect-view"
  },
  {
    "name": "Height of Wake Effect View",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/downwash-analyst/height-of-wake-effect-view",
    "url": "/software/air-dispersion-data-visualization/downwash-analyst/height-of-wake-effect-view",
    "template": "general_content",
    "section": "height-of-wake-effect-view"
  },
  {
    "name": "Structure and Body Components",
    "apiurl": "/restapi/customcontent/software/explosion/vasdip/structure-and-body-components",
    "url": "/software/explosion/vasdip/structure-and-body-components",
    "template": "general_content",
    "section": "structure-and-body-components"
  },
  {
    "name": "DEGADIS Model",
    "apiurl": "/restapi/customcontent/software/hazard/lfg-fire-risk/degadis-model",
    "url": "/software/hazard/lfg-fire-risk/degadis-model",
    "template": "general_content",
    "section": "degadis-model"
  },
  {
    "name": "DEGADIS Model",
    "apiurl": "/restapi/customcontent/software/hazard/lfg-fire-risk/degadis-model",
    "url": "/software/hazard/lfg-fire-risk-modeling/degadis-model",
    "template": "general_content",
    "section": "degadis-model"
  },
  {
    "name": "Data Rose",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/metview/data-rose",
    "url": "/software/air-dispersion---data/metview/data-rose",
    "template": "general_content",
    "section": "data-rose"
  },
  {
    "name": "Data Rose",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/metview/data-rose",
    "url": "/software/air-dispersion-data-visualization/metview/data-rose",
    "template": "general_content",
    "section": "data-rose"
  },
  {
    "name": "AERMOD Editions",
    "apiurl": "/restapi/customcontent/software/dispersion/aermod/aermod-editions",
    "url": "/software/dispersion/aermod/aermod-editions",
    "template": "general_content",
    "section": "aermod-editions"
  },
  {
    "name": "ExDAM vs CFD Applications",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/EXDAM-vs-CFD",
    "url": "/software/explosion/exdam/EXDAM-vs-CFD",
    "template": "general_content",
    "section": "exdam-vs-cfd-applications"
  },
  {
    "name": "ExDAM vs CFD Applications",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/EXDAM-vs-CFD",
    "url": "/software/explosion/exdam/who-should-use-exdam",
    "template": "general_content",
    "section": "exdam-vs-cfd-applications"
  },
  {
    "name": "Data Processing",
    "apiurl": "/restapi/customcontent/contact-us/data-processing",
    "url": "/contact-us/data-processing",
    "template": "general_content",
    "section": "data-processing"
  },
  {
    "name": "High Speed Modeling",
    "apiurl": "/restapi/customcontent/contact-us/high-speed-modeling",
    "url": "/contact-us/high-speed-modeling",
    "template": "general_content",
    "section": "high-speed-modeling"
  },
  {
    "name": "Specialized Consulting Services",
    "apiurl": "/restapi/customcontent/contact-us/specialized-consulting-services",
    "url": "/contact-us/specialized-consulting-services",
    "template": "general_content",
    "section": "specialized-consulting-services"
  },
  {
    "name": "Chemicals",
    "apiurl": "/restapi/customcontent/contact-us/chemicals",
    "url": "/contact-us/chemicals",
    "template": "general_content",
    "section": "chemicals"
  },
  {
    "name": "Automotive",
    "apiurl": "/restapi/customcontent/contact-us/automotive",
    "url": "/contact-us/automotive",
    "template": "general_content",
    "section": "automotive"
  },
  {
    "name": "Aerospace",
    "apiurl": "/restapi/customcontent/contact-us/aerospace",
    "url": "/contact-us/aerospace",
    "template": "general_content",
    "section": "aerospace"
  },
  {
    "name": "Education",
    "apiurl": "/restapi/customcontent/contact-us/education",
    "url": "/contact-us/education",
    "template": "general_content",
    "section": "education"
  },
  {
    "name": "Power Generation",
    "apiurl": "/restapi/customcontent/contact-us/power-generation",
    "url": "/contact-us/power-generation",
    "template": "general_content",
    "section": "power-generation"
  },
  {
    "name": "Petroleum Refining",
    "apiurl": "/restapi/customcontent/contact-us/petroleum-refining",
    "url": "/contact-us/petroleum-refining",
    "template": "general_content",
    "section": "petroleum-refining"
  },
  {
    "name": "Agricultural Processing",
    "apiurl": "/restapi/customcontent/contact-us/agricultural-processing",
    "url": "/contact-us/agricultural-processing",
    "template": "general_content",
    "section": "agricultural-processing"
  },
  {
    "name": "Forest Products",
    "apiurl": "/restapi/customcontent/contact-us/forest-products",
    "url": "/contact-us/forest-products",
    "template": "general_content",
    "section": "forest-products"
  },
  {
    "name": "Mining",
    "apiurl": "/restapi/customcontent/contact-us/mining",
    "url": "/contact-us/mining",
    "template": "general_content",
    "section": "mining"
  },
  {
    "name": "Transportation",
    "apiurl": "/restapi/customcontent/contact-us/transportation",
    "url": "/contact-us/transportation",
    "template": "general_content",
    "section": "transportation"
  },
  {
    "name": "Regulatory Agency",
    "apiurl": "/restapi/customcontent/contact-us/regulatory-agency",
    "url": "/contact-us/regulatory-agency",
    "template": "general_content",
    "section": "regulatory-agency"
  },
  {
    "name": "Pharmaceutical/Bio-Pharmaceutical",
    "apiurl": "/restapi/customcontent/contact-us/pharmaceutical-bio-pharmaceutical",
    "url": "/contact-us/pharmaceutical-bio-pharmaceutical",
    "template": "general_content",
    "section": "pharmaceuticalbio-pharmaceutical"
  },
  {
    "name": "Landfills",
    "apiurl": "/restapi/customcontent/contact-us/landfills",
    "url": "/contact-us/landfills",
    "template": "general_content",
    "section": "landfills"
  },
  {
    "name": "Technology",
    "apiurl": "/restapi/customcontent/contact-us/technology",
    "url": "/contact-us/technology",
    "template": "general_content",
    "section": "technology"
  },
  {
    "name": "General Manufacturing",
    "apiurl": "/restapi/customcontent/contact-us/general-manufacturing",
    "url": "/contact-us/general-manufacturing",
    "template": "general_content",
    "section": "general-manufacturing"
  },
  {
    "name": "Liquid Terminals",
    "apiurl": "/restapi/customcontent/contact-us/liquid-terminals",
    "url": "/contact-us/liquid-terminals",
    "template": "general_content",
    "section": "liquid-terminals"
  },
  {
    "name": "Oil & Gas Production/Processing",
    "apiurl": "/restapi/customcontent/contact-us/oil-gas-production-processing",
    "url": "/contact-us/oil-gas-production-processing",
    "template": "general_content",
    "section": "oil-gas-productionprocessing"
  },
  {
    "name": "Consulting",
    "apiurl": "/restapi/customcontent/contact-us/consulting",
    "url": "/contact-us/consulting",
    "template": "general_content",
    "section": "consulting"
  },
  {
    "name": "Cement, Lime & Aggregates",
    "apiurl": "/restapi/customcontent/contact-us/cement-lime-aggregates",
    "url": "/contact-us/cement-lime-aggregates",
    "template": "general_content",
    "section": "cement,-lime-aggregates"
  },
  {
    "name": "Aquatic Habitat Evaluations",
    "apiurl": "/restapi/customcontent/minnow-aquatic-environmental-services/aquatic-habitat-evaluations",
    "url": "/minnow-aquatic-environmental-services/aquatic-habitat-evaluations",
    "template": "general_content",
    "section": "aquatic-habitat-evaluations"
  },
  {
    "name": "Aquatic Habitat Evaluations",
    "apiurl": "/restapi/customcontent/minnow-aquatic-environmental-services/aquatic-habitat-evaluations",
    "url": "/consulting/science/aquatic-ecology/aquatic-habitat-evaluations",
    "template": "general_content",
    "section": "aquatic-habitat-evaluations"
  },
  {
    "name": "Toxicology",
    "apiurl": "/restapi/customcontent/safebridge-regulatory-life-sciences-group/toxicology",
    "url": "/safebridge-regulatory-life-sciences-group/toxicology",
    "template": "general_content",
    "section": "toxicology"
  },
  {
    "name": "Environmental Effects Monitoring",
    "apiurl": "/restapi/customcontent/minnow-aquatic-environmental-services/environmental-effects-monitoring",
    "url": "/minnow-aquatic-environmental-services/environmental-effects-monitoring",
    "template": "general_content",
    "section": "environmental-effects-monitoring"
  },
  {
    "name": "Environmental Effects Monitoring",
    "apiurl": "/restapi/customcontent/minnow-aquatic-environmental-services/environmental-effects-monitoring",
    "url": "/consulting/science/aquatic-ecology/environmental-effects-monitoring-eem",
    "template": "general_content",
    "section": "environmental-effects-monitoring"
  },
  {
    "name": "Automation Engineering",
    "apiurl": "/restapi/customcontent/advent-life-sciences-engineering-services/automation-engineering",
    "url": "/advent-life-sciences-engineering-services/automation-engineering",
    "template": "general_content",
    "section": "automation-engineering"
  },
  {
    "name": "Automation Engineering",
    "apiurl": "/restapi/customcontent/advent-life-sciences-engineering-services/automation-engineering",
    "url": "/consulting/engineering/biopharma-services/automation-engineering",
    "template": "general_content",
    "section": "automation-engineering"
  },
  {
    "name": "Project Management",
    "apiurl": "/restapi/customcontent/advent-life-sciences-engineering-services/project-management",
    "url": "/advent-life-sciences-engineering-services/project-management",
    "template": "general_content",
    "section": "project-management"
  },
  {
    "name": "Project Management",
    "apiurl": "/restapi/customcontent/advent-life-sciences-engineering-services/project-management",
    "url": "/consulting/engineering/biopharma-services/project-management",
    "template": "general_content",
    "section": "project-management"
  },
  {
    "name": "Regulatory Permitting, Authorizations, and Compliance",
    "apiurl": "/restapi/customcontent/minnow-aquatic-environmental-services/regulatory-permitting-authorizations-and-compliance",
    "url": "/minnow-aquatic-environmental-services/regulatory-permitting-authorizations-and-compliance",
    "template": "general_content",
    "section": "regulatory-permitting,-authorizations,-and-compliance"
  },
  {
    "name": "Hazard Communication and GHS Services",
    "apiurl": "/restapi/customcontent/safebridge-regulatory-life-sciences-group/hazard-communication-and-ghs-services",
    "url": "/safebridge-regulatory-life-sciences-group/hazard-communication-and-ghs-services",
    "template": "general_content",
    "section": "hazard-communication-and-ghs-services"
  },
  {
    "name": "Hazard Communication and GHS Services",
    "apiurl": "/restapi/customcontent/safebridge-regulatory-life-sciences-group/hazard-communication-and-ghs-services",
    "url": "/consulting/ehs/chemical-compliance/hazard-communication-and-ghs-services",
    "template": "general_content",
    "section": "hazard-communication-and-ghs-services"
  },
  {
    "name": "Process Development for Biopharmaceuticals",
    "apiurl": "/restapi/customcontent/advent-life-sciences-engineering-services/process-development-for-pharmaceuticals",
    "url": "/advent-life-sciences-engineering-services/process-development-for-pharmaceuticals",
    "template": "general_content",
    "section": "process-development-for-biopharmaceuticals"
  },
  {
    "name": "Aquatic Chemistry Studies",
    "apiurl": "/restapi/customcontent/Minnow-Aquatic-Environmental-Services/block-2",
    "url": "/Minnow-Aquatic-Environmental-Services/block-2",
    "template": "general_content",
    "section": "aquatic-chemistry-studies"
  },
  {
    "name": "Aquatic Chemistry Studies",
    "apiurl": "/restapi/customcontent/Minnow-Aquatic-Environmental-Services/block-2",
    "url": "/consulting/science/aquatic-ecology/6-aquatic-chemistry-studies",
    "template": "general_content",
    "section": "aquatic-chemistry-studies"
  },
  {
    "name": "Aquatic Environmental Monitoring",
    "apiurl": "/restapi/customcontent/minnow-aquatic-environmental-services/aquatic-environmental-monitoring",
    "url": "/minnow-aquatic-environmental-services/aquatic-environmental-monitoring",
    "template": "general_content",
    "section": "aquatic-environmental-monitoring"
  },
  {
    "name": "Aquatic Environmental Monitoring",
    "apiurl": "/restapi/customcontent/minnow-aquatic-environmental-services/aquatic-environmental-monitoring",
    "url": "/consulting/science/aquatic-ecology/aquatic-environmental-monitoring",
    "template": "general_content",
    "section": "aquatic-environmental-monitoring"
  },
  {
    "name": "Aquatic Toxicological Studies",
    "apiurl": "/restapi/customcontent/minnow-aquatic-environmental-services/aquatic-toxicological-studies",
    "url": "/minnow-aquatic-environmental-services/aquatic-toxicological-studies",
    "template": "general_content",
    "section": "aquatic-toxicological-studies"
  },
  {
    "name": "Aquatic Toxicological Studies",
    "apiurl": "/restapi/customcontent/minnow-aquatic-environmental-services/aquatic-toxicological-studies",
    "url": "/consulting/science/aquatic-ecology/aquatic-toxicological-studies",
    "template": "general_content",
    "section": "aquatic-toxicological-studies"
  },
  {
    "name": "Statistical Analysis of Environmental Data",
    "apiurl": "/restapi/customcontent/minnow-aquatic-environmental-services/statistical-analysis-of-environmental-data",
    "url": "/minnow-aquatic-environmental-services/statistical-analysis-of-environmental-data",
    "template": "general_content",
    "section": "statistical-analysis-of-environmental-data"
  },
  {
    "name": "Statistical Analysis of Environmental Data",
    "apiurl": "/restapi/customcontent/minnow-aquatic-environmental-services/statistical-analysis-of-environmental-data",
    "url": "/consulting/science/aquatic-ecology/statistical-analysis-of-environmental-data",
    "template": "general_content",
    "section": "statistical-analysis-of-environmental-data"
  },
  {
    "name": "Contaminant Dispersion and Hydrodynamic Mixing in Aquatic Systems",
    "apiurl": "/restapi/customcontent/minnow-aquatic-environmental-services/contaminant-dispersion-and-hydrodynamic-mixing-in-aquatic-systems",
    "url": "/minnow-aquatic-environmental-services/contaminant-dispersion-and-hydrodynamic-mixing-in-aquatic-systems",
    "template": "general_content",
    "section": "contaminant-dispersion-and-hydrodynamic-mixing-in-aquatic-systems"
  },
  {
    "name": "Contaminant Dispersion and Hydrodynamic Mixing in Aquatic Systems",
    "apiurl": "/restapi/customcontent/minnow-aquatic-environmental-services/contaminant-dispersion-and-hydrodynamic-mixing-in-aquatic-systems",
    "url": "/consulting/science/aquatic-ecology/contaminant-dispersion-and-hydrodynamic-mixing-in-aquatic-systems",
    "template": "general_content",
    "section": "contaminant-dispersion-and-hydrodynamic-mixing-in-aquatic-systems"
  },
  {
    "name": "Industrial Hygiene for Life Sciences",
    "apiurl": "/restapi/customcontent/safebridge-regulatory-life-sciences-group/industrial-hygiene-for-life-sciences",
    "url": "/safebridge-regulatory-life-sciences-group/industrial-hygiene-for-life-sciences",
    "template": "general_content",
    "section": "industrial-hygiene-for-life-sciences"
  },
  {
    "name": "Industrial Hygiene for Life Sciences",
    "apiurl": "/restapi/customcontent/safebridge-regulatory-life-sciences-group/industrial-hygiene-for-life-sciences",
    "url": "/consulting/ehs/health-safety/industrial-hygiene-for-life-sciences",
    "template": "general_content",
    "section": "industrial-hygiene-for-life-sciences"
  },
  {
    "name": "Potent Compound Safety Certification",
    "apiurl": "/restapi/customcontent/safebridge-regulatory-life-sciences-group/potent-compound-safety-certification",
    "url": "/safebridge-regulatory-life-sciences-group/potent-compound-safety-certification",
    "template": "general_content",
    "section": "potent-compound-safety-certification"
  },
  {
    "name": "Potent Compound Safety Certification",
    "apiurl": "/restapi/customcontent/safebridge-regulatory-life-sciences-group/potent-compound-safety-certification",
    "url": "/consulting/ehs/health-safety/Potent-Compound-Safety",
    "template": "general_content",
    "section": "potent-compound-safety-certification"
  },
  {
    "name": "Safety and Loss Control",
    "apiurl": "/restapi/customcontent/safebridge-regulatory-life-sciences-group/safety-and-loss-control",
    "url": "/safebridge-regulatory-life-sciences-group/safety-and-loss-control",
    "template": "general_content",
    "section": "safety-and-loss-control"
  },
  {
    "name": "Safety and Loss Control",
    "apiurl": "/restapi/customcontent/safebridge-regulatory-life-sciences-group/safety-and-loss-control",
    "url": "/consulting/ehs/health-safety/Safety-Loss-Control",
    "template": "general_content",
    "section": "safety-and-loss-control"
  },
  {
    "name": "Technical Support and Training",
    "apiurl": "/restapi/customcontent/minnow-aquatic-environmental-services/technical-support-and-training",
    "url": "/minnow-aquatic-environmental-services/technical-support-and-training",
    "template": "general_content",
    "section": "technical-support-and-training"
  },
  {
    "name": "Technical Support and Training",
    "apiurl": "/restapi/customcontent/minnow-aquatic-environmental-services/technical-support-and-training",
    "url": "/consulting/science/aquatic-ecology/technical-support-and-training",
    "template": "general_content",
    "section": "technical-support-and-training"
  },
  {
    "name": "Commissioning, Qualification and Validation",
    "apiurl": "/restapi/customcontent/advent-life-sciences-engineering-services/commissioning-qualification-and-validation",
    "url": "/advent-life-sciences-engineering-services/commissioning-qualification-and-validation",
    "template": "general_content",
    "section": "commissioning,-qualification-and-validation"
  },
  {
    "name": "Commissioning, Qualification and Validation",
    "apiurl": "/restapi/customcontent/advent-life-sciences-engineering-services/commissioning-qualification-and-validation",
    "url": "/consulting/engineering/biopharma-services/commissioning-qualification-and-validation",
    "template": "general_content",
    "section": "commissioning,-qualification-and-validation"
  },
  {
    "name": "Process Design",
    "apiurl": "/restapi/customcontent/advent-life-sciences-engineering-services/process-design",
    "url": "/advent-life-sciences-engineering-services/process-design",
    "template": "general_content",
    "section": "process-design"
  },
  {
    "name": "Process Design",
    "apiurl": "/restapi/customcontent/advent-life-sciences-engineering-services/process-design",
    "url": "/consulting/engineering/biopharma-services",
    "template": "general_content",
    "section": "process-design"
  },
  {
    "name": "Ingredient Approval",
    "apiurl": "/restapi/customcontent/safebridge-regulatory-life-sciences-group/ingredient-approval",
    "url": "/safebridge-regulatory-life-sciences-group/ingredient-approval",
    "template": "general_content",
    "section": "ingredient-approval"
  },
  {
    "name": "Ingredient Approval",
    "apiurl": "/restapi/customcontent/safebridge-regulatory-life-sciences-group/ingredient-approval",
    "url": "/consulting/science/Ingredient-Approval",
    "template": "general_content",
    "section": "ingredient-approval"
  },
  {
    "name": "Analytical Laboratory",
    "apiurl": "/restapi/customcontent/safebridge-regulatory-life-sciences-group/analytical-laboratory",
    "url": "/safebridge-regulatory-life-sciences-group/analytical-laboratory",
    "template": "general_content",
    "section": "analytical-laboratory"
  },
  {
    "name": "Analytical Laboratory",
    "apiurl": "/restapi/customcontent/safebridge-regulatory-life-sciences-group/analytical-laboratory",
    "url": "/consulting/ehs/health-safety/Analytical-Laboratory",
    "template": "general_content",
    "section": "analytical-laboratory"
  },
  {
    "name": "Fish and Fish Habitat Studies",
    "apiurl": "/restapi/customcontent/minnow-aquatic-environmental-services/fish-and-fish-habitat-studies",
    "url": "/minnow-aquatic-environmental-services/fish-and-fish-habitat-studies",
    "template": "general_content",
    "section": "fish-and-fish-habitat-studies"
  },
  {
    "name": "Fish and Fish Habitat Studies",
    "apiurl": "/restapi/customcontent/minnow-aquatic-environmental-services/fish-and-fish-habitat-studies",
    "url": "/consulting/science/aquatic-ecology/fish-and-fish-habitat-studies",
    "template": "general_content",
    "section": "fish-and-fish-habitat-studies"
  },
  {
    "name": "Environmental Health & Safety Program Support",
    "apiurl": "/restapi/customcontent/safebridge-regulatory-life-sciences-group/environmental-health-safety-program-support",
    "url": "/safebridge-regulatory-life-sciences-group/environmental-health-safety-program-support",
    "template": "general_content",
    "section": "environmental-health-safety-program-support"
  },
  {
    "name": "Environmental Health & Safety Program Support",
    "apiurl": "/restapi/customcontent/safebridge-regulatory-life-sciences-group/environmental-health-safety-program-support",
    "url": "/consulting/ehs/health-safety/EHS",
    "template": "general_content",
    "section": "environmental-health-safety-program-support"
  },
  {
    "name": "Aquatic Biological and Ecological Assessment",
    "apiurl": "/restapi/customcontent/Minnow-Aquatic-Environmental-Services/block1",
    "url": "/Minnow-Aquatic-Environmental-Services/block1",
    "template": "general_content",
    "section": "aquatic-biological-and-ecological-assessment"
  },
  {
    "name": "Aquatic Biological and Ecological Assessment",
    "apiurl": "/restapi/customcontent/Minnow-Aquatic-Environmental-Services/block1",
    "url": "/consulting/science/aquatic-ecology/aquatic-biological-and-ecological-assessment",
    "template": "general_content",
    "section": "aquatic-biological-and-ecological-assessment"
  },
  {
    "name": "Environmental Geochemistry",
    "apiurl": "/restapi/customcontent/minnow-aquatic-environmental-services/environmental-geochemistry",
    "url": "/minnow-aquatic-environmental-services/environmental-geochemistry",
    "template": "general_content",
    "section": "environmental-geochemistry"
  },
  {
    "name": "Environmental Geochemistry",
    "apiurl": "/restapi/customcontent/minnow-aquatic-environmental-services/environmental-geochemistry",
    "url": "/consulting/science/aquatic-ecology/environmental-geochemistry",
    "template": "general_content",
    "section": "environmental-geochemistry"
  },
  {
    "name": "Aquatic Environmental Impact Assessment",
    "apiurl": "/restapi/customcontent/Minnow-Aquatic-Environmental-Services/service-block-1",
    "url": "/Minnow-Aquatic-Environmental-Services/service-block-1",
    "template": "general_content",
    "section": "aquatic-environmental-impact-assessment"
  },
  {
    "name": "Aquatic Environmental Impact Assessment",
    "apiurl": "/restapi/customcontent/Minnow-Aquatic-Environmental-Services/service-block-1",
    "url": "/consulting/science/aquatic-ecology/aquatic-environmental-impact-assessment",
    "template": "general_content",
    "section": "aquatic-environmental-impact-assessment"
  },
  {
    "name": "General Information",
    "apiurl": "/restapi/customcontent/software/support/faq/faq",
    "url": "/software/support/faq/faq",
    "template": "general_content",
    "section": "general-information"
  },
  {
    "name": "TankESP",
    "apiurl": "/restapi/customcontent/software/support/release-notes/tankesp",
    "url": "/software/support/release-notes/tankesp",
    "template": "general_content",
    "section": "tankesp"
  },
  {
    "name": "ROADS",
    "apiurl": "/restapi/customcontent/software/support/release-notes/roads",
    "url": "/software/support/release-notes/roads",
    "template": "general_content",
    "section": "roads"
  },
  {
    "name": "Purchasing",
    "apiurl": "/restapi/customcontent/software/support/faq/purchasing",
    "url": "/software/support/faq/purchasing",
    "template": "general_content",
    "section": "purchasing"
  },
  {
    "name": "Support",
    "apiurl": "/restapi/customcontent/software/support/faq/support",
    "url": "/software/support/faq/support",
    "template": "general_content",
    "section": "support"
  },
  {
    "name": "3D Analyst",
    "apiurl": "/restapi/customcontent/software/support/release-notes/3d-analyst",
    "url": "/software/support/release-notes/3d-analyst",
    "template": "general_content",
    "section": "3d-analyst"
  },
  {
    "name": "3D Analyst",
    "apiurl": "/restapi/customcontent/software/support/release-notes/3d-analyst",
    "url": "/software/support/faqs/3d-analyst",
    "template": "general_content",
    "section": "3d-analyst"
  },
  {
    "name": "AERMOD",
    "apiurl": "/restapi/customcontent/software/support/release-notes/aermod",
    "url": "/software/support/release-notes/aermod",
    "template": "general_content",
    "section": "aermod"
  },
  {
    "name": "Incident Analyst",
    "apiurl": "/restapi/customcontent/software/support/release-notes/incident-analyst",
    "url": "/software/support/release-notes/incident-analyst",
    "template": "general_content",
    "section": "incident-analyst"
  },
  {
    "name": "MetView",
    "apiurl": "/restapi/customcontent/software/support/release-notes/metview",
    "url": "/software/support/release-notes/metview",
    "template": "general_content",
    "section": "metview"
  },
  {
    "name": "Maintenance",
    "apiurl": "/restapi/customcontent/software/support/faq/maintenance",
    "url": "/software/support/faq/maintenance",
    "template": "general_content",
    "section": "maintenance"
  },
  {
    "name": "Software Updates",
    "apiurl": "/restapi/customcontent/software/support/faq/software-updates",
    "url": "/software/support/faq/software-updates",
    "template": "general_content",
    "section": "software-updates"
  },
  {
    "name": "AERMET",
    "apiurl": "/restapi/customcontent/software/support/release-notes/aermet",
    "url": "/software/support/release-notes/aermet",
    "template": "general_content",
    "section": "aermet"
  },
  {
    "name": "AERSCREEN",
    "apiurl": "/restapi/customcontent/software/support/release-notes/aerscreen",
    "url": "/software/support/release-notes/aerscreen",
    "template": "general_content",
    "section": "aerscreen"
  },
  {
    "name": "Maintenance and Support",
    "apiurl": "/restapi/customcontent/software/support/maintenance-support-agreements/maintenance-and-support",
    "url": "/software/support/maintenance-support-agreements/maintenance-and-support",
    "template": "general_content",
    "section": "maintenance-and-support"
  },
  {
    "name": "Maintenance and Support",
    "apiurl": "/restapi/customcontent/software/support/maintenance-support-agreements/maintenance-and-support",
    "url": "/software/support/maintenance-and-support-agreements/maintenance-and-support",
    "template": "general_content",
    "section": "maintenance-and-support"
  },
  {
    "name": "Downwash Analyst",
    "apiurl": "/restapi/customcontent/software/support/release-notes/downwash-analyst",
    "url": "/software/support/release-notes/downwash-analyst",
    "template": "general_content",
    "section": "downwash-analyst"
  },
  {
    "name": "ExDAM",
    "apiurl": "/restapi/customcontent/software/support/release-notes/exdam",
    "url": "/software/support/release-notes/exdam",
    "template": "general_content",
    "section": "exdam"
  },
  {
    "name": "CALPUFF",
    "apiurl": "/restapi/customcontent/software/support/release-notes/calpuff",
    "url": "/software/support/release-notes/calpuff",
    "template": "general_content",
    "section": "calpuff"
  },
  {
    "name": "Licensing",
    "apiurl": "/restapi/customcontent/software/support/faq/licensing",
    "url": "/software/support/faq/licensing",
    "template": "general_content",
    "section": "licensing"
  },
  {
    "name": "AERMOD FAQs",
    "apiurl": "/restapi/customcontent/software/support/faq/aermod",
    "url": "/software/support/faq/aermod",
    "template": "general_content",
    "section": "aermod-faqs"
  },
  {
    "name": "VASDIP",
    "apiurl": "/restapi/customcontent/software/support/release-notes/vasdip",
    "url": "/software/support/release-notes/vasdip",
    "template": "general_content",
    "section": "vasdip"
  },
  {
    "name": "Submit Remote Modeling",
    "apiurl": "/restapi/customcontent/remote-modeling-requirements",
    "url": "/remote-modeling-requirements",
    "template": "general_content",
    "section": "submit-remote-modeling"
  },
  {
    "name": "Submit Remote Modeling",
    "apiurl": "/restapi/customcontent/remote-modeling-requirements",
    "url": "/submit-remote-modeling",
    "template": "general_content",
    "section": "submit-remote-modeling"
  },
  {
    "name": "Training Registration Policies",
    "apiurl": "/restapi/customcontent/shopping-cart/review-attendees",
    "url": "/shopping-cart/review-attendees",
    "template": "general_content",
    "section": "training-registration-policies"
  },
  {
    "name": "Training Registration Policies",
    "apiurl": "/restapi/customcontent/shopping-cart/review-attendees",
    "url": "/shoppingcart/review-attendees",
    "template": "general_content",
    "section": "training-registration-policies"
  },
  {
    "name": "Operational & Maintenance >",
    "apiurl": "/restapi/customtechnologylvl3content/technology/our-approach/operational-maintenance",
    "url": "/technology/our-approach/operational-maintenance",
    "template": "new-technology-individual-sub-category",
    "section": "our-approach"
  },
  {
    "name": "Operational & Maintenance >",
    "apiurl": "/restapi/customtechnologylvl3content/technology/our-approach/operational-maintenance",
    "url": "/environmental-technology/our-approach/operational-maintenance",
    "template": "new-technology-individual-sub-category",
    "section": "our-approach"
  },
  {
    "name": "Data Analytics & Regulatory Reporting >",
    "apiurl": "/restapi/customtechnologylvl3content/technology/our-approach/data-analytics-reg-reporting",
    "url": "/technology/our-approach/data-analytics-reg-reporting",
    "template": "new-technology-individual-sub-category",
    "section": "our-approach"
  },
  {
    "name": "Data Analytics & Regulatory Reporting >",
    "apiurl": "/restapi/customtechnologylvl3content/technology/our-approach/data-analytics-reg-reporting",
    "url": "/technology/our-approach/data-analytics",
    "template": "new-technology-individual-sub-category",
    "section": "our-approach"
  },
  {
    "name": "Deployment >",
    "apiurl": "/restapi/customtechnologylvl3content/technology/our-approach/deployment",
    "url": "/technology/our-approach/deployment",
    "template": "new-technology-individual-sub-category",
    "section": "our-approach"
  },
  {
    "name": "Deployment >",
    "apiurl": "/restapi/customtechnologylvl3content/technology/our-approach/deployment",
    "url": "/environmental-technology/our-approach/deployment",
    "template": "new-technology-individual-sub-category",
    "section": "our-approach"
  },
  {
    "name": "Strategy & Planning >",
    "apiurl": "/restapi/customtechnologylvl3content/technology/our-approach/strategy-planning",
    "url": "/technology/our-approach/strategy-planning",
    "template": "new-technology-individual-sub-category",
    "section": "our-approach"
  },
  {
    "name": "Agile Build & Integration >",
    "apiurl": "/restapi/customtechnologylvl3content/technology/our-approach/agile-build-and-integration",
    "url": "/technology/our-approach/agile-build-and-integration",
    "template": "new-technology-individual-sub-category",
    "section": "our-approach"
  },
  {
    "name": "Agile Build & Integration >",
    "apiurl": "/restapi/customtechnologylvl3content/technology/our-approach/agile-build-and-integration",
    "url": "/technology/our-approach/system-integration",
    "template": "new-technology-individual-sub-category",
    "section": "our-approach"
  },
  {
    "name": "Design & Development >",
    "apiurl": "/restapi/customtechnologylvl3content/technology/our-approach/design-development",
    "url": "/technology/our-approach/design-development",
    "template": "new-technology-individual-sub-category",
    "section": "our-approach"
  },
  {
    "name": "Industry Specific",
    "apiurl": "/restapi/customcontent/training/training-by-industry/industry-specific",
    "url": "/training/training-by-industry/industry-specific",
    "template": "general_content",
    "section": "industry-specific"
  },
  {
    "name": "Introductory Courses",
    "apiurl": "/restapi/customcontent/training/training-by-category/introductory-courses",
    "url": "/training/training-by-category/introductory-courses",
    "template": "general_content",
    "section": "introductory-courses"
  },
  {
    "name": "EHS&S Management",
    "apiurl": "/restapi/customcontent/training/training-by-category/ehs-s-management",
    "url": "/training/training-by-category/ehs-s-management",
    "template": "general_content",
    "section": "ehss-management"
  },
  {
    "name": "EHS Regulations",
    "apiurl": "/restapi/customcontent/training/training-by-category/ehs-regulations",
    "url": "/training/training-by-category/ehs-regulations",
    "template": "general_content",
    "section": "ehs-regulations"
  },
  {
    "name": "Technical Courses",
    "apiurl": "/restapi/customcontent/training/training-by-category/technical-courses",
    "url": "/training/training-by-category/technical-courses",
    "template": "general_content",
    "section": "technical-courses"
  },
  {
    "name": "Environmental Auditing",
    "apiurl": "/restapi/customcontent/training/training-by-category/environmental-auditing",
    "url": "/training/training-by-category/environmental-auditing",
    "template": "general_content",
    "section": "environmental-auditing"
  },
  {
    "name": "Software Courses",
    "apiurl": "/restapi/customcontent/training/training-by-category/software-courses",
    "url": "/training/training-by-category/software-courses",
    "template": "general_content",
    "section": "software-courses"
  },
  {
    "name": "Environmental Analysis",
    "apiurl": "/restapi/customcontent/training/training-by-category/environmental-analysis",
    "url": "/training/training-by-category/environmental-analysis",
    "template": "general_content",
    "section": "environmental-analysis"
  },
  {
    "name": "Environmental Reporting",
    "apiurl": "/restapi/customcontent/training/training-by-category/environmental-reporting",
    "url": "/training/training-by-category/environmental-reporting",
    "template": "general_content",
    "section": "environmental-reporting"
  },
  {
    "name": "Environmental Management",
    "apiurl": "/restapi/customcontent/training/training-by-category/environmental-management",
    "url": "/training/training-by-category/environmental-management",
    "template": "general_content",
    "section": "environmental-management"
  },
  {
    "name": "Recruiting",
    "apiurl": "/restapi/customcareerslvl2content/careers/recruiting",
    "url": "/careers/recruiting",
    "template": "new-trinity-company-career",
    "section": "careers"
  },
  {
    "name": "Recruiting",
    "apiurl": "/restapi/customcareerslvl2content/careers/recruiting",
    "url": "/environmental-consultant-career/recruiting",
    "template": "new-trinity-company-career",
    "section": "careers"
  },
  {
    "name": "Recruiting",
    "apiurl": "/restapi/customcareerslvl2content/careers/recruiting",
    "url": "/careers/recruiting",
    "template": "new-trinity-position",
    "section": "careers"
  },
  {
    "name": "Recruiting",
    "apiurl": "/restapi/customcareerslvl2content/careers/recruiting",
    "url": "/environmental-consultant-career/recruiting",
    "template": "new-trinity-position",
    "section": "careers"
  },
  {
    "name": "Career Program",
    "apiurl": "/restapi/customcareerslvl2content/careers/career-program",
    "url": "/careers/career-program",
    "template": "",
    "section": "careers"
  },
  {
    "name": "Career Program",
    "apiurl": "/restapi/customcareerslvl2content/careers/career-program",
    "url": "/careers/career-program",
    "template": "new-trinity-position",
    "section": "careers"
  },
  {
    "name": "Available Positions",
    "apiurl": "/restapi/customcareerslvl2content/careers/available-positions",
    "url": "/careers/available-positions",
    "template": "new-trinity-available-positions",
    "section": "careers"
  },
  {
    "name": "Available Positions",
    "apiurl": "/restapi/customcareerslvl2content/careers/available-positions",
    "url": "/about/careers/available-positions",
    "template": "new-trinity-available-positions",
    "section": "careers"
  },
  {
    "name": "Available Positions",
    "apiurl": "/restapi/customcareerslvl2content/careers/available-positions",
    "url": "/career/available-positions",
    "template": "new-trinity-available-positions",
    "section": "careers"
  },
  {
    "name": "Available Positions",
    "apiurl": "/restapi/customcareerslvl2content/careers/available-positions",
    "url": "/careers/available-positions",
    "template": "new-trinity-position",
    "section": "careers"
  },
  {
    "name": "Available Positions",
    "apiurl": "/restapi/customcareerslvl2content/careers/available-positions",
    "url": "/about/careers/available-positions",
    "template": "new-trinity-position",
    "section": "careers"
  },
  {
    "name": "Available Positions",
    "apiurl": "/restapi/customcareerslvl2content/careers/available-positions",
    "url": "/career/available-positions",
    "template": "new-trinity-position",
    "section": "careers"
  },
  {
    "name": "Benefits",
    "apiurl": "/restapi/customcareerslvl2content/careers/benefits",
    "url": "/careers/benefits",
    "template": "new-trinity-company-career",
    "section": "careers"
  },
  {
    "name": "Benefits",
    "apiurl": "/restapi/customcareerslvl2content/careers/benefits",
    "url": "/environmental-consultant-career/benefits",
    "template": "new-trinity-company-career",
    "section": "careers"
  },
  {
    "name": "Benefits",
    "apiurl": "/restapi/customcareerslvl2content/careers/benefits",
    "url": "/careers/benefits",
    "template": "new-trinity-position",
    "section": "careers"
  },
  {
    "name": "Benefits",
    "apiurl": "/restapi/customcareerslvl2content/careers/benefits",
    "url": "/environmental-consultant-career/benefits",
    "template": "new-trinity-position",
    "section": "careers"
  },
  {
    "name": "Culture",
    "apiurl": "/restapi/customcareerslvl2content/careers/culture",
    "url": "/careers/culture",
    "template": "new-trinity-company-career",
    "section": "careers"
  },
  {
    "name": "Culture",
    "apiurl": "/restapi/customcareerslvl2content/careers/culture",
    "url": "/careers/culture",
    "template": "new-trinity-position",
    "section": "careers"
  },
  {
    "name": "Prince Edward Island",
    "apiurl": "/restapi/customcontent/contact-us/Prince-Edward-Island",
    "url": "/contact-us/Prince-Edward-Island",
    "template": "general_content",
    "section": "prince-edward-island"
  },
  {
    "name": "Saskatchewan",
    "apiurl": "/restapi/customcontent/contact-us/Saskatchewan",
    "url": "/contact-us/Saskatchewan",
    "template": "general_content",
    "section": "saskatchewan"
  },
  {
    "name": "Nevada",
    "apiurl": "/restapi/customcontent/contact-us/Nevada",
    "url": "/contact-us/Nevada",
    "template": "general_content",
    "section": "nevada"
  },
  {
    "name": "Oregon",
    "apiurl": "/restapi/customcontent/contact-us/Oregon",
    "url": "/contact-us/Oregon",
    "template": "general_content",
    "section": "oregon"
  },
  {
    "name": "Texas",
    "apiurl": "/restapi/customcontent/contact-us/Texas",
    "url": "/contact-us/Texas",
    "template": "general_content",
    "section": "texas"
  },
  {
    "name": "Ohio",
    "apiurl": "/restapi/customcontent/contact-us/Ohio",
    "url": "/contact-us/Ohio",
    "template": "general_content",
    "section": "ohio"
  },
  {
    "name": "Leinster",
    "apiurl": "/restapi/customcontent/contact-us/leinster",
    "url": "/contact-us/leinster",
    "template": "general_content",
    "section": "leinster"
  },
  {
    "name": "Hawaii",
    "apiurl": "/restapi/customcontent/contact-us/Hawaii",
    "url": "/contact-us/Hawaii",
    "template": "general_content",
    "section": "hawaii"
  },
  {
    "name": "British Columbia",
    "apiurl": "/restapi/customcontent/contact-us/British-Columbia",
    "url": "/contact-us/British-Columbia",
    "template": "general_content",
    "section": "british-columbia"
  },
  {
    "name": "Georgia",
    "apiurl": "/restapi/customcontent/contact-us/Georgia",
    "url": "/contact-us/Georgia",
    "template": "general_content",
    "section": "georgia"
  },
  {
    "name": "Wyoming",
    "apiurl": "/restapi/customcontent/contact-us/Wyoming",
    "url": "/contact-us/Wyoming",
    "template": "general_content",
    "section": "wyoming"
  },
  {
    "name": "Arkansas",
    "apiurl": "/restapi/customcontent/contact-us/Arkansas",
    "url": "/contact-us/Arkansas",
    "template": "general_content",
    "section": "arkansas"
  },
  {
    "name": "Massachusetts",
    "apiurl": "/restapi/customcontent/contact-us/Massachusetts",
    "url": "/contact-us/Massachusetts",
    "template": "general_content",
    "section": "massachusetts"
  },
  {
    "name": "New Brunswick",
    "apiurl": "/restapi/customcontent/contact-us/New-Brunswick",
    "url": "/contact-us/New-Brunswick",
    "template": "general_content",
    "section": "new-brunswick"
  },
  {
    "name": "Iowa",
    "apiurl": "/restapi/customcontent/contact-us/Iowa",
    "url": "/contact-us/Iowa",
    "template": "general_content",
    "section": "iowa"
  },
  {
    "name": "South Dakota",
    "apiurl": "/restapi/customcontent/contact-us/South-Dakota",
    "url": "/contact-us/South-Dakota",
    "template": "general_content",
    "section": "south-dakota"
  },
  {
    "name": "New South Wales",
    "apiurl": "/restapi/customcontent/contact-us/new-south-wales",
    "url": "/contact-us/new-south-wales",
    "template": "general_content",
    "section": "new-south-wales"
  },
  {
    "name": "Utah",
    "apiurl": "/restapi/customcontent/contact-us/Utah",
    "url": "/contact-us/Utah",
    "template": "general_content",
    "section": "utah"
  },
  {
    "name": "Yukon",
    "apiurl": "/restapi/customcontent/contact-us/Yukon",
    "url": "/contact-us/Yukon",
    "template": "general_content",
    "section": "yukon"
  },
  {
    "name": "Hainan Province",
    "apiurl": "/restapi/customcontent/contact-us/hainan-province",
    "url": "/contact-us/hainan-province",
    "template": "general_content",
    "section": "hainan-province"
  },
  {
    "name": "Northwest Territories",
    "apiurl": "/restapi/customcontent/contact-us/Northwest-Territories",
    "url": "/contact-us/Northwest-Territories",
    "template": "general_content",
    "section": "northwest-territories"
  },
  {
    "name": "Calgary",
    "apiurl": "/restapi/customcontent/contact-us/Calgary",
    "url": "/contact-us/Calgary",
    "template": "general_content",
    "section": "calgary"
  },
  {
    "name": "Washington, DC",
    "apiurl": "/restapi/customcontent/contact-us/Washington-DC",
    "url": "/contact-us/Washington-DC",
    "template": "general_content",
    "section": "washington,-dc"
  },
  {
    "name": "Washington",
    "apiurl": "/restapi/customcontent/contact-us/Washington",
    "url": "/contact-us/Washington",
    "template": "general_content",
    "section": "washington"
  },
  {
    "name": "New Mexico",
    "apiurl": "/restapi/customcontent/contact-us/New-Mexico",
    "url": "/contact-us/New-Mexico",
    "template": "general_content",
    "section": "new-mexico"
  },
  {
    "name": "Idaho",
    "apiurl": "/restapi/customcontent/contact-us/Idaho",
    "url": "/contact-us/Idaho",
    "template": "general_content",
    "section": "idaho"
  },
  {
    "name": "Nova Scotia",
    "apiurl": "/restapi/customcontent/contact-us/Nova-Scotia",
    "url": "/contact-us/Nova-Scotia",
    "template": "general_content",
    "section": "nova-scotia"
  },
  {
    "name": "Vermont",
    "apiurl": "/restapi/customcontent/contact-us/Vermont",
    "url": "/contact-us/Vermont",
    "template": "general_content",
    "section": "vermont"
  },
  {
    "name": "North Carolina",
    "apiurl": "/restapi/customcontent/contact-us/North-Carolina",
    "url": "/contact-us/North-Carolina",
    "template": "general_content",
    "section": "north-carolina"
  },
  {
    "name": "Alabama",
    "apiurl": "/restapi/customcontent/contact-us/Alabama",
    "url": "/contact-us/Alabama",
    "template": "general_content",
    "section": "alabama"
  },
  {
    "name": "International",
    "apiurl": "/restapi/customcontent/contact-us/International",
    "url": "/contact-us/International",
    "template": "general_content",
    "section": "international"
  },
  {
    "name": "Indiana",
    "apiurl": "/restapi/customcontent/contact-us/Indiana",
    "url": "/contact-us/Indiana",
    "template": "general_content",
    "section": "indiana"
  },
  {
    "name": "Maine",
    "apiurl": "/restapi/customcontent/contact-us/Maine",
    "url": "/contact-us/Maine",
    "template": "general_content",
    "section": "maine"
  },
  {
    "name": "South Carolina",
    "apiurl": "/restapi/customcontent/contact-us/South-Carolina",
    "url": "/contact-us/South-Carolina",
    "template": "general_content",
    "section": "south-carolina"
  },
  {
    "name": "Zhejiang",
    "apiurl": "/restapi/customcontent/contact-us/Zhejiang",
    "url": "/contact-us/Zhejiang",
    "template": "general_content",
    "section": "zhejiang"
  },
  {
    "name": "Newfoundland and Labrador",
    "apiurl": "/restapi/customcontent/contact-us/Newfoundland-and-Labrador",
    "url": "/contact-us/Newfoundland-and-Labrador",
    "template": "general_content",
    "section": "newfoundland-and-labrador"
  },
  {
    "name": "Arizona",
    "apiurl": "/restapi/customcontent/contact-us/Arizona",
    "url": "/contact-us/Arizona",
    "template": "general_content",
    "section": "arizona"
  },
  {
    "name": "Kansas",
    "apiurl": "/restapi/customcontent/contact-us/Kansas",
    "url": "/contact-us/Kansas",
    "template": "general_content",
    "section": "kansas"
  },
  {
    "name": "Nunavut",
    "apiurl": "/restapi/customcontent/contact-us/Nunavut",
    "url": "/contact-us/Nunavut",
    "template": "general_content",
    "section": "nunavut"
  },
  {
    "name": "Maryland",
    "apiurl": "/restapi/customcontent/contact-us/Maryland",
    "url": "/contact-us/Maryland",
    "template": "general_content",
    "section": "maryland"
  },
  {
    "name": "Queensland",
    "apiurl": "/restapi/customcontent/contact-us/queensland",
    "url": "/contact-us/queensland",
    "template": "general_content",
    "section": "queensland"
  },
  {
    "name": "Missouri",
    "apiurl": "/restapi/customcontent/contact-us/Missouri",
    "url": "/contact-us/Missouri",
    "template": "general_content",
    "section": "missouri"
  },
  {
    "name": "North Dakota",
    "apiurl": "/restapi/customcontent/contact-us/North-Dakota",
    "url": "/contact-us/North-Dakota",
    "template": "general_content",
    "section": "north-dakota"
  },
  {
    "name": "California",
    "apiurl": "/restapi/customcontent/contact-us/California",
    "url": "/contact-us/California",
    "template": "general_content",
    "section": "california"
  },
  {
    "name": "Tennessee",
    "apiurl": "/restapi/customcontent/contact-us/Tennessee",
    "url": "/contact-us/Tennessee",
    "template": "general_content",
    "section": "tennessee"
  },
  {
    "name": "Nebraska",
    "apiurl": "/restapi/customcontent/contact-us/Nebraska",
    "url": "/contact-us/Nebraska",
    "template": "general_content",
    "section": "nebraska"
  },
  {
    "name": "District of Columbia",
    "apiurl": "/restapi/customcontent/contact-us/district-of-columbia",
    "url": "/contact-us/district-of-columbia",
    "template": "general_content",
    "section": "district-of-columbia"
  },
  {
    "name": "Oklahoma",
    "apiurl": "/restapi/customcontent/contact-us/Oklahoma",
    "url": "/contact-us/Oklahoma",
    "template": "general_content",
    "section": "oklahoma"
  },
  {
    "name": "Puerto Rico",
    "apiurl": "/restapi/customcontent/contact-us/Puerto-Rico",
    "url": "/contact-us/Puerto-Rico",
    "template": "general_content",
    "section": "puerto-rico"
  },
  {
    "name": "New Hampshire",
    "apiurl": "/restapi/customcontent/contact-us/New-Hampshire",
    "url": "/contact-us/New-Hampshire",
    "template": "general_content",
    "section": "new-hampshire"
  },
  {
    "name": "Canada",
    "apiurl": "/restapi/customcontent/contact-us/Canada",
    "url": "/contact-us/Canada",
    "template": "general_content",
    "section": "canada"
  },
  {
    "name": "Manitoba",
    "apiurl": "/restapi/customcontent/contact-us/Manitoba",
    "url": "/contact-us/Manitoba",
    "template": "general_content",
    "section": "manitoba"
  },
  {
    "name": "Quebec",
    "apiurl": "/restapi/customcontent/contact-us/Quebec",
    "url": "/contact-us/Quebec",
    "template": "general_content",
    "section": "quebec"
  },
  {
    "name": "Mississippi",
    "apiurl": "/restapi/customcontent/contact-us/Mississippi",
    "url": "/contact-us/Mississippi",
    "template": "general_content",
    "section": "mississippi"
  },
  {
    "name": "Wisconsin",
    "apiurl": "/restapi/customcontent/contact-us/Wisconsin",
    "url": "/contact-us/Wisconsin",
    "template": "general_content",
    "section": "wisconsin"
  },
  {
    "name": "West Virginia",
    "apiurl": "/restapi/customcontent/contact-us/West-Virginia",
    "url": "/contact-us/West-Virginia",
    "template": "general_content",
    "section": "west-virginia"
  },
  {
    "name": "Pennsylvania",
    "apiurl": "/restapi/customcontent/contact-us/Pennsylvania",
    "url": "/contact-us/Pennsylvania",
    "template": "general_content",
    "section": "pennsylvania"
  },
  {
    "name": "Guam",
    "apiurl": "/restapi/customcontent/contact-us/Guam",
    "url": "/contact-us/Guam",
    "template": "general_content",
    "section": "guam"
  },
  {
    "name": "Kentucky",
    "apiurl": "/restapi/customcontent/contact-us/Kentucky",
    "url": "/contact-us/Kentucky",
    "template": "general_content",
    "section": "kentucky"
  },
  {
    "name": "Alberta",
    "apiurl": "/restapi/customcontent/contact-us/Alberta",
    "url": "/contact-us/Alberta",
    "template": "general_content",
    "section": "alberta"
  },
  {
    "name": "United Kingdom",
    "apiurl": "/restapi/customcontent/contact-us/United-Kingdom",
    "url": "/contact-us/United-Kingdom",
    "template": "general_content",
    "section": "united-kingdom"
  },
  {
    "name": "Rhode Island",
    "apiurl": "/restapi/customcontent/contact-us/Rhode-Island",
    "url": "/contact-us/Rhode-Island",
    "template": "general_content",
    "section": "rhode-island"
  },
  {
    "name": "South Island",
    "apiurl": "/restapi/customcontent/contact-us/south-island",
    "url": "/contact-us/south-island",
    "template": "general_content",
    "section": "south-island"
  },
  {
    "name": "Montana",
    "apiurl": "/restapi/customcontent/contact-us/Montana",
    "url": "/contact-us/Montana",
    "template": "general_content",
    "section": "montana"
  },
  {
    "name": "Toronto",
    "apiurl": "/restapi/customcontent/contact-us/toronto",
    "url": "/contact-us/toronto",
    "template": "general_content",
    "section": "toronto"
  },
  {
    "name": "Beijing",
    "apiurl": "/restapi/customcontent/contact-us/beijing",
    "url": "/contact-us/beijing",
    "template": "general_content",
    "section": "beijing"
  },
  {
    "name": "Delaware",
    "apiurl": "/restapi/customcontent/contact-us/Delaware",
    "url": "/contact-us/Delaware",
    "template": "general_content",
    "section": "delaware"
  },
  {
    "name": "New Jersey",
    "apiurl": "/restapi/customcontent/contact-us/New-Jersey",
    "url": "/contact-us/New-Jersey",
    "template": "general_content",
    "section": "new-jersey"
  },
  {
    "name": "Guangdong",
    "apiurl": "/restapi/customcontent/contact-us/guangdong",
    "url": "/contact-us/guangdong",
    "template": "general_content",
    "section": "guangdong"
  },
  {
    "name": "Alaska",
    "apiurl": "/restapi/customcontent/contact-us/Alaska",
    "url": "/contact-us/Alaska",
    "template": "general_content",
    "section": "alaska"
  },
  {
    "name": "Colorado",
    "apiurl": "/restapi/customcontent/contact-us/Colorado",
    "url": "/contact-us/Colorado",
    "template": "general_content",
    "section": "colorado"
  },
  {
    "name": "Michigan",
    "apiurl": "/restapi/customcontent/contact-us/Michigan",
    "url": "/contact-us/Michigan",
    "template": "general_content",
    "section": "michigan"
  },
  {
    "name": "Illinois",
    "apiurl": "/restapi/customcontent/contact-us/Illinois",
    "url": "/contact-us/Illinois",
    "template": "general_content",
    "section": "illinois"
  },
  {
    "name": "New York",
    "apiurl": "/restapi/customcontent/contact-us/New-York",
    "url": "/contact-us/New-York",
    "template": "general_content",
    "section": "new-york"
  },
  {
    "name": "Florida",
    "apiurl": "/restapi/customcontent/contact-us/Florida",
    "url": "/contact-us/Florida",
    "template": "general_content",
    "section": "florida"
  },
  {
    "name": "Connecticut",
    "apiurl": "/restapi/customcontent/contact-us/Connecticut",
    "url": "/contact-us/Connecticut",
    "template": "general_content",
    "section": "connecticut"
  },
  {
    "name": "Louisiana",
    "apiurl": "/restapi/customcontent/contact-us/Louisiana",
    "url": "/contact-us/Louisiana",
    "template": "general_content",
    "section": "louisiana"
  },
  {
    "name": "Suffolk",
    "apiurl": "/restapi/customcontent/contact-us/suffolk",
    "url": "/contact-us/suffolk",
    "template": "general_content",
    "section": "suffolk"
  },
  {
    "name": "Virginia",
    "apiurl": "/restapi/customcontent/contact-us/Virginia",
    "url": "/contact-us/Virginia",
    "template": "general_content",
    "section": "virginia"
  },
  {
    "name": "Minnesota",
    "apiurl": "/restapi/customcontent/contact-us/Minnesota",
    "url": "/contact-us/Minnesota",
    "template": "general_content",
    "section": "minnesota"
  },
  {
    "name": "Request Data Quote",
    "apiurl": "/restapi/customcontent/request-data-quote",
    "url": "/request-data-quote",
    "template": "general_content",
    "section": "request-data-quote"
  },
  {
    "name": "Environmental Health & Safety",
    "apiurl": "/restapi/customcontent/environmental-health-safety",
    "url": "/environmental-health-safety",
    "template": "general_content",
    "section": "environmental-health-safety"
  },
  {
    "name": "Engineering",
    "apiurl": "/restapi/customcontent/engineering",
    "url": "/engineering",
    "template": "general_content",
    "section": "engineering"
  },
  {
    "name": "Accidental Hazardous Release",
    "apiurl": "/restapi/customcontent/contact-us/accidental-hazardous-release",
    "url": "/contact-us/accidental-hazardous-release",
    "template": "general_content",
    "section": "accidental-hazardous-release"
  },
  {
    "name": "Tank Services",
    "apiurl": "/restapi/customcontent/contact-us/tank-services",
    "url": "/contact-us/tank-services",
    "template": "general_content",
    "section": "tank-services"
  },
  {
    "name": "Explosion Damage Assessment",
    "apiurl": "/restapi/customcontent/contact-us/explosion-damage-assessment",
    "url": "/contact-us/explosion-damage-assessment",
    "template": "general_content",
    "section": "explosion-damage-assessment"
  },
  {
    "name": "Data Visualization and Analysis Tools",
    "apiurl": "/restapi/customcontent/contact-us/data-visualization-and-analysis-tools",
    "url": "/contact-us/data-visualization-and-analysis-tools",
    "template": "general_content",
    "section": "data-visualization-and-analysis-tools"
  },
  {
    "name": "Health Risk Assessment",
    "apiurl": "/restapi/customcontent/contact-us/health-risk-assessment",
    "url": "/contact-us/health-risk-assessment",
    "template": "general_content",
    "section": "health-risk-assessment"
  },
  {
    "name": "Continuous Release",
    "apiurl": "/restapi/customcontent/contact-us/continuous-release",
    "url": "/contact-us/continuous-release",
    "template": "general_content",
    "section": "continuous-release"
  },
  {
    "name": "Home",
    "apiurl": "/restapi/customcontent/home",
    "url": "/home",
    "template": "general_content",
    "section": "home"
  },
  {
    "name": "High Speed Modeling Services",
    "apiurl": "/restapi/customsoftwareservicecontentlvl2/software/high-speed-modeling-services",
    "url": "/software/high-speed-modeling-services",
    "template": "new-software-modeling-ready-data",
    "section": "software"
  },
  {
    "name": "High Speed Modeling Services",
    "apiurl": "/restapi/customsoftwareservicecontentlvl2/software/high-speed-modeling-services",
    "url": "/software/remote-modeling-services",
    "template": "new-software-modeling-ready-data",
    "section": "software"
  },
  {
    "name": "High Speed Modeling Services",
    "apiurl": "/restapi/customsoftwareservicecontentlvl2/software/high-speed-modeling-services",
    "url": "/software/high-speed-modeling-services",
    "template": "software-software-categories",
    "section": "software"
  },
  {
    "name": "High Speed Modeling Services",
    "apiurl": "/restapi/customsoftwareservicecontentlvl2/software/high-speed-modeling-services",
    "url": "/software/remote-modeling-services",
    "template": "software-software-categories",
    "section": "software"
  },
  {
    "name": "Software Resources",
    "apiurl": "/restapi/customsoftwareresourcescontent/software/resources",
    "url": "/software/resources",
    "template": "new-software-resources",
    "section": "software"
  },
  {
    "name": "Software Resources",
    "apiurl": "/restapi/customsoftwareresourcescontent/software/resources",
    "url": "/software/sw-resources",
    "template": "new-software-resources",
    "section": "software"
  },
  {
    "name": "Software Resources",
    "apiurl": "/restapi/customsoftwareresourcescontent/software/resources",
    "url": "/software/software-resources",
    "template": "new-software-resources",
    "section": "software"
  },
  {
    "name": "Software Resources",
    "apiurl": "/restapi/customsoftwareresourcescontent/software/resources",
    "url": "/software/resources",
    "template": "software-software-categories",
    "section": "software"
  },
  {
    "name": "Software Resources",
    "apiurl": "/restapi/customsoftwareresourcescontent/software/resources",
    "url": "/software/sw-resources",
    "template": "software-software-categories",
    "section": "software"
  },
  {
    "name": "Software Resources",
    "apiurl": "/restapi/customsoftwareresourcescontent/software/resources",
    "url": "/software/software-resources",
    "template": "software-software-categories",
    "section": "software"
  },
  {
    "name": "Custom Development Services",
    "apiurl": "/restapi/customsoftwareservicecontentlvl2/software/custom-model-development",
    "url": "/software/custom-model-development",
    "template": "new-software-modeling-ready-data",
    "section": "software"
  },
  {
    "name": "Custom Development Services",
    "apiurl": "/restapi/customsoftwareservicecontentlvl2/software/custom-model-development",
    "url": "/software/custom-development-services",
    "template": "new-software-modeling-ready-data",
    "section": "software"
  },
  {
    "name": "Custom Development Services",
    "apiurl": "/restapi/customsoftwareservicecontentlvl2/software/custom-model-development",
    "url": "/software/custom-solutions",
    "template": "new-software-modeling-ready-data",
    "section": "software"
  },
  {
    "name": "Custom Development Services",
    "apiurl": "/restapi/customsoftwareservicecontentlvl2/software/custom-model-development",
    "url": "/software/custom-model-development",
    "template": "software-software-categories",
    "section": "software"
  },
  {
    "name": "Custom Development Services",
    "apiurl": "/restapi/customsoftwareservicecontentlvl2/software/custom-model-development",
    "url": "/software/custom-development-services",
    "template": "software-software-categories",
    "section": "software"
  },
  {
    "name": "Custom Development Services",
    "apiurl": "/restapi/customsoftwareservicecontentlvl2/software/custom-model-development",
    "url": "/software/custom-solutions",
    "template": "software-software-categories",
    "section": "software"
  },
  {
    "name": "Regulatory Agency Program",
    "apiurl": "/restapi/customcontent/software/regulatory-agency-program",
    "url": "/software/regulatory-agency-program",
    "template": "regulatory-agency-program",
    "section": "software"
  },
  {
    "name": "Regulatory Agency Program",
    "apiurl": "/restapi/customcontent/software/regulatory-agency-program",
    "url": "/software/regulatory-agency-program",
    "template": "software-software-categories",
    "section": "software"
  },
  {
    "name": "Specialty Modeling Services",
    "apiurl": "/restapi/customsoftwareservicecontentlvl2/software/specialty-modeling-services",
    "url": "/software/specialty-modeling-services",
    "template": "new-software-modeling-ready-data",
    "section": "software"
  },
  {
    "name": "Specialty Modeling Services",
    "apiurl": "/restapi/customsoftwareservicecontentlvl2/software/specialty-modeling-services",
    "url": "/software/specialty-modeling-services",
    "template": "software-software-categories",
    "section": "software"
  },
  {
    "name": "Meteorological and Terrain Data",
    "apiurl": "/restapi/customsoftwareservicecontentlvl2/software/model-ready-data",
    "url": "/software/model-ready-data",
    "template": "new-software-modeling-ready-data",
    "section": "software"
  },
  {
    "name": "Meteorological and Terrain Data",
    "apiurl": "/restapi/customsoftwareservicecontentlvl2/software/model-ready-data",
    "url": "/software/meteorological-and-terrain-data",
    "template": "new-software-modeling-ready-data",
    "section": "software"
  },
  {
    "name": "Meteorological and Terrain Data",
    "apiurl": "/restapi/customsoftwareservicecontentlvl2/software/model-ready-data",
    "url": "/software/model-ready-data",
    "template": "software-software-categories",
    "section": "software"
  },
  {
    "name": "Meteorological and Terrain Data",
    "apiurl": "/restapi/customsoftwareservicecontentlvl2/software/model-ready-data",
    "url": "/software/meteorological-and-terrain-data",
    "template": "software-software-categories",
    "section": "software"
  },
  {
    "name": "Global Partners",
    "apiurl": "/restapi/customsoftwareservicecontentlvl2/software/global-partners",
    "url": "/software/global-partners",
    "template": "new-software-global-partners",
    "section": "software"
  },
  {
    "name": "Global Partners",
    "apiurl": "/restapi/customsoftwareservicecontentlvl2/software/global-partners",
    "url": "/software/global-partners",
    "template": "software-software-categories",
    "section": "software"
  },
  {
    "name": "Support",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl2/software/support",
    "url": "/software/support",
    "template": "new-software-support",
    "section": "software"
  },
  {
    "name": "Support",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl2/software/support",
    "url": "/software/software-support",
    "template": "new-software-support",
    "section": "software"
  },
  {
    "name": "Support",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl2/software/support",
    "url": "/software/support",
    "template": "software-software-categories",
    "section": "software"
  },
  {
    "name": "Support",
    "apiurl": "/restapi/customsoftwaresupportcontentlvl2/software/support",
    "url": "/software/software-support",
    "template": "software-software-categories",
    "section": "software"
  },
  {
    "name": "SCREEN3",
    "apiurl": "/restapi/customcontent/contact-us/screen3",
    "url": "/contact-us/screen3",
    "template": "general_content",
    "section": "screen3"
  },
  {
    "name": "TankESP FX",
    "apiurl": "/restapi/customcontent/contact-us/tankesp-fx",
    "url": "/contact-us/tankesp-fx",
    "template": "general_content",
    "section": "tankesp-fx"
  },
  {
    "name": "MetView",
    "apiurl": "/restapi/customcontent/contact-us/metview",
    "url": "/contact-us/metview",
    "template": "general_content",
    "section": "metview"
  },
  {
    "name": "AERMET",
    "apiurl": "/restapi/customcontent/contact-us/aermet",
    "url": "/contact-us/aermet",
    "template": "general_content",
    "section": "aermet"
  },
  {
    "name": "LFG Fire/Risk",
    "apiurl": "/restapi/customcontent/contact-us/lfg-fire-risk",
    "url": "/contact-us/lfg-fire-risk",
    "template": "general_content",
    "section": "lfg-firerisk"
  },
  {
    "name": "AERSCREEN",
    "apiurl": "/restapi/customcontent/contact-us/aerscreen",
    "url": "/contact-us/aerscreen",
    "template": "general_content",
    "section": "aerscreen"
  },
  {
    "name": "Incident Analyst",
    "apiurl": "/restapi/customcontent/contact-us/incident-analyst",
    "url": "/contact-us/incident-analyst",
    "template": "general_content",
    "section": "incident-analyst"
  },
  {
    "name": "Risk Analyst",
    "apiurl": "/restapi/customcontent/contact-us/risk-analyst",
    "url": "/contact-us/risk-analyst",
    "template": "general_content",
    "section": "risk-analyst"
  },
  {
    "name": "TankESP LT",
    "apiurl": "/restapi/customcontent/contact-us/tankesp-lt",
    "url": "/contact-us/tankesp-lt",
    "template": "general_content",
    "section": "tankesp-lt"
  },
  {
    "name": "Downwash Analyst",
    "apiurl": "/restapi/customcontent/contact-us/downwash-analyst",
    "url": "/contact-us/downwash-analyst",
    "template": "general_content",
    "section": "downwash-analyst"
  },
  {
    "name": "TankESP PRO",
    "apiurl": "/restapi/customcontent/contact-us/tankesp-pro",
    "url": "/contact-us/tankesp-pro",
    "template": "general_content",
    "section": "tankesp-pro"
  },
  {
    "name": "AERMOD",
    "apiurl": "/restapi/customcontent/contact-us/aermod",
    "url": "/contact-us/aermod",
    "template": "general_content",
    "section": "aermod"
  },
  {
    "name": "CALPUFF",
    "apiurl": "/restapi/customcontent/contact-us/calpuff",
    "url": "/contact-us/calpuff",
    "template": "general_content",
    "section": "calpuff"
  },
  {
    "name": "3D Analyst",
    "apiurl": "/restapi/customcontent/contact-us/3d-analyst",
    "url": "/contact-us/3d-analyst",
    "template": "general_content",
    "section": "3d-analyst"
  },
  {
    "name": "ROADS",
    "apiurl": "/restapi/customcontent/contact-us/roads",
    "url": "/contact-us/roads",
    "template": "general_content",
    "section": "roads"
  },
  {
    "name": "ExDAM",
    "apiurl": "/restapi/customcontent/contact-us/exdam",
    "url": "/contact-us/exdam",
    "template": "general_content",
    "section": "exdam"
  },
  {
    "name": "Software Solutions",
    "apiurl": "/restapi/customtechnologylvl2content/technology/software-solutions",
    "url": "/technology/software-solutions",
    "template": "new-technology-individual-category",
    "section": "technology"
  },
  {
    "name": "About EHS Digital Solutions",
    "apiurl": "/restapi/customtechnologylvl2content/technology/about-ehs-digital-solutions",
    "url": "/technology/about-ehs-digital-solutions",
    "template": "new-technology-individual-category",
    "section": "technology"
  },
  {
    "name": "About EHS Digital Solutions",
    "apiurl": "/restapi/customtechnologylvl2content/technology/about-ehs-digital-solutions",
    "url": "/technology/about-us",
    "template": "new-technology-individual-category",
    "section": "technology"
  },
  {
    "name": "Our Approach",
    "apiurl": "/restapi/customtechnologylvl2content/technology/our-approach",
    "url": "/technology/our-approach",
    "template": "new-technology-individual-category",
    "section": "technology"
  },
  {
    "name": "2020 Client Satisfaction Survey Summary",
    "apiurl": "/restapi/customcontent/home/2020-client-satisfaction-survey-summary",
    "url": "/home/2020-client-satisfaction-survey-summary",
    "template": "general_content",
    "section": "2020-client-satisfaction-survey-summary"
  },
  {
    "name": "CA-based Sespe Consulting Joins Trinity",
    "apiurl": "/restapi/customcontent/home/ca-based-sespe-consulting-joins-trinity",
    "url": "/home/ca-based-sespe-consulting-joins-trinity",
    "template": "general_content",
    "section": "ca-based-sespe-consulting-joins-trinity"
  },
  {
    "name": "Good News - Employee Highlights",
    "apiurl": "/restapi/customcontent/home/spot",
    "url": "/home/spot",
    "template": "general_content",
    "section": "good-news--employee-highlights"
  },
  {
    "name": "New Website - Expanded Expertise",
    "apiurl": "/restapi/customcontent/home/new-website---expanded-expertise",
    "url": "/home/new-website---expanded-expertise",
    "template": "general_content",
    "section": "new-website--expanded-expertise"
  },
  {
    "name": "New Website - Expanded Expertise",
    "apiurl": "/restapi/customcontent/home/new-website---expanded-expertise",
    "url": "/home/new-website---more-services",
    "template": "general_content",
    "section": "new-website--expanded-expertise"
  },
  {
    "name": "Trinity Acquires AWN Consulting",
    "apiurl": "/restapi/customcontent/home/trinity-acquires-awn-consulting",
    "url": "/home/trinity-acquires-awn-consulting",
    "template": "general_content",
    "section": "trinity-acquires-awn-consulting"
  },
  {
    "name": "Trinity Acquires AWN Consulting",
    "apiurl": "/restapi/customcontent/home/trinity-acquires-awn-consulting",
    "url": "/www.trinityconsultants.com/news/trinity-acquires-awn-consulting",
    "template": "general_content",
    "section": "trinity-acquires-awn-consulting"
  },
  {
    "name": "EHS Quarterly Issue 3",
    "apiurl": "/restapi/customcontent/home/ehs-quarterly-issue-3",
    "url": "/home/ehs-quarterly-issue-3",
    "template": "general_content",
    "section": "ehs-quarterly-issue-3"
  },
  {
    "name": "Climate Change & Sustainability Support",
    "apiurl": "/restapi/customcontent/home/climate-change-sustainability-support",
    "url": "/home/climate-change-sustainability-support",
    "template": "general_content",
    "section": "climate-change-sustainability-support"
  },
  {
    "name": "EHS Quarterly Issue 4",
    "apiurl": "/restapi/customcontent/home/ehs-quarterly-issue-4",
    "url": "/home/ehs-quarterly-issue-4",
    "template": "general_content",
    "section": "ehs-quarterly-issue-4"
  },
  {
    "name": "State\\Province News",
    "apiurl": "/restapi/customcontent/contact-us/state-province-news",
    "url": "/contact-us/state-province-news",
    "template": "general_content",
    "section": "state\\province-news"
  },
  {
    "name": "Federal News",
    "apiurl": "/restapi/customcontent/contact-us/federal-news",
    "url": "/contact-us/federal-news",
    "template": "general_content",
    "section": "federal-news"
  },
  {
    "name": "Consultant",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/consultant",
    "url": "/careers/available-positions/consultant",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Process Automation Engineer",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/process-automation-engineer",
    "url": "/careers/available-positions/process-automation-engineer",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Process Automation Engineer",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/process-automation-engineer",
    "url": "/careers/available-positions/automation-engineer-with-deltav",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Senior Market Research Analysts",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/senior-market-research-analysts",
    "url": "/careers/available-positions/senior-market-research-analysts",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Senior Air Quality Consultant",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/senior-air-quality-consultant-exton",
    "url": "/careers/available-positions/senior-air-quality-consultant-exton",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Senior Air Quality Consultant",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/senior-air-quality-consultant-exton",
    "url": "/careers/available-positions/senior-air-quality-consultant-pennsylvania-",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Associate Consultant - Entry Level",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/associate-consultant-entry-level-orlando",
    "url": "/careers/available-positions/associate-consultant-entry-level-orlando",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Senior Consultant",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/senior-consultant-bakersfield",
    "url": "/careers/available-positions/senior-consultant-bakersfield",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Associate Consultant-Entry Level",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/associate-consultant-entry-level-dallas",
    "url": "/careers/available-positions/associate-consultant-entry-level-dallas",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Associate Consultant-Entry Level",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/associate-consultant-entry-level-dallas",
    "url": "/careers/available-positions/associate-consultant--entry-level-dallas",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Associate Consultant-Entry Level",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/associate-consultant-entry-level-dallas",
    "url": "/careers/available-positions/associate-consultant-entry-level-burlington",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Associate Consultant-Entry Level",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/associate-consultant-entry-level-dallas",
    "url": "/careers/available-positions/associate-consultant-entry-level-texas",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Associate Consultant-Entry Level",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/associate-consultant-entry-level-dallas",
    "url": "/associate-consultant--entry-level-dallas",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Senior Cleaning Validation Consultant",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/senior-cleaning-validation-consultant",
    "url": "/careers/available-positions/senior-cleaning-validation-consultant",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Managing Consultant",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/managing-consultant",
    "url": "/careers/available-positions/managing-consultant",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Entry Level Environmental Engineer",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/entry-level-environmental-engineer-albany",
    "url": "/careers/available-positions/entry-level-environmental-engineer-albany",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Regional Staff Accountant",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/regional-staff-accountant-dallas",
    "url": "/careers/available-positions/regional-staff-accountant-dallas",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Consultant",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/consultant-covington",
    "url": "/careers/available-positions/consultant-covington",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Consultant",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/consultant-covington",
    "url": "/careers/available-positions/consultant-orlando",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Senior Consultant",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/senior-consultant",
    "url": "/careers/available-positions/senior-consultant",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Senior Air Quality Consultant",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/senior-air-quality-consultant-oakland",
    "url": "/careers/available-positions/senior-air-quality-consultant-oakland",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Senior Air Quality Consultant",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/senior-air-quality-consultant-oakland",
    "url": "/careers/available-positions/senior-air-quality-consultant-california-",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Validation / Senior Validation Engineer / Consultant",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/validation-senior-validation-engineer-consultant",
    "url": "/careers/available-positions/validation-senior-validation-engineer-consultant",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Validation Specialist",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/validation-specialist",
    "url": "/careers/available-positions/validation-specialist",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Associate Consultant - Entry Level",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/associate-consultant-entry-level-birmingham",
    "url": "/careers/available-positions/associate-consultant-entry-level-birmingham",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Associate Consultant - Entry Level",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/associate-consultant-entry-level-birmingham",
    "url": "/careers/available-positions/associate-consultant-entry-level-bakersfield",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Senior Air Quality Consultant",
    "apiurl": "/restapi/customcareerslvl3content/careers/available-positions/senior-air-quality-consultant",
    "url": "/careers/available-positions/senior-air-quality-consultant",
    "template": "new-trinity-individual-position",
    "section": "available-positions"
  },
  {
    "name": "Data for CALPUFF and CALMET",
    "apiurl": "/restapi/customcontent/contact-us/data-calpuff-calmet",
    "url": "/contact-us/data-calpuff-calmet",
    "template": "general_content",
    "section": "data-for-calpuff-and-calmet"
  },
  {
    "name": "TankESP",
    "apiurl": "/restapi/customcontent/contact-us/tankesp",
    "url": "/contact-us/tankesp",
    "template": "general_content",
    "section": "tankesp"
  },
  {
    "name": "Data for ISC and CAL3QHCR",
    "apiurl": "/restapi/customcontent/contact-us/data-isc-cal3qhcr",
    "url": "/contact-us/data-isc-cal3qhcr",
    "template": "general_content",
    "section": "data-for-isc-and-cal3qhcr"
  },
  {
    "name": "LFG Fire/Risk Modeling",
    "apiurl": "/restapi/customcontent/contact-us/lfg-fire-risk-modeling",
    "url": "/contact-us/lfg-fire-risk-modeling",
    "template": "general_content",
    "section": "lfg-firerisk-modeling"
  },
  {
    "name": "Specialized Consulting",
    "apiurl": "/restapi/customcontent/contact-us/specialized-consulting",
    "url": "/contact-us/specialized-consulting",
    "template": "general_content",
    "section": "specialized-consulting"
  },
  {
    "name": "VASDIP",
    "apiurl": "/restapi/customcontent/contact-us/vaspid",
    "url": "/contact-us/vaspid",
    "template": "general_content",
    "section": "vasdip"
  },
  {
    "name": "Data for AERMOD and AERMET",
    "apiurl": "/restapi/customcontent/contact-us/data-aermod-aermet",
    "url": "/contact-us/data-aermod-aermet",
    "template": "general_content",
    "section": "data-for-aermod-and-aermet"
  },
  {
    "name": "Consulting",
    "apiurl": "/restapi/customconsultingcontent/consulting",
    "url": "/consulting",
    "template": "new-consulting-landing",
    "section": "consulting"
  },
  {
    "name": "Data for ISC and CAL3QHCR",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/model-ready-data/data-isc-cal3qhcr",
    "url": "/software/model-ready-data/data-isc-cal3qhcr",
    "template": "new-software-software-sub-categories",
    "section": "meteorological-and-terrain-data"
  },
  {
    "name": "Data for ISC and CAL3QHCR",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/model-ready-data/data-isc-cal3qhcr",
    "url": "/software/model-ready-data/data-for-isc-and-cal3qhcr",
    "template": "new-software-software-sub-categories",
    "section": "meteorological-and-terrain-data"
  },
  {
    "name": "Data for ISC and CAL3QHCR",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/model-ready-data/data-isc-cal3qhcr",
    "url": "/software/meteorological-and-terrain-data/data-for-isc-and-cal3qhcr",
    "template": "new-software-software-sub-categories",
    "section": "meteorological-and-terrain-data"
  },
  {
    "name": "Pricing",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/model-ready-data/pricing",
    "url": "/software/model-ready-data/pricing",
    "template": "new-software-software-sub-categories",
    "section": "meteorological-and-terrain-data"
  },
  {
    "name": "Overview",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/custom-model-development/overview",
    "url": "/software/custom-model-development/overview",
    "template": "new-software-software-sub-categories",
    "section": "custom-development-services"
  },
  {
    "name": "Overview",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/custom-model-development/overview",
    "url": "/software/custom-development-services/overview",
    "template": "new-software-software-sub-categories",
    "section": "custom-development-services"
  },
  {
    "name": "Overview",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/specialty-modeling-services/overview",
    "url": "/software/specialty-modeling-services/overview",
    "template": "new-software-software-sub-categories",
    "section": "specialty-modeling-services"
  },
  {
    "name": "Cluster Computing",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/high-speed-modeling-services/cluster-computing",
    "url": "/software/high-speed-modeling-services/cluster-computing",
    "template": "new-software-software-sub-categories",
    "section": "high-speed-modeling-services"
  },
  {
    "name": "Meteorological Analysis",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/model-ready-data/meteorological-analysis",
    "url": "/software/model-ready-data/meteorological-analysis",
    "template": "new-software-software-sub-categories",
    "section": "meteorological-and-terrain-data"
  },
  {
    "name": "Meteorological Analysis",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/model-ready-data/meteorological-analysis",
    "url": "/software/meteorological-and-terrain-data/meteorological-analysis",
    "template": "new-software-software-sub-categories",
    "section": "meteorological-and-terrain-data"
  },
  {
    "name": "Standard Computing",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/high-speed-modeling-services/standard-computing",
    "url": "/software/high-speed-modeling-services/standard-computing",
    "template": "new-software-software-sub-categories",
    "section": "high-speed-modeling-services"
  },
  {
    "name": "Accidental Hazardous Release Modeling",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/specialty-modeling-services/accidental-hazardous-release-modeling",
    "url": "/software/specialty-modeling-services/accidental-hazardous-release-modeling",
    "template": "new-software-software-sub-categories",
    "section": "specialty-modeling-services"
  },
  {
    "name": "Explosion Modeling",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/specialty-modeling-services/explosion-modeling",
    "url": "/software/specialty-modeling-services/explosion-modeling",
    "template": "new-software-software-sub-categories",
    "section": "specialty-modeling-services"
  },
  {
    "name": "Frequently Asked Questions",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/support/faq",
    "url": "/software/support/faq",
    "template": "new-software-software-sub-categories",
    "section": "support"
  },
  {
    "name": "Release Notes",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/support/release-notes",
    "url": "/software/support/release-notes",
    "template": "new-software-software-sub-categories",
    "section": "support"
  },
  {
    "name": "Custom Datasets",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/model-ready-data/custom-datasets",
    "url": "/software/model-ready-data/custom-datasets",
    "template": "new-software-software-sub-categories",
    "section": "meteorological-and-terrain-data"
  },
  {
    "name": "Certified Consulting Meteorologists",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/model-ready-data/certified-consulting-meteorologists",
    "url": "/software/model-ready-data/certified-consulting-meteorologists",
    "template": "new-software-software-sub-categories",
    "section": "meteorological-and-terrain-data"
  },
  {
    "name": "Certified Consulting Meteorologists",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/model-ready-data/certified-consulting-meteorologists",
    "url": "/software/meteorological-and-terrain-data/certified-consulting-meteorologists",
    "template": "new-software-software-sub-categories",
    "section": "meteorological-and-terrain-data"
  },
  {
    "name": "Why Choose Us",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/model-ready-data/why-choose-us",
    "url": "/software/model-ready-data/why-choose-us",
    "template": "new-software-software-sub-categories",
    "section": "meteorological-and-terrain-data"
  },
  {
    "name": "Why Choose Us",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/model-ready-data/why-choose-us",
    "url": "/software/meteorological-and-terrain-data/why-choose-us",
    "template": "new-software-software-sub-categories",
    "section": "meteorological-and-terrain-data"
  },
  {
    "name": "Data for CALPUFF and CALMET",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/model-ready-data/data-calpuff-calmet",
    "url": "/software/model-ready-data/data-calpuff-calmet",
    "template": "new-software-software-sub-categories",
    "section": "meteorological-and-terrain-data"
  },
  {
    "name": "Data for CALPUFF and CALMET",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/model-ready-data/data-calpuff-calmet",
    "url": "/software/meteorological-and-terrain-data/data-for-calpuff-and-calmet",
    "template": "new-software-software-sub-categories",
    "section": "meteorological-and-terrain-data"
  },
  {
    "name": "Data for CALPUFF and CALMET",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/model-ready-data/data-calpuff-calmet",
    "url": "/software/model-ready-data/data-for-calpuff-and-calmet",
    "template": "new-software-software-sub-categories",
    "section": "meteorological-and-terrain-data"
  },
  {
    "name": "Data for ADMS",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/model-ready-data/data-adms",
    "url": "/software/model-ready-data/data-adms",
    "template": "new-software-software-sub-categories",
    "section": "meteorological-and-terrain-data"
  },
  {
    "name": "Data for ADMS",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/model-ready-data/data-adms",
    "url": "/software/model-ready-data/data-for-adms",
    "template": "new-software-software-sub-categories",
    "section": "meteorological-and-terrain-data"
  },
  {
    "name": "Data for ADMS",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/model-ready-data/data-adms",
    "url": "/software/meteorological-and-terrain-data/data-for-adms",
    "template": "new-software-software-sub-categories",
    "section": "meteorological-and-terrain-data"
  },
  {
    "name": "Overview",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/high-speed-modeling-services/overview",
    "url": "/software/high-speed-modeling-services/overview",
    "template": "new-software-software-sub-categories",
    "section": "high-speed-modeling-services"
  },
  {
    "name": "Data for AERMOD and AERMET",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/model-ready-data/data-aermod-aermet",
    "url": "/software/model-ready-data/data-aermod-aermet",
    "template": "new-software-software-sub-categories",
    "section": "meteorological-and-terrain-data"
  },
  {
    "name": "Data for AERMOD and AERMET",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/model-ready-data/data-aermod-aermet",
    "url": "/software/meteorological-and-terrain-data/data-for-aermod-and-aermet",
    "template": "new-software-software-sub-categories",
    "section": "meteorological-and-terrain-data"
  },
  {
    "name": "Data for AERMOD and AERMET",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/model-ready-data/data-aermod-aermet",
    "url": "/software/model-ready-data/data-for-aermod-and-aermet",
    "template": "new-software-software-sub-categories",
    "section": "meteorological-and-terrain-data"
  },
  {
    "name": "Air Dispersion Modeling",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/specialty-modeling-services/air-dispersion-modeling",
    "url": "/software/specialty-modeling-services/air-dispersion-modeling",
    "template": "new-software-software-sub-categories",
    "section": "specialty-modeling-services"
  },
  {
    "name": "Maintenance and Support Agreements",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/support/maintenance-support-agreements",
    "url": "/software/support/maintenance-support-agreements",
    "template": "new-software-software-sub-categories",
    "section": "support"
  },
  {
    "name": "Maintenance and Support Agreements",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/support/maintenance-support-agreements",
    "url": "/software/support/maintenance-and-support-agreements",
    "template": "new-software-software-sub-categories",
    "section": "support"
  },
  {
    "name": "Frequently Asked Questions",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/model-ready-data/faq",
    "url": "/software/model-ready-data/faq",
    "template": "new-software-software-sub-categories",
    "section": "meteorological-and-terrain-data"
  },
  {
    "name": "Frequently Asked Questions",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/model-ready-data/faq",
    "url": "/software/meteorological-and-terrain-data/model-ready-data-faqs",
    "template": "new-software-software-sub-categories",
    "section": "meteorological-and-terrain-data"
  },
  {
    "name": "Frequently Asked Questions",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/model-ready-data/faq",
    "url": "/software/model-ready-data/model-ready-data-faqs",
    "template": "new-software-software-sub-categories",
    "section": "meteorological-and-terrain-data"
  },
  {
    "name": "Overview",
    "apiurl": "/restapi/customsoftwareservicecontentlvl3/software/global-partners/overview",
    "url": "/software/global-partners/overview",
    "template": "new-software-software-sub-categories",
    "section": "global-partners"
  },
  {
    "name": "Degree",
    "apiurl": "/restapi/customcontent/contact-us/degree",
    "url": "/contact-us/degree",
    "template": "general_content",
    "section": "degree"
  },
  {
    "name": "Diploma",
    "apiurl": "/restapi/customcontent/contact-us/diploma",
    "url": "/contact-us/diploma",
    "template": "general_content",
    "section": "diploma"
  },
  {
    "name": "Review Shopping Cart",
    "apiurl": "/restapi/customcontent/shopping-cart",
    "url": "/shopping-cart",
    "template": "shopping-cart",
    "section": "review-shopping-cart"
  },
  {
    "name": "NAEM Software, Innovation, & Technology Showcase",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/naem-software-innovation-technology-showcase",
    "url": "/about-us/trade-shows/naem-software-innovation-technology-showcase",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "Energy Utility Environment Conference (EUEC)  Virtual + Live",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/euec-virtual-live",
    "url": "/about-us/trade-shows/euec-virtual-live",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "Kentucky Environmental Permitting and Reporting Conference",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/kentucky-environmental-permitting-and-reporting-conference",
    "url": "/about-us/trade-shows/kentucky-environmental-permitting-and-reporting-conference",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "NAEM EHS & Sustainability Management Forum",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/naem-ehs-sustainability-management-forum",
    "url": "/about-us/trade-shows/naem-ehs-sustainability-management-forum",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "Tennessee Environmental Conference",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/tennessee-environmental-conference",
    "url": "/about-us/trade-shows/tennessee-environmental-conference",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "2021 AFPM Summit",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/2021-afpm-summit",
    "url": "/about-us/trade-shows/2021-afpm-summit",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "Missouri Waste Control Coalition",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/missouri-waste-control-coalition",
    "url": "/about-us/trade-shows/missouri-waste-control-coalition",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "CIBO Combined Boiler Operations, Maintenance & Performance / Industrial Emissions Control Technology Conference",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/cibo-combined-boiler-emissions-virtual-conference",
    "url": "/about-us/trade-shows/cibo-combined-boiler-emissions-virtual-conference",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "ISPE Annual Meeting and Expo",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/ispe-annual-meeting-and-expo",
    "url": "/about-us/trade-shows/ispe-annual-meeting-and-expo",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "Annual Environmental Permitting Summer School",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/35th-annual-environmental-permitting-summer-school",
    "url": "/about-us/trade-shows/35th-annual-environmental-permitting-summer-school",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "AFPM Environmental Conference",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/afpm",
    "url": "/about-us/trade-shows/afpm",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "ILTA International Operating Conference & Trade Show",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/ilta-international-operating-conference-trade-show",
    "url": "/about-us/trade-shows/ilta-international-operating-conference-trade-show",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "API Storage Tank Conference And Safe Tank Entry Workshop",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/api-storage-tank-conference-and-safe-tank-entry-workshop",
    "url": "/about-us/trade-shows/api-storage-tank-conference-and-safe-tank-entry-workshop",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "ASHP Midyear Clinical Meeting and Exhibition",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/ashp-midyear-clinical-meeting-and-exhibition",
    "url": "/about-us/trade-shows/ashp-midyear-clinical-meeting-and-exhibition",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "IEEE-IAS/PCA Cement Conference 2021",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/ieee-ias-pca-cement-conference-2021",
    "url": "/about-us/trade-shows/ieee-ias-pca-cement-conference-2021",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "NMA MINExpo International",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/nma-minexpo-international",
    "url": "/about-us/trade-shows/nma-minexpo-international",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "2021 UTA Oil & Gas Conference",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/2021-uta-oil-gas-conference",
    "url": "/about-us/trade-shows/2021-uta-oil-gas-conference",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "AWMA Annual Conference & Exhibition",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/awma-annual-conference-exhibition",
    "url": "/about-us/trade-shows/awma-annual-conference-exhibition",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "Midwest Environmental Compliance Conference",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/midwest-environmental-compliance-conference",
    "url": "/about-us/trade-shows/midwest-environmental-compliance-conference",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "2021 Environmental Conference",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/2021-environmental-conference",
    "url": "/about-us/trade-shows/2021-environmental-conference",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "Specialty & Agro Chemicals America Forum",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/specialty-agro-chemicals-america-forum",
    "url": "/about-us/trade-shows/specialty-agro-chemicals-america-forum",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "4C Health Safety & Environmental Conference",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/4c-health-safety-environmental-conference",
    "url": "/about-us/trade-shows/4c-health-safety-environmental-conference",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "FET Annual Conference",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/fet-annual-conference",
    "url": "/about-us/trade-shows/fet-annual-conference",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "NCASI Virtual Conference",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/ncasi",
    "url": "/about-us/trade-shows/ncasi",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "Spring CAPCA Virtual Conference",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/capca-virtual-conference",
    "url": "/about-us/trade-shows/capca-virtual-conference",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "Indiana Chamber Environmental Conference",
    "apiurl": "/restapi/customcontent/about-us/trade-shows/indiana-chamber-environmental-conference",
    "url": "/about-us/trade-shows/indiana-chamber-environmental-conference",
    "template": "trade-shows",
    "section": "trade-shows-events"
  },
  {
    "name": "South",
    "apiurl": "/restapi/customcontent/contact-us/south",
    "url": "/contact-us/south",
    "template": "general_content",
    "section": "south"
  },
  {
    "name": "North",
    "apiurl": "/restapi/customcontent/contact-us/north",
    "url": "/contact-us/north",
    "template": "general_content",
    "section": "north"
  },
  {
    "name": "Request a Software Demo",
    "apiurl": "/restapi/customcontent/software-demo",
    "url": "/software-demo",
    "template": "general_content",
    "section": "request-a-software-demo"
  },
  {
    "name": "Australia",
    "apiurl": "/restapi/customcontent/locations/australia/australia",
    "url": "/locations/australia/australia",
    "template": "general_content",
    "section": "australia"
  },
  {
    "name": "North America",
    "apiurl": "/restapi/customcontent/default-mainlocation/location/north-america",
    "url": "/default-mainlocation/location/north-america",
    "template": "general_content",
    "section": "north-america"
  },
  {
    "name": "North America",
    "apiurl": "/restapi/customcontent/default-mainlocation/location/north-america",
    "url": "/location/north-america",
    "template": "general_content",
    "section": "north-america"
  },
  {
    "name": "Ireland",
    "apiurl": "/restapi/customcontent/locations/europe/ireland",
    "url": "/locations/europe/ireland",
    "template": "general_content",
    "section": "ireland"
  },
  {
    "name": "United Kingdom",
    "apiurl": "/restapi/customcontent/locations/europe/europe-country",
    "url": "/locations/europe/europe-country",
    "template": "general_content",
    "section": "united-kingdom"
  },
  {
    "name": "Canada",
    "apiurl": "/restapi/customcontent/locations/north-america/canada",
    "url": "/locations/north-america/canada",
    "template": "general_content",
    "section": "canada"
  },
  {
    "name": "Canada",
    "apiurl": "/restapi/customcontent/default-mainlocation/northamerica/canada",
    "url": "/default-mainlocation/northamerica/canada",
    "template": "general_content",
    "section": "canada"
  },
  {
    "name": "Canada",
    "apiurl": "/restapi/customcontent/default-mainlocation/northamerica/canada",
    "url": "/northamerica/canada",
    "template": "general_content",
    "section": "canada"
  },
  {
    "name": "United States",
    "apiurl": "/restapi/customcontent/locations/north-america/united-states",
    "url": "/locations/north-america/united-states",
    "template": "general_content",
    "section": "united-states"
  },
  {
    "name": "United States",
    "apiurl": "/restapi/customcontent/locations/north-america/united-states",
    "url": "/location/north-america/united-states",
    "template": "general_content",
    "section": "united-states"
  },
  {
    "name": "New Zealand",
    "apiurl": "/restapi/customcontent/locations/australia/new-zealand",
    "url": "/locations/australia/new-zealand",
    "template": "general_content",
    "section": "new-zealand"
  },
  {
    "name": "China",
    "apiurl": "/restapi/customcontent/default-mainlocation/location/china",
    "url": "/default-mainlocation/location/china",
    "template": "general_content",
    "section": "china"
  },
  {
    "name": "China",
    "apiurl": "/restapi/customcontent/default-mainlocation/location/china",
    "url": "/location/china",
    "template": "general_content",
    "section": "china"
  },
  {
    "name": "United States",
    "apiurl": "/restapi/customcontent/default-mainlocation/northamerica/unitedstates",
    "url": "/default-mainlocation/northamerica/unitedstates",
    "template": "general_content",
    "section": "united-states"
  },
  {
    "name": "United States",
    "apiurl": "/restapi/customcontent/default-mainlocation/northamerica/unitedstates",
    "url": "/northamerica/unitedstates",
    "template": "general_content",
    "section": "united-states"
  },
  {
    "name": "Australia",
    "apiurl": "/restapi/customcontent/default-mainlocation/australia/australia",
    "url": "/default-mainlocation/australia/australia",
    "template": "general_content",
    "section": "australia"
  },
  {
    "name": "Australia",
    "apiurl": "/restapi/customcontent/default-mainlocation/australia/australia",
    "url": "/australia/australia",
    "template": "general_content",
    "section": "australia"
  },
  {
    "name": "China",
    "apiurl": "/restapi/customcontent/locations/asia/china",
    "url": "/locations/asia/china",
    "template": "general_content",
    "section": "china"
  },
  {
    "name": "China",
    "apiurl": "/restapi/customcontent/locations/asia/china",
    "url": "/locations/asia-pacific/asia-pacific-country",
    "template": "general_content",
    "section": "china"
  },
  {
    "name": "China",
    "apiurl": "/restapi/customcontent/locations/asia/china",
    "url": "/locations/asia/asia-pacific-country",
    "template": "general_content",
    "section": "china"
  },
  {
    "name": "Australia",
    "apiurl": "/restapi/customcontent/default-mainlocation/location/australia",
    "url": "/default-mainlocation/location/australia",
    "template": "general_content",
    "section": "australia"
  },
  {
    "name": "Australia",
    "apiurl": "/restapi/customcontent/default-mainlocation/location/australia",
    "url": "/location/australia",
    "template": "general_content",
    "section": "australia"
  },
  {
    "name": "United Kingdom",
    "apiurl": "/restapi/customcontent/default-mainlocation/location/united-kingdom",
    "url": "/default-mainlocation/location/united-kingdom",
    "template": "general_content",
    "section": "united-kingdom"
  },
  {
    "name": "United Kingdom",
    "apiurl": "/restapi/customcontent/default-mainlocation/location/united-kingdom",
    "url": "/location/united-kingdom",
    "template": "general_content",
    "section": "united-kingdom"
  },
  {
    "name": "Contact Information",
    "apiurl": "/restapi/customcontent/contact-us/contact-information",
    "url": "/contact-us/contact-information",
    "template": "general_content",
    "section": "contact-information"
  },
  {
    "name": "Request a Trial License",
    "apiurl": "/restapi/customcontent/request-a-trial-license",
    "url": "/request-a-trial-license",
    "template": "general_content",
    "section": "request-a-trial-license"
  },
  {
    "name": "VideoIcon",
    "apiurl": "/restapi/customcontent/contact-us/videoicon",
    "url": "/contact-us/videoicon",
    "template": "general_content",
    "section": "videoicon"
  },
  {
    "name": "NewsIcon",
    "apiurl": "/restapi/customcontent/contact-us/newsicon",
    "url": "/contact-us/newsicon",
    "template": "general_content",
    "section": "newsicon"
  },
  {
    "name": "TrainingIcon",
    "apiurl": "/restapi/customcontent/contact-us/trainingicon",
    "url": "/contact-us/trainingicon",
    "template": "general_content",
    "section": "trainingicon"
  },
  {
    "name": "PDFIcon",
    "apiurl": "/restapi/customcontent/contact-us/pdficon",
    "url": "/contact-us/pdficon",
    "template": "general_content",
    "section": "pdficon"
  },
  {
    "name": "ProductIcon",
    "apiurl": "/restapi/customcontent/contact-us/producticon",
    "url": "/contact-us/producticon",
    "template": "general_content",
    "section": "producticon"
  },
  {
    "name": "MediaIcon",
    "apiurl": "/restapi/customcontent/contact-us/mediaicon",
    "url": "/contact-us/mediaicon",
    "template": "general_content",
    "section": "mediaicon"
  },
  {
    "name": "TradeShowIcon",
    "apiurl": "/restapi/customcontent/contact-us/trandshowicon",
    "url": "/contact-us/trandshowicon",
    "template": "general_content",
    "section": "tradeshowicon"
  },
  {
    "name": "BREEZE Software Support",
    "apiurl": "/restapi/customcontent/contact-us/breeze-software-support",
    "url": "/contact-us/breeze-software-support",
    "template": "general_content",
    "section": "breeze-software-support"
  },
  {
    "name": "Request Software Quote",
    "apiurl": "/restapi/customcontent/request-software-quote",
    "url": "/request-software-quote",
    "template": "general_content",
    "section": "request-software-quote"
  },
  {
    "name": "Creating Animations with Incident Analyst Results using BREEZE 3D Analyst",
    "apiurl": "/restapi/customcontent/software/hazard/incident-analyst/creating-animations-with-incident-analyst-results-using-breeze-3d-analyst",
    "url": "/software/hazard/incident-analyst/creating-animations-with-incident-analyst-results-using-breeze-3d-analyst",
    "template": "general_content",
    "section": "creating-animations-with-incident-analyst-results-using-breeze-3d-analyst"
  },
  {
    "name": "TankESP Software Product Suite Version 5.0 Overview Tutorial",
    "apiurl": "/restapi/customcontent/software/tanks/tankesp/tankesp-software-product-suite-version-5.0-overview-tutorial",
    "url": "/software/tanks/tankesp/tankesp-software-product-suite-version-5.0-overview-tutorial",
    "template": "general_content",
    "section": "tankesp-software-product-suite-version-5.0-overview-tutorial"
  },
  {
    "name": "TankESP Software Product Suite Version 5.0 Overview Tutorial",
    "apiurl": "/restapi/customcontent/software/tanks/tankesp/tankesp-software-product-suite-version-5.0-overview-tutorial",
    "url": "/software/tank-emissions/tankesp/tankesp-software-product-suite-version-5.0-overview-tutorial",
    "template": "general_content",
    "section": "tankesp-software-product-suite-version-5.0-overview-tutorial"
  },
  {
    "name": "Import 3D Data Files - ExDAM 3D Extend Module",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/import-3d-data-files---exdam-3d-extend-module",
    "url": "/software/explosion/exdam/import-3d-data-files---exdam-3d-extend-module",
    "template": "general_content",
    "section": "import-3d-data-files--exdam-3d-extend-module"
  },
  {
    "name": "BREEZE AERSCREEN Demo",
    "apiurl": "/restapi/customcontent/software/dispersion/aerscreen/breeze-aerscreen-demo",
    "url": "/software/dispersion/aerscreen/breeze-aerscreen-demo",
    "template": "general_content",
    "section": "breeze-aerscreen-demo"
  },
  {
    "name": "Tutorial: Creating Roadway Sources Using Drawing Tools in BREEZE AERMOD",
    "apiurl": "/restapi/customcontent/software/dispersion/aermod/tutorial-creating-roadway-sources-using-drawing-tools-in-breeze-aermod",
    "url": "/software/dispersion/aermod/tutorial-creating-roadway-sources-using-drawing-tools-in-breeze-aermod",
    "template": "general_content",
    "section": "tutorial:-creating-roadway-sources-using-drawing-tools-in-breeze-aermod"
  },
  {
    "name": "03: Quickly Define Meteorological Conditions and Levels of Concern – BREEZE Incident Analyst ",
    "apiurl": "/restapi/customcontent/software/hazard/incident-analyst/03-quickly-define-meteorological-conditions-and-levels-of-concern-breeze-incident-analyst",
    "url": "/software/hazard/incident-analyst/03-quickly-define-meteorological-conditions-and-levels-of-concern-breeze-incident-analyst",
    "template": "general_content",
    "section": "03:-quickly-define-meteorological-conditions-and-levels-of-concern-–-breeze-incident-analyst-"
  },
  {
    "name": "05: Analyze and Visualize Model Results – BREEZE Incident Analyst ",
    "apiurl": "/restapi/customcontent/software/hazard/incident-analyst/05-analyze-and-visualize-model-results-breeze-incident-analyst",
    "url": "/software/hazard/incident-analyst/05-analyze-and-visualize-model-results-breeze-incident-analyst",
    "template": "general_content",
    "section": "05:-analyze-and-visualize-model-results-–-breeze-incident-analyst-"
  },
  {
    "name": "Animating Gridded Meteorological Data",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/animating-gridded-meteorological-data",
    "url": "/software/air-dispersion---data-visualization/3d-analyst/animating-gridded-meteorological-data",
    "template": "general_content",
    "section": "animating-gridded-meteorological-data"
  },
  {
    "name": "Animating Gridded Meteorological Data",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/animating-gridded-meteorological-data",
    "url": "/software/air-dispersion---data/3d-analyst/animating-gridded-meteorological-data",
    "template": "general_content",
    "section": "animating-gridded-meteorological-data"
  },
  {
    "name": "Animating Gridded Meteorological Data",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/animating-gridded-meteorological-data",
    "url": "/software/air-dispersion-data-visualization/3d-analyst/animating-gridded-meteorological-data",
    "template": "general_content",
    "section": "animating-gridded-meteorological-data"
  },
  {
    "name": "BREEZE SCREEN3 Overview",
    "apiurl": "/restapi/customcontent/software/dispersion/screen3/breeze-screen3-overview",
    "url": "/software/dispersion/screen3/breeze-screen3-overview",
    "template": "general_content",
    "section": "breeze-screen3-overview"
  },
  {
    "name": "Sample Grid Results - BREEZE ExDAM",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/sample-grid-results---breeze-exdam",
    "url": "/software/explosion/exdam/sample-grid-results---breeze-exdam",
    "template": "general_content",
    "section": "sample-grid-results--breeze-exdam"
  },
  {
    "name": "BREEZE Incident Analyst: Results Analysis - Plume Dispersion",
    "apiurl": "/restapi/customcontent/software/hazard/incident-analyst/breeze-incident-analyst-results-analysis---plume-dispersion",
    "url": "/software/hazard/incident-analyst/breeze-incident-analyst-results-analysis---plume-dispersion",
    "template": "general_content",
    "section": "breeze-incident-analyst:-results-analysis--plume-dispersion"
  },
  {
    "name": "Tutorial: How to import data from a spreadsheet into BREEZE AERMOD",
    "apiurl": "/restapi/customcontent/software/dispersion/aermod/tutorial-how-to-import-data-from-a-spreadsheet-into-breeze-aermod",
    "url": "/software/dispersion/aermod/tutorial-how-to-import-data-from-a-spreadsheet-into-breeze-aermod",
    "template": "general_content",
    "section": "tutorial:-how-to-import-data-from-a-spreadsheet-into-breeze-aermod"
  },
  {
    "name": "Phase I - Structure Development",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/phase-i---structure-development",
    "url": "/software/explosion/exdam/phase-i---structure-development",
    "template": "general_content",
    "section": "phase-i--structure-development"
  },
  {
    "name": "West, Texas Explosion Analysis",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/west-texas-explosion-analysis",
    "url": "/software/explosion/exdam/west-texas-explosion-analysis",
    "template": "general_content",
    "section": "west,-texas-explosion-analysis"
  },
  {
    "name": "Import Structures from Text Files (.txt) - 3D Extend Module",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/import-structures-from-text-files-(.txt)---3d-extend-module",
    "url": "/software/explosion/exdam/import-structures-from-text-files-(.txt)---3d-extend-module",
    "template": "general_content",
    "section": "import-structures-from-text-files-(.txt)--3d-extend-module"
  },
  {
    "name": "04: Multiple Ways to Add Sources and Receptors – BREEZE Incident Analyst ",
    "apiurl": "/restapi/customcontent/software/hazard/incident-analyst/04-multiple-ways-to-add-sources-and-receptors-breeze-incident-analyst",
    "url": "/software/hazard/incident-analyst/04-multiple-ways-to-add-sources-and-receptors-breeze-incident-analyst",
    "template": "general_content",
    "section": "04:-multiple-ways-to-add-sources-and-receptors-–-breeze-incident-analyst-"
  },
  {
    "name": "BREEZE AERSCREEN Overview",
    "apiurl": "/restapi/customcontent/software/dispersion/aerscreen/breeze-aerscreen-overview",
    "url": "/software/dispersion/aerscreen/breeze-aerscreen-overview",
    "template": "general_content",
    "section": "breeze-aerscreen-overview"
  },
  {
    "name": "Tutorial: Importing Base Maps in BREEZE AERMOD",
    "apiurl": "/restapi/customcontent/software/dispersion/aermod/tutorial-importing-base-maps-in-breeze-aermod",
    "url": "/software/dispersion/aermod/tutorial-importing-base-maps-in-breeze-aermod",
    "template": "general_content",
    "section": "tutorial:-importing-base-maps-in-breeze-aermod"
  },
  {
    "name": "02: Editing an Existing Building Structure – BREEZE ExDAM",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/02-editing-an-existing-building-structure-breeze-exdam",
    "url": "/software/explosion/exdam/02-editing-an-existing-building-structure-breeze-exdam",
    "template": "general_content",
    "section": "02:-editing-an-existing-building-structure-–-breeze-exdam"
  },
  {
    "name": "01: Getting Started – BREEZE Incident Analyst",
    "apiurl": "/restapi/customcontent/software/hazard/incident-analyst/01-getting-started-breeze-incident-analyst",
    "url": "/software/hazard/incident-analyst/01-getting-started-breeze-incident-analyst",
    "template": "general_content",
    "section": "01:-getting-started-–-breeze-incident-analyst"
  },
  {
    "name": "Working with Gridded Meteorological Data",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/working-with-gridded-meteorological-data",
    "url": "/software/air-dispersion---data-visualization/3d-analyst/working-with-gridded-meteorological-data",
    "template": "general_content",
    "section": "working-with-gridded-meteorological-data"
  },
  {
    "name": "Working with Gridded Meteorological Data",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/working-with-gridded-meteorological-data",
    "url": "/software/air-dispersion-data-visualization/3d-analyst/working-with-gridded-meteorological-data",
    "template": "general_content",
    "section": "working-with-gridded-meteorological-data"
  },
  {
    "name": "Working with Gridded Meteorological Data",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/working-with-gridded-meteorological-data",
    "url": "/software/air-dispersion---data/3d-analyst/working-with-gridded-meteorological-data",
    "template": "general_content",
    "section": "working-with-gridded-meteorological-data"
  },
  {
    "name": "BREEZE AERMOD Overview Tutorial",
    "apiurl": "/restapi/customcontent/software/dispersion/aermod/breeze-aermod-overview-tutorial",
    "url": "/software/dispersion/aermod/breeze-aermod-overview-tutorial",
    "template": "general_content",
    "section": "breeze-aermod-overview-tutorial"
  },
  {
    "name": "BREEZE CALPUFF: Results Analysis - Puff Dispersion of Pollutants",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/breeze-calpuff-results-analysis---puff-dispersion-of-pollutants",
    "url": "/software/air-dispersion---data-visualization/3d-analyst/breeze-calpuff-results-analysis---puff-dispersion-of-pollutants",
    "template": "general_content",
    "section": "breeze-calpuff:-results-analysis--puff-dispersion-of-pollutants"
  },
  {
    "name": "BREEZE CALPUFF: Results Analysis - Puff Dispersion of Pollutants",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/breeze-calpuff-results-analysis---puff-dispersion-of-pollutants",
    "url": "/software/air-dispersion-data-visualization/3d-analyst/breeze-calpuff-results-analysis---puff-dispersion-of-pollutants",
    "template": "general_content",
    "section": "breeze-calpuff:-results-analysis--puff-dispersion-of-pollutants"
  },
  {
    "name": "BREEZE CALPUFF: Results Analysis - Puff Dispersion of Pollutants",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/breeze-calpuff-results-analysis---puff-dispersion-of-pollutants",
    "url": "/software/air-dispersion---data/3d-analyst/breeze-calpuff-results-analysis---puff-dispersion-of-pollutants",
    "template": "general_content",
    "section": "breeze-calpuff:-results-analysis--puff-dispersion-of-pollutants"
  },
  {
    "name": "Tutorial: Creating Animations in BREEZE 3D Analyst",
    "apiurl": "/restapi/customcontent/software/dispersion/aermod/tutorial-creating-animations-in-breeze-3d-analyst",
    "url": "/software/dispersion/aermod/tutorial-creating-animations-in-breeze-3d-analyst",
    "template": "general_content",
    "section": "tutorial:-creating-animations-in-breeze-3d-analyst"
  },
  {
    "name": "01: Build a Basic Building Structure – BREEZE ExDAM",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/01-build-a-basic-building-structure-breeze-exdam",
    "url": "/software/explosion/exdam/01-build-a-basic-building-structure-breeze-exdam",
    "template": "general_content",
    "section": "01:-build-a-basic-building-structure-–-breeze-exdam"
  },
  {
    "name": "Tutorial: Importing Buildings in BREEZE AERMOD",
    "apiurl": "/restapi/customcontent/software/dispersion/aermod/tutorial-importing-buildings-in-breeze-aermod",
    "url": "/software/dispersion/aermod/tutorial-importing-buildings-in-breeze-aermod",
    "template": "general_content",
    "section": "tutorial:-importing-buildings-in-breeze-aermod"
  },
  {
    "name": "BREEZE Incident Analyst: Results Analysis - Plume Dispersion",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/breeze-incident-analyst-results-analysis---plume-dispersion",
    "url": "/software/air-dispersion---data-visualization/3d-analyst/breeze-incident-analyst-results-analysis---plume-dispersion",
    "template": "general_content",
    "section": "breeze-incident-analyst:-results-analysis--plume-dispersion"
  },
  {
    "name": "BREEZE Incident Analyst: Results Analysis - Plume Dispersion",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/breeze-incident-analyst-results-analysis---plume-dispersion",
    "url": "/software/air-dispersion-data-visualization/3d-analyst/breeze-incident-analyst-results-analysis---plume-dispersion",
    "template": "general_content",
    "section": "breeze-incident-analyst:-results-analysis--plume-dispersion"
  },
  {
    "name": "BREEZE Incident Analyst: Results Analysis - Plume Dispersion",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/3d-analyst/breeze-incident-analyst-results-analysis---plume-dispersion",
    "url": "/software/air-dispersion---data/3d-analyst/breeze-incident-analyst-results-analysis---plume-dispersion",
    "template": "general_content",
    "section": "breeze-incident-analyst:-results-analysis--plume-dispersion"
  },
  {
    "name": "Introduction to BREEZE ExDAM 9.0",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/introduction-to-breeze-exdam-9.0",
    "url": "/software/explosion/exdam/introduction-to-breeze-exdam-9.0",
    "template": "general_content",
    "section": "introduction-to-breeze-exdam-9.0"
  },
  {
    "name": "Building Structure Demonstration - Lakeshore Condo Scenario",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/building-structure-demonstration---lakeshore-condo-scenario",
    "url": "/software/explosion/exdam/building-structure-demonstration---lakeshore-condo-scenario",
    "template": "general_content",
    "section": "building-structure-demonstration--lakeshore-condo-scenario"
  },
  {
    "name": "Introduction to the Wind Rose, Data Rose, and Pollution Rose",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/metview/introduction-to-the-wind-rose-data-rose-and-pollution-rose",
    "url": "/software/air-dispersion---data-visualization/metview/introduction-to-the-wind-rose-data-rose-and-pollution-rose",
    "template": "general_content",
    "section": "introduction-to-the-wind-rose,-data-rose,-and-pollution-rose"
  },
  {
    "name": "Introduction to the Wind Rose, Data Rose, and Pollution Rose",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/metview/introduction-to-the-wind-rose-data-rose-and-pollution-rose",
    "url": "/software/air-dispersion-data-visualization/metview/introduction-to-the-wind-rose-data-rose-and-pollution-rose",
    "template": "general_content",
    "section": "introduction-to-the-wind-rose,-data-rose,-and-pollution-rose"
  },
  {
    "name": "Introduction to the Wind Rose, Data Rose, and Pollution Rose",
    "apiurl": "/restapi/customcontent/software/air-dispersion---data-visualization/metview/introduction-to-the-wind-rose-data-rose-and-pollution-rose",
    "url": "/software/air-dispersion---data/metview/introduction-to-the-wind-rose-data-rose-and-pollution-rose",
    "template": "general_content",
    "section": "introduction-to-the-wind-rose,-data-rose,-and-pollution-rose"
  },
  {
    "name": "BREEZE ExDAM Overview: Petroleum Plant Siting",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/breeze-exdam-overview-petroleum-plant-siting",
    "url": "/software/explosion/exdam/breeze-exdam-overview-petroleum-plant-siting",
    "template": "general_content",
    "section": "breeze-exdam-overview:-petroleum-plant-siting"
  },
  {
    "name": "Import Structures from Esri Shapefiles - ExDAM 3D Extend Module",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/import-structures-from-esri-shapefiles---exdam-3d-extend-module",
    "url": "/software/explosion/exdam/import-structures-from-esri-shapefiles---exdam-3d-extend-module",
    "template": "general_content",
    "section": "import-structures-from-esri-shapefiles--exdam-3d-extend-module"
  },
  {
    "name": "Create Detailed 3D Structures with XY Block Contour Function - ExDAM 3D Extend Module",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/create-detailed-3d-structures-with-xy-block-contour-function---exdam-3d-extend-module",
    "url": "/software/explosion/exdam/create-detailed-3d-structures-with-xy-block-contour-function---exdam-3d-extend-module",
    "template": "general_content",
    "section": "create-detailed-3d-structures-with-xy-block-contour-function--exdam-3d-extend-module"
  },
  {
    "name": "Introduction to BREEZE Incident Analyst 3.0",
    "apiurl": "/restapi/customcontent/software/hazard/incident-analyst/introduction-to-breeze-incident-analyst-3.0",
    "url": "/software/hazard/incident-analyst/introduction-to-breeze-incident-analyst-3.0",
    "template": "general_content",
    "section": "introduction-to-breeze-incident-analyst-3.0"
  },
  {
    "name": "Overview",
    "apiurl": "/restapi/customcontent/software/health-risk/risk-analyst/overview",
    "url": "/software/health-risk/risk-analyst/overview",
    "template": "general_content",
    "section": "overview"
  },
  {
    "name": "Phase II and III - Grid, Model Run, and Results Analysis",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/phase-ii-and-iii---grid-model-run-and-results-analysis",
    "url": "/software/explosion/exdam/phase-ii-and-iii---grid-model-run-and-results-analysis",
    "template": "general_content",
    "section": "phase-ii-and-iii--grid,-model-run,-and-results-analysis"
  },
  {
    "name": "Tutorial: Gridded Plume Downwash",
    "apiurl": "/restapi/customcontent/software/dispersion/aermod/tutorial-gridded-plume-downwash",
    "url": "/software/dispersion/aermod/tutorial-gridded-plume-downwash",
    "template": "general_content",
    "section": "tutorial:-gridded-plume-downwash"
  },
  {
    "name": "02: How to Select and Add Chemicals – BREEZE Incident Analyst",
    "apiurl": "/restapi/customcontent/software/hazard/incident-analyst/02-how-to-select-and-add-chemicals-breeze-incident-analyst",
    "url": "/software/hazard/incident-analyst/02-how-to-select-and-add-chemicals-breeze-incident-analyst",
    "template": "general_content",
    "section": "02:-how-to-select-and-add-chemicals-–-breeze-incident-analyst"
  },
  {
    "name": "03: Adding a Vapor Cloud and Sample Grid – BREEZE ExDAM",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/03-adding-a-vapor-cloud-and-sample-grid-breeze-exdam",
    "url": "/software/explosion/exdam/03-adding-a-vapor-cloud-and-sample-grid-breeze-exdam",
    "template": "general_content",
    "section": "03:-adding-a-vapor-cloud-and-sample-grid-–-breeze-exdam"
  },
  {
    "name": "Building Structure Demonstration - City Scenario",
    "apiurl": "/restapi/customcontent/software/explosion/exdam/building-structure-demonstration---city-scenario",
    "url": "/software/explosion/exdam/building-structure-demonstration---city-scenario",
    "template": "general_content",
    "section": "building-structure-demonstration--city-scenario"
  },
  {
    "name": "Focus Areas",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/focus-area",
    "url": "/staffinges/focus-area",
    "template": "new-staffing-common",
    "section": "staffing"
  },
  {
    "name": "Focus Areas",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/focus-area",
    "url": "/staffing/focus-area",
    "template": "new-staffing-common",
    "section": "staffing"
  },
  {
    "name": "Focus Areas",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/focus-area",
    "url": "/staffings/focus-area",
    "template": "new-staffing-common",
    "section": "staffing"
  },
  {
    "name": "Focus Areas",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/focus-area",
    "url": "/staffing/focus-areas",
    "template": "new-staffing-common",
    "section": "staffing"
  },
  {
    "name": "Focus Areas",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/focus-area",
    "url": "/staffinges/focus-area",
    "template": "stafﬁng-category",
    "section": "staffing"
  },
  {
    "name": "Focus Areas",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/focus-area",
    "url": "/staffing/focus-area",
    "template": "stafﬁng-category",
    "section": "staffing"
  },
  {
    "name": "Focus Areas",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/focus-area",
    "url": "/staffings/focus-area",
    "template": "stafﬁng-category",
    "section": "staffing"
  },
  {
    "name": "Focus Areas",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/focus-area",
    "url": "/staffing/focus-areas",
    "template": "stafﬁng-category",
    "section": "staffing"
  },
  {
    "name": "Search Options",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/search-options",
    "url": "/staffinges/search-options",
    "template": "new-staffing-common",
    "section": "staffing"
  },
  {
    "name": "Search Options",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/search-options",
    "url": "/staffings/search-options",
    "template": "new-staffing-common",
    "section": "staffing"
  },
  {
    "name": "Search Options",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/search-options",
    "url": "/staffing/options",
    "template": "new-staffing-common",
    "section": "staffing"
  },
  {
    "name": "Search Options",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/search-options",
    "url": "/ehs-recruiters/options",
    "template": "new-staffing-common",
    "section": "staffing"
  },
  {
    "name": "Search Options",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/search-options",
    "url": "/staffing/search-options",
    "template": "new-staffing-common",
    "section": "staffing"
  },
  {
    "name": "Search Options",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/search-options",
    "url": "/staffinges/search-options",
    "template": "stafﬁng-category",
    "section": "staffing"
  },
  {
    "name": "Search Options",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/search-options",
    "url": "/staffings/search-options",
    "template": "stafﬁng-category",
    "section": "staffing"
  },
  {
    "name": "Search Options",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/search-options",
    "url": "/staffing/options",
    "template": "stafﬁng-category",
    "section": "staffing"
  },
  {
    "name": "Search Options",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/search-options",
    "url": "/ehs-recruiters/options",
    "template": "stafﬁng-category",
    "section": "staffing"
  },
  {
    "name": "Search Options",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/search-options",
    "url": "/staffing/search-options",
    "template": "stafﬁng-category",
    "section": "staffing"
  },
  {
    "name": "Job Alert Sign Up",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/job-alert-sign-up",
    "url": "/staffinges/job-alert-sign-up",
    "template": "new-staffing-job-alert-sign-up",
    "section": "staffing"
  },
  {
    "name": "Job Alert Sign Up",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/job-alert-sign-up",
    "url": "/staffing/job-alert-sign-up",
    "template": "new-staffing-job-alert-sign-up",
    "section": "staffing"
  },
  {
    "name": "Job Alert Sign Up",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/job-alert-sign-up",
    "url": "/staffings/job-alert-sign-up",
    "template": "new-staffing-job-alert-sign-up",
    "section": "staffing"
  },
  {
    "name": "Job Alert Sign Up",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/job-alert-sign-up",
    "url": "/ehs-recruiters/job-alert-sign-up",
    "template": "new-staffing-job-alert-sign-up",
    "section": "staffing"
  },
  {
    "name": "Job Alert Sign Up",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/job-alert-sign-up",
    "url": "/staffinges/job-alert-sign-up",
    "template": "stafﬁng-category",
    "section": "staffing"
  },
  {
    "name": "Job Alert Sign Up",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/job-alert-sign-up",
    "url": "/staffing/job-alert-sign-up",
    "template": "stafﬁng-category",
    "section": "staffing"
  },
  {
    "name": "Job Alert Sign Up",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/job-alert-sign-up",
    "url": "/staffings/job-alert-sign-up",
    "template": "stafﬁng-category",
    "section": "staffing"
  },
  {
    "name": "Job Alert Sign Up",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/job-alert-sign-up",
    "url": "/ehs-recruiters/job-alert-sign-up",
    "template": "stafﬁng-category",
    "section": "staffing"
  },
  {
    "name": "Search Benefits",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/search-benefits",
    "url": "/staffinges/search-benefits",
    "template": "new-staffing-common",
    "section": "staffing"
  },
  {
    "name": "Search Benefits",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/search-benefits",
    "url": "/staffings/search-benefits",
    "template": "new-staffing-common",
    "section": "staffing"
  },
  {
    "name": "Search Benefits",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/search-benefits",
    "url": "/staffing/search-benefits",
    "template": "new-staffing-common",
    "section": "staffing"
  },
  {
    "name": "Search Benefits",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/search-benefits",
    "url": "/staffinges/search-benefits",
    "template": "stafﬁng-category",
    "section": "staffing"
  },
  {
    "name": "Search Benefits",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/search-benefits",
    "url": "/staffings/search-benefits",
    "template": "stafﬁng-category",
    "section": "staffing"
  },
  {
    "name": "Search Benefits",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/search-benefits",
    "url": "/staffing/search-benefits",
    "template": "stafﬁng-category",
    "section": "staffing"
  },
  {
    "name": "Submit a Job Request",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/submit-job-request",
    "url": "/staffinges/submit-job-request",
    "template": "new-staffing-submit-a-job-request",
    "section": "staffing"
  },
  {
    "name": "Submit a Job Request",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/submit-job-request",
    "url": "/ehs-recruiters/submit-job-request",
    "template": "new-staffing-submit-a-job-request",
    "section": "staffing"
  },
  {
    "name": "Submit a Job Request",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/submit-job-request",
    "url": "/ehs-recruiters/submit-a-job-request",
    "template": "new-staffing-submit-a-job-request",
    "section": "staffing"
  },
  {
    "name": "Submit a Job Request",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/submit-job-request",
    "url": "/staffings/submit-job-request",
    "template": "new-staffing-submit-a-job-request",
    "section": "staffing"
  },
  {
    "name": "Submit a Job Request",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/submit-job-request",
    "url": "/staffing/submit-job-request",
    "template": "new-staffing-submit-a-job-request",
    "section": "staffing"
  },
  {
    "name": "Submit a Job Request",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/submit-job-request",
    "url": "/staffinges/submit-job-request",
    "template": "stafﬁng-category",
    "section": "staffing"
  },
  {
    "name": "Submit a Job Request",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/submit-job-request",
    "url": "/ehs-recruiters/submit-job-request",
    "template": "stafﬁng-category",
    "section": "staffing"
  },
  {
    "name": "Submit a Job Request",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/submit-job-request",
    "url": "/ehs-recruiters/submit-a-job-request",
    "template": "stafﬁng-category",
    "section": "staffing"
  },
  {
    "name": "Submit a Job Request",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/submit-job-request",
    "url": "/staffings/submit-job-request",
    "template": "stafﬁng-category",
    "section": "staffing"
  },
  {
    "name": "Submit a Job Request",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/submit-job-request",
    "url": "/staffing/submit-job-request",
    "template": "stafﬁng-category",
    "section": "staffing"
  },
  {
    "name": "Available Positions",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/available-positions",
    "url": "/staffinges/available-positions",
    "template": "new-staffing-available-positions",
    "section": "staffing"
  },
  {
    "name": "Available Positions",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/available-positions",
    "url": "/ehs-recruiters/available-positions",
    "template": "new-staffing-available-positions",
    "section": "staffing"
  },
  {
    "name": "Available Positions",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/available-positions",
    "url": "/staffing/available-positions",
    "template": "new-staffing-available-positions",
    "section": "staffing"
  },
  {
    "name": "Available Positions",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/available-positions",
    "url": "/staffings/available-positions",
    "template": "new-staffing-available-positions",
    "section": "staffing"
  },
  {
    "name": "Available Positions",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/available-positions",
    "url": "/staffinges/available-positions",
    "template": "stafﬁng-category",
    "section": "staffing"
  },
  {
    "name": "Available Positions",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/available-positions",
    "url": "/ehs-recruiters/available-positions",
    "template": "stafﬁng-category",
    "section": "staffing"
  },
  {
    "name": "Available Positions",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/available-positions",
    "url": "/staffing/available-positions",
    "template": "stafﬁng-category",
    "section": "staffing"
  },
  {
    "name": "Available Positions",
    "apiurl": "/restapi/customstaffinglvl2content/staffinges/available-positions",
    "url": "/staffings/available-positions",
    "template": "stafﬁng-category",
    "section": "staffing"
  },
  {
    "name": "About Us",
    "apiurl": "/restapi/customaboutuscontent/about-us",
    "url": "/about-us",
    "template": "new-about-us",
    "section": "about-us"
  },
  {
    "name": "About Us",
    "apiurl": "/restapi/customaboutuscontent/about-us",
    "url": "/about-us1",
    "template": "new-about-us",
    "section": "about-us"
  },
  {
    "name": "About Us",
    "apiurl": "/restapi/customaboutuscontent/about-us",
    "url": "/about",
    "template": "new-about-us",
    "section": "about-us"
  },
  {
    "name": "About Us",
    "apiurl": "/restapi/customaboutuscontent/about-us",
    "url": "/additional-links/about-us",
    "template": "new-about-us",
    "section": "about-us"
  },
  {
    "name": "Webinar",
    "apiurl": "/restapi/customcontent/webinar-signup",
    "url": "/webinar-signup",
    "template": "general_content",
    "section": "webinar"
  },
  {
    "name": "Webinar",
    "apiurl": "/restapi/customcontent/webinar-signup",
    "url": "/webinar",
    "template": "general_content",
    "section": "webinar"
  },
  {
    "name": "Submit Resume",
    "apiurl": "/restapi/customcontent/apply-online-form",
    "url": "/apply-online-form",
    "template": "general_content",
    "section": "submit-resume"
  },
  {
    "name": "Submit Resume",
    "apiurl": "/restapi/customcontent/apply-online-form",
    "url": "/staffing-resume",
    "template": "general_content",
    "section": "submit-resume"
  },
  {
    "name": "Submit Resume",
    "apiurl": "/restapi/customcontent/apply-online-form",
    "url": "/apply-online",
    "template": "general_content",
    "section": "submit-resume"
  },
  {
    "name": "Submit Resume",
    "apiurl": "/restapi/customcontent/apply-online-form",
    "url": "/submit-resume",
    "template": "general_content",
    "section": "submit-resume"
  },
  {
    "name": "Publications",
    "apiurl": "/restapi/customehspublication/publications",
    "url": "/publications",
    "template": "new-trinity-ehs-publication",
    "section": "publications"
  },
  {
    "name": "Publications",
    "apiurl": "/restapi/customehspublication/publications",
    "url": "/resources/publications",
    "template": "new-trinity-ehs-publication",
    "section": "publications"
  },
  {
    "name": "EQ Winter 2020",
    "apiurl": "/restapi/customcontent/publications/eq-winter-2020",
    "url": "/publications/eq-winter-2020",
    "template": "general_content",
    "section": "eq-winter-2020"
  },
  {
    "name": "Issue 4 Apr 2021",
    "apiurl": "/restapi/customcontent/publications/issue-4-apr-2021",
    "url": "/publications/issue-4-apr-2021",
    "template": "general_content",
    "section": "issue-4-apr-2021"
  },
  {
    "name": "Resources",
    "apiurl": "/restapi/customresourcescontent/resources",
    "url": "/resources",
    "template": "new-trinity-resource",
    "section": "resources"
  },
  {
    "name": "Software Support Request",
    "apiurl": "/restapi/customcontent/software-support-request",
    "url": "/software-support-request",
    "template": "general_content",
    "section": "software-support-request"
  },
  {
    "name": "Add Attendees",
    "apiurl": "/restapi/customcontent/shopping-cart/attendees",
    "url": "/shopping-cart/attendees",
    "template": "attendees",
    "section": "review-shopping-cart"
  },
  {
    "name": "Contact Us",
    "apiurl": "/restapi/customcontent/contactus",
    "url": "/contactus",
    "template": "general_content",
    "section": "contact-us"
  },
  {
    "name": "Contact Us",
    "apiurl": "/restapi/customcontent/contactus",
    "url": "/additional-links/contact-us",
    "template": "general_content",
    "section": "contact-us"
  },
  {
    "name": "Commercial/Institutional",
    "apiurl": "/restapi/customindustrylvl2content/industries/commercial-institutional",
    "url": "/industries/commercial-institutional",
    "template": "new-industry-landing-secondary",
    "section": "commercialinstitutional"
  },
  {
    "name": "Commercial/Institutional",
    "apiurl": "/restapi/customindustrylvl2content/industries/commercial-institutional",
    "url": "/test/commercial-institutional",
    "template": "new-industry-landing-secondary",
    "section": "commercialinstitutional"
  },
  {
    "name": "Life Sciences",
    "apiurl": "/restapi/customindustrylvl2content/industries/life-sciences",
    "url": "/industries/life-sciences",
    "template": "new-industry-landing-secondary",
    "section": "life-sciences"
  },
  {
    "name": "Life Sciences",
    "apiurl": "/restapi/customindustrylvl2content/industries/life-sciences",
    "url": "/test/life-sciences",
    "template": "new-industry-landing-secondary",
    "section": "life-sciences"
  },
  {
    "name": "Energy",
    "apiurl": "/restapi/customindustrylvl2content/industries/energy",
    "url": "/industries/energy",
    "template": "new-industry-landing-secondary",
    "section": "energy"
  },
  {
    "name": "Energy",
    "apiurl": "/restapi/customindustrylvl2content/industries/energy",
    "url": "/test/energy",
    "template": "new-industry-landing-secondary",
    "section": "energy"
  },
  {
    "name": "Manufacturing - Industrial - Mining",
    "apiurl": "/restapi/customindustrylvl2content/industries/manufacturing-industrial-mining",
    "url": "/industries/manufacturing-industrial-mining",
    "template": "new-industry-landing-secondary",
    "section": "manufacturing--industrial--mining"
  },
  {
    "name": "EPA Acid Rain Information",
    "apiurl": "/restapi/customcontent/contact-us/epa-acid-rain-information",
    "url": "/contact-us/epa-acid-rain-information",
    "template": "general_content",
    "section": "epa-acid-rain-information"
  },
  {
    "name": "New York State Department of Environmental Conservation",
    "apiurl": "/restapi/customcontent/contact-us/new-york-state-department-of-environmental-conservation",
    "url": "/contact-us/new-york-state-department-of-environmental-conservation",
    "template": "general_content",
    "section": "new-york-state-department-of-environmental-conservation"
  },
  {
    "name": "Arizona Department of Environmental Quality",
    "apiurl": "/restapi/customcontent/contact-us/arizona-department-of-environmental-quality",
    "url": "/contact-us/arizona-department-of-environmental-quality",
    "template": "general_content",
    "section": "arizona-department-of-environmental-quality"
  },
  {
    "name": "NYC Department of Environmental Protection",
    "apiurl": "/restapi/customcontent/contact-us/nyc-department-of-environmental-protection",
    "url": "/contact-us/nyc-department-of-environmental-protection",
    "template": "general_content",
    "section": "nyc-department-of-environmental-protection"
  },
  {
    "name": "Olympic Region Clean Air Agency",
    "apiurl": "/restapi/customcontent/contact-us/olympic-region-clean-air-agency",
    "url": "/contact-us/olympic-region-clean-air-agency",
    "template": "general_content",
    "section": "olympic-region-clean-air-agency"
  },
  {
    "name": "Spokane Regional Clean Air Agency",
    "apiurl": "/restapi/customcontent/contact-us/spokane-regional-clean-air-agency",
    "url": "/contact-us/spokane-regional-clean-air-agency",
    "template": "general_content",
    "section": "spokane-regional-clean-air-agency"
  },
  {
    "name": "Pennsylvania Department of Environmental Protection",
    "apiurl": "/restapi/customcontent/contact-us/pennsylvania-department-of-environmental-protection",
    "url": "/contact-us/pennsylvania-department-of-environmental-protection",
    "template": "general_content",
    "section": "pennsylvania-department-of-environmental-protection"
  },
  {
    "name": "Manufacture Alabama",
    "apiurl": "/restapi/customcontent/contact-us/manufacture-alabama",
    "url": "/contact-us/manufacture-alabama",
    "template": "general_content",
    "section": "manufacture-alabama"
  },
  {
    "name": "Polk County",
    "apiurl": "/restapi/customcontent/contact-us/polk-county",
    "url": "/contact-us/polk-county",
    "template": "general_content",
    "section": "polk-county"
  },
  {
    "name": "LRAPA",
    "apiurl": "/restapi/customcontent/contact-us/lrapa",
    "url": "/contact-us/lrapa",
    "template": "general_content",
    "section": "lrapa"
  },
  {
    "name": "Idaho Department of Environmental Quality",
    "apiurl": "/restapi/customcontent/contact-us/idaho-department-of-environmental-quality",
    "url": "/contact-us/idaho-department-of-environmental-quality",
    "template": "general_content",
    "section": "idaho-department-of-environmental-quality"
  },
  {
    "name": "Kansas Department of Health and Environment",
    "apiurl": "/restapi/customcontent/contact-us/kansas-department-of-health-and-environment",
    "url": "/contact-us/kansas-department-of-health-and-environment",
    "template": "general_content",
    "section": "kansas-department-of-health-and-environment"
  },
  {
    "name": "Maryland Department of the Environment",
    "apiurl": "/restapi/customcontent/contact-us/maryland-department-of-the-environment",
    "url": "/contact-us/maryland-department-of-the-environment",
    "template": "general_content",
    "section": "maryland-department-of-the-environment"
  },
  {
    "name": "http://www.yakimacleanair.org/",
    "apiurl": "/restapi/customcontent/contact-us/http-www.yakimacleanair.org",
    "url": "/contact-us/http-www.yakimacleanair.org",
    "template": "general_content",
    "section": "http:www.yakimacleanair.org"
  },
  {
    "name": "Department of Energy and Environment",
    "apiurl": "/restapi/customcontent/contact-us/department-of-energy-and-environment",
    "url": "/contact-us/department-of-energy-and-environment",
    "template": "general_content",
    "section": "department-of-energy-and-environment"
  },
  {
    "name": "Massachusetts Department of Environmental Protection",
    "apiurl": "/restapi/customcontent/contact-us/massachusetts-department-of-environmental-protection",
    "url": "/contact-us/massachusetts-department-of-environmental-protection",
    "template": "general_content",
    "section": "massachusetts-department-of-environmental-protection"
  },
  {
    "name": "Allegheny County Health Department",
    "apiurl": "/restapi/customcontent/contact-us/allegheny-county-health-department",
    "url": "/contact-us/allegheny-county-health-department",
    "template": "general_content",
    "section": "allegheny-county-health-department"
  },
  {
    "name": "Chemical and Pollution Control",
    "apiurl": "/restapi/customcontent/contact-us/chemical-and-pollution-control",
    "url": "/contact-us/chemical-and-pollution-control",
    "template": "general_content",
    "section": "chemical-and-pollution-control"
  },
  {
    "name": "EPA 2003 Hazardous Waste Report Form and Instructions",
    "apiurl": "/restapi/customcontent/contact-us/epa-2003-hazardous-waste-report-form-and-instructions",
    "url": "/contact-us/epa-2003-hazardous-waste-report-form-and-instructions",
    "template": "general_content",
    "section": "epa-2003-hazardous-waste-report-form-and-instructions"
  },
  {
    "name": "City of Albuquerque/Bernalillo County Environmental Health Department",
    "apiurl": "/restapi/customcontent/contact-us/city-of-albuquerque-bernalillo-county-environmental-health-department",
    "url": "/contact-us/city-of-albuquerque-bernalillo-county-environmental-health-department",
    "template": "general_content",
    "section": "city-of-albuquerquebernalillo-county-environmental-health-department"
  },
  {
    "name": "EPA Region 7",
    "apiurl": "/restapi/customcontent/contact-us/epa-region-7",
    "url": "/contact-us/epa-region-7",
    "template": "general_content",
    "section": "epa-region-7"
  },
  {
    "name": "Oregon Department of Environmental Quality",
    "apiurl": "/restapi/customcontent/contact-us/oregon-department-of-environmental-quality",
    "url": "/contact-us/oregon-department-of-environmental-quality",
    "template": "general_content",
    "section": "oregon-department-of-environmental-quality"
  },
  {
    "name": "Environmental Federation of Oklahoma",
    "apiurl": "/restapi/customcontent/contact-us/environmental-federation-of-oklahoma",
    "url": "/contact-us/environmental-federation-of-oklahoma",
    "template": "general_content",
    "section": "environmental-federation-of-oklahoma"
  },
  {
    "name": "Ohio Environmental Protection Agency",
    "apiurl": "/restapi/customcontent/contact-us/ohio-environmental-protection-agency",
    "url": "/contact-us/ohio-environmental-protection-agency",
    "template": "general_content",
    "section": "ohio-environmental-protection-agency"
  },
  {
    "name": "Tennessee Department of Environment & Conservation (TDEC)",
    "apiurl": "/restapi/customcontent/contact-us/tennessee-department-of-environment-conservation-(tdec)",
    "url": "/contact-us/tennessee-department-of-environment-conservation-(tdec)",
    "template": "general_content",
    "section": "tennessee-department-of-environment-conservation-(tdec)"
  },
  {
    "name": "California Air Resources Board",
    "apiurl": "/restapi/customcontent/contact-us/california-air-resources-board",
    "url": "/contact-us/california-air-resources-board",
    "template": "general_content",
    "section": "california-air-resources-board"
  },
  {
    "name": "Colorado Department of Public Health & Environment",
    "apiurl": "/restapi/customcontent/contact-us/colorado-department-of-public-health-environment",
    "url": "/contact-us/colorado-department-of-public-health-environment",
    "template": "general_content",
    "section": "colorado-department-of-public-health-environment"
  },
  {
    "name": "California Air Resources Board (Current Rules List)",
    "apiurl": "/restapi/customcontent/contact-us/california-air-resources-board-(current-rules-list)",
    "url": "/contact-us/california-air-resources-board-(current-rules-list)",
    "template": "general_content",
    "section": "california-air-resources-board-(current-rules-list)"
  },
  {
    "name": "Board of Professional Engineers of Queensland (BPEQ)",
    "apiurl": "/restapi/customcontent/contact-us/board-of-professional-engineers-of-queensland-(bpeq)",
    "url": "/contact-us/board-of-professional-engineers-of-queensland-(bpeq)",
    "template": "general_content",
    "section": "board-of-professional-engineers-of-queensland-(bpeq)"
  },
  {
    "name": "EPA Region 1",
    "apiurl": "/restapi/customcontent/contact-us/epa-region-1",
    "url": "/contact-us/epa-region-1",
    "template": "general_content",
    "section": "epa-region-1"
  },
  {
    "name": "Queensland Legislation",
    "apiurl": "/restapi/customcontent/contact-us/queensland-legislation",
    "url": "/contact-us/queensland-legislation",
    "template": "general_content",
    "section": "queensland-legislation"
  },
  {
    "name": "Indiana Department of Environmental Management",
    "apiurl": "/restapi/customcontent/contact-us/indiana-department-of-environmental-management",
    "url": "/contact-us/indiana-department-of-environmental-management",
    "template": "general_content",
    "section": "indiana-department-of-environmental-management"
  },
  {
    "name": "EPA Air Toxics Website",
    "apiurl": "/restapi/customcontent/contact-us/epa-air-toxics-website",
    "url": "/contact-us/epa-air-toxics-website",
    "template": "general_content",
    "section": "epa-air-toxics-website"
  },
  {
    "name": "Wisconsin Department of Natural Resources",
    "apiurl": "/restapi/customcontent/contact-us/wisconsin-department-of-natural-resources",
    "url": "/contact-us/wisconsin-department-of-natural-resources",
    "template": "general_content",
    "section": "wisconsin-department-of-natural-resources"
  },
  {
    "name": "New Mexico Environment Department",
    "apiurl": "/restapi/customcontent/contact-us/new-mexico-environment-department",
    "url": "/contact-us/new-mexico-environment-department",
    "template": "general_content",
    "section": "new-mexico-environment-department"
  },
  {
    "name": "Southwest Clean Air Agency",
    "apiurl": "/restapi/customcontent/contact-us/southwest-clean-air-agency",
    "url": "/contact-us/southwest-clean-air-agency",
    "template": "general_content",
    "section": "southwest-clean-air-agency"
  },
  {
    "name": "Quick Link 1",
    "apiurl": "/restapi/customcontent/contact-us/quick-link-1",
    "url": "/contact-us/quick-link-1",
    "template": "general_content",
    "section": "quick-link-1"
  },
  {
    "name": "Air & Waste Management Association - Alabama Chapter",
    "apiurl": "/restapi/customcontent/contact-us/air-waste-management-association---alabama-chapter",
    "url": "/contact-us/air-waste-management-association---alabama-chapter",
    "template": "general_content",
    "section": "air-waste-management-association--alabama-chapter"
  },
  {
    "name": "Provenance Consulting, a Trinity Consultants Co.",
    "apiurl": "/restapi/customcontent/contact-us/provenance-consulting-a-trinity-consultants-co",
    "url": "/contact-us/provenance-consulting-a-trinity-consultants-co",
    "template": "general_content",
    "section": "provenance-consulting,-a-trinity-consultants-co."
  },
  {
    "name": "Georgia Department of Natural Resources",
    "apiurl": "/restapi/customcontent/contact-us/georgia-department-of-natural-resources",
    "url": "/contact-us/georgia-department-of-natural-resources",
    "template": "general_content",
    "section": "georgia-department-of-natural-resources"
  },
  {
    "name": "EPA Region 9",
    "apiurl": "/restapi/customcontent/contact-us/epa-region-9",
    "url": "/contact-us/epa-region-9",
    "template": "general_content",
    "section": "epa-region-9"
  },
  {
    "name": "Environment and Climate Change Canada NPRI",
    "apiurl": "/restapi/customcontent/contact-us/environment-and-climate-change-canada-npri",
    "url": "/contact-us/environment-and-climate-change-canada-npri",
    "template": "general_content",
    "section": "environment-and-climate-change-canada-npri"
  },
  {
    "name": "EPA Region 3",
    "apiurl": "/restapi/customcontent/contact-us/epa-region-3",
    "url": "/contact-us/epa-region-3",
    "template": "general_content",
    "section": "epa-region-3"
  },
  {
    "name": "Northwest Clean Air Agency",
    "apiurl": "/restapi/customcontent/contact-us/northwest-clean-air-agency",
    "url": "/contact-us/northwest-clean-air-agency",
    "template": "general_content",
    "section": "northwest-clean-air-agency"
  },
  {
    "name": "Air & Waste Management Association - Georgia Chapter",
    "apiurl": "/restapi/customcontent/contact-us/air-waste-management-association---georgia-chapter",
    "url": "/contact-us/air-waste-management-association---georgia-chapter",
    "template": "general_content",
    "section": "air-waste-management-association--georgia-chapter"
  },
  {
    "name": "Wyoming Oil and Gas Conservation Commission",
    "apiurl": "/restapi/customcontent/contact-us/wyoming-oil-and-gas-conservation-commission",
    "url": "/contact-us/wyoming-oil-and-gas-conservation-commission",
    "template": "general_content",
    "section": "wyoming-oil-and-gas-conservation-commission"
  },
  {
    "name": "EPA Oil Spill Program Homepage",
    "apiurl": "/restapi/customcontent/contact-us/epa-oil-spill-program-homepage",
    "url": "/contact-us/epa-oil-spill-program-homepage",
    "template": "general_content",
    "section": "epa-oil-spill-program-homepage"
  },
  {
    "name": "Australian Acoustical Society (AAS)",
    "apiurl": "/restapi/customcontent/contact-us/australian-acoustical-society-(aas)",
    "url": "/contact-us/australian-acoustical-society-(aas)",
    "template": "general_content",
    "section": "australian-acoustical-society-(aas)"
  },
  {
    "name": "EPA Region 10",
    "apiurl": "/restapi/customcontent/contact-us/epa-region-10",
    "url": "/contact-us/epa-region-10",
    "template": "general_content",
    "section": "epa-region-10"
  },
  {
    "name": "El Dorado County Air Quality Management District",
    "apiurl": "/restapi/customcontent/contact-us/el-dorado-county-air-quality-management-district",
    "url": "/contact-us/el-dorado-county-air-quality-management-district",
    "template": "general_content",
    "section": "el-dorado-county-air-quality-management-district"
  },
  {
    "name": "Emission Factors",
    "apiurl": "/restapi/customcontent/contact-us/emission-factors",
    "url": "/contact-us/emission-factors",
    "template": "general_content",
    "section": "emission-factors"
  },
  {
    "name": "Iowa Department of Natural Resources",
    "apiurl": "/restapi/customcontent/contact-us/iowa-department-of-natural-resources",
    "url": "/contact-us/iowa-department-of-natural-resources",
    "template": "general_content",
    "section": "iowa-department-of-natural-resources"
  },
  {
    "name": "Mississippi Department of Environmental Quality (MDEQ)",
    "apiurl": "/restapi/customcontent/contact-us/mississippi-department-of-environmental-quality-(mdeq)",
    "url": "/contact-us/mississippi-department-of-environmental-quality-(mdeq)",
    "template": "general_content",
    "section": "mississippi-department-of-environmental-quality-(mdeq)"
  },
  {
    "name": "EPA International Waste Activities",
    "apiurl": "/restapi/customcontent/contact-us/epa-international-waste-activities",
    "url": "/contact-us/epa-international-waste-activities",
    "template": "general_content",
    "section": "epa-international-waste-activities"
  },
  {
    "name": "Air & Waste Management Association – Oklahoma Chapter",
    "apiurl": "/restapi/customcontent/contact-us/air-waste-management-association-oklahoma-chapter",
    "url": "/contact-us/air-waste-management-association-oklahoma-chapter",
    "template": "general_content",
    "section": "air-waste-management-association-–-oklahoma-chapter"
  },
  {
    "name": "Utah Department of Environmental Quality",
    "apiurl": "/restapi/customcontent/contact-us/utah-department-of-environmental-quality",
    "url": "/contact-us/utah-department-of-environmental-quality",
    "template": "general_content",
    "section": "utah-department-of-environmental-quality"
  },
  {
    "name": "City of Huntsville Air Program",
    "apiurl": "/restapi/customcontent/contact-us/city-of-huntsville-air-program",
    "url": "/contact-us/city-of-huntsville-air-program",
    "template": "general_content",
    "section": "city-of-huntsville-air-program"
  },
  {
    "name": "Brisbane City Council Noise Complaints",
    "apiurl": "/restapi/customcontent/contact-us/brisbane-city-council-noise-complaints",
    "url": "/contact-us/brisbane-city-council-noise-complaints",
    "template": "general_content",
    "section": "brisbane-city-council-noise-complaints"
  },
  {
    "name": "Pinal County Air Quality Control District (PCAQCD)",
    "apiurl": "/restapi/customcontent/contact-us/pinal-county-air-quality-control-district-(pcaqcd)",
    "url": "/contact-us/pinal-county-air-quality-control-district-(pcaqcd)",
    "template": "general_content",
    "section": "pinal-county-air-quality-control-district-(pcaqcd)"
  },
  {
    "name": "Missouri Department of Natural Resources",
    "apiurl": "/restapi/customcontent/contact-us/missouri-department-of-natural-resources",
    "url": "/contact-us/missouri-department-of-natural-resources",
    "template": "general_content",
    "section": "missouri-department-of-natural-resources"
  },
  {
    "name": "Texas Commission on Environmental Quality",
    "apiurl": "/restapi/customcontent/contact-us/texas-commission-on-environmental-quality",
    "url": "/contact-us/texas-commission-on-environmental-quality",
    "template": "general_content",
    "section": "texas-commission-on-environmental-quality"
  },
  {
    "name": "Georgia Environmental Protection Division (EPD)",
    "apiurl": "/restapi/customcontent/contact-us/georgia-environmental-protection-division-(epd)",
    "url": "/contact-us/georgia-environmental-protection-division-(epd)",
    "template": "general_content",
    "section": "georgia-environmental-protection-division-(epd)"
  },
  {
    "name": "Florida Department of Environmental Protection",
    "apiurl": "/restapi/customcontent/contact-us/florida-department-of-environmental-protection",
    "url": "/contact-us/florida-department-of-environmental-protection",
    "template": "general_content",
    "section": "florida-department-of-environmental-protection"
  },
  {
    "name": "Ontario Toxic Reduction Act Reports",
    "apiurl": "/restapi/customcontent/contact-us/ontario-toxic-reduction-act-reports",
    "url": "/contact-us/ontario-toxic-reduction-act-reports",
    "template": "general_content",
    "section": "ontario-toxic-reduction-act-reports"
  },
  {
    "name": "IEPA",
    "apiurl": "/restapi/customcontent/contact-us/iepa",
    "url": "/contact-us/iepa",
    "template": "general_content",
    "section": "iepa"
  },
  {
    "name": "New Jersey Department of Environmental Protection",
    "apiurl": "/restapi/customcontent/contact-us/new-jersey-department-of-environmental-protection",
    "url": "/contact-us/new-jersey-department-of-environmental-protection",
    "template": "general_content",
    "section": "new-jersey-department-of-environmental-protection"
  },
  {
    "name": "Australian Government – Australia’s Guide to Environmentally Sustainable Homes / Noise Control",
    "apiurl": "/restapi/customcontent/contact-us/australian-government-australia-s-guide-to-environmentally-sustainable-homes-noise-control",
    "url": "/contact-us/australian-government-australia-s-guide-to-environmentally-sustainable-homes-noise-control",
    "template": "general_content",
    "section": "australian-government-–-australia’s-guide-to-environmentally-sustainable-homes--noise-control"
  },
  {
    "name": "Alabama Department of Environmental Management",
    "apiurl": "/restapi/customcontent/contact-us/alabama-department-of-environmental-management",
    "url": "/contact-us/alabama-department-of-environmental-management",
    "template": "general_content",
    "section": "alabama-department-of-environmental-management"
  },
  {
    "name": "Louisiana Department of Environmental Quality",
    "apiurl": "/restapi/customcontent/contact-us/louisiana-department-of-environmental-quality",
    "url": "/contact-us/louisiana-department-of-environmental-quality",
    "template": "general_content",
    "section": "louisiana-department-of-environmental-quality"
  },
  {
    "name": "EPA Acid Rain Program Annual Reconciliation Fact Sheet",
    "apiurl": "/restapi/customcontent/contact-us/epa-acid-rain-program-annual-reconciliation-fact-sheet",
    "url": "/contact-us/epa-acid-rain-program-annual-reconciliation-fact-sheet",
    "template": "general_content",
    "section": "epa-acid-rain-program-annual-reconciliation-fact-sheet"
  },
  {
    "name": "Acid Rain Program Forms",
    "apiurl": "/restapi/customcontent/contact-us/acid-rain-program-forms",
    "url": "/contact-us/acid-rain-program-forms",
    "template": "general_content",
    "section": "acid-rain-program-forms"
  },
  {
    "name": "EPA Region 6",
    "apiurl": "/restapi/customcontent/contact-us/epa-region-6",
    "url": "/contact-us/epa-region-6",
    "template": "general_content",
    "section": "epa-region-6"
  },
  {
    "name": "Maricopa County Air Quality Department",
    "apiurl": "/restapi/customcontent/contact-us/maricopa-county-air-quality-department",
    "url": "/contact-us/maricopa-county-air-quality-department",
    "template": "general_content",
    "section": "maricopa-county-air-quality-department"
  },
  {
    "name": "OSHA Combustible Dust National Emphasis Program",
    "apiurl": "/restapi/customcontent/contact-us/osha-combustible-dust-national-emphasis-program",
    "url": "/contact-us/osha-combustible-dust-national-emphasis-program",
    "template": "general_content",
    "section": "osha-combustible-dust-national-emphasis-program"
  },
  {
    "name": "Queensland Transport Noise Corridor (MP 4.4)",
    "apiurl": "/restapi/customcontent/contact-us/queensland-transport-noise-corridor-(mp-4.4)",
    "url": "/contact-us/queensland-transport-noise-corridor-(mp-4.4)",
    "template": "general_content",
    "section": "queensland-transport-noise-corridor-(mp-4.4)"
  },
  {
    "name": "Linn County",
    "apiurl": "/restapi/customcontent/contact-us/linn-county",
    "url": "/contact-us/linn-county",
    "template": "general_content",
    "section": "linn-county"
  },
  {
    "name": "Colusa County Air Pollution Control District",
    "apiurl": "/restapi/customcontent/contact-us/colusa-county-air-pollution-control-district",
    "url": "/contact-us/colusa-county-air-pollution-control-district",
    "template": "general_content",
    "section": "colusa-county-air-pollution-control-district"
  },
  {
    "name": "Kentucky Division for Air Quality",
    "apiurl": "/restapi/customcontent/contact-us/kentucky-division-for-air-quality",
    "url": "/contact-us/kentucky-division-for-air-quality",
    "template": "general_content",
    "section": "kentucky-division-for-air-quality"
  },
  {
    "name": "Air & Waste Management Association - East Tennessee Chapter",
    "apiurl": "/restapi/customcontent/contact-us/air-waste-management-association---east-tennessee-chapter",
    "url": "/contact-us/air-waste-management-association---east-tennessee-chapter",
    "template": "general_content",
    "section": "air-waste-management-association--east-tennessee-chapter"
  },
  {
    "name": "Quick Link 2",
    "apiurl": "/restapi/customcontent/contact-us/quick-link-2",
    "url": "/contact-us/quick-link-2",
    "template": "general_content",
    "section": "quick-link-2"
  },
  {
    "name": "Antelope Valley Air Quality Management District",
    "apiurl": "/restapi/customcontent/contact-us/antelope-valley-air-quality-management-district",
    "url": "/contact-us/antelope-valley-air-quality-management-district",
    "template": "general_content",
    "section": "antelope-valley-air-quality-management-district"
  },
  {
    "name": "EPA Air Toxics",
    "apiurl": "/restapi/customcontent/contact-us/epa-air-toxics",
    "url": "/contact-us/epa-air-toxics",
    "template": "general_content",
    "section": "epa-air-toxics"
  },
  {
    "name": "EPA Quarterly Emissions Submissions Methods/User Registration",
    "apiurl": "/restapi/customcontent/contact-us/epa-quarterly-emissions-submissions-methods-user-registration",
    "url": "/contact-us/epa-quarterly-emissions-submissions-methods-user-registration",
    "template": "general_content",
    "section": "epa-quarterly-emissions-submissions-methodsuser-registration"
  },
  {
    "name": "Minnesota Pollution Control Agency",
    "apiurl": "/restapi/customcontent/contact-us/minnesota-pollution-control-agency",
    "url": "/contact-us/minnesota-pollution-control-agency",
    "template": "general_content",
    "section": "minnesota-pollution-control-agency"
  },
  {
    "name": "Puget Sound Clean Air Agency",
    "apiurl": "/restapi/customcontent/contact-us/puget-sound-clean-air-agency",
    "url": "/contact-us/puget-sound-clean-air-agency",
    "template": "general_content",
    "section": "puget-sound-clean-air-agency"
  },
  {
    "name": "Oklahoma Department of Environmental Quality (ODEQ)",
    "apiurl": "/restapi/customcontent/contact-us/oklahoma-department-of-environmental-quality-(odeq)",
    "url": "/contact-us/oklahoma-department-of-environmental-quality-(odeq)",
    "template": "general_content",
    "section": "oklahoma-department-of-environmental-quality-(odeq)"
  },
  {
    "name": "Ontario Ministry of the Environment and Climate Change",
    "apiurl": "/restapi/customcontent/contact-us/ontario-ministry-of-the-environment-and-climate-change",
    "url": "/contact-us/ontario-ministry-of-the-environment-and-climate-change",
    "template": "general_content",
    "section": "ontario-ministry-of-the-environment-and-climate-change"
  },
  {
    "name": "Queensland Government Live Air Quality Data",
    "apiurl": "/restapi/customcontent/contact-us/queensland-government-live-air-quality-data",
    "url": "/contact-us/queensland-government-live-air-quality-data",
    "template": "general_content",
    "section": "queensland-government-live-air-quality-data"
  },
  {
    "name": "Benton Clean Air Agency",
    "apiurl": "/restapi/customcontent/contact-us/benton-clean-air-agency",
    "url": "/contact-us/benton-clean-air-agency",
    "template": "general_content",
    "section": "benton-clean-air-agency"
  },
  {
    "name": "EPA Region 4",
    "apiurl": "/restapi/customcontent/contact-us/epa-region-4",
    "url": "/contact-us/epa-region-4",
    "template": "general_content",
    "section": "epa-region-4"
  },
  {
    "name": "Philadelphia Department of Health - Air Management Services",
    "apiurl": "/restapi/customcontent/contact-us/philadelphia-department-of-health---air-management-services",
    "url": "/contact-us/philadelphia-department-of-health---air-management-services",
    "template": "general_content",
    "section": "philadelphia-department-of-health--air-management-services"
  },
  {
    "name": "Association of Australasian Acoustical Consultants (AAAC)",
    "apiurl": "/restapi/customcontent/contact-us/association-of-australasian-acoustical-consultants-(aaac)",
    "url": "/contact-us/association-of-australasian-acoustical-consultants-(aaac)",
    "template": "general_content",
    "section": "association-of-australasian-acoustical-consultants-(aaac)"
  },
  {
    "name": "Louisville Metro Air Pollution Control District",
    "apiurl": "/restapi/customcontent/contact-us/louisville-metro-air-pollution-control-district",
    "url": "/contact-us/louisville-metro-air-pollution-control-district",
    "template": "general_content",
    "section": "louisville-metro-air-pollution-control-district"
  },
  {
    "name": "Prima County Department of Environmental Quality",
    "apiurl": "/restapi/customcontent/contact-us/prima-county-department-of-environmental-quality",
    "url": "/contact-us/prima-county-department-of-environmental-quality",
    "template": "general_content",
    "section": "prima-county-department-of-environmental-quality"
  },
  {
    "name": "Wyoming Department of Environmental Quality",
    "apiurl": "/restapi/customcontent/contact-us/wyoming-department-of-environmental-quality",
    "url": "/contact-us/wyoming-department-of-environmental-quality",
    "template": "general_content",
    "section": "wyoming-department-of-environmental-quality"
  },
  {
    "name": "Clean Air Society of Australia and New Zealand (CASANZ)",
    "apiurl": "/restapi/customcontent/contact-us/clean-air-society-of-australia-and-new-zealand-(casanz)",
    "url": "/contact-us/clean-air-society-of-australia-and-new-zealand-(casanz)",
    "template": "general_content",
    "section": "clean-air-society-of-australia-and-new-zealand-(casanz)"
  },
  {
    "name": "North Carolina Department of Environment & Natural Resources",
    "apiurl": "/restapi/customcontent/contact-us/north-carolina-department-of-environment-natural-resources",
    "url": "/contact-us/north-carolina-department-of-environment-natural-resources",
    "template": "general_content",
    "section": "north-carolina-department-of-environment-natural-resources"
  },
  {
    "name": "EPA Region 2",
    "apiurl": "/restapi/customcontent/contact-us/epa-region-2",
    "url": "/contact-us/epa-region-2",
    "template": "general_content",
    "section": "epa-region-2"
  },
  {
    "name": "Feather River Air Quality Management District",
    "apiurl": "/restapi/customcontent/contact-us/feather-river-air-quality-management-district",
    "url": "/contact-us/feather-river-air-quality-management-district",
    "template": "general_content",
    "section": "feather-river-air-quality-management-district"
  },
  {
    "name": "Jefferson County Department of Public Health - Air Pollution Control",
    "apiurl": "/restapi/customcontent/contact-us/jefferson-county-department-of-public-health---air-pollution-control",
    "url": "/contact-us/jefferson-county-department-of-public-health---air-pollution-control",
    "template": "general_content",
    "section": "jefferson-county-department-of-public-health--air-pollution-control"
  },
  {
    "name": "EPA Region 5",
    "apiurl": "/restapi/customcontent/contact-us/epa-region-5",
    "url": "/contact-us/epa-region-5",
    "template": "general_content",
    "section": "epa-region-5"
  },
  {
    "name": "Bay Area Air Quality Management District",
    "apiurl": "/restapi/customcontent/contact-us/bay-area-air-quality-management-district",
    "url": "/contact-us/bay-area-air-quality-management-district",
    "template": "general_content",
    "section": "bay-area-air-quality-management-district"
  },
  {
    "name": "Michigan Department of Environmental Quality",
    "apiurl": "/restapi/customcontent/contact-us/michigan-department-of-environmental-quality",
    "url": "/contact-us/michigan-department-of-environmental-quality",
    "template": "general_content",
    "section": "michigan-department-of-environmental-quality"
  },
  {
    "name": "Washington Department of Ecology (Air Quality Program)",
    "apiurl": "/restapi/customcontent/contact-us/washington-department-of-ecology-(air-quality-program)",
    "url": "/contact-us/washington-department-of-ecology-(air-quality-program)",
    "template": "general_content",
    "section": "washington-department-of-ecology-(air-quality-program)"
  },
  {
    "name": "Virginia Department of Environmental Quality",
    "apiurl": "/restapi/customcontent/contact-us/virginia-department-of-environmental-quality",
    "url": "/contact-us/virginia-department-of-environmental-quality",
    "template": "general_content",
    "section": "virginia-department-of-environmental-quality"
  },
  {
    "name": "Yakima Clean Air Agency",
    "apiurl": "/restapi/customcontent/contact-us/yakima-clean-air-agency",
    "url": "/contact-us/yakima-clean-air-agency",
    "template": "general_content",
    "section": "yakima-clean-air-agency"
  },
  {
    "name": "Amador Air District",
    "apiurl": "/restapi/customcontent/contact-us/amador-air-district",
    "url": "/contact-us/amador-air-district",
    "template": "general_content",
    "section": "amador-air-district"
  },
  {
    "name": "EPA Region 8",
    "apiurl": "/restapi/customcontent/contact-us/epa-region-8",
    "url": "/contact-us/epa-region-8",
    "template": "general_content",
    "section": "epa-region-8"
  },
  {
    "name": "Brisbane City Council Air Quality Complaints",
    "apiurl": "/restapi/customcontent/contact-us/brisbane-city-council-air-quality-complaints",
    "url": "/contact-us/brisbane-city-council-air-quality-complaints",
    "template": "general_content",
    "section": "brisbane-city-council-air-quality-complaints"
  },
  {
    "name": "Butte County Air Quality Management District",
    "apiurl": "/restapi/customcontent/contact-us/butte-county-air-quality-management-district",
    "url": "/contact-us/butte-county-air-quality-management-district",
    "template": "general_content",
    "section": "butte-county-air-quality-management-district"
  },
  {
    "name": "Environment and Climate Change Canada Acts and Regulations",
    "apiurl": "/restapi/customcontent/contact-us/environment-and-climate-change-canada-acts-and-regulations",
    "url": "/contact-us/environment-and-climate-change-canada-acts-and-regulations",
    "template": "general_content",
    "section": "environment-and-climate-change-canada-acts-and-regulations"
  },
  {
    "name": "Report writing",
    "apiurl": "/restapi/customcontent/contact-us/report-writing",
    "url": "/contact-us/report-writing",
    "template": "general_content",
    "section": "report-writing"
  },
  {
    "name": "Essay writing",
    "apiurl": "/restapi/customcontent/contact-us/essay-writing",
    "url": "/contact-us/essay-writing",
    "template": "general_content",
    "section": "essay-writing"
  },
  {
    "name": "Fujian",
    "apiurl": "/restapi/customlocationcontentlvl3/location/china/china/fujian",
    "url": "/location/china/china/fujian",
    "template": "new-individual-locations",
    "section": "fujian"
  },
  {
    "name": "North Dakota",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/north-dakota",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/north-dakota",
    "template": "new-individual-locations",
    "section": "north-dakota"
  },
  {
    "name": "Oklahoma",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/oklahoma",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/oklahoma",
    "template": "new-individual-locations",
    "section": "oklahoma"
  },
  {
    "name": "Arkansas",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/arkansas",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/arkansas",
    "template": "new-individual-locations",
    "section": "arkansas"
  },
  {
    "name": "Louisiana Lake Charles",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/louisiana-lake-charles",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/louisiana-lake-charles",
    "template": "new-individual-locations",
    "section": "louisiana-lake-charles"
  },
  {
    "name": "California Bakersfield",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/california-bakersfield",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/california-bakersfield",
    "template": "new-individual-locations",
    "section": "california-bakersfield"
  },
  {
    "name": "Christchurch",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/australia/new-zealand/south-island/christchurch",
    "url": "/locations/australia/new-zealand/south-island/christchurch",
    "template": "new-individual-locations",
    "section": "south-island"
  },
  {
    "name": "Chicago",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/illinois/chicago",
    "url": "/locations/north-america/united-states/illinois/chicago",
    "template": "new-individual-locations",
    "section": "illinois"
  },
  {
    "name": "Arizona",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/arizona",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/arizona",
    "template": "new-individual-locations",
    "section": "arizona"
  },
  {
    "name": "Albany",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/new-york/albany",
    "url": "/locations/north-america/united-states/new-york/albany",
    "template": "new-individual-locations",
    "section": "new-york"
  },
  {
    "name": "Arkansas Little Rock",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/arkansas-little-rock",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/arkansas-little-rock",
    "template": "new-individual-locations",
    "section": "arkansas-little-rock"
  },
  {
    "name": "Louisiana",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/louisiana",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/louisiana",
    "template": "new-individual-locations",
    "section": "louisiana"
  },
  {
    "name": "British Columbia",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/british-columbia",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/british-columbia",
    "template": "new-individual-locations",
    "section": "british-columbia"
  },
  {
    "name": "Missouri",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/missouri",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/missouri",
    "template": "new-individual-locations",
    "section": "missouri"
  },
  {
    "name": "China",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/china",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/china",
    "template": "new-individual-locations",
    "section": "china"
  },
  {
    "name": "Hangzhou",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/asia/china/asia-pacific-state/asia-pacific-location",
    "url": "/locations/asia/china/asia-pacific-state/asia-pacific-location",
    "template": "new-individual-locations",
    "section": "asia-pacific-state"
  },
  {
    "name": "South Dakota",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/south-dakota",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/south-dakota",
    "template": "new-individual-locations",
    "section": "south-dakota"
  },
  {
    "name": "Lincoln",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/nebraska/lincoln",
    "url": "/locations/north-america/united-states/nebraska/lincoln",
    "template": "new-individual-locations",
    "section": "nebraska"
  },
  {
    "name": "British Columbia Victoria",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/british-columbia-victoria",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/british-columbia-victoria",
    "template": "new-individual-locations",
    "section": "british-columbia-victoria"
  },
  {
    "name": "Qatar",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/qatar",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/qatar",
    "template": "new-individual-locations",
    "section": "qatar"
  },
  {
    "name": "California Mountain View",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/california-mountain-view",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/california-mountain-view",
    "template": "new-individual-locations",
    "section": "california-mountain-view"
  },
  {
    "name": "Pittsburgh",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/pennsylvania/pittsburgh",
    "url": "/locations/north-america/united-states/pennsylvania/pittsburgh",
    "template": "new-individual-locations",
    "section": "pennsylvania"
  },
  {
    "name": "Wyoming Cheyenne",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/wyoming-cheyenne",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/wyoming-cheyenne",
    "template": "new-individual-locations",
    "section": "wyoming-cheyenne"
  },
  {
    "name": "Ohio Cleveland",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/ohio-cleveland",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/ohio-cleveland",
    "template": "new-individual-locations",
    "section": "ohio-cleveland"
  },
  {
    "name": "Pennsylvania Philadelphia",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/pennsylvania-philadelphia",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/pennsylvania-philadelphia",
    "template": "new-individual-locations",
    "section": "pennsylvania-philadelphia"
  },
  {
    "name": "Washington Seattle",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/washington-seattle",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/washington-seattle",
    "template": "new-individual-locations",
    "section": "washington-seattle"
  },
  {
    "name": "Minnesota Minneapolis",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/minnesota-minneapolis",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/minnesota-minneapolis",
    "template": "new-individual-locations",
    "section": "minnesota-minneapolis"
  },
  {
    "name": "Delaware",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/delaware",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/delaware",
    "template": "new-individual-locations",
    "section": "delaware"
  },
  {
    "name": "Oregon(1)",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/oregon(1)",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/oregon(1)",
    "template": "new-individual-locations",
    "section": "oregon(1)"
  },
  {
    "name": "Washington, DC",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/washington-dc",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/washington-dc",
    "template": "new-individual-locations",
    "section": "washington,-dc"
  },
  {
    "name": "Florida",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/florida",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/florida",
    "template": "new-individual-locations",
    "section": "florida"
  },
  {
    "name": "Covington",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/kentucky/covington",
    "url": "/locations/north-america/united-states/kentucky/covington",
    "template": "new-individual-locations",
    "section": "kentucky"
  },
  {
    "name": "London",
    "apiurl": "/restapi/customlocationcontentlvl3/location/united-kingdom/united-kingdom/london",
    "url": "/location/united-kingdom/united-kingdom/london",
    "template": "new-individual-locations",
    "section": "london"
  },
  {
    "name": "Guangzhou",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/asia/china/asia-pacific-state/guangzhou",
    "url": "/locations/asia/china/asia-pacific-state/guangzhou",
    "template": "new-individual-locations",
    "section": "asia-pacific-state"
  },
  {
    "name": "Ontario Toronto",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/ontario-toronto",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/ontario-toronto",
    "template": "new-individual-locations",
    "section": "ontario-toronto"
  },
  {
    "name": "Seattle",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/washington/seattle",
    "url": "/locations/north-america/united-states/washington/seattle",
    "template": "new-individual-locations",
    "section": "washington"
  },
  {
    "name": "Seattle",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/washington/seattle",
    "url": "/locations/seattle/",
    "template": "new-individual-locations",
    "section": "washington"
  },
  {
    "name": "Seattle",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/washington/seattle",
    "url": "/locations/washington/",
    "template": "new-individual-locations",
    "section": "washington"
  },
  {
    "name": "California Sacramento",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/california-sacramento",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/california-sacramento",
    "template": "new-individual-locations",
    "section": "california-sacramento"
  },
  {
    "name": "Guelph",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/canada/ontario/guelph",
    "url": "/locations/north-america/canada/ontario/guelph",
    "template": "new-individual-locations",
    "section": "ontario"
  },
  {
    "name": "Guelph",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/canada/ontario/guelph",
    "url": "/locations/north-america/canada/toronto/guelph",
    "template": "new-individual-locations",
    "section": "ontario"
  },
  {
    "name": "Charlotte",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/north-carolina/charlotte",
    "url": "/locations/north-america/united-states/north-carolina/charlotte",
    "template": "new-individual-locations",
    "section": "north-carolina"
  },
  {
    "name": "Kansas City",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/kansas-kansas-city",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/kansas-kansas-city",
    "template": "new-individual-locations",
    "section": "kansas-city"
  },
  {
    "name": "Dallas",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/texas/dallas",
    "url": "/locations/north-america/united-states/texas/dallas",
    "template": "new-individual-locations",
    "section": "texas"
  },
  {
    "name": "Washington D.C.",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/washington-d.c/washington-dc",
    "url": "/locations/north-america/united-states/washington-d.c/washington-dc",
    "template": "new-individual-locations",
    "section": "washington-d.c"
  },
  {
    "name": "Washington D.C.",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/washington-d.c/washington-dc",
    "url": "/locations/north-america/united-states/washington-dc/washington-dc",
    "template": "new-individual-locations",
    "section": "washington-d.c"
  },
  {
    "name": "Washington D.C.",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/washington-d.c/washington-dc",
    "url": "/locations/north-america/united-states/maryland/washington-dc",
    "template": "new-individual-locations",
    "section": "washington-d.c"
  },
  {
    "name": "Boise",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/idaho/boise",
    "url": "/locations/north-america/united-states/idaho/boise",
    "template": "new-individual-locations",
    "section": "idaho"
  },
  {
    "name": "Oakland",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/california/oakland",
    "url": "/locations/north-america/united-states/california/oakland",
    "template": "new-individual-locations",
    "section": "california"
  },
  {
    "name": "Phoenix",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/arizona/phoenix",
    "url": "/locations/north-america/united-states/arizona/phoenix",
    "template": "new-individual-locations",
    "section": "arizona"
  },
  {
    "name": "Phoenix",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/arizona/phoenix",
    "url": "/locations/arizona/phoenix/",
    "template": "new-individual-locations",
    "section": "arizona"
  },
  {
    "name": "Phoenix",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/arizona/phoenix",
    "url": "/locations/arizona/",
    "template": "new-individual-locations",
    "section": "arizona"
  },
  {
    "name": "Irvine",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/california/irvine",
    "url": "/locations/north-america/united-states/california/irvine",
    "template": "new-individual-locations",
    "section": "california"
  },
  {
    "name": "Irvine",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/california/irvine",
    "url": "/locations/washington",
    "template": "new-individual-locations",
    "section": "california"
  },
  {
    "name": "Saskatoon",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/canada/saskatchewan/saskatoon",
    "url": "/locations/north-america/canada/saskatchewan/saskatoon",
    "template": "new-individual-locations",
    "section": "saskatchewan"
  },
  {
    "name": "Florida Orlando",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/florida-orlando",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/florida-orlando",
    "template": "new-individual-locations",
    "section": "florida-orlando"
  },
  {
    "name": "Kansas",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/kansas",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/kansas",
    "template": "new-individual-locations",
    "section": "kansas"
  },
  {
    "name": "Salt Lake City",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/utah/salt-lake-city",
    "url": "/locations/north-america/united-states/utah/salt-lake-city",
    "template": "new-individual-locations",
    "section": "utah"
  },
  {
    "name": "Virginia Roanoke",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/virginia-roanoke",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/virginia-roanoke",
    "template": "new-individual-locations",
    "section": "virginia-roanoke"
  },
  {
    "name": "Borger",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/texas/borger",
    "url": "/locations/north-america/united-states/texas/borger",
    "template": "new-individual-locations",
    "section": "texas"
  },
  {
    "name": "Saskatchewan",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/saskatchewan",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/saskatchewan",
    "template": "new-individual-locations",
    "section": "saskatchewan"
  },
  {
    "name": "New Jersey",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/new-jersey",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/new-jersey",
    "template": "new-individual-locations",
    "section": "new-jersey"
  },
  {
    "name": "Indiana",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/indiana",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/indiana",
    "template": "new-individual-locations",
    "section": "indiana"
  },
  {
    "name": "New York",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/new-york",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/new-york",
    "template": "new-individual-locations",
    "section": "new-york"
  },
  {
    "name": "Arizona Phoenix",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/arizona-phoenix",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/arizona-phoenix",
    "template": "new-individual-locations",
    "section": "arizona-phoenix"
  },
  {
    "name": "Wisconsin",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/wisconsin",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/wisconsin",
    "template": "new-individual-locations",
    "section": "wisconsin"
  },
  {
    "name": "Charlottesville",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/virginia/charlottesville",
    "url": "/locations/north-america/united-states/virginia/charlottesville",
    "template": "new-individual-locations",
    "section": "virginia"
  },
  {
    "name": "Georgia Atlanta",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/georgia-atlanta",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/georgia-atlanta",
    "template": "new-individual-locations",
    "section": "georgia-atlanta"
  },
  {
    "name": "Princeton",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/new-jersey/princeton",
    "url": "/locations/north-america/united-states/new-jersey/princeton",
    "template": "new-individual-locations",
    "section": "new-jersey"
  },
  {
    "name": "Oregon Portland",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/oregon-portland",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/oregon-portland",
    "template": "new-individual-locations",
    "section": "oregon-portland"
  },
  {
    "name": "Mississippi",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/mississippi",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/mississippi",
    "template": "new-individual-locations",
    "section": "mississippi"
  },
  {
    "name": "Kentucky",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/kentucky",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/kentucky",
    "template": "new-individual-locations",
    "section": "kentucky"
  },
  {
    "name": "Cleveland",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/ohio/cleveland",
    "url": "/locations/north-america/united-states/ohio/cleveland",
    "template": "new-individual-locations",
    "section": "ohio"
  },
  {
    "name": "Nebraska",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/nebraska",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/nebraska",
    "template": "new-individual-locations",
    "section": "nebraska"
  },
  {
    "name": "Baton Rouge",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/louisiana/baton-rouge",
    "url": "/locations/north-america/united-states/louisiana/baton-rouge",
    "template": "new-individual-locations",
    "section": "louisiana"
  },
  {
    "name": "Brisbane (ASK)",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/australia/australia/Queensland/brisbane-(ask)",
    "url": "/locations/australia/australia/Queensland/brisbane-(ask)",
    "template": "new-individual-locations",
    "section": "queensland"
  },
  {
    "name": "Hawaii",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/hawaii",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/hawaii",
    "template": "new-individual-locations",
    "section": "hawaii"
  },
  {
    "name": "Vermont",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/vermont",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/vermont",
    "template": "new-individual-locations",
    "section": "vermont"
  },
  {
    "name": "Bakersfield",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/california/bakersfield",
    "url": "/locations/north-america/united-states/california/bakersfield",
    "template": "new-individual-locations",
    "section": "california"
  },
  {
    "name": "Ontario Georgetown",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/ontario-georgetown",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/ontario-georgetown",
    "template": "new-individual-locations",
    "section": "ontario-georgetown"
  },
  {
    "name": "Utah",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/utah",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/utah",
    "template": "new-individual-locations",
    "section": "utah"
  },
  {
    "name": "Boston",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/massachusetts/boston",
    "url": "/locations/north-america/united-states/massachusetts/boston",
    "template": "new-individual-locations",
    "section": "massachusetts"
  },
  {
    "name": "Utah",
    "apiurl": "/restapi/customlocationcontentlvl3/location/north-america/united-states/utah",
    "url": "/location/north-america/united-states/utah",
    "template": "new-individual-locations",
    "section": "utah"
  },
  {
    "name": "New Mexico Albuquerque",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/new-mexico-albuquerque",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/new-mexico-albuquerque",
    "template": "new-individual-locations",
    "section": "new-mexico-albuquerque"
  },
  {
    "name": "OfficeName",
    "apiurl": "/restapi/customlocationcontentlvl3/default-mainlocation/northamerica/unitedstates/texas/dallas",
    "url": "/default-mainlocation/northamerica/unitedstates/texas/dallas",
    "template": "new-individual-locations",
    "section": "texas"
  },
  {
    "name": "OfficeName",
    "apiurl": "/restapi/customlocationcontentlvl3/default-mainlocation/northamerica/unitedstates/texas/dallas",
    "url": "/northamerica/unitedstates/texas/dallas",
    "template": "new-individual-locations",
    "section": "texas"
  },
  {
    "name": "Ontario",
    "apiurl": "/restapi/customlocationcontentlvl3/location/north-america/canada/ontario",
    "url": "/location/north-america/canada/ontario",
    "template": "new-individual-locations",
    "section": "ontario"
  },
  {
    "name": "Guangzhou",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/guangzhou",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/guangzhou",
    "template": "new-individual-locations",
    "section": "guangzhou"
  },
  {
    "name": "Missouri St. Louis",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/missouri-st.-louis",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/missouri-st.-louis",
    "template": "new-individual-locations",
    "section": "missouri-st.-louis"
  },
  {
    "name": "Orlando",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/florida/orlando",
    "url": "/locations/north-america/united-states/florida/orlando",
    "template": "new-individual-locations",
    "section": "florida"
  },
  {
    "name": "Kansas City",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/kansas/kansas-city",
    "url": "/locations/north-america/united-states/kansas/kansas-city",
    "template": "new-individual-locations",
    "section": "kansas"
  },
  {
    "name": "Virginia",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/virginia",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/virginia",
    "template": "new-individual-locations",
    "section": "virginia"
  },
  {
    "name": "Alaska",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/alaska",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/alaska",
    "template": "new-individual-locations",
    "section": "alaska"
  },
  {
    "name": "Beijing",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/asia/china/asia-pacific-state/beijing",
    "url": "/locations/asia/china/asia-pacific-state/beijing",
    "template": "new-individual-locations",
    "section": "asia-pacific-state"
  },
  {
    "name": "Belfast",
    "apiurl": "/restapi/customlocationcontentlvl3/location/united-kingdom/united-kingdom/belfast",
    "url": "/location/united-kingdom/united-kingdom/belfast",
    "template": "new-individual-locations",
    "section": "belfast"
  },
  {
    "name": "Ontario",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/ontario",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/ontario",
    "template": "new-individual-locations",
    "section": "ontario"
  },
  {
    "name": "Australia Location Information 1",
    "apiurl": "/restapi/customlocationcontentlvl3/default-mainlocation/australia/australia/austalia-test-1/australia-location-information-1",
    "url": "/default-mainlocation/australia/australia/austalia-test-1/australia-location-information-1",
    "template": "new-individual-locations",
    "section": "austalia-test-1"
  },
  {
    "name": "Australia Location Information 1",
    "apiurl": "/restapi/customlocationcontentlvl3/default-mainlocation/australia/australia/austalia-test-1/australia-location-information-1",
    "url": "/australia/australia/austalia-test-1/australia-location-information-1",
    "template": "new-individual-locations",
    "section": "austalia-test-1"
  },
  {
    "name": "Pennsylvania",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/pennsylvania",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/pennsylvania",
    "template": "new-individual-locations",
    "section": "pennsylvania"
  },
  {
    "name": "Idaho",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/idaho",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/idaho",
    "template": "new-individual-locations",
    "section": "idaho"
  },
  {
    "name": "New Orleans",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/louisiana/new-orleans",
    "url": "/locations/north-america/united-states/louisiana/new-orleans",
    "template": "new-individual-locations",
    "section": "louisiana"
  },
  {
    "name": "Massachusetts Boston",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/massachusetts-boston",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/massachusetts-boston",
    "template": "new-individual-locations",
    "section": "massachusetts-boston"
  },
  {
    "name": "Minnesota",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/minnesota",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/minnesota",
    "template": "new-individual-locations",
    "section": "minnesota"
  },
  {
    "name": "Illinois",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/illinois",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/illinois",
    "template": "new-individual-locations",
    "section": "illinois"
  },
  {
    "name": "Mississippi Jackson",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/mississippi-jackson",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/mississippi-jackson",
    "template": "new-individual-locations",
    "section": "mississippi-jackson"
  },
  {
    "name": "Louisiana New Orleans",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/louisiana-new-orleans",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/louisiana-new-orleans",
    "template": "new-individual-locations",
    "section": "louisiana-new-orleans"
  },
  {
    "name": "Colorado Denver",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/colorado-denver",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/colorado-denver",
    "template": "new-individual-locations",
    "section": "colorado-denver"
  },
  {
    "name": "Roanoke",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/virginia/roanoke",
    "url": "/locations/north-america/united-states/virginia/roanoke",
    "template": "new-individual-locations",
    "section": "virginia"
  },
  {
    "name": "Connecticut",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/connecticut",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/connecticut",
    "template": "new-individual-locations",
    "section": "connecticut"
  },
  {
    "name": "Liverpool",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/liverpool",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/liverpool",
    "template": "new-individual-locations",
    "section": "liverpool"
  },
  {
    "name": "Rhode Island",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/rhode-island",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/rhode-island",
    "template": "new-individual-locations",
    "section": "rhode-island"
  },
  {
    "name": "Georgetown",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/canada/ontario/georgetown",
    "url": "/locations/north-america/canada/ontario/georgetown",
    "template": "new-individual-locations",
    "section": "ontario"
  },
  {
    "name": "Georgetown",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/canada/ontario/georgetown",
    "url": "/locations/north-america/canada/toronto/georgetown",
    "template": "new-individual-locations",
    "section": "ontario"
  },
  {
    "name": "Frederick",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/maryland/maryland",
    "url": "/locations/north-america/united-states/maryland/maryland",
    "template": "new-individual-locations",
    "section": "maryland"
  },
  {
    "name": "Frederick",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/maryland/maryland",
    "url": "/locations/north-america/united-states/washington-dc/maryland",
    "template": "new-individual-locations",
    "section": "maryland"
  },
  {
    "name": "Brisbane (ANE)",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/australia/australia/Queensland/brisbane-ane",
    "url": "/locations/australia/australia/Queensland/brisbane-ane",
    "template": "new-individual-locations",
    "section": "queensland"
  },
  {
    "name": "Bahrain",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/bahrain",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/bahrain",
    "template": "new-individual-locations",
    "section": "bahrain"
  },
  {
    "name": "Victoria",
    "apiurl": "/restapi/customlocationcontentlvl3/location/australia/australia/victoria",
    "url": "/location/australia/australia/victoria",
    "template": "new-individual-locations",
    "section": "victoria"
  },
  {
    "name": "Montana",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/montana",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/montana",
    "template": "new-individual-locations",
    "section": "montana"
  },
  {
    "name": "Sydney (ANE)",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/australia/australia/new-south-wales/sydney-australia-(ane)",
    "url": "/locations/australia/australia/new-south-wales/sydney-australia-(ane)",
    "template": "new-individual-locations",
    "section": "new-south-wales"
  },
  {
    "name": "Sydney (ANE)",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/australia/australia/new-south-wales/sydney-australia-(ane)",
    "url": "/locations/australia/australia/new-south-wales/sydney-australia",
    "template": "new-individual-locations",
    "section": "new-south-wales"
  },
  {
    "name": "Sydney (ANE)",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/australia/australia/new-south-wales/sydney-australia-(ane)",
    "url": "/locations/australia/australia/new-south-wales/sydney",
    "template": "new-individual-locations",
    "section": "new-south-wales"
  },
  {
    "name": "Illinois Chicago",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/illinois-chicago",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/illinois-chicago",
    "template": "new-individual-locations",
    "section": "illinois-chicago"
  },
  {
    "name": "Oakdale",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/minnesota/oakdale",
    "url": "/locations/north-america/united-states/minnesota/oakdale",
    "template": "new-individual-locations",
    "section": "minnesota"
  },
  {
    "name": "Oakdale",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/minnesota/oakdale",
    "url": "/locations/north-america/united-states/minnesota/minneapolis",
    "template": "new-individual-locations",
    "section": "minnesota"
  },
  {
    "name": "New York City",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/new-york-city",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/new-york-city",
    "template": "new-individual-locations",
    "section": "new-york-city"
  },
  {
    "name": "Hainan",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/hainan",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/hainan",
    "template": "new-individual-locations",
    "section": "hainan"
  },
  {
    "name": "Texas Corpus Christi",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/texas-corpus-christi",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/texas-corpus-christi",
    "template": "new-individual-locations",
    "section": "texas-corpus-christi"
  },
  {
    "name": "Ohio",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/ohio",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/ohio",
    "template": "new-individual-locations",
    "section": "ohio"
  },
  {
    "name": "California Oakland",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/california-oakland",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/california-oakland",
    "template": "new-individual-locations",
    "section": "california-oakland"
  },
  {
    "name": "Lake Charles",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/louisiana/lake-charles",
    "url": "/locations/north-america/united-states/louisiana/lake-charles",
    "template": "new-individual-locations",
    "section": "louisiana"
  },
  {
    "name": "Nevada",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/nevada",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/nevada",
    "template": "new-individual-locations",
    "section": "nevada"
  },
  {
    "name": "Utah Salt Lake City",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/utah-salt-lake-city",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/utah-salt-lake-city",
    "template": "new-individual-locations",
    "section": "utah-salt-lake-city"
  },
  {
    "name": "Portland",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/oregon/portland",
    "url": "/locations/north-america/united-states/oregon/portland",
    "template": "new-individual-locations",
    "section": "oregon"
  },
  {
    "name": "Dallas",
    "apiurl": "/restapi/customlocationcontentlvl3/location/north-america/united-states/dallas",
    "url": "/location/north-america/united-states/dallas",
    "template": "new-individual-locations",
    "section": "dallas"
  },
  {
    "name": "Victoria",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/canada/british-columbia/victoria",
    "url": "/locations/north-america/canada/british-columbia/victoria",
    "template": "new-individual-locations",
    "section": "british-columbia"
  },
  {
    "name": "Philadelphia",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/pennsylvania/philadelphia",
    "url": "/locations/north-america/united-states/pennsylvania/philadelphia",
    "template": "new-individual-locations",
    "section": "pennsylvania"
  },
  {
    "name": "Texas Dallas",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/texas-dallas",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/texas-dallas",
    "template": "new-individual-locations",
    "section": "texas-dallas"
  },
  {
    "name": "North Carolina Raleigh",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/north-carolina-raleigh",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/north-carolina-raleigh",
    "template": "new-individual-locations",
    "section": "north-carolina-raleigh"
  },
  {
    "name": "North Carolina Raleigh",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/north-carolina-raleigh",
    "url": "/location/north-america/north-carolina",
    "template": "new-individual-locations",
    "section": "north-carolina-raleigh"
  },
  {
    "name": "Washington",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/washington",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/washington",
    "template": "new-individual-locations",
    "section": "washington"
  },
  {
    "name": "California",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/california",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/california",
    "template": "new-individual-locations",
    "section": "california"
  },
  {
    "name": "Ohio Columbus",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/ohio-columbus",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/ohio-columbus",
    "template": "new-individual-locations",
    "section": "ohio-columbus"
  },
  {
    "name": "Texas",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/texas",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/texas",
    "template": "new-individual-locations",
    "section": "texas"
  },
  {
    "name": "Wyoming",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/wyoming",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/wyoming",
    "template": "new-individual-locations",
    "section": "wyoming"
  },
  {
    "name": "Oklahoma City",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/oklahoma/oklahoma-city",
    "url": "/locations/north-america/united-states/oklahoma/oklahoma-city",
    "template": "new-individual-locations",
    "section": "oklahoma"
  },
  {
    "name": "Plano",
    "apiurl": "/restapi/customlocationcontentlvl3/location/north-america/united-states/plano",
    "url": "/location/north-america/united-states/plano",
    "template": "new-individual-locations",
    "section": "plano"
  },
  {
    "name": "Birmingham",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/alabama/birmingham",
    "url": "/locations/north-america/united-states/alabama/birmingham",
    "template": "new-individual-locations",
    "section": "alabama"
  },
  {
    "name": "North Carolina Charlotte",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/north-carolina-charlotte",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/north-carolina-charlotte",
    "template": "new-individual-locations",
    "section": "north-carolina-charlotte"
  },
  {
    "name": "Raleigh",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/north-carolina/raleigh",
    "url": "/locations/north-america/united-states/north-carolina/raleigh",
    "template": "new-individual-locations",
    "section": "north-carolina"
  },
  {
    "name": "New Mexico",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/new-mexico",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/new-mexico",
    "template": "new-individual-locations",
    "section": "new-mexico"
  },
  {
    "name": "Dublin",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/europe/ireland/dublin/dublin",
    "url": "/locations/europe/ireland/dublin/dublin",
    "template": "new-individual-locations",
    "section": "dublin"
  },
  {
    "name": "Iowa Burlington",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/iowa-burlington",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/iowa-burlington",
    "template": "new-individual-locations",
    "section": "iowa-burlington"
  },
  {
    "name": "Brisbane Australia",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/brisbane-australia",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/brisbane-australia",
    "template": "new-individual-locations",
    "section": "brisbane-australia"
  },
  {
    "name": "Frisco",
    "apiurl": "/restapi/customlocationcontentlvl3/location/north-america/united-states/frisco",
    "url": "/location/north-america/united-states/frisco",
    "template": "new-individual-locations",
    "section": "frisco"
  },
  {
    "name": "Wisconsin Milwaukee",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/wisconsin-milwaukee",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/wisconsin-milwaukee",
    "template": "new-individual-locations",
    "section": "wisconsin-milwaukee"
  },
  {
    "name": "Jackson",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/mississippi/jackson",
    "url": "/locations/north-america/united-states/mississippi/jackson",
    "template": "new-individual-locations",
    "section": "mississippi"
  },
  {
    "name": "Iowa Des Moines",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/iowa-des-moines",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/iowa-des-moines",
    "template": "new-individual-locations",
    "section": "iowa-des-moines"
  },
  {
    "name": "Iowa",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/iowa",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/iowa",
    "template": "new-individual-locations",
    "section": "iowa"
  },
  {
    "name": "Oklahoma City",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/oklahoma-city",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/oklahoma-city",
    "template": "new-individual-locations",
    "section": "oklahoma-city"
  },
  {
    "name": "Ventura",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/california/ventura",
    "url": "/locations/north-america/united-states/california/ventura",
    "template": "new-individual-locations",
    "section": "california"
  },
  {
    "name": "Louisiana Baton Rouge",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/louisiana-baton-rouge",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/louisiana-baton-rouge",
    "template": "new-individual-locations",
    "section": "louisiana-baton-rouge"
  },
  {
    "name": "West Des Moines",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/iowa/west-des-moines",
    "url": "/locations/north-america/united-states/iowa/west-des-moines",
    "template": "new-individual-locations",
    "section": "iowa"
  },
  {
    "name": "West Des Moines",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/iowa/west-des-moines",
    "url": "/locations/iowa/des-moines",
    "template": "new-individual-locations",
    "section": "iowa"
  },
  {
    "name": "Corpus Christi",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/texas/corpus-christi",
    "url": "/locations/north-america/united-states/texas/corpus-christi",
    "template": "new-individual-locations",
    "section": "texas"
  },
  {
    "name": "Corpus Christi",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/texas/corpus-christi",
    "url": "/locations/north-america/united-states/texas/office-information",
    "template": "new-individual-locations",
    "section": "texas"
  },
  {
    "name": "Mountain View",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/california/mountain-view",
    "url": "/locations/north-america/united-states/california/mountain-view",
    "template": "new-individual-locations",
    "section": "california"
  },
  {
    "name": "Puerto Rico",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/puerto-rico",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/puerto-rico",
    "template": "new-individual-locations",
    "section": "puerto-rico"
  },
  {
    "name": "Hainan",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/asia/china/asia-pacific-state/hainan",
    "url": "/locations/asia/china/asia-pacific-state/hainan",
    "template": "new-individual-locations",
    "section": "asia-pacific-state"
  },
  {
    "name": "Alabama",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/alabama",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/alabama",
    "template": "new-individual-locations",
    "section": "alabama"
  },
  {
    "name": "Oklahoma Tulsa",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/oklahoma-tulsa",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/oklahoma-tulsa",
    "template": "new-individual-locations",
    "section": "oklahoma-tulsa"
  },
  {
    "name": "Cheyenne",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/wyoming/cheyenne",
    "url": "/locations/north-america/united-states/wyoming/cheyenne",
    "template": "new-individual-locations",
    "section": "wyoming"
  },
  {
    "name": "Kentucky Covington",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/kentucky-covington",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/kentucky-covington",
    "template": "new-individual-locations",
    "section": "kentucky-covington"
  },
  {
    "name": "Hainan",
    "apiurl": "/restapi/customlocationcontentlvl3/location/china/china/hainan",
    "url": "/location/china/china/hainan",
    "template": "new-individual-locations",
    "section": "hainan"
  },
  {
    "name": "Pennsylvania Pittsburgh",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/pennsylvania-pittsburgh",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/pennsylvania-pittsburgh",
    "template": "new-individual-locations",
    "section": "pennsylvania-pittsburgh"
  },
  {
    "name": "Sacramento",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/california/sacramento",
    "url": "/locations/north-america/united-states/california/sacramento",
    "template": "new-individual-locations",
    "section": "california"
  },
  {
    "name": "Hampshire",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/europe/europe-country/europe-state/hampshire",
    "url": "/locations/europe/europe-country/europe-state/hampshire",
    "template": "new-individual-locations",
    "section": "europe-state"
  },
  {
    "name": "Indiana Indianapolis",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/indiana-indianapolis",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/indiana-indianapolis",
    "template": "new-individual-locations",
    "section": "indiana-indianapolis"
  },
  {
    "name": "New Jersey Princeton",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/new-jersey-princeton",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/new-jersey-princeton",
    "template": "new-individual-locations",
    "section": "new-jersey-princeton"
  },
  {
    "name": "New York Albany",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/new-york-albany",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/new-york-albany",
    "template": "new-individual-locations",
    "section": "new-york-albany"
  },
  {
    "name": "Alabama Birmingham",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/alabama-birmingham",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/alabama-birmingham",
    "template": "new-individual-locations",
    "section": "alabama-birmingham"
  },
  {
    "name": "Tennessee",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/tennessee",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/tennessee",
    "template": "new-individual-locations",
    "section": "tennessee"
  },
  {
    "name": "Idaho Boise",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/idaho-boise",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/idaho-boise",
    "template": "new-individual-locations",
    "section": "idaho-boise"
  },
  {
    "name": "Michigan",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/michigan",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/michigan",
    "template": "new-individual-locations",
    "section": "michigan"
  },
  {
    "name": "Michigan Ann Arbor",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/michigan-ann-arbor",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/michigan-ann-arbor",
    "template": "new-individual-locations",
    "section": "michigan-ann-arbor"
  },
  {
    "name": "Gladstone (VE)",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/australia/australia/Queensland/gladstone-ve",
    "url": "/locations/australia/australia/Queensland/gladstone-ve",
    "template": "new-individual-locations",
    "section": "queensland"
  },
  {
    "name": "Colorado",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/colorado",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/colorado",
    "template": "new-individual-locations",
    "section": "colorado"
  },
  {
    "name": "Austin",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/texas/austin",
    "url": "/locations/north-america/united-states/texas/austin",
    "template": "new-individual-locations",
    "section": "texas"
  },
  {
    "name": "Albuquerque",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/new-mexico/albuquerque",
    "url": "/locations/north-america/united-states/new-mexico/albuquerque",
    "template": "new-individual-locations",
    "section": "new-mexico"
  },
  {
    "name": "South Carolina",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/south-carolina",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/south-carolina",
    "template": "new-individual-locations",
    "section": "south-carolina"
  },
  {
    "name": "Maryland",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/maryland",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/maryland",
    "template": "new-individual-locations",
    "section": "maryland"
  },
  {
    "name": "Virginia Charlottesville",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/virginia-charlottesville",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/virginia-charlottesville",
    "template": "new-individual-locations",
    "section": "virginia-charlottesville"
  },
  {
    "name": "Ontario Guelph",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/ontario-guelph",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/ontario-guelph",
    "template": "new-individual-locations",
    "section": "ontario-guelph"
  },
  {
    "name": "Denver",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/colorado/denver",
    "url": "/locations/north-america/united-states/colorado/denver",
    "template": "new-individual-locations",
    "section": "colorado"
  },
  {
    "name": "Massachusetts",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/massachusetts",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/massachusetts",
    "template": "new-individual-locations",
    "section": "massachusetts"
  },
  {
    "name": "Oregon",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/oregon",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/oregon",
    "template": "new-individual-locations",
    "section": "oregon"
  },
  {
    "name": "San Diego",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/california/san-diego",
    "url": "/locations/north-america/united-states/california/san-diego",
    "template": "new-individual-locations",
    "section": "california"
  },
  {
    "name": "Indianapolis",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/indiana/indianapolis",
    "url": "/locations/north-america/united-states/indiana/indianapolis",
    "template": "new-individual-locations",
    "section": "indiana"
  },
  {
    "name": "Quebec",
    "apiurl": "/restapi/customlocationcontentlvl3/location/north-america/canada/quebec",
    "url": "/location/north-america/canada/quebec",
    "template": "new-individual-locations",
    "section": "quebec"
  },
  {
    "name": "Bury St. Edmunds",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/europe/europe-country/europe-state/europe-location",
    "url": "/locations/europe/europe-country/europe-state/europe-location",
    "template": "new-individual-locations",
    "section": "europe-state"
  },
  {
    "name": "Tulsa",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/oklahoma/tulsa",
    "url": "/locations/north-america/united-states/oklahoma/tulsa",
    "template": "new-individual-locations",
    "section": "oklahoma"
  },
  {
    "name": "St. Louis",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/missouri/st.-louis",
    "url": "/locations/north-america/united-states/missouri/st.-louis",
    "template": "new-individual-locations",
    "section": "missouri"
  },
  {
    "name": "San Ramon",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/california/san-ramon",
    "url": "/locations/north-america/united-states/california/san-ramon",
    "template": "new-individual-locations",
    "section": "california"
  },
  {
    "name": "Columbus",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/ohio/columbus",
    "url": "/locations/north-america/united-states/ohio/columbus",
    "template": "new-individual-locations",
    "section": "ohio"
  },
  {
    "name": "West Virginia",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/west-virginia",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/west-virginia",
    "template": "new-individual-locations",
    "section": "west-virginia"
  },
  {
    "name": "Xi'an",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/asia/china/asia-pacific-state/xi'an",
    "url": "/locations/asia/china/asia-pacific-state/xi'an",
    "template": "new-individual-locations",
    "section": "asia-pacific-state"
  },
  {
    "name": "Atlanta",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/georgia/atlanta",
    "url": "/locations/north-america/united-states/georgia/atlanta",
    "template": "new-individual-locations",
    "section": "georgia"
  },
  {
    "name": "Houston",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/texas/houston",
    "url": "/locations/north-america/united-states/texas/houston",
    "template": "new-individual-locations",
    "section": "texas"
  },
  {
    "name": "New York City",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/new-york/new-york-city-office",
    "url": "/locations/north-america/united-states/new-york/new-york-city-office",
    "template": "new-individual-locations",
    "section": "new-york"
  },
  {
    "name": "Toronto",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/canada/ontario/toronto",
    "url": "/locations/north-america/canada/ontario/toronto",
    "template": "new-individual-locations",
    "section": "ontario"
  },
  {
    "name": "Toronto",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/canada/ontario/toronto",
    "url": "/locations/north-america/canada/toronto/toronto",
    "template": "new-individual-locations",
    "section": "ontario"
  },
  {
    "name": "Beijing",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/beijing",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/beijing",
    "template": "new-individual-locations",
    "section": "beijing"
  },
  {
    "name": "California Irvine",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/california-irvine",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/california-irvine",
    "template": "new-individual-locations",
    "section": "california-irvine"
  },
  {
    "name": "Queensland",
    "apiurl": "/restapi/customlocationcontentlvl3/location/australia/australia/queensland",
    "url": "/location/australia/australia/queensland",
    "template": "new-individual-locations",
    "section": "queensland"
  },
  {
    "name": "Ann Arbor",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/michigan/ann-arbor",
    "url": "/locations/north-america/united-states/michigan/ann-arbor",
    "template": "new-individual-locations",
    "section": "michigan"
  },
  {
    "name": "New Hampshire",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/new-hampshire",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/new-hampshire",
    "template": "new-individual-locations",
    "section": "new-hampshire"
  },
  {
    "name": "Milwaukee",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/wisconsin/milwaukee",
    "url": "/locations/north-america/united-states/wisconsin/milwaukee",
    "template": "new-individual-locations",
    "section": "wisconsin"
  },
  {
    "name": "Texas Austin",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/texas-austin",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/texas-austin",
    "template": "new-individual-locations",
    "section": "texas-austin"
  },
  {
    "name": "Georgia",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/georgia",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/georgia",
    "template": "new-individual-locations",
    "section": "georgia"
  },
  {
    "name": "Burlington",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/iowa/burlington",
    "url": "/locations/north-america/united-states/iowa/burlington",
    "template": "new-individual-locations",
    "section": "iowa"
  },
  {
    "name": "Little Rock",
    "apiurl": "/restapi/customlocationcontentlvl3/locations/north-america/united-states/arkansas/little-rock",
    "url": "/locations/north-america/united-states/arkansas/little-rock",
    "template": "new-individual-locations",
    "section": "arkansas"
  },
  {
    "name": "Texas Houston",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/texas-houston",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/texas-houston",
    "template": "new-individual-locations",
    "section": "texas-houston"
  },
  {
    "name": "Maine",
    "apiurl": "/restapi/customlocationcontentlvl3/default-location/default-locationcategory/default-locationsubcategory/maine",
    "url": "/default-location/default-locationcategory/default-locationsubcategory/maine",
    "template": "new-individual-locations",
    "section": "maine"
  },
  {
    "name": "2019",
    "apiurl": "/restapi/customcontent/contact-us/2019",
    "url": "/contact-us/2019",
    "template": "general_content",
    "section": "2019"
  },
  {
    "name": "2020",
    "apiurl": "/restapi/customcontent/contact-us/2020",
    "url": "/contact-us/2020",
    "template": "general_content",
    "section": "2020"
  },
  {
    "name": "2013",
    "apiurl": "/restapi/customcontent/contact-us/2013",
    "url": "/contact-us/2013",
    "template": "general_content",
    "section": "2013"
  },
  {
    "name": "2010",
    "apiurl": "/restapi/customcontent/contact-us/2010",
    "url": "/contact-us/2010",
    "template": "general_content",
    "section": "2010"
  },
  {
    "name": "2014",
    "apiurl": "/restapi/customcontent/contact-us/2014",
    "url": "/contact-us/2014",
    "template": "general_content",
    "section": "2014"
  },
  {
    "name": "2012",
    "apiurl": "/restapi/customcontent/contact-us/2012",
    "url": "/contact-us/2012",
    "template": "general_content",
    "section": "2012"
  },
  {
    "name": "2018",
    "apiurl": "/restapi/customcontent/contact-us/2018",
    "url": "/contact-us/2018",
    "template": "general_content",
    "section": "2018"
  },
  {
    "name": "2017",
    "apiurl": "/restapi/customcontent/contact-us/2017",
    "url": "/contact-us/2017",
    "template": "general_content",
    "section": "2017"
  },
  {
    "name": "2015",
    "apiurl": "/restapi/customcontent/contact-us/2015",
    "url": "/contact-us/2015",
    "template": "general_content",
    "section": "2015"
  },
  {
    "name": "2011",
    "apiurl": "/restapi/customcontent/contact-us/2011",
    "url": "/contact-us/2011",
    "template": "general_content",
    "section": "2011"
  },
  {
    "name": "2016",
    "apiurl": "/restapi/customcontent/contact-us/2016",
    "url": "/contact-us/2016",
    "template": "general_content",
    "section": "2016"
  },
  {
    "name": "2021",
    "apiurl": "/restapi/customcontent/contact-us/2021",
    "url": "/contact-us/2021",
    "template": "general_content",
    "section": "2021"
  },
  {
    "name": "Request Consulting Quote",
    "apiurl": "/restapi/customcontent/request-a-quote",
    "url": "/request-a-quote",
    "template": "general_content",
    "section": "request-consulting-quote"
  },
  {
    "name": "Request Consulting Quote",
    "apiurl": "/restapi/customcontent/request-a-quote",
    "url": "/request-data-quote",
    "template": "general_content",
    "section": "request-consulting-quote"
  },
  {
    "name": "3D Analyst",
    "apiurl": "/restapi/customsoftwareproductcontent/software/air-dispersion---data-visualization/3d-analyst",
    "url": "/software/air-dispersion---data-visualization/3d-analyst",
    "template": "new-software-product",
    "section": "data-analysis"
  },
  {
    "name": "3D Analyst",
    "apiurl": "/restapi/customsoftwareproductcontent/software/air-dispersion---data-visualization/3d-analyst",
    "url": "/software/air-dispersion-data-visualization/3d-analyst",
    "template": "new-software-product",
    "section": "data-analysis"
  },
  {
    "name": "3D Analyst",
    "apiurl": "/restapi/customsoftwareproductcontent/software/air-dispersion---data-visualization/3d-analyst",
    "url": "/software/air-dispersion---data/3d-analyst",
    "template": "new-software-product",
    "section": "data-analysis"
  },
  {
    "name": "3D Analyst",
    "apiurl": "/restapi/customsoftwareproductcontent/software/air-dispersion---data-visualization/3d-analyst",
    "url": "/software/products/3d-analyst",
    "template": "new-software-product",
    "section": "data-analysis"
  },
  {
    "name": "AERMOD",
    "apiurl": "/restapi/customsoftwareproductcontent/software/dispersion/aermod",
    "url": "/software/dispersion/aermod",
    "template": "new-software-product",
    "section": "air-dispersion"
  },
  {
    "name": "AERMOD",
    "apiurl": "/restapi/customsoftwareproductcontent/software/dispersion/aermod",
    "url": "/software/products/aermod/",
    "template": "new-software-product",
    "section": "air-dispersion"
  },
  {
    "name": "Downwash Analyst",
    "apiurl": "/restapi/customsoftwareproductcontent/software/air-dispersion---data-visualization/downwash-analyst",
    "url": "/software/air-dispersion---data-visualization/downwash-analyst",
    "template": "new-software-product",
    "section": "data-analysis"
  },
  {
    "name": "Downwash Analyst",
    "apiurl": "/restapi/customsoftwareproductcontent/software/air-dispersion---data-visualization/downwash-analyst",
    "url": "/software/products/downwash-analyst",
    "template": "new-software-product",
    "section": "data-analysis"
  },
  {
    "name": "Downwash Analyst",
    "apiurl": "/restapi/customsoftwareproductcontent/software/air-dispersion---data-visualization/downwash-analyst",
    "url": "/software/air-dispersion---data/downwash-analyst",
    "template": "new-software-product",
    "section": "data-analysis"
  },
  {
    "name": "Downwash Analyst",
    "apiurl": "/restapi/customsoftwareproductcontent/software/air-dispersion---data-visualization/downwash-analyst",
    "url": "/software/air-dispersion-data-visualization/downwash-analyst",
    "template": "new-software-product",
    "section": "data-analysis"
  },
  {
    "name": "Incident Analyst",
    "apiurl": "/restapi/customsoftwareproductcontent/software/hazard/incident-analyst",
    "url": "/software/hazard/incident-analyst",
    "template": "new-software-product",
    "section": "hazard"
  },
  {
    "name": "Incident Analyst",
    "apiurl": "/restapi/customsoftwareproductcontent/software/hazard/incident-analyst",
    "url": "/software/incident-analyst",
    "template": "new-software-product",
    "section": "hazard"
  },
  {
    "name": "Incident Analyst",
    "apiurl": "/restapi/customsoftwareproductcontent/software/hazard/incident-analyst",
    "url": "/software/products/incident-analyst",
    "template": "new-software-product",
    "section": "hazard"
  },
  {
    "name": "LFG Fire/Risk",
    "apiurl": "/restapi/customsoftwareproductcontent/software/hazard/lfg-fire-risk",
    "url": "/software/hazard/lfg-fire-risk",
    "template": "new-software-product",
    "section": "hazard"
  },
  {
    "name": "LFG Fire/Risk",
    "apiurl": "/restapi/customsoftwareproductcontent/software/hazard/lfg-fire-risk",
    "url": "/software/products/lfg-fire-risk",
    "template": "new-software-product",
    "section": "hazard"
  },
  {
    "name": "VASDIP",
    "apiurl": "/restapi/customsoftwareproductcontent/software/explosion/vasdip",
    "url": "/software/explosion/vasdip",
    "template": "new-software-product",
    "section": "explosion"
  },
  {
    "name": "VASDIP",
    "apiurl": "/restapi/customsoftwareproductcontent/software/explosion/vasdip",
    "url": "/software/products/vasdip",
    "template": "new-software-product",
    "section": "explosion"
  },
  {
    "name": "SCREEN3",
    "apiurl": "/restapi/customsoftwareproductcontent/software/dispersion/screen3",
    "url": "/software/dispersion/screen3",
    "template": "new-software-product",
    "section": "air-dispersion"
  },
  {
    "name": "SCREEN3",
    "apiurl": "/restapi/customsoftwareproductcontent/software/dispersion/screen3",
    "url": "/software/products/screen3",
    "template": "new-software-product",
    "section": "air-dispersion"
  },
  {
    "name": "Risk Analyst",
    "apiurl": "/restapi/customsoftwareproductcontent/software/health-risk/risk-analyst",
    "url": "/software/health-risk/risk-analyst",
    "template": "new-software-product",
    "section": "health-risk"
  },
  {
    "name": "Risk Analyst",
    "apiurl": "/restapi/customsoftwareproductcontent/software/health-risk/risk-analyst",
    "url": "/software/Risk-Analyst",
    "template": "new-software-product",
    "section": "health-risk"
  },
  {
    "name": "Risk Analyst",
    "apiurl": "/restapi/customsoftwareproductcontent/software/health-risk/risk-analyst",
    "url": "/software/products/risk-analyst",
    "template": "new-software-product",
    "section": "health-risk"
  },
  {
    "name": "AERSCREEN",
    "apiurl": "/restapi/customsoftwareproductcontent/software/dispersion/aerscreen",
    "url": "/software/dispersion/aerscreen",
    "template": "new-software-product",
    "section": "air-dispersion"
  },
  {
    "name": "AERSCREEN",
    "apiurl": "/restapi/customsoftwareproductcontent/software/dispersion/aerscreen",
    "url": "/software/products/aerscreen",
    "template": "new-software-product",
    "section": "air-dispersion"
  },
  {
    "name": "CALPUFF",
    "apiurl": "/restapi/customsoftwareproductcontent/software/dispersion/calpuff",
    "url": "/software/dispersion/calpuff",
    "template": "new-software-product",
    "section": "air-dispersion"
  },
  {
    "name": "CALPUFF",
    "apiurl": "/restapi/customsoftwareproductcontent/software/dispersion/calpuff",
    "url": "/software/products/calpuff",
    "template": "new-software-product",
    "section": "air-dispersion"
  },
  {
    "name": "ROADS",
    "apiurl": "/restapi/customsoftwareproductcontent/software/dispersion/roads",
    "url": "/software/dispersion/roads",
    "template": "new-software-product",
    "section": "air-dispersion"
  },
  {
    "name": "ROADS",
    "apiurl": "/restapi/customsoftwareproductcontent/software/dispersion/roads",
    "url": "/software/products/roads",
    "template": "new-software-product",
    "section": "air-dispersion"
  },
  {
    "name": "ExDAM",
    "apiurl": "/restapi/customsoftwareproductcontent/software/explosion/exdam",
    "url": "/software/explosion/exdam",
    "template": "new-software-product",
    "section": "explosion"
  },
  {
    "name": "ExDAM",
    "apiurl": "/restapi/customsoftwareproductcontent/software/explosion/exdam",
    "url": "/software/products/exdam",
    "template": "new-software-product",
    "section": "explosion"
  },
  {
    "name": "ExDAM",
    "apiurl": "/restapi/customsoftwareproductcontent/software/explosion/exdam",
    "url": "/software/exdam",
    "template": "new-software-product",
    "section": "explosion"
  },
  {
    "name": "MetView",
    "apiurl": "/restapi/customsoftwareproductcontent/software/air-dispersion---data-visualization/metview",
    "url": "/software/air-dispersion---data-visualization/metview",
    "template": "new-software-product",
    "section": "data-analysis"
  },
  {
    "name": "MetView",
    "apiurl": "/restapi/customsoftwareproductcontent/software/air-dispersion---data-visualization/metview",
    "url": "/software/products/metview",
    "template": "new-software-product",
    "section": "data-analysis"
  },
  {
    "name": "MetView",
    "apiurl": "/restapi/customsoftwareproductcontent/software/air-dispersion---data-visualization/metview",
    "url": "/software/air-dispersion-data-visualization/metview",
    "template": "new-software-product",
    "section": "data-analysis"
  },
  {
    "name": "MetView",
    "apiurl": "/restapi/customsoftwareproductcontent/software/air-dispersion---data-visualization/metview",
    "url": "/software/air-dispersion---data/metview",
    "template": "new-software-product",
    "section": "data-analysis"
  },
  {
    "name": "AERMET",
    "apiurl": "/restapi/customsoftwareproductcontent/software/dispersion/aermet",
    "url": "/software/dispersion/aermet",
    "template": "new-software-product",
    "section": "air-dispersion"
  },
  {
    "name": "AERMET",
    "apiurl": "/restapi/customsoftwareproductcontent/software/dispersion/aermet",
    "url": "/software/products/aermet",
    "template": "new-software-product",
    "section": "air-dispersion"
  },
  {
    "name": "TankESP",
    "apiurl": "/restapi/customsoftwareproductcontent/software/tanks/tankesp",
    "url": "/software/tanks/tankesp",
    "template": "new-software-product",
    "section": "tanks"
  },
  {
    "name": "TankESP",
    "apiurl": "/restapi/customsoftwareproductcontent/software/tanks/tankesp",
    "url": "/software/products/tankesp",
    "template": "new-software-product",
    "section": "tanks"
  },
  {
    "name": "Operations",
    "apiurl": "/restapi/customcontent/contact-us/operations",
    "url": "/contact-us/operations",
    "template": "general_content",
    "section": "operations"
  },
  {
    "name": "Leadership",
    "apiurl": "/restapi/customcontent/contact-us/leadership",
    "url": "/contact-us/leadership",
    "template": "general_content",
    "section": "leadership"
  },
  {
    "name": "Review Shopping Cart",
    "apiurl": "/restapi/customcontent/shopping-cart",
    "url": "/shopping-cart",
    "template": "general_content",
    "section": "review-shopping-cart"
  },
  {
    "name": "Order Confirmation",
    "apiurl": "/restapi/customcontent/shopping-cart/attendees/review-order/payment/order-confirmation",
    "url": "/shopping-cart/attendees/review-order/payment/order-confirmation",
    "template": "order-confirmation",
    "section": "shopping-cart"
  },
  {
    "name": "Design",
    "apiurl": "/restapi/customcontent/contact-us/design",
    "url": "/contact-us/design",
    "template": "general_content",
    "section": "design"
  },
  {
    "name": "Development",
    "apiurl": "/restapi/customcontent/contact-us/development",
    "url": "/contact-us/development",
    "template": "general_content",
    "section": "development"
  },
  {
    "name": "Locations",
    "apiurl": "/restapi/customlocationcontent/locations",
    "url": "/locations",
    "template": "new-locations",
    "section": "locations"
  },
  {
    "name": "Locations",
    "apiurl": "/restapi/customlocationcontent/locations",
    "url": "/location",
    "template": "new-locations",
    "section": "locations"
  },
  {
    "name": "Locations",
    "apiurl": "/restapi/customlocationcontent/locations",
    "url": "/additional-links/locations",
    "template": "new-locations",
    "section": "locations"
  },
  {
    "name": "Policies",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/policies",
    "url": "/about-us/policies",
    "template": "new-policies",
    "section": "about-us"
  },
  {
    "name": "Policies",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/policies",
    "url": "/about-us/policies",
    "template": "new-aboutus-category",
    "section": "about-us"
  },
  {
    "name": "Trade Shows & Events",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/trade-shows",
    "url": "/about-us/trade-shows",
    "template": "new-trade-shows",
    "section": "about-us"
  },
  {
    "name": "Trade Shows & Events",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/trade-shows",
    "url": "/about-us/trade-shows",
    "template": "new-aboutus-category",
    "section": "about-us"
  },
  {
    "name": "EHS Quarterly",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/ehs-quarterly",
    "url": "/about-us/ehs-quarterly",
    "template": "new-mission",
    "section": "about-us"
  },
  {
    "name": "EHS Quarterly",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/ehs-quarterly",
    "url": "/media/environmental-quarterly",
    "template": "new-mission",
    "section": "about-us"
  },
  {
    "name": "EHS Quarterly",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/ehs-quarterly",
    "url": "/about-us/ehs-quarterly",
    "template": "new-aboutus-category",
    "section": "about-us"
  },
  {
    "name": "EHS Quarterly",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/ehs-quarterly",
    "url": "/media/environmental-quarterly",
    "template": "new-aboutus-category",
    "section": "about-us"
  },
  {
    "name": "Mission, Vision & Values",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/mission",
    "url": "/about-us/mission",
    "template": "new-mission",
    "section": "about-us"
  },
  {
    "name": "Mission, Vision & Values",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/mission",
    "url": "/about-us1/mission",
    "template": "new-mission",
    "section": "about-us"
  },
  {
    "name": "Mission, Vision & Values",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/mission",
    "url": "/about-us/mission-vision-values",
    "template": "new-mission",
    "section": "about-us"
  },
  {
    "name": "Mission, Vision & Values",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/mission",
    "url": "/about-us/mission",
    "template": "new-aboutus-category",
    "section": "about-us"
  },
  {
    "name": "Mission, Vision & Values",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/mission",
    "url": "/about-us1/mission",
    "template": "new-aboutus-category",
    "section": "about-us"
  },
  {
    "name": "Mission, Vision & Values",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/mission",
    "url": "/about-us/mission-vision-values",
    "template": "new-aboutus-category",
    "section": "about-us"
  },
  {
    "name": "Quality",
    "apiurl": "/restapi/customaboutuslvl3content/about-us/policies/quality",
    "url": "/about-us/policies/quality",
    "template": "new-individual-policy",
    "section": "quality"
  },
  {
    "name": "Sustainability",
    "apiurl": "/restapi/customaboutuslvl3content/about-us/policies/sustainability",
    "url": "/about-us/policies/sustainability",
    "template": "new-individual-policy",
    "section": "sustainability"
  },
  {
    "name": "Show 1",
    "apiurl": "/restapi/customaboutuslvl3content/about-us/trade-shows/show-1",
    "url": "/about-us/trade-shows/show-1",
    "template": "new-individual-policy",
    "section": "show-1"
  },
  {
    "name": "Health, Safety & Environmental",
    "apiurl": "/restapi/customaboutuslvl3content/about-us/policies/hse-policy",
    "url": "/about-us/policies/hse-policy",
    "template": "new-individual-policy",
    "section": "health,-safety-environmental"
  },
  {
    "name": "Health, Safety & Environmental",
    "apiurl": "/restapi/customaboutuslvl3content/about-us/policies/hse-policy",
    "url": "/about-us1/policies/hse-policy",
    "template": "new-individual-policy",
    "section": "health,-safety-environmental"
  },
  {
    "name": "Health, Safety & Environmental",
    "apiurl": "/restapi/customaboutuslvl3content/about-us/policies/hse-policy",
    "url": "/about-us/policies/he-policy",
    "template": "new-individual-policy",
    "section": "health,-safety-environmental"
  },
  {
    "name": "Yes",
    "apiurl": "/restapi/customcontent/contact-us/yes",
    "url": "/contact-us/yes",
    "template": "general_content",
    "section": "yes"
  },
  {
    "name": "No",
    "apiurl": "/restapi/customcontent/contact-us/no",
    "url": "/contact-us/no",
    "template": "general_content",
    "section": "no"
  },
  {
    "name": "Submit Job Request",
    "apiurl": "/restapi/customcontent/submit-job-request",
    "url": "/submit-job-request",
    "template": "general_content",
    "section": "submit-job-request"
  },
  {
    "name": "Industries",
    "apiurl": "/restapi/customindustrycontent/industries",
    "url": "/industries",
    "template": "new-industry-landing",
    "section": "industries"
  },
  {
    "name": "Executive Committee Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/executive-committee/individual-bio/jay-hofmann",
    "url": "/about-us/executive-committee/individual-bio/jay-hofmann",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Executive Committee Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/executive-committee/individual-bio/jay-hofmann",
    "url": "/about-us1/executive-committee",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Executive Committee Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/executive-committee/individual-bio/dave-larsen",
    "url": "/about-us/executive-committee/individual-bio/dave-larsen",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Executive Committee Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/executive-committee/individual-bio/dave-larsen",
    "url": "/about-us1/executive-committee",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Executive Committee Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/executive-committee/individual-bio/paul-greywall",
    "url": "/about-us/executive-committee/individual-bio/paul-greywall",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Executive Committee Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/executive-committee/individual-bio/paul-greywall",
    "url": "/about-us1/executive-committee",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Executive Committee Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/executive-committee/individual-bio/chris-price",
    "url": "/about-us/executive-committee/individual-bio/chris-price",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Executive Committee Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/executive-committee/individual-bio/chris-price",
    "url": "/about-us1/executive-committee",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Executive Committee Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/executive-committee/individual-bio/laura-redmon",
    "url": "/about-us/executive-committee/individual-bio/laura-redmon",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Executive Committee Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/executive-committee/individual-bio/laura-redmon",
    "url": "/about-us1/executive-committee",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Executive Committee Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/executive-committee/individual-bio/mike-remsberg",
    "url": "/about-us/executive-committee/individual-bio/mike-remsberg",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Executive Committee Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/executive-committee/individual-bio/mike-remsberg",
    "url": "/about-us1/executive-committee",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Executive Committee Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/executive-committee/individual-bio/hung-ming-sue-sung",
    "url": "/about-us/executive-committee/individual-bio/hung-ming-sue-sung",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Executive Committee Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/executive-committee/individual-bio/hung-ming-sue-sung",
    "url": "/about-us1/executive-committee",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Executive Committee Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/executive-committee/individual-bio/cynthia-russel",
    "url": "/about-us/executive-committee/individual-bio/cynthia-russel",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Executive Committee Individual Bio",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/executive-committee/individual-bio/cynthia-russel",
    "url": "/about-us1/executive-committee",
    "template": "new-individual-bio",
    "section": "about-us"
  },
  {
    "name": "Executive Committee",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/executive-committee",
    "url": "/about-us/executive-committee",
    "template": "new-executive-committee",
    "section": "about-us"
  },
  {
    "name": "Executive Committee",
    "apiurl": "/restapi/customaboutuslvl2content/about-us/executive-committee",
    "url": "/about-us1/executive-committee",
    "template": "new-executive-committee",
    "section": "about-us"
  },
  {
    "name": "Minnow Aquatic Environmental",
    "apiurl": "/restapi/customcontent/home/minnow-aquatic-environmental",
    "url": "/home/minnow-aquatic-environmental",
    "template": "general_content",
    "section": "minnow-aquatic-environmental"
  },
  {
    "name": "Minnow Aquatic Environmental",
    "apiurl": "/restapi/customcontent/home/minnow-aquatic-environmental",
    "url": "/home/minnow",
    "template": "general_content",
    "section": "minnow-aquatic-environmental"
  },
  {
    "name": "SafeBridge Regulatory & Life Science Group",
    "apiurl": "/restapi/customcontent/home/SafeBridge-Regulatory-Life-Science-Group",
    "url": "/home/SafeBridge-Regulatory-Life-Science-Group",
    "template": "general_content",
    "section": "safebridge-regulatory-life-science-group"
  },
  {
    "name": "SafeBridge Regulatory & Life Science Group",
    "apiurl": "/restapi/customcontent/home/SafeBridge-Regulatory-Life-Science-Group",
    "url": "/home/safebridge",
    "template": "general_content",
    "section": "safebridge-regulatory-life-science-group"
  },
  {
    "name": "Advent Engineering Life Science Solutions",
    "apiurl": "/restapi/customcontent/home/Advent-Engineering-Life-Science-Solutions",
    "url": "/home/Advent-Engineering-Life-Science-Solutions",
    "template": "general_content",
    "section": "advent-engineering-life-science-solutions"
  },
  {
    "name": "Advent Engineering Life Science Solutions",
    "apiurl": "/restapi/customcontent/home/Advent-Engineering-Life-Science-Solutions",
    "url": "/home/advent",
    "template": "general_content",
    "section": "advent-engineering-life-science-solutions"
  },
  {
    "name": "AERMAT",
    "apiurl": "/restapi/customcontent/contact-us/aermat",
    "url": "/contact-us/aermat",
    "template": "general_content",
    "section": "aermat"
  }
]